import { useNavigate as xt, useParams as _t, Outlet as Wi } from "react-router-dom";
import * as p from "react";
import k, { createContext as Ha, useContext as Ir, useEffect as xr, useRef as Wt, cloneElement as Hg, useImperativeHandle as Af, useLayoutEffect as _f, useState as ja, useMemo as $a, forwardRef as Wa, Component as Mf, Children as Wg, createRef as Gg, useCallback as Kg } from "react";
import rt from "dayjs";
import { select as Yg, debounce as Mn, group as Qg, omit as Bt } from "radash";
import se from "react-hot-toast";
import * as Xg from "react-dom";
import Zg, { createPortal as Jg, flushSync as Sd } from "react-dom";
import { Constants as st, Flex as Ke, Box as at, InputNumber as Ia, DatePicker as Lf, Button as wt, Heading as gn, Steps as ev, Divider as tv, Form as Vt, Avatar as _l, Descriptions as On, Text as qt, Link as nr, Card as bn, Input as Ed, Select as So, Drawer as rv, Chips as nv, Space as Gi, GirlShowingInfo as ov, Tag as rr, EmptyState as Wr, CardTable as Ln, Textarea as av, IconText as Eo, Tabs as iv, ErrorState as It, Loading as Gr, Dropdown as sv, DeleteQuestionSVG as cv, EditingSVG as yi, useBreadcrumbActions as lv, Icon as Vf } from "@nubeteck/components";
import { Spin as Xo, Modal as Rn, DatePicker as Kt, Select as Ht, Switch as ec, InputNumber as Vn, Space as ir, Avatar as Ml, Descriptions as pr, Alert as zo, Input as Hr, Button as to, Form as K, Drawer as Ga, Table as mo, Typography as ds, Popconfirm as us, Tooltip as Ar, Popover as Dd, message as Or, Card as Qt, Checkbox as Lc, Skeleton as Ki, Flex as Vc, Upload as dv, Tag as uv, Row as Zo, Dropdown as zf, Tabs as Kr } from "antd";
import "react-hook-form";
import { Datejs as bt, ArrayUtils as Da } from "@nubeteck/utils";
import "react-i18next";
import { FormUtils as wa, useForm as fv, useWatch as mn, Formeck as zc, Form as mv, FormGrid as Qn, FormInput as ar, useFormContext as pv } from "@nubeteck/formeck";
import Ee, { keyframes as hv, css as gv } from "styled-components";
import { Icon as me } from "@nubeteck/icons";
import { useQuery as Ye, useQueryClient as Ue, useMutation as ke, QueryClient as vv } from "@tanstack/react-query";
import yv from "axios";
import wd from "i18next";
import { persistQueryClient as bv } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister as Cv } from "@tanstack/query-sync-storage-persister";
import "react-loading-skeleton";
import { QueryHooks as Yi } from "@nubeteck/queries";
import { ReportingModule as Qi } from "@nubeteck/reporting_module";
const Td = "/documentos-ventas", Iv = "/documentos-compras", xv = "orden-compra", Sv = "orden-compra-detalles", Ev = "conduce-venta", Dv = "conduce-compra", wv = "conduce-venta-detalles", Tv = "conduce-compra-detalles", Fv = "cotizacion", Ov = "cotizacion-detalles", Bf = "nota-credito", kf = "nota-credito-detalles", Uf = "nota-debito", qf = "nota-debito-detalles", Nv = "factura-venta", Rv = "factura-venta-detalles", Pv = "factura-compra", jv = "factura-compra-detalles", nt = {
  ESTADOS: "Estados",
  MONEDAS: "Monedas",
  RECEIPTS: "Recibos",
  CONTACTOS: "Contactos",
  ALMACENES: "Almacenes",
  DOCUMENTOS: "Documentos",
  NOTAS_VENTAS: "NotasVentas",
  NOTAS_DEBITOS: "NotasDebitos",
  IMPUESTOS_TIPOS: "ImpuestosTipos",
  ORDENES_COMPRAS: "OrdenesCompras",
  DOCUMENTOSTIPOS: "DocumentosTipos",
  NOTAS_VENTAS_APLICAR: "NotasVentas/Aplicar",
  NOTAS_DEBITOS_APLICAR: "NotasDebitos/Aplicar",
  DOCUMENTOS_RECURRENTES: "DocumentosRecurrentes",
  TIPOS_FRECUENCIAS_PAGOS: "TiposFrecuenciasPagos",
  PRODUCTOS_LISTAS_PRECIOS: "ProductosListasPrecios",
  DOCUMENTOS_VENTAS: "Documentos/GetDocumentosVentas",
  RECONCILE_BANKS_CASH_ACCOUNTS: "CuadresBancosCajas",
  COTIZACIONES_CLONAR: "Cotizaciones/ClonarCotizacion",
  GUARDARCAMBIOS_NOTAVENTA: "GUARDARCAMBIOS_NOTAVENTA",
  DOCUMENTOS_COMPRAS: "Documentos/GetDocumentosCompras",
  DOCUMENTOS_CAMBIAR_ESTADO: "Documentos/CambiarEstado",
  GET_ALL_DOCUMENTOS_VENTAS: "GET_ALL_DOCUMENTOS_VENTAS",
  CLIENTE_INFO_BASICA: "Contactos/GetInfoBasicaContacto",
  GUARDARCAMBIOS_COTIZACION: "GUARDARCAMBIOS_COTIZACION",
  FACTURAS_VENTAS_CLONAR: "FacturasVentas/ClonarFactura",
  CONDUCES_VENTAS_CLONAR: "ConducesVentas/ClonarConduce",
  GUARDARCAMBIOS_NOTADEBITO: "GUARDARCAMBIOS_NOTADEBITO",
  DIRECCIONES_BY_CONTACTO: "Contactos/GetDireccionesById",
  GET_ALL_DOCUMENTOS_COMPRAS: "GET_ALL_DOCUMENTOS_COMPRAS",
  GUARDARCAMBIOS_ORDENCOMPRA: "GUARDARCAMBIOS_ORDENCOMPRA",
  CONDUCES_COMPRAS_CLONAR: "ConducesCompras/ClonarConduce",
  IMPUESTOS_TIPOS_GROUP: "ImpuestosTipos/GetImpuestosGroup",
  FACTURAS_COMPRAS_CLONAR: "FacturasCompras/_ClonarFactura",
  ORDENES_COMPRAS_CLONAR: "OrdenesCompras/ClonarOrdenCompra",
  GUARDARCAMBIOS_FACTURAVENTA: "GUARDARCAMBIOS_FACTURAVENTA",
  CONTACTOS_BY_TIPO: "Contactos/GetContactosByTipoForOptions",
  GUARDARCAMBIOS_FACTURACOMPRA: "GUARDARCAMBIOS_FACTURACOMPRA",
  GUARDARCAMBIOS_CONDUCESVENTAS: "GUARDARCAMBIOS_CONDUCESVENTAS",
  GUARDARCAMBIOS_CONDUCESCOMPRAS: "GUARDARCAMBIOS_CONDUCESCOMPRAS",
  DOCUMENTOS_RECURRENTES_PROC: "DocumentosRecurrentes/GetDocumentosRecurrentes",
  FacturasComprasDetallesLotes_GetLotesById: "FacturasComprasDetallesLotes/_GetLotesById",
  DOCUMENTOSTIPOS_AREA_VENTAS_O_COMRAS: "/DocumentosTipos/GetDocumentosTiposAreaVentasOCompras"
}, Oe = {
  ESTADOS: "ESTADOS",
  MONEDAS: "MONEDAS",
  ALMACENES: "ALMACENES",
  PRODUCTOS: "PRODUCTOS",
  DOCUMENTOS: "DOCUMENTOS",
  COTIZACIONES: "COTIZACIONES",
  PRODUCTOSBYSEARCH: "PRODUCTOS",
  DOCUMENTOSTIPOS: "DOCUMENTOSTIPOS",
  IMPUESTOS_TIPOS: "IMPUESTOS_TIPOS",
  DOCUMENTOS_VENTAS: "DOCUMENTOS_VENTAS",
  CONTACTOS_BY_TIPO: "CONTACTOS_BY_TIPO",
  DOCUMENTS_RECEIPTS: "DOCUMENTS_RECEIPTS",
  DOCUMENTOS_COMPRAS: "DOCUMENTOS_COMPRAS",
  CLIENTE_INFO_BASICA: "CLIENTE_INFO_BASICA",
  IMPUESTOS_TIPOS_GROUP: "IMPUESTOS_TIPOS_GROUP",
  NOTAS_DEBITOS_APLICAR: "NOTAS_DEBITOS_APLICAR",
  DOCUMENTOS_RECURRENTES: "DOCUMENTOS_RECURRENTES",
  TIPOS_FRECUENCIAS_PAGOS: "TIPOS_FRECUENCIAS_PAGOS",
  PRODUCTOS_LISTAS_PRECIOS: "PRODUCTOS_LISTAS_PRECIOS",
  GUARDARCAMBIOS_NOTAVENTA: "GUARDARCAMBIOS_NOTAVENTA",
  DOCUMENTOS_CAMBIAR_ESTADO: "DOCUMENTOS_CAMBIAR_ESTADO",
  GET_ALL_DOCUMENTOS_VENTAS: "GET_ALL_DOCUMENTOS_VENTAS",
  GUARDARCAMBIOS_NOTADEBITO: "GUARDARCAMBIOS_NOTADEBITO",
  GET_ALL_DOCUMENTOS_COMPRAS: "GET_ALL_DOCUMENTOS_COMPRAS",
  GUARDARCAMBIOS_ORDENCOMPRA: "GUARDARCAMBIOS_ORDENCOMPRA",
  DOCUMENTOS_RECURRENTES_PROC: "DOCUMENTOS_RECURRENTES_PROC",
  GUARDARCAMBIOS_FACTURAVENTA: "GUARDARCAMBIOS_FACTURAVENTA",
  GUARDARCAMBIOS_FACTURACOMPRA: "GUARDARCAMBIOS_FACTURACOMPRA",
  RECONCILE_BANKS_CASH_ACCOUNTS: "RECONCILE_BANKS_CASH_ACCOUNTS",
  DOCUMENTOSTIPOS_AREA_VENTAS_O_COMRAS: "DOCUMENTOSTIPOS_AREA_VENTAS_O_COMRAS"
}, Dt = {
  CASH: 1,
  CHECK: 3,
  CREDIT: 2,
  DEPOSIT: 7,
  TRANSFER: 8,
  PREPAYMENT: 6,
  CREDIT_NOTE: 4,
  DEBIT_CREDIT: 5
}, $v = {
  error_unhandled: "This error is not being handled.",
  error_required: "This field is required",
  error_major: "Major"
}, Av = {
  error_unhandled: "Este error no se está manejando.",
  error_required: "Este campo es obligatorio",
  error_major: "Mayor"
}, Fd = {
  en: $v,
  es: Av
}, _v = "Example", Mv = {
  key: _v
}, Lv = "Ejemplo", Vv = {
  key: Lv
}, zv = [
  {
    "message-en": "There was an error connecting to the server.",
    "message-es": "Hubo un error al conectar con el servidor.",
    keys: [
      "network"
    ]
  },
  {
    "message-en": "Timeout. Please try again later.",
    "message-es": "Tiempo de espera agotado. Por favor, inténtalo nuevamente más tarde.",
    keys: [
      "timeout"
    ]
  },
  {
    "message-en": "There was an error with the user.",
    "message-es": "Hubo un error con el usuario.",
    keys: [
      "user"
    ]
  }
];
var jo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bc = { exports: {} }, ha = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Od;
function Bv() {
  if (Od)
    return ha;
  Od = 1;
  var e = k, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, l, d) {
    var u, f = {}, h = null, g = null;
    d !== void 0 && (h = "" + d), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (g = l.ref);
    for (u in l)
      n.call(l, u) && !a.hasOwnProperty(u) && (f[u] = l[u]);
    if (c && c.defaultProps)
      for (u in l = c.defaultProps, l)
        f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: t, type: c, key: h, ref: g, props: f, _owner: o.current };
  }
  return ha.Fragment = r, ha.jsx = s, ha.jsxs = s, ha;
}
var ga = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nd;
function kv() {
  return Nd || (Nd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = k, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), E = Symbol.iterator, v = "@@iterator";
    function m(U) {
      if (U === null || typeof U != "object")
        return null;
      var oe = E && U[E] || U[v];
      return typeof oe == "function" ? oe : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(U) {
      {
        for (var oe = arguments.length, Ce = new Array(oe > 1 ? oe - 1 : 0), ze = 1; ze < oe; ze++)
          Ce[ze - 1] = arguments[ze];
        b("error", U, Ce);
      }
    }
    function b(U, oe, Ce) {
      {
        var ze = y.ReactDebugCurrentFrame, ct = ze.getStackAddendum();
        ct !== "" && (oe += "%s", Ce = Ce.concat([ct]));
        var gt = Ce.map(function(tt) {
          return String(tt);
        });
        gt.unshift("Warning: " + oe), Function.prototype.apply.call(console[U], console, gt);
      }
    }
    var C = !1, S = !1, T = !1, N = !1, V = !1, D;
    D = Symbol.for("react.module.reference");
    function x(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === n || U === a || V || U === o || U === d || U === u || N || U === g || C || S || T || typeof U == "object" && U !== null && (U.$$typeof === h || U.$$typeof === f || U.$$typeof === s || U.$$typeof === c || U.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === D || U.getModuleId !== void 0));
    }
    function O(U, oe, Ce) {
      var ze = U.displayName;
      if (ze)
        return ze;
      var ct = oe.displayName || oe.name || "";
      return ct !== "" ? Ce + "(" + ct + ")" : Ce;
    }
    function w(U) {
      return U.displayName || "Context";
    }
    function j(U) {
      if (U == null)
        return null;
      if (typeof U.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof U == "function")
        return U.displayName || U.name || null;
      if (typeof U == "string")
        return U;
      switch (U) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case c:
            var oe = U;
            return w(oe) + ".Consumer";
          case s:
            var Ce = U;
            return w(Ce._context) + ".Provider";
          case l:
            return O(U, U.render, "ForwardRef");
          case f:
            var ze = U.displayName || null;
            return ze !== null ? ze : j(U.type) || "Memo";
          case h: {
            var ct = U, gt = ct._payload, tt = ct._init;
            try {
              return j(tt(gt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, _ = 0, A, R, P, z, F, L, M;
    function B() {
    }
    B.__reactDisabledLog = !0;
    function W() {
      {
        if (_ === 0) {
          A = console.log, R = console.info, P = console.warn, z = console.error, F = console.group, L = console.groupCollapsed, M = console.groupEnd;
          var U = {
            configurable: !0,
            enumerable: !0,
            value: B,
            writable: !0
          };
          Object.defineProperties(console, {
            info: U,
            log: U,
            warn: U,
            error: U,
            group: U,
            groupCollapsed: U,
            groupEnd: U
          });
        }
        _++;
      }
    }
    function ee() {
      {
        if (_--, _ === 0) {
          var U = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, U, {
              value: A
            }),
            info: $({}, U, {
              value: R
            }),
            warn: $({}, U, {
              value: P
            }),
            error: $({}, U, {
              value: z
            }),
            group: $({}, U, {
              value: F
            }),
            groupCollapsed: $({}, U, {
              value: L
            }),
            groupEnd: $({}, U, {
              value: M
            })
          });
        }
        _ < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = y.ReactCurrentDispatcher, de;
    function Z(U, oe, Ce) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (ct) {
            var ze = ct.stack.trim().match(/\n( *(at )?)/);
            de = ze && ze[1] || "";
          }
        return `
` + de + U;
      }
    }
    var ce = !1, Y;
    {
      var he = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new he();
    }
    function ve(U, oe) {
      if (!U || ce)
        return "";
      {
        var Ce = Y.get(U);
        if (Ce !== void 0)
          return Ce;
      }
      var ze;
      ce = !0;
      var ct = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var gt;
      gt = te.current, te.current = null, W();
      try {
        if (oe) {
          var tt = function() {
            throw Error();
          };
          if (Object.defineProperty(tt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(tt, []);
            } catch (mr) {
              ze = mr;
            }
            Reflect.construct(U, [], tt);
          } else {
            try {
              tt.call();
            } catch (mr) {
              ze = mr;
            }
            U.call(tt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mr) {
            ze = mr;
          }
          U();
        }
      } catch (mr) {
        if (mr && ze && typeof mr.stack == "string") {
          for (var Je = mr.stack.split(`
`), Ot = ze.stack.split(`
`), Et = Je.length - 1, lt = Ot.length - 1; Et >= 1 && lt >= 0 && Je[Et] !== Ot[lt]; )
            lt--;
          for (; Et >= 1 && lt >= 0; Et--, lt--)
            if (Je[Et] !== Ot[lt]) {
              if (Et !== 1 || lt !== 1)
                do
                  if (Et--, lt--, lt < 0 || Je[Et] !== Ot[lt]) {
                    var Yt = `
` + Je[Et].replace(" at new ", " at ");
                    return U.displayName && Yt.includes("<anonymous>") && (Yt = Yt.replace("<anonymous>", U.displayName)), typeof U == "function" && Y.set(U, Yt), Yt;
                  }
                while (Et >= 1 && lt >= 0);
              break;
            }
        }
      } finally {
        ce = !1, te.current = gt, ee(), Error.prepareStackTrace = ct;
      }
      var Br = U ? U.displayName || U.name : "", qn = Br ? Z(Br) : "";
      return typeof U == "function" && Y.set(U, qn), qn;
    }
    function ue(U, oe, Ce) {
      return ve(U, !1);
    }
    function le(U) {
      var oe = U.prototype;
      return !!(oe && oe.isReactComponent);
    }
    function Fe(U, oe, Ce) {
      if (U == null)
        return "";
      if (typeof U == "function")
        return ve(U, le(U));
      if (typeof U == "string")
        return Z(U);
      switch (U) {
        case d:
          return Z("Suspense");
        case u:
          return Z("SuspenseList");
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case l:
            return ue(U.render);
          case f:
            return Fe(U.type, oe, Ce);
          case h: {
            var ze = U, ct = ze._payload, gt = ze._init;
            try {
              return Fe(gt(ct), oe, Ce);
            } catch {
            }
          }
        }
      return "";
    }
    var He = Object.prototype.hasOwnProperty, We = {}, ie = y.ReactDebugCurrentFrame;
    function ge(U) {
      if (U) {
        var oe = U._owner, Ce = Fe(U.type, U._source, oe ? oe.type : null);
        ie.setExtraStackFrame(Ce);
      } else
        ie.setExtraStackFrame(null);
    }
    function be(U, oe, Ce, ze, ct) {
      {
        var gt = Function.call.bind(He);
        for (var tt in U)
          if (gt(U, tt)) {
            var Je = void 0;
            try {
              if (typeof U[tt] != "function") {
                var Ot = Error((ze || "React class") + ": " + Ce + " type `" + tt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof U[tt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ot.name = "Invariant Violation", Ot;
              }
              Je = U[tt](oe, tt, ze, Ce, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Et) {
              Je = Et;
            }
            Je && !(Je instanceof Error) && (ge(ct), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ze || "React class", Ce, tt, typeof Je), ge(null)), Je instanceof Error && !(Je.message in We) && (We[Je.message] = !0, ge(ct), I("Failed %s type: %s", Ce, Je.message), ge(null));
          }
      }
    }
    var Ie = Array.isArray;
    function Pe(U) {
      return Ie(U);
    }
    function Le(U) {
      {
        var oe = typeof Symbol == "function" && Symbol.toStringTag, Ce = oe && U[Symbol.toStringTag] || U.constructor.name || "Object";
        return Ce;
      }
    }
    function Ve(U) {
      try {
        return _e(U), !1;
      } catch {
        return !0;
      }
    }
    function _e(U) {
      return "" + U;
    }
    function ut(U) {
      if (Ve(U))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Le(U)), _e(U);
    }
    var Nt = y.ReactCurrentOwner, pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ge, dt, q;
    q = {};
    function H(U) {
      if (He.call(U, "ref")) {
        var oe = Object.getOwnPropertyDescriptor(U, "ref").get;
        if (oe && oe.isReactWarning)
          return !1;
      }
      return U.ref !== void 0;
    }
    function G(U) {
      if (He.call(U, "key")) {
        var oe = Object.getOwnPropertyDescriptor(U, "key").get;
        if (oe && oe.isReactWarning)
          return !1;
      }
      return U.key !== void 0;
    }
    function ne(U, oe) {
      if (typeof U.ref == "string" && Nt.current && oe && Nt.current.stateNode !== oe) {
        var Ce = j(Nt.current.type);
        q[Ce] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(Nt.current.type), U.ref), q[Ce] = !0);
      }
    }
    function fe(U, oe) {
      {
        var Ce = function() {
          Ge || (Ge = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        Ce.isReactWarning = !0, Object.defineProperty(U, "key", {
          get: Ce,
          configurable: !0
        });
      }
    }
    function Te(U, oe) {
      {
        var Ce = function() {
          dt || (dt = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        Ce.isReactWarning = !0, Object.defineProperty(U, "ref", {
          get: Ce,
          configurable: !0
        });
      }
    }
    var Be = function(U, oe, Ce, ze, ct, gt, tt) {
      var Je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: U,
        key: oe,
        ref: Ce,
        props: tt,
        // Record the component responsible for creating this element.
        _owner: gt
      };
      return Je._store = {}, Object.defineProperty(Je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ze
      }), Object.defineProperty(Je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ct
      }), Object.freeze && (Object.freeze(Je.props), Object.freeze(Je)), Je;
    };
    function $e(U, oe, Ce, ze, ct) {
      {
        var gt, tt = {}, Je = null, Ot = null;
        Ce !== void 0 && (ut(Ce), Je = "" + Ce), G(oe) && (ut(oe.key), Je = "" + oe.key), H(oe) && (Ot = oe.ref, ne(oe, ct));
        for (gt in oe)
          He.call(oe, gt) && !pt.hasOwnProperty(gt) && (tt[gt] = oe[gt]);
        if (U && U.defaultProps) {
          var Et = U.defaultProps;
          for (gt in Et)
            tt[gt] === void 0 && (tt[gt] = Et[gt]);
        }
        if (Je || Ot) {
          var lt = typeof U == "function" ? U.displayName || U.name || "Unknown" : U;
          Je && fe(tt, lt), Ot && Te(tt, lt);
        }
        return Be(U, Je, Ot, ct, ze, Nt.current, tt);
      }
    }
    var pe = y.ReactCurrentOwner, X = y.ReactDebugCurrentFrame;
    function re(U) {
      if (U) {
        var oe = U._owner, Ce = Fe(U.type, U._source, oe ? oe.type : null);
        X.setExtraStackFrame(Ce);
      } else
        X.setExtraStackFrame(null);
    }
    var ye;
    ye = !1;
    function xe(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function Ae() {
      {
        if (pe.current) {
          var U = j(pe.current.type);
          if (U)
            return `

Check the render method of \`` + U + "`.";
        }
        return "";
      }
    }
    function je(U) {
      {
        if (U !== void 0) {
          var oe = U.fileName.replace(/^.*[\\\/]/, ""), Ce = U.lineNumber;
          return `

Check your code at ` + oe + ":" + Ce + ".";
        }
        return "";
      }
    }
    var Qe = {};
    function ht(U) {
      {
        var oe = Ae();
        if (!oe) {
          var Ce = typeof U == "string" ? U : U.displayName || U.name;
          Ce && (oe = `

Check the top-level render call using <` + Ce + ">.");
        }
        return oe;
      }
    }
    function Ft(U, oe) {
      {
        if (!U._store || U._store.validated || U.key != null)
          return;
        U._store.validated = !0;
        var Ce = ht(oe);
        if (Qe[Ce])
          return;
        Qe[Ce] = !0;
        var ze = "";
        U && U._owner && U._owner !== pe.current && (ze = " It was passed a child from " + j(U._owner.type) + "."), re(U), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ce, ze), re(null);
      }
    }
    function $t(U, oe) {
      {
        if (typeof U != "object")
          return;
        if (Pe(U))
          for (var Ce = 0; Ce < U.length; Ce++) {
            var ze = U[Ce];
            xe(ze) && Ft(ze, oe);
          }
        else if (xe(U))
          U._store && (U._store.validated = !0);
        else if (U) {
          var ct = m(U);
          if (typeof ct == "function" && ct !== U.entries)
            for (var gt = ct.call(U), tt; !(tt = gt.next()).done; )
              xe(tt.value) && Ft(tt.value, oe);
        }
      }
    }
    function Er(U) {
      {
        var oe = U.type;
        if (oe == null || typeof oe == "string")
          return;
        var Ce;
        if (typeof oe == "function")
          Ce = oe.propTypes;
        else if (typeof oe == "object" && (oe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        oe.$$typeof === f))
          Ce = oe.propTypes;
        else
          return;
        if (Ce) {
          var ze = j(oe);
          be(Ce, U.props, "prop", ze, U);
        } else if (oe.PropTypes !== void 0 && !ye) {
          ye = !0;
          var ct = j(oe);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ct || "Unknown");
        }
        typeof oe.getDefaultProps == "function" && !oe.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function nn(U) {
      {
        for (var oe = Object.keys(U.props), Ce = 0; Ce < oe.length; Ce++) {
          var ze = oe[Ce];
          if (ze !== "children" && ze !== "key") {
            re(U), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ze), re(null);
            break;
          }
        }
        U.ref !== null && (re(U), I("Invalid attribute `ref` supplied to `React.Fragment`."), re(null));
      }
    }
    function Lt(U, oe, Ce, ze, ct, gt) {
      {
        var tt = x(U);
        if (!tt) {
          var Je = "";
          (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && (Je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ot = je(ct);
          Ot ? Je += Ot : Je += Ae();
          var Et;
          U === null ? Et = "null" : Pe(U) ? Et = "array" : U !== void 0 && U.$$typeof === t ? (Et = "<" + (j(U.type) || "Unknown") + " />", Je = " Did you accidentally export a JSX literal instead of a component?") : Et = typeof U, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Et, Je);
        }
        var lt = $e(U, oe, Ce, ct, gt);
        if (lt == null)
          return lt;
        if (tt) {
          var Yt = oe.children;
          if (Yt !== void 0)
            if (ze)
              if (Pe(Yt)) {
                for (var Br = 0; Br < Yt.length; Br++)
                  $t(Yt[Br], U);
                Object.freeze && Object.freeze(Yt);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $t(Yt, U);
        }
        return U === n ? nn(lt) : Er(lt), lt;
      }
    }
    function on(U, oe, Ce) {
      return Lt(U, oe, Ce, !0);
    }
    function an(U, oe, Ce) {
      return Lt(U, oe, Ce, !1);
    }
    var zr = an, sn = on;
    ga.Fragment = n, ga.jsx = zr, ga.jsxs = sn;
  }()), ga;
}
process.env.NODE_ENV === "production" ? Bc.exports = Bv() : Bc.exports = kv();
var i = Bc.exports;
function mt() {
  return mt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mt.apply(this, arguments);
}
var Uv = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const qv = Uv;
function Wf(e) {
  if (Array.isArray(e))
    return e;
}
function Hv(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, a, s, c = [], l = !0, d = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        l = !1;
      } else
        for (; !(l = (n = a.call(r)).done) && (c.push(n.value), c.length !== t); l = !0)
          ;
    } catch (u) {
      d = !0, o = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return c;
  }
}
function kc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Ll(e, t) {
  if (e) {
    if (typeof e == "string")
      return kc(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return kc(e, t);
  }
}
function Gf() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Se(e, t) {
  return Wf(e) || Hv(e, t) || Ll(e, t) || Gf();
}
function it(e) {
  "@babel/helpers - typeof";
  return it = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, it(e);
}
function Wv(e, t) {
  if (it(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (it(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Kf(e) {
  var t = Wv(e, "string");
  return it(t) == "symbol" ? t : String(t);
}
function Q(e, t, r) {
  return t = Kf(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Gv(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function cr(e, t) {
  if (e == null)
    return {};
  var r = Gv(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
var Yf = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var a = "", s = 0; s < arguments.length; s++) {
        var c = arguments[s];
        c && (a = o(a, n(c)));
      }
      return a;
    }
    function n(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var s = "";
      for (var c in a)
        t.call(a, c) && a[c] && (s = o(s, c));
      return s;
    }
    function o(a, s) {
      return s ? a ? a + " " + s : a + s : a;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Yf);
var Kv = Yf.exports;
const we = /* @__PURE__ */ Hf(Kv);
function Xt(e, t) {
  Yv(e) && (e = "100%");
  var r = Qv(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function bi(e) {
  return Math.min(1, Math.max(0, e));
}
function Yv(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Qv(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function Qf(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ci(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function ro(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Xv(e, t, r) {
  return {
    r: Xt(e, 255) * 255,
    g: Xt(t, 255) * 255,
    b: Xt(r, 255) * 255
  };
}
function Rd(e, t, r) {
  e = Xt(e, 255), t = Xt(t, 255), r = Xt(r, 255);
  var n = Math.max(e, t, r), o = Math.min(e, t, r), a = 0, s = 0, c = (n + o) / 2;
  if (n === o)
    s = 0, a = 0;
  else {
    var l = n - o;
    switch (s = c > 0.5 ? l / (2 - n - o) : l / (n + o), n) {
      case e:
        a = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        a = (r - e) / l + 2;
        break;
      case r:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s, l: c };
}
function tc(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * (6 * r) : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function Zv(e, t, r) {
  var n, o, a;
  if (e = Xt(e, 360), t = Xt(t, 100), r = Xt(r, 100), t === 0)
    o = r, a = r, n = r;
  else {
    var s = r < 0.5 ? r * (1 + t) : r + t - r * t, c = 2 * r - s;
    n = tc(c, s, e + 1 / 3), o = tc(c, s, e), a = tc(c, s, e - 1 / 3);
  }
  return { r: n * 255, g: o * 255, b: a * 255 };
}
function Uc(e, t, r) {
  e = Xt(e, 255), t = Xt(t, 255), r = Xt(r, 255);
  var n = Math.max(e, t, r), o = Math.min(e, t, r), a = 0, s = n, c = n - o, l = n === 0 ? 0 : c / n;
  if (n === o)
    a = 0;
  else {
    switch (n) {
      case e:
        a = (t - r) / c + (t < r ? 6 : 0);
        break;
      case t:
        a = (r - e) / c + 2;
        break;
      case r:
        a = (e - t) / c + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: l, v: s };
}
function Jv(e, t, r) {
  e = Xt(e, 360) * 6, t = Xt(t, 100), r = Xt(r, 100);
  var n = Math.floor(e), o = e - n, a = r * (1 - t), s = r * (1 - o * t), c = r * (1 - (1 - o) * t), l = n % 6, d = [r, s, a, a, c, r][l], u = [c, r, r, s, a, a][l], f = [a, a, c, r, r, s][l];
  return { r: d * 255, g: u * 255, b: f * 255 };
}
function qc(e, t, r, n) {
  var o = [
    ro(Math.round(e).toString(16)),
    ro(Math.round(t).toString(16)),
    ro(Math.round(r).toString(16))
  ];
  return n && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function ey(e, t, r, n, o) {
  var a = [
    ro(Math.round(e).toString(16)),
    ro(Math.round(t).toString(16)),
    ro(Math.round(r).toString(16)),
    ro(ty(n))
  ];
  return o && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function ty(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Pd(e) {
  return vr(e) / 255;
}
function vr(e) {
  return parseInt(e, 16);
}
function ry(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var Hc = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Ro(e) {
  var t = { r: 0, g: 0, b: 0 }, r = 1, n = null, o = null, a = null, s = !1, c = !1;
  return typeof e == "string" && (e = ay(e)), typeof e == "object" && (un(e.r) && un(e.g) && un(e.b) ? (t = Xv(e.r, e.g, e.b), s = !0, c = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : un(e.h) && un(e.s) && un(e.v) ? (n = Ci(e.s), o = Ci(e.v), t = Jv(e.h, n, o), s = !0, c = "hsv") : un(e.h) && un(e.s) && un(e.l) && (n = Ci(e.s), a = Ci(e.l), t = Zv(e.h, n, a), s = !0, c = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (r = e.a)), r = Qf(r), {
    ok: s,
    format: e.format || c,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
var ny = "[-\\+]?\\d+%?", oy = "[-\\+]?\\d*\\.\\d+%?", Tn = "(?:".concat(oy, ")|(?:").concat(ny, ")"), rc = "[\\s|\\(]+(".concat(Tn, ")[,|\\s]+(").concat(Tn, ")[,|\\s]+(").concat(Tn, ")\\s*\\)?"), nc = "[\\s|\\(]+(".concat(Tn, ")[,|\\s]+(").concat(Tn, ")[,|\\s]+(").concat(Tn, ")[,|\\s]+(").concat(Tn, ")\\s*\\)?"), Pr = {
  CSS_UNIT: new RegExp(Tn),
  rgb: new RegExp("rgb" + rc),
  rgba: new RegExp("rgba" + nc),
  hsl: new RegExp("hsl" + rc),
  hsla: new RegExp("hsla" + nc),
  hsv: new RegExp("hsv" + rc),
  hsva: new RegExp("hsva" + nc),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function ay(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (Hc[e])
    e = Hc[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var r = Pr.rgb.exec(e);
  return r ? { r: r[1], g: r[2], b: r[3] } : (r = Pr.rgba.exec(e), r ? { r: r[1], g: r[2], b: r[3], a: r[4] } : (r = Pr.hsl.exec(e), r ? { h: r[1], s: r[2], l: r[3] } : (r = Pr.hsla.exec(e), r ? { h: r[1], s: r[2], l: r[3], a: r[4] } : (r = Pr.hsv.exec(e), r ? { h: r[1], s: r[2], v: r[3] } : (r = Pr.hsva.exec(e), r ? { h: r[1], s: r[2], v: r[3], a: r[4] } : (r = Pr.hex8.exec(e), r ? {
    r: vr(r[1]),
    g: vr(r[2]),
    b: vr(r[3]),
    a: Pd(r[4]),
    format: t ? "name" : "hex8"
  } : (r = Pr.hex6.exec(e), r ? {
    r: vr(r[1]),
    g: vr(r[2]),
    b: vr(r[3]),
    format: t ? "name" : "hex"
  } : (r = Pr.hex4.exec(e), r ? {
    r: vr(r[1] + r[1]),
    g: vr(r[2] + r[2]),
    b: vr(r[3] + r[3]),
    a: Pd(r[4] + r[4]),
    format: t ? "name" : "hex8"
  } : (r = Pr.hex3.exec(e), r ? {
    r: vr(r[1] + r[1]),
    g: vr(r[2] + r[2]),
    b: vr(r[3] + r[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function un(e) {
  return !!Pr.CSS_UNIT.exec(String(e));
}
var yr = (
  /** @class */
  function() {
    function e(t, r) {
      t === void 0 && (t = ""), r === void 0 && (r = {});
      var n;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = ry(t)), this.originalInput = t;
      var o = Ro(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = r.format) !== null && n !== void 0 ? n : o.format, this.gradientType = r.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), r, n, o, a = t.r / 255, s = t.g / 255, c = t.b / 255;
      return a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? n = s / 12.92 : n = Math.pow((s + 0.055) / 1.055, 2.4), c <= 0.03928 ? o = c / 12.92 : o = Math.pow((c + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * n + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = Qf(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = Uc(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = Uc(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(r, ", ").concat(n, "%, ").concat(o, "%)") : "hsva(".concat(r, ", ").concat(n, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = Rd(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = Rd(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(r, ", ").concat(n, "%, ").concat(o, "%)") : "hsla(".concat(r, ", ").concat(n, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), qc(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), ey(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), r = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(r, ", ").concat(n, ")") : "rgba(".concat(t, ", ").concat(r, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(r) {
        return "".concat(Math.round(Xt(r, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(r) {
        return Math.round(Xt(r, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + qc(this.r, this.g, this.b, !1), r = 0, n = Object.entries(Hc); r < n.length; r++) {
        var o = n[r], a = o[0], s = o[1];
        if (t === s)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var r = !!t;
      t = t ?? this.format;
      var n = !1, o = this.a < 1 && this.a >= 0, a = !r && o && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (n = this.toRgbString()), t === "prgb" && (n = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (n = this.toHexString()), t === "hex3" && (n = this.toHexString(!0)), t === "hex4" && (n = this.toHex8String(!0)), t === "hex8" && (n = this.toHex8String()), t === "name" && (n = this.toName()), t === "hsl" && (n = this.toHslString()), t === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.l += t / 100, r.l = bi(r.l), new e(r);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var r = this.toRgb();
      return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(t / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(t / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(t / 100)))), new e(r);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.l -= t / 100, r.l = bi(r.l), new e(r);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.s -= t / 100, r.s = bi(r.s), new e(r);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var r = this.toHsl();
      return r.s += t / 100, r.s = bi(r.s), new e(r);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var r = this.toHsl(), n = (r.h + t) % 360;
      return r.h = n < 0 ? 360 + n : n, new e(r);
    }, e.prototype.mix = function(t, r) {
      r === void 0 && (r = 50);
      var n = this.toRgb(), o = new e(t).toRgb(), a = r / 100, s = {
        r: (o.r - n.r) * a + n.r,
        g: (o.g - n.g) * a + n.g,
        b: (o.b - n.b) * a + n.b,
        a: (o.a - n.a) * a + n.a
      };
      return new e(s);
    }, e.prototype.analogous = function(t, r) {
      t === void 0 && (t = 6), r === void 0 && (r = 30);
      var n = this.toHsl(), o = 360 / r, a = [this];
      for (n.h = (n.h - (o * t >> 1) + 720) % 360; --t; )
        n.h = (n.h + o) % 360, a.push(new e(n));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var r = this.toHsv(), n = r.h, o = r.s, a = r.v, s = [], c = 1 / t; t--; )
        s.push(new e({ h: n, s: o, v: a })), a = (a + c) % 1;
      return s;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), r = t.h;
      return [
        this,
        new e({ h: (r + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (r + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var r = this.toRgb(), n = new e(t).toRgb(), o = r.a + n.a * (1 - r.a);
      return new e({
        r: (r.r * r.a + n.r * n.a * (1 - r.a)) / o,
        g: (r.g * r.a + n.g * n.a * (1 - r.a)) / o,
        b: (r.b * r.a + n.b * n.a * (1 - r.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var r = this.toHsl(), n = r.h, o = [this], a = 360 / t, s = 1; s < t; s++)
        o.push(new e({ h: (n + s * a) % 360, s: r.s, l: r.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), Ii = 2, jd = 0.16, iy = 0.05, sy = 0.05, cy = 0.15, Xf = 5, Zf = 4, ly = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function $d(e) {
  var t = e.r, r = e.g, n = e.b, o = Uc(t, r, n);
  return {
    h: o.h * 360,
    s: o.s,
    v: o.v
  };
}
function xi(e) {
  var t = e.r, r = e.g, n = e.b;
  return "#".concat(qc(t, r, n, !1));
}
function dy(e, t, r) {
  var n = r / 100, o = {
    r: (t.r - e.r) * n + e.r,
    g: (t.g - e.g) * n + e.g,
    b: (t.b - e.b) * n + e.b
  };
  return o;
}
function Ad(e, t, r) {
  var n;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? n = r ? Math.round(e.h) - Ii * t : Math.round(e.h) + Ii * t : n = r ? Math.round(e.h) + Ii * t : Math.round(e.h) - Ii * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function _d(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var n;
  return r ? n = e.s - jd * t : t === Zf ? n = e.s + jd : n = e.s + iy * t, n > 1 && (n = 1), r && t === Xf && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Number(n.toFixed(2));
}
function Md(e, t, r) {
  var n;
  return r ? n = e.v + sy * t : n = e.v - cy * t, n > 1 && (n = 1), Number(n.toFixed(2));
}
function co(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], n = Ro(e), o = Xf; o > 0; o -= 1) {
    var a = $d(n), s = xi(Ro({
      h: Ad(a, o, !0),
      s: _d(a, o, !0),
      v: Md(a, o, !0)
    }));
    r.push(s);
  }
  r.push(xi(n));
  for (var c = 1; c <= Zf; c += 1) {
    var l = $d(n), d = xi(Ro({
      h: Ad(l, c),
      s: _d(l, c),
      v: Md(l, c)
    }));
    r.push(d);
  }
  return t.theme === "dark" ? ly.map(function(u) {
    var f = u.index, h = u.opacity, g = xi(dy(Ro(t.backgroundColor || "#141414"), Ro(r[f]), h * 100));
    return g;
  }) : r;
}
var Mo = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Ta = {}, oc = {};
Object.keys(Mo).forEach(function(e) {
  Ta[e] = co(Mo[e]), Ta[e].primary = Ta[e][5], oc[e] = co(Mo[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), oc[e].primary = oc[e][5];
});
var uy = Ta.gold, Wc = Ta.blue, Vl = /* @__PURE__ */ Ha({});
function Ld(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ld(Object(r), !0).forEach(function(n) {
      Q(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ld(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function fy(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var Vd = "data-rc-order", zd = "data-rc-priority", my = "rc-util-key", Gc = /* @__PURE__ */ new Map();
function Jf() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : my;
}
function fs(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function py(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function em(e) {
  return Array.from((Gc.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function tm(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Zt())
    return null;
  var r = t.csp, n = t.prepend, o = t.priority, a = o === void 0 ? 0 : o, s = py(n), c = s === "prependQueue", l = document.createElement("style");
  l.setAttribute(Vd, s), c && a && l.setAttribute(zd, "".concat(a)), r != null && r.nonce && (l.nonce = r?.nonce), l.innerHTML = e;
  var d = fs(t), u = d.firstChild;
  if (n) {
    if (c) {
      var f = em(d).filter(function(h) {
        if (!["prepend", "prependQueue"].includes(h.getAttribute(Vd)))
          return !1;
        var g = Number(h.getAttribute(zd) || 0);
        return a >= g;
      });
      if (f.length)
        return d.insertBefore(l, f[f.length - 1].nextSibling), l;
    }
    d.insertBefore(l, u);
  } else
    d.appendChild(l);
  return l;
}
function rm(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = fs(t);
  return em(r).find(function(n) {
    return n.getAttribute(Jf(t)) === e;
  });
}
function Aa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = rm(e, t);
  if (r) {
    var n = fs(t);
    n.removeChild(r);
  }
}
function hy(e, t) {
  var r = Gc.get(e);
  if (!r || !fy(document, r)) {
    var n = tm("", t), o = n.parentNode;
    Gc.set(e, o), e.removeChild(n);
  }
}
function Pn(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = fs(r);
  hy(n, r);
  var o = rm(t, r);
  if (o) {
    var a, s;
    if ((a = r.csp) !== null && a !== void 0 && a.nonce && o.nonce !== ((s = r.csp) === null || s === void 0 ? void 0 : s.nonce)) {
      var c;
      o.nonce = (c = r.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return o.innerHTML !== e && (o.innerHTML = e), o;
  }
  var l = tm(e, r);
  return l.setAttribute(Jf(r), t), l;
}
function nm(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function gy(e) {
  return nm(e) instanceof ShadowRoot;
}
function Xi(e) {
  return gy(e) ? nm(e) : null;
}
var Kc = {}, zl = [], vy = function(t) {
  zl.push(t);
};
function Bo(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = zl.reduce(function(n, o) {
      return o(n ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function yy(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = zl.reduce(function(n, o) {
      return o(n ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function om() {
  Kc = {};
}
function am(e, t, r) {
  !t && !Kc[r] && (e(!1, r), Kc[r] = !0);
}
function Tt(e, t) {
  am(Bo, e, t);
}
function by(e, t) {
  am(yy, e, t);
}
Tt.preMessage = vy;
Tt.resetWarned = om;
Tt.noteOnce = by;
function Cy(e) {
  return e.replace(/-(.)/g, function(t, r) {
    return r.toUpperCase();
  });
}
function Iy(e, t) {
  Tt(e, "[@ant-design/icons] ".concat(t));
}
function Bd(e) {
  return it(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (it(e.icon) === "object" || typeof e.icon == "function");
}
function kd() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, r) {
    var n = e[r];
    switch (r) {
      case "class":
        t.className = n, delete t.class;
        break;
      default:
        delete t[r], t[Cy(r)] = n;
    }
    return t;
  }, {});
}
function Yc(e, t, r) {
  return r ? /* @__PURE__ */ k.createElement(e.tag, ae(ae({
    key: t
  }, kd(e.attrs)), r), (e.children || []).map(function(n, o) {
    return Yc(n, "".concat(t, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ k.createElement(e.tag, ae({
    key: t
  }, kd(e.attrs)), (e.children || []).map(function(n, o) {
    return Yc(n, "".concat(t, "-").concat(e.tag, "-").concat(o));
  }));
}
function im(e) {
  return co(e)[0];
}
function sm(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var xy = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Sy = function(t) {
  var r = Ir(Vl), n = r.csp, o = r.prefixCls, a = xy;
  o && (a = a.replace(/anticon/g, o)), xr(function() {
    var s = t.current, c = Xi(s);
    Pn(a, "@ant-design-icons", {
      prepend: !0,
      csp: n,
      attachTo: c
    });
  }, []);
}, Ey = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], Fa = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Dy(e) {
  var t = e.primaryColor, r = e.secondaryColor;
  Fa.primaryColor = t, Fa.secondaryColor = r || im(t), Fa.calculated = !!r;
}
function wy() {
  return ae({}, Fa);
}
var ms = function(t) {
  var r = t.icon, n = t.className, o = t.onClick, a = t.style, s = t.primaryColor, c = t.secondaryColor, l = cr(t, Ey), d = p.useRef(), u = Fa;
  if (s && (u = {
    primaryColor: s,
    secondaryColor: c || im(s)
  }), Sy(d), Iy(Bd(r), "icon should be icon definiton, but got ".concat(r)), !Bd(r))
    return null;
  var f = r;
  return f && typeof f.icon == "function" && (f = ae(ae({}, f), {}, {
    icon: f.icon(u.primaryColor, u.secondaryColor)
  })), Yc(f.icon, "svg-".concat(f.name), ae(ae({
    className: n,
    onClick: o,
    style: a,
    "data-icon": f.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: d
  }));
};
ms.displayName = "IconReact";
ms.getTwoToneColors = wy;
ms.setTwoToneColors = Dy;
const Bl = ms;
function cm(e) {
  var t = sm(e), r = Se(t, 2), n = r[0], o = r[1];
  return Bl.setTwoToneColors({
    primaryColor: n,
    secondaryColor: o
  });
}
function Ty() {
  var e = Bl.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Fy = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
cm(Wc.primary);
var ps = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.className, n = e.icon, o = e.spin, a = e.rotate, s = e.tabIndex, c = e.onClick, l = e.twoToneColor, d = cr(e, Fy), u = p.useContext(Vl), f = u.prefixCls, h = f === void 0 ? "anticon" : f, g = u.rootClassName, E = we(g, h, Q(Q({}, "".concat(h, "-").concat(n.name), !!n.name), "".concat(h, "-spin"), !!o || n.name === "loading"), r), v = s;
  v === void 0 && c && (v = -1);
  var m = a ? {
    msTransform: "rotate(".concat(a, "deg)"),
    transform: "rotate(".concat(a, "deg)")
  } : void 0, y = sm(l), I = Se(y, 2), b = I[0], C = I[1];
  return /* @__PURE__ */ p.createElement("span", mt({
    role: "img",
    "aria-label": n.name
  }, d, {
    ref: t,
    tabIndex: v,
    onClick: c,
    className: E
  }), /* @__PURE__ */ p.createElement(Bl, {
    icon: n,
    primaryColor: b,
    secondaryColor: C,
    style: m
  }));
});
ps.displayName = "AntdIcon";
ps.getTwoToneColor = Ty;
ps.setTwoToneColor = cm;
const or = ps;
var lm = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: qv
  }));
};
process.env.NODE_ENV !== "production" && (lm.displayName = "CloseCircleFilled");
const kl = /* @__PURE__ */ p.forwardRef(lm);
function Oy(e) {
  if (Array.isArray(e))
    return kc(e);
}
function dm(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ny() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ne(e) {
  return Oy(e) || dm(e) || Ll(e) || Ny();
}
function Ry(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function Py(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function Ud(e, t, r, n) {
  if (r) {
    var o = t;
    if (t.type === "click") {
      var a = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: a
        },
        currentTarget: {
          value: a
        }
      }), a.value = "", r(o);
      return;
    }
    if (e.type !== "file" && n !== void 0) {
      var s = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: s
        },
        currentTarget: {
          value: s
        }
      }), s.value = n, r(o);
      return;
    }
    r(o);
  }
}
var jy = function(t) {
  var r, n, o = t.inputElement, a = t.children, s = t.prefixCls, c = t.prefix, l = t.suffix, d = t.addonBefore, u = t.addonAfter, f = t.className, h = t.style, g = t.disabled, E = t.readOnly, v = t.focused, m = t.triggerFocus, y = t.allowClear, I = t.value, b = t.handleReset, C = t.hidden, S = t.classes, T = t.classNames, N = t.dataAttrs, V = t.styles, D = t.components, x = a ?? o, O = D?.affixWrapper || "span", w = D?.groupWrapper || "span", j = D?.wrapper || "span", $ = D?.groupAddon || "span", _ = Wt(null), A = function(le) {
    var Fe;
    (Fe = _.current) !== null && Fe !== void 0 && Fe.contains(le.target) && m?.();
  }, R = Py(t), P = /* @__PURE__ */ Hg(x, {
    value: I,
    className: we(x.props.className, !R && T?.variant) || null
  });
  if (R) {
    var z, F = null;
    if (y) {
      var L, M = !g && !E && I, B = "".concat(s, "-clear-icon"), W = it(y) === "object" && y !== null && y !== void 0 && y.clearIcon ? y.clearIcon : "✖";
      F = /* @__PURE__ */ k.createElement("span", {
        onClick: b,
        onMouseDown: function(le) {
          return le.preventDefault();
        },
        className: we(B, (L = {}, Q(L, "".concat(B, "-hidden"), !M), Q(L, "".concat(B, "-has-suffix"), !!l), L)),
        role: "button",
        tabIndex: -1
      }, W);
    }
    var ee = "".concat(s, "-affix-wrapper"), te = we(ee, (z = {}, Q(z, "".concat(s, "-disabled"), g), Q(z, "".concat(ee, "-disabled"), g), Q(z, "".concat(ee, "-focused"), v), Q(z, "".concat(ee, "-readonly"), E), Q(z, "".concat(ee, "-input-with-clear-btn"), l && y && I), z), S?.affixWrapper, T?.affixWrapper, T?.variant), de = (l || y) && /* @__PURE__ */ k.createElement("span", {
      className: we("".concat(s, "-suffix"), T?.suffix),
      style: V?.suffix
    }, F, l);
    P = /* @__PURE__ */ k.createElement(O, mt({
      className: te,
      style: V?.affixWrapper,
      onClick: A
    }, N?.affixWrapper, {
      ref: _
    }), c && /* @__PURE__ */ k.createElement("span", {
      className: we("".concat(s, "-prefix"), T?.prefix),
      style: V?.prefix
    }, c), P, de);
  }
  if (Ry(t)) {
    var Z = "".concat(s, "-group"), ce = "".concat(Z, "-addon"), Y = "".concat(Z, "-wrapper"), he = we("".concat(s, "-wrapper"), Z, S?.wrapper, T?.wrapper), ve = we(Y, Q({}, "".concat(Y, "-disabled"), g), S?.group, T?.groupWrapper);
    P = /* @__PURE__ */ k.createElement(w, {
      className: ve
    }, /* @__PURE__ */ k.createElement(j, {
      className: he
    }, d && /* @__PURE__ */ k.createElement($, {
      className: ce
    }, d), P, u && /* @__PURE__ */ k.createElement($, {
      className: ce
    }, u)));
  }
  return /* @__PURE__ */ k.cloneElement(P, {
    className: we((r = P.props) === null || r === void 0 ? void 0 : r.className, f) || null,
    style: ae(ae({}, (n = P.props) === null || n === void 0 ? void 0 : n.style), h),
    hidden: C
  });
};
function Ur(e) {
  var t = p.useRef();
  t.current = e;
  var r = p.useCallback(function() {
    for (var n, o = arguments.length, a = new Array(o), s = 0; s < o; s++)
      a[s] = arguments[s];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(a));
  }, []);
  return r;
}
var qd = process.env.NODE_ENV !== "test" && Zt() ? p.useLayoutEffect : p.useEffect, jt = function(t, r) {
  var n = p.useRef(!0);
  qd(function() {
    return t(n.current);
  }, r), qd(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, Hd = function(t, r) {
  jt(function(n) {
    if (!n)
      return t();
  }, r);
};
function ao(e) {
  var t = p.useRef(!1), r = p.useState(e), n = Se(r, 2), o = n[0], a = n[1];
  p.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function s(c, l) {
    l && t.current || a(c);
  }
  return [o, s];
}
function ac(e) {
  return e !== void 0;
}
function Ka(e, t) {
  var r = t || {}, n = r.defaultValue, o = r.value, a = r.onChange, s = r.postState, c = ao(function() {
    return ac(o) ? o : ac(n) ? typeof n == "function" ? n() : n : typeof e == "function" ? e() : e;
  }), l = Se(c, 2), d = l[0], u = l[1], f = o !== void 0 ? o : d, h = s ? s(f) : f, g = Ur(a), E = ao([f]), v = Se(E, 2), m = v[0], y = v[1];
  Hd(function() {
    var b = m[0];
    d !== b && g(d, b);
  }, [m]), Hd(function() {
    ac(o) || u(o);
  }, [o]);
  var I = Ur(function(b, C) {
    u(b, C), y([f], C);
  });
  return [h, I];
}
function Ya(e, t) {
  var r = ae({}, e);
  return Array.isArray(t) && t.forEach(function(n) {
    delete r[n];
  }), r;
}
var $y = ["show"];
function Ay(e, t) {
  return p.useMemo(function() {
    var r = {};
    t && (r.show = it(t) === "object" && t.formatter ? t.formatter : !!t), r = ae(ae({}, r), e);
    var n = r, o = n.show, a = cr(n, $y);
    return ae(ae({}, a), {}, {
      show: !!o,
      showFormatter: typeof o == "function" ? o : void 0,
      strategy: a.strategy || function(s) {
        return s.length;
      }
    });
  }, [e, t]);
}
var Qc = { exports: {} }, vt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wd;
function _y() {
  if (Wd)
    return vt;
  Wd = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), E;
  E = Symbol.for("react.module.reference");
  function v(m) {
    if (typeof m == "object" && m !== null) {
      var y = m.$$typeof;
      switch (y) {
        case e:
          switch (m = m.type, m) {
            case r:
            case o:
            case n:
            case d:
            case u:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case c:
                case s:
                case l:
                case h:
                case f:
                case a:
                  return m;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return vt.ContextConsumer = s, vt.ContextProvider = a, vt.Element = e, vt.ForwardRef = l, vt.Fragment = r, vt.Lazy = h, vt.Memo = f, vt.Portal = t, vt.Profiler = o, vt.StrictMode = n, vt.Suspense = d, vt.SuspenseList = u, vt.isAsyncMode = function() {
    return !1;
  }, vt.isConcurrentMode = function() {
    return !1;
  }, vt.isContextConsumer = function(m) {
    return v(m) === s;
  }, vt.isContextProvider = function(m) {
    return v(m) === a;
  }, vt.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, vt.isForwardRef = function(m) {
    return v(m) === l;
  }, vt.isFragment = function(m) {
    return v(m) === r;
  }, vt.isLazy = function(m) {
    return v(m) === h;
  }, vt.isMemo = function(m) {
    return v(m) === f;
  }, vt.isPortal = function(m) {
    return v(m) === t;
  }, vt.isProfiler = function(m) {
    return v(m) === o;
  }, vt.isStrictMode = function(m) {
    return v(m) === n;
  }, vt.isSuspense = function(m) {
    return v(m) === d;
  }, vt.isSuspenseList = function(m) {
    return v(m) === u;
  }, vt.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === o || m === n || m === d || m === u || m === g || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === f || m.$$typeof === a || m.$$typeof === s || m.$$typeof === l || m.$$typeof === E || m.getModuleId !== void 0);
  }, vt.typeOf = v, vt;
}
var yt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gd;
function My() {
  return Gd || (Gd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), E = !1, v = !1, m = !1, y = !1, I = !1, b;
    b = Symbol.for("react.module.reference");
    function C(le) {
      return !!(typeof le == "string" || typeof le == "function" || le === r || le === o || I || le === n || le === d || le === u || y || le === g || E || v || m || typeof le == "object" && le !== null && (le.$$typeof === h || le.$$typeof === f || le.$$typeof === a || le.$$typeof === s || le.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      le.$$typeof === b || le.getModuleId !== void 0));
    }
    function S(le) {
      if (typeof le == "object" && le !== null) {
        var Fe = le.$$typeof;
        switch (Fe) {
          case e:
            var He = le.type;
            switch (He) {
              case r:
              case o:
              case n:
              case d:
              case u:
                return He;
              default:
                var We = He && He.$$typeof;
                switch (We) {
                  case c:
                  case s:
                  case l:
                  case h:
                  case f:
                  case a:
                    return We;
                  default:
                    return Fe;
                }
            }
          case t:
            return Fe;
        }
      }
    }
    var T = s, N = a, V = e, D = l, x = r, O = h, w = f, j = t, $ = o, _ = n, A = d, R = u, P = !1, z = !1;
    function F(le) {
      return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(le) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function M(le) {
      return S(le) === s;
    }
    function B(le) {
      return S(le) === a;
    }
    function W(le) {
      return typeof le == "object" && le !== null && le.$$typeof === e;
    }
    function ee(le) {
      return S(le) === l;
    }
    function te(le) {
      return S(le) === r;
    }
    function de(le) {
      return S(le) === h;
    }
    function Z(le) {
      return S(le) === f;
    }
    function ce(le) {
      return S(le) === t;
    }
    function Y(le) {
      return S(le) === o;
    }
    function he(le) {
      return S(le) === n;
    }
    function ve(le) {
      return S(le) === d;
    }
    function ue(le) {
      return S(le) === u;
    }
    yt.ContextConsumer = T, yt.ContextProvider = N, yt.Element = V, yt.ForwardRef = D, yt.Fragment = x, yt.Lazy = O, yt.Memo = w, yt.Portal = j, yt.Profiler = $, yt.StrictMode = _, yt.Suspense = A, yt.SuspenseList = R, yt.isAsyncMode = F, yt.isConcurrentMode = L, yt.isContextConsumer = M, yt.isContextProvider = B, yt.isElement = W, yt.isForwardRef = ee, yt.isFragment = te, yt.isLazy = de, yt.isMemo = Z, yt.isPortal = ce, yt.isProfiler = Y, yt.isStrictMode = he, yt.isSuspense = ve, yt.isSuspenseList = ue, yt.isValidElementType = C, yt.typeOf = S;
  }()), yt;
}
process.env.NODE_ENV === "production" ? Qc.exports = _y() : Qc.exports = My();
var um = Qc.exports;
function lo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return k.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(lo(n)) : um.isFragment(n) && n.props ? r = r.concat(lo(n.props.children, t)) : r.push(n));
  }), r;
}
function Zi(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function Vi(e) {
  return Zi(e) ? e : e instanceof k.Component ? Zg.findDOMNode(e) : null;
}
function Ul(e, t, r) {
  var n = p.useRef({});
  return (!("value" in n.current) || r(n.current.condition, t)) && (n.current.value = e(), n.current.condition = t), n.current.value;
}
function ql(e, t) {
  typeof e == "function" ? e(t) : it(e) === "object" && e && "current" in e && (e.current = t);
}
function po() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t.filter(function(o) {
    return o;
  });
  return n.length <= 1 ? n[0] : function(o) {
    t.forEach(function(a) {
      ql(a, o);
    });
  };
}
function Hl() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return Ul(function() {
    return po.apply(void 0, t);
  }, t, function(n, o) {
    return n.length !== o.length || n.every(function(a, s) {
      return a !== o[s];
    });
  });
}
function Jo(e) {
  var t, r, n = um.isMemo(e) ? e.type.type : e.type;
  return !(typeof n == "function" && !((t = n.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((r = e.prototype) !== null && r !== void 0 && r.render));
}
var Xc = /* @__PURE__ */ p.createContext(null);
function Ly(e) {
  var t = e.children, r = e.onBatchResize, n = p.useRef(0), o = p.useRef([]), a = p.useContext(Xc), s = p.useCallback(function(c, l, d) {
    n.current += 1;
    var u = n.current;
    o.current.push({
      size: c,
      element: l,
      data: d
    }), Promise.resolve().then(function() {
      u === n.current && (r?.(o.current), o.current = []);
    }), a?.(c, l, d);
  }, [r, a]);
  return /* @__PURE__ */ p.createElement(Xc.Provider, {
    value: s
  }, t);
}
var fm = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(o, a) {
      return o[0] === r ? (n = a, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var n = e(this.__entries__, r), o = this.__entries__[n];
        return o && o[1];
      }, t.prototype.set = function(r, n) {
        var o = e(this.__entries__, r);
        ~o ? this.__entries__[o][1] = n : this.__entries__.push([r, n]);
      }, t.prototype.delete = function(r) {
        var n = this.__entries__, o = e(n, r);
        ~o && n.splice(o, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var o = 0, a = this.__entries__; o < a.length; o++) {
          var s = a[o];
          r.call(n, s[1], s[0]);
        }
      }, t;
    }()
  );
}(), Zc = typeof window < "u" && typeof document < "u" && window.document === document, Ji = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Vy = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Ji) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), zy = 2;
function By(e, t) {
  var r = !1, n = !1, o = 0;
  function a() {
    r && (r = !1, e()), n && c();
  }
  function s() {
    Vy(a);
  }
  function c() {
    var l = Date.now();
    if (r) {
      if (l - o < zy)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(s, t);
    o = l;
  }
  return c;
}
var ky = 20, Uy = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], qy = typeof MutationObserver < "u", Hy = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = By(this.refresh.bind(this), ky);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, n = r.indexOf(t);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Zc || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), qy ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Zc || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, n = r === void 0 ? "" : r, o = Uy.some(function(a) {
        return !!~n.indexOf(a);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), mm = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var o = n[r];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, ko = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Ji;
}, pm = hs(0, 0, 0, 0);
function es(e) {
  return parseFloat(e) || 0;
}
function Kd(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, o) {
    var a = e["border-" + o + "-width"];
    return n + es(a);
  }, 0);
}
function Wy(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, o = t; n < o.length; n++) {
    var a = o[n], s = e["padding-" + a];
    r[a] = es(s);
  }
  return r;
}
function Gy(e) {
  var t = e.getBBox();
  return hs(0, 0, t.width, t.height);
}
function Ky(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return pm;
  var n = ko(e).getComputedStyle(e), o = Wy(n), a = o.left + o.right, s = o.top + o.bottom, c = es(n.width), l = es(n.height);
  if (n.boxSizing === "border-box" && (Math.round(c + a) !== t && (c -= Kd(n, "left", "right") + a), Math.round(l + s) !== r && (l -= Kd(n, "top", "bottom") + s)), !Qy(e)) {
    var d = Math.round(c + a) - t, u = Math.round(l + s) - r;
    Math.abs(d) !== 1 && (c -= d), Math.abs(u) !== 1 && (l -= u);
  }
  return hs(o.left, o.top, c, l);
}
var Yy = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof ko(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof ko(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function Qy(e) {
  return e === ko(e).document.documentElement;
}
function Xy(e) {
  return Zc ? Yy(e) ? Gy(e) : Ky(e) : pm;
}
function Zy(e) {
  var t = e.x, r = e.y, n = e.width, o = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(a.prototype);
  return mm(s, {
    x: t,
    y: r,
    width: n,
    height: o,
    top: r,
    right: t + n,
    bottom: o + r,
    left: t
  }), s;
}
function hs(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var Jy = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = hs(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Xy(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), e0 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r) {
      var n = Zy(r);
      mm(this, { target: t, contentRect: n });
    }
    return e;
  }()
), t0 = (
  /** @class */
  function() {
    function e(t, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new fm(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ko(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new Jy(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof ko(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new e0(n.target, n.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), hm = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new fm(), gm = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = Hy.getInstance(), n = new t0(t, r, this);
      hm.set(this, n);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  gm.prototype[e] = function() {
    var t;
    return (t = hm.get(this))[e].apply(t, arguments);
  };
});
var r0 = function() {
  return typeof Ji.ResizeObserver < "u" ? Ji.ResizeObserver : gm;
}(), vn = /* @__PURE__ */ new Map();
function vm(e) {
  e.forEach(function(t) {
    var r, n = t.target;
    (r = vn.get(n)) === null || r === void 0 || r.forEach(function(o) {
      return o(n);
    });
  });
}
var ym = new r0(vm);
process.env.NODE_ENV;
process.env.NODE_ENV;
function n0(e, t) {
  vn.has(e) || (vn.set(e, /* @__PURE__ */ new Set()), ym.observe(e)), vn.get(e).add(t);
}
function o0(e, t) {
  vn.has(e) && (vn.get(e).delete(t), vn.get(e).size || (ym.unobserve(e), vn.delete(e)));
}
function lr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yd(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kf(n.key), n);
  }
}
function dr(e, t, r) {
  return t && Yd(e.prototype, t), r && Yd(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Jc(e, t) {
  return Jc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Jc(e, t);
}
function zn(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Jc(e, t);
}
function jn(e) {
  return jn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, jn(e);
}
function gs() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gs = function() {
    return !!e;
  })();
}
function Ze(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wl(e, t) {
  if (t && (it(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ze(e);
}
function ea(e) {
  var t = gs();
  return function() {
    var n = jn(e), o;
    if (t) {
      var a = jn(this).constructor;
      o = Reflect.construct(n, arguments, a);
    } else
      o = n.apply(this, arguments);
    return Wl(this, o);
  };
}
var a0 = /* @__PURE__ */ function(e) {
  zn(r, e);
  var t = ea(r);
  function r() {
    return lr(this, r), t.apply(this, arguments);
  }
  return dr(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(p.Component);
function i0(e, t) {
  var r = e.children, n = e.disabled, o = p.useRef(null), a = p.useRef(null), s = p.useContext(Xc), c = typeof r == "function", l = c ? r(o) : r, d = p.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !c && /* @__PURE__ */ p.isValidElement(l) && Jo(l), f = u ? l.ref : null, h = Hl(f, o), g = function() {
    var y;
    return Vi(o.current) || // Support `nativeElement` format
    (o.current && it(o.current) === "object" ? Vi((y = o.current) === null || y === void 0 ? void 0 : y.nativeElement) : null) || Vi(a.current);
  };
  p.useImperativeHandle(t, function() {
    return g();
  });
  var E = p.useRef(e);
  E.current = e;
  var v = p.useCallback(function(m) {
    var y = E.current, I = y.onResize, b = y.data, C = m.getBoundingClientRect(), S = C.width, T = C.height, N = m.offsetWidth, V = m.offsetHeight, D = Math.floor(S), x = Math.floor(T);
    if (d.current.width !== D || d.current.height !== x || d.current.offsetWidth !== N || d.current.offsetHeight !== V) {
      var O = {
        width: D,
        height: x,
        offsetWidth: N,
        offsetHeight: V
      };
      d.current = O;
      var w = N === Math.round(S) ? S : N, j = V === Math.round(T) ? T : V, $ = ae(ae({}, O), {}, {
        offsetWidth: w,
        offsetHeight: j
      });
      s?.($, m, b), I && Promise.resolve().then(function() {
        I($, m);
      });
    }
  }, []);
  return p.useEffect(function() {
    var m = g();
    return m && !n && n0(m, v), function() {
      return o0(m, v);
    };
  }, [o.current, n]), /* @__PURE__ */ p.createElement(a0, {
    ref: a
  }, u ? /* @__PURE__ */ p.cloneElement(l, {
    ref: h
  }) : l);
}
var bm = /* @__PURE__ */ p.forwardRef(i0);
process.env.NODE_ENV !== "production" && (bm.displayName = "SingleObserver");
var s0 = "rc-observer-key";
function c0(e, t) {
  var r = e.children, n = typeof r == "function" ? [r] : lo(r);
  return process.env.NODE_ENV !== "production" && (n.length > 1 ? Bo(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : n.length === 0 && Bo(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), n.map(function(o, a) {
    var s = o?.key || "".concat(s0, "-").concat(a);
    return /* @__PURE__ */ p.createElement(bm, mt({}, e, {
      key: s,
      ref: a === 0 ? t : void 0
    }), o);
  });
}
var ta = /* @__PURE__ */ p.forwardRef(c0);
process.env.NODE_ENV !== "production" && (ta.displayName = "ResizeObserver");
ta.Collection = Ly;
var Cm = function(t) {
  return +setTimeout(t, 16);
}, Im = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (Cm = function(t) {
  return window.requestAnimationFrame(t);
}, Im = function(t) {
  return window.cancelAnimationFrame(t);
});
var Qd = 0, vs = /* @__PURE__ */ new Map();
function xm(e) {
  vs.delete(e);
}
var Gl = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Qd += 1;
  var n = Qd;
  function o(a) {
    if (a === 0)
      xm(n), t();
    else {
      var s = Cm(function() {
        o(a - 1);
      });
      vs.set(n, s);
    }
  }
  return o(r), n;
};
Gl.cancel = function(e) {
  var t = vs.get(e);
  return xm(e), Im(t);
};
process.env.NODE_ENV !== "production" && (Gl.ids = function() {
  return vs;
});
const Nr = Gl;
var l0 = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, d0 = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], ic = {}, wr;
function u0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && ic[r])
    return ic[r];
  var n = window.getComputedStyle(e), o = n.getPropertyValue("box-sizing") || n.getPropertyValue("-moz-box-sizing") || n.getPropertyValue("-webkit-box-sizing"), a = parseFloat(n.getPropertyValue("padding-bottom")) + parseFloat(n.getPropertyValue("padding-top")), s = parseFloat(n.getPropertyValue("border-bottom-width")) + parseFloat(n.getPropertyValue("border-top-width")), c = d0.map(function(d) {
    return "".concat(d, ":").concat(n.getPropertyValue(d));
  }).join(";"), l = {
    sizingStyle: c,
    paddingSize: a,
    borderSize: s,
    boxSizing: o
  };
  return t && r && (ic[r] = l), l;
}
function f0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  wr || (wr = document.createElement("textarea"), wr.setAttribute("tab-index", "-1"), wr.setAttribute("aria-hidden", "true"), document.body.appendChild(wr)), e.getAttribute("wrap") ? wr.setAttribute("wrap", e.getAttribute("wrap")) : wr.removeAttribute("wrap");
  var o = u0(e, t), a = o.paddingSize, s = o.borderSize, c = o.boxSizing, l = o.sizingStyle;
  wr.setAttribute("style", "".concat(l, ";").concat(l0)), wr.value = e.value || e.placeholder || "";
  var d = void 0, u = void 0, f, h = wr.scrollHeight;
  if (c === "border-box" ? h += s : c === "content-box" && (h -= a), r !== null || n !== null) {
    wr.value = " ";
    var g = wr.scrollHeight - a;
    r !== null && (d = g * r, c === "border-box" && (d = d + a + s), h = Math.max(d, h)), n !== null && (u = g * n, c === "border-box" && (u = u + a + s), f = h > u ? "" : "hidden", h = Math.min(u, h));
  }
  var E = {
    height: h,
    overflowY: f,
    resize: "none"
  };
  return d && (E.minHeight = d), u && (E.maxHeight = u), E;
}
var m0 = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], sc = 0, cc = 1, lc = 2, p0 = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e, n = r.prefixCls;
  r.onPressEnter;
  var o = r.defaultValue, a = r.value, s = r.autoSize, c = r.onResize, l = r.className, d = r.style, u = r.disabled, f = r.onChange, h = r.onInternalAutoSize, g = cr(r, m0), E = Ka(o, {
    value: a,
    postState: function(ee) {
      return ee ?? "";
    }
  }), v = Se(E, 2), m = v[0], y = v[1], I = function(ee) {
    y(ee.target.value), f?.(ee);
  }, b = p.useRef();
  p.useImperativeHandle(t, function() {
    return {
      textArea: b.current
    };
  });
  var C = p.useMemo(function() {
    return s && it(s) === "object" ? [s.minRows, s.maxRows] : [];
  }, [s]), S = Se(C, 2), T = S[0], N = S[1], V = !!s, D = function() {
    try {
      if (document.activeElement === b.current) {
        var ee = b.current, te = ee.selectionStart, de = ee.selectionEnd, Z = ee.scrollTop;
        b.current.setSelectionRange(te, de), b.current.scrollTop = Z;
      }
    } catch {
    }
  }, x = p.useState(lc), O = Se(x, 2), w = O[0], j = O[1], $ = p.useState(), _ = Se($, 2), A = _[0], R = _[1], P = function() {
    j(sc), process.env.NODE_ENV === "test" && h?.();
  };
  jt(function() {
    V && P();
  }, [a, T, N, V]), jt(function() {
    if (w === sc)
      j(cc);
    else if (w === cc) {
      var W = f0(b.current, !1, T, N);
      j(lc), R(W);
    } else
      D();
  }, [w]);
  var z = p.useRef(), F = function() {
    Nr.cancel(z.current);
  }, L = function(ee) {
    w === lc && (c?.(ee), s && (F(), z.current = Nr(function() {
      P();
    })));
  };
  p.useEffect(function() {
    return F;
  }, []);
  var M = V ? A : null, B = ae(ae({}, d), M);
  return (w === sc || w === cc) && (B.overflowY = "hidden", B.overflowX = "hidden"), /* @__PURE__ */ p.createElement(ta, {
    onResize: L,
    disabled: !(s || c)
  }, /* @__PURE__ */ p.createElement("textarea", mt({}, g, {
    ref: b,
    style: B,
    className: we(n, l, Q({}, "".concat(n, "-disabled"), u)),
    disabled: u,
    value: m,
    onChange: I
  })));
}), h0 = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"], g0 = /* @__PURE__ */ k.forwardRef(function(e, t) {
  var r, n, o = e.defaultValue, a = e.value, s = e.onFocus, c = e.onBlur, l = e.onChange, d = e.allowClear, u = e.maxLength, f = e.onCompositionStart, h = e.onCompositionEnd, g = e.suffix, E = e.prefixCls, v = E === void 0 ? "rc-textarea" : E, m = e.showCount, y = e.count, I = e.className, b = e.style, C = e.disabled, S = e.hidden, T = e.classNames, N = e.styles, V = e.onResize, D = cr(e, h0), x = Ka(o, {
    value: a,
    defaultValue: o
  }), O = Se(x, 2), w = O[0], j = O[1], $ = w == null ? "" : String(w), _ = k.useState(!1), A = Se(_, 2), R = A[0], P = A[1], z = k.useRef(!1), F = k.useState(null), L = Se(F, 2), M = L[0], B = L[1], W = Wt(null), ee = function() {
    var Ge;
    return (Ge = W.current) === null || Ge === void 0 ? void 0 : Ge.textArea;
  }, te = function() {
    ee().focus();
  };
  Af(t, function() {
    return {
      resizableTextArea: W.current,
      focus: te,
      blur: function() {
        ee().blur();
      }
    };
  }), xr(function() {
    P(function(pt) {
      return !C && pt;
    });
  }, [C]);
  var de = k.useState(null), Z = Se(de, 2), ce = Z[0], Y = Z[1];
  k.useEffect(function() {
    if (ce) {
      var pt;
      (pt = ee()).setSelectionRange.apply(pt, Ne(ce));
    }
  }, [ce]);
  var he = Ay(y, m), ve = (r = he.max) !== null && r !== void 0 ? r : u, ue = Number(ve) > 0, le = he.strategy($), Fe = !!ve && le > ve, He = function(Ge, dt) {
    var q = dt;
    !z.current && he.exceedFormatter && he.max && he.strategy(dt) > he.max && (q = he.exceedFormatter(dt, {
      max: he.max
    }), dt !== q && Y([ee().selectionStart || 0, ee().selectionEnd || 0])), j(q), Ud(Ge.currentTarget, Ge, l, q);
  }, We = function(Ge) {
    z.current = !0, f?.(Ge);
  }, ie = function(Ge) {
    z.current = !1, He(Ge, Ge.currentTarget.value), h?.(Ge);
  }, ge = function(Ge) {
    He(Ge, Ge.target.value);
  }, be = function(Ge) {
    var dt = D.onPressEnter, q = D.onKeyDown;
    Ge.key === "Enter" && dt && dt(Ge), q?.(Ge);
  }, Ie = function(Ge) {
    P(!0), s?.(Ge);
  }, Pe = function(Ge) {
    P(!1), c?.(Ge);
  }, Le = function(Ge) {
    j(""), te(), Ud(ee(), Ge, l);
  }, Ve = g, _e;
  he.show && (he.showFormatter ? _e = he.showFormatter({
    value: $,
    count: le,
    maxLength: ve
  }) : _e = "".concat(le).concat(ue ? " / ".concat(ve) : ""), Ve = /* @__PURE__ */ k.createElement(k.Fragment, null, Ve, /* @__PURE__ */ k.createElement("span", {
    className: we("".concat(v, "-data-count"), T?.count),
    style: N?.count
  }, _e)));
  var ut = function(Ge) {
    var dt;
    V?.(Ge), (dt = ee()) !== null && dt !== void 0 && dt.style.height && B(!0);
  }, Nt = !D.autoSize && !m && !d;
  return /* @__PURE__ */ k.createElement(jy, {
    value: $,
    allowClear: d,
    handleReset: Le,
    suffix: Ve,
    prefixCls: v,
    classNames: ae(ae({}, T), {}, {
      affixWrapper: we(T?.affixWrapper, (n = {}, Q(n, "".concat(v, "-show-count"), m), Q(n, "".concat(v, "-textarea-allow-clear"), d), n))
    }),
    disabled: C,
    focused: R,
    className: we(I, Fe && "".concat(v, "-out-of-range")),
    style: ae(ae({}, b), M && !Nt ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof _e == "string" ? _e : void 0
      }
    },
    hidden: S
  }, /* @__PURE__ */ k.createElement(p0, mt({}, D, {
    maxLength: u,
    onKeyDown: be,
    onChange: ge,
    onFocus: Ie,
    onBlur: Pe,
    onCompositionStart: We,
    onCompositionEnd: ie,
    className: we(T?.textarea),
    style: ae(ae({}, N?.textarea), {}, {
      resize: b?.resize
    }),
    disabled: C,
    prefixCls: v,
    onResize: ut,
    ref: W
  })));
});
function v0(e, t, r) {
  return we({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: r
  });
}
const y0 = (e, t) => t || e;
function ts(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Sm(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function o(a, s) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = n.has(a);
    if (Tt(!l, "Warning: There may be circular references"), l)
      return !1;
    if (a === s)
      return !0;
    if (r && c > 1)
      return !1;
    n.add(a);
    var d = c + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(s) || a.length !== s.length)
        return !1;
      for (var u = 0; u < a.length; u++)
        if (!o(a[u], s[u], d))
          return !1;
      return !0;
    }
    if (a && s && it(a) === "object" && it(s) === "object") {
      var f = Object.keys(a);
      return f.length !== Object.keys(s).length ? !1 : f.every(function(h) {
        return o(a[h], s[h], d);
      });
    }
    return !1;
  }
  return o(e, t);
}
var b0 = "%";
function el(e) {
  return e.join(b0);
}
var C0 = /* @__PURE__ */ function() {
  function e(t) {
    lr(this, e), Q(this, "instanceId", void 0), Q(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return dr(e, [{
    key: "get",
    value: function(r) {
      return this.opGet(el(r));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(r) {
      return this.cache.get(r) || null;
    }
  }, {
    key: "update",
    value: function(r, n) {
      return this.opUpdate(el(r), n);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(r, n) {
      var o = this.cache.get(r), a = n(o);
      a === null ? this.cache.delete(r) : this.cache.set(r, a);
    }
  }]), e;
}(), Uo = "data-token-hash", _r = "data-css-hash", I0 = "data-cache-path", Fn = "__cssinjs_instance__";
function x0() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(_r, "]")) || [], r = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[Fn] = o[Fn] || e, o[Fn] === e && document.head.insertBefore(o, r);
    });
    var n = {};
    Array.from(document.querySelectorAll("style[".concat(_r, "]"))).forEach(function(o) {
      var a = o.getAttribute(_r);
      if (n[a]) {
        if (o[Fn] === e) {
          var s;
          (s = o.parentNode) === null || s === void 0 || s.removeChild(o);
        }
      } else
        n[a] = !0;
    });
  }
  return new C0(e);
}
var ys = /* @__PURE__ */ p.createContext({
  hashPriority: "low",
  cache: x0(),
  defaultCache: !0
});
function S0(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var Kl = /* @__PURE__ */ function() {
  function e() {
    lr(this, e), Q(this, "cache", void 0), Q(this, "keys", void 0), Q(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return dr(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(r) {
      var n, o, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = {
        map: this.cache
      };
      return r.forEach(function(c) {
        if (!s)
          s = void 0;
        else {
          var l;
          s = (l = s) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(c);
        }
      }), (n = s) !== null && n !== void 0 && n.value && a && (s.value[1] = this.cacheCallTimes++), (o = s) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(r) {
      var n;
      return (n = this.internalGet(r, !0)) === null || n === void 0 ? void 0 : n[0];
    }
  }, {
    key: "has",
    value: function(r) {
      return !!this.internalGet(r);
    }
  }, {
    key: "set",
    value: function(r, n) {
      var o = this;
      if (!this.has(r)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var a = this.keys.reduce(function(d, u) {
            var f = Se(d, 2), h = f[1];
            return o.internalGet(u)[1] < h ? [u, o.internalGet(u)[1]] : d;
          }, [this.keys[0], this.cacheCallTimes]), s = Se(a, 1), c = s[0];
          this.delete(c);
        }
        this.keys.push(r);
      }
      var l = this.cache;
      r.forEach(function(d, u) {
        if (u === r.length - 1)
          l.set(d, {
            value: [n, o.cacheCallTimes++]
          });
        else {
          var f = l.get(d);
          f ? f.map || (f.map = /* @__PURE__ */ new Map()) : l.set(d, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(d).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(r, n) {
      var o = r.get(n[0]);
      if (n.length === 1) {
        var a;
        return o.map ? r.set(n[0], {
          map: o.map
        }) : r.delete(n[0]), (a = o.value) === null || a === void 0 ? void 0 : a[0];
      }
      var s = this.deleteByPath(o.map, n.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && r.delete(n[0]), s;
    }
  }, {
    key: "delete",
    value: function(r) {
      if (this.has(r))
        return this.keys = this.keys.filter(function(n) {
          return !S0(n, r);
        }), this.deleteByPath(this.cache, r);
    }
  }]), e;
}();
Q(Kl, "MAX_CACHE_SIZE", 20);
Q(Kl, "MAX_CACHE_OFFSET", 5);
var Xd = 0, Em = /* @__PURE__ */ function() {
  function e(t) {
    lr(this, e), Q(this, "derivatives", void 0), Q(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = Xd, t.length === 0 && Bo(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), Xd += 1;
  }
  return dr(e, [{
    key: "getDerivativeToken",
    value: function(r) {
      return this.derivatives.reduce(function(n, o) {
        return o(r, n);
      }, void 0);
    }
  }]), e;
}(), dc = new Kl();
function tl(e) {
  var t = Array.isArray(e) ? e : [e];
  return dc.has(t) || dc.set(t, new Em(t)), dc.get(t);
}
var E0 = /* @__PURE__ */ new WeakMap(), uc = {};
function D0(e, t) {
  for (var r = E0, n = 0; n < t.length; n += 1) {
    var o = t[n];
    r.has(o) || r.set(o, /* @__PURE__ */ new WeakMap()), r = r.get(o);
  }
  return r.has(uc) || r.set(uc, e()), r.get(uc);
}
var Zd = /* @__PURE__ */ new WeakMap();
function Oa(e) {
  var t = Zd.get(e) || "";
  return t || (Object.keys(e).forEach(function(r) {
    var n = e[r];
    t += r, n instanceof Em ? t += n.id : n && it(n) === "object" ? t += Oa(n) : t += n;
  }), Zd.set(e, t)), t;
}
function Jd(e, t) {
  return ts("".concat(t, "_").concat(Oa(e)));
}
var Na = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), Dm = "_bAmBoO_";
function w0(e, t, r) {
  if (Zt()) {
    var n, o;
    Pn(e, Na);
    var a = document.createElement("div");
    a.style.position = "fixed", a.style.left = "0", a.style.top = "0", t?.(a), document.body.appendChild(a), process.env.NODE_ENV !== "production" && (a.innerHTML = "Test", a.style.zIndex = "9999999");
    var s = r ? r(a) : (n = getComputedStyle(a).content) === null || n === void 0 ? void 0 : n.includes(Dm);
    return (o = a.parentNode) === null || o === void 0 || o.removeChild(a), Aa(Na), s;
  }
  return !1;
}
var fc = void 0;
function T0() {
  return fc === void 0 && (fc = w0("@layer ".concat(Na, " { .").concat(Na, ' { content: "').concat(Dm, '"!important; } }'), function(e) {
    e.className = Na;
  })), fc;
}
var rl = Zt();
function Me(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function rs(e, t, r) {
  var n, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (a)
    return e;
  var s = ae(ae({}, o), {}, (n = {}, Q(n, Uo, t), Q(n, _r, r), n)), c = Object.keys(s).map(function(l) {
    var d = s[l];
    return d ? "".concat(l, '="').concat(d, '"') : null;
  }).filter(function(l) {
    return l;
  }).join(" ");
  return "<style ".concat(c, ">").concat(e, "</style>");
}
var wm = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(r ? "".concat(r, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, F0 = function(t, r, n) {
  return Object.keys(t).length ? ".".concat(r).concat(n != null && n.scope ? ".".concat(n.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var a = Se(o, 2), s = a[0], c = a[1];
    return "".concat(s, ":").concat(c, ";");
  }).join(""), "}") : "";
}, Tm = function(t, r, n) {
  var o = {}, a = {};
  return Object.entries(t).forEach(function(s) {
    var c, l, d = Se(s, 2), u = d[0], f = d[1];
    if (n != null && (c = n.preserve) !== null && c !== void 0 && c[u])
      a[u] = f;
    else if ((typeof f == "string" || typeof f == "number") && !(n != null && (l = n.ignore) !== null && l !== void 0 && l[u])) {
      var h, g = wm(u, n?.prefix);
      o[g] = typeof f == "number" && !(n != null && (h = n.unitless) !== null && h !== void 0 && h[u]) ? "".concat(f, "px") : String(f), a[u] = "var(".concat(g, ")");
    }
  }), [a, F0(o, r, {
    scope: n?.scope
  })];
}, O0 = ae({}, p), eu = O0.useInsertionEffect, N0 = function(t, r, n) {
  p.useMemo(t, n), jt(function() {
    return r(!0);
  }, n);
}, R0 = eu ? function(e, t, r) {
  return eu(function() {
    return e(), t();
  }, r);
} : N0, P0 = ae({}, p), j0 = P0.useInsertionEffect, $0 = function(t) {
  var r = [], n = !1;
  function o(a) {
    if (n) {
      process.env.NODE_ENV !== "production" && Bo(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    r.push(a);
  }
  return p.useEffect(function() {
    return n = !1, function() {
      n = !0, r.length && r.forEach(function(a) {
        return a();
      });
    };
  }, t), o;
}, A0 = function() {
  return function(t) {
    t();
  };
}, _0 = typeof j0 < "u" ? $0 : A0;
function M0() {
  return !1;
}
var nl = !1;
function L0() {
  return nl;
}
const V0 = process.env.NODE_ENV === "production" ? M0 : L0;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var mc = window;
  if (typeof mc.webpackHotUpdate == "function") {
    var z0 = mc.webpackHotUpdate;
    mc.webpackHotUpdate = function() {
      return nl = !0, setTimeout(function() {
        nl = !1;
      }, 0), z0.apply(void 0, arguments);
    };
  }
}
function Yl(e, t, r, n, o) {
  var a = p.useContext(ys), s = a.cache, c = [e].concat(Ne(t)), l = el(c), d = _0([l]), u = V0(), f = function(v) {
    s.opUpdate(l, function(m) {
      var y = m || [void 0, void 0], I = Se(y, 2), b = I[0], C = b === void 0 ? 0 : b, S = I[1], T = S;
      process.env.NODE_ENV !== "production" && S && u && (n?.(T, u), T = null);
      var N = T || r(), V = [C, N];
      return v ? v(V) : V;
    });
  };
  p.useMemo(
    function() {
      f();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var h = s.opGet(l);
  process.env.NODE_ENV !== "production" && !h && (f(), h = s.opGet(l));
  var g = h[1];
  return R0(function() {
    o?.(g);
  }, function(E) {
    return f(function(v) {
      var m = Se(v, 2), y = m[0], I = m[1];
      return E && y === 0 && o?.(g), [y + 1, I];
    }), function() {
      s.opUpdate(l, function(v) {
        var m = v || [], y = Se(m, 2), I = y[0], b = I === void 0 ? 0 : I, C = y[1], S = b - 1;
        return S === 0 ? (d(function() {
          (E || !s.opGet(l)) && n?.(C, !1);
        }), null) : [b - 1, C];
      });
    };
  }, [l]), g;
}
var B0 = {}, k0 = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", eo = /* @__PURE__ */ new Map();
function U0(e) {
  eo.set(e, (eo.get(e) || 0) + 1);
}
function q0(e, t) {
  if (typeof document < "u") {
    var r = document.querySelectorAll("style[".concat(Uo, '="').concat(e, '"]'));
    r.forEach(function(n) {
      if (n[Fn] === t) {
        var o;
        (o = n.parentNode) === null || o === void 0 || o.removeChild(n);
      }
    });
  }
}
var H0 = 0;
function W0(e, t) {
  eo.set(e, (eo.get(e) || 0) - 1);
  var r = Array.from(eo.keys()), n = r.filter(function(o) {
    var a = eo.get(o) || 0;
    return a <= 0;
  });
  r.length - n.length > H0 && n.forEach(function(o) {
    q0(o, t), eo.delete(o);
  });
}
var G0 = function(t, r, n, o) {
  var a = n.getDerivativeToken(t), s = ae(ae({}, a), r);
  return o && (s = o(s)), s;
}, Fm = "token";
function K0(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = Ir(ys), o = n.cache.instanceId, a = n.container, s = r.salt, c = s === void 0 ? "" : s, l = r.override, d = l === void 0 ? B0 : l, u = r.formatToken, f = r.getComputedToken, h = r.cssVar, g = D0(function() {
    return Object.assign.apply(Object, [{}].concat(Ne(t)));
  }, t), E = Oa(g), v = Oa(d), m = h ? Oa(h) : "", y = Yl(Fm, [c, e.id, E, v, m], function() {
    var I, b = f ? f(g, d, e) : G0(g, d, e, u), C = ae({}, b), S = "";
    if (h) {
      var T = Tm(b, h.key, {
        prefix: h.prefix,
        ignore: h.ignore,
        unitless: h.unitless,
        preserve: h.preserve
      }), N = Se(T, 2);
      b = N[0], S = N[1];
    }
    var V = Jd(b, c);
    b._tokenKey = V, C._tokenKey = Jd(C, c);
    var D = (I = h?.key) !== null && I !== void 0 ? I : V;
    b._themeKey = D, U0(D);
    var x = "".concat(k0, "-").concat(ts(V));
    return b._hashId = x, [b, x, C, S, h?.key || ""];
  }, function(I) {
    W0(I[0]._themeKey, o);
  }, function(I) {
    var b = Se(I, 4), C = b[0], S = b[3];
    if (h && S) {
      var T = Pn(S, ts("css-variables-".concat(C._themeKey)), {
        mark: _r,
        prepend: "queue",
        attachTo: a,
        priority: -999
      });
      T[Fn] = o, T.setAttribute(Uo, C._themeKey);
    }
  });
  return y;
}
var Y0 = function(t, r, n) {
  var o = Se(t, 5), a = o[2], s = o[3], c = o[4], l = n || {}, d = l.plain;
  if (!s)
    return null;
  var u = a._tokenKey, f = -999, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  }, g = rs(s, c, u, h, d);
  return [f, u, g];
}, Q0 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Om = "comm", Nm = "rule", Rm = "decl", X0 = "@import", Z0 = "@keyframes", J0 = "@layer", Pm = Math.abs, Ql = String.fromCharCode;
function jm(e) {
  return e.trim();
}
function zi(e, t, r) {
  return e.replace(t, r);
}
function eb(e, t, r) {
  return e.indexOf(t, r);
}
function _a(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ma(e, t, r) {
  return e.slice(t, r);
}
function hn(e) {
  return e.length;
}
function tb(e) {
  return e.length;
}
function Si(e, t) {
  return t.push(e), e;
}
var bs = 1, qo = 1, $m = 0, Rr = 0, zt = 0, ra = "";
function Xl(e, t, r, n, o, a, s, c) {
  return { value: e, root: t, parent: r, type: n, props: o, children: a, line: bs, column: qo, length: s, return: "", siblings: c };
}
function rb() {
  return zt;
}
function nb() {
  return zt = Rr > 0 ? _a(ra, --Rr) : 0, qo--, zt === 10 && (qo = 1, bs--), zt;
}
function Mr() {
  return zt = Rr < $m ? _a(ra, Rr++) : 0, qo++, zt === 10 && (qo = 1, bs++), zt;
}
function io() {
  return _a(ra, Rr);
}
function Bi() {
  return Rr;
}
function Cs(e, t) {
  return Ma(ra, e, t);
}
function ol(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ob(e) {
  return bs = qo = 1, $m = hn(ra = e), Rr = 0, [];
}
function ab(e) {
  return ra = "", e;
}
function pc(e) {
  return jm(Cs(Rr - 1, al(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ib(e) {
  for (; (zt = io()) && zt < 33; )
    Mr();
  return ol(e) > 2 || ol(zt) > 3 ? "" : " ";
}
function sb(e, t) {
  for (; --t && Mr() && !(zt < 48 || zt > 102 || zt > 57 && zt < 65 || zt > 70 && zt < 97); )
    ;
  return Cs(e, Bi() + (t < 6 && io() == 32 && Mr() == 32));
}
function al(e) {
  for (; Mr(); )
    switch (zt) {
      case e:
        return Rr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && al(zt);
        break;
      case 40:
        e === 41 && al(e);
        break;
      case 92:
        Mr();
        break;
    }
  return Rr;
}
function cb(e, t) {
  for (; Mr() && e + zt !== 57; )
    if (e + zt === 84 && io() === 47)
      break;
  return "/*" + Cs(t, Rr - 1) + "*" + Ql(e === 47 ? e : Mr());
}
function lb(e) {
  for (; !ol(io()); )
    Mr();
  return Cs(e, Rr);
}
function db(e) {
  return ab(ki("", null, null, null, [""], e = ob(e), 0, [0], e));
}
function ki(e, t, r, n, o, a, s, c, l) {
  for (var d = 0, u = 0, f = s, h = 0, g = 0, E = 0, v = 1, m = 1, y = 1, I = 0, b = "", C = o, S = a, T = n, N = b; m; )
    switch (E = I, I = Mr()) {
      case 40:
        if (E != 108 && _a(N, f - 1) == 58) {
          eb(N += zi(pc(I), "&", "&\f"), "&\f", Pm(d ? c[d - 1] : 0)) != -1 && (y = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        N += pc(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        N += ib(E);
        break;
      case 92:
        N += sb(Bi() - 1, 7);
        continue;
      case 47:
        switch (io()) {
          case 42:
          case 47:
            Si(ub(cb(Mr(), Bi()), t, r, l), l);
            break;
          default:
            N += "/";
        }
        break;
      case 123 * v:
        c[d++] = hn(N) * y;
      case 125 * v:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            m = 0;
          case 59 + u:
            y == -1 && (N = zi(N, /\f/g, "")), g > 0 && hn(N) - f && Si(g > 32 ? ru(N + ";", n, r, f - 1, l) : ru(zi(N, " ", "") + ";", n, r, f - 2, l), l);
            break;
          case 59:
            N += ";";
          default:
            if (Si(T = tu(N, t, r, d, u, o, c, b, C = [], S = [], f, a), a), I === 123)
              if (u === 0)
                ki(N, t, T, T, C, a, f, c, S);
              else
                switch (h === 99 && _a(N, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ki(e, T, T, n && Si(tu(e, T, T, 0, 0, o, c, b, o, C = [], f, S), S), o, S, f, c, n ? C : S);
                    break;
                  default:
                    ki(N, T, T, T, [""], S, 0, c, S);
                }
        }
        d = u = g = 0, v = y = 1, b = N = "", f = s;
        break;
      case 58:
        f = 1 + hn(N), g = E;
      default:
        if (v < 1) {
          if (I == 123)
            --v;
          else if (I == 125 && v++ == 0 && nb() == 125)
            continue;
        }
        switch (N += Ql(I), I * v) {
          case 38:
            y = u > 0 ? 1 : (N += "\f", -1);
            break;
          case 44:
            c[d++] = (hn(N) - 1) * y, y = 1;
            break;
          case 64:
            io() === 45 && (N += pc(Mr())), h = io(), u = f = hn(b = N += lb(Bi())), I++;
            break;
          case 45:
            E === 45 && hn(N) == 2 && (v = 0);
        }
    }
  return a;
}
function tu(e, t, r, n, o, a, s, c, l, d, u, f) {
  for (var h = o - 1, g = o === 0 ? a : [""], E = tb(g), v = 0, m = 0, y = 0; v < n; ++v)
    for (var I = 0, b = Ma(e, h + 1, h = Pm(m = s[v])), C = e; I < E; ++I)
      (C = jm(m > 0 ? g[I] + " " + b : zi(b, /&\f/g, g[I]))) && (l[y++] = C);
  return Xl(e, t, r, o === 0 ? Nm : c, l, d, u, f);
}
function ub(e, t, r, n) {
  return Xl(e, t, r, Om, Ql(rb()), Ma(e, 2, -2), 0, n);
}
function ru(e, t, r, n, o) {
  return Xl(e, t, r, Rm, Ma(e, 0, n), Ma(e, n + 1, -1), n, o);
}
function il(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function fb(e, t, r, n) {
  switch (e.type) {
    case J0:
      if (e.children.length)
        break;
    case X0:
    case Rm:
      return e.return = e.return || e.value;
    case Om:
      return "";
    case Z0:
      return e.return = e.value + "{" + il(e.children, n) + "}";
    case Nm:
      if (!hn(e.value = e.props.join(",")))
        return "";
  }
  return hn(r = il(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function Am(e, t) {
  var r = t.path, n = t.parentSelectors;
  Tt(!1, "[Ant Design CSS-in-JS] ".concat(r ? "Error in ".concat(r, ": ") : "").concat(e).concat(n.length ? " Selector: ".concat(n.join(" | ")) : ""));
}
var mb = function(t, r, n) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, a = ["normal", "none", "initial", "inherit", "unset"];
    (typeof r != "string" || a.indexOf(r) === -1 && !o.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")) && Am("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(r, "\"'`."), n);
  }
}, pb = function(t, r, n) {
  t === "animation" && n.hashId && r !== "none" && Am("You seem to be using hashed animation '".concat(r, "', in which case 'animationName' with Keyframe as value is recommended."), n);
}, nu = "data-ant-cssinjs-cache-path", _m = "_FILE_STYLE__", so, Mm = !0;
function hb() {
  if (!so && (so = {}, Zt())) {
    var e = document.createElement("div");
    e.className = nu, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var a = o.split(":"), s = Se(a, 2), c = s[0], l = s[1];
      so[c] = l;
    });
    var r = document.querySelector("style[".concat(nu, "]"));
    if (r) {
      var n;
      Mm = !1, (n = r.parentNode) === null || n === void 0 || n.removeChild(r);
    }
    document.body.removeChild(e);
  }
}
function gb(e) {
  return hb(), !!so[e];
}
function vb(e) {
  var t = so[e], r = null;
  if (t && Zt())
    if (Mm)
      r = _m;
    else {
      var n = document.querySelector("style[".concat(_r, '="').concat(so[e], '"]'));
      n ? r = n.innerHTML : delete so[e];
    }
  return [r, t];
}
var Lm = "_skip_check_", Vm = "_multi_value_";
function sl(e) {
  var t = il(db(e), fb);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function yb(e) {
  return it(e) === "object" && e && (Lm in e || Vm in e);
}
function bb(e, t, r) {
  if (!t)
    return e;
  var n = ".".concat(t), o = r === "low" ? ":where(".concat(n, ")") : n, a = e.split(",").map(function(s) {
    var c, l = s.trim().split(/\s+/), d = l[0] || "", u = ((c = d.match(/^\w+/)) === null || c === void 0 ? void 0 : c[0]) || "";
    return d = "".concat(u).concat(o).concat(d.slice(u.length)), [d].concat(Ne(l.slice(1))).join(" ");
  });
  return a.join(",");
}
var Cb = function e(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = n.root, a = n.injectHash, s = n.parentSelectors, c = r.hashId, l = r.layer, d = r.path, u = r.hashPriority, f = r.transformers, h = f === void 0 ? [] : f, g = r.linters, E = g === void 0 ? [] : g, v = "", m = {};
  function y(T) {
    var N = T.getName(c);
    if (!m[N]) {
      var V = e(T.style, r, {
        root: !1,
        parentSelectors: s
      }), D = Se(V, 1), x = D[0];
      m[N] = "@keyframes ".concat(T.getName(c)).concat(x);
    }
  }
  function I(T) {
    var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return T.forEach(function(V) {
      Array.isArray(V) ? I(V, N) : V && N.push(V);
    }), N;
  }
  var b = I(Array.isArray(t) ? t : [t]);
  if (b.forEach(function(T) {
    var N = typeof T == "string" && !o ? {} : T;
    if (typeof N == "string")
      v += "".concat(N, `
`);
    else if (N._keyframe)
      y(N);
    else {
      var V = h.reduce(function(D, x) {
        var O;
        return (x == null || (O = x.visit) === null || O === void 0 ? void 0 : O.call(x, D)) || D;
      }, N);
      Object.keys(V).forEach(function(D) {
        var x = V[D];
        if (it(x) === "object" && x && (D !== "animationName" || !x._keyframe) && !yb(x)) {
          var O = !1, w = D.trim(), j = !1;
          (o || a) && c ? w.startsWith("@") ? O = !0 : w = bb(D, c, u) : o && !c && (w === "&" || w === "") && (w = "", j = !0);
          var $ = e(x, r, {
            root: j,
            injectHash: O,
            parentSelectors: [].concat(Ne(s), [w])
          }), _ = Se($, 2), A = _[0], R = _[1];
          m = ae(ae({}, m), R), v += "".concat(w).concat(A);
        } else {
          let F = function(L, M) {
            process.env.NODE_ENV !== "production" && (it(x) !== "object" || !(x != null && x[Lm])) && [mb, pb].concat(Ne(E)).forEach(function(ee) {
              return ee(L, M, {
                path: d,
                hashId: c,
                parentSelectors: s
              });
            });
            var B = L.replace(/[A-Z]/g, function(ee) {
              return "-".concat(ee.toLowerCase());
            }), W = M;
            !Q0[L] && typeof W == "number" && W !== 0 && (W = "".concat(W, "px")), L === "animationName" && M !== null && M !== void 0 && M._keyframe && (y(M), W = M.getName(c)), v += "".concat(B, ":").concat(W, ";");
          };
          var P, z = (P = x?.value) !== null && P !== void 0 ? P : x;
          it(x) === "object" && x !== null && x !== void 0 && x[Vm] && Array.isArray(z) ? z.forEach(function(L) {
            F(D, L);
          }) : F(D, z);
        }
      });
    }
  }), !o)
    v = "{".concat(v, "}");
  else if (l && T0()) {
    var C = l.split(","), S = C[C.length - 1].trim();
    v = "@layer ".concat(S, " {").concat(v, "}"), C.length > 1 && (v = "@layer ".concat(l, "{%%%:%}").concat(v));
  }
  return [v, m];
};
function zm(e, t) {
  return ts("".concat(e.join("%")).concat(t));
}
function Ib() {
  return null;
}
var Bm = "style";
function cl(e, t) {
  var r = e.token, n = e.path, o = e.hashId, a = e.layer, s = e.nonce, c = e.clientOnly, l = e.order, d = l === void 0 ? 0 : l, u = p.useContext(ys), f = u.autoClear, h = u.mock, g = u.defaultCache, E = u.hashPriority, v = u.container, m = u.ssrInline, y = u.transformers, I = u.linters, b = u.cache, C = r._tokenKey, S = [C].concat(Ne(n)), T = rl;
  process.env.NODE_ENV !== "production" && h !== void 0 && (T = h === "client");
  var N = Yl(
    Bm,
    S,
    // Create cache if needed
    function() {
      var w = S.join("|");
      if (gb(w)) {
        var j = vb(w), $ = Se(j, 2), _ = $[0], A = $[1];
        if (_)
          return [_, C, A, {}, c, d];
      }
      var R = t(), P = Cb(R, {
        hashId: o,
        hashPriority: E,
        layer: a,
        path: n.join("-"),
        transformers: y,
        linters: I
      }), z = Se(P, 2), F = z[0], L = z[1], M = sl(F), B = zm(S, M);
      return [M, C, B, L, c, d];
    },
    // Remove cache if no need
    function(w, j) {
      var $ = Se(w, 3), _ = $[2];
      (j || f) && rl && Aa(_, {
        mark: _r
      });
    },
    // Effect: Inject style here
    function(w) {
      var j = Se(w, 4), $ = j[0];
      j[1];
      var _ = j[2], A = j[3];
      if (T && $ !== _m) {
        var R = {
          mark: _r,
          prepend: "queue",
          attachTo: v,
          priority: d
        }, P = typeof s == "function" ? s() : s;
        P && (R.csp = {
          nonce: P
        });
        var z = Pn($, _, R);
        z[Fn] = b.instanceId, z.setAttribute(Uo, C), process.env.NODE_ENV !== "production" && z.setAttribute(I0, S.join("|")), Object.keys(A).forEach(function(F) {
          Pn(sl(A[F]), "_effect-".concat(F), R);
        });
      }
    }
  ), V = Se(N, 3), D = V[0], x = V[1], O = V[2];
  return function(w) {
    var j;
    if (!m || T || !g)
      j = /* @__PURE__ */ p.createElement(Ib, null);
    else {
      var $;
      j = /* @__PURE__ */ p.createElement("style", mt({}, ($ = {}, Q($, Uo, x), Q($, _r, O), $), {
        dangerouslySetInnerHTML: {
          __html: D
        }
      }));
    }
    return /* @__PURE__ */ p.createElement(p.Fragment, null, j, w);
  };
}
var xb = function(t, r, n) {
  var o = Se(t, 6), a = o[0], s = o[1], c = o[2], l = o[3], d = o[4], u = o[5], f = n || {}, h = f.plain;
  if (d)
    return null;
  var g = a, E = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return g = rs(a, s, c, E, h), l && Object.keys(l).forEach(function(v) {
    if (!r[v]) {
      r[v] = !0;
      var m = sl(l[v]);
      g += rs(m, s, "_effect-".concat(v), E, h);
    }
  }), [u, c, g];
}, km = "cssVar", Sb = function(t, r) {
  var n = t.key, o = t.prefix, a = t.unitless, s = t.ignore, c = t.token, l = t.scope, d = l === void 0 ? "" : l, u = Ir(ys), f = u.cache.instanceId, h = u.container, g = c._tokenKey, E = [].concat(Ne(t.path), [n, d, g]), v = Yl(km, E, function() {
    var m = r(), y = Tm(m, n, {
      prefix: o,
      unitless: a,
      ignore: s,
      scope: d
    }), I = Se(y, 2), b = I[0], C = I[1], S = zm(E, C);
    return [b, C, S, n];
  }, function(m) {
    var y = Se(m, 3), I = y[2];
    rl && Aa(I, {
      mark: _r
    });
  }, function(m) {
    var y = Se(m, 3), I = y[1], b = y[2];
    if (I) {
      var C = Pn(I, b, {
        mark: _r,
        prepend: "queue",
        attachTo: h,
        priority: -999
      });
      C[Fn] = f, C.setAttribute(Uo, n);
    }
  });
  return v;
}, Eb = function(t, r, n) {
  var o = Se(t, 4), a = o[1], s = o[2], c = o[3], l = n || {}, d = l.plain;
  if (!a)
    return null;
  var u = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, h = rs(a, c, s, f, d);
  return [u, s, h];
}, va;
va = {}, Q(va, Bm, xb), Q(va, Fm, Y0), Q(va, km, Eb);
var er = /* @__PURE__ */ function() {
  function e(t, r) {
    lr(this, e), Q(this, "name", void 0), Q(this, "style", void 0), Q(this, "_keyframe", !0), this.name = t, this.style = r;
  }
  return dr(e, [{
    key: "getName",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return r ? "".concat(r, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function Do(e) {
  return e.notSplit = !0, e;
}
Do(["borderTop", "borderBottom"]), Do(["borderTop"]), Do(["borderBottom"]), Do(["borderLeft", "borderRight"]), Do(["borderLeft"]), Do(["borderRight"]);
function Db(e) {
  return Wf(e) || dm(e) || Ll(e) || Gf();
}
function qr(e, t) {
  for (var r = e, n = 0; n < t.length; n += 1) {
    if (r == null)
      return;
    r = r[t[n]];
  }
  return r;
}
function Um(e, t, r, n) {
  if (!t.length)
    return r;
  var o = Db(t), a = o[0], s = o.slice(1), c;
  return !e && typeof a == "number" ? c = [] : Array.isArray(e) ? c = Ne(e) : c = ae({}, e), n && r === void 0 && s.length === 1 ? delete c[a][s[0]] : c[a] = Um(c[a], s, r, n), c;
}
function jr(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && n && r === void 0 && !qr(e, t.slice(0, -1)) ? e : Um(e, t, r, n);
}
function wb(e) {
  return it(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function ou(e) {
  return Array.isArray(e) ? [] : {};
}
var Tb = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function $o() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = ou(t[0]);
  return t.forEach(function(o) {
    function a(s, c) {
      var l = new Set(c), d = qr(o, s), u = Array.isArray(d);
      if (u || wb(d)) {
        if (!l.has(d)) {
          l.add(d);
          var f = qr(n, s);
          u ? n = jr(n, s, []) : (!f || it(f) !== "object") && (n = jr(n, s, ou(d))), Tb(d).forEach(function(h) {
            a([].concat(Ne(s), [h]), l);
          });
        }
      } else
        n = jr(n, s, d);
    }
    a([]);
  }), n;
}
function qm() {
}
let pn = null;
function Fb() {
  pn = null, om();
}
let Zl = qm;
process.env.NODE_ENV !== "production" && (Zl = (e, t, r) => {
  Tt(e, `[antd: ${t}] ${r}`), process.env.NODE_ENV === "test" && Fb();
});
const Hm = /* @__PURE__ */ p.createContext({}), ur = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = p.useContext(Hm), r = (n, o, a) => {
    if (!n)
      if (t === !1 && o === "deprecated") {
        const s = pn;
        pn || (pn = {}), pn[e] = pn[e] || [], pn[e].includes(a || "") || pn[e].push(a || ""), s || console.warn("[antd] There exists deprecated usage in your code:", pn);
      } else
        process.env.NODE_ENV !== "production" && Zl(n, e, a);
  };
  return r.deprecated = (n, o, a, s) => {
    r(n, "deprecated", `\`${o}\` is deprecated. Please use \`${a}\` instead.${s ? ` ${s}` : ""}`);
  }, r;
} : () => {
  const e = () => {
  };
  return e.deprecated = qm, e;
}, Is = Zl, Wm = /* @__PURE__ */ Ha(void 0);
var Ob = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, Nb = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const Rb = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, Gm = Rb, Pb = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, Nb),
  timePickerLocale: Object.assign({}, Gm)
}, au = Pb, hr = "${label} is not a valid ${type}", $n = {
  locale: "en",
  Pagination: Ob,
  DatePicker: au,
  TimePicker: Gm,
  Calendar: au,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: hr,
        method: hr,
        array: hr,
        object: hr,
        number: hr,
        date: hr,
        boolean: hr,
        integer: hr,
        float: hr,
        regexp: hr,
        email: hr,
        url: hr,
        hex: hr
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
};
Object.assign({}, $n.Modal);
let Ui = [];
const iu = () => Ui.reduce((e, t) => Object.assign(Object.assign({}, e), t), $n.Modal);
function jb(e) {
  if (e) {
    const t = Object.assign({}, e);
    return Ui.push(t), iu(), () => {
      Ui = Ui.filter((r) => r !== t), iu();
    };
  }
  Object.assign({}, $n.Modal);
}
const $b = /* @__PURE__ */ Ha(void 0), Jl = $b, ed = (e, t) => {
  const r = p.useContext(Jl), n = p.useMemo(() => {
    var a;
    const s = t || $n[e], c = (a = r?.[e]) !== null && a !== void 0 ? a : {};
    return Object.assign(Object.assign({}, typeof s == "function" ? s() : s), c || {});
  }, [e, t, r]), o = p.useMemo(() => {
    const a = r?.locale;
    return r?.exist && !a ? $n.locale : a;
  }, [r]);
  return [n, o];
}, Km = "internalMark", Ym = (e) => {
  const {
    locale: t = {},
    children: r,
    _ANT_MARK__: n
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const a = ur("LocaleProvider");
    process.env.NODE_ENV !== "production" && a(n === Km, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  p.useEffect(() => jb(t && t.Modal), [t]);
  const o = p.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ p.createElement(Jl.Provider, {
    value: o
  }, r);
};
process.env.NODE_ENV !== "production" && (Ym.displayName = "LocaleProvider");
const Ab = Ym, _b = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function Mb(e) {
  const {
    sizeUnit: t,
    sizeStep: r
  } = e;
  return {
    sizeXXL: t * (r + 8),
    // 48
    sizeXL: t * (r + 4),
    // 32
    sizeLG: t * (r + 2),
    // 24
    sizeMD: t * (r + 1),
    // 20
    sizeMS: t * r,
    // 16
    size: t * r,
    // 16
    sizeSM: t * (r - 1),
    // 12
    sizeXS: t * (r - 2),
    // 8
    sizeXXS: t * (r - 3)
    // 4
  };
}
const Qm = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, Lb = Object.assign(Object.assign({}, Qm), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), La = Lb;
function Vb(e, t) {
  let {
    generateColorPalettes: r,
    generateNeutralColorPalettes: n
  } = t;
  const {
    colorSuccess: o,
    colorWarning: a,
    colorError: s,
    colorInfo: c,
    colorPrimary: l,
    colorBgBase: d,
    colorTextBase: u
  } = e, f = r(l), h = r(o), g = r(a), E = r(s), v = r(c), m = n(d, u), y = e.colorLink || e.colorInfo, I = r(y);
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: f[1],
    colorPrimaryBgHover: f[2],
    colorPrimaryBorder: f[3],
    colorPrimaryBorderHover: f[4],
    colorPrimaryHover: f[5],
    colorPrimary: f[6],
    colorPrimaryActive: f[7],
    colorPrimaryTextHover: f[8],
    colorPrimaryText: f[9],
    colorPrimaryTextActive: f[10],
    colorSuccessBg: h[1],
    colorSuccessBgHover: h[2],
    colorSuccessBorder: h[3],
    colorSuccessBorderHover: h[4],
    colorSuccessHover: h[4],
    colorSuccess: h[6],
    colorSuccessActive: h[7],
    colorSuccessTextHover: h[8],
    colorSuccessText: h[9],
    colorSuccessTextActive: h[10],
    colorErrorBg: E[1],
    colorErrorBgHover: E[2],
    colorErrorBorder: E[3],
    colorErrorBorderHover: E[4],
    colorErrorHover: E[5],
    colorError: E[6],
    colorErrorActive: E[7],
    colorErrorTextHover: E[8],
    colorErrorText: E[9],
    colorErrorTextActive: E[10],
    colorWarningBg: g[1],
    colorWarningBgHover: g[2],
    colorWarningBorder: g[3],
    colorWarningBorderHover: g[4],
    colorWarningHover: g[4],
    colorWarning: g[6],
    colorWarningActive: g[7],
    colorWarningTextHover: g[8],
    colorWarningText: g[9],
    colorWarningTextActive: g[10],
    colorInfoBg: v[1],
    colorInfoBgHover: v[2],
    colorInfoBorder: v[3],
    colorInfoBorderHover: v[4],
    colorInfoHover: v[4],
    colorInfo: v[6],
    colorInfoActive: v[7],
    colorInfoTextHover: v[8],
    colorInfoText: v[9],
    colorInfoTextActive: v[10],
    colorLinkHover: I[4],
    colorLink: I[6],
    colorLinkActive: I[7],
    colorBgMask: new yr("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const zb = (e) => {
  let t = e, r = e, n = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? r = 4 : e < 8 && e >= 7 ? r = 5 : e < 14 && e >= 8 ? r = 6 : e < 16 && e >= 14 ? r = 7 : e >= 16 && (r = 8), e < 6 && e >= 2 ? n = 1 : e >= 6 && (n = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: n,
    borderRadiusSM: r,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
};
function Bb(e) {
  const {
    motionUnit: t,
    motionBase: r,
    borderRadius: n,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(r + t).toFixed(1)}s`,
    motionDurationMid: `${(r + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(r + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, zb(n));
}
const fn = (e, t) => new yr(e).setAlpha(t).toRgbString(), ya = (e, t) => new yr(e).darken(t).toHexString(), kb = (e) => {
  const t = co(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, Ub = (e, t) => {
  const r = e || "#fff", n = t || "#000";
  return {
    colorBgBase: r,
    colorTextBase: n,
    colorText: fn(n, 0.88),
    colorTextSecondary: fn(n, 0.65),
    colorTextTertiary: fn(n, 0.45),
    colorTextQuaternary: fn(n, 0.25),
    colorFill: fn(n, 0.15),
    colorFillSecondary: fn(n, 0.06),
    colorFillTertiary: fn(n, 0.04),
    colorFillQuaternary: fn(n, 0.02),
    colorBgLayout: ya(r, 4),
    colorBgContainer: ya(r, 0),
    colorBgElevated: ya(r, 0),
    colorBgSpotlight: fn(n, 0.85),
    colorBgBlur: "transparent",
    colorBorder: ya(r, 15),
    colorBorderSecondary: ya(r, 6)
  };
};
function qi(e) {
  return (e + 8) / e;
}
function qb(e) {
  const t = new Array(10).fill(null).map((r, n) => {
    const o = n - 1, a = e * Math.pow(2.71828, o / 5), s = n > 1 ? Math.floor(a) : Math.ceil(a);
    return Math.floor(s / 2) * 2;
  });
  return t[1] = e, t.map((r) => ({
    size: r,
    lineHeight: qi(r)
  }));
}
const Hb = (e) => {
  const t = qb(e), r = t.map((u) => u.size), n = t.map((u) => u.lineHeight), o = r[1], a = r[0], s = r[2], c = n[1], l = n[0], d = n[2];
  return {
    fontSizeSM: a,
    fontSize: o,
    fontSizeLG: s,
    fontSizeXL: r[3],
    fontSizeHeading1: r[6],
    fontSizeHeading2: r[5],
    fontSizeHeading3: r[4],
    fontSizeHeading4: r[3],
    fontSizeHeading5: r[2],
    lineHeight: c,
    lineHeightLG: d,
    lineHeightSM: l,
    fontHeight: Math.round(c * o),
    fontHeightLG: Math.round(d * s),
    fontHeightSM: Math.round(l * a),
    lineHeightHeading1: n[6],
    lineHeightHeading2: n[5],
    lineHeightHeading3: n[4],
    lineHeightHeading4: n[3],
    lineHeightHeading5: n[2]
  };
};
function Wb(e) {
  const t = Object.keys(Qm).map((r) => {
    const n = co(e[r]);
    return new Array(10).fill(1).reduce((o, a, s) => (o[`${r}-${s + 1}`] = n[s], o[`${r}${s + 1}`] = n[s], o), {});
  }).reduce((r, n) => (r = Object.assign(Object.assign({}, r), n), r), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), Vb(e, {
    generateColorPalettes: kb,
    generateNeutralColorPalettes: Ub
  })), Hb(e.fontSize)), Mb(e)), _b(e)), Bb(e));
}
const Xm = tl(Wb), ll = {
  token: La,
  override: {
    override: La
  },
  hashed: !0
}, Zm = /* @__PURE__ */ k.createContext(ll), Jm = "anticon", Gb = (e, t) => t || (e ? `ant-${e}` : "ant"), Mt = /* @__PURE__ */ p.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: Gb,
  iconPrefixCls: Jm
}), Kb = `-ant-${Date.now()}-${Math.random()}`;
function Yb(e, t) {
  const r = {}, n = (s, c) => {
    let l = s.clone();
    return l = c?.(l) || l, l.toRgbString();
  }, o = (s, c) => {
    const l = new yr(s), d = co(l.toRgbString());
    r[`${c}-color`] = n(l), r[`${c}-color-disabled`] = d[1], r[`${c}-color-hover`] = d[4], r[`${c}-color-active`] = d[6], r[`${c}-color-outline`] = l.clone().setAlpha(0.2).toRgbString(), r[`${c}-color-deprecated-bg`] = d[0], r[`${c}-color-deprecated-border`] = d[2];
  };
  if (t.primaryColor) {
    o(t.primaryColor, "primary");
    const s = new yr(t.primaryColor), c = co(s.toRgbString());
    c.forEach((d, u) => {
      r[`primary-${u + 1}`] = d;
    }), r["primary-color-deprecated-l-35"] = n(s, (d) => d.lighten(35)), r["primary-color-deprecated-l-20"] = n(s, (d) => d.lighten(20)), r["primary-color-deprecated-t-20"] = n(s, (d) => d.tint(20)), r["primary-color-deprecated-t-50"] = n(s, (d) => d.tint(50)), r["primary-color-deprecated-f-12"] = n(s, (d) => d.setAlpha(d.getAlpha() * 0.12));
    const l = new yr(c[0]);
    r["primary-color-active-deprecated-f-30"] = n(l, (d) => d.setAlpha(d.getAlpha() * 0.3)), r["primary-color-active-deprecated-d-02"] = n(l, (d) => d.darken(2));
  }
  return t.successColor && o(t.successColor, "success"), t.warningColor && o(t.warningColor, "warning"), t.errorColor && o(t.errorColor, "error"), t.infoColor && o(t.infoColor, "info"), `
  :root {
    ${Object.keys(r).map((s) => `--${e}-${s}: ${r[s]};`).join(`
`)}
  }
  `.trim();
}
function Qb(e, t) {
  const r = Yb(e, t);
  Zt() ? Pn(r, `${Kb}-dynamic-theme`) : process.env.NODE_ENV !== "production" && Is(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const dl = /* @__PURE__ */ p.createContext(!1), ep = (e) => {
  let {
    children: t,
    disabled: r
  } = e;
  const n = p.useContext(dl);
  return /* @__PURE__ */ p.createElement(dl.Provider, {
    value: r ?? n
  }, t);
}, Qa = dl, ul = /* @__PURE__ */ p.createContext(void 0), Xb = (e) => {
  let {
    children: t,
    size: r
  } = e;
  const n = p.useContext(ul);
  return /* @__PURE__ */ p.createElement(ul.Provider, {
    value: r || n
  }, t);
}, Xa = ul;
function Zb() {
  const e = Ir(Qa), t = Ir(Xa);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
const ns = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], Jb = "5.14.1";
function hc(e) {
  return e >= 0 && e <= 255;
}
function Ei(e, t) {
  const {
    r,
    g: n,
    b: o,
    a
  } = new yr(e).toRgb();
  if (a < 1)
    return e;
  const {
    r: s,
    g: c,
    b: l
  } = new yr(t).toRgb();
  for (let d = 0.01; d <= 1; d += 0.01) {
    const u = Math.round((r - s * (1 - d)) / d), f = Math.round((n - c * (1 - d)) / d), h = Math.round((o - l * (1 - d)) / d);
    if (hc(u) && hc(f) && hc(h))
      return new yr({
        r: u,
        g: f,
        b: h,
        a: Math.round(d * 100) / 100
      }).toRgbString();
  }
  return new yr({
    r,
    g: n,
    b: o,
    a: 1
  }).toRgbString();
}
var eC = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function tp(e) {
  const {
    override: t
  } = e, r = eC(e, ["override"]), n = Object.assign({}, t);
  Object.keys(La).forEach((h) => {
    delete n[h];
  });
  const o = Object.assign(Object.assign({}, r), n), a = 480, s = 576, c = 768, l = 992, d = 1200, u = 1600;
  if (o.motion === !1) {
    const h = "0s";
    o.motionDurationFast = h, o.motionDurationMid = h, o.motionDurationSlow = h;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: Ei(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: Ei(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: Ei(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 4,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: Ei(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: a,
    screenXSMin: a,
    screenXSMax: s - 1,
    screenSM: s,
    screenSMMin: s,
    screenSMMax: c - 1,
    screenMD: c,
    screenMDMin: c,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: d - 1,
    screenXL: d,
    screenXLMin: d,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new yr("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new yr("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new yr("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), n);
}
var su = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const rp = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, np = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, tC = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, op = (e, t, r) => {
  const n = r.getDerivativeToken(e), {
    override: o
  } = t, a = su(t, ["override"]);
  let s = Object.assign(Object.assign({}, n), {
    override: o
  });
  return s = tp(s), a && Object.entries(a).forEach((c) => {
    let [l, d] = c;
    const {
      theme: u
    } = d, f = su(d, ["theme"]);
    let h = f;
    u && (h = op(Object.assign(Object.assign({}, s), f), {
      override: f
    }, u)), s[l] = h;
  }), s;
};
function Lr() {
  const {
    token: e,
    hashed: t,
    theme: r,
    override: n,
    cssVar: o
  } = k.useContext(Zm), a = `${Jb}-${t || ""}`, s = r || Xm, [c, l, d] = K0(s, [La, e], {
    salt: a,
    override: n,
    getComputedToken: op,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: tp,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: rp,
      ignore: np,
      preserve: tC
    }
  });
  return [s, d, t ? l : "", c, o];
}
const ap = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), ip = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, ho = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, rC = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), td = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), nC = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), oC = (e, t, r) => {
  const {
    fontFamily: n,
    fontSize: o
  } = e, a = `[class^="${t}"], [class*=" ${t}"]`;
  return {
    [r ? `.${r}` : a]: {
      fontFamily: n,
      fontSize: o,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [a]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, aC = (e) => ({
  outline: `${Me(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), iC = (e) => ({
  "&:focus-visible": Object.assign({}, aC(e))
});
let sC = /* @__PURE__ */ dr(function e() {
  lr(this, e);
});
const sp = sC;
function cC(e, t, r) {
  return t = jn(t), Wl(e, gs() ? Reflect.construct(t, r || [], jn(e).constructor) : t.apply(e, r));
}
let lC = /* @__PURE__ */ function(e) {
  zn(t, e);
  function t(r) {
    var n;
    return lr(this, t), n = cC(this, t), n.result = 0, r instanceof t ? n.result = r.result : typeof r == "number" && (n.result = r), n;
  }
  return dr(t, [{
    key: "add",
    value: function(n) {
      return n instanceof t ? this.result += n.result : typeof n == "number" && (this.result += n), this;
    }
  }, {
    key: "sub",
    value: function(n) {
      return n instanceof t ? this.result -= n.result : typeof n == "number" && (this.result -= n), this;
    }
  }, {
    key: "mul",
    value: function(n) {
      return n instanceof t ? this.result *= n.result : typeof n == "number" && (this.result *= n), this;
    }
  }, {
    key: "div",
    value: function(n) {
      return n instanceof t ? this.result /= n.result : typeof n == "number" && (this.result /= n), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), t;
}(sp);
function dC(e, t, r) {
  return t = jn(t), Wl(e, gs() ? Reflect.construct(t, r || [], jn(e).constructor) : t.apply(e, r));
}
const cp = "CALC_UNIT";
function gc(e) {
  return typeof e == "number" ? `${e}${cp}` : e;
}
let uC = /* @__PURE__ */ function(e) {
  zn(t, e);
  function t(r) {
    var n;
    return lr(this, t), n = dC(this, t), n.result = "", r instanceof t ? n.result = `(${r.result})` : typeof r == "number" ? n.result = gc(r) : typeof r == "string" && (n.result = r), n;
  }
  return dr(t, [{
    key: "add",
    value: function(n) {
      return n instanceof t ? this.result = `${this.result} + ${n.getResult()}` : (typeof n == "number" || typeof n == "string") && (this.result = `${this.result} + ${gc(n)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(n) {
      return n instanceof t ? this.result = `${this.result} - ${n.getResult()}` : (typeof n == "number" || typeof n == "string") && (this.result = `${this.result} - ${gc(n)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(n) {
      return this.lowPriority && (this.result = `(${this.result})`), n instanceof t ? this.result = `${this.result} * ${n.getResult(!0)}` : (typeof n == "number" || typeof n == "string") && (this.result = `${this.result} * ${n}`), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(n) {
      return this.lowPriority && (this.result = `(${this.result})`), n instanceof t ? this.result = `${this.result} / ${n.getResult(!0)}` : (typeof n == "number" || typeof n == "string") && (this.result = `${this.result} / ${n}`), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(n) {
      return this.lowPriority || n ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function(n) {
      const {
        unit: o = !0
      } = n || {}, a = new RegExp(`${cp}`, "g");
      return this.result = this.result.replace(a, o ? "px" : ""), typeof this.lowPriority < "u" ? `calc(${this.result})` : this.result;
    }
  }]), t;
}(sp);
const fC = (e) => {
  const t = e === "css" ? uC : lC;
  return (r) => new t(r);
};
function mC(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
        r[n] = arguments[n];
      return `max(${r.map((o) => Me(o)).join(",")})`;
    },
    min: function() {
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
        r[n] = arguments[n];
      return `min(${r.map((o) => Me(o)).join(",")})`;
    }
  };
}
const lp = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u";
let fl = !0;
function fr() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!lp)
    return Object.assign.apply(Object, [{}].concat(t));
  fl = !1;
  const n = {};
  return t.forEach((o) => {
    Object.keys(o).forEach((s) => {
      Object.defineProperty(n, s, {
        configurable: !0,
        enumerable: !0,
        get: () => o[s]
      });
    });
  }), fl = !0, n;
}
const cu = {};
function pC() {
}
const hC = (e) => {
  let t, r = e, n = pC;
  return lp && typeof Proxy < "u" && (t = /* @__PURE__ */ new Set(), r = new Proxy(e, {
    get(o, a) {
      return fl && t.add(a), o[a];
    }
  }), n = (o, a) => {
    var s;
    cu[o] = {
      global: Array.from(t),
      component: Object.assign(Object.assign({}, (s = cu[o]) === null || s === void 0 ? void 0 : s.component), a)
    };
  }), {
    token: r,
    keys: t,
    flush: n
  };
}, dp = (e, t) => {
  const [r, n] = Lr();
  return cl({
    theme: r,
    token: n,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t?.nonce
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, rC()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, up = (e, t, r) => {
  var n;
  return typeof r == "function" ? r(fr(t, (n = t[e]) !== null && n !== void 0 ? n : {})) : r ?? {};
}, fp = (e, t, r, n) => {
  const o = Object.assign({}, t[e]);
  if (n?.deprecatedTokens) {
    const {
      deprecatedTokens: s
    } = n;
    s.forEach((c) => {
      let [l, d] = c;
      var u;
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && Tt(!o?.[l], `Component Token \`${String(l)}\` of ${e} is deprecated. Please use \`${String(d)}\` instead.`), (o?.[l] || o?.[d]) && ((u = o[d]) !== null && u !== void 0 || (o[d] = o?.[l]));
    });
  }
  const a = Object.assign(Object.assign({}, r), o);
  return Object.keys(a).forEach((s) => {
    a[s] === t[s] && delete a[s];
  }), a;
}, gC = (e, t) => `${[t, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function rd(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const o = Array.isArray(e) ? e : [e, e], [a] = o, s = o.join("-");
  return function(c) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c;
    const [d, u, f, h, g] = Lr(), {
      getPrefixCls: E,
      iconPrefixCls: v,
      csp: m
    } = Ir(Mt), y = E(), I = g ? "css" : "js", b = fC(I), {
      max: C,
      min: S
    } = mC(I), T = {
      theme: d,
      token: h,
      hashId: f,
      nonce: () => m?.nonce,
      clientOnly: n.clientOnly,
      // antd is always at top of styles
      order: n.order || -999
    };
    return cl(Object.assign(Object.assign({}, T), {
      clientOnly: !1,
      path: ["Shared", y]
    }), () => [{
      // Link
      "&": nC(h)
    }]), dp(v, m), [cl(Object.assign(Object.assign({}, T), {
      path: [s, c, v]
    }), () => {
      if (n.injectStyle === !1)
        return [];
      const {
        token: V,
        flush: D
      } = hC(h), x = up(a, u, r), O = `.${c}`, w = fp(a, u, x, {
        deprecatedTokens: n.deprecatedTokens
      });
      g && Object.keys(x).forEach((_) => {
        x[_] = `var(${wm(_, gC(a, g.prefix))})`;
      });
      const j = fr(V, {
        componentCls: O,
        prefixCls: c,
        iconCls: `.${v}`,
        antCls: `.${y}`,
        calc: b,
        max: C,
        min: S
      }, g ? x : w), $ = t(j, {
        hashId: f,
        prefixCls: c,
        rootPrefixCls: y,
        iconPrefixCls: v
      });
      return D(a, w), [n.resetStyle === !1 ? null : oC(j, c, l), $];
    }), f];
  };
}
const mp = (e, t, r, n) => {
  const o = rd(e, t, r, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, n)), a = (s) => {
    let {
      prefixCls: c,
      rootCls: l = c
    } = s;
    return o(c, l), null;
  };
  return process.env.NODE_ENV !== "production" && (a.displayName = `SubStyle_${Array.isArray(e) ? e.join(".") : e}`), a;
}, vC = (e, t, r) => {
  function n(d) {
    return `${e}${d.slice(0, 1).toUpperCase()}${d.slice(1)}`;
  }
  const {
    unitless: o = {},
    injectStyle: a = !0
  } = r ?? {}, s = {
    [n("zIndexPopup")]: !0
  };
  Object.keys(o).forEach((d) => {
    s[n(d)] = o[d];
  });
  const c = (d) => {
    let {
      rootCls: u,
      cssVar: f
    } = d;
    const [, h] = Lr();
    return Sb({
      path: [e],
      prefix: f.prefix,
      key: f?.key,
      unitless: Object.assign(Object.assign({}, rp), s),
      ignore: np,
      token: h,
      scope: u
    }, () => {
      const g = up(e, h, t), E = fp(e, h, g, {
        deprecatedTokens: r?.deprecatedTokens
      });
      return Object.keys(g).forEach((v) => {
        E[n(v)] = E[v], delete E[v];
      }), E;
    }), null;
  };
  return (d) => {
    const [, , , , u] = Lr();
    return [(f) => a && u ? /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(c, {
      rootCls: d,
      cssVar: u,
      component: e
    }), f) : f, u?.key];
  };
}, Cn = (e, t, r, n) => {
  const o = rd(e, t, r, n), a = vC(Array.isArray(e) ? e[0] : e, r, n);
  return function(s) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
    const [, l] = o(s, c), [d, u] = a(c);
    return [d, l, u];
  };
};
function yC(e, t) {
  return ns.reduce((r, n) => {
    const o = e[`${n}1`], a = e[`${n}3`], s = e[`${n}6`], c = e[`${n}7`];
    return Object.assign(Object.assign({}, r), t(n, {
      lightColor: o,
      lightBorderColor: a,
      darkColor: s,
      textColor: c
    }));
  }, {});
}
const bC = Object.assign({}, p), {
  useId: lu
} = bC, CC = () => "", IC = typeof lu > "u" ? CC : lu;
function xC(e, t) {
  var r, n;
  const o = ur("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, ll), {
    hashed: (r = t?.hashed) !== null && r !== void 0 ? r : ll.hashed,
    cssVar: t?.cssVar
  }) : t, c = IC();
  if (process.env.NODE_ENV !== "production") {
    const l = a.cssVar || s.cssVar, d = !!(typeof a.cssVar == "object" && (!((n = a.cssVar) === null || n === void 0) && n.key) || c);
    process.env.NODE_ENV !== "production" && o(!l || d, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return Ul(() => {
    var l, d;
    if (!e)
      return t;
    const u = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((g) => {
      u[g] = Object.assign(Object.assign({}, u[g]), e.components[g]);
    });
    const f = `css-var-${c.replace(/:/g, "")}`, h = ((l = a.cssVar) !== null && l !== void 0 ? l : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: "ant"
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((d = a.cssVar) === null || d === void 0 ? void 0 : d.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: u,
      cssVar: h
    });
  }, [a, s], (l, d) => l.some((u, f) => {
    const h = d[f];
    return !Sm(u, h, !0);
  }));
}
var SC = ["children"], pp = /* @__PURE__ */ p.createContext({});
function EC(e) {
  var t = e.children, r = cr(e, SC);
  return /* @__PURE__ */ p.createElement(pp.Provider, {
    value: r
  }, t);
}
var DC = /* @__PURE__ */ function(e) {
  zn(r, e);
  var t = ea(r);
  function r() {
    return lr(this, r), t.apply(this, arguments);
  }
  return dr(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(p.Component), Zn = "none", Di = "appear", wi = "enter", Ti = "leave", du = "none", $r = "prepare", Ao = "start", _o = "active", nd = "end", hp = "prepared";
function uu(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function wC(e, t) {
  var r = {
    animationend: uu("Animation", "AnimationEnd"),
    transitionend: uu("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var TC = wC(Zt(), typeof window < "u" ? window : {}), gp = {};
if (Zt()) {
  var FC = document.createElement("div");
  gp = FC.style;
}
var Fi = {};
function vp(e) {
  if (Fi[e])
    return Fi[e];
  var t = TC[e];
  if (t)
    for (var r = Object.keys(t), n = r.length, o = 0; o < n; o += 1) {
      var a = r[o];
      if (Object.prototype.hasOwnProperty.call(t, a) && a in gp)
        return Fi[e] = t[a], Fi[e];
    }
  return "";
}
var yp = vp("animationend"), bp = vp("transitionend"), Cp = !!(yp && bp), fu = yp || "animationend", mu = bp || "transitionend";
function pu(e, t) {
  if (!e)
    return null;
  if (it(e) === "object") {
    var r = t.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
const OC = function(e) {
  var t = Wt(), r = Wt(e);
  r.current = e;
  var n = p.useCallback(function(s) {
    r.current(s);
  }, []);
  function o(s) {
    s && (s.removeEventListener(mu, n), s.removeEventListener(fu, n));
  }
  function a(s) {
    t.current && t.current !== s && o(t.current), s && s !== t.current && (s.addEventListener(mu, n), s.addEventListener(fu, n), t.current = s);
  }
  return p.useEffect(function() {
    return function() {
      o(t.current);
    };
  }, []), [a, o];
};
var Ip = Zt() ? _f : xr;
const NC = function() {
  var e = p.useRef(null);
  function t() {
    Nr.cancel(e.current);
  }
  function r(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var a = Nr(function() {
      o <= 1 ? n({
        isCanceled: function() {
          return a !== e.current;
        }
      }) : r(n, o - 1);
    });
    e.current = a;
  }
  return p.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
};
var RC = [$r, Ao, _o, nd], PC = [$r, hp], xp = !1, jC = !0;
function Sp(e) {
  return e === _o || e === nd;
}
const $C = function(e, t, r) {
  var n = ao(du), o = Se(n, 2), a = o[0], s = o[1], c = NC(), l = Se(c, 2), d = l[0], u = l[1];
  function f() {
    s($r, !0);
  }
  var h = t ? PC : RC;
  return Ip(function() {
    if (a !== du && a !== nd) {
      var g = h.indexOf(a), E = h[g + 1], v = r(a);
      v === xp ? s(E, !0) : E && d(function(m) {
        function y() {
          m.isCanceled() || s(E, !0);
        }
        v === !0 ? y() : Promise.resolve(v).then(y);
      });
    }
  }, [e, a]), p.useEffect(function() {
    return function() {
      u();
    };
  }, []), [f, a];
};
function AC(e, t, r, n) {
  var o = n.motionEnter, a = o === void 0 ? !0 : o, s = n.motionAppear, c = s === void 0 ? !0 : s, l = n.motionLeave, d = l === void 0 ? !0 : l, u = n.motionDeadline, f = n.motionLeaveImmediately, h = n.onAppearPrepare, g = n.onEnterPrepare, E = n.onLeavePrepare, v = n.onAppearStart, m = n.onEnterStart, y = n.onLeaveStart, I = n.onAppearActive, b = n.onEnterActive, C = n.onLeaveActive, S = n.onAppearEnd, T = n.onEnterEnd, N = n.onLeaveEnd, V = n.onVisibleChanged, D = ao(), x = Se(D, 2), O = x[0], w = x[1], j = ao(Zn), $ = Se(j, 2), _ = $[0], A = $[1], R = ao(null), P = Se(R, 2), z = P[0], F = P[1], L = Wt(!1), M = Wt(null);
  function B() {
    return r();
  }
  var W = Wt(!1);
  function ee() {
    A(Zn, !0), F(null, !0);
  }
  function te(ge) {
    var be = B();
    if (!(ge && !ge.deadline && ge.target !== be)) {
      var Ie = W.current, Pe;
      _ === Di && Ie ? Pe = S?.(be, ge) : _ === wi && Ie ? Pe = T?.(be, ge) : _ === Ti && Ie && (Pe = N?.(be, ge)), _ !== Zn && Ie && Pe !== !1 && ee();
    }
  }
  var de = OC(te), Z = Se(de, 1), ce = Z[0], Y = function(be) {
    var Ie, Pe, Le;
    switch (be) {
      case Di:
        return Ie = {}, Q(Ie, $r, h), Q(Ie, Ao, v), Q(Ie, _o, I), Ie;
      case wi:
        return Pe = {}, Q(Pe, $r, g), Q(Pe, Ao, m), Q(Pe, _o, b), Pe;
      case Ti:
        return Le = {}, Q(Le, $r, E), Q(Le, Ao, y), Q(Le, _o, C), Le;
      default:
        return {};
    }
  }, he = p.useMemo(function() {
    return Y(_);
  }, [_]), ve = $C(_, !e, function(ge) {
    if (ge === $r) {
      var be = he[$r];
      return be ? be(B()) : xp;
    }
    if (Fe in he) {
      var Ie;
      F(((Ie = he[Fe]) === null || Ie === void 0 ? void 0 : Ie.call(he, B(), null)) || null);
    }
    return Fe === _o && (ce(B()), u > 0 && (clearTimeout(M.current), M.current = setTimeout(function() {
      te({
        deadline: !0
      });
    }, u))), Fe === hp && ee(), jC;
  }), ue = Se(ve, 2), le = ue[0], Fe = ue[1], He = Sp(Fe);
  W.current = He, Ip(function() {
    w(t);
    var ge = L.current;
    L.current = !0;
    var be;
    !ge && t && c && (be = Di), ge && t && a && (be = wi), (ge && !t && d || !ge && f && !t && d) && (be = Ti);
    var Ie = Y(be);
    be && (e || Ie[$r]) ? (A(be), le()) : A(Zn);
  }, [t]), xr(function() {
    // Cancel appear
    (_ === Di && !c || // Cancel enter
    _ === wi && !a || // Cancel leave
    _ === Ti && !d) && A(Zn);
  }, [c, a, d]), xr(function() {
    return function() {
      L.current = !1, clearTimeout(M.current);
    };
  }, []);
  var We = p.useRef(!1);
  xr(function() {
    O && (We.current = !0), O !== void 0 && _ === Zn && ((We.current || O) && V?.(O), We.current = !0);
  }, [O, _]);
  var ie = z;
  return he[$r] && Fe === Ao && (ie = ae({
    transition: "none"
  }, ie)), [_, Fe, ie, O ?? t];
}
function _C(e) {
  var t = e;
  it(e) === "object" && (t = e.transitionSupport);
  function r(o, a) {
    return !!(o.motionName && t && a !== !1);
  }
  var n = /* @__PURE__ */ p.forwardRef(function(o, a) {
    var s = o.visible, c = s === void 0 ? !0 : s, l = o.removeOnLeave, d = l === void 0 ? !0 : l, u = o.forceRender, f = o.children, h = o.motionName, g = o.leavedClassName, E = o.eventProps, v = p.useContext(pp), m = v.motion, y = r(o, m), I = Wt(), b = Wt();
    function C() {
      try {
        return I.current instanceof HTMLElement ? I.current : Vi(b.current);
      } catch {
        return null;
      }
    }
    var S = AC(y, c, C, o), T = Se(S, 4), N = T[0], V = T[1], D = T[2], x = T[3], O = p.useRef(x);
    x && (O.current = !0);
    var w = p.useCallback(function(F) {
      I.current = F, ql(a, F);
    }, [a]), j, $ = ae(ae({}, E), {}, {
      visible: c
    });
    if (!f)
      j = null;
    else if (N === Zn)
      x ? j = f(ae({}, $), w) : !d && O.current && g ? j = f(ae(ae({}, $), {}, {
        className: g
      }), w) : u || !d && !g ? j = f(ae(ae({}, $), {}, {
        style: {
          display: "none"
        }
      }), w) : j = null;
    else {
      var _, A;
      V === $r ? A = "prepare" : Sp(V) ? A = "active" : V === Ao && (A = "start");
      var R = pu(h, "".concat(N, "-").concat(A));
      j = f(ae(ae({}, $), {}, {
        className: we(pu(h, N), (_ = {}, Q(_, R, R && A), Q(_, h, typeof h == "string"), _)),
        style: D
      }), w);
    }
    if (/* @__PURE__ */ p.isValidElement(j) && Jo(j)) {
      var P = j, z = P.ref;
      z || (j = /* @__PURE__ */ p.cloneElement(j, {
        ref: w
      }));
    }
    return /* @__PURE__ */ p.createElement(DC, {
      ref: b
    }, j);
  });
  return n.displayName = "CSSMotion", n;
}
const Bn = _C(Cp);
var ml = "add", pl = "keep", hl = "remove", vc = "removed";
function MC(e) {
  var t;
  return e && it(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ae(ae({}, t), {}, {
    key: String(t.key)
  });
}
function gl() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(MC);
}
function LC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, o = t.length, a = gl(e), s = gl(t);
  a.forEach(function(d) {
    for (var u = !1, f = n; f < o; f += 1) {
      var h = s[f];
      if (h.key === d.key) {
        n < f && (r = r.concat(s.slice(n, f).map(function(g) {
          return ae(ae({}, g), {}, {
            status: ml
          });
        })), n = f), r.push(ae(ae({}, h), {}, {
          status: pl
        })), n += 1, u = !0;
        break;
      }
    }
    u || r.push(ae(ae({}, d), {}, {
      status: hl
    }));
  }), n < o && (r = r.concat(s.slice(n).map(function(d) {
    return ae(ae({}, d), {}, {
      status: ml
    });
  })));
  var c = {};
  r.forEach(function(d) {
    var u = d.key;
    c[u] = (c[u] || 0) + 1;
  });
  var l = Object.keys(c).filter(function(d) {
    return c[d] > 1;
  });
  return l.forEach(function(d) {
    r = r.filter(function(u) {
      var f = u.key, h = u.status;
      return f !== d || h !== hl;
    }), r.forEach(function(u) {
      u.key === d && (u.status = pl);
    });
  }), r;
}
var VC = ["component", "children", "onVisibleChanged", "onAllRemoved"], zC = ["status"], BC = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function kC(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bn, r = /* @__PURE__ */ function(n) {
    zn(a, n);
    var o = ea(a);
    function a() {
      var s;
      lr(this, a);
      for (var c = arguments.length, l = new Array(c), d = 0; d < c; d++)
        l[d] = arguments[d];
      return s = o.call.apply(o, [this].concat(l)), Q(Ze(s), "state", {
        keyEntities: []
      }), Q(Ze(s), "removeKey", function(u) {
        var f = s.state.keyEntities, h = f.map(function(g) {
          return g.key !== u ? g : ae(ae({}, g), {}, {
            status: vc
          });
        });
        return s.setState({
          keyEntities: h
        }), h.filter(function(g) {
          var E = g.status;
          return E !== vc;
        }).length;
      }), s;
    }
    return dr(a, [{
      key: "render",
      value: function() {
        var c = this, l = this.state.keyEntities, d = this.props, u = d.component, f = d.children, h = d.onVisibleChanged, g = d.onAllRemoved, E = cr(d, VC), v = u || p.Fragment, m = {};
        return BC.forEach(function(y) {
          m[y] = E[y], delete E[y];
        }), delete E.keys, /* @__PURE__ */ p.createElement(v, E, l.map(function(y, I) {
          var b = y.status, C = cr(y, zC), S = b === ml || b === pl;
          return /* @__PURE__ */ p.createElement(t, mt({}, m, {
            key: C.key,
            visible: S,
            eventProps: C,
            onVisibleChanged: function(N) {
              if (h?.(N, {
                key: C.key
              }), !N) {
                var V = c.removeKey(C.key);
                V === 0 && g && g();
              }
            }
          }), function(T, N) {
            return f(ae(ae({}, T), {}, {
              index: I
            }), N);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(c, l) {
        var d = c.keys, u = l.keyEntities, f = gl(d), h = LC(u, f);
        return {
          keyEntities: h.filter(function(g) {
            var E = u.find(function(v) {
              var m = v.key;
              return g.key === m;
            });
            return !(E && E.status === vc && g.status === hl);
          })
        };
      }
    }]), a;
  }(p.Component);
  return Q(r, "defaultProps", {
    component: "div"
  }), r;
}
const Ep = kC(Cp);
function UC(e) {
  const {
    children: t
  } = e, [, r] = Lr(), {
    motion: n
  } = r, o = p.useRef(!1);
  return o.current = o.current || n === !1, o.current ? /* @__PURE__ */ p.createElement(EC, {
    motion: n
  }, t) : t;
}
const Dp = /* @__PURE__ */ p.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return ur("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (Dp.displayName = "PropWarning");
const qC = process.env.NODE_ENV !== "production" ? Dp : () => null;
var HC = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
let vl = !1;
process.env.NODE_ENV;
const WC = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], GC = "ant";
let wp;
function KC() {
  return wp || GC;
}
function YC(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const QC = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: r,
    theme: n,
    holderRender: o
  } = e;
  t !== void 0 && (wp = t), n && YC(n) && (process.env.NODE_ENV !== "production" && Is(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), Qb(KC(), n));
}, XC = (e) => {
  const {
    children: t,
    csp: r,
    autoInsertSpaceInButton: n,
    alert: o,
    anchor: a,
    form: s,
    locale: c,
    componentSize: l,
    direction: d,
    space: u,
    virtual: f,
    dropdownMatchSelectWidth: h,
    popupMatchSelectWidth: g,
    popupOverflow: E,
    legacyLocale: v,
    parentContext: m,
    iconPrefixCls: y,
    theme: I,
    componentDisabled: b,
    segmented: C,
    statistic: S,
    spin: T,
    calendar: N,
    carousel: V,
    cascader: D,
    collapse: x,
    typography: O,
    checkbox: w,
    descriptions: j,
    divider: $,
    drawer: _,
    skeleton: A,
    steps: R,
    image: P,
    layout: z,
    list: F,
    mentions: L,
    modal: M,
    progress: B,
    result: W,
    slider: ee,
    breadcrumb: te,
    menu: de,
    pagination: Z,
    input: ce,
    empty: Y,
    badge: he,
    radio: ve,
    rate: ue,
    switch: le,
    transfer: Fe,
    avatar: He,
    message: We,
    tag: ie,
    table: ge,
    card: be,
    tabs: Ie,
    timeline: Pe,
    timePicker: Le,
    upload: Ve,
    notification: _e,
    tree: ut,
    colorPicker: Nt,
    datePicker: pt,
    rangePicker: Ge,
    flex: dt,
    wave: q,
    dropdown: H,
    warning: G,
    tour: ne
  } = e, fe = p.useCallback((Qe, ht) => {
    const {
      prefixCls: Ft
    } = e;
    if (ht)
      return ht;
    const $t = Ft || m.getPrefixCls("");
    return Qe ? `${$t}-${Qe}` : $t;
  }, [m.getPrefixCls, e.prefixCls]), Te = y || m.iconPrefixCls || Jm, Be = r || m.csp;
  dp(Te, Be);
  const $e = xC(I, m.theme);
  process.env.NODE_ENV !== "production" && (vl = vl || !!$e);
  const pe = {
    csp: Be,
    autoInsertSpaceInButton: n,
    alert: o,
    anchor: a,
    locale: c || v,
    direction: d,
    space: u,
    virtual: f,
    popupMatchSelectWidth: g ?? h,
    popupOverflow: E,
    getPrefixCls: fe,
    iconPrefixCls: Te,
    theme: $e,
    segmented: C,
    statistic: S,
    spin: T,
    calendar: N,
    carousel: V,
    cascader: D,
    collapse: x,
    typography: O,
    checkbox: w,
    descriptions: j,
    divider: $,
    drawer: _,
    skeleton: A,
    steps: R,
    image: P,
    input: ce,
    layout: z,
    list: F,
    mentions: L,
    modal: M,
    progress: B,
    result: W,
    slider: ee,
    breadcrumb: te,
    menu: de,
    pagination: Z,
    empty: Y,
    badge: he,
    radio: ve,
    rate: ue,
    switch: le,
    transfer: Fe,
    avatar: He,
    message: We,
    tag: ie,
    table: ge,
    card: be,
    tabs: Ie,
    timeline: Pe,
    timePicker: Le,
    upload: Ve,
    notification: _e,
    tree: ut,
    colorPicker: Nt,
    datePicker: pt,
    rangePicker: Ge,
    flex: dt,
    wave: q,
    dropdown: H,
    warning: G,
    tour: ne
  }, X = Object.assign({}, m);
  Object.keys(pe).forEach((Qe) => {
    pe[Qe] !== void 0 && (X[Qe] = pe[Qe]);
  }), WC.forEach((Qe) => {
    const ht = e[Qe];
    ht && (X[Qe] = ht);
  });
  const re = Ul(() => X, X, (Qe, ht) => {
    const Ft = Object.keys(Qe), $t = Object.keys(ht);
    return Ft.length !== $t.length || Ft.some((Er) => Qe[Er] !== ht[Er]);
  }), ye = p.useMemo(() => ({
    prefixCls: Te,
    csp: Be
  }), [Te, Be]);
  let xe = /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(qC, {
    dropdownMatchSelectWidth: h
  }), t);
  const Ae = p.useMemo(() => {
    var Qe, ht, Ft, $t;
    return $o(((Qe = $n.Form) === null || Qe === void 0 ? void 0 : Qe.defaultValidateMessages) || {}, ((Ft = (ht = re.locale) === null || ht === void 0 ? void 0 : ht.Form) === null || Ft === void 0 ? void 0 : Ft.defaultValidateMessages) || {}, (($t = re.form) === null || $t === void 0 ? void 0 : $t.validateMessages) || {}, s?.validateMessages || {});
  }, [re, s?.validateMessages]);
  Object.keys(Ae).length > 0 && (xe = /* @__PURE__ */ p.createElement(Wm.Provider, {
    value: Ae
  }, xe)), c && (xe = /* @__PURE__ */ p.createElement(Ab, {
    locale: c,
    _ANT_MARK__: Km
  }, xe)), (Te || Be) && (xe = /* @__PURE__ */ p.createElement(Vl.Provider, {
    value: ye
  }, xe)), l && (xe = /* @__PURE__ */ p.createElement(Xb, {
    size: l
  }, xe)), xe = /* @__PURE__ */ p.createElement(UC, null, xe);
  const je = p.useMemo(() => {
    const Qe = $e || {}, {
      algorithm: ht,
      token: Ft,
      components: $t,
      cssVar: Er
    } = Qe, nn = HC(Qe, ["algorithm", "token", "components", "cssVar"]), Lt = ht && (!Array.isArray(ht) || ht.length > 0) ? tl(ht) : Xm, on = {};
    Object.entries($t || {}).forEach((zr) => {
      let [sn, U] = zr;
      const oe = Object.assign({}, U);
      "algorithm" in oe && (oe.algorithm === !0 ? oe.theme = Lt : (Array.isArray(oe.algorithm) || typeof oe.algorithm == "function") && (oe.theme = tl(oe.algorithm)), delete oe.algorithm), on[sn] = oe;
    });
    const an = Object.assign(Object.assign({}, La), Ft);
    return Object.assign(Object.assign({}, nn), {
      theme: Lt,
      token: an,
      components: on,
      override: Object.assign({
        override: an
      }, on),
      cssVar: Er
    });
  }, [$e]);
  return I && (xe = /* @__PURE__ */ p.createElement(Zm.Provider, {
    value: je
  }, xe)), re.warning && (xe = /* @__PURE__ */ p.createElement(Hm.Provider, {
    value: re.warning
  }, xe)), b !== void 0 && (xe = /* @__PURE__ */ p.createElement(ep, {
    disabled: b
  }, xe)), /* @__PURE__ */ p.createElement(Mt.Provider, {
    value: re
  }, xe);
}, na = (e) => {
  const t = p.useContext(Mt), r = p.useContext(Jl);
  return /* @__PURE__ */ p.createElement(XC, Object.assign({
    parentContext: t,
    legacyLocale: r
  }, e));
};
na.ConfigContext = Mt;
na.SizeContext = Xa;
na.config = QC;
na.useConfig = Zb;
Object.defineProperty(na, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && Is(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Xa)
});
process.env.NODE_ENV !== "production" && (na.displayName = "ConfigProvider");
const od = (e) => {
  const t = k.useContext(Xa);
  return k.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
};
function Jt() {
  Jt = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(A, R, P) {
    A[R] = P.value;
  }, a = typeof Symbol == "function" ? Symbol : {}, s = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", l = a.toStringTag || "@@toStringTag";
  function d(A, R, P) {
    return Object.defineProperty(A, R, {
      value: P,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[R];
  }
  try {
    d({}, "");
  } catch {
    d = function(P, z, F) {
      return P[z] = F;
    };
  }
  function u(A, R, P, z) {
    var F = R && R.prototype instanceof y ? R : y, L = Object.create(F.prototype), M = new $(z || []);
    return o(L, "_invoke", {
      value: x(A, P, M)
    }), L;
  }
  function f(A, R, P) {
    try {
      return {
        type: "normal",
        arg: A.call(R, P)
      };
    } catch (z) {
      return {
        type: "throw",
        arg: z
      };
    }
  }
  t.wrap = u;
  var h = "suspendedStart", g = "suspendedYield", E = "executing", v = "completed", m = {};
  function y() {
  }
  function I() {
  }
  function b() {
  }
  var C = {};
  d(C, s, function() {
    return this;
  });
  var S = Object.getPrototypeOf, T = S && S(S(_([])));
  T && T !== r && n.call(T, s) && (C = T);
  var N = b.prototype = y.prototype = Object.create(C);
  function V(A) {
    ["next", "throw", "return"].forEach(function(R) {
      d(A, R, function(P) {
        return this._invoke(R, P);
      });
    });
  }
  function D(A, R) {
    function P(F, L, M, B) {
      var W = f(A[F], A, L);
      if (W.type !== "throw") {
        var ee = W.arg, te = ee.value;
        return te && it(te) == "object" && n.call(te, "__await") ? R.resolve(te.__await).then(function(de) {
          P("next", de, M, B);
        }, function(de) {
          P("throw", de, M, B);
        }) : R.resolve(te).then(function(de) {
          ee.value = de, M(ee);
        }, function(de) {
          return P("throw", de, M, B);
        });
      }
      B(W.arg);
    }
    var z;
    o(this, "_invoke", {
      value: function(L, M) {
        function B() {
          return new R(function(W, ee) {
            P(L, M, W, ee);
          });
        }
        return z = z ? z.then(B, B) : B();
      }
    });
  }
  function x(A, R, P) {
    var z = h;
    return function(F, L) {
      if (z === E)
        throw new Error("Generator is already running");
      if (z === v) {
        if (F === "throw")
          throw L;
        return {
          value: e,
          done: !0
        };
      }
      for (P.method = F, P.arg = L; ; ) {
        var M = P.delegate;
        if (M) {
          var B = O(M, P);
          if (B) {
            if (B === m)
              continue;
            return B;
          }
        }
        if (P.method === "next")
          P.sent = P._sent = P.arg;
        else if (P.method === "throw") {
          if (z === h)
            throw z = v, P.arg;
          P.dispatchException(P.arg);
        } else
          P.method === "return" && P.abrupt("return", P.arg);
        z = E;
        var W = f(A, R, P);
        if (W.type === "normal") {
          if (z = P.done ? v : g, W.arg === m)
            continue;
          return {
            value: W.arg,
            done: P.done
          };
        }
        W.type === "throw" && (z = v, P.method = "throw", P.arg = W.arg);
      }
    };
  }
  function O(A, R) {
    var P = R.method, z = A.iterator[P];
    if (z === e)
      return R.delegate = null, P === "throw" && A.iterator.return && (R.method = "return", R.arg = e, O(A, R), R.method === "throw") || P !== "return" && (R.method = "throw", R.arg = new TypeError("The iterator does not provide a '" + P + "' method")), m;
    var F = f(z, A.iterator, R.arg);
    if (F.type === "throw")
      return R.method = "throw", R.arg = F.arg, R.delegate = null, m;
    var L = F.arg;
    return L ? L.done ? (R[A.resultName] = L.value, R.next = A.nextLoc, R.method !== "return" && (R.method = "next", R.arg = e), R.delegate = null, m) : L : (R.method = "throw", R.arg = new TypeError("iterator result is not an object"), R.delegate = null, m);
  }
  function w(A) {
    var R = {
      tryLoc: A[0]
    };
    1 in A && (R.catchLoc = A[1]), 2 in A && (R.finallyLoc = A[2], R.afterLoc = A[3]), this.tryEntries.push(R);
  }
  function j(A) {
    var R = A.completion || {};
    R.type = "normal", delete R.arg, A.completion = R;
  }
  function $(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(w, this), this.reset(!0);
  }
  function _(A) {
    if (A || A === "") {
      var R = A[s];
      if (R)
        return R.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var P = -1, z = function F() {
          for (; ++P < A.length; )
            if (n.call(A, P))
              return F.value = A[P], F.done = !1, F;
          return F.value = e, F.done = !0, F;
        };
        return z.next = z;
      }
    }
    throw new TypeError(it(A) + " is not iterable");
  }
  return I.prototype = b, o(N, "constructor", {
    value: b,
    configurable: !0
  }), o(b, "constructor", {
    value: I,
    configurable: !0
  }), I.displayName = d(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var R = typeof A == "function" && A.constructor;
    return !!R && (R === I || (R.displayName || R.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, b) : (A.__proto__ = b, d(A, l, "GeneratorFunction")), A.prototype = Object.create(N), A;
  }, t.awrap = function(A) {
    return {
      __await: A
    };
  }, V(D.prototype), d(D.prototype, c, function() {
    return this;
  }), t.AsyncIterator = D, t.async = function(A, R, P, z, F) {
    F === void 0 && (F = Promise);
    var L = new D(u(A, R, P, z), F);
    return t.isGeneratorFunction(R) ? L : L.next().then(function(M) {
      return M.done ? M.value : L.next();
    });
  }, V(N), d(N, l, "Generator"), d(N, s, function() {
    return this;
  }), d(N, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var R = Object(A), P = [];
    for (var z in R)
      P.push(z);
    return P.reverse(), function F() {
      for (; P.length; ) {
        var L = P.pop();
        if (L in R)
          return F.value = L, F.done = !1, F;
      }
      return F.done = !0, F;
    };
  }, t.values = _, $.prototype = {
    constructor: $,
    reset: function(R) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(j), !R)
        for (var P in this)
          P.charAt(0) === "t" && n.call(this, P) && !isNaN(+P.slice(1)) && (this[P] = e);
    },
    stop: function() {
      this.done = !0;
      var R = this.tryEntries[0].completion;
      if (R.type === "throw")
        throw R.arg;
      return this.rval;
    },
    dispatchException: function(R) {
      if (this.done)
        throw R;
      var P = this;
      function z(ee, te) {
        return M.type = "throw", M.arg = R, P.next = ee, te && (P.method = "next", P.arg = e), !!te;
      }
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var L = this.tryEntries[F], M = L.completion;
        if (L.tryLoc === "root")
          return z("end");
        if (L.tryLoc <= this.prev) {
          var B = n.call(L, "catchLoc"), W = n.call(L, "finallyLoc");
          if (B && W) {
            if (this.prev < L.catchLoc)
              return z(L.catchLoc, !0);
            if (this.prev < L.finallyLoc)
              return z(L.finallyLoc);
          } else if (B) {
            if (this.prev < L.catchLoc)
              return z(L.catchLoc, !0);
          } else {
            if (!W)
              throw new Error("try statement without catch or finally");
            if (this.prev < L.finallyLoc)
              return z(L.finallyLoc);
          }
        }
      }
    },
    abrupt: function(R, P) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var F = this.tryEntries[z];
        if (F.tryLoc <= this.prev && n.call(F, "finallyLoc") && this.prev < F.finallyLoc) {
          var L = F;
          break;
        }
      }
      L && (R === "break" || R === "continue") && L.tryLoc <= P && P <= L.finallyLoc && (L = null);
      var M = L ? L.completion : {};
      return M.type = R, M.arg = P, L ? (this.method = "next", this.next = L.finallyLoc, m) : this.complete(M);
    },
    complete: function(R, P) {
      if (R.type === "throw")
        throw R.arg;
      return R.type === "break" || R.type === "continue" ? this.next = R.arg : R.type === "return" ? (this.rval = this.arg = R.arg, this.method = "return", this.next = "end") : R.type === "normal" && P && (this.next = P), m;
    },
    finish: function(R) {
      for (var P = this.tryEntries.length - 1; P >= 0; --P) {
        var z = this.tryEntries[P];
        if (z.finallyLoc === R)
          return this.complete(z.completion, z.afterLoc), j(z), m;
      }
    },
    catch: function(R) {
      for (var P = this.tryEntries.length - 1; P >= 0; --P) {
        var z = this.tryEntries[P];
        if (z.tryLoc === R) {
          var F = z.completion;
          if (F.type === "throw") {
            var L = F.arg;
            j(z);
          }
          return L;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(R, P, z) {
      return this.delegate = {
        iterator: _(R),
        resultName: P,
        nextLoc: z
      }, this.method === "next" && (this.arg = e), m;
    }
  }, t;
}
function hu(e, t, r, n, o, a, s) {
  try {
    var c = e[a](s), l = c.value;
  } catch (d) {
    r(d);
    return;
  }
  c.done ? t(l) : Promise.resolve(l).then(n, o);
}
function kn(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, o) {
      var a = e.apply(t, r);
      function s(l) {
        hu(a, n, o, s, c, "next", l);
      }
      function c(l) {
        hu(a, n, o, s, c, "throw", l);
      }
      s(void 0);
    });
  };
}
var no = "RC_FORM_INTERNAL_HOOKS", St = function() {
  Tt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, uo = /* @__PURE__ */ p.createContext({
  getFieldValue: St,
  getFieldsValue: St,
  getFieldError: St,
  getFieldWarning: St,
  getFieldsError: St,
  isFieldsTouched: St,
  isFieldTouched: St,
  isFieldValidating: St,
  isFieldsValidating: St,
  resetFields: St,
  setFields: St,
  setFieldValue: St,
  setFieldsValue: St,
  validateFields: St,
  submit: St,
  getInternalHooks: function() {
    return St(), {
      dispatch: St,
      initEntityValue: St,
      registerField: St,
      useSubscribe: St,
      setInitialValues: St,
      destroyForm: St,
      setCallbacks: St,
      registerWatch: St,
      getFields: St,
      setValidateMessages: St,
      setPreserve: St,
      getInitialValue: St
    };
  }
}), Va = /* @__PURE__ */ p.createContext(null);
function yl(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function ZC(e) {
  return e && !!e._init;
}
function oo() {
  return oo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, oo.apply(this, arguments);
}
function JC(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, za(e, t);
}
function bl(e) {
  return bl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, bl(e);
}
function za(e, t) {
  return za = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, za(e, t);
}
function eI() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hi(e, t, r) {
  return eI() ? Hi = Reflect.construct.bind() : Hi = function(o, a, s) {
    var c = [null];
    c.push.apply(c, a);
    var l = Function.bind.apply(o, c), d = new l();
    return s && za(d, s.prototype), d;
  }, Hi.apply(null, arguments);
}
function tI(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Cl(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Cl = function(n) {
    if (n === null || !tI(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, o);
    }
    function o() {
      return Hi(n, arguments, bl(this).constructor);
    }
    return o.prototype = Object.create(n.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), za(o, n);
  }, Cl(e);
}
var rI = /%[sdj%]/g, Tp = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (Tp = function(t, r) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && r.every(function(n) {
    return typeof n == "string";
  }) && console.warn(t, r);
});
function Il(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function br(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var o = 0, a = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var s = e.replace(rI, function(c) {
      if (c === "%%")
        return "%";
      if (o >= a)
        return c;
      switch (c) {
        case "%s":
          return String(r[o++]);
        case "%d":
          return Number(r[o++]);
        case "%j":
          try {
            return JSON.stringify(r[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return c;
      }
    });
    return s;
  }
  return e;
}
function nI(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Gt(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || nI(t) && typeof e == "string" && !e);
}
function oI(e, t, r) {
  var n = [], o = 0, a = e.length;
  function s(c) {
    n.push.apply(n, c || []), o++, o === a && r(n);
  }
  e.forEach(function(c) {
    t(c, s);
  });
}
function gu(e, t, r) {
  var n = 0, o = e.length;
  function a(s) {
    if (s && s.length) {
      r(s);
      return;
    }
    var c = n;
    n = n + 1, c < o ? t(e[c], a) : r([]);
  }
  a([]);
}
function aI(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, e[r] || []);
  }), t;
}
var vu = /* @__PURE__ */ function(e) {
  JC(t, e);
  function t(r, n) {
    var o;
    return o = e.call(this, "Async Validation Error") || this, o.errors = r, o.fields = n, o;
  }
  return t;
}(/* @__PURE__ */ Cl(Error));
function iI(e, t, r, n, o) {
  if (t.first) {
    var a = new Promise(function(h, g) {
      var E = function(y) {
        return n(y), y.length ? g(new vu(y, Il(y))) : h(o);
      }, v = aI(e);
      gu(v, r, E);
    });
    return a.catch(function(h) {
      return h;
    }), a;
  }
  var s = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], c = Object.keys(e), l = c.length, d = 0, u = [], f = new Promise(function(h, g) {
    var E = function(m) {
      if (u.push.apply(u, m), d++, d === l)
        return n(u), u.length ? g(new vu(u, Il(u))) : h(o);
    };
    c.length || (n(u), h(o)), c.forEach(function(v) {
      var m = e[v];
      s.indexOf(v) !== -1 ? gu(m, r, E) : oI(m, r, E);
    });
  });
  return f.catch(function(h) {
    return h;
  }), f;
}
function sI(e) {
  return !!(e && e.message !== void 0);
}
function cI(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function yu(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = cI(t, e.fullFields) : n = t[r.field || e.fullField], sI(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function bu(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        typeof n == "object" && typeof e[r] == "object" ? e[r] = oo({}, e[r], n) : e[r] = n;
      }
  }
  return e;
}
var Fp = function(t, r, n, o, a, s) {
  t.required && (!n.hasOwnProperty(t.field) || Gt(r, s || t.type)) && o.push(br(a.messages.required, t.fullField));
}, lI = function(t, r, n, o, a) {
  (/^\s+$/.test(r) || r === "") && o.push(br(a.messages.whitespace, t.fullField));
}, Oi, dI = function() {
  if (Oi)
    return Oi;
  var e = "[a-fA-F\\d:]", t = function(C) {
    return C && C.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", o = (`
(?:
(?:` + n + ":){7}(?:" + n + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + n + ":){6}(?:" + r + "|:" + n + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + n + ":){5}(?::" + r + "|(?::" + n + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + n + ":){4}(?:(?::" + n + "){0,1}:" + r + "|(?::" + n + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + n + ":){3}(?:(?::" + n + "){0,2}:" + r + "|(?::" + n + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + n + ":){2}(?:(?::" + n + "){0,3}:" + r + "|(?::" + n + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + n + ":){1}(?:(?::" + n + "){0,4}:" + r + "|(?::" + n + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + n + "){0,5}:" + r + "|(?::" + n + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), a = new RegExp("(?:^" + r + "$)|(?:^" + o + "$)"), s = new RegExp("^" + r + "$"), c = new RegExp("^" + o + "$"), l = function(C) {
    return C && C.exact ? a : new RegExp("(?:" + t(C) + r + t(C) + ")|(?:" + t(C) + o + t(C) + ")", "g");
  };
  l.v4 = function(b) {
    return b && b.exact ? s : new RegExp("" + t(b) + r + t(b), "g");
  }, l.v6 = function(b) {
    return b && b.exact ? c : new RegExp("" + t(b) + o + t(b), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", u = "(?:\\S+(?::\\S*)?@)?", f = l.v4().source, h = l.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", E = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", v = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", y = '(?:[/?#][^\\s"]*)?', I = "(?:" + d + "|www\\.)" + u + "(?:localhost|" + f + "|" + h + "|" + g + E + v + ")" + m + y;
  return Oi = new RegExp("(?:^" + I + "$)", "i"), Oi;
}, Cu = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, xa = {
  integer: function(t) {
    return xa.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return xa.number(t) && !xa.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !xa.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(Cu.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(dI());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(Cu.hex);
  }
}, uI = function(t, r, n, o, a) {
  if (t.required && r === void 0) {
    Fp(t, r, n, o, a);
    return;
  }
  var s = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], c = t.type;
  s.indexOf(c) > -1 ? xa[c](r) || o.push(br(a.messages.types[c], t.fullField, t.type)) : c && typeof r !== t.type && o.push(br(a.messages.types[c], t.fullField, t.type));
}, fI = function(t, r, n, o, a) {
  var s = typeof t.len == "number", c = typeof t.min == "number", l = typeof t.max == "number", d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = r, f = null, h = typeof r == "number", g = typeof r == "string", E = Array.isArray(r);
  if (h ? f = "number" : g ? f = "string" : E && (f = "array"), !f)
    return !1;
  E && (u = r.length), g && (u = r.replace(d, "_").length), s ? u !== t.len && o.push(br(a.messages[f].len, t.fullField, t.len)) : c && !l && u < t.min ? o.push(br(a.messages[f].min, t.fullField, t.min)) : l && !c && u > t.max ? o.push(br(a.messages[f].max, t.fullField, t.max)) : c && l && (u < t.min || u > t.max) && o.push(br(a.messages[f].range, t.fullField, t.min, t.max));
}, wo = "enum", mI = function(t, r, n, o, a) {
  t[wo] = Array.isArray(t[wo]) ? t[wo] : [], t[wo].indexOf(r) === -1 && o.push(br(a.messages[wo], t.fullField, t[wo].join(", ")));
}, pI = function(t, r, n, o, a) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || o.push(br(a.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var s = new RegExp(t.pattern);
      s.test(r) || o.push(br(a.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, ft = {
  required: Fp,
  whitespace: lI,
  type: uI,
  range: fI,
  enum: mI,
  pattern: pI
}, hI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r, "string") && !t.required)
      return n();
    ft.required(t, r, o, s, a, "string"), Gt(r, "string") || (ft.type(t, r, o, s, a), ft.range(t, r, o, s, a), ft.pattern(t, r, o, s, a), t.whitespace === !0 && ft.whitespace(t, r, o, s, a));
  }
  n(s);
}, gI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && ft.type(t, r, o, s, a);
  }
  n(s);
}, vI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (r === "" && (r = void 0), Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && (ft.type(t, r, o, s, a), ft.range(t, r, o, s, a));
  }
  n(s);
}, yI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && ft.type(t, r, o, s, a);
  }
  n(s);
}, bI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), Gt(r) || ft.type(t, r, o, s, a);
  }
  n(s);
}, CI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && (ft.type(t, r, o, s, a), ft.range(t, r, o, s, a));
  }
  n(s);
}, II = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && (ft.type(t, r, o, s, a), ft.range(t, r, o, s, a));
  }
  n(s);
}, xI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (r == null && !t.required)
      return n();
    ft.required(t, r, o, s, a, "array"), r != null && (ft.type(t, r, o, s, a), ft.range(t, r, o, s, a));
  }
  n(s);
}, SI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && ft.type(t, r, o, s, a);
  }
  n(s);
}, EI = "enum", DI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a), r !== void 0 && ft[EI](t, r, o, s, a);
  }
  n(s);
}, wI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r, "string") && !t.required)
      return n();
    ft.required(t, r, o, s, a), Gt(r, "string") || ft.pattern(t, r, o, s, a);
  }
  n(s);
}, TI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r, "date") && !t.required)
      return n();
    if (ft.required(t, r, o, s, a), !Gt(r, "date")) {
      var l;
      r instanceof Date ? l = r : l = new Date(r), ft.type(t, l, o, s, a), l && ft.range(t, l.getTime(), o, s, a);
    }
  }
  n(s);
}, FI = function(t, r, n, o, a) {
  var s = [], c = Array.isArray(r) ? "array" : typeof r;
  ft.required(t, r, o, s, a, c), n(s);
}, yc = function(t, r, n, o, a) {
  var s = t.type, c = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Gt(r, s) && !t.required)
      return n();
    ft.required(t, r, o, c, a, s), Gt(r, s) || ft.type(t, r, o, c, a);
  }
  n(c);
}, OI = function(t, r, n, o, a) {
  var s = [], c = t.required || !t.required && o.hasOwnProperty(t.field);
  if (c) {
    if (Gt(r) && !t.required)
      return n();
    ft.required(t, r, o, s, a);
  }
  n(s);
}, Ra = {
  string: hI,
  method: gI,
  number: vI,
  boolean: yI,
  regexp: bI,
  integer: CI,
  float: II,
  array: xI,
  object: SI,
  enum: DI,
  pattern: wI,
  date: TI,
  url: yc,
  hex: yc,
  email: yc,
  required: FI,
  any: OI
};
function xl() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var Sl = xl(), Za = /* @__PURE__ */ function() {
  function e(r) {
    this.rules = null, this._messages = Sl, this.define(r);
  }
  var t = e.prototype;
  return t.define = function(n) {
    var o = this;
    if (!n)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof n != "object" || Array.isArray(n))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(n).forEach(function(a) {
      var s = n[a];
      o.rules[a] = Array.isArray(s) ? s : [s];
    });
  }, t.messages = function(n) {
    return n && (this._messages = bu(xl(), n)), this._messages;
  }, t.validate = function(n, o, a) {
    var s = this;
    o === void 0 && (o = {}), a === void 0 && (a = function() {
    });
    var c = n, l = o, d = a;
    if (typeof l == "function" && (d = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return d && d(null, c), Promise.resolve(c);
    function u(v) {
      var m = [], y = {};
      function I(C) {
        if (Array.isArray(C)) {
          var S;
          m = (S = m).concat.apply(S, C);
        } else
          m.push(C);
      }
      for (var b = 0; b < v.length; b++)
        I(v[b]);
      m.length ? (y = Il(m), d(m, y)) : d(null, c);
    }
    if (l.messages) {
      var f = this.messages();
      f === Sl && (f = xl()), bu(f, l.messages), l.messages = f;
    } else
      l.messages = this.messages();
    var h = {}, g = l.keys || Object.keys(this.rules);
    g.forEach(function(v) {
      var m = s.rules[v], y = c[v];
      m.forEach(function(I) {
        var b = I;
        typeof b.transform == "function" && (c === n && (c = oo({}, c)), y = c[v] = b.transform(y)), typeof b == "function" ? b = {
          validator: b
        } : b = oo({}, b), b.validator = s.getValidationMethod(b), b.validator && (b.field = v, b.fullField = b.fullField || v, b.type = s.getType(b), h[v] = h[v] || [], h[v].push({
          rule: b,
          value: y,
          source: c,
          field: v
        }));
      });
    });
    var E = {};
    return iI(h, l, function(v, m) {
      var y = v.rule, I = (y.type === "object" || y.type === "array") && (typeof y.fields == "object" || typeof y.defaultField == "object");
      I = I && (y.required || !y.required && v.value), y.field = v.field;
      function b(T, N) {
        return oo({}, N, {
          fullField: y.fullField + "." + T,
          fullFields: y.fullFields ? [].concat(y.fullFields, [T]) : [T]
        });
      }
      function C(T) {
        T === void 0 && (T = []);
        var N = Array.isArray(T) ? T : [T];
        !l.suppressWarning && N.length && e.warning("async-validator:", N), N.length && y.message !== void 0 && (N = [].concat(y.message));
        var V = N.map(yu(y, c));
        if (l.first && V.length)
          return E[y.field] = 1, m(V);
        if (!I)
          m(V);
        else {
          if (y.required && !v.value)
            return y.message !== void 0 ? V = [].concat(y.message).map(yu(y, c)) : l.error && (V = [l.error(y, br(l.messages.required, y.field))]), m(V);
          var D = {};
          y.defaultField && Object.keys(v.value).map(function(w) {
            D[w] = y.defaultField;
          }), D = oo({}, D, v.rule.fields);
          var x = {};
          Object.keys(D).forEach(function(w) {
            var j = D[w], $ = Array.isArray(j) ? j : [j];
            x[w] = $.map(b.bind(null, w));
          });
          var O = new e(x);
          O.messages(l.messages), v.rule.options && (v.rule.options.messages = l.messages, v.rule.options.error = l.error), O.validate(v.value, v.rule.options || l, function(w) {
            var j = [];
            V && V.length && j.push.apply(j, V), w && w.length && j.push.apply(j, w), m(j.length ? j : null);
          });
        }
      }
      var S;
      if (y.asyncValidator)
        S = y.asyncValidator(y, v.value, C, v.source, l);
      else if (y.validator) {
        try {
          S = y.validator(y, v.value, C, v.source, l);
        } catch (T) {
          console.error?.(T), l.suppressValidatorError || setTimeout(function() {
            throw T;
          }, 0), C(T.message);
        }
        S === !0 ? C() : S === !1 ? C(typeof y.message == "function" ? y.message(y.fullField || y.field) : y.message || (y.fullField || y.field) + " fails") : S instanceof Array ? C(S) : S instanceof Error && C(S.message);
      }
      S && S.then && S.then(function() {
        return C();
      }, function(T) {
        return C(T);
      });
    }, function(v) {
      u(v);
    }, c);
  }, t.getType = function(n) {
    if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !Ra.hasOwnProperty(n.type))
      throw new Error(br("Unknown rule type %s", n.type));
    return n.type || "string";
  }, t.getValidationMethod = function(n) {
    if (typeof n.validator == "function")
      return n.validator;
    var o = Object.keys(n), a = o.indexOf("message");
    return a !== -1 && o.splice(a, 1), o.length === 1 && o[0] === "required" ? Ra.required : Ra[this.getType(n)] || void 0;
  }, e;
}();
Za.register = function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  Ra[t] = r;
};
Za.warning = Tp;
Za.messages = Sl;
Za.validators = Ra;
var gr = "'${name}' is not a valid ${type}", Op = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: gr,
    method: gr,
    array: gr,
    object: gr,
    number: gr,
    date: gr,
    boolean: gr,
    integer: gr,
    float: gr,
    regexp: gr,
    email: gr,
    url: gr,
    hex: gr
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, Iu = Za;
function NI(e, t) {
  return e.replace(/\$\{\w+\}/g, function(r) {
    var n = r.slice(2, -1);
    return t[n];
  });
}
var xu = "CODE_LOGIC_ERROR";
function El(e, t, r, n, o) {
  return Dl.apply(this, arguments);
}
function Dl() {
  return Dl = kn(/* @__PURE__ */ Jt().mark(function e(t, r, n, o, a) {
    var s, c, l, d, u, f, h, g, E;
    return Jt().wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            return s = ae({}, n), delete s.ruleIndex, Iu.warning = function() {
            }, s.validator && (c = s.validator, s.validator = function() {
              try {
                return c.apply(void 0, arguments);
              } catch (y) {
                return console.error(y), Promise.reject(xu);
              }
            }), l = null, s && s.type === "array" && s.defaultField && (l = s.defaultField, delete s.defaultField), d = new Iu(Q({}, t, [s])), u = $o(Op, o.validateMessages), d.messages(u), f = [], m.prev = 10, m.next = 13, Promise.resolve(d.validate(Q({}, t, r), ae({}, o)));
          case 13:
            m.next = 18;
            break;
          case 15:
            m.prev = 15, m.t0 = m.catch(10), m.t0.errors && (f = m.t0.errors.map(function(y, I) {
              var b = y.message, C = b === xu ? u.default : b;
              return /* @__PURE__ */ p.isValidElement(C) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ p.cloneElement(C, {
                  key: "error_".concat(I)
                })
              ) : C;
            }));
          case 18:
            if (!(!f.length && l)) {
              m.next = 23;
              break;
            }
            return m.next = 21, Promise.all(r.map(function(y, I) {
              return El("".concat(t, ".").concat(I), y, l, o, a);
            }));
          case 21:
            return h = m.sent, m.abrupt("return", h.reduce(function(y, I) {
              return [].concat(Ne(y), Ne(I));
            }, []));
          case 23:
            return g = ae(ae({}, n), {}, {
              name: t,
              enum: (n.enum || []).join(", ")
            }, a), E = f.map(function(y) {
              return typeof y == "string" ? NI(y, g) : y;
            }), m.abrupt("return", E);
          case 26:
          case "end":
            return m.stop();
        }
    }, e, null, [[10, 15]]);
  })), Dl.apply(this, arguments);
}
function RI(e, t, r, n, o, a) {
  var s = e.join("."), c = r.map(function(u, f) {
    var h = u.validator, g = ae(ae({}, u), {}, {
      ruleIndex: f
    });
    return h && (g.validator = function(E, v, m) {
      var y = !1, I = function() {
        for (var S = arguments.length, T = new Array(S), N = 0; N < S; N++)
          T[N] = arguments[N];
        Promise.resolve().then(function() {
          Tt(!y, "Your validator function has already return a promise. `callback` will be ignored."), y || m.apply(void 0, T);
        });
      }, b = h(E, v, I);
      y = b && typeof b.then == "function" && typeof b.catch == "function", Tt(y, "`callback` is deprecated. Please return a promise instead."), y && b.then(function() {
        m();
      }).catch(function(C) {
        m(C || " ");
      });
    }), g;
  }).sort(function(u, f) {
    var h = u.warningOnly, g = u.ruleIndex, E = f.warningOnly, v = f.ruleIndex;
    return !!h == !!E ? g - v : h ? 1 : -1;
  }), l;
  if (o === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var u = kn(/* @__PURE__ */ Jt().mark(function f(h, g) {
        var E, v, m;
        return Jt().wrap(function(I) {
          for (; ; )
            switch (I.prev = I.next) {
              case 0:
                E = 0;
              case 1:
                if (!(E < c.length)) {
                  I.next = 12;
                  break;
                }
                return v = c[E], I.next = 5, El(s, t, v, n, a);
              case 5:
                if (m = I.sent, !m.length) {
                  I.next = 9;
                  break;
                }
                return g([{
                  errors: m,
                  rule: v
                }]), I.abrupt("return");
              case 9:
                E += 1, I.next = 1;
                break;
              case 12:
                h([]);
              case 13:
              case "end":
                return I.stop();
            }
        }, f);
      }));
      return function(f, h) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var d = c.map(function(u) {
      return El(s, t, u, n, a).then(function(f) {
        return {
          errors: f,
          rule: u
        };
      });
    });
    l = (o ? jI(d) : PI(d)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return l.catch(function(u) {
    return u;
  }), l;
}
function PI(e) {
  return wl.apply(this, arguments);
}
function wl() {
  return wl = kn(/* @__PURE__ */ Jt().mark(function e(t) {
    return Jt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.all(t).then(function(o) {
              var a, s = (a = []).concat.apply(a, Ne(o));
              return s;
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), wl.apply(this, arguments);
}
function jI(e) {
  return Tl.apply(this, arguments);
}
function Tl() {
  return Tl = kn(/* @__PURE__ */ Jt().mark(function e(t) {
    var r;
    return Jt().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return r = 0, o.abrupt("return", new Promise(function(a) {
              t.forEach(function(s) {
                s.then(function(c) {
                  c.errors.length && a([c]), r += 1, r === t.length && a([]);
                });
              });
            }));
          case 2:
          case "end":
            return o.stop();
        }
    }, e);
  })), Tl.apply(this, arguments);
}
function At(e) {
  return yl(e);
}
function Su(e, t) {
  var r = {};
  return t.forEach(function(n) {
    var o = qr(e, n);
    r = jr(r, n, o);
  }), r;
}
function Lo(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(n) {
    return Np(t, n, r);
  });
}
function Np(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !r && e.length !== t.length ? !1 : t.every(function(n, o) {
    return e[o] === n;
  });
}
function $I(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || it(e) !== "object" || it(t) !== "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), o = new Set([].concat(r, n));
  return Ne(o).every(function(a) {
    var s = e[a], c = t[a];
    return typeof s == "function" && typeof c == "function" ? !0 : s === c;
  });
}
function AI(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && it(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function Eu(e, t, r) {
  var n = e.length;
  if (t < 0 || t >= n || r < 0 || r >= n)
    return e;
  var o = e[t], a = t - r;
  return a > 0 ? [].concat(Ne(e.slice(0, r)), [o], Ne(e.slice(r, t)), Ne(e.slice(t + 1, n))) : a < 0 ? [].concat(Ne(e.slice(0, t)), Ne(e.slice(t + 1, r + 1)), [o], Ne(e.slice(r + 1, n))) : e;
}
var _I = ["name"], Tr = [];
function Du(e, t, r, n, o, a) {
  return typeof e == "function" ? e(t, r, "source" in a ? {
    source: a.source
  } : {}) : n !== o;
}
var ad = /* @__PURE__ */ function(e) {
  zn(r, e);
  var t = ea(r);
  function r(n) {
    var o;
    if (lr(this, r), o = t.call(this, n), Q(Ze(o), "state", {
      resetCount: 0
    }), Q(Ze(o), "cancelRegisterFunc", null), Q(Ze(o), "mounted", !1), Q(Ze(o), "touched", !1), Q(Ze(o), "dirty", !1), Q(Ze(o), "validatePromise", void 0), Q(Ze(o), "prevValidating", void 0), Q(Ze(o), "errors", Tr), Q(Ze(o), "warnings", Tr), Q(Ze(o), "cancelRegister", function() {
      var l = o.props, d = l.preserve, u = l.isListField, f = l.name;
      o.cancelRegisterFunc && o.cancelRegisterFunc(u, d, At(f)), o.cancelRegisterFunc = null;
    }), Q(Ze(o), "getNamePath", function() {
      var l = o.props, d = l.name, u = l.fieldContext, f = u.prefixName, h = f === void 0 ? [] : f;
      return d !== void 0 ? [].concat(Ne(h), Ne(d)) : [];
    }), Q(Ze(o), "getRules", function() {
      var l = o.props, d = l.rules, u = d === void 0 ? [] : d, f = l.fieldContext;
      return u.map(function(h) {
        return typeof h == "function" ? h(f) : h;
      });
    }), Q(Ze(o), "refresh", function() {
      o.mounted && o.setState(function(l) {
        var d = l.resetCount;
        return {
          resetCount: d + 1
        };
      });
    }), Q(Ze(o), "metaCache", null), Q(Ze(o), "triggerMetaEvent", function(l) {
      var d = o.props.onMetaChange;
      if (d) {
        var u = ae(ae({}, o.getMeta()), {}, {
          destroy: l
        });
        Sm(o.metaCache, u) || d(u), o.metaCache = u;
      } else
        o.metaCache = null;
    }), Q(Ze(o), "onStoreChange", function(l, d, u) {
      var f = o.props, h = f.shouldUpdate, g = f.dependencies, E = g === void 0 ? [] : g, v = f.onReset, m = u.store, y = o.getNamePath(), I = o.getValue(l), b = o.getValue(m), C = d && Lo(d, y);
      switch (u.type === "valueUpdate" && u.source === "external" && I !== b && (o.touched = !0, o.dirty = !0, o.validatePromise = null, o.errors = Tr, o.warnings = Tr, o.triggerMetaEvent()), u.type) {
        case "reset":
          if (!d || C) {
            o.touched = !1, o.dirty = !1, o.validatePromise = void 0, o.errors = Tr, o.warnings = Tr, o.triggerMetaEvent(), v?.(), o.refresh();
            return;
          }
          break;
        case "remove": {
          if (h) {
            o.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var S = u.data;
          if (C) {
            "touched" in S && (o.touched = S.touched), "validating" in S && !("originRCField" in S) && (o.validatePromise = S.validating ? Promise.resolve([]) : null), "errors" in S && (o.errors = S.errors || Tr), "warnings" in S && (o.warnings = S.warnings || Tr), o.dirty = !0, o.triggerMetaEvent(), o.reRender();
            return;
          } else if ("value" in S && Lo(d, y, !0)) {
            o.reRender();
            return;
          }
          if (h && !y.length && Du(h, l, m, I, b, u)) {
            o.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var T = E.map(At);
          if (T.some(function(N) {
            return Lo(u.relatedFields, N);
          })) {
            o.reRender();
            return;
          }
          break;
        }
        default:
          if (C || (!E.length || y.length || h) && Du(h, l, m, I, b, u)) {
            o.reRender();
            return;
          }
          break;
      }
      h === !0 && o.reRender();
    }), Q(Ze(o), "validateRules", function(l) {
      var d = o.getNamePath(), u = o.getValue(), f = l || {}, h = f.triggerName, g = f.validateOnly, E = g === void 0 ? !1 : g, v = Promise.resolve().then(/* @__PURE__ */ kn(/* @__PURE__ */ Jt().mark(function m() {
        var y, I, b, C, S, T, N;
        return Jt().wrap(function(D) {
          for (; ; )
            switch (D.prev = D.next) {
              case 0:
                if (o.mounted) {
                  D.next = 2;
                  break;
                }
                return D.abrupt("return", []);
              case 2:
                if (y = o.props, I = y.validateFirst, b = I === void 0 ? !1 : I, C = y.messageVariables, S = y.validateDebounce, T = o.getRules(), h && (T = T.filter(function(x) {
                  return x;
                }).filter(function(x) {
                  var O = x.validateTrigger;
                  if (!O)
                    return !0;
                  var w = yl(O);
                  return w.includes(h);
                })), !(S && h)) {
                  D.next = 10;
                  break;
                }
                return D.next = 8, new Promise(function(x) {
                  setTimeout(x, S);
                });
              case 8:
                if (o.validatePromise === v) {
                  D.next = 10;
                  break;
                }
                return D.abrupt("return", []);
              case 10:
                return N = RI(d, u, T, l, b, C), N.catch(function(x) {
                  return x;
                }).then(function() {
                  var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Tr;
                  if (o.validatePromise === v) {
                    var O;
                    o.validatePromise = null;
                    var w = [], j = [];
                    (O = x.forEach) === null || O === void 0 || O.call(x, function($) {
                      var _ = $.rule.warningOnly, A = $.errors, R = A === void 0 ? Tr : A;
                      _ ? j.push.apply(j, Ne(R)) : w.push.apply(w, Ne(R));
                    }), o.errors = w, o.warnings = j, o.triggerMetaEvent(), o.reRender();
                  }
                }), D.abrupt("return", N);
              case 13:
              case "end":
                return D.stop();
            }
        }, m);
      })));
      return E || (o.validatePromise = v, o.dirty = !0, o.errors = Tr, o.warnings = Tr, o.triggerMetaEvent(), o.reRender()), v;
    }), Q(Ze(o), "isFieldValidating", function() {
      return !!o.validatePromise;
    }), Q(Ze(o), "isFieldTouched", function() {
      return o.touched;
    }), Q(Ze(o), "isFieldDirty", function() {
      if (o.dirty || o.props.initialValue !== void 0)
        return !0;
      var l = o.props.fieldContext, d = l.getInternalHooks(no), u = d.getInitialValue;
      return u(o.getNamePath()) !== void 0;
    }), Q(Ze(o), "getErrors", function() {
      return o.errors;
    }), Q(Ze(o), "getWarnings", function() {
      return o.warnings;
    }), Q(Ze(o), "isListField", function() {
      return o.props.isListField;
    }), Q(Ze(o), "isList", function() {
      return o.props.isList;
    }), Q(Ze(o), "isPreserve", function() {
      return o.props.preserve;
    }), Q(Ze(o), "getMeta", function() {
      o.prevValidating = o.isFieldValidating();
      var l = {
        touched: o.isFieldTouched(),
        validating: o.prevValidating,
        errors: o.errors,
        warnings: o.warnings,
        name: o.getNamePath(),
        validated: o.validatePromise === null
      };
      return l;
    }), Q(Ze(o), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var d = o.getMeta();
        return ae(ae({}, o.getOnlyChild(l(o.getControlled(), d, o.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = lo(l);
      return u.length !== 1 || !/* @__PURE__ */ p.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), Q(Ze(o), "getValue", function(l) {
      var d = o.props.fieldContext.getFieldsValue, u = o.getNamePath();
      return qr(l || d(!0), u);
    }), Q(Ze(o), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = o.props, u = d.trigger, f = d.validateTrigger, h = d.getValueFromEvent, g = d.normalize, E = d.valuePropName, v = d.getValueProps, m = d.fieldContext, y = f !== void 0 ? f : m.validateTrigger, I = o.getNamePath(), b = m.getInternalHooks, C = m.getFieldsValue, S = b(no), T = S.dispatch, N = o.getValue(), V = v || function(w) {
        return Q({}, E, w);
      }, D = l[u], x = ae(ae({}, l), V(N));
      x[u] = function() {
        o.touched = !0, o.dirty = !0, o.triggerMetaEvent();
        for (var w, j = arguments.length, $ = new Array(j), _ = 0; _ < j; _++)
          $[_] = arguments[_];
        h ? w = h.apply(void 0, $) : w = AI.apply(void 0, [E].concat($)), g && (w = g(w, N, C(!0))), T({
          type: "updateValue",
          namePath: I,
          value: w
        }), D && D.apply(void 0, $);
      };
      var O = yl(y || []);
      return O.forEach(function(w) {
        var j = x[w];
        x[w] = function() {
          j && j.apply(void 0, arguments);
          var $ = o.props.rules;
          $ && $.length && T({
            type: "validateField",
            namePath: I,
            triggerName: w
          });
        };
      }), x;
    }), n.fieldContext) {
      var a = n.fieldContext.getInternalHooks, s = a(no), c = s.initEntityValue;
      c(Ze(o));
    }
    return o;
  }
  return dr(r, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, a = o.shouldUpdate, s = o.fieldContext;
      if (this.mounted = !0, s) {
        var c = s.getInternalHooks, l = c(no), d = l.registerField;
        this.cancelRegisterFunc = d(this);
      }
      a === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state.resetCount, a = this.props.children, s = this.getOnlyChild(a), c = s.child, l = s.isFunction, d;
      return l ? d = c : /* @__PURE__ */ p.isValidElement(c) ? d = /* @__PURE__ */ p.cloneElement(c, this.getControlled(c.props)) : (Tt(!c, "`children` of Field is not validate ReactElement."), d = c), /* @__PURE__ */ p.createElement(p.Fragment, {
        key: o
      }, d);
    }
  }]), r;
}(p.Component);
Q(ad, "contextType", uo);
Q(ad, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function id(e) {
  var t = e.name, r = cr(e, _I), n = p.useContext(uo), o = p.useContext(Va), a = t !== void 0 ? At(t) : void 0, s = "keep";
  return r.isListField || (s = "_".concat((a || []).join("_"))), process.env.NODE_ENV !== "production" && r.preserve === !1 && r.isListField && a.length <= 1 && Tt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ p.createElement(ad, mt({
    key: s,
    name: a,
    isListField: !!o
  }, r, {
    fieldContext: n
  }));
}
function MI(e) {
  var t = e.name, r = e.initialValue, n = e.children, o = e.rules, a = e.validateTrigger, s = e.isListField, c = p.useContext(uo), l = p.useContext(Va), d = p.useRef({
    keys: [],
    id: 0
  }), u = d.current, f = p.useMemo(function() {
    var v = At(c.prefixName) || [];
    return [].concat(Ne(v), Ne(At(t)));
  }, [c.prefixName, t]), h = p.useMemo(function() {
    return ae(ae({}, c), {}, {
      prefixName: f
    });
  }, [c, f]), g = p.useMemo(function() {
    return {
      getKey: function(m) {
        var y = f.length, I = m[y];
        return [u.keys[I], m.slice(y + 1)];
      }
    };
  }, [f]);
  if (typeof n != "function")
    return Tt(!1, "Form.List only accepts function as children."), null;
  var E = function(m, y, I) {
    var b = I.source;
    return b === "internal" ? !1 : m !== y;
  };
  return /* @__PURE__ */ p.createElement(Va.Provider, {
    value: g
  }, /* @__PURE__ */ p.createElement(uo.Provider, {
    value: h
  }, /* @__PURE__ */ p.createElement(id, {
    name: [],
    shouldUpdate: E,
    rules: o,
    validateTrigger: a,
    initialValue: r,
    isList: !0,
    isListField: s ?? !!l
  }, function(v, m) {
    var y = v.value, I = y === void 0 ? [] : y, b = v.onChange, C = c.getFieldValue, S = function() {
      var D = C(f || []);
      return D || [];
    }, T = {
      add: function(D, x) {
        var O = S();
        x >= 0 && x <= O.length ? (u.keys = [].concat(Ne(u.keys.slice(0, x)), [u.id], Ne(u.keys.slice(x))), b([].concat(Ne(O.slice(0, x)), [D], Ne(O.slice(x))))) : (process.env.NODE_ENV !== "production" && (x < 0 || x > O.length) && Tt(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(Ne(u.keys), [u.id]), b([].concat(Ne(O), [D]))), u.id += 1;
      },
      remove: function(D) {
        var x = S(), O = new Set(Array.isArray(D) ? D : [D]);
        O.size <= 0 || (u.keys = u.keys.filter(function(w, j) {
          return !O.has(j);
        }), b(x.filter(function(w, j) {
          return !O.has(j);
        })));
      },
      move: function(D, x) {
        if (D !== x) {
          var O = S();
          D < 0 || D >= O.length || x < 0 || x >= O.length || (u.keys = Eu(u.keys, D, x), b(Eu(O, D, x)));
        }
      }
    }, N = I || [];
    return Array.isArray(N) || (N = [], process.env.NODE_ENV !== "production" && Tt(!1, "Current value of '".concat(f.join(" > "), "' is not an array type."))), n(N.map(function(V, D) {
      var x = u.keys[D];
      return x === void 0 && (u.keys[D] = u.id, x = u.keys[D], u.id += 1), {
        name: D,
        key: x,
        isListField: !0
      };
    }), T, m);
  })));
}
function LI(e) {
  var t = !1, r = e.length, n = [];
  return e.length ? new Promise(function(o, a) {
    e.forEach(function(s, c) {
      s.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        r -= 1, n[c] = l, !(r > 0) && (t && a(n), o(n));
      });
    });
  }) : Promise.resolve([]);
}
var Rp = "__@field_split__";
function bc(e) {
  return e.map(function(t) {
    return "".concat(it(t), ":").concat(t);
  }).join(Rp);
}
var To = /* @__PURE__ */ function() {
  function e() {
    lr(this, e), Q(this, "kvs", /* @__PURE__ */ new Map());
  }
  return dr(e, [{
    key: "set",
    value: function(r, n) {
      this.kvs.set(bc(r), n);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.kvs.get(bc(r));
    }
  }, {
    key: "update",
    value: function(r, n) {
      var o = this.get(r), a = n(o);
      a ? this.set(r, a) : this.delete(r);
    }
  }, {
    key: "delete",
    value: function(r) {
      this.kvs.delete(bc(r));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(r) {
      return Ne(this.kvs.entries()).map(function(n) {
        var o = Se(n, 2), a = o[0], s = o[1], c = a.split(Rp);
        return r({
          key: c.map(function(l) {
            var d = l.match(/^([^:]*):(.*)$/), u = Se(d, 3), f = u[1], h = u[2];
            return f === "number" ? Number(h) : h;
          }),
          value: s
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var r = {};
      return this.map(function(n) {
        var o = n.key, a = n.value;
        return r[o.join(".")] = a, null;
      }), r;
    }
  }]), e;
}(), VI = ["name"], zI = /* @__PURE__ */ dr(function e(t) {
  var r = this;
  lr(this, e), Q(this, "formHooked", !1), Q(this, "forceRootUpdate", void 0), Q(this, "subscribable", !0), Q(this, "store", {}), Q(this, "fieldEntities", []), Q(this, "initialValues", {}), Q(this, "callbacks", {}), Q(this, "validateMessages", null), Q(this, "preserve", null), Q(this, "lastValidatePromise", null), Q(this, "getForm", function() {
    return {
      getFieldValue: r.getFieldValue,
      getFieldsValue: r.getFieldsValue,
      getFieldError: r.getFieldError,
      getFieldWarning: r.getFieldWarning,
      getFieldsError: r.getFieldsError,
      isFieldsTouched: r.isFieldsTouched,
      isFieldTouched: r.isFieldTouched,
      isFieldValidating: r.isFieldValidating,
      isFieldsValidating: r.isFieldsValidating,
      resetFields: r.resetFields,
      setFields: r.setFields,
      setFieldValue: r.setFieldValue,
      setFieldsValue: r.setFieldsValue,
      validateFields: r.validateFields,
      submit: r.submit,
      _init: !0,
      getInternalHooks: r.getInternalHooks
    };
  }), Q(this, "getInternalHooks", function(n) {
    return n === no ? (r.formHooked = !0, {
      dispatch: r.dispatch,
      initEntityValue: r.initEntityValue,
      registerField: r.registerField,
      useSubscribe: r.useSubscribe,
      setInitialValues: r.setInitialValues,
      destroyForm: r.destroyForm,
      setCallbacks: r.setCallbacks,
      setValidateMessages: r.setValidateMessages,
      getFields: r.getFields,
      setPreserve: r.setPreserve,
      getInitialValue: r.getInitialValue,
      registerWatch: r.registerWatch
    }) : (Tt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), Q(this, "useSubscribe", function(n) {
    r.subscribable = n;
  }), Q(this, "prevWithoutPreserves", null), Q(this, "setInitialValues", function(n, o) {
    if (r.initialValues = n || {}, o) {
      var a, s = $o(n, r.store);
      (a = r.prevWithoutPreserves) === null || a === void 0 || a.map(function(c) {
        var l = c.key;
        s = jr(s, l, qr(n, l));
      }), r.prevWithoutPreserves = null, r.updateStore(s);
    }
  }), Q(this, "destroyForm", function() {
    var n = new To();
    r.getFieldEntities(!0).forEach(function(o) {
      r.isMergedPreserve(o.isPreserve()) || n.set(o.getNamePath(), !0);
    }), r.prevWithoutPreserves = n;
  }), Q(this, "getInitialValue", function(n) {
    var o = qr(r.initialValues, n);
    return n.length ? $o(o) : o;
  }), Q(this, "setCallbacks", function(n) {
    r.callbacks = n;
  }), Q(this, "setValidateMessages", function(n) {
    r.validateMessages = n;
  }), Q(this, "setPreserve", function(n) {
    r.preserve = n;
  }), Q(this, "watchList", []), Q(this, "registerWatch", function(n) {
    return r.watchList.push(n), function() {
      r.watchList = r.watchList.filter(function(o) {
        return o !== n;
      });
    };
  }), Q(this, "notifyWatch", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (r.watchList.length) {
      var o = r.getFieldsValue(), a = r.getFieldsValue(!0);
      r.watchList.forEach(function(s) {
        s(o, a, n);
      });
    }
  }), Q(this, "timeoutId", null), Q(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !r.timeoutId && typeof window < "u" && (r.timeoutId = setTimeout(function() {
      r.timeoutId = null, r.formHooked || Tt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), Q(this, "updateStore", function(n) {
    r.store = n;
  }), Q(this, "getFieldEntities", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return n ? r.fieldEntities.filter(function(o) {
      return o.getNamePath().length;
    }) : r.fieldEntities;
  }), Q(this, "getFieldsMap", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = new To();
    return r.getFieldEntities(n).forEach(function(a) {
      var s = a.getNamePath();
      o.set(s, a);
    }), o;
  }), Q(this, "getFieldEntitiesForNamePathList", function(n) {
    if (!n)
      return r.getFieldEntities(!0);
    var o = r.getFieldsMap(!0);
    return n.map(function(a) {
      var s = At(a);
      return o.get(s) || {
        INVALIDATE_NAME_PATH: At(a)
      };
    });
  }), Q(this, "getFieldsValue", function(n, o) {
    r.warningUnhooked();
    var a, s, c;
    if (n === !0 || Array.isArray(n) ? (a = n, s = o) : n && it(n) === "object" && (c = n.strict, s = n.filter), a === !0 && !s)
      return r.store;
    var l = r.getFieldEntitiesForNamePathList(Array.isArray(a) ? a : null), d = [];
    return l.forEach(function(u) {
      var f, h, g = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (c) {
        var E, v;
        if ((E = (v = u).isList) !== null && E !== void 0 && E.call(v))
          return;
      } else if (!a && (f = (h = u).isListField) !== null && f !== void 0 && f.call(h))
        return;
      if (!s)
        d.push(g);
      else {
        var m = "getMeta" in u ? u.getMeta() : null;
        s(m) && d.push(g);
      }
    }), Su(r.store, d.map(At));
  }), Q(this, "getFieldValue", function(n) {
    r.warningUnhooked();
    var o = At(n);
    return qr(r.store, o);
  }), Q(this, "getFieldsError", function(n) {
    r.warningUnhooked();
    var o = r.getFieldEntitiesForNamePathList(n);
    return o.map(function(a, s) {
      return a && !("INVALIDATE_NAME_PATH" in a) ? {
        name: a.getNamePath(),
        errors: a.getErrors(),
        warnings: a.getWarnings()
      } : {
        name: At(n[s]),
        errors: [],
        warnings: []
      };
    });
  }), Q(this, "getFieldError", function(n) {
    r.warningUnhooked();
    var o = At(n), a = r.getFieldsError([o])[0];
    return a.errors;
  }), Q(this, "getFieldWarning", function(n) {
    r.warningUnhooked();
    var o = At(n), a = r.getFieldsError([o])[0];
    return a.warnings;
  }), Q(this, "isFieldsTouched", function() {
    r.warningUnhooked();
    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    var s = o[0], c = o[1], l, d = !1;
    o.length === 0 ? l = null : o.length === 1 ? Array.isArray(s) ? (l = s.map(At), d = !1) : (l = null, d = s) : (l = s.map(At), d = c);
    var u = r.getFieldEntities(!0), f = function(m) {
      return m.isFieldTouched();
    };
    if (!l)
      return d ? u.every(f) : u.some(f);
    var h = new To();
    l.forEach(function(v) {
      h.set(v, []);
    }), u.forEach(function(v) {
      var m = v.getNamePath();
      l.forEach(function(y) {
        y.every(function(I, b) {
          return m[b] === I;
        }) && h.update(y, function(I) {
          return [].concat(Ne(I), [v]);
        });
      });
    });
    var g = function(m) {
      return m.some(f);
    }, E = h.map(function(v) {
      var m = v.value;
      return m;
    });
    return d ? E.every(g) : E.some(g);
  }), Q(this, "isFieldTouched", function(n) {
    return r.warningUnhooked(), r.isFieldsTouched([n]);
  }), Q(this, "isFieldsValidating", function(n) {
    r.warningUnhooked();
    var o = r.getFieldEntities();
    if (!n)
      return o.some(function(s) {
        return s.isFieldValidating();
      });
    var a = n.map(At);
    return o.some(function(s) {
      var c = s.getNamePath();
      return Lo(a, c) && s.isFieldValidating();
    });
  }), Q(this, "isFieldValidating", function(n) {
    return r.warningUnhooked(), r.isFieldsValidating([n]);
  }), Q(this, "resetWithFieldInitialValue", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = new To(), a = r.getFieldEntities(!0);
    a.forEach(function(l) {
      var d = l.props.initialValue, u = l.getNamePath();
      if (d !== void 0) {
        var f = o.get(u) || /* @__PURE__ */ new Set();
        f.add({
          entity: l,
          value: d
        }), o.set(u, f);
      }
    });
    var s = function(d) {
      d.forEach(function(u) {
        var f = u.props.initialValue;
        if (f !== void 0) {
          var h = u.getNamePath(), g = r.getInitialValue(h);
          if (g !== void 0)
            Tt(!1, "Form already set 'initialValues' with path '".concat(h.join("."), "'. Field can not overwrite it."));
          else {
            var E = o.get(h);
            if (E && E.size > 1)
              Tt(!1, "Multiple Field with path '".concat(h.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (E) {
              var v = r.getFieldValue(h), m = u.isListField();
              !m && (!n.skipExist || v === void 0) && r.updateStore(jr(r.store, h, Ne(E)[0].value));
            }
          }
        }
      });
    }, c;
    n.entities ? c = n.entities : n.namePathList ? (c = [], n.namePathList.forEach(function(l) {
      var d = o.get(l);
      if (d) {
        var u;
        (u = c).push.apply(u, Ne(Ne(d).map(function(f) {
          return f.entity;
        })));
      }
    })) : c = a, s(c);
  }), Q(this, "resetFields", function(n) {
    r.warningUnhooked();
    var o = r.store;
    if (!n) {
      r.updateStore($o(r.initialValues)), r.resetWithFieldInitialValue(), r.notifyObservers(o, null, {
        type: "reset"
      }), r.notifyWatch();
      return;
    }
    var a = n.map(At);
    a.forEach(function(s) {
      var c = r.getInitialValue(s);
      r.updateStore(jr(r.store, s, c));
    }), r.resetWithFieldInitialValue({
      namePathList: a
    }), r.notifyObservers(o, a, {
      type: "reset"
    }), r.notifyWatch(a);
  }), Q(this, "setFields", function(n) {
    r.warningUnhooked();
    var o = r.store, a = [];
    n.forEach(function(s) {
      var c = s.name, l = cr(s, VI), d = At(c);
      a.push(d), "value" in l && r.updateStore(jr(r.store, d, l.value)), r.notifyObservers(o, [d], {
        type: "setField",
        data: s
      });
    }), r.notifyWatch(a);
  }), Q(this, "getFields", function() {
    var n = r.getFieldEntities(!0), o = n.map(function(a) {
      var s = a.getNamePath(), c = a.getMeta(), l = ae(ae({}, c), {}, {
        name: s,
        value: r.getFieldValue(s)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return o;
  }), Q(this, "initEntityValue", function(n) {
    var o = n.props.initialValue;
    if (o !== void 0) {
      var a = n.getNamePath(), s = qr(r.store, a);
      s === void 0 && r.updateStore(jr(r.store, a, o));
    }
  }), Q(this, "isMergedPreserve", function(n) {
    var o = n !== void 0 ? n : r.preserve;
    return o ?? !0;
  }), Q(this, "registerField", function(n) {
    r.fieldEntities.push(n);
    var o = n.getNamePath();
    if (r.notifyWatch([o]), n.props.initialValue !== void 0) {
      var a = r.store;
      r.resetWithFieldInitialValue({
        entities: [n],
        skipExist: !0
      }), r.notifyObservers(a, [n.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(s, c) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r.fieldEntities = r.fieldEntities.filter(function(f) {
        return f !== n;
      }), !r.isMergedPreserve(c) && (!s || l.length > 1)) {
        var d = s ? void 0 : r.getInitialValue(o);
        if (o.length && r.getFieldValue(o) !== d && r.fieldEntities.every(function(f) {
          return (
            // Only reset when no namePath exist
            !Np(f.getNamePath(), o)
          );
        })) {
          var u = r.store;
          r.updateStore(jr(u, o, d, !0)), r.notifyObservers(u, [o], {
            type: "remove"
          }), r.triggerDependenciesUpdate(u, o);
        }
      }
      r.notifyWatch([o]);
    };
  }), Q(this, "dispatch", function(n) {
    switch (n.type) {
      case "updateValue": {
        var o = n.namePath, a = n.value;
        r.updateValue(o, a);
        break;
      }
      case "validateField": {
        var s = n.namePath, c = n.triggerName;
        r.validateFields([s], {
          triggerName: c
        });
        break;
      }
    }
  }), Q(this, "notifyObservers", function(n, o, a) {
    if (r.subscribable) {
      var s = ae(ae({}, a), {}, {
        store: r.getFieldsValue(!0)
      });
      r.getFieldEntities().forEach(function(c) {
        var l = c.onStoreChange;
        l(n, o, s);
      });
    } else
      r.forceRootUpdate();
  }), Q(this, "triggerDependenciesUpdate", function(n, o) {
    var a = r.getDependencyChildrenFields(o);
    return a.length && r.validateFields(a), r.notifyObservers(n, a, {
      type: "dependenciesUpdate",
      relatedFields: [o].concat(Ne(a))
    }), a;
  }), Q(this, "updateValue", function(n, o) {
    var a = At(n), s = r.store;
    r.updateStore(jr(r.store, a, o)), r.notifyObservers(s, [a], {
      type: "valueUpdate",
      source: "internal"
    }), r.notifyWatch([a]);
    var c = r.triggerDependenciesUpdate(s, a), l = r.callbacks.onValuesChange;
    if (l) {
      var d = Su(r.store, [a]);
      l(d, r.getFieldsValue());
    }
    r.triggerOnFieldsChange([a].concat(Ne(c)));
  }), Q(this, "setFieldsValue", function(n) {
    r.warningUnhooked();
    var o = r.store;
    if (n) {
      var a = $o(r.store, n);
      r.updateStore(a);
    }
    r.notifyObservers(o, null, {
      type: "valueUpdate",
      source: "external"
    }), r.notifyWatch();
  }), Q(this, "setFieldValue", function(n, o) {
    r.setFields([{
      name: n,
      value: o
    }]);
  }), Q(this, "getDependencyChildrenFields", function(n) {
    var o = /* @__PURE__ */ new Set(), a = [], s = new To();
    r.getFieldEntities().forEach(function(l) {
      var d = l.props.dependencies;
      (d || []).forEach(function(u) {
        var f = At(u);
        s.update(f, function() {
          var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return h.add(l), h;
        });
      });
    });
    var c = function l(d) {
      var u = s.get(d) || /* @__PURE__ */ new Set();
      u.forEach(function(f) {
        if (!o.has(f)) {
          o.add(f);
          var h = f.getNamePath();
          f.isFieldDirty() && h.length && (a.push(h), l(h));
        }
      });
    };
    return c(n), a;
  }), Q(this, "triggerOnFieldsChange", function(n, o) {
    var a = r.callbacks.onFieldsChange;
    if (a) {
      var s = r.getFields();
      if (o) {
        var c = new To();
        o.forEach(function(d) {
          var u = d.name, f = d.errors;
          c.set(u, f);
        }), s.forEach(function(d) {
          d.errors = c.get(d.name) || d.errors;
        });
      }
      var l = s.filter(function(d) {
        var u = d.name;
        return Lo(n, u);
      });
      l.length && a(l, s);
    }
  }), Q(this, "validateFields", function(n, o) {
    r.warningUnhooked();
    var a, s;
    Array.isArray(n) || typeof n == "string" || typeof o == "string" ? (a = n, s = o) : s = n;
    var c = !!a, l = c ? a.map(At) : [], d = [], u = String(Date.now()), f = /* @__PURE__ */ new Set(), h = s || {}, g = h.recursive, E = h.dirty;
    r.getFieldEntities(!0).forEach(function(I) {
      if (c || l.push(I.getNamePath()), !(!I.props.rules || !I.props.rules.length) && !(E && !I.isFieldDirty())) {
        var b = I.getNamePath();
        if (f.add(b.join(u)), !c || Lo(l, b, g)) {
          var C = I.validateRules(ae({
            validateMessages: ae(ae({}, Op), r.validateMessages)
          }, s));
          d.push(C.then(function() {
            return {
              name: b,
              errors: [],
              warnings: []
            };
          }).catch(function(S) {
            var T, N = [], V = [];
            return (T = S.forEach) === null || T === void 0 || T.call(S, function(D) {
              var x = D.rule.warningOnly, O = D.errors;
              x ? V.push.apply(V, Ne(O)) : N.push.apply(N, Ne(O));
            }), N.length ? Promise.reject({
              name: b,
              errors: N,
              warnings: V
            }) : {
              name: b,
              errors: N,
              warnings: V
            };
          }));
        }
      }
    });
    var v = LI(d);
    r.lastValidatePromise = v, v.catch(function(I) {
      return I;
    }).then(function(I) {
      var b = I.map(function(C) {
        var S = C.name;
        return S;
      });
      r.notifyObservers(r.store, b, {
        type: "validateFinish"
      }), r.triggerOnFieldsChange(b, I);
    });
    var m = v.then(function() {
      return r.lastValidatePromise === v ? Promise.resolve(r.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(I) {
      var b = I.filter(function(C) {
        return C && C.errors.length;
      });
      return Promise.reject({
        values: r.getFieldsValue(l),
        errorFields: b,
        outOfDate: r.lastValidatePromise !== v
      });
    });
    m.catch(function(I) {
      return I;
    });
    var y = l.filter(function(I) {
      return f.has(I.join(u));
    });
    return r.triggerOnFieldsChange(y), m;
  }), Q(this, "submit", function() {
    r.warningUnhooked(), r.validateFields().then(function(n) {
      var o = r.callbacks.onFinish;
      if (o)
        try {
          o(n);
        } catch (a) {
          console.error(a);
        }
    }).catch(function(n) {
      var o = r.callbacks.onFinishFailed;
      o && o(n);
    });
  }), this.forceRootUpdate = t;
});
function sd(e) {
  var t = p.useRef(), r = p.useState({}), n = Se(r, 2), o = n[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var a = function() {
        o({});
      }, s = new zI(a);
      t.current = s.getForm();
    }
  return [t.current];
}
var Fl = /* @__PURE__ */ p.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), Pp = function(t) {
  var r = t.validateMessages, n = t.onFormChange, o = t.onFormFinish, a = t.children, s = p.useContext(Fl), c = p.useRef({});
  return /* @__PURE__ */ p.createElement(Fl.Provider, {
    value: ae(ae({}, s), {}, {
      validateMessages: ae(ae({}, s.validateMessages), r),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(d, u) {
        n && n(d, {
          changedFields: u,
          forms: c.current
        }), s.triggerFormChange(d, u);
      },
      triggerFormFinish: function(d, u) {
        o && o(d, {
          values: u,
          forms: c.current
        }), s.triggerFormFinish(d, u);
      },
      registerForm: function(d, u) {
        d && (c.current = ae(ae({}, c.current), {}, Q({}, d, u))), s.registerForm(d, u);
      },
      unregisterForm: function(d) {
        var u = ae({}, c.current);
        delete u[d], c.current = u, s.unregisterForm(d);
      }
    })
  }, a);
}, BI = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], kI = function(t, r) {
  var n = t.name, o = t.initialValues, a = t.fields, s = t.form, c = t.preserve, l = t.children, d = t.component, u = d === void 0 ? "form" : d, f = t.validateMessages, h = t.validateTrigger, g = h === void 0 ? "onChange" : h, E = t.onValuesChange, v = t.onFieldsChange, m = t.onFinish, y = t.onFinishFailed, I = cr(t, BI), b = p.useContext(Fl), C = sd(s), S = Se(C, 1), T = S[0], N = T.getInternalHooks(no), V = N.useSubscribe, D = N.setInitialValues, x = N.setCallbacks, O = N.setValidateMessages, w = N.setPreserve, j = N.destroyForm;
  p.useImperativeHandle(r, function() {
    return T;
  }), p.useEffect(function() {
    return b.registerForm(n, T), function() {
      b.unregisterForm(n);
    };
  }, [b, T, n]), O(ae(ae({}, b.validateMessages), f)), x({
    onValuesChange: E,
    onFieldsChange: function(M) {
      if (b.triggerFormChange(n, M), v) {
        for (var B = arguments.length, W = new Array(B > 1 ? B - 1 : 0), ee = 1; ee < B; ee++)
          W[ee - 1] = arguments[ee];
        v.apply(void 0, [M].concat(W));
      }
    },
    onFinish: function(M) {
      b.triggerFormFinish(n, M), m && m(M);
    },
    onFinishFailed: y
  }), w(c);
  var $ = p.useRef(null);
  D(o, !$.current), $.current || ($.current = !0), p.useEffect(
    function() {
      return j;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var _, A = typeof l == "function";
  if (A) {
    var R = T.getFieldsValue(!0);
    _ = l(R, T);
  } else
    _ = l;
  V(!A);
  var P = p.useRef();
  p.useEffect(function() {
    $I(P.current || [], a || []) || T.setFields(a || []), P.current = a;
  }, [a, T]);
  var z = p.useMemo(function() {
    return ae(ae({}, T), {}, {
      validateTrigger: g
    });
  }, [T, g]), F = /* @__PURE__ */ p.createElement(Va.Provider, {
    value: null
  }, /* @__PURE__ */ p.createElement(uo.Provider, {
    value: z
  }, _));
  return u === !1 ? F : /* @__PURE__ */ p.createElement(u, mt({}, I, {
    onSubmit: function(M) {
      M.preventDefault(), M.stopPropagation(), T.submit();
    },
    onReset: function(M) {
      var B;
      M.preventDefault(), T.resetFields(), (B = I.onReset) === null || B === void 0 || B.call(I, M);
    }
  }), F);
};
function wu(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var UI = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), r = Wt(t);
  Tt(r.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Ba() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t[0], o = t[1], a = o === void 0 ? {} : o, s = ZC(a) ? {
    form: a
  } : a, c = s.form, l = ja(), d = Se(l, 2), u = d[0], f = d[1], h = $a(function() {
    return wu(u);
  }, [u]), g = Wt(h);
  g.current = h;
  var E = Ir(uo), v = c || E, m = v && v._init;
  process.env.NODE_ENV !== "production" && Tt(t.length === 2 ? c ? m : !0 : m, "useWatch requires a form instance since it can not auto detect from context.");
  var y = At(n), I = Wt(y);
  return I.current = y, UI(y), xr(
    function() {
      if (m) {
        var b = v.getFieldsValue, C = v.getInternalHooks, S = C(no), T = S.registerWatch, N = function(O, w) {
          var j = s.preserve ? w : O;
          return typeof n == "function" ? n(j) : qr(j, I.current);
        }, V = T(function(x, O) {
          var w = N(x, O), j = wu(w);
          g.current !== j && (g.current = j, f(w));
        }), D = N(b(), b(!0));
        return u !== D && f(D), V;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m]
  ), u;
}
var qI = /* @__PURE__ */ p.forwardRef(kI), oa = qI;
oa.FormProvider = Pp;
oa.Field = id;
oa.List = MI;
oa.useForm = sd;
oa.useWatch = Ba;
const An = /* @__PURE__ */ p.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), jp = /* @__PURE__ */ p.createContext(null), HI = (e) => {
  const t = Ya(e, ["prefixCls"]);
  return /* @__PURE__ */ p.createElement(Pp, Object.assign({}, t));
}, $p = /* @__PURE__ */ p.createContext({
  prefixCls: ""
}), Ho = /* @__PURE__ */ p.createContext({});
process.env.NODE_ENV !== "production" && (Ho.displayName = "FormItemInputContext");
const Ap = /* @__PURE__ */ Ha(void 0), _p = /* @__PURE__ */ p.createContext(null), WI = (e, t) => {
  const r = p.useContext(_p), n = p.useMemo(() => {
    if (!r)
      return "";
    const {
      compactDirection: o,
      isFirstItem: a,
      isLastItem: s
    } = r, c = o === "vertical" ? "-vertical-" : "-";
    return we(`${e}-compact${c}item`, {
      [`${e}-compact${c}first-item`]: a,
      [`${e}-compact${c}last-item`]: s,
      [`${e}-compact${c}item-rtl`]: t === "rtl"
    });
  }, [e, t, r]);
  return {
    compactSize: r?.compactSize,
    compactDirection: r?.compactDirection,
    compactItemClassnames: n
  };
}, GI = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ p.createElement(_p.Provider, {
    value: null
  }, t);
};
function KI(e, t, r) {
  const {
    focusElCls: n,
    focus: o,
    borderElCls: a
  } = r, s = a ? "> *" : "", c = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${s}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [c]: {
        zIndex: 2
      }
    }, n ? {
      [`&${n}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${s}`]: {
        zIndex: 0
      }
    })
  };
}
function YI(e, t, r) {
  const {
    borderElCls: n
  } = r, o = n ? `> ${n}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function Mp(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: r
  } = e, n = `${r}-compact`;
  return {
    [n]: Object.assign(Object.assign({}, KI(e, n, t)), YI(r, n, t))
  };
}
function QI(e) {
  return fr(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const XI = (e) => {
  const {
    controlHeight: t,
    fontSize: r,
    lineHeight: n,
    lineWidth: o,
    controlHeightSM: a,
    controlHeightLG: s,
    fontSizeLG: c,
    lineHeightLG: l,
    paddingSM: d,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: f,
    colorFillAlter: h,
    colorPrimaryHover: g,
    colorPrimary: E,
    controlOutlineWidth: v,
    controlOutline: m,
    colorErrorOutline: y,
    colorWarningOutline: I,
    colorBgContainer: b
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - r * n) / 2 * 10) / 10 - o, 0),
    paddingBlockSM: Math.max(Math.round((a - r * n) / 2 * 10) / 10 - o, 0),
    paddingBlockLG: Math.ceil((s - c * l) / 2 * 10) / 10 - o,
    paddingInline: d - o,
    paddingInlineSM: u - o,
    paddingInlineLG: f - o,
    addonBg: h,
    activeBorderColor: E,
    hoverBorderColor: g,
    activeShadow: `0 0 0 ${v}px ${m}`,
    errorActiveShadow: `0 0 0 ${v}px ${y}`,
    warningActiveShadow: `0 0 0 ${v}px ${I}`,
    hoverBg: b,
    activeBg: b,
    inputFontSize: r,
    inputFontSizeLG: c,
    inputFontSizeSM: r
  };
}, ZI = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), cd = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, ZI(fr(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), Lp = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), Tu = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, Lp(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), JI = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Lp(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, cd(e))
  }), Tu(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), Tu(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), Fu = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), ex = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, Fu(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), Fu(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, cd(e))
    }
  })
}), tx = (e, t) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled
    }
  }, t)
}), Vp = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t?.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), Ou = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, Vp(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), rx = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Vp(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, cd(e))
  }), Ou(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), Ou(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), Nu = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), nx = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${Me(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${Me(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, Nu(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), Nu(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), ox = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), zp = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: r,
    borderRadiusLG: n,
    paddingInlineLG: o
  } = e;
  return {
    padding: `${Me(t)} ${Me(o)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: r,
    borderRadius: n
  };
}, Bp = (e) => ({
  padding: `${Me(e.paddingBlockSM)} ${Me(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), kp = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${Me(e.paddingBlock)} ${Me(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, ox(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, zp(e)),
  "&-sm": Object.assign({}, Bp(e)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), ax = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, zp(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, Bp(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${Me(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${r}-select`]: {
          margin: `${Me(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${Me(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${r}-select-single:not(${r}-select-customize-input):not(${r}-pagination-size-changer)`]: {
            [`${r}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${Me(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${r}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${r}-cascader-picker`]: {
          margin: `-9px ${Me(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${r}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${t}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, td()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${r}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${r}-select > ${r}-select-selector,
      & > ${r}-select-auto-complete ${t},
      & > ${r}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${r}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${r}-select > ${r}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${r}-select:first-child > ${r}-select-selector,
      & > ${r}-select-auto-complete:first-child ${t},
      & > ${r}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${r}-select:last-child > ${r}-select-selector,
      & > ${r}-cascader-picker:last-child ${t},
      & > ${r}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${r}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, ix = (e) => {
  const {
    componentCls: t,
    controlHeightSM: r,
    lineWidth: n,
    calc: o
  } = e, s = o(r).sub(o(n).mul(2)).sub(16).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ho(e)), kp(e)), JI(e)), rx(e)), tx(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: r,
          paddingTop: s,
          paddingBottom: s
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, sx = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${Me(e.inputAffixPadding)}`
      }
    }
  };
}, cx = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: r,
    colorTextDescription: n,
    motionDurationSlow: o,
    colorIcon: a,
    colorIconHover: s,
    iconCls: c
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign({}, kp(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: n
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: r
        },
        "&-suffix": {
          marginInlineStart: r
        }
      }
    }), sx(e)), {
      // password
      [`${c}${t}-password-icon`]: {
        color: a,
        cursor: "pointer",
        transition: `all ${o}`,
        "&:hover": {
          color: s
        }
      }
    })
  };
}, lx = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: r,
    borderRadiusSM: n
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, ho(e)), ax(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: r,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: n
          }
        }
      }, ex(e)), nx(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, dx = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, n = `${t}-search`;
  return {
    [n]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${n}-button:not(${r}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal({
          unit: !1
        })
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${n}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${n}-button:not(${r}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${r}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${n}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${n}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${n}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, ux = (e) => {
  const {
    componentCls: t,
    paddingLG: r
  } = e, n = `${t}-textarea`;
  return {
    [n]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${t}`]: {
          paddingInlineEnd: r
        }
      },
      [`&-affix-wrapper${n}-has-feedback`]: {
        [`${t}`]: {
          paddingInlineEnd: r
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingXS,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${n}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, fx = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, mx = Cn("Input", (e) => {
  const t = fr(e, QI(e));
  return [
    ix(t),
    ux(t),
    cx(t),
    lx(t),
    dx(t),
    fx(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    Mp(t)
  ];
}, XI), xs = (e) => {
  const [, , , , t] = Lr();
  return t ? `${e}-css-var` : "";
}, px = ["outlined", "borderless", "filled"], hx = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const r = Ir(Ap);
  let n;
  typeof e < "u" ? n = e : t === !1 ? n = "borderless" : n = r ?? "outlined";
  const o = px.includes(n);
  return [n, o];
};
function gx(e, t) {
  if (!e)
    return;
  e.focus(t);
  const {
    cursor: r
  } = t || {};
  if (r) {
    const n = e.value.length;
    switch (r) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(n, n);
        break;
      default:
        e.setSelectionRange(0, n);
        break;
    }
  }
}
var vx = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const yx = /* @__PURE__ */ Wa((e, t) => {
  var r;
  const {
    prefixCls: n,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: c,
    allowClear: l,
    classNames: d,
    rootClassName: u,
    className: f,
    variant: h
  } = e, g = vx(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: A
    } = ur("TextArea");
    A(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: E,
    direction: v
  } = p.useContext(Mt), m = od(a), y = p.useContext(Qa), I = s ?? y, {
    status: b,
    hasFeedback: C,
    feedbackIcon: S
  } = p.useContext(Ho), T = y0(b, c), N = p.useRef(null);
  p.useImperativeHandle(t, () => {
    var A;
    return {
      resizableTextArea: (A = N.current) === null || A === void 0 ? void 0 : A.resizableTextArea,
      focus: (R) => {
        var P, z;
        gx((z = (P = N.current) === null || P === void 0 ? void 0 : P.resizableTextArea) === null || z === void 0 ? void 0 : z.textArea, R);
      },
      blur: () => {
        var R;
        return (R = N.current) === null || R === void 0 ? void 0 : R.blur();
      }
    };
  });
  const V = E("input", n);
  let D;
  typeof l == "object" && l?.clearIcon ? D = l : l && (D = {
    clearIcon: /* @__PURE__ */ p.createElement(kl, null)
  });
  const x = xs(V), [O, w, j] = mx(V, x), [$, _] = hx(h, o);
  return O(/* @__PURE__ */ p.createElement(g0, Object.assign({}, g, {
    disabled: I,
    allowClear: D,
    className: we(j, x, f, u),
    classNames: Object.assign(Object.assign({}, d), {
      textarea: we({
        [`${V}-sm`]: m === "small",
        [`${V}-lg`]: m === "large"
      }, w, d?.textarea),
      variant: we({
        [`${V}-${$}`]: _
      }, v0(V, T)),
      affixWrapper: we(`${V}-textarea-affix-wrapper`, {
        [`${V}-affix-wrapper-rtl`]: v === "rtl",
        [`${V}-affix-wrapper-sm`]: m === "small",
        [`${V}-affix-wrapper-lg`]: m === "large",
        [`${V}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, w)
    }),
    prefixCls: V,
    suffix: C && /* @__PURE__ */ p.createElement("span", {
      className: `${V}-textarea-suffix`
    }, S),
    ref: N
  })));
}), Ja = yx, bx = st.device.mobileS, Cx = st.maxDevice.tablet;
Ee(Ke)`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	column-gap: 20px;

	@media only screen and (${bx}) and (${Cx}) {
		flex-direction: column;
	}
`;
Ee(at)`
	flex: 1;
	margin-bottom: 10px;
`;
Ee(Ia)`
	width: 100%;
`;
Ee(Lf)`
	width: 100%;
`;
Ee(wt)`
	border-radius: 32px !important;
	letter-spacing: 1px;
`;
k.createContext(null);
const Ix = hv`
  0% {
    opacity: 1;
    color: #29ABE2; /* Color 1 */
  }
  
  }
  50% {
    opacity: 0;
    color: #124054; /* Color 2 */
  }

  }
  100% {
    opacity: 1;
    color: #00141D; /* Color 3 */
  }
`, xx = Ee.span`=
margin-top: ${({ marginTop: e }) => e || "10px"};
  animation: ${({ isSaving: e }) => e ? gv`
					${Ix} 1s infinite
				` : "none"};
`, Vr = (e) => i.jsxs("div", { style: { display: "flex", textAlign: "center", flexDirection: "column" }, children: [i.jsx(Xo, { size: e.size, style: { marginBottom: "10px" } }), i.jsx(xx, { isSaving: e.isLoading, children: e.title })] }), Wo = st.device.mobileS, Go = st.maxDevice.tablet;
Ee(Ke)`
	flex: 1;
	flex-direction: column;

	@media ${st.device.mobileS} {
		flex-direction: column;
	}

	@media screen and (${st.device.laptop}) {
		flex-direction: column;
		height: 100%;
	}
`;
const Sx = Ee(gn)``;
Ee(at)`
	display: flex;
	padding: 10px 24px;
	border-bottom: 1.8px solid lightgrey;
	align-items: center;
	gap: 15px;
	justify-content: space-between;

	${Sx} {
		align-self: center;
	}

	@media only screen and (${Wo}) and (${Go}) {
		border-right: 0;
		overflow: unset;
		flex-direction: column;
		align-items: flex-start;
		padding: 15px;
	}
`;
Ee(ev)`
	display: flex;
	padding: 10px;
	width: 50%;

	@media only screen and (${Wo}) and (${Go}) {
		width: 100%;
	}
`;
Ee(Ke)`
	flex: 1;
	flex-direction: row;
	gap: 20px;
	overflow: hidden;

	@media ${st.device.mobileS} {
		flex-direction: column;
	}

	@media ${st.device.tablet} {
		flex-direction: row;
	}
`;
const Ex = Ee(tv)``;
Ee(Ke)`
	flex-direction: row;
	align-items: center;

	${Ex} {
		margin: 0px 20px;
		height: 50px;

		@media only screen and (${Wo}) and (${Go}) {
			display: none;
		}
	}

	@media only screen and (${Wo}) and (${Go}) {
		flex-direction: column;
	}
`;
Ee(Ke)`
	flex: 1;
	margin: 20px 0px 20px 20px;
	flex-direction: column;
	justify-content: center;

	@media only screen and (${Wo}) and (${Go}) {
		display: none !important;
	}
`;
Ee(Vt)`
	display: flex;
	flex: 3.5;
	height: 100%;
	flex-direction: column;
	padding: 20px 20px 20px 0px;
	overflow: auto;

	@media only screen and (${Wo}) and (${Go}) {
		padding: 20px;
	}
`;
Ee(Ke)`
	flex: 1;
	height: 100%;
	align-items: center;
	justify-content: center;
`;
Ee(_l)`
	background-color: ${({ theme: e }) => e.colors?.primary500};
`;
const Ru = (e) => {
  const t = e.toLowerCase(), r = wd.language.includes("es") ? "es" : wd.language;
  return Yg(zv, (n) => r === "en" ? n["message-en"] : n["message-es"], (n) => n.keys.every((o) => t.includes(o)));
}, Up = (e, t) => `${e ?? ""}${e && t ? " " : ""}${t ?? ""}`;
function Dx(e, t) {
  return e.length > t ? e.substring(0, t) + "..." : e;
}
const et = () => ({
  reports: {
    Cuadre_Caja: 21,
    Factura_Compra: 5,
    Cobros_Ingresos: 4,
    Factura_Estados: 6,
    Listado_Ingresos: 1,
    Ajustes_Inventario: 3,
    Inventario_Agotado: 7,
    Recibos_Pago_Seguro: 17,
    Transanccion_Cuadre: 19,
    Producto_Por_Almacen: 22,
    Transferencia_Almacen: 20,
    Listado_Factura_Producto: 8,
    Recibos_Detalles_Seguros: 13,
    Recibos_Pago_Aseguradora: 16,
    Ordenes_Compra_Rango_Fecha: 9,
    Recibos_Cobro_Aseguradora: 12,
    Ticket_Linea_Historial_Pago: 18,
    Productos_Vendidos_Rango_Fecha: 11,
    Recibos_Detalles_Seguros_Header: 10
  },
  docTypes: {
    Conduce: 5,
    Cotizacion: 1,
    Nota_de_debito: 4,
    Nota_de_credito: 3,
    Orden_de_compra: 7,
    Factura_de_venta: 2,
    Factura_de_compra: 6,
    Movimiento_de_inventario: 8
  },
  tiposNotas: {
    nota_debito: 2,
    nota_credito: 1
  },
  formasPagos: {
    Cheque: 3,
    Credito: 2,
    Depsito: 7,
    Efectivo: 1,
    Nota_credito: 4,
    Transferencia: 8,
    Debito_Credito: 5,
    Pago_anticipado: 6
  },
  tiposNCFIds: {
    Credito_Fiscal: 1,
    Nota_de_Debito: 3,
    Gastos_menores: 7,
    Nota_de_Credito: 4,
    Consumidor_final: 2,
    Comprobante_de_compra: 5,
    Registro_Unico_de_Ingresos: 6,
    Comprobantes_Gubernamentales: 9,
    Regimenes_Especiales_de_Tributacion: 8
  },
  statesValues: {
    Activo: 1,
    Anulado: 4,
    Inactivo: 2,
    Borrador: 3,
    Saldado: 10,
    Disputa: 13,
    Cerrado: 25,
    Rechazado: 6,
    Incautado: 8,
    Eliminado: 15,
    Bloqueado: 16,
    Terminado: 20,
    Facturado: 22,
    Pendiente: 23,
    Compromiso: 11,
    Incobrable: 14,
    Conciliado: 17,
    Recurrente: 19,
    Finalizado: 24,
    Refinanciado: 9,
    Pasado_a_legal: 7,
    No_conciliado: 18,
    Pago_informado: 12,
    Terminado_incompleto: 21,
    Pendiente_de_aprobacion: 5
  },
  frecuenciesValues: {
    Diario: 1,
    Semanal: 2,
    Mensual: 4,
    Quincenal: 3
  },
  sourcesVouchersT: {
    Conduce: 4,
    Gastos_menores: 3,
    Comprobante_factura: 1,
    Comprobante_de_compra: 2
  },
  tiposPlazosValues: {
    Contado: 1,
    _7_Dias: 3,
    _15_Dias: 4,
    _30_Dias: 5,
    _60_Dias: 6,
    _90_Dias: 7,
    VencimientoManual: 2
  }
}), Ss = (e, t) => {
  const { frecuenciesValues: r } = et();
  if (t === r.Diario) {
    const n = rt(e).add(1, "day");
    return new Date(n.date());
  } else if (t === r.Semanal) {
    const n = rt(e).add(7, "day");
    return new Date(n.date());
  } else if (t === r.Quincenal) {
    const n = rt(e).add(15, "day");
    return new Date(n.date());
  } else if (t === r.Mensual) {
    const n = rt(e).add(1, "month");
    return new Date(n.date());
  } else
    return /* @__PURE__ */ new Date();
}, ld = (e) => i.jsx(Ke, { style: { justifyContent: "center" }, children: i.jsx(me, { touchable: !0, size: "large", colorPrimary: e, color: e ? void 0 : "#ff4d4f", name: e ? "circle-check-filled" : "circle-x-filled" }) });
function De(e) {
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (isNaN(t))
    return "0";
  const o = (Math.round(t * 100) / 100).toFixed(2).split(".");
  return o[0] = o[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), o.length === 1 ? `${o[0]}.00` : o[1].length === 1 ? `${o[0]}.${o[1]}0` : `${o[0]}.${o[1]}`;
}
const ot = (e, t) => i.jsx(On.Item, { label: typeof e == "string" ? i.jsx(qt, { strong: !0, children: e }) : e, children: typeof t == "string" ? i.jsx(qt, { children: t }) : t }), Pu = (e, t = !1) => t ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : e.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), dd = (e, t) => Pu(`${e}`, !0)?.includes(Pu(t, !0)), tr = (e, t) => `${t ? `${t} ` : ""}${wa.format("number", e)}`, qp = process.env.NUBETECK_SERVER_URL ?? "";
if (!qp)
  throw new Error("Please add your Server URL to environment variables.");
const J = (e) => {
  const t = localStorage.getItem("token"), r = yv.create({
    params: e,
    timeout: 1e6,
    baseURL: qp,
    headers: { Authorization: `Bearer ${t}` }
  });
  return r.interceptors.response.use((n) => n, (n) => n.response ? Promise.reject(Ru(n.response.data?.Result?.OuterException ?? "").join(" ")) : Promise.reject(Ru(n.message).join(""))), r;
}, Hp = {
  getDNITypes: async () => (await J().get("ContactosTiposDNI")).data.Result,
  getPurchaseQuantities: async (e) => (await J().post("/PagosProveedoresDetalleFacturas/CantidadDePagosPorFacturaId", { facturaId: e })).data.Result[0].CantidadDePagagos
}, wx = {
  getAll: async () => (await J().get(nt.MONEDAS)).data.Result
}, Tx = {
  getByProductId: async (e) => {
    try {
      return (await J().post("/ProductosTiposUnidadesMedidas/GetUnidadesByProductoId", { productoId: e })).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Fx = {
  getAll: async () => (await J().get(nt.ESTADOS)).data.Result
}, Ox = {
  getCreditInfo: async (e) => {
    try {
      return (await J().post("/Clientes/GetCreditInfo", {
        clientId: e
      })).data.Result[0];
    } catch (t) {
      console.error(t);
    }
  }
}, Wp = {
  getAll: async () => {
    try {
      return (await J().get("/Productos")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getFotografiaById: async (e) => {
    try {
      return (await J().post("/Productos/GetFotografiasById", {
        productoId: e
      })).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getBySearchTerm: async (e) => {
    try {
      return (await J().post("Productos/GetProductosBySearchTerm_AndIds", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getLlevaSerieTieneVencimiento: async (e) => {
    try {
      return (await J().post("/Productos/Get_LlevaSerieTieneVencimiento", {
        productoId: e
      })).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getWithSearch: async (e = "", t = "", r = "") => {
    try {
      return (await J().post("/Productos/GetProductosByCustomSearch", {
        codigo: e,
        referencia: r,
        descripcion: t
      })).data.Result;
    } catch (n) {
      console.error(n);
    }
  }
}, ud = {
  getAll: async () => {
    try {
      return (await J().get("/Contactos")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getByTipoForOptions: async (e) => {
    try {
      return (await J().post(nt.CONTACTOS_BY_TIPO, {
        tipoId: e
      })).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getDirections: async (e) => {
    try {
      return (await J().post(nt.DIRECCIONES_BY_CONTACTO, {
        contactoId: e
      })).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getFullName: async (e, t, r) => {
    try {
      return (await J().post(`/Contactos/${e === 1 ? "GetContactosClientesFullName" : "GetContactosProveedoresFullName"}`, { q: r, oldContactId: t })).data.Result;
    } catch (n) {
      console.error(n);
    }
  }
}, Gp = {
  getAll: async () => {
    try {
      return (await J().get(`${nt.RECEIPTS}?filters[TipoReciboId][$eq][0]=1`)).data.Result;
    } catch (e) {
      throw console.error(e), e;
    }
  },
  create: async (e) => {
    try {
      return (await J().post(`${nt.RECEIPTS}`, e)).data.Result;
    } catch (t) {
      throw console.error("Error al crear el recibo:", t), t;
    }
  },
  updateReceipt: async (e) => {
    try {
      return (await J().put(`${nt.RECEIPTS}/${e.ReciboId}`, e)).data.Result;
    } catch (t) {
      throw console.error("Error al anular el recibo:", t), t;
    }
  }
}, Nx = {
  getNCFOrFuentesComprobantes: async (e) => {
    try {
      return (await J().post("/TiposNCF/GetByArea", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Rx = {
  getAll: async () => (await J().get(nt.IMPUESTOS_TIPOS)).data.Result,
  getAllV2: async () => (await J().post(nt.IMPUESTOS_TIPOS_GROUP)).data.Result,
  create: async (e) => {
    try {
      return (await J().post(nt.IMPUESTOS_TIPOS, e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  update: async (e) => {
    try {
      return (await J().put(`${nt.IMPUESTOS_TIPOS}/${e.ImpuestoId}`, e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Sr = {
  getAll: async () => {
    try {
      return (await J().get("/Documentos")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/Documentos/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/Documentos", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetPrincipalInfo: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetInfoAdicional: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetRecurrenceInfo: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetInfoPayInvoice: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetTotalYProductos: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetDocumentosReferencia: async (e) => {
    try {
      return (await J().post("/GET_DETALLES_DOCUMENTO", e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  getReferencesDocuments: async (e) => {
    try {
      return (await J().post("/Documentos/_GetDocumentosReferencia", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  convertToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  clonate: async (e) => {
    try {
      return (await J().post("/Documentos/ClonarDocumento", e)).data.Result[0].DocumentoId;
    } catch (t) {
      console.error(t);
    }
  },
  convertOrdenCompraToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  convertConduceVentaToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  convertCotizacionToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  saveChanges: async (e) => {
    const t = await J().post("GUARDARCAMBIOSDOCUMENTOS", e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      throw new Error(t.data.Message);
    return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/Documentos/${e.DocumentoId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, go = {
  changeState: async (e) => (await J().put(`/Cotizaciones/${e.CotizacionId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/Cotizaciones")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/Cotizaciones/" + e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/Cotizaciones", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  convertToConduce: async (e) => {
    const t = await J().post("/Cotizaciones/ConvertirEnConduce", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  convertToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_COTIZACION, e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      se.error("Error al guardar los datos de cotización");
    else
      return t.data.Result;
  },
  clonateQuote: async (e) => {
    const t = await J().post(nt.COTIZACIONES_CLONAR, {
      CotizacionId: e
    });
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      se.error("Error al clonar la cotización");
    else
      return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/Cotizaciones/${e.CotizacionId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        se.error("Error al guardar los datos de cotización");
      else
        return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Px = {
  getAll: async () => (await J().get(nt.ALMACENES)).data.Result
}, jx = {
  getAll: async () => {
    try {
      return (await J().get("/TiposPlazos")).data.Result;
    } catch (e) {
      console.error(e);
    }
  }
}, aa = {
  changeState: async (e) => (await J().put(`/FacturasVentas/${e.FacturaId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/FacturasVentas")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/FacturasVentas/" + e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  clonateSaleInvoice: async (e) => {
    const t = await J().post(nt.FACTURAS_VENTAS_CLONAR, { FacturaId: e });
    return t.data.OperationStatus === "Failure" && se.error("Error al clonar la factura de venta"), t.data.Result;
  },
  create: async (e) => {
    try {
      const t = await J().post("/FacturasVentas", e);
      return t.data.OperationStatus === "Failure" && se.error("Error al crear la factura"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  update: async (e) => {
    try {
      const t = await J().put(`/FacturasVentas/${e.FacturaId}`, e);
      return t.data.OperationStatus === "Failure" && se.error("Error al guardar los cambios de la factura"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    try {
      const t = await J().post(nt.GUARDARCAMBIOS_FACTURAVENTA, e);
      return t.data.OperationStatus === "Failure" && se.error(t?.data?.Message), t.data.Result;
    } catch (t) {
      throw console.error(t), t;
    }
  }
}, ia = {
  changeState: async (e) => (await J().put(`/ConducesVentas/${e.ConduceId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/ConducesVentas")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/ConducesVentas/" + e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/ConducesVentas", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  convertToFacutra: async (e) => {
    try {
      const t = await J().post("CONVERTTOFACTURA", e);
      return t.data.OperationStatus === "Failure" && se.error("Error al convertir en factura"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  update: async (e) => {
    try {
      const t = await J().put(`/ConducesVentas/${e.ConduceId}`, e);
      return t.data.OperationStatus === "Failure" && se.error("Error al guardar los cambios"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    try {
      const t = await J().post(nt.GUARDARCAMBIOS_CONDUCESVENTAS, e);
      if (t.data.OperationStatus === "Failure")
        se.error("Error al guardar los cambios");
      else
        return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  clonateConduceVenta: async (e) => {
    try {
      const t = await J().post(nt.CONDUCES_VENTAS_CLONAR, { ConduceId: e });
      if (t.data.OperationStatus === "Failure")
        se.error("Error al clonar el conduce");
      else
        return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, $x = {
  getByMonedaId: async (e) => {
    try {
      return (await J().post("/TasaCambio/ObtenerTasaMasReciente", {
        monedaId: e
      })).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, vo = {
  changeState: async (e) => (await J().put(`/OrdenesCompras/${e.OrdenId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/OrdenesCompras")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/OrdenesCompras/" + e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  convertToConduce: async (e) => {
    const t = await J().post("/OrdenesCompras/ConvertirEnConduce", e);
    try {
      return t.data.OperationStatus === "Failure" && se.error("Error al convertir en conduce"), t.data.Result;
    } catch (r) {
      console.error(r);
    }
  },
  convertToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    try {
      return t.data.OperationStatus === "Failure" && se.error("Error al clonar convertir en factura"), t.data.Result;
    } catch (r) {
      console.error(r);
    }
  },
  clonatePurchaseOrder: async (e) => {
    const t = await J().post(nt.ORDENES_COMPRAS_CLONAR, { ordenId: e });
    return t.data.OperationStatus === "Failure" && se.error("Error al clonar la orden de compra"), t.data.Result;
  },
  create: async (e) => {
    try {
      const t = await J().post("/OrdenesCompras", e);
      return (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500) && se.error("Error al guardar los cambios del documento"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  update: async (e) => {
    try {
      const t = await J().put(`/OrdenesCompras/${e.OrdenId}`, e);
      return (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500) && se.error("Error al guardar los cambios del documento"), t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_ORDENCOMPRA, e);
    return (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500) && se.error("Error al guardar los cambios del documento"), t.data.Result;
  }
}, Ax = {
  getUserIdContactoId: async (e) => {
    try {
      return (await J().post("/ContactosUsers/GetContactoIdUserId", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, _x = {
  create: async (e) => (await J().post(nt.DOCUMENTOS_RECURRENTES, e)).data.Result,
  getAll: async () => (await J().post(nt.DOCUMENTOS_RECURRENTES_PROC)).data.Result
}, Kp = {
  changeState: async (e) => (await J().post(nt.DOCUMENTOS_CAMBIAR_ESTADO, e)).data.Result,
  getAll: async () => {
    try {
      const e = await J().get(nt.GET_ALL_DOCUMENTOS_VENTAS);
      return e.data.OperationStatus === "Failure" ? (ju(), []) : e.data.Result;
    } catch {
      return ju(), [];
    }
  }
}, ju = () => {
  se.error("Ha ocurrido un error al consultar la lista de documentos de ventas");
}, Mx = {
  getAll: async () => (await J().get(nt.DOCUMENTOSTIPOS)).data.Result,
  getAllByArea: async (e) => (await J().post(nt.DOCUMENTOSTIPOS_AREA_VENTAS_O_COMRAS, {
    area: e
  })).data.Result
}, Lx = {
  insertFile: async (e) => (await J().post("INSERTFILEDOCUMENT", e)).data.Result
}, sa = {
  changeState: async (e) => (await J().put(`/FacturasCompras/${e.FacturaId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/FacturasCompras")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/FacturasCompras/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/FacturasCompras", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetPrincipalInfo: async (e) => {
    try {
      const t = await J().post("/GET_DETALLES_DOCUMENTO", e);
      if (t.data.OperationStatus === "Failure")
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetInfoAdicional: async (e) => {
    try {
      const t = await J().post("/GET_DETALLES_DOCUMENTO", e);
      if (t.data.OperationStatus === "Failure")
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetTotalYProductos: async (e) => {
    try {
      const t = await J().post("/GET_DETALLES_DOCUMENTO", e);
      if (t.data.OperationStatus === "Failure")
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  detailGetDocumentosReferencia: async (e) => {
    try {
      const t = await J().post("/GET_DETALLES_DOCUMENTO", e);
      if (t.data.OperationStatus === "Failure")
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_FACTURACOMPRA, e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      throw new Error(t.data.Message);
    return t.data.Result;
  },
  clonatePurchaseInvoice: async (e) => {
    const t = await J().post(nt.FACTURAS_COMPRAS_CLONAR, { FacturaId: e });
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      throw new Error(t.data.Message);
    return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/FacturasCompras/${e.FacturaId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, ei = {
  changeState: async (e) => (await J().put(`/NotasVentas/${e.NotaVentaId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/NotasVentas")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/NotasVentas/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/NotasVentas", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  aplicateNoteSalesArea: async (e) => {
    try {
      return (await J().post(nt.NOTAS_VENTAS_APLICAR, e)).data.Result[0].NuevaNotaDebitoId;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_NOTAVENTA, e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      throw new Error(t.data.Message);
    return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/NotasVentas/${e.NotaVentaId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, ca = {
  changeState: async (e) => (await J().put(`/ConducesCompras/${e.ConduceId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/ConducesCompras")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/ConducesCompras/" + e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/ConducesCompras", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  convertToFacutra: async (e) => {
    const t = await J().post("CONVERTTOFACTURA", e);
    if (t.data.OperationStatus === "Failure")
      throw t.data.Message;
    return t.data.Result;
  },
  clonateConduceCompra: async (e) => {
    const t = await J().post(nt.CONDUCES_COMPRAS_CLONAR, { ConduceId: e });
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      se.error("Error al clonar el conduce");
    else
      return t.data.Result;
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_CONDUCESCOMPRAS, e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      se.error("Error al guardar los cambios del conduce");
    else
      return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/ConducesCompras/${e.ConduceId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Vx = {
  getInfoBasicClient: async (e) => (await J().post(nt.CLIENTE_INFO_BASICA, {
    contactoId: e
  })).data.Result[0]
}, zx = {
  getAll: async () => (await J().get(nt.PRODUCTOS_LISTAS_PRECIOS)).data.Result
}, ti = {
  changeState: async (e) => (await J().put(`/NotasDebitos/${e.NotaDebitoId}`, e)).data.Result,
  getAll: async () => {
    try {
      return (await J().get("/NotasDebitos")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  getById: async (e) => {
    try {
      return (await J().get("/NotasDebitos/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/NotasDebitos", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  aplicateDebitNote: async (e) => {
    try {
      return (await J().post(nt.NOTAS_DEBITOS_APLICAR, e)).data.Result[0].NuevaNotaDebitoId;
    } catch (t) {
      console.error(t);
    }
  },
  saveChanges: async (e) => {
    const t = await J().post(nt.GUARDARCAMBIOS_NOTADEBITO, e);
    if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
      throw new Error(t.data.Message);
    return t.data.Result;
  },
  update: async (e) => {
    try {
      const t = await J().put(`/NotasDebitos/${e.NotaDebitoId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Yp = {
  getImpuestoIncluido: async () => {
    try {
      return (await J().post("/ConfiguracionesGenerales/GetImpuestoIncluido")).data.Result[0];
    } catch (e) {
      console.error(e);
    }
  },
  getFormaPagoDefecto: async () => {
    try {
      return (await J().post("/ConfiguracionesGenerales/GetFormaPagoDefecto")).data.Result[0];
    } catch (e) {
      console.error(e);
    }
  }
}, Qp = {
  getById: async (e) => {
    try {
      return (await J().get("/FacturasVentasRecurrentes/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getAllRecurringSaleInvoices: async () => {
    try {
      return (await J().post("/FacturasVentasRecurrentes/GetAll")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/FacturasVentasRecurrentes", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  update: async (e) => {
    try {
      const t = await J().put(`/FacturasVentasRecurrentes/${e.FacturaId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Bx = {
  changeState: async (e) => (await J().post(nt.DOCUMENTOS_CAMBIAR_ESTADO, e)).data.Result,
  getAll: async () => {
    try {
      const e = await J().get(nt.GET_ALL_DOCUMENTOS_COMPRAS);
      return e.data.OperationStatus === "Failure" ? ($u(), []) : e.data.Result;
    } catch {
      return $u(), [];
    }
  }
}, $u = () => {
  se.error("Ha ocurrido un error al consultar la lista de documentos de compras");
}, kx = {
  getAll: async () => (await J().get(nt.TIPOS_FRECUENCIAS_PAGOS)).data.Result
}, Ux = {
  getFacturasVentasLotesByFactura_Producto: async (e) => {
    try {
      return (await J().post("/FacturasVentasDetallesLotes/_GetByFacturaAndProducto", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Xp = {
  getById: async (e) => {
    try {
      return (await J().get("/FacturasVentas/" + e)).data.Result.Result;
    } catch (t) {
      console.error(t);
    }
  },
  create: async (e) => {
    try {
      return (await J().post("/FacturasComprasRecurrentes", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getAllRecurringPurchaseInvoices: async () => {
    try {
      return (await J().post("/FacturasComprasRecurrentes/GetAll")).data.Result;
    } catch (e) {
      console.error(e);
    }
  },
  update: async (e) => {
    try {
      const t = await J().put(`/FacturasVentas/${e.FacturaId}`, e);
      if (t.data.OperationStatus === "Failure" || t.data.StatusCode === 500)
        throw new Error(t.data.Message);
      return t.data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, qx = {
  getAll: async () => {
    try {
      return (await J().get(nt.RECONCILE_BANKS_CASH_ACCOUNTS)).data.Result;
    } catch (e) {
      throw console.error("Error al obtener los cuadres bancos cajas:", e), e;
    }
  }
}, fd = {
  getFacturasComprasLotesByProductoId: async (e) => {
    try {
      return (await J().post("/FacturasComprasDetallesLotes/_GetLotesById", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getFacturasComprasLotesByFactura_Producto: async (e) => {
    try {
      return (await J().post("/FacturasComprasDetallesLotes/_GetByFacturaAndProducto", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  },
  getFacturasComprasDetallesSeriesByProductoId: async (e) => {
    try {
      return (await J().post("/FacturasComprasDetallesSeries/_GetSeriesByProductoId", e)).data.Result;
    } catch (t) {
      console.error(t);
    }
  }
}, Hx = (e) => Ye({
  queryKey: ["/TiposNCF/GetPorTipoDocumentoId", e],
  queryFn: () => Nx.getNCFOrFuentesComprobantes(e)
}), Zp = () => Ye({
  networkMode: "online",
  queryKey: ["tiposPlazos"],
  queryFn: jx.getAll
}), Wx = (e) => Ye({
  networkMode: "online",
  queryFn: () => Wp.getBySearchTerm(e),
  queryKey: ["/Productos/GetProductosBySearchTerm_AndIds", e]
}), Gx = (e) => Ye({
  queryKey: [Oe.PRODUCTOS, e],
  queryFn: () => Wp.getFotografiaById?.(e)
}), Es = () => Ye({
  queryFn: Fx.getAll,
  queryKey: [Oe.ESTADOS]
}), Jp = (e) => Ye({
  queryFn: () => Mx.getAllByArea?.(e),
  queryKey: [Oe.DOCUMENTOSTIPOS_AREA_VENTAS_O_COMRAS, e]
}), Kx = () => Ye({
  queryFn: Kp.getAll,
  queryKey: [Oe.DOCUMENTOS_VENTAS]
}), ri = () => Ye({
  queryFn: kx.getAll,
  queryKey: [Oe.TIPOS_FRECUENCIAS_PAGOS]
}), Yx = () => Ye({
  queryFn: zx.getAll,
  queryKey: [Oe.PRODUCTOS_LISTAS_PRECIOS]
}), la = (e, t = 0, r = "") => Ye({
  networkMode: "online",
  queryKey: ["Contacts", e, t, r],
  queryFn: () => ud.getFullName(e, t, r)
}), Qx = (e) => Ye({
  networkMode: "online",
  enabled: !!e,
  queryKey: ["Contacts", e],
  queryFn: () => ud.getDirections(e || 0)
}), Xx = (e) => Ye({
  queryKey: [Oe.CONTACTOS_BY_TIPO, e],
  queryFn: () => ud.getByTipoForOptions?.(e)
}), Zx = () => Ye({
  queryFn: Rx.getAllV2,
  queryKey: [Oe.IMPUESTOS_TIPOS_GROUP]
}), Jx = () => Ye({
  queryFn: wx.getAll,
  queryKey: [Oe.MONEDAS]
}), eS = () => Ye({
  queryFn: Px.getAll,
  queryKey: [Oe.ALMACENES]
}), tS = () => Ye({
  queryFn: qx.getAll,
  queryKey: [Oe.RECONCILE_BANKS_CASH_ACCOUNTS]
}), eh = ({ NotaDebitoId: e }) => Ye({
  networkMode: "online",
  enabled: !!e,
  queryKey: ["/NotasDebitos", e],
  queryFn: () => ti.getById(e || 0)
}), th = ({ NotaVentaId: e }) => Ye({
  networkMode: "online",
  enabled: !!e,
  queryKey: ["/NotasVentas", e],
  queryFn: () => ei.getById(e || 0)
}), rS = () => Ye({
  queryFn: Bx.getAll,
  queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
}), nS = ({ FacturaId: e }) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["/FacturasVentas", e],
  queryFn: () => aa.getById(e || 0)
}), oS = ({ ConduceId: e }) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["/ConducesCompras", e],
  queryFn: () => ca.getById(e || 0)
}), aS = () => Ye({
  queryKey: ["GetAllRecurringPurchaseDocuments"],
  queryFn: Xp.getAllRecurringPurchaseInvoices
}), iS = () => Ye({
  queryKey: ["GetAllRecurringSalesDocuments"],
  queryFn: Qp.getAllRecurringSaleInvoices
}), sS = (e) => Ye({
  networkMode: "online",
  queryKey: ["Document"],
  queryFn: () => Sr.getReferencesDocuments(e)
}), Yr = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetPrincipalInfo(e)
}), cS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetTotalYProductos(e)
}), lS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetInfoAdicional(e)
}), dS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetDocumentosReferencia(e)
}), uS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetInfoPayInvoice(e)
}), fS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/GET_DETALLES_DOCUMENTO", e],
  queryFn: () => Sr.detailGetRecurrenceInfo(e)
}), mS = (e) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["ExchangeRate", e],
  queryFn: () => $x.getByMonedaId(e)
}), pS = (e) => Ye({
  networkMode: "online",
  queryKey: ["/FacturasVentasDetallesLotes/_GetByFacturaAndProducto"],
  queryFn: () => Ux.getFacturasVentasLotesByFactura_Producto(e)
}), hS = (e) => Ye({
  networkMode: "online",
  enabled: !!e.UserId,
  queryKey: ["/ContactosUsers/GetContactoIdUserId", e],
  queryFn: () => Ax.getUserIdContactoId(e)
}), gS = ({ OrdenId: e }) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["/OrdenesCompras", e],
  queryFn: () => vo.getById(e || 0)
}), Ds = (e) => {
  const t = Ue();
  return ke({
    mutationFn: Kp.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [
          e === "Venta" ? Oe.DOCUMENTOS_VENTAS : Oe.GET_ALL_DOCUMENTOS_COMPRAS
        ]
      });
    }
  });
}, rh = () => {
  const e = Ue();
  return ke({
    mutationFn: _x.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_RECURRENTES]
      }), e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, vS = () => {
  const e = Ue();
  return ke({
    mutationFn: Gp.create,
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Oe.DOCUMENTS_RECEIPTS] });
    }
  });
}, yS = (e, t) => {
  const r = Ue();
  return ke({
    mutationFn: Gp.updateReceipt,
    onSuccess: () => {
      r.invalidateQueries({
        queryKey: ["/GET_DETALLES_DOCUMENTO", e]
      }), r.invalidateQueries({
        queryKey: ["/GET_DETALLES_DOCUMENTO", t]
      });
    }
  });
}, nh = new vv({
  defaultOptions: {
    queries: {
      gcTime: 1e3 * 60 * 60 * 24
    },
    mutations: {
      gcTime: 1e3 * 60 * 60 * 24
    }
  }
}), bS = Cv({
  storage: window.localStorage
});
bv({
  queryClient: nh,
  persister: bS
});
const oh = (e, t, r) => ke({
  mutationFn: Lx.insertFile,
  onSuccess: () => {
    nh.invalidateQueries({
      queryKey: ["Files", e, t, r]
    });
  }
}), md = {
  delete: async (e) => (await J().delete("/Files/" + e)).data.Result,
  getById: async (e) => (await J().get("/Files/" + e)).data.Result,
  getFilesByDocumentId: async (e) => (await J().post("/Documentos/GetArchivosDocumento", e)).data.Result
}, ah = (e, t, r) => {
  const n = Ue();
  return ke({
    mutationFn: md.delete,
    onSuccess: () => {
      n.invalidateQueries({
        queryKey: ["Files", e, t, r]
      });
    }
  });
}, CS = () => {
  const e = Ue();
  return ke({
    mutationFn: vo.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, IS = () => {
  const e = Ue();
  return ke({
    mutationFn: vo.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, xS = () => {
  const e = Ue();
  return ke({
    mutationFn: vo.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, SS = () => {
  const e = Ue();
  return ke({
    mutationFn: vo.clonatePurchaseOrder,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, ih = (e) => {
  const t = Ue();
  return ke({
    mutationFn: vo.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/OrdenesCompras", e]
      });
    }
  });
}, ES = () => {
  const e = Ue();
  return ke({
    mutationFn: vo.convertToConduce,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, DS = () => {
  const e = Ue();
  return ke({
    mutationFn: sa.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, wS = () => {
  const e = Ue();
  return ke({
    mutationFn: sa.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, TS = () => {
  const e = Ue();
  return ke({
    mutationFn: sa.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, FS = () => {
  const e = Ue();
  return ke({
    mutationFn: sa.clonatePurchaseInvoice,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, sh = (e) => {
  const t = Ue();
  return ke({
    mutationFn: sa.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/FacturasCompras", e]
      });
    }
  });
}, ch = () => {
  const e = Ue();
  return ke({
    mutationFn: ei.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      });
    }
  });
}, lh = () => {
  const e = Ue();
  return ke({
    mutationFn: ei.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      });
    }
  });
}, ws = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ei.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/NotasVentas", e]
      });
    }
  });
}, OS = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ei.aplicateNoteSalesArea,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/NotasVentas", e]
      });
    }
  });
}, dh = () => {
  const e = Ue();
  return ke({
    mutationFn: ti.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, uh = () => {
  const e = Ue();
  return ke({
    mutationFn: ti.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, Ts = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ti.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/NotasDebitos", e]
      });
    }
  });
}, NS = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ti.aplicateDebitNote,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/NotasDebitos", e]
      });
    }
  });
}, RS = () => {
  const e = Ue();
  return ke({
    mutationFn: ca.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, PS = () => {
  const e = Ue();
  return ke({
    mutationFn: ca.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_COMPRAS]
      });
    }
  });
}, jS = () => {
  const e = Ue();
  return ke({
    mutationFn: ca.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_COMPRAS]
      });
    }
  });
}, $S = () => {
  const e = Ue();
  return ke({
    mutationFn: ca.clonateConduceCompra,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_COMPRAS]
      });
    }
  });
}, fh = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ca.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/ConducesCompras", e]
      });
    }
  });
}, AS = (e) => {
  const t = Ue();
  return ke({
    mutationFn: Xp.create,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      }), t.invalidateQueries({
        queryKey: ["/FacturasCompras", e]
      });
    }
  });
}, _S = (e) => {
  const t = Ue();
  return ke({
    mutationFn: Qp.create,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/FacturasVentas", e]
      });
    }
  });
}, Fs = ({ isOpen: e, methodOk: t, setIsOpen: r, formRecurring: n, changeStateLoading: o }) => {
  const a = ri(), [s, c] = ja(!1), l = (u) => (c(u), u || n.setFieldValue("CantidadVeces", null), u), d = (u) => u;
  return i.jsx(i.Fragment, { children: i.jsx(Rn, { width: 550, open: e, title: "Recurrencia", maskClosable: !1, closable: !o, onCancel: () => r(!1), onOk: () => {
    n.validateFields().then(() => {
      t();
    }).catch(() => {
    });
  }, children: i.jsxs(Vt, { layout: "vertical", form: n, style: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between"
  }, children: [i.jsx(Vt.Item, { name: "FechaInicio", style: { width: "48%" }, label: "Fecha de inicio", rules: [
    {
      required: !0,
      message: "Por favor, seleccione la fecha de inicio"
    }
  ], children: i.jsx(Kt, { size: "large", id: "datePicker-1", format: "MM/DD/YYYY", style: { width: "100%" } }) }), i.jsx(Vt.Item, { label: "Frecuencia", name: "FrecuenciaId", style: { width: "48%" }, rules: [
    {
      required: !0,
      message: "Por favor, seleccione la frecuencia"
    }
  ], children: i.jsx(Ht, { size: "large", onChange: d, placeholder: "Seleccione la frecuencia", options: a.data?.map((u) => ({
    value: u.FrecuenciaPagoId,
    label: u.FrecuenciaPagoNombre
  })) }) }), i.jsxs(Ke, { style: {
    width: "100%",
    justifyContent: "space-between"
  }, children: [i.jsx(Vt.Item, { name: "EsLimitado", label: "Es limitado", style: { flex: 1 }, children: i.jsx(ec, { onChange: l, defaultChecked: !1 }) }), i.jsx(Vt.Item, { style: { flex: 1 }, name: "EnviarPorCorreo", label: "Enviar por correo", children: i.jsx(ec, { defaultChecked: !1 }) }), i.jsx(Vt.Item, { style: { flex: 1 }, name: "CrearComoBorrador", label: "Crear como borrador", children: i.jsx(ec, { defaultChecked: !1 }) })] }), s && i.jsx(Vt.Item, { name: "CantidadVeces", style: { width: "48%" }, label: "Cantidad de veces", rules: [
    s ? {
      required: !0,
      message: "Por favor, seleccione la frecuencia"
    } : {}
  ], children: i.jsx(Vn, { size: "large", type: "number", style: { width: "100%" } }) })] }) }) });
};
var MS = typeof jo == "object" && jo && jo.Object === Object && jo, LS = typeof self == "object" && self && self.Object === Object && self;
MS || LS || Function("return this")();
var VS = typeof window < "u" ? _f : xr, zS = typeof window > "u";
function sr(e, t) {
  const r = typeof t == "boolean" ? t : t?.defaultValue ?? !1, n = typeof t == "boolean" ? void 0 : t?.initializeWithValue ?? void 0, [o, a] = ja(() => n ? s(e) : r), s = (l) => zS ? r : window.matchMedia(l).matches;
  function c() {
    a(s(e));
  }
  return VS(() => {
    const l = window.matchMedia(e);
    return c(), l.addListener ? l.addListener(c) : l.addEventListener("change", c), () => {
      l.removeListener ? l.removeListener(c) : l.removeEventListener("change", c);
    };
  }, [e]), o;
}
const Au = (e) => typeof e == "object" && e != null && e.nodeType === 1, _u = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", Cc = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const r = getComputedStyle(e, null);
    return _u(r.overflowY, t) || _u(r.overflowX, t) || ((n) => {
      const o = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView)
          return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(n);
      return !!o && (o.clientHeight < n.scrollHeight || o.clientWidth < n.scrollWidth);
    })(e);
  }
  return !1;
}, Ni = (e, t, r, n, o, a, s, c) => a < e && s > t || a > e && s < t ? 0 : a <= e && c <= r || s >= t && c >= r ? a - e - n : s > t && c < r || a < e && c > r ? s - t + o : 0, BS = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, Mu = (e, t) => {
  var r, n, o, a;
  if (typeof document > "u")
    return [];
  const { scrollMode: s, block: c, inline: l, boundary: d, skipOverflowHiddenElements: u } = t, f = typeof d == "function" ? d : (A) => A !== d;
  if (!Au(e))
    throw new TypeError("Invalid target");
  const h = document.scrollingElement || document.documentElement, g = [];
  let E = e;
  for (; Au(E) && f(E); ) {
    if (E = BS(E), E === h) {
      g.push(E);
      break;
    }
    E != null && E === document.body && Cc(E) && !Cc(document.documentElement) || E != null && Cc(E, u) && g.push(E);
  }
  const v = (n = (r = window.visualViewport) == null ? void 0 : r.width) != null ? n : innerWidth, m = (a = (o = window.visualViewport) == null ? void 0 : o.height) != null ? a : innerHeight, { scrollX: y, scrollY: I } = window, { height: b, width: C, top: S, right: T, bottom: N, left: V } = e.getBoundingClientRect(), { top: D, right: x, bottom: O, left: w } = ((A) => {
    const R = window.getComputedStyle(A);
    return { top: parseFloat(R.scrollMarginTop) || 0, right: parseFloat(R.scrollMarginRight) || 0, bottom: parseFloat(R.scrollMarginBottom) || 0, left: parseFloat(R.scrollMarginLeft) || 0 };
  })(e);
  let j = c === "start" || c === "nearest" ? S - D : c === "end" ? N + O : S + b / 2 - D + O, $ = l === "center" ? V + C / 2 - w + x : l === "end" ? T + x : V - w;
  const _ = [];
  for (let A = 0; A < g.length; A++) {
    const R = g[A], { height: P, width: z, top: F, right: L, bottom: M, left: B } = R.getBoundingClientRect();
    if (s === "if-needed" && S >= 0 && V >= 0 && N <= m && T <= v && S >= F && N <= M && V >= B && T <= L)
      return _;
    const W = getComputedStyle(R), ee = parseInt(W.borderLeftWidth, 10), te = parseInt(W.borderTopWidth, 10), de = parseInt(W.borderRightWidth, 10), Z = parseInt(W.borderBottomWidth, 10);
    let ce = 0, Y = 0;
    const he = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - ee - de : 0, ve = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - te - Z : 0, ue = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : z / R.offsetWidth : 0, le = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : P / R.offsetHeight : 0;
    if (h === R)
      ce = c === "start" ? j : c === "end" ? j - m : c === "nearest" ? Ni(I, I + m, m, te, Z, I + j, I + j + b, b) : j - m / 2, Y = l === "start" ? $ : l === "center" ? $ - v / 2 : l === "end" ? $ - v : Ni(y, y + v, v, ee, de, y + $, y + $ + C, C), ce = Math.max(0, ce + I), Y = Math.max(0, Y + y);
    else {
      ce = c === "start" ? j - F - te : c === "end" ? j - M + Z + ve : c === "nearest" ? Ni(F, M, P, te, Z + ve, j, j + b, b) : j - (F + P / 2) + ve / 2, Y = l === "start" ? $ - B - ee : l === "center" ? $ - (B + z / 2) + he / 2 : l === "end" ? $ - L + de + he : Ni(B, L, z, ee, de + he, $, $ + C, C);
      const { scrollLeft: Fe, scrollTop: He } = R;
      ce = le === 0 ? 0 : Math.max(0, Math.min(He + ce / le, R.scrollHeight - P / le + ve)), Y = ue === 0 ? 0 : Math.max(0, Math.min(Fe + Y / ue, R.scrollWidth - z / ue + he)), j += He - ce, $ += Fe - Y;
    }
    _.push({ el: R, top: ce, left: Y });
  }
  return _;
}, kS = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function US(e, t) {
  if (!e.isConnected || !((o) => {
    let a = o;
    for (; a && a.parentNode; ) {
      if (a.parentNode === document)
        return !0;
      a = a.parentNode instanceof ShadowRoot ? a.parentNode.host : a.parentNode;
    }
    return !1;
  })(e))
    return;
  const r = ((o) => {
    const a = window.getComputedStyle(o);
    return { top: parseFloat(a.scrollMarginTop) || 0, right: parseFloat(a.scrollMarginRight) || 0, bottom: parseFloat(a.scrollMarginBottom) || 0, left: parseFloat(a.scrollMarginLeft) || 0 };
  })(e);
  if (((o) => typeof o == "object" && typeof o.behavior == "function")(t))
    return t.behavior(Mu(e, t));
  const n = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: o, top: a, left: s } of Mu(e, kS(t))) {
    const c = a - r.top + r.bottom, l = s - r.left + r.right;
    o.scroll({ top: c, left: l, behavior: n });
  }
}
const qS = ["parentNode"], HS = "form_item";
function Pa(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function mh(e, t) {
  if (!e.length)
    return;
  const r = e.join("_");
  return t ? `${t}_${r}` : qS.includes(r) ? `${HS}_${r}` : r;
}
function ph(e, t, r, n, o, a) {
  let s = n;
  return a !== void 0 ? s = a : r.validating ? s = "validating" : e.length ? s = "error" : t.length ? s = "warning" : (r.touched || o && r.validated) && (s = "success"), s;
}
function Lu(e) {
  return Pa(e).join("_");
}
function Os(e) {
  const [t] = sd(), r = p.useRef({}), n = p.useMemo(() => e ?? Object.assign(Object.assign({}, t), {
    __INTERNAL__: {
      itemRef: (o) => (a) => {
        const s = Lu(o);
        a ? r.current[s] = a : delete r.current[s];
      }
    },
    scrollToField: function(o) {
      let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const s = Pa(o), c = mh(s, n.__INTERNAL__.name), l = c ? document.getElementById(c) : null;
      l && US(l, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, a));
    },
    getFieldInstance: (o) => {
      const a = Lu(o);
      return r.current[a];
    }
  }), [e, t]);
  return [n];
}
const Ri = {};
function WS(e) {
  let {
    name: t
  } = e;
  const r = ur("Form");
  xr(() => {
    if (t)
      return Ri[t] = (Ri[t] || 0) + 1, process.env.NODE_ENV !== "production" && r(Ri[t] <= 1, "usage", "There exist multiple Form with same `name`."), () => {
        Ri[t] -= 1;
      };
  }, [t]);
}
const GS = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), KS = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), hh = function(e, t, r, n) {
  const a = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${a}${e}-enter,
      ${a}${e}-appear
    `]: Object.assign(Object.assign({}, GS(n)), {
      animationPlayState: "paused"
    }),
    [`${a}${e}-leave`]: Object.assign(Object.assign({}, KS(n)), {
      animationPlayState: "paused"
    }),
    [`
      ${a}${e}-enter${e}-enter-active,
      ${a}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${a}${e}-leave${e}-leave-active`]: {
      animationName: r,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, YS = new er("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), QS = new er("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), XS = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: r
  } = e, n = `${r}-fade`, o = t ? "&" : "";
  return [hh(n, YS, QS, e.motionDurationMid, t), {
    [`
        ${o}${n}-enter,
        ${o}${n}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${o}${n}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, pd = new er("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), ZS = new er("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), Vu = new er("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zu = new er("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), JS = new er("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), eE = new er("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), tE = new er("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), rE = new er("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), nE = new er("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), oE = new er("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), aE = new er("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), iE = new er("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), sE = {
  zoom: {
    inKeyframes: pd,
    outKeyframes: ZS
  },
  "zoom-big": {
    inKeyframes: Vu,
    outKeyframes: zu
  },
  "zoom-big-fast": {
    inKeyframes: Vu,
    outKeyframes: zu
  },
  "zoom-left": {
    inKeyframes: tE,
    outKeyframes: rE
  },
  "zoom-right": {
    inKeyframes: nE,
    outKeyframes: oE
  },
  "zoom-up": {
    inKeyframes: JS,
    outKeyframes: eE
  },
  "zoom-down": {
    inKeyframes: aE,
    outKeyframes: iE
  }
}, cE = (e, t) => {
  const {
    antCls: r
  } = e, n = `${r}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = sE[t];
  return [hh(n, o, a, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${n}-enter,
        ${n}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${n}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, lE = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), gh = lE, dE = (e) => {
  const {
    componentCls: t
  } = e, r = `${t}-show-help`, n = `${t}-show-help-item`;
  return {
    [r]: {
      // Explain holder
      transition: `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [n]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationSlow} ${e.motionEaseInOut},
                     opacity ${e.motionDurationSlow} ${e.motionEaseInOut},
                     transform ${e.motionDurationSlow} ${e.motionEaseInOut} !important`,
        [`&${n}-appear, &${n}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${n}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, uE = dE, fE = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${Me(e.controlOutlineWidth)} ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), Bu = (e, t) => {
  const {
    formItemCls: r
  } = e;
  return {
    [r]: {
      [`${r}-label > label`]: {
        height: t
      },
      [`${r}-control-input`]: {
        minHeight: t
      }
    }
  };
}, mE = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: Object.assign(Object.assign(Object.assign({}, ho(e)), fE(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, Bu(e, e.controlHeightSM)),
      "&-large": Object.assign({}, Bu(e, e.controlHeightLG))
    })
  };
}, pE = (e) => {
  const {
    formItemCls: t,
    iconCls: r,
    componentCls: n,
    rootPrefixCls: o,
    labelRequiredMarkColor: a,
    labelColor: s,
    labelFontSize: c,
    labelHeight: l,
    labelColonMarginInlineStart: d,
    labelColonMarginInlineEnd: u,
    itemMarginBottom: f
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, ho(e)), {
      marginBottom: f,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden.${o}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: e.lineHeight,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: l,
          color: s,
          fontSize: c,
          [`> ${r}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${t}-required:not(${t}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: e.marginXXS,
            color: a,
            fontSize: e.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${n}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`${n}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: d,
            marginInlineEnd: u
          },
          [`&${t}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${o}-col-'"]):not([class*="' ${o}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: pd,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, hE = (e) => {
  const {
    componentCls: t,
    formItemCls: r
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${r}-label`]: {
        flexGrow: 0
      },
      [`${r}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${r}-label[class$='-24'], ${r}-label[class*='-24 ']`]: {
        [`& + ${r}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, gE = (e) => {
  const {
    componentCls: t,
    formItemCls: r
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [r]: {
        flex: "none",
        marginInlineEnd: e.margin,
        marginBottom: 0,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${r}-label,
        > ${r}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${r}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${r}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, Po = (e) => ({
  padding: e.verticalLabelPadding,
  margin: e.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), vE = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    rootPrefixCls: n
  } = e;
  return {
    [`${r} ${r}-label`]: Po(e),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${t}:not(${t}-inline)`]: {
      [r]: {
        flexWrap: "wrap",
        [`${r}-label, ${r}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${n}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, yE = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    rootPrefixCls: n
  } = e;
  return {
    [`${t}-vertical`]: {
      [r]: {
        "&-row": {
          flexDirection: "column"
        },
        "&-label > label": {
          height: "auto"
        },
        [`${t}-item-control`]: {
          width: "100%"
        }
      }
    },
    [`${t}-vertical ${r}-label,
      .${n}-col-24${r}-label,
      .${n}-col-xl-24${r}-label`]: Po(e),
    [`@media (max-width: ${Me(e.screenXSMax)})`]: [vE(e), {
      [t]: {
        [`.${n}-col-xs-24${r}-label`]: Po(e)
      }
    }],
    [`@media (max-width: ${Me(e.screenSMMax)})`]: {
      [t]: {
        [`.${n}-col-sm-24${r}-label`]: Po(e)
      }
    },
    [`@media (max-width: ${Me(e.screenMDMax)})`]: {
      [t]: {
        [`.${n}-col-md-24${r}-label`]: Po(e)
      }
    },
    [`@media (max-width: ${Me(e.screenLGMax)})`]: {
      [t]: {
        [`.${n}-col-lg-24${r}-label`]: Po(e)
      }
    }
  };
}, bE = (e) => ({
  labelRequiredMarkColor: e.colorError,
  labelColor: e.colorTextHeading,
  labelFontSize: e.fontSize,
  labelHeight: e.controlHeight,
  labelColonMarginInlineStart: e.marginXXS / 2,
  labelColonMarginInlineEnd: e.marginXS,
  itemMarginBottom: e.marginLG,
  verticalLabelPadding: `0 0 ${e.paddingXS}px`,
  verticalLabelMargin: 0
}), vh = (e, t) => fr(e, {
  formItemCls: `${e.componentCls}-item`,
  rootPrefixCls: t
}), hd = Cn("Form", (e, t) => {
  let {
    rootPrefixCls: r
  } = t;
  const n = vh(e, r);
  return [mE(n), pE(n), uE(n), hE(n), gE(n), yE(n), gh(n), pd];
}, bE, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
});
var CE = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const IE = (e, t) => {
  const r = p.useContext(Qa), {
    getPrefixCls: n,
    direction: o,
    form: a
  } = p.useContext(Mt), {
    prefixCls: s,
    className: c,
    rootClassName: l,
    size: d,
    disabled: u = r,
    form: f,
    colon: h,
    labelAlign: g,
    labelWrap: E,
    labelCol: v,
    wrapperCol: m,
    hideRequiredMark: y,
    layout: I = "horizontal",
    scrollToFirstError: b,
    requiredMark: C,
    onFinishFailed: S,
    name: T,
    style: N,
    feedbackIcons: V,
    variant: D
  } = e, x = CE(e, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), O = od(d), w = p.useContext(Wm);
  process.env.NODE_ENV !== "production" && WS(e);
  const j = $a(() => C !== void 0 ? C : y ? !1 : a && a.requiredMark !== void 0 ? a.requiredMark : !0, [y, C, a]), $ = h ?? a?.colon, _ = n("form", s), A = xs(_), [R, P, z] = hd(_, A), F = we(_, `${_}-${I}`, {
    [`${_}-hide-required-mark`]: j === !1,
    [`${_}-rtl`]: o === "rtl",
    [`${_}-${O}`]: O
  }, z, A, P, a?.className, c, l), [L] = Os(f), {
    __INTERNAL__: M
  } = L;
  M.name = T;
  const B = $a(() => ({
    name: T,
    labelAlign: g,
    labelCol: v,
    labelWrap: E,
    wrapperCol: m,
    vertical: I === "vertical",
    colon: $,
    requiredMark: j,
    itemRef: M.itemRef,
    form: L,
    feedbackIcons: V
  }), [T, g, v, m, I, $, j, L, V]);
  p.useImperativeHandle(t, () => L);
  const W = (te, de) => {
    if (te) {
      let Z = {
        block: "nearest"
      };
      typeof te == "object" && (Z = te), L.scrollToField(de, Z);
    }
  }, ee = (te) => {
    if (S?.(te), te.errorFields.length) {
      const de = te.errorFields[0].name;
      if (b !== void 0) {
        W(b, de);
        return;
      }
      a && a.scrollToFirstError !== void 0 && W(a.scrollToFirstError, de);
    }
  };
  return R(/* @__PURE__ */ p.createElement(Ap.Provider, {
    value: D
  }, /* @__PURE__ */ p.createElement(ep, {
    disabled: u
  }, /* @__PURE__ */ p.createElement(Xa.Provider, {
    value: O
  }, /* @__PURE__ */ p.createElement(HI, {
    // This is not list in API, we pass with spread
    validateMessages: w
  }, /* @__PURE__ */ p.createElement(An.Provider, {
    value: B
  }, /* @__PURE__ */ p.createElement(oa, Object.assign({
    id: T
  }, x, {
    name: T,
    onFinishFailed: ee,
    form: L,
    style: Object.assign(Object.assign({}, a?.style), N),
    className: F
  }))))))));
}, xE = /* @__PURE__ */ p.forwardRef(IE);
process.env.NODE_ENV !== "production" && (xE.displayName = "Form");
const Vo = (e) => {
  let t;
  do
    t = Math.floor(Math.random() * 1e3);
  while (e.includes(t));
  return t;
}, Ns = ({ FotoGrafia: e, DataHeader: t }) => {
  const n = {
    items: [
      {
        key: "1",
        label: "Producto",
        children: i.jsx("p", { children: t.Referencia })
      },
      {
        key: "2",
        label: "Cantidad",
        children: i.jsx("p", { children: t.Cantidad })
      },
      {
        key: "3",
        label: "Restante",
        children: i.jsx("p", { children: t.Restante })
      }
    ],
    size: "small",
    bordered: !0,
    layout: "horizontal",
    labelStyle: { paddingTop: 4, paddingBottom: 4 },
    contentStyle: { paddingTop: 4, paddingBottom: 4 },
    column: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }
  };
  return i.jsxs(ir.Compact, { style: { display: "flex", flexDirection: "row" }, children: [i.jsx(Ml, { size: 133, shape: "square", src: e && e?.Data }), i.jsx(pr, { ...n, style: { flex: "1" }, labelStyle: { textAlign: "center" } })] });
}, Rs = ({ TypeFooter: e, CondComplete: t }) => {
  const r = e == "Serie" ? "Las series han sido completadas" : "Los lotes han sido completados", n = e == "Serie" ? "Series incompletas en este detalle" : "Lotes incompletos en este detalle";
  return i.jsx("div", { children: t ? i.jsx(zo, { showIcon: !0, type: "error", message: n }) : i.jsx(zo, { showIcon: !0, type: "success", message: r }) });
}, yh = Ee(Vn)`
	width: 80px;
	font-size: 12px;
	text-align: center;
`, bh = Ee(Hr)`
	width: 120px;
	font-size: 12px;
	text-align: center;
`, SE = Ee(Kt)`
	width: 110px;
	font-size: 12px;
`, _n = Ee(to)`
	background: transparent;
	border: none;
	border-style: none;
`, Ch = Ee(K)`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
`, Ih = Ee.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
`;
Ee(to)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;
const EE = Ee.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	padding: 8px;
	border-radius: 8px;
`, ku = (e) => {
  const t = e?.DetalleSeries?.length || 0;
  return e.UnidadMedidaId == 1 ? e?.Cantidad - t : 1 - t;
}, DE = ({ title: e, index: t, record: r, editing: n, children: o, dataIndex: a, dataCurrentDetail: s, ...c }) => {
  const l = i.jsx(bh, { size: "small" });
  return console.log(e, r, t, o, a), i.jsx("td", { ...c, children: n ? i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx(K.Item, { name: "NumeroSerie", style: { margin: 0 }, initialValue: r.NumeroSerie, rules: [
    { required: !0, message: "Debe ingresar el no. De serie" },
    {
      min: 9,
      message: "La serie no debe ser menor a 9 dígitos"
    },
    {
      max: 13,
      message: "La serie no debe ser mayor a 13 dígitos"
    },
    (d) => ({
      validator(u, f) {
        return s?.DetalleSeries?.map((h) => h.NumeroSerie).includes(f) ? Promise.reject(new Error("El número de serie debe ser único.")) : Promise.resolve();
      }
    })
  ], children: l }) }) : o });
}, wE = ({ openDrawer: e, FotoGrafia: t, onCloseDrawer: r, setDataSource: n, dataCurrentDetail: o }) => {
  const [a] = Os(), [s] = K.useForm(), c = k.useRef(null), [l, d] = k.useState(o?.DetalleSeries?.map((C, S) => ({ ...C, Key: S })) || []), [u, f] = k.useState(), h = (C) => C.Key === u;
  k.useEffect(() => {
    if (o.Cantidad < l.length) {
      const C = l.length + 1 - o.Cantidad, S = l.splice(-C, C);
      d(S);
    }
  }, [o.Cantidad, l]), k.useEffect(() => {
    n((C) => {
      const S = C.findIndex((N) => N.Key == o.Key), T = C;
      return T[S].DetalleSeries = l, [...T];
    });
  }, [l, n, o.Key]);
  const g = (C) => {
    if (C.key === "Enter") {
      if ((o?.DetalleSeries?.length || 0) < o.Cantidad) {
        const S = a.getFieldValue("NumeroSerie");
        console.log(S.length, "serie"), S.length >= 9 || S.length < 13 ? d((T) => {
          const N = T.map((V) => V.Key) || [1];
          return [
            ...T,
            {
              NumeroSerie: S,
              Key: Vo(N),
              DetalleId: o.DocumentoDetalleId,
              FacturaDetalleId: o.DocumentoDetalleId
            }
          ];
        }) : se.error("El número de serie debe ser entre 9 y 13 digitos");
      }
      a.resetFields();
    }
  }, E = async (C) => {
    try {
      const S = await s.validateFields();
      d((T) => {
        const N = T.findIndex((D) => D.Key === C.Key) || 0, V = T;
        return V[N] = {
          ...V[N],
          NumeroSerie: S.NumeroSerie
        }, [...V];
      }), a.resetFields(), f(void 0);
    } catch {
      se.error("Datos invalidos");
    }
  }, v = (C) => {
    o && d((S) => [...S.filter((V) => V.Key !== C)]);
  }, m = (C) => {
    s.setFieldsValue({
      NumeroSerie: C.NumeroSerie
    }), f(C.Key);
  }, y = () => {
    f(void 0);
  }, b = [
    {
      title: "Número",
      key: "NumeroSerie",
      dataIndex: "NumeroSerie"
    },
    {
      title: "",
      align: "center",
      dataIndex: "operation",
      render: (C, S) => h(S) ? i.jsxs("span", { children: [i.jsx(ds.Link, { style: { marginRight: 8 }, onClick: () => E(S), children: i.jsx(me, { name: "checks" }) }), i.jsx(us, { onConfirm: y, title: "Deseas cancelar?", children: i.jsx(me, { name: "x" }) })] }) : i.jsxs(i.Fragment, { children: [i.jsx(_n, { size: "small", disabled: u == 0, onClick: () => m({ ...S }), children: i.jsx(me, { size: 18, name: "edit" }) }), i.jsx(_n, { size: "small", onClick: () => v(S.Key), children: i.jsx(me, { size: 18, name: "trash" }) })] })
    }
  ].map((C) => C.editable ? {
    ...C,
    onCell: (S) => ({
      record: S,
      title: C.title,
      inputType: "text",
      dataSeries: l,
      dataIndex: C.dataIndex,
      editing: h(S),
      dataCurrentDetail: o
    })
  } : C);
  return i.jsx(Ga, { width: 460, open: e, onClose: () => r(), footer: o.Cantidad == 0 ? void 0 : i.jsx(Rs, { TypeFooter: "Serie", CondComplete: ku(o) > 0 }), title: i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("span", { style: { fontSize: "21px", marginLeft: "8px", fontWeight: "bold" }, children: "Asignación de número de serie" }) }), children: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "column"
  }, children: [i.jsx(Ns, { FotoGrafia: t, DataHeader: {
    Cantidad: o.Cantidad,
    Referencia: o.Referencia,
    Restante: ku(o)
  } }), i.jsx("div", { style: { marginTop: "20px" }, children: i.jsx(K, { form: a, layout: "vertical", style: { width: "70%" }, children: i.jsx(K.Item, { name: "NumeroSerie", label: i.jsx("span", { style: {
    fontSize: "15px",
    fontWeight: "bold"
  }, children: "No. para asignar:" }), rules: [
    (o?.DetalleSeries?.length || 0) < o?.Cantidad && {
      required: !0,
      message: "Debe ingresar el no. De serie"
    } || {},
    {
      min: 9,
      message: "La serie no debe ser menor a 9 dígitos"
    },
    {
      max: 13,
      message: "La serie no debe ser mayor a 13 dígitos"
    },
    (C) => ({
      validator(S, T) {
        return o?.DetalleSeries?.map((N) => N.NumeroSerie).includes(T) ? Promise.reject(new Error("El número de serie debe ser único.")) : Promise.resolve();
      }
    })
  ], children: i.jsx("div", { children: i.jsx(Hr, { ref: c, onKeyDown: (C) => a.validateFields().then(() => {
    g(C);
  }).catch(() => {
  }), disabled: o.UnidadMedidaId !== 1 && (o?.DetalleSeries?.length || 0) > 0 || (o?.DetalleSeries?.length || 0) === o?.Cantidad }) }) }) }) }), i.jsxs("div", { style: {
    width: "70%"
  }, children: [i.jsx("div", { style: { marginBottom: "5px" }, children: i.jsx("span", { style: {
    fontSize: "15px",
    fontWeight: "bold",
    marginBottom: "5px"
  }, children: "No. Asignados:" }) }), i.jsx("div", { style: { marginTop: "30px" }, children: i.jsx(K, { form: s, children: i.jsx(mo, { bordered: !0, size: "small", dataSource: l, rowClassName: "editable-row", columns: b, pagination: {
    onChange: y
  }, components: {
    body: {
      cell: DE
    }
  }, title: () => i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("strong", { style: { fontSize: "17px", marginLeft: "9px" }, children: "Lista de series agregadas:" }) }), locale: {
    emptyText: i.jsxs("div", { style: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }, children: [i.jsx(me, { name: "hourglass-empty" }), i.jsx("div", { style: { width: "100%" }, children: i.jsx("strong", { children: "No has agregado ningun lote" }) })] })
  } }) }) })] })] }) });
}, xh = ({ Text: e }) => i.jsx("div", { style: {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
}, children: i.jsx("strong", { style: {
  fontSize: "17px",
  marginLeft: "3px",
  fontWeight: "bold"
}, children: e }) }), TE = (e) => Ye({
  networkMode: "online",
  queryKey: ["/FacturasComprasDetallesLotes/_GetLotesById"],
  queryFn: () => fd.getFacturasComprasLotesByProductoId(e)
}), Sh = (e) => Ye({
  networkMode: "online",
  enabled: !!e.ProductoId,
  queryKey: ["/FacturasComprasDetallesSeries/_GetSeriesByProductoId", e],
  queryFn: () => fd.getFacturasComprasDetallesSeriesByProductoId(e)
}), Eh = (e) => Ye({
  networkMode: "online",
  queryKey: ["/FacturasComprasDetallesLotes/_GetByFacturaAndProducto"],
  queryFn: () => fd.getFacturasComprasLotesByFactura_Producto(e)
}), FE = ({ title: e, index: t, record: r, editing: n, children: o, dataIndex: a, inputType: s, dataCurrentDetail: c, ...l }) => {
  const [d, u] = k.useState(!1), f = c?.FacturaCompraDetalleLotes?.filter((E) => E?.Key != r?.Key)?.reduce((E, v) => E + (v?.Cantidad || 0), 0) || 0, h = c?.Cantidad - f;
  console.log(e, t);
  const g = s === "number" ? i.jsx(yh, { size: "small" }) : s === "text" ? i.jsx(bh, { size: "small" }) : i.jsx(SE, { size: "small", allowClear: !1 });
  return i.jsx("td", { ...l, children: n ? i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(K.Item, { name: a, style: { margin: 0 }, initialValue: a === "Numero" ? r.Numero : a === "Cantidad" ? r.Cantidad : a === "Vencimiento" ? r.Vencimiento : null, rules: s === "text" ? [
    {
      required: !0,
      message: "Requerido"
    },
    {
      min: 9,
      message: "Mín 9"
    },
    {
      max: 13,
      message: "Max 13"
    },
    (E) => ({
      validator(v, m) {
        return c?.FacturaCompraDetalleLotes?.filter((y) => y.Key !== r.Key).map((y) => y.Numero).includes(m) ? Promise.reject(new Error("Repetido")) : Promise.resolve();
      }
    })
  ] : s === "date" ? [
    {
      required: !0,
      message: "req"
    }
  ] : s === "number" ? [
    {
      required: !0,
      message: "Req"
    },
    (E) => ({
      validator(v, m) {
        return c.Cantidad - f, m > h ? (u(!0), Promise.reject(new Error(""))) : (u(!1), Promise.resolve());
      }
    })
  ] : [], children: g }), d ? i.jsx(Ar, { title: h > 0 ? `Solo ${h === 1 ? "queda" : "quedan"}, ${h} ${h === 1 ? "unidad" : "unidades"} ${h === 1 ? "restante" : "restantes"}` : "No quedan unidades", children: i.jsx(me, { size: 15, color: "red", name: "alert-circle-filled" }) }) : null] }) : o });
}, OE = ({ FotoGrafia: e, drawerLotes: t, setDataSource: r, setDrawerLotes: n, dataCurrentDetail: o }) => {
  const [a, s] = k.useState(o?.FacturaCompraDetalleLotes || []), c = Eh({
    ProductoId: o.ProductoId,
    FacturaId: o.DocumentoId
  });
  k.useEffect(() => {
    s(c?.data?.map((O) => ({
      Key: 1,
      LoteId: O.LoteId,
      Numero: O.Numero,
      Cantidad: O.Cantidad,
      Vencimiento: bt(O.Vencimiento),
      ProductoId: o.ProductoId,
      FacturaDetalleLoteId: O.FacturaCompraDetalleLoteId || 0
    })) || []);
  }, []), k.useEffect(() => {
    const O = a.reduce((w, j) => w + j.Cantidad, 0);
    if (O > o.Cantidad) {
      let w = O;
      const j = a.map(($) => {
        if (w <= o.Cantidad)
          return $;
        {
          const _ = w - o.Cantidad;
          return w -= _, {
            ...$,
            Cantidad: $.Cantidad - _
          };
        }
      }).filter(($) => $.Cantidad > 0);
      s(j);
    }
  }, [a, o.Cantidad]), k.useEffect(() => {
    r((O) => {
      const w = O.findIndex(($) => $.Key == o.Key), j = O;
      return j[w].FacturaCompraDetalleLotes = a, [...j];
    });
  }, [a, r, o.Key]);
  const [l, d] = k.useState(!1), [u] = K.useForm(), [f] = K.useForm(), h = o?.FacturaCompraDetalleLotes?.reduce((O, w) => O + (w.Cantidad || 0), 0) || 0, g = o.Cantidad - h;
  k.useEffect(() => {
    g == 0 && u.resetFields();
  }, [g, u]);
  const E = K.useWatch("Numero", u), v = K.useWatch("Cantidad", u), m = K.useWatch("Vencimiento", u), [y, I] = k.useState(), b = (O) => O.Key === y, C = (O) => {
    f.setFieldsValue({
      Numero: O.Numero,
      Cantidad: O.Cantidad,
      Vencimiento: O.Vencimiento
    }), I(O.Key);
  }, S = () => {
    I(void 0);
  }, T = () => {
    s((O) => {
      const w = u.getFieldsValue(), j = O.map(($) => $.Key) || [1];
      return [
        ...O,
        {
          LoteId: 0,
          Numero: w.Numero,
          FacturaDetalleLoteId: 0,
          Cantidad: w.Cantidad,
          Vencimiento: w.Vencimiento,
          Key: Vo(j),
          ProductoId: o.ProductoId
        }
      ];
    }), l && d(!1), u.resetFields();
  }, N = async (O) => {
    try {
      const w = await f.validateFields();
      s((j) => {
        const $ = j.findIndex((A) => A.Key === O.Key) || 0, _ = j;
        return _[$] = {
          ..._[$],
          Numero: w.Numero,
          Cantidad: w.Cantidad,
          Vencimiento: w.Vencimiento
        }, [..._];
      }), l && d(!1), u.resetFields(), I(void 0);
    } catch {
      se.error("Datos invalidos");
    }
  }, V = (O) => {
    o && s((w) => [...w.filter((_) => _.Key !== O)]);
  }, x = [
    {
      key: "Numero",
      editable: !0,
      title: "Número",
      dataIndex: "Numero"
    },
    {
      editable: !0,
      key: "Cantidad",
      align: "center",
      title: "Cantidad",
      dataIndex: "Cantidad"
    },
    {
      editable: !0,
      align: "center",
      key: "Vencimiento",
      title: "Vencimiento",
      dataIndex: "Vencimiento",
      render: (O) => rt(O).format("DD/MM/YYYY")
    },
    {
      title: "",
      align: "center",
      dataIndex: "operation",
      render: (O, w) => b(w) ? i.jsxs("span", { children: [i.jsx(ds.Link, { style: { marginRight: 8 }, onClick: () => N(w), children: i.jsx(me, { name: "checks" }) }), i.jsx(us, { onConfirm: S, title: "Deseas cancelar?", children: i.jsx(me, { name: "x" }) })] }) : i.jsxs(i.Fragment, { children: [i.jsx(_n, { size: "small", disabled: y == 0, onClick: () => C({ ...w }), children: i.jsx(me, { size: 18, name: "edit" }) }), i.jsx(_n, { size: "small", onClick: () => V(w.Key), children: i.jsx(me, { size: 18, name: "trash" }) })] })
    }
  ].map((O) => O.editable ? {
    ...O,
    onCell: (w) => ({
      record: w,
      title: O.title,
      dataIndex: O.dataIndex,
      editing: b(w),
      dataCurrentDetail: o,
      inputType: O.dataIndex === "Numero" ? "text" : O.dataIndex === "Vencimiento" ? "date" : "number"
    })
  } : O);
  return i.jsx(Ga, { width: 600, open: t, onClose: () => n(!1), style: { display: "flex", flexDirection: "column" }, title: i.jsx("strong", { style: { fontSize: "20px" }, children: "Creación de los lotes" }), footer: o.Cantidad == 0 ? void 0 : i.jsx(Rs, { TypeFooter: "Lote", CondComplete: g > 0 }), children: i.jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [i.jsx(Ns, { FotoGrafia: e, DataHeader: {
    Restante: g,
    Cantidad: o.Cantidad,
    Referencia: o.Referencia
  } }), i.jsxs(Ch, { form: u, layout: "vertical", disabled: g == 0, children: [i.jsxs(Ih, { children: [i.jsx(xh, { IconName: "caret-right", Text: "Agregar nuevo lote:" }), i.jsx(nr, { onClick: () => T(), disabled: E == null || v == null || m == null, style: {
    color: E == null || v == null || m == null ? "#DFDFDF" : "#3DA86B"
  }, children: i.jsx(me, { name: "cube-plus" }) })] }), i.jsxs(EE, { children: [i.jsx(K.Item, { name: "Numero", style: { marginBottom: "0px" }, label: i.jsx("strong", { children: "Número:" }), rules: [
    {
      required: !0,
      message: "Este campo es requerido"
    },
    {
      min: 9,
      message: "Mínimo 9 carácteres"
    },
    {
      max: 13,
      message: "Mínimo 13 carácteres"
    },
    (O) => ({
      validator(w, j) {
        return o?.FacturaCompraDetalleLotes?.map(($) => $.Numero).includes(j) ? Promise.reject(new Error("El número debe ser único.")) : Promise.resolve();
      }
    })
  ], children: i.jsx(Hr, { placeholder: "Ingrese el número" }) }), i.jsx(K.Item, { name: "Cantidad", style: { marginBottom: "0px" }, rules: [
    {
      message: "*",
      required: !0
    },
    (O) => ({
      validator(w, j) {
        const $ = o?.FacturaCompraDetalleLotes?.reduce((A, R) => A + (R.Cantidad || 0), 0) || 0, _ = o.Cantidad - $;
        return j > _ ? (d(!0), Promise.reject(new Error(""))) : (d(!1), Promise.resolve());
      }
    })
  ], label: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx("strong", { children: "Cantidad:" }), l ? i.jsx(Ar, { title: g > 0 ? `Solo ${g === 1 ? "queda" : "quedan"}, ${g} ${g === 1 ? "unidad" : "unidades"} ${g === 1 ? "restante" : "restantes"}` : "No quedan unidades", children: i.jsx(me, { size: 15, color: "red", name: "alert-circle-filled" }) }) : null] }), children: i.jsx(Vn, { min: 1, placeholder: "0", max: g > 0 ? g : 1 }) }), i.jsx(K.Item, { name: "Vencimiento", style: { marginBottom: "0px" }, label: i.jsx("strong", { children: "Vencimiento:" }), rules: [
    {
      required: !0,
      message: "Este campo es requerido"
    }
  ], children: i.jsx(Kt, { placeholder: "Fecha", disabledDate: (O) => O && bt(O).isBefore(bt().startOf("day")) }) })] })] }), i.jsx("div", { style: { marginTop: "30px" }, children: i.jsx(K, { form: f, children: i.jsx(mo, { bordered: !0, size: "small", dataSource: a, rowClassName: "editable-row", columns: x, pagination: {
    onChange: S
  }, components: {
    body: {
      cell: FE
    }
  }, title: () => i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("strong", { style: { fontSize: "17px", marginLeft: "9px" }, children: "Lista de lotes agregados:" }) }), locale: {
    emptyText: i.jsxs("div", { style: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }, children: [i.jsx(me, { name: "hourglass-empty" }), i.jsx("div", { style: { width: "100%" }, children: i.jsx("strong", { children: "No has agregado ningún lote" }) })] })
  } }) }) })] }) });
}, NE = ({ title: e, index: t, record: r, editing: n, children: o, formEdit: a, dataIndex: s, inputType: c, dataBatches: l, dataCurrentDetail: d, fetchPurchaseInvoiceLots: u, ...f }) => {
  console.log(e, t);
  const h = K.useWatch("FacturaCompraDetalleLoteId", a), [g, E] = k.useState(!1), v = d?.FacturaVentaDetalleLotes?.filter((b) => b?.FacturaCompraDetalleLoteId != r?.FacturaCompraDetalleLoteId)?.reduce((b, C) => b + (C?.Cantidad || 0), 0) || 0, m = d?.Cantidad - v, y = u?.data?.find((b) => b.FacturaCompraDetalleLoteId == h)?.Cantidad, I = c === "number" ? i.jsx(yh, { size: "small", max: m > 0 ? Math.min(m, y || 0) : 1 }) : i.jsx(Ht, { size: "small", style: {
    minWidth: "220px"
  }, options: u?.data?.filter((b) => !l.filter((C) => C.FacturaCompraDetalleLoteId !== r.FacturaCompraDetalleLoteId).map((C) => C.FacturaCompraDetalleLoteId).includes(b.FacturaCompraDetalleLoteId)).map((b) => ({
    value: b.FacturaCompraDetalleLoteId,
    label: `${b.Numero} - ${rt(b.Vencimiento).format("DD/MM/YYYY")}`
  })) });
  return i.jsx("td", { ...f, children: n ? i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(K.Item, { name: s, style: { margin: 0 }, help: s === "FacturaCompraDetalleLoteId" ? `Disponible en el lote: ${y || "N/A"}` : void 0, initialValue: s === "FacturaCompraDetalleLoteId" ? r.FacturaCompraDetalleLoteId : s === "Cantidad" ? r.Cantidad : null, rules: c === "selectId" ? [
    {
      required: !0,
      message: "Requerido"
    }
  ] : [
    {
      required: !0,
      message: "Req"
    },
    (b) => ({
      validator(C, S) {
        return d.Cantidad - v, S > m ? (E(!0), Promise.reject(new Error(""))) : (E(!1), Promise.resolve());
      }
    })
  ], children: I }), g ? i.jsx(Ar, { title: m > 0 ? `Solo ${m === 1 ? "queda" : "quedan"}, ${m} ${m === 1 ? "unidad" : "unidades"} ${m === 1 ? "restante" : "restantes"}` : "No quedan unidades", children: i.jsx(me, { size: 15, color: "red", name: "alert-circle-filled" }) }) : null] }) : o });
}, RE = ({ FotoGrafia: e, drawerSeries: t, setDataSource: r, setDrawerSeries: n, dataCurrentDetail: o }) => {
  const [a, s] = k.useState(o?.FacturaVentaDetalleLotes || []);
  k.useEffect(() => {
    const O = a.reduce((w, j) => w + j.Cantidad, 0);
    if (O > o.Cantidad) {
      let w = O;
      const j = a.map(($) => {
        if (w <= o.Cantidad)
          return $;
        {
          const _ = w - o.Cantidad;
          return w -= _, {
            ...$,
            Cantidad: $.Cantidad - _
          };
        }
      }).filter(($) => $.Cantidad > 0);
      s(j);
    }
  }, [a, o.Cantidad]), k.useEffect(() => {
    r((O) => {
      const w = O.findIndex(($) => $.Key == o.Key), j = O;
      return j[w].FacturaVentaDetalleLotes = a, [...j];
    });
  }, [a, r, o.Key]);
  const [c, l] = k.useState(!1), d = TE({
    ProductoId: o.ProductoId
  }), [u] = K.useForm(), [f] = K.useForm(), h = o?.FacturaVentaDetalleLotes?.reduce((O, w) => O + (w.Cantidad || 0), 0) || 0, g = o.Cantidad - h;
  k.useEffect(() => {
    g == 0 && u.resetFields();
  }, [g, u]);
  const E = K.useWatch("FacturaCompraDetalleLoteId", u), v = d.data?.find((O) => O.FacturaCompraDetalleLoteId == E)?.Cantidad, m = K.useWatch("Cantidad", u), [y, I] = k.useState(), b = (O) => O.Key === y, C = (O) => {
    f.setFieldsValue({
      Cantidad: O.Cantidad,
      FacturaCompraDetalleLoteId: O.FacturaCompraDetalleLoteId
    }), I(O.Key);
  }, S = () => {
    I(void 0);
  }, T = () => {
    s((O) => {
      const w = u.getFieldsValue(), j = O.map(($) => $.Key) || [1];
      return [
        ...O,
        {
          Cantidad: w.Cantidad,
          FacturaVentaDetalleLoteId: 0,
          Key: Vo(j),
          DetalleId: o.DocumentoDetalleId,
          FacturaCompraDetalleLoteId: w.FacturaCompraDetalleLoteId
        }
      ];
    }), c && l(!1), u.resetFields();
  }, N = async (O) => {
    try {
      const w = await f.validateFields();
      s((j) => {
        const $ = j.findIndex((A) => A.Key === O.Key) || 0, _ = j;
        return _[$] = {
          ..._[$],
          Cantidad: w.Cantidad,
          FacturaCompraDetalleLoteId: w.FacturaCompraDetalleLoteId
        }, [..._];
      }), c && l(!1), u.resetFields(), I(void 0);
    } catch {
      se.error("Datos invalidos");
    }
  }, V = (O) => {
    o && s((w) => [...w.filter((_) => _.FacturaCompraDetalleLoteId !== O)]);
  }, x = [
    {
      editable: !0,
      title: "Número - Vencimiento",
      key: "FacturaCompraDetalleLoteId",
      dataIndex: "FacturaCompraDetalleLoteId",
      render: (O, w) => i.jsx("span", { children: d.data?.find((j) => j.FacturaCompraDetalleLoteId == w.FacturaCompraDetalleLoteId)?.Numero + " - " + rt(d.data?.find((j) => j.FacturaCompraDetalleLoteId == w.FacturaCompraDetalleLoteId)?.Vencimiento).format("DD/MM/YYYY") })
    },
    {
      editable: !0,
      key: "Cantidad",
      align: "center",
      title: "Cantidad",
      dataIndex: "Cantidad"
    },
    {
      title: "",
      align: "center",
      dataIndex: "operation",
      render: (O, w) => b(w) ? i.jsxs("span", { children: [i.jsx(ds.Link, { style: { marginRight: 8 }, onClick: () => N(w), children: i.jsx(me, { name: "checks" }) }), i.jsx(us, { onConfirm: S, title: "Deseas cancelar?", children: i.jsx(me, { name: "x" }) })] }) : i.jsxs(i.Fragment, { children: [i.jsx(_n, { size: "small", disabled: y == 0, onClick: () => C({ ...w }), children: i.jsx(me, { size: 18, name: "edit" }) }), i.jsx(_n, { size: "small", onClick: () => V(w.FacturaCompraDetalleLoteId), children: i.jsx(me, { size: 18, name: "trash" }) })] })
    }
  ].map((O) => O.editable ? {
    ...O,
    onCell: (w) => ({
      record: w,
      title: O.title,
      formEdit: f,
      dataIndex: O.dataIndex,
      dataBatches: a,
      editing: b(w),
      dataCurrentDetail: o,
      fetchPurchaseInvoiceLots: d,
      inputType: O.dataIndex === "FacturaCompraDetalleLoteId" ? "selectId" : "number"
    })
  } : O);
  return i.jsx(Ga, { width: 600, open: t, onClose: () => n(!1), style: { display: "flex", flexDirection: "column" }, title: i.jsx("strong", { style: { fontSize: "20px" }, children: "Selección de los lotes" }), footer: o.Cantidad == 0 ? void 0 : i.jsx(Rs, { TypeFooter: "Lote", CondComplete: g > 0 }), children: i.jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [i.jsx(Ns, { FotoGrafia: e, DataHeader: {
    Restante: g,
    Cantidad: o.Cantidad,
    Referencia: o.Referencia
  } }), i.jsxs(Ch, { form: u, layout: "vertical", disabled: g <= 0, children: [i.jsxs(Ih, { children: [i.jsx(xh, { IconName: "caret-right", Text: "Agregar nuevo lote:" }), i.jsx(Ar, { title: "Agregar", children: i.jsx(nr, { onClick: () => T(), disabled: E == null || m == null || g <= 0, style: {
    color: E == null || m == null || g <= 0 ? "#DFDFDF" : "#3DA86B"
  }, children: i.jsx(me, { name: "cube-plus" }) }) })] }), i.jsxs(ir.Compact, { children: [i.jsx(K.Item, { name: "FacturaCompraDetalleLoteId", label: i.jsx("strong", { children: "Número - Vencimiento:" }), style: { minWidth: "300px", marginBottom: "0px" }, help: `Disponible en el lote: ${v || "N/A"}`, rules: [
    {
      required: !0,
      message: "Requerido"
    }
  ], children: i.jsx(Ht, { placeholder: "Seleccione", options: d?.data?.filter((O) => !a.map((w) => w.FacturaCompraDetalleLoteId).includes(O.FacturaCompraDetalleLoteId)).map((O) => ({
    value: O.FacturaCompraDetalleLoteId,
    label: `${O.Numero} - ${rt(O.Vencimiento).format("DD/MM/YYYY")}`
  })) }) }), i.jsx(K.Item, { name: "Cantidad", style: { marginBottom: "0px" }, rules: [
    {
      message: "*",
      required: !0
    },
    (O) => ({
      validator(w, j) {
        const $ = o?.FacturaCompraDetalleLotes?.reduce((A, R) => A + (R.Cantidad || 0), 0) || 0, _ = o.Cantidad - $;
        return j > _ ? (l(!0), Promise.reject(new Error(""))) : (l(!1), Promise.resolve());
      }
    })
  ], label: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx("strong", { children: "Cantidad:" }), c ? i.jsx(Ar, { title: g > 0 ? `Solo ${g === 1 ? "queda" : "quedan"}, ${g} ${g === 1 ? "unidad" : "unidades"} ${g === 1 ? "restante" : "restantes"}` : "No quedan unidades", children: i.jsx(me, { size: 15, color: "red", name: "alert-circle-filled" }) }) : null] }), children: i.jsx(Vn, { min: 1, placeholder: "0", max: g > 0 ? Math.min(g, v || 0) : 1 }) })] })] }), i.jsx("div", { style: { marginTop: "30px" }, children: i.jsx(K, { form: f, children: i.jsx(mo, { bordered: !0, size: "small", dataSource: a, rowClassName: "editable-row", columns: x, pagination: {
    onChange: S
  }, components: {
    body: {
      cell: NE
    }
  }, title: () => i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("strong", { style: { fontSize: "17px", marginLeft: "9px" }, children: "Lista de lotes agregados:" }) }), locale: {
    emptyText: i.jsxs("div", { style: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }, children: [i.jsx(me, { name: "hourglass-empty" }), i.jsx("div", { style: { width: "100%" }, children: i.jsx("strong", { children: "No has agregado ningun lote" }) })] })
  } }) }) })] }) });
}, Uu = (e) => {
  const t = e?.FacturaVentaDetalleSeries?.length || 0;
  return e.UnidadMedidaId == 1 ? e?.Cantidad - t : 1 - t;
}, PE = ({ record: e, editing: t, children: r, dataIndex: n, dataSeries: o, dataCurrentDetail: a, ...s }) => {
  const [c, l] = k.useState(""), d = Sh({
    Search: c,
    ProductoId: a?.ProductoId
  }), u = i.jsx(Ht, { showSearch: !0, size: "small", style: {
    minWidth: "220px"
  }, onSearch: (f) => l(f), filterOption: (f, h) => (h?.label || "").toLowerCase().includes(f.toLowerCase()), options: d?.data?.filter((f) => !o.filter((h) => h.FacturaCompraDetalleSerieId !== e.FacturaCompraDetalleSerieId).map((h) => h.FacturaCompraDetalleSerieId).includes(f.FacturaCompraDetalleSerieId))?.map((f) => ({
    label: `${f.NumeroSerie}`,
    value: f.FacturaCompraDetalleSerieId
  })) });
  return i.jsx("td", { ...s, children: t ? i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx(K.Item, { name: n, style: { margin: 0 }, initialValue: e.FacturaCompraDetalleSerieId, rules: [
    {
      required: !0,
      message: "Requerido"
    }
  ], children: u }) }) : r });
}, jE = ({ FotoGrafia: e, setDataSource: t, dataCurrentDetail: r, openDrawerSelectSerie: n, onCloseDrawerSelectSerie: o }) => {
  const [a] = Os(), [s] = K.useForm(), [c, l] = k.useState(""), [d, u] = k.useState(), [f, h] = k.useState(r?.FacturaVentaDetalleSeries || []), g = K.useWatch("FacturaCompraDetalleSerieId", a);
  k.useEffect(() => {
    if (r.Cantidad < f.length) {
      const D = f.length + 1 - r.Cantidad, x = f.splice(-D, D);
      h(x);
    }
  }, [r.Cantidad, f]), k.useEffect(() => {
    t((D) => {
      const x = D.findIndex((w) => w.Key == r.Key), O = D;
      return O[x].FacturaVentaDetalleSeries = f, [...O];
    });
  }, [f, t, r.Key]);
  const E = Sh({
    Search: c,
    ProductoId: r.ProductoId
  }), v = (D) => {
    if (D.key === "Enter" && (r?.FacturaVentaDetalleSeries?.length || 0) < r.Cantidad) {
      const x = E.data?.find((O) => O.NumeroSerie == c);
      x && (h((O) => [
        ...O,
        {
          FacturaVentaDetalleSerieId: 0,
          DetalleId: r.DocumentoDetalleId,
          FacturaCompraDetalleSerieId: x.FacturaCompraDetalleSerieId,
          NumeroSerie: E.data?.find((w) => w.FacturaCompraDetalleSerieId == x.FacturaCompraDetalleSerieId || 0)?.NumeroSerie
        }
      ]), a.resetFields());
    }
  }, m = (D) => D.FacturaCompraDetalleSerieId === d, y = () => {
    u(void 0);
  }, I = async (D) => {
    try {
      const x = await s.validateFields();
      h((O) => {
        const w = O.findIndex(($) => $.FacturaCompraDetalleSerieId === D.FacturaCompraDetalleSerieId) || 0, j = O;
        return j[w] = {
          ...j[w],
          FacturaCompraDetalleSerieId: x.FacturaCompraDetalleSerieId,
          NumeroSerie: E.data?.find(($) => $.FacturaCompraDetalleSerieId == x.FacturaCompraDetalleSerieId || 0)?.NumeroSerie
        }, [...j];
      }), a.resetFields(), u(void 0);
    } catch {
      se.error("Debe seleccionar la serie");
    }
  }, b = (D) => {
    s.setFieldsValue({
      FacturaCompraDetalleSerieId: D.FacturaCompraDetalleSerieId
    }), u(D.FacturaCompraDetalleSerieId);
  }, C = () => {
    h((D) => {
      const x = a.getFieldsValue();
      return [
        ...D,
        {
          FacturaVentaDetalleSerieId: 0,
          DetalleId: r.DocumentoDetalleId,
          FacturaCompraDetalleSerieId: x.FacturaCompraDetalleSerieId,
          NumeroSerie: E.data?.find((O) => O.FacturaCompraDetalleSerieId == x.FacturaCompraDetalleSerieId || 0)?.NumeroSerie
        }
      ];
    }), a.resetFields();
  }, S = (D) => {
    r && h((x) => [...x.filter((j) => j.FacturaCompraDetalleSerieId !== D)]);
  }, N = [
    {
      editable: !0,
      title: "Número de serie",
      key: "FacturaCompraDetalleSerieId",
      dataIndex: "FacturaCompraDetalleSerieId",
      render: (D, x) => i.jsx("span", { children: x?.NumeroSerie })
    },
    {
      title: "",
      align: "center",
      dataIndex: "operation",
      render: (D, x) => m(x) ? i.jsxs("span", { children: [i.jsx(ds.Link, { style: { marginRight: 8 }, onClick: () => I(x), children: i.jsx(me, { name: "checks" }) }), i.jsx(us, { onConfirm: y, title: "Deseas cancelar?", children: i.jsx(me, { name: "x" }) })] }) : i.jsxs(i.Fragment, { children: [i.jsx(_n, { size: "small", disabled: d == 0, onClick: () => b({ ...x }), children: i.jsx(me, { size: 18, name: "edit" }) }), i.jsx(_n, { size: "small", onClick: () => S(x.FacturaCompraDetalleSerieId), children: i.jsx(me, { size: 18, name: "trash" }) })] })
    }
  ].map((D) => D.editable ? {
    ...D,
    onCell: (x) => ({
      record: x,
      dataSeries: f,
      dataIndex: D.dataIndex,
      editing: m(x),
      dataCurrentDetail: r
    })
  } : D), V = (D) => {
    l(D);
  };
  return i.jsx(Ga, { width: 460, open: n, onClose: () => o(), footer: r.Cantidad == 0 ? void 0 : i.jsx(Rs, { TypeFooter: "Serie", CondComplete: Uu(r) > 0 }), title: i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("span", { style: { fontSize: "21px", marginLeft: "8px", fontWeight: "bold" }, children: "Asignación de número de serie" }) }), children: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "column"
  }, children: [i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "15px"
  }, children: i.jsx("span", { style: { fontSize: "17px", marginLeft: "8px", fontWeight: "bold" }, children: "Información del detalle:" }) }), i.jsx(Ns, { FotoGrafia: e, DataHeader: {
    Cantidad: r.Cantidad,
    Referencia: r.Referencia,
    Restante: Uu(r)
  } }), i.jsx("div", { style: { marginTop: "20px" }, children: i.jsx(K, { form: a, layout: "vertical", style: { width: "70%" }, children: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(K.Item, { name: "FacturaCompraDetalleSerieId", style: { minWidth: "300px", marginRight: "10px" }, label: i.jsx("span", { style: {
    fontSize: "15px",
    fontWeight: "bold"
  }, children: "No. para asignar:" }), children: i.jsx(Ht, { allowClear: !0, showSearch: !0, onSearch: Mn({ delay: 500 }, V), onKeyDown: (D) => v(D), filterOption: (D, x) => (x?.label || "").toLowerCase().includes(D.toLowerCase()), notFoundContent: E.isLoading ? i.jsx(Xo, {}) : E.error ? "Error al buscar" : "No se encontraron resultados", disabled: r.UnidadMedidaId !== 1 && (r?.FacturaVentaDetalleSeries?.length || 0) > 0 || (r?.FacturaVentaDetalleSeries?.length || 0) === r?.Cantidad, options: E?.data?.filter((D) => !f?.map((x) => x.FacturaCompraDetalleSerieId).includes(D.FacturaCompraDetalleSerieId))?.map((D) => ({
    label: D.NumeroSerie,
    value: D.FacturaCompraDetalleSerieId
  })) }) }), i.jsx(Ar, { title: "Agregar", children: i.jsx(nr, { onClick: () => C(), disabled: g == null || g == null || g == 0, style: {
    color: g == null || g == null || g == 0 ? "#DFDFDF" : "#3DA86B"
  }, children: i.jsx(me, { name: "cube-plus" }) }) })] }) }) }), i.jsx("div", { style: {
    width: "100%"
  }, children: i.jsx(K, { form: s, children: i.jsx(mo, { bordered: !0, size: "small", dataSource: f, rowClassName: "editable-row", columns: N, pagination: {
    onChange: y
  }, components: {
    body: {
      cell: PE
    }
  }, title: () => i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: i.jsx("strong", { style: { fontSize: "17px", marginLeft: "9px" }, children: "Lista de series agregadas:" }) }), locale: {
    emptyText: i.jsxs("div", { style: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }, children: [i.jsx(me, { name: "hourglass-empty" }), i.jsx("div", { style: { width: "100%" }, children: i.jsx("strong", { children: "No has agregado ninguna serie" }) })] })
  } }) }) })] }) });
}, $E = (e) => Ye({
  networkMode: "online",
  queryKey: ["Units", e],
  queryFn: () => Tx.getByProductId(e)
}), AE = Ee(Ke)`
	@media screen and (${st.maxDevice.laptopL}) {
		flex-direction: column;
	}
`, _E = Ee(Ke)`
	gap: 16px;
	align-items: center;
	@media screen and (${st.maxDevice.laptop}) {
		flex-direction: column;
	}
`, ME = ({ item: e, onSave: t, enabled: r, onDelete: n, dataSource: o, DocumentData: a, setDataSource: s, detailInConflict: c, detailWidthConflict: l, setDetailInConflict: d }) => {
  const [u, f] = k.useState(!1), [h, g] = k.useState(!1), [E] = Vt.useForm(), { data: v, isLoading: m } = Gx(e.ProductoId ?? 0), { data: y } = $E(e.ProductoId), { docTypes: I } = et(), b = a?.TipoDocumentoId === I.Factura_de_compra || a?.TipoDocumentoId === I.Factura_de_venta, C = a?.TipoDocumentoId === I.Factura_de_compra, [S, T] = k.useState(!1), [N, V] = k.useState(!1), [D, x] = k.useState(!1), [O, w] = k.useState();
  k.useEffect(() => {
    w(!!c);
  }, [c]);
  const [j, $] = k.useState(!1), _ = async (L) => {
    try {
      const M = await E.validateFields();
      t({ ...e, ...M }), L && s((B) => {
        const W = B.findIndex((te) => te.Key === e.Key), ee = B;
        return ee[W].DetalleSeries = void 0, [...ee];
      });
    } catch (M) {
      Or.info(`Save failed: ${M}`);
    }
  }, A = (L) => {
    if (a?.TipoDocumentoId === I.Nota_de_credito) {
      const M = a?.ProductosCantidadesDisponibles?.find((W) => W.ProductoId === e.ProductoId);
      L > M?.CantidadDisponible && (se.error("Solo quedan " + M?.CantidadDisponible + " Unidades disponibles para este producto en esta nota de credito"), E.setFieldValue("Cantidad", null));
    }
    if (L < (e.DetalleSeries?.length || 0)) {
      const M = (e.DetalleSeries?.length || 0) - L;
      s((B) => {
        const W = B.findIndex((te) => te.Key === e.Key), ee = B;
        return ee[W].DetalleSeries = ee[W]?.DetalleSeries?.slice(0, -M), ee[W].Cantidad = L, E.resetFields(), [...ee];
      });
      return;
    }
  }, R = () => {
    u && _(), f(!u);
  }, P = sr(`${st.maxDevice.tablet}`), z = {
    column: 1,
    size: "small",
    bordered: !0,
    labelStyle: { minWidth: 128 },
    layout: P ? "vertical" : "horizontal"
  }, F = () => i.jsxs(Ke, { style: { gap: 8 }, children: [i.jsx(wt, { ghost: !0, danger: !0, size: "middle", type: "primary", renderLeftIcon: i.jsx(me, { size: 15, name: "x" }), onClick: () => w(!1), children: "Aceptar" }), i.jsx(wt, { size: "middle", type: "primary", renderLeftIcon: i.jsx(me, { size: 15, name: "settings-check" }), onClick: () => {
    a?.TipoDocumentoId == I.Factura_de_compra ? c?.Conflict == "Lotes" ? $(!0) : x(!0) : c?.Conflict == "Lotes" ? T(!0) : V(!0), w(!1);
  }, children: "Completar" })] });
  return i.jsxs(i.Fragment, { children: [i.jsx(bn, { loading: m, styles: { body: { padding: 0 } }, extra: i.jsxs(ir, { children: [u ? i.jsx(me, { hoverablePrimary: !0, name: "device-floppy", onClick: r ? R : void 0 }) : i.jsx(Ar, { title: "Editar", color: "#2C874F", children: i.jsx(me, { name: "pencil", touchable: r, hoverablePrimary: r, color: r ? void 0 : "#a8a8a8", onClick: r ? R : void 0 }) }), i.jsx(wt, { danger: !0, size: "middle", type: "primary", disabled: !r, renderLeftIcon: i.jsx(me, { name: "trash", size: "small" }), onClick: () => {
    r && (n(e.Key ?? 0), l && d && d(void 0));
  }, children: "Remover" })] }), title: b ? i.jsxs(ir, { children: [e.TieneVencimiento && e.UnidadMedidaId == 1 && i.jsx(Ar, { fresh: !0, title: "Lotes", color: "#2C874F", placement: "left", children: i.jsx(Dd, { content: F(), open: O && l && c?.Conflict == "Lotes", title: i.jsx(zo, { showIcon: !0, type: "warning", message: "¡Lotes imcompletos!" }), children: i.jsx(me, { name: "cube-plus", hoverablePrimary: !0, onClick: () => {
    e.TieneVencimiento ? (w(!1), C ? $(!0) : T(!0)) : se.error("Este producto no tiene vencimiento");
  } }) }) }), e.LLevaSerie && e.UnidadMedidaId == 1 && i.jsx(Ar, { color: "#2C874F", placement: "right", title: "Asignar series", children: i.jsx(Dd, { content: F, open: O && l && c?.Conflict == "Series", title: i.jsx(zo, { showIcon: !0, type: "warning", message: "Series imcompletas!" }), children: i.jsx(me, { name: "barcode", hoverablePrimary: !0, onClick: () => {
    a?.TipoDocumentoId === I.Factura_de_compra ? x(!0) : V(!0), w(!1);
  } }) }) })] }) : e.Descripcion, children: i.jsx(Vt, { form: E, children: i.jsxs(AE, { children: [i.jsx(at, { style: { flex: 1, padding: 8, minWidth: 150 }, children: i.jsxs(Ke, { style: {
    gap: 6,
    height: "100%",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  }, children: [i.jsx(_l, { size: 96, src: v && v[0]?.Data, alt: v && v[0]?.FileName }), i.jsx(qt, { strong: !0, style: { wordWrap: "break-word" }, children: e.Codigo })] }) }), i.jsxs(_E, { style: { flex: 3 }, children: [i.jsxs(On, { ...z, style: { flex: 2, width: "100%" }, children: [ot("Descripción", i.jsx(Vt.Item, { noStyle: !0, name: "Descripcion", initialValue: e.Descripcion, children: i.jsx(Ed, { size: "middle", bordered: u, readOnly: !u, disabled: !r, defaultValue: e.Descripcion }) })), ot("Referencia", i.jsx(Vt.Item, { noStyle: !0, name: "Referencia", initialValue: e.Referencia, children: i.jsx(Ed, { size: "middle", bordered: u, readOnly: !u, defaultValue: e?.Referencia || "" }) })), ot("Precio", i.jsx(Vt.Item, { noStyle: !0, name: "PrecioUnitario", initialValue: e.PrecioUnitario, children: i.jsx(Ia, { min: 0, bordered: u, readOnly: !u, controls: !1, style: { width: "100%" }, defaultValue: e.PrecioUnitario ?? 0 }) })), ot("Cantidad", i.jsxs(ir.Compact, { children: [i.jsx(Vt.Item, { noStyle: !0, name: "Cantidad", initialValue: e.Cantidad, children: i.jsx(Ia, { min: 0, bordered: u, readOnly: !u, controls: !1, disabled: !r, defaultValue: e.Cantidad, onBlur: () => _(!1), onChange: (L) => A(L), parser: (L) => e.UnidadMedidaId === 1 ? Math.round(Number.parseFloat(L || "")) : Number.parseFloat(L || ""), formatter: (L) => new Intl.NumberFormat("es-DO", {
    maximumFractionDigits: e.UnidadMedidaId === 1 ? 0 : 2
  }).format(L) }) }), i.jsx(Vt.Item, { noStyle: !0, name: "UnidadMedidaId", initialValue: e.UnidadMedidaId, children: i.jsxs(So, { bordered: u, disabled: !u, onChange: () => _(!0), options: y?.map((L) => ({
    value: L.UnidadMedidaId,
    label: L.ProductoTipoUnidadMedidaNombre
  })), children: [i.jsx(So.Option, { value: !1, children: "$" }), i.jsx(So.Option, { value: !0, children: "%" })] }) })] }))] }), i.jsxs(On, { ...z, colon: !1, bordered: !1, layout: "vertical", style: { flex: 1, padding: P ? 16 : 0 }, children: [ot("Descuento", i.jsxs(ir.Compact, { children: [i.jsx(Vt.Item, { noStyle: !0, name: "DescuentoUnitario", initialValue: e.DescuentoUnitario, children: i.jsx(Ia, { min: 0, bordered: u, readOnly: !u, controls: !1, disabled: !r, onBlur: () => _(!1), defaultValue: e.DescuentoUnitario ?? 0 }) }), i.jsx(Vt.Item, { noStyle: !0, name: "DescuentoEsPorcentual", initialValue: e.DescuentoEsPorcentual, children: i.jsxs(So, { bordered: u, disabled: !u, onBlur: () => _(!1), defaultValue: e.DescuentoEsPorcentual ?? !1, children: [i.jsx(So.Option, { value: !1, children: "$" }), i.jsx(So.Option, { value: !0, children: "%" })] }) })] })), (a?.TipoDocumentoId === I.Factura_de_compra || a?.TipoDocumentoId === I.Factura_de_venta) && i.jsx(On.Item, { label: h ? i.jsx(qt, { strong: !0, onClick: () => r ? g(!0) : null, children: "Cortesía" }) : i.jsx(Ar, { color: "#29ABE2", title: "Agregar cantidad de cortesía", children: i.jsx(nr, { strong: !0, onClick: () => r ? g(!0) : null, children: "Cortesía" }) }), children: h && i.jsx(Vt.Item, { noStyle: !0, name: "CantidadCortesia", initialValue: e.CantidadCortesia, children: i.jsx(Ia, { min: 0, size: "middle", controls: !1, style: { width: "100%" }, readOnly: !h, defaultValue: e.CantidadCortesia }) }) }), ot("Subtotal", tr(e.SubTotal, "RD$"))] })] })] }) }) }, e.Codigo), i.jsx(wE, { dataUnits: y, dataCurrentDetail: e, setDataSource: s, openDrawer: D, FotoGrafia: v ? v[0] : void 0, onCloseDrawer: () => x(!1) }), i.jsx(jE, { dataUnits: y, dataCurrentDetail: e, setDataSource: s, openDrawerSelectSerie: N, FotoGrafia: v ? v[0] : void 0, onCloseDrawerSelectSerie: () => V(!1) }), i.jsx(RE, { dataUnits: y, dataSource: o, dataCurrentDetail: e, setDataSource: s, drawerSeries: S, setDrawerSeries: T, FotoGrafia: v ? v[0] : void 0 }), i.jsx(OE, { dataUnits: y, dataSource: o, dataCurrentDetail: e, setDataSource: s, drawerLotes: j, setDrawerLotes: $, FotoGrafia: v ? v[0] : void 0 })] });
};
Ee.div`
	margin-top: 20px;
	width: 94%;
	margin: 0 auto;
	box-shadow: 0.6px 1px 9px 2.9px rgba(0, 0, 0, 0.09);
	transition: box-shadow 0.3s ease;
	//padding: 20px;
	padding-top: 40px;
	padding-bottom: 20px;
	padding-left: 30px;
	padding-right: 30px;
	position: relative;
	margin-top: 5px;
	margin-bottom: 35px;
	border-radius: 8px;

	.card:hover {
		box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.3);
	}
`;
Ee.div`
	position: absolute;
	top: 0;
	right: 0;
	padding: 8px;
	cursor: pointer;
`;
Ee.div`
	position: absolute;
	top: 0;
	right: 30px;
	padding: 8px;
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
`;
Ee.div`
	margin-bottom: 1px;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
Ee.div`
	background: #b3def6;
	width: 117px;
	height: 95px;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-radius: 10px 10px 0 0;
`;
Ee.div`
	max-width: 80px;
	min-width: 80px;
	max-height: 80px;
	min-height: 80px;
	border-radius: 100%;
	margin: 0 auto;
	border: 2.5px solid white;
	background: #cbcbcb;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	text-align: center;
`;
Ee.div`
	width: 117px;
	min-height: 22px;
	text-align: center;
	background: #eaf7fe;
	border-radius: 0 0 10px 10px;
`;
Ee.span`
	color: #39506a;
	font-weight: bold;
	font-size: 10.4px;
`;
Ee.div`
	display: flex;
	flex-direction: column;
	margin-left: 15px;
`;
Ee.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
Ee.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
Ee.span`
	color: #008eca;
	font-weight: bold;
	cursor: pointer;
	font-size: 11.5px;
`;
Ee.div`
	min-width: 168px;
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: space-between;
`;
Ee.div`
	font-weight: 600;
	color: #353535;
	margin-right: 5px;
`;
Ee.div`
	margin-bottom: 5px;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
Ee.div`
	minwidth: 168px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	font-size: 13px;
`;
Ee.span`
	font-weight: bold;
	color: #353535;
`;
Ee.div`
	min-width: 168px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;
Ee.div`
	margin-bottom: 5px;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
Ee.div`
	min-width: 168px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-end;
`;
const LE = (e) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["ClientCreditInfo", e],
  queryFn: () => Ox.getCreditInfo(e)
}), Qr = () => Ye({
  networkMode: "online",
  queryKey: ["GeneralConfiguration"],
  queryFn: Yp.getImpuestoIncluido
}), VE = () => Ye({
  networkMode: "online",
  queryKey: ["GeneralConfiguration"],
  queryFn: Yp.getFormaPagoDefecto
}), zE = {
  [Dt.CREDIT]: ["MontoCredito"],
  [Dt.CASH]: ["MontoEfectivo", "DineroRecibido"],
  [Dt.DEBIT_CREDIT]: ["MontoTarjeta", "Autorizacion"],
  [Dt.CHECK]: ["MontoCheque", "NumeroCheque", "BancoId"],
  [Dt.DEPOSIT]: [
    "MontoDeposito",
    "Referencia",
    "CuentaBancariaId"
  ]
}, { statesValues: BE } = et(), kE = ({ open: e, onClose: t, clientId: r, paymentProps: n, setReceiptData: o, handleSaveNormal: a }) => {
  const s = vS(), c = Yi.useFetchBanks(), l = Yi.useFetchCurrencies(), d = tS(), { data: u } = VE(), { data: f } = LE(r), h = fv({
    mode: "all",
    reValidateMode: "onChange",
    criteriaMode: "firstError",
    defaultValues: {
      Total: 0,
      Nota: "",
      TotalPagar: 0,
      MontoCheque: 0,
      Referencia: "",
      MontoCredito: 0,
      MontoTarjeta: 0,
      NotaCredito: "",
      MontoAplicar: 0,
      Observacion: "",
      FormasPagos: [],
      MontoEfectivo: 0,
      Autorizacion: "",
      NumeroCheque: "",
      MontoDeposito: 0,
      DineroRecibido: 0,
      notaCreditoDisponible: 0
    }
  }), { control: g, trigger: E, setValue: v } = h, m = mn({ control: g }), y = k.useCallback(() => {
    switch (v("TotalPagar", n?.TotalPagar ?? 0), v("FormasPagos", [Number.parseInt(u?.Valor || "")]), Number.parseInt(u?.Valor || "")) {
      case Dt.CASH:
        v("DineroRecibido", n?.TotalPagar ?? 0), v("MontoEfectivo", n?.TotalPagar ?? 0);
        break;
      case Dt.DEBIT_CREDIT:
        v("MontoTarjeta", n?.TotalPagar ?? 0);
        break;
      case Dt.CHECK:
        v("MontoCheque", n?.TotalPagar ?? 0);
        break;
      case Dt.DEPOSIT:
        v("MontoDeposito", n?.TotalPagar ?? 0);
        break;
      case Dt.CREDIT:
        v("MontoCredito", n?.TotalPagar ?? 0);
        break;
    }
  }, [v, n?.TotalPagar, u?.Valor]);
  k.useEffect(() => {
    y();
  }, [y]), k.useEffect(() => {
    Object.entries(zE).forEach(([N, V]) => {
      m.FormasPagos?.includes(parseInt(N)) || V.forEach((D) => v(D, void 0));
    });
  }, [v, m.FormasPagos.length]);
  const I = k.useMemo(() => c.data?.length ? Da.selectLabelValue(c.data, "BancoNombre", "BancoId") : [], [c.data]), b = k.useMemo(() => d.data?.length ? Da.selectLabelValue(d.data, "CuentaNombre", "CuadreBancoCajaId") : [], [d.data]), C = k.useMemo(() => l.data?.length ? Da.selectLabelValue(l.data ?? [], "MonedaNombre", "MonedaId") : [], [l]), S = k.useCallback(async () => {
    if (!await E()) {
      se.error("Hay algunos campos que necesitan ser revisados.");
      return;
    }
    if (m.Total !== m.TotalPagar)
      return se.error("El monto a pagar no puede ser mayor ni menor que el total de la factura.");
    a();
  }, [E, m.Total, m.TotalPagar, a]), T = k.useCallback((N) => {
    const V = {
      ReciboId: 0,
      CuadreBancoCajaId: 2,
      Tasa: m.Tasa || 0,
      BancoId: m.BancoId,
      MonedaId: m.MonedaId || 0,
      Referencia: m.Referencia || "",
      Monto: n?.TotalPagar || 0
    };
    switch (N) {
      case Dt.CASH:
        return {
          FormaPagoId: 1,
          ...V,
          Recibido: m.DineroRecibido || 0
        };
      case Dt.CREDIT:
        return {
          FormaPagoId: 2,
          ...V,
          Recibido: m.MontoCredito || 0
        };
      case Dt.CHECK:
        return {
          FormaPagoId: 3,
          ...V,
          Recibido: m.MontoCheque || 0
        };
      case Dt.DEBIT_CREDIT:
        return {
          FormaPagoId: 5,
          ...V,
          Recibido: m.MontoTarjeta || 0
        };
      case Dt.DEPOSIT:
        return {
          FormaPagoId: 7,
          ...V,
          Recibido: m.MontoDeposito || 0
        };
      default:
        return {};
    }
  }, [
    m.Tasa,
    m.Referencia,
    m.DineroRecibido,
    m.MontoTarjeta,
    m.MontoCheque,
    m.MontoDeposito,
    m.MontoCredito,
    n?.TotalPagar,
    m.MonedaId,
    m.BancoId
  ]);
  return k.useEffect(() => {
    const N = m.FormasPagos.map((V) => T(V));
    o && o((V) => ({ ...V, ReciboFormasPago: N }));
  }, [T, o, m.FormasPagos]), k.useEffect(() => {
    o((N) => ({
      ...N,
      ReciboId: 0,
      SucursalId: 1,
      Secuencia: "0",
      TipoReciboId: 1,
      EsIngreso: !0,
      OrigenPagoId: 1,
      Fecha: /* @__PURE__ */ new Date(),
      ClienteId: r,
      ConceptoGeneralId: 1,
      Recibido: m.Total,
      Tasa: m.Tasa || 0,
      Nota: m.Nota || "",
      EstadoId: BE.Activo,
      Devolucion: m.Devolucion,
      MonedaId: m.MonedaId || 0,
      Referencia: m?.Referencia || "",
      SubTotal: n?.SubTotal || 0,
      Impuestos: n?.Impuestos || 0,
      Observaciones: m.Observacion || "",
      TotalAPagar: n?.TotalPagar || 0,
      Retenciones: n?.Retenciones || 0,
      ReciboDetalleFactura: {
        ReciboId: 0,
        DetalleId: 0,
        Monto: n?.Monto,
        Pendiente: m.Faltante,
        FacturaId: n?.FacturaId
      }
    }));
  }, [
    n?.FacturaId,
    m.MonedaId,
    m.Nota,
    m.Observacion,
    m.Tasa,
    o,
    m?.Referencia,
    r,
    n?.SubTotal,
    n?.Impuestos,
    n?.Retenciones,
    n?.TotalPagar,
    n?.Monto,
    m.Devolucion,
    m.Total,
    m.Faltante
  ]), i.jsx(zc, { methods: h, children: i.jsx(rv, { width: "50%", open: e, title: "Pago", onClose: t, styles: { footer: { padding: 16 } }, footer: i.jsx(UE, { onClose: t, buttonLoading: s.isPending, onApplyPaymentClick: S }), children: i.jsx(mv, { requiredMark: !0, layout: "vertical", children: i.jsxs(Ke, { style: { flexDirection: "column" }, children: [i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, children: [i.jsx("div", { children: i.jsxs(ir, { align: "center", style: { marginBottom: 32 }, children: [i.jsx(gn, { level: 4, children: "Monto a pagar:" }), i.jsx(gn, { level: 4, children: wa.format("currency", m.TotalPagar) })] }) }), i.jsx("div", { children: i.jsxs(ir, { align: "center", style: { marginBottom: 32 }, children: [i.jsx(gn, { level: 4, children: "Factura no." }), i.jsx(gn, { level: 4, children: n?.FacturaId })] }) })] }), i.jsxs(Ke, { style: { gap: 10, flexDirection: "column" }, children: [i.jsx(gn, { level: 5, children: "Métodos de pago" }), i.jsx(nv.Group, { size: "large", onSelectChip: (N) => v("FormasPagos", N), defaultValue: Number.parseInt(u?.Valor || "") || void 0, options: [
    {
      iconName: "",
      label: "Efectivo",
      value: Dt.CASH
    },
    ...f?.HabilitarCredito ? [
      {
        iconName: "",
        label: "Crédito",
        value: Dt.CREDIT
      }
    ] : [],
    {
      iconName: "",
      label: "Débito/Crédito",
      value: Dt.DEBIT_CREDIT
    },
    {
      iconName: "",
      label: "Cheque",
      value: Dt.CHECK
    },
    {
      iconName: "",
      label: "Depósito",
      value: Dt.DEPOSIT
    }
  ] })] }), i.jsxs(Qn, { columnsByRows: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
    xl: 2,
    xxl: 3
  }, children: [m.FormasPagos?.includes(Dt.CASH) && i.jsxs(Qn.Section, { section: "Efectivo", children: [i.jsx(ar, { type: "currency", label: "Efectivo", name: "MontoEfectivo", placeholder: "Escribe un monto", rules: { required: "error_required" } }), i.jsx(ar, { type: "currency", name: "DineroRecibido", label: "Monto recibido", min: m?.MontoEfectivo, placeholder: "Escribe un monto", rules: { required: "error_required" } })] }), m.FormasPagos?.includes(Dt.CREDIT) && i.jsx(Qn.Section, { section: "Crédito", children: i.jsx(ar, { type: "currency", label: "Crédito", name: "MontoCredito", placeholder: "Escribe un monto", rules: { required: "error_required" }, max: f?.LimitarCredito ? void 0 : f?.LimiteCredito }) }), m.FormasPagos?.includes(Dt.DEBIT_CREDIT) && i.jsxs(Qn.Section, { section: "Débito/Crédito", children: [i.jsx(ar, { type: "currency", name: "MontoTarjeta", label: "Monto de tarjeta", placeholder: "Escribe un monto", rules: { required: "error_required" } }), i.jsx(ar, { type: "text", name: "Autorizacion", label: "Autorización", placeholder: "Autorización", rules: { required: "error_required" } })] }), m.FormasPagos?.includes(Dt.CHECK) && i.jsxs(Qn.Section, { section: "Cheque", children: [i.jsx(ar, { type: "currency", name: "MontoCheque", label: "Monto del cheque", placeholder: "Escribe un monto", rules: { required: "error_required" } }), i.jsx(ar, { type: "text", name: "NumeroCheque", label: "Número de cheque", placeholder: "Número de cheque", rules: { required: "error_required" } }), i.jsx(ar, { showSearch: !0, type: "select", name: "BancoId", label: "Banco", options: I, placeholder: "Banco", loading: c.isPending, optionFilterProp: "children", rules: { required: "error_required" }, filterOption: (N, V) => (V?.label?.toString() ?? "").toLowerCase().includes(N.toLowerCase()) })] }), m.FormasPagos?.includes(Dt.DEPOSIT) && i.jsxs(Qn.Section, { section: "Depósito", children: [i.jsx(ar, { type: "currency", name: "MontoDeposito", label: "Transferencia", placeholder: "Escribe un monto", rules: { required: "error_required" } }), i.jsx(ar, { type: "text", name: "Referencia", label: "Referencia", rules: { required: "error_required" } }), i.jsx(ar, { showSearch: !0, type: "select", name: "CuentaBancariaId", options: b, optionFilterProp: "children", label: "Depósito bancario", loading: d.isPending, placeholder: "Depósito bancario", rules: { required: "error_required" }, filterOption: (N, V) => (V?.label?.toString() ?? "").toLowerCase().includes(N.toLowerCase()) })] }), i.jsxs(Qn.Section, { section: "Información adicional", children: [i.jsx(ar, { type: "select", name: "MonedaId", placeholder: "Moneda", label: "Tipo de moneda", options: C, rules: { required: "error_required" }, onChange: (N) => {
    v("Tasa", void 0), N === 1 && v("Tasa", 1);
  } }), i.jsx(ar, { name: "Tasa", label: "Tasa", type: "number", readOnly: m.MonedaId === 1, rules: { required: "error_required" }, placeholder: "Ingresa la tasa de cambio actual" }), i.jsx(ar, { name: "Notas", label: "Notas", type: "textarea", placeholder: "Escribe una nota" }), i.jsx(ar, { type: "textarea", name: "Observaciones", label: "Observaciones", placeholder: "Escribe una observación" })] })] })] }) }) }) });
}, UE = ({ onClose: e, buttonLoading: t, onApplyPaymentClick: r }) => {
  const { control: n, setValue: o } = pv(), a = mn({ control: n }), s = mn({ exact: !0, name: "MontoCheque" }), c = mn({ exact: !0, name: "MontoTarjeta" }), l = mn({ exact: !0, name: "MontoDeposito" }), d = mn({ exact: !0, name: "MontoEfectivo" }), u = mn({ exact: !0, name: "DineroRecibido" }), f = mn({ exact: !0, name: "MontoAplicar" }), h = mn({ exact: !0, name: "MontoCredito" });
  return k.useEffect(() => {
    const g = (d ?? 0) + (l ?? 0) + (c ?? 0) + (f ?? 0) + (h ?? 0) + (s ?? 0);
    o("Total", g ?? 0);
  }, [
    o,
    s,
    l,
    d,
    c,
    f,
    h
  ]), k.useEffect(() => {
    o("Devolucion", (u ?? 0) - (d ?? 0));
  }, [o, u, d]), k.useEffect(() => {
    o("Faltante", (a.TotalPagar ?? 0) - (a.Total ?? 0));
  }, [o, a.Total, a.TotalPagar]), i.jsxs(Gi, { style: { width: "100%", justifyContent: "space-between" }, children: [i.jsx(On, { column: 1, size: "small", items: [
    {
      label: "Total",
      children: wa.format("currency", a.Total ?? 0)
    },
    {
      label: "Faltante",
      children: wa.format("currency", a.Faltante ?? 0)
    },
    {
      label: "Cambio",
      children: wa.format("currency", a.Devolucion ?? 0)
    }
  ] }), i.jsxs(Gi, { children: [i.jsx(zc.ResetButton, { onClick: e, children: "Cancelar" }), i.jsx(zc.SubmitButton, { loading: t, onClick: r, children: "Aplicar Pago" })] })] });
}, qE = {
  marginBottom: 8,
  display: "block"
}, HE = { width: "100%", justifyContent: "space-between" }, WE = { flex: 1 }, Ko = ({ confirm: e, clearFilters: t, selectedKeys: r, setSelectedKeys: n }) => {
  const [o, a] = k.useState();
  let s;
  const c = r[0];
  (typeof c == "string" || typeof c == "number") && (s = bt(c, "DD/MM/YYYY"));
  const l = k.useCallback(() => {
    const u = o ? o.format("DD/MM/YYYY") : "";
    n([u]), e();
  }, [e, o, n]), d = k.useCallback(() => {
    t && t(), e();
  }, [t, e]);
  return i.jsxs(at, { style: { padding: 8 }, children: [i.jsx(Lf, { size: "large", allowClear: !1, format: "DD/MM/YYYY", value: s, style: qE, onChange: (u) => {
    a(u);
  } }), i.jsxs(Gi, { style: HE, children: [i.jsx(at, { style: WE, children: i.jsx(nr, { onClick: d, children: "Restablecer" }) }), i.jsx(wt, { type: "primary", onClick: l, children: "Aplicar" })] })] });
}, qu = ({ form: e, method: t, formIntanceConfig: r }) => {
  e.validateFields().then(() => {
    r.validateFields().then(() => {
      t && t();
    }).catch(() => {
      se.error("Hay campos que deben ser revisados");
    });
  }).catch(() => {
    se.error("Hay campos que deben ser revisados");
  });
}, GE = Ee(Ke)`
	gap: 16px;
	overflow: hidden;
	align-items: center;
	flex-wrap: wrap;

	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: column;
		overflow: unset;
	}
`, KE = Ee(Ke)`
	flex-direction: column;
	gap: 24px;
	flex: 3;
	overflow-y: auto;
	height: 100%;

	@media screen and (${st.maxDevice.tablet}) {
		overflow: unset;
		width: 100%;
	}
`, ba = Ee(Ke)`
	width: 100%;
	gap: 16px;
	@media screen and (${st.maxDevice.laptop}) {
		flex-direction: column;
	}

	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: row;
	}
	@media screen and (${st.maxDevice.mobileL}) {
		flex-direction: column;
	}
`, kr = Ee(at)`
	width: 100%;
`, YE = Ee(Ke)`
	width: 100%;
	flex-direction: column;
	gap: 16px;
	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: row;
		gap: 16px;
	}

	@media screen and (${st.maxDevice.mobileL}) {
		flex-direction: column;
	}
`, QE = ({ method: e, products: t }) => {
  t && t?.length === 0 ? se.error("No puede guardar este documento sin agregar productos") : t?.find((n) => n.Cantidad == 0) ? se.error("No pueden haber detalles coon la cantidad en cero") : e && e();
}, XE = Ee.div`
	display: flex;
	flex-direction: column;
`, Xn = Ee.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 20px;
`, Xr = ({ Total: e, Flete: t, Importe: r, methods: n, enabled: o, Subtotal: a, Descuento: s, Impuestos: c, isLoading: l, dataSource: d, Retenciones: u, formInstance: f, isFleteEnable: h, formIntanceConfig: g, ValidationDetails: E, IsBorradorDocument: v, IsRecurringDocument: m, setDetailInConflict: y }) => {
  const I = () => {
    if (y) {
      const C = d.find((S) => S.TieneVencimiento && (S?.FacturaCompraDetalleLotes?.reduce((T, N) => T + (N.Cantidad || 0), 0) || 0) < S.Cantidad);
      if (C && C.UnidadMedidaId == 1)
        y({
          Conflict: "Lotes",
          ObjectDetail: C
        });
      else {
        y(void 0);
        const S = d.find((T) => T.LLevaSerie && (T?.DetalleSeries?.length || 0) < T.Cantidad);
        S && S.UnidadMedidaId == 1 ? y({
          Conflict: "Series",
          ObjectDetail: S
        }) : n.handleSaveNormal();
      }
    } else
      n.handleSaveNormal();
  }, b = () => {
    if (y) {
      const C = d.find((S) => S.TieneVencimiento && (S?.FacturaVentaDetalleLotes?.reduce((T, N) => T + (N.Cantidad || 0), 0) || 0) < S.Cantidad);
      if (C && C.UnidadMedidaId == 1)
        y({
          Conflict: "Lotes",
          ObjectDetail: C
        });
      else {
        y(void 0);
        const S = d.find((T) => T.LLevaSerie && (T?.FacturaVentaDetalleSeries?.length || 0) < T.Cantidad);
        S && S.UnidadMedidaId == 1 ? y({
          Conflict: "Series",
          ObjectDetail: S
        }) : n.handleSaveNormal();
      }
    } else
      n.handleSaveNormal();
  };
  return i.jsxs(Qt, { loading: l, style: { flex: 1, width: "100%" }, children: [i.jsxs(K, { form: f, children: [i.jsxs(Xn, { children: [i.jsx("span", { children: "Descuento" }), i.jsx("span", { children: `RD$ ${s}` })] }), i.jsxs(Xn, { style: { alignItems: "center" }, children: [i.jsx(K.Item, { name: "IsFlete", valuePropName: "checked", children: i.jsx(Lc, { disabled: !o, children: "Flete" }) }), i.jsx(K.Item, { name: "Flete", initialValue: t, children: i.jsx(Vn, { disabled: h }) })] }), i.jsxs(Xn, { style: { marginBottom: "24px" }, children: [i.jsx("span", { children: "Importe" }), i.jsxs("span", { children: ["RD$ ", r] })] }), i.jsxs(Xn, { style: { marginBottom: "24px" }, children: [i.jsx("span", { children: "Impuestos" }), i.jsxs("span", { children: ["RD$ ", c] })] }), i.jsxs(Xn, { style: { marginBottom: "24px" }, children: [i.jsx("span", { children: "Retenciones" }), i.jsxs("span", { children: ["RD$ ", u] })] }), i.jsxs(Xn, { style: { marginTop: "32px" }, children: [i.jsx("span", { style: { color: "#022E4F", fontWeight: "bold" }, children: "Subtotal" }), i.jsxs("span", { children: ["RD$ ", a] })] }), i.jsxs(Xn, { children: [i.jsx("span", { style: { color: "#022E4F", fontWeight: "bold" }, children: "Total" }), i.jsxs("span", { children: ["RD$ ", e] })] })] }), i.jsxs(XE, { children: [n?.handlePago && !m ? i.jsx(to, { size: "large", type: "primary", htmlType: "submit", onClick: () => qu({
    form: f,
    method: () => {
    },
    formIntanceConfig: g
  }), children: "Guardar y pagar" }) : null, i.jsxs(YE, { children: [v ? i.jsx(to, { size: "large", type: "primary", htmlType: "submit", style: { width: "100%" }, onClick: () => qu({
    form: f,
    formIntanceConfig: g,
    method: () => QE({
      products: d,
      method: E === "FacturaCompraDetallesLotes" ? I : b
    })
  }), children: "Guardar" }) : null, !m && v ? i.jsx(to, { ghost: !0, size: "large", type: "primary", style: { width: "100%" }, onClick: () => n.handleSaveBorrador(), children: "Guardar como borrador" }) : null] }), !m && !v ? i.jsx(to, { ghost: !0, size: "large", type: "primary", style: {
    marginTop: 10
  }, onClick: () => n.handleVolverABorrador(), children: "Volver a borrador" }) : null] })] });
}, ZE = ({ Total: e, Importe: t, Subtotal: r, Descuento: n, Impuestos: o, isLoading: a, Retenciones: s }) => {
  const c = sr(`${st.maxDevice.mobileM}`), l = sr(`${st.minDevice.mobileL}`), d = sr(`${st.maxDevice.laptop}`), u = {
    column: 1,
    style: { flex: 1, maxWidth: 300 },
    layout: c ? "vertical" : "horizontal",
    contentStyle: {
      flex: 1,
      display: "flex",
      justifyContent: c ? "flex-start" : "flex-end"
    }
  }, f = (h, g) => i.jsx(pr.Item, { label: typeof h == "string" ? i.jsx(qt, { children: h }) : h, children: typeof g == "string" ? i.jsx(qt, { children: g }) : g });
  return i.jsxs(Qt, { loading: a, bodyStyle: { display: "flex" }, style: {
    flex: 1,
    width: "100%",
    minWidth: 300
  }, children: [i.jsxs(pr, { ...u, title: "Total general", children: [f("Descuento", n), f("Flete", i.jsx(me, { touchable: !0, size: "large", colorPrimary: !0, name: "circle-check-filled" })), f("Importe", t), f("Impuestos", o), f("Retenciones", s), i.jsx("br", {}), i.jsx(pr.Item, { label: i.jsx(qt, { strong: !0, children: "Subtotal" }), children: i.jsx(qt, { children: r }) }), i.jsx(pr.Item, { label: i.jsx(qt, { strong: !0, children: "Total" }), children: i.jsx(qt, { children: e }) })] }), l && d && i.jsx(Ke, { style: { flex: 1, alignItems: "center", justifyContent: "center" }, children: i.jsx(ov, { width: 150 }) })] });
};
Ee.span`
	font-size: 20.5px;
	color: #263958;
	font-weight: bold;
`;
const JE = (e) => Ye({
  enabled: !!e,
  queryKey: ["utils", e],
  queryFn: () => Hp.getPurchaseQuantities(e)
}), Dh = () => Ye({
  queryKey: ["utils"],
  queryFn: Hp.getDNITypes
}), eD = ({ EstadoId: e, DocumentoId: t, EsRecurrente: r, RouteNavigate: n, ExecuteClonate: o, TipoDocumentoId: a, ExecuteBackToDraft: s, TieneReciboAnulado: c }) => {
  const l = xt(), { docTypes: d, statesValues: u } = et(), { data: f } = JE(t || 0), h = a === d.Factura_de_venta ? "ReporteFacturaVenta2" : a === d.Cotizacion ? "ReporteCotizacion" : a === d.Conduce ? "ReporteConduce" : "", g = a === d.Factura_de_venta ? "facturaId" : a === d.Cotizacion ? "cotizacionId" : a === d.Conduce ? "conduceId" : "";
  return i.jsxs(Gi, { wrap: !0, children: [!s || !c && a === d.Factura_de_venta || r == !0 || (f || 0) > 0 && a === d.Factura_de_compra ? null : i.jsx(wt, { size: "large", type: "default", renderLeftIcon: i.jsx(me, { name: "receipt-refund" }), onClick: () => s ? s() : null, children: "Volver a borrador" }, "dsi-volver-borrador"), o && e && e != u.Borrador ? i.jsx(wt, { ghost: !0, size: "large", type: "primary", onClick: () => o(), renderLeftIcon: i.jsx(me, { size: 18, name: "copy" }), children: "Clonar" }) : null, e == u.Borrador && e ? i.jsx(wt, { size: "large", type: "default", renderLeftIcon: i.jsx(me, { size: 18, name: "file-pencil" }), onClick: () => l(`../${n}/${t}`), children: "Editar" }, "dsi-editar") : null, e == u.Activo && e && [
    d.Conduce,
    d.Cotizacion,
    d.Factura_de_venta
  ].includes(a || 0) ? i.jsx(wt, { size: "large", type: "primary", renderLeftIcon: i.jsx(me, { size: 18, name: "printer" }), onClick: () => Qi.chooseReportType(() => {
    window.location.assign(`${Qi.generatePath(h, {
      [g]: `${t}`
    }, "pdf")}`);
  }, {
    documentId: t || 0,
    documentTypeId: a || 0
  }), children: "Imprimir" }, "dsi-imprimir") : null] });
}, Ps = ({ EstadoId: e, ExecuteApprove: t, ExecuteOverride: r, ExecuteBackToDraft: n, ExecuteConvertToInvoice: o, ExecuteConvertToConduce: a }) => {
  const { statesValues: s } = et();
  return i.jsxs(Ke, { style: { gap: 8, flexDirection: "row", alignItems: "center" }, children: [e == s.Activo && o ? i.jsx(wt, { size: "large", renderLeftIcon: i.jsx(me, { name: "file-pencil" }), onClick: () => o ? o() : null, children: "Convertir en factura" }) : null, e == s.Activo && a ? i.jsx(wt, { size: "large", renderLeftIcon: i.jsx(me, { name: "shopping-cart-up" }), onClick: () => a ? a() : null, children: "Convertir en conduce" }) : null, e == s.Pendiente_de_aprobacion ? i.jsxs(Ke, { style: { gap: 4, flexDirection: "row", alignItems: "center" }, children: [i.jsx(wt, { size: "large", onClick: () => t ? t() : null, renderLeftIcon: i.jsx(me, { size: 16, name: "circle-check-filled" }), children: "Aprobar" }), i.jsx(wt, { size: "large", onClick: () => n(), renderLeftIcon: i.jsx(me, { name: "pencil-cog" }), children: "Corregir" }), i.jsx(wt, { size: "large", renderLeftIcon: i.jsx(me, { name: "circle-x-filled" }), onClick: () => r ? r() : null, children: "Anular" })] }) : null] });
}, tD = ({ Area: e, isFetching: t, ContactInfo: r }) => {
  const o = {
    column: 1,
    size: "small",
    bordered: !0,
    layout: sr(`${st.maxDevice.mobileM}`) ? "vertical" : "horizontal",
    labelStyle: { paddingTop: 4, paddingBottom: 4 },
    contentStyle: { paddingTop: 4, paddingBottom: 4 }
  }, a = () => r?.Data ? `data:${r?.ContentType};base64,${r?.Data}` : void 0;
  return i.jsx(bn, { style: { flex: 1 }, loading: t, headStyle: { textAlign: "center" }, title: `Información del ${e === "Ventas" ? "cliente" : "proveedor"}`, children: i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsxs(Ke, { style: {
    gap: 8,
    alignItems: "center"
  }, children: [i.jsx(_l, { size: 56, alt: "client info", src: a() ? a() : "/avatar-placeholder.png" }), i.jsx(gn, { level: 4, children: Up(`${r?.Nombre}`, `${r?.Apellido}`) })] }), i.jsxs(On, { ...o, labelStyle: { textAlign: "center" }, children: [ot(i.jsx(me, { name: "id", hoverablePrimary: !0 }), r?.DNI), ot(i.jsx(me, { hoverablePrimary: !0, name: "device-mobile" }), i.jsx(nr, { href: `tel: ${r?.Telefono}`, children: r?.Telefono })), ot(i.jsx(me, { name: "at", hoverablePrimary: !0 }), i.jsx(nr, { href: `mailto: ${r?.CorreoElectronico}`, children: r?.CorreoElectronico }))] }), i.jsxs(On, { ...o, children: [ot("Deuda", tr(Number(r?.Deuda), "RD$")), ot("Crédito disponible", r?.LimiteCredito ? tr(Number(r?.LimiteCredito), "RD$") : "N/A"), ot("Saldo a favor", tr(Number(r?.SaldoAFavor), "RD$"))] })] }) });
}, rD = ({ PrincipalInfo: e, GlobalButtons: t }) => {
  const n = {
    bordered: !0,
    layout: sr(`${st.maxDevice.mobileM}`) ? "vertical" : "horizontal",
    column: { xs: 1, sm: 1, md: 1, lg: 1, xl: 2, xxl: 2 }
  };
  return i.jsx(Qt, { style: { flex: 2.5 }, extra: t, title: `Documento No. ${e?.DocumentoNumero}`, children: i.jsxs(pr, { ...n, style: { width: "100%" }, children: [ot("Documento", e?.TipoDocumentoNombre), ot("Tipo de plazo", e?.TipoPlazoNombre), ot("Comprobante", e?.NombreCorto), ot("Almacén", e?.AlmacenNombre), ot("Fecha", new Date(e?.Fecha || "").getDate() ? bt(e?.Fecha).format("DD-MM-YYYY") : "N/A"), ot("Lista de precio", e?.ProductoListaPrecioNombre), ot("Moneda", e?.MonedaNombre), ot("Tasa venta", tr(Number(e?.Tasa))), ot("Vencimiento", new Date(e?.FechaVencimiento || "").getDate() ? bt(e?.FechaVencimiento).format("DD-MM-YYYY") : "N/A"), ot("Fecha tasa", new Date(e?.TasaFecha || "").getDate() ? bt(e?.TasaFecha).format("DD-MM-YYYY") : "N/A"), ot("Estado", i.jsx(rr.Status, { state: e?.EstadoNombre }))] }) });
}, Zr = ({ Area: e, isPending: t, isFetching: r, ContactInfo: n, PrincipalInfo: o, RouteNavigate: a, ExecuteClonate: s, ExecuteBackToDraft: c }) => {
  const { statesValues: l } = et(), d = sr(`${st.maxDevice.laptop}`);
  return i.jsxs(Ke, { style: {
    gap: 16,
    width: "100%",
    flexDirection: d ? "column" : "row"
  }, children: [i.jsx(tD, { Area: e, isPending: t, isFetching: r, ContactInfo: n }), i.jsx(rD, { PrincipalInfo: o, GlobalButtons: i.jsx(eD, { RouteNavigate: a, ExecuteClonate: s, EstadoId: o?.EstadoId, DocumentoId: o?.DocumentoId, TipoDocumentoId: o?.TipoDocumentoId, TieneReciboAnulado: o?.TieneReciboAnulado, ExecuteBackToDraft: !o?.EsRecurrente && o?.EstadoId && o?.EstadoId !== l.Borrador ? c : void 0 }) })] });
}, nD = () => i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  minHeight: "150px",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "space-between"
}, children: [i.jsx("div", { style: {
  width: "27%",
  padding: "15px",
  display: "flex",
  flexWrap: "wrap",
  paddingTop: "0px",
  background: "white",
  borderRadius: "8px",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0.6px 1px 9px 2.9px rgba(0, 0, 0, 0.09)"
}, children: i.jsx(Ki, { active: !0 }) }), i.jsx("div", { style: {
  width: "70%",
  padding: "25px",
  paddingTop: "0",
  display: "flex",
  marginTop: "0px",
  flexWrap: "wrap",
  minHeight: "150px",
  background: "white",
  borderRadius: "8px",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0.6px 1px 9px 2.9px rgba(0, 0, 0, 0.09)"
}, children: i.jsx(Vr, { size: "large", isLoading: !0, title: "Cargando la info del documento" }) }), i.jsx("div", { style: {
  width: "100%",
  marginTop: "30px",
  marginBottom: "10px",
  borderBottom: "1.5px solid #E2E2E2"
} })] }), Ct = () => i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "row",
  alignItems: "center"
}, children: [i.jsx(nD, {}), i.jsx("div", { style: { width: "100%", marginTop: "20px", minHeight: "350px" }, children: i.jsx("div", { style: { padding: "20px", background: "white" }, children: i.jsx(Ki, { active: !0 }) }) })] });
var oD = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, aD = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, iD = "".concat(oD, " ").concat(aD).split(/[\s\n]+/), sD = "aria-", cD = "data-";
function Hu(e, t) {
  return e.indexOf(t) === 0;
}
function lD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r;
  t === !1 ? r = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? r = {
    aria: !0
  } : r = ae({}, t);
  var n = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (r.aria && (o === "role" || Hu(o, sD)) || // Data
    r.data && Hu(o, cD) || // Attr
    r.attr && iD.includes(o)) && (n[o] = e[o]);
  }), n;
}
const Ic = function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), n = e.name || "", o = e.type || "", a = o.replace(/\/.*$/, "");
    return r.some(function(s) {
      var c = s.trim();
      if (/^\*(\/\*)?$/.test(s))
        return !0;
      if (c.charAt(0) === ".") {
        var l = n.toLowerCase(), d = c.toLowerCase(), u = [d];
        return (d === ".jpg" || d === ".jpeg") && (u = [".jpg", ".jpeg"]), u.some(function(f) {
          return l.endsWith(f);
        });
      }
      return /\/\*$/.test(c) ? a === c.replace(/\/.*$/, "") : o === c ? !0 : /^\w+$/.test(c) ? (Tt(!1, "Upload takes an invalidate 'accept' type '".concat(c, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
};
function dD(e, t) {
  var r = "cannot ".concat(e.method, " ").concat(e.action, " ").concat(t.status, "'"), n = new Error(r);
  return n.status = t.status, n.method = e.method, n.url = e.action, n;
}
function Wu(e) {
  var t = e.responseText || e.response;
  if (!t)
    return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
function uD(e) {
  var t = new XMLHttpRequest();
  e.onProgress && t.upload && (t.upload.onprogress = function(a) {
    a.total > 0 && (a.percent = a.loaded / a.total * 100), e.onProgress(a);
  });
  var r = new FormData();
  e.data && Object.keys(e.data).forEach(function(o) {
    var a = e.data[o];
    if (Array.isArray(a)) {
      a.forEach(function(s) {
        r.append("".concat(o, "[]"), s);
      });
      return;
    }
    r.append(o, a);
  }), e.file instanceof Blob ? r.append(e.filename, e.file, e.file.name) : r.append(e.filename, e.file), t.onerror = function(a) {
    e.onError(a);
  }, t.onload = function() {
    return t.status < 200 || t.status >= 300 ? e.onError(dD(e, t), Wu(t)) : e.onSuccess(Wu(t), t);
  }, t.open(e.method, e.action, !0), e.withCredentials && "withCredentials" in t && (t.withCredentials = !0);
  var n = e.headers || {};
  return n["X-Requested-With"] !== null && t.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(n).forEach(function(o) {
    n[o] !== null && t.setRequestHeader(o, n[o]);
  }), t.send(r), {
    abort: function() {
      t.abort();
    }
  };
}
function fD(e, t) {
  var r = e.createReader(), n = [];
  function o() {
    r.readEntries(function(a) {
      var s = Array.prototype.slice.apply(a);
      n = n.concat(s);
      var c = !s.length;
      c ? t(n) : o();
    });
  }
  o();
}
var mD = function(t, r, n) {
  var o = function a(s, c) {
    s && (s.path = c || "", s.isFile ? s.file(function(l) {
      n(l) && (s.fullPath && !l.webkitRelativePath && (Object.defineProperties(l, {
        webkitRelativePath: {
          writable: !0
        }
      }), l.webkitRelativePath = s.fullPath.replace(/^\//, ""), Object.defineProperties(l, {
        webkitRelativePath: {
          writable: !1
        }
      })), r([l]));
    }) : s.isDirectory && fD(s, function(l) {
      l.forEach(function(d) {
        a(d, "".concat(c).concat(s.name, "/"));
      });
    }));
  };
  t.forEach(function(a) {
    o(a.webkitGetAsEntry());
  });
}, pD = +/* @__PURE__ */ new Date(), hD = 0;
function xc() {
  return "rc-upload-".concat(pD, "-").concat(++hD);
}
var gD = ["component", "prefixCls", "className", "classNames", "disabled", "id", "style", "styles", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"], vD = /* @__PURE__ */ function(e) {
  zn(r, e);
  var t = ea(r);
  function r() {
    var n;
    lr(this, r);
    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++)
      a[s] = arguments[s];
    return n = t.call.apply(t, [this].concat(a)), Q(Ze(n), "state", {
      uid: xc()
    }), Q(Ze(n), "reqs", {}), Q(Ze(n), "fileInput", void 0), Q(Ze(n), "_isMounted", void 0), Q(Ze(n), "onChange", function(c) {
      var l = n.props, d = l.accept, u = l.directory, f = c.target.files, h = Ne(f).filter(function(g) {
        return !u || Ic(g, d);
      });
      n.uploadFiles(h), n.reset();
    }), Q(Ze(n), "onClick", function(c) {
      var l = n.fileInput;
      if (l) {
        var d = c.target, u = n.props.onClick;
        if (d && d.tagName === "BUTTON") {
          var f = l.parentNode;
          f.focus(), d.blur();
        }
        l.click(), u && u(c);
      }
    }), Q(Ze(n), "onKeyDown", function(c) {
      c.key === "Enter" && n.onClick(c);
    }), Q(Ze(n), "onFileDrop", function(c) {
      var l = n.props.multiple;
      if (c.preventDefault(), c.type !== "dragover")
        if (n.props.directory)
          mD(Array.prototype.slice.call(c.dataTransfer.items), n.uploadFiles, function(u) {
            return Ic(u, n.props.accept);
          });
        else {
          var d = Ne(c.dataTransfer.files).filter(function(u) {
            return Ic(u, n.props.accept);
          });
          l === !1 && (d = d.slice(0, 1)), n.uploadFiles(d);
        }
    }), Q(Ze(n), "uploadFiles", function(c) {
      var l = Ne(c), d = l.map(function(u) {
        return u.uid = xc(), n.processFile(u, l);
      });
      Promise.all(d).then(function(u) {
        var f = n.props.onBatchStart;
        f?.(u.map(function(h) {
          var g = h.origin, E = h.parsedFile;
          return {
            file: g,
            parsedFile: E
          };
        })), u.filter(function(h) {
          return h.parsedFile !== null;
        }).forEach(function(h) {
          n.post(h);
        });
      });
    }), Q(Ze(n), "processFile", /* @__PURE__ */ function() {
      var c = kn(/* @__PURE__ */ Jt().mark(function l(d, u) {
        var f, h, g, E, v, m, y, I, b;
        return Jt().wrap(function(S) {
          for (; ; )
            switch (S.prev = S.next) {
              case 0:
                if (f = n.props.beforeUpload, h = d, !f) {
                  S.next = 14;
                  break;
                }
                return S.prev = 3, S.next = 6, f(d, u);
              case 6:
                h = S.sent, S.next = 12;
                break;
              case 9:
                S.prev = 9, S.t0 = S.catch(3), h = !1;
              case 12:
                if (h !== !1) {
                  S.next = 14;
                  break;
                }
                return S.abrupt("return", {
                  origin: d,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                if (g = n.props.action, typeof g != "function") {
                  S.next = 21;
                  break;
                }
                return S.next = 18, g(d);
              case 18:
                E = S.sent, S.next = 22;
                break;
              case 21:
                E = g;
              case 22:
                if (v = n.props.data, typeof v != "function") {
                  S.next = 29;
                  break;
                }
                return S.next = 26, v(d);
              case 26:
                m = S.sent, S.next = 30;
                break;
              case 29:
                m = v;
              case 30:
                return y = // string type is from legacy `transformFile`.
                // Not sure if this will work since no related test case works with it
                (it(h) === "object" || typeof h == "string") && h ? h : d, y instanceof File ? I = y : I = new File([y], d.name, {
                  type: d.type
                }), b = I, b.uid = d.uid, S.abrupt("return", {
                  origin: d,
                  data: m,
                  parsedFile: b,
                  action: E
                });
              case 35:
              case "end":
                return S.stop();
            }
        }, l, null, [[3, 9]]);
      }));
      return function(l, d) {
        return c.apply(this, arguments);
      };
    }()), Q(Ze(n), "saveFileInput", function(c) {
      n.fileInput = c;
    }), n;
  }
  return dr(r, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort();
    }
  }, {
    key: "post",
    value: function(o) {
      var a = this, s = o.data, c = o.origin, l = o.action, d = o.parsedFile;
      if (this._isMounted) {
        var u = this.props, f = u.onStart, h = u.customRequest, g = u.name, E = u.headers, v = u.withCredentials, m = u.method, y = c.uid, I = h || uD, b = {
          action: l,
          filename: g,
          data: s,
          file: d,
          headers: E,
          withCredentials: v,
          method: m || "post",
          onProgress: function(S) {
            var T = a.props.onProgress;
            T?.(S, d);
          },
          onSuccess: function(S, T) {
            var N = a.props.onSuccess;
            N?.(S, d, T), delete a.reqs[y];
          },
          onError: function(S, T) {
            var N = a.props.onError;
            N?.(S, T, d), delete a.reqs[y];
          }
        };
        f(c), this.reqs[y] = I(b);
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: xc()
      });
    }
  }, {
    key: "abort",
    value: function(o) {
      var a = this.reqs;
      if (o) {
        var s = o.uid ? o.uid : o;
        a[s] && a[s].abort && a[s].abort(), delete a[s];
      } else
        Object.keys(a).forEach(function(c) {
          a[c] && a[c].abort && a[c].abort(), delete a[c];
        });
    }
  }, {
    key: "render",
    value: function() {
      var o, a = this.props, s = a.component, c = a.prefixCls, l = a.className, d = a.classNames, u = d === void 0 ? {} : d, f = a.disabled, h = a.id, g = a.style, E = a.styles, v = E === void 0 ? {} : E, m = a.multiple, y = a.accept, I = a.capture, b = a.children, C = a.directory, S = a.openFileDialogOnClick, T = a.onMouseEnter, N = a.onMouseLeave, V = a.hasControlInside, D = cr(a, gD), x = we((o = {}, Q(o, c, !0), Q(o, "".concat(c, "-disabled"), f), Q(o, l, l), o)), O = C ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, w = f ? {} : {
        onClick: S ? this.onClick : function() {
        },
        onKeyDown: S ? this.onKeyDown : function() {
        },
        onMouseEnter: T,
        onMouseLeave: N,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: V ? void 0 : "0"
      };
      return /* @__PURE__ */ k.createElement(s, mt({}, w, {
        className: x,
        role: V ? void 0 : "button",
        style: g
      }), /* @__PURE__ */ k.createElement("input", mt({}, lD(D, {
        aria: !0,
        data: !0
      }), {
        id: h,
        disabled: f,
        type: "file",
        ref: this.saveFileInput,
        onClick: function($) {
          return $.stopPropagation();
        },
        key: this.state.uid,
        style: ae({
          display: "none"
        }, v.input),
        className: u.input,
        accept: y
      }, O, {
        multiple: m,
        onChange: this.onChange
      }, I != null ? {
        capture: I
      } : {})), b);
    }
  }]), r;
}(Mf);
function Sc() {
}
var Ol = /* @__PURE__ */ function(e) {
  zn(r, e);
  var t = ea(r);
  function r() {
    var n;
    lr(this, r);
    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++)
      a[s] = arguments[s];
    return n = t.call.apply(t, [this].concat(a)), Q(Ze(n), "uploader", void 0), Q(Ze(n), "saveUploader", function(c) {
      n.uploader = c;
    }), n;
  }
  return dr(r, [{
    key: "abort",
    value: function(o) {
      this.uploader.abort(o);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ k.createElement(vD, mt({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), r;
}(Mf);
Q(Ol, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: Sc,
  onError: Sc,
  onSuccess: Sc,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0,
  hasControlInside: !1
});
const yD = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: e.colorFillAlter,
        border: `${Me(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [t]: {
          padding: e.padding
        },
        [`${t}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none",
          borderRadius: e.borderRadiusLG,
          "&:focus-visible": {
            outline: `${Me(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`
          }
        },
        [`${t}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${t}-disabled):hover,
          &-hover:not(${t}-disabled)
        `]: {
          borderColor: e.colorPrimaryHover
        },
        [`p${t}-drag-icon`]: {
          marginBottom: e.margin,
          [r]: {
            color: e.colorPrimary,
            fontSize: e.uploadThumbnailSize
          }
        },
        [`p${t}-text`]: {
          margin: `0 0 ${Me(e.marginXXS)}`,
          color: e.colorTextHeading,
          fontSize: e.fontSizeLG
        },
        [`p${t}-hint`]: {
          color: e.colorTextDescription,
          fontSize: e.fontSize
        },
        // ===================== Disabled =====================
        [`&${t}-disabled`]: {
          [`p${t}-drag-icon ${r},
            p${t}-text,
            p${t}-hint
          `]: {
            color: e.colorTextDisabled
          }
        }
      }
    }
  };
}, bD = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: n,
    fontSize: o,
    lineHeight: a,
    calc: s
  } = e, c = `${t}-list-item`, l = `${c}-actions`, d = `${c}-action`, u = e.fontHeightSM;
  return {
    [`${t}-wrapper`]: {
      [`${t}-list`]: Object.assign(Object.assign({}, td()), {
        lineHeight: e.lineHeight,
        [c]: {
          position: "relative",
          height: s(e.lineHeight).mul(o).equal(),
          marginTop: e.marginXS,
          fontSize: o,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${e.motionDurationSlow}`,
          "&:hover": {
            backgroundColor: e.controlItemBgHover
          },
          [`${c}-name`]: Object.assign(Object.assign({}, ip), {
            padding: `0 ${Me(e.paddingXS)}`,
            lineHeight: a,
            flex: "auto",
            transition: `all ${e.motionDurationSlow}`
          }),
          [l]: {
            [d]: {
              opacity: 0
            },
            [n]: {
              color: e.actionsColor,
              transition: `all ${e.motionDurationSlow}`
            },
            [`
              ${d}:focus-visible,
              &.picture ${d}
            `]: {
              opacity: 1
            },
            [`${d}${r}-btn`]: {
              height: u,
              border: 0,
              lineHeight: 1
            }
          },
          [`${t}-icon ${n}`]: {
            color: e.colorTextDescription,
            fontSize: o
          },
          [`${c}-progress`]: {
            position: "absolute",
            bottom: e.calc(e.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: s(o).add(e.paddingXS).equal(),
            fontSize: o,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${c}:hover ${d}`]: {
          opacity: 1
        },
        [`${c}-error`]: {
          color: e.colorError,
          [`${c}-name, ${t}-icon ${n}`]: {
            color: e.colorError
          },
          [l]: {
            [`${n}, ${n}:hover`]: {
              color: e.colorError
            },
            [d]: {
              opacity: 1
            }
          }
        },
        [`${t}-list-item-container`]: {
          transition: `opacity ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
}, Gu = new er("uploadAnimateInlineIn", {
  from: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), Ku = new er("uploadAnimateInlineOut", {
  to: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), CD = (e) => {
  const {
    componentCls: t
  } = e, r = `${t}-animate-inline`;
  return [{
    [`${t}-wrapper`]: {
      [`${r}-appear, ${r}-enter, ${r}-leave`]: {
        animationDuration: e.motionDurationSlow,
        animationTimingFunction: e.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${r}-appear, ${r}-enter`]: {
        animationName: Gu
      },
      [`${r}-leave`]: {
        animationName: Ku
      }
    }
  }, {
    [`${t}-wrapper`]: XS(e)
  }, Gu, Ku];
}, ID = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    uploadThumbnailSize: n,
    uploadProgressOffset: o,
    calc: a
  } = e, s = `${t}-list`, c = `${s}-item`;
  return {
    [`${t}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${s}${s}-picture,
        ${s}${s}-picture-card,
        ${s}${s}-picture-circle
      `]: {
        [c]: {
          position: "relative",
          height: a(n).add(a(e.lineWidth).mul(2)).add(a(e.paddingXS).mul(2)).equal(),
          padding: e.paddingXS,
          border: `${Me(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${c}-thumbnail`]: Object.assign(Object.assign({}, ip), {
            width: n,
            height: n,
            lineHeight: Me(a(n).add(e.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [r]: {
              fontSize: e.fontSizeHeading2,
              color: e.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${c}-progress`]: {
            bottom: o,
            width: `calc(100% - ${Me(a(e.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: a(n).add(e.paddingXS).equal()
          }
        },
        [`${c}-error`]: {
          borderColor: e.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${c}-thumbnail ${r}`]: {
            [`svg path[fill='${Wc[0]}']`]: {
              fill: e.colorErrorBg
            },
            [`svg path[fill='${Wc.primary}']`]: {
              fill: e.colorError
            }
          }
        },
        [`${c}-uploading`]: {
          borderStyle: "dashed",
          [`${c}-name`]: {
            marginBottom: o
          }
        }
      },
      [`${s}${s}-picture-circle ${c}`]: {
        [`&, &::before, ${c}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
}, xD = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontSizeLG: n,
    colorTextLightSolid: o,
    calc: a
  } = e, s = `${t}-list`, c = `${s}-item`, l = e.uploadPicCardSize;
  return {
    [`
      ${t}-wrapper${t}-picture-card-wrapper,
      ${t}-wrapper${t}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, td()), {
      display: "inline-block",
      width: "100%",
      [`${t}${t}-select`]: {
        width: l,
        height: l,
        marginInlineEnd: e.marginXS,
        marginBottom: e.marginXS,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: e.colorFillAlter,
        border: `${Me(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [`> ${t}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${t}-disabled):hover`]: {
          borderColor: e.colorPrimary
        }
      },
      // list
      [`${s}${s}-picture-card, ${s}${s}-picture-circle`]: {
        [`${s}-item-container`]: {
          display: "inline-block",
          width: l,
          height: l,
          marginBlock: `0 ${Me(e.marginXS)}`,
          marginInline: `0 ${Me(e.marginXS)}`,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        [c]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${Me(a(e.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${Me(a(e.paddingXS).mul(2).equal())})`,
            backgroundColor: e.colorBgMask,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${c}:hover`]: {
          [`&::before, ${c}-actions`]: {
            opacity: 1
          }
        },
        [`${c}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${e.motionDurationSlow}`,
          [`
            ${r}-eye,
            ${r}-download,
            ${r}-delete
          `]: {
            zIndex: 10,
            width: n,
            margin: `0 ${Me(e.marginXXS)}`,
            fontSize: n,
            cursor: "pointer",
            transition: `all ${e.motionDurationSlow}`,
            color: o,
            "&:hover": {
              color: o
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${c}-thumbnail, ${c}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${c}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${c}-file + ${c}-name`]: {
          position: "absolute",
          bottom: e.margin,
          display: "block",
          width: `calc(100% - ${Me(a(e.paddingXS).mul(2).equal())})`
        },
        [`${c}-uploading`]: {
          [`&${c}`]: {
            backgroundColor: e.colorFillAlter
          },
          [`&::before, ${r}-eye, ${r}-download, ${r}-delete`]: {
            display: "none"
          }
        },
        [`${c}-progress`]: {
          bottom: e.marginXL,
          width: `calc(100% - ${Me(a(e.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${t}-wrapper${t}-picture-circle-wrapper`]: {
      [`${t}${t}-select`]: {
        borderRadius: "50%"
      }
    }
  };
}, SD = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  };
}, ED = (e) => {
  const {
    componentCls: t,
    colorTextDisabled: r
  } = e;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, ho(e)), {
      [t]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${t}-select`]: {
        display: "inline-block"
      },
      [`${t}-disabled`]: {
        color: r,
        cursor: "not-allowed"
      }
    })
  };
}, DD = (e) => ({
  actionsColor: e.colorTextDescription
}), wD = Cn("Upload", (e) => {
  const {
    fontSizeHeading3: t,
    fontHeight: r,
    lineWidth: n,
    controlHeightLG: o,
    calc: a
  } = e, s = fr(e, {
    uploadThumbnailSize: a(t).mul(2).equal(),
    uploadProgressOffset: a(a(r).div(2)).add(n).equal(),
    uploadPicCardSize: a(o).mul(2.55).equal()
  });
  return [ED(s), yD(s), ID(s), xD(s), bD(s), CD(s), SD(s), gh(s)];
}, DD);
var TD = { icon: function(t, r) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: r } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: t } }] };
}, name: "file", theme: "twotone" };
const FD = TD;
var wh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: FD
  }));
};
process.env.NODE_ENV !== "production" && (wh.displayName = "FileTwoTone");
const OD = /* @__PURE__ */ p.forwardRef(wh);
var ND = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const RD = ND;
var Th = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: RD
  }));
};
process.env.NODE_ENV !== "production" && (Th.displayName = "LoadingOutlined");
const os = /* @__PURE__ */ p.forwardRef(Th);
var PD = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" };
const jD = PD;
var Fh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: jD
  }));
};
process.env.NODE_ENV !== "production" && (Fh.displayName = "PaperClipOutlined");
const $D = /* @__PURE__ */ p.forwardRef(Fh);
var AD = { icon: function(t, r) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: t } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: r } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: r } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: r } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: t } }] };
}, name: "picture", theme: "twotone" };
const _D = AD;
var Oh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: _D
  }));
};
process.env.NODE_ENV !== "production" && (Oh.displayName = "PictureTwoTone");
const MD = /* @__PURE__ */ p.forwardRef(Oh);
function LD() {
  const [, e] = p.useReducer((t) => t + 1, 0);
  return e;
}
const Ec = () => ({
  height: 0,
  opacity: 0
}), Yu = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, VD = (e) => ({
  height: e ? e.offsetHeight : 0
}), Dc = (e, t) => t?.deadline === !0 || t.propertyName === "height", zD = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: Ec,
    onEnterStart: Ec,
    onAppearActive: Yu,
    onEnterActive: Yu,
    onLeaveStart: VD,
    onLeaveActive: Ec,
    onAppearEnd: Dc,
    onEnterEnd: Dc,
    onLeaveEnd: Dc,
    motionDeadline: 500
  };
}, BD = (e, t, r) => r !== void 0 ? r : `${e}-${t}`, Nl = zD, {
  isValidElement: Yo
} = p;
function Nh(e) {
  return e && Yo(e) && e.type === p.Fragment;
}
function kD(e, t, r) {
  return Yo(e) ? /* @__PURE__ */ p.cloneElement(e, typeof r == "function" ? r(e.props || {}) : r) : t;
}
function fo(e, t) {
  return kD(e, e, t);
}
const gd = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), r = t.width, n = t.height;
      if (r || n)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), a = o.width, s = o.height;
      if (a || s)
        return !0;
    }
  }
  return !1;
}, UD = (e) => {
  const {
    componentCls: t,
    colorPrimary: r
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${r})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${e.motionEaseInOut}`, `opacity 0.35s ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, qD = rd("Wave", (e) => [UD(e)]);
var ni = ae({}, Xg), HD = ni.version, WD = ni.render, GD = ni.unmountComponentAtNode, js;
try {
  var KD = Number((HD || "").split(".")[0]);
  KD >= 18 && (js = ni.createRoot);
} catch {
}
function Qu(e) {
  var t = ni.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && it(t) === "object" && (t.usingClientEntryPoint = e);
}
var as = "__rc_react_root__";
function YD(e, t) {
  Qu(!0);
  var r = t[as] || js(t);
  Qu(!1), r.render(e), t[as] = r;
}
function QD(e, t) {
  WD(e, t);
}
function XD(e, t) {
  if (js) {
    YD(e, t);
    return;
  }
  QD(e, t);
}
function ZD(e) {
  return Rl.apply(this, arguments);
}
function Rl() {
  return Rl = kn(/* @__PURE__ */ Jt().mark(function e(t) {
    return Jt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = t[as]) === null || o === void 0 || o.unmount(), delete t[as];
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), Rl.apply(this, arguments);
}
function JD(e) {
  GD(e);
}
function ew(e) {
  return Pl.apply(this, arguments);
}
function Pl() {
  return Pl = kn(/* @__PURE__ */ Jt().mark(function e(t) {
    return Jt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            if (js === void 0) {
              n.next = 2;
              break;
            }
            return n.abrupt("return", ZD(t));
          case 2:
            JD(t);
          case 3:
          case "end":
            return n.stop();
        }
    }, e);
  })), Pl.apply(this, arguments);
}
function tw(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function wc(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && tw(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function rw(e) {
  const {
    borderTopColor: t,
    borderColor: r,
    backgroundColor: n
  } = getComputedStyle(e);
  return wc(t) ? t : wc(r) ? r : wc(n) ? n : null;
}
const Rh = "ant-wave-target";
function Tc(e) {
  return Number.isNaN(e) ? 0 : e;
}
const nw = (e) => {
  const {
    className: t,
    target: r,
    component: n
  } = e, o = p.useRef(null), [a, s] = p.useState(null), [c, l] = p.useState([]), [d, u] = p.useState(0), [f, h] = p.useState(0), [g, E] = p.useState(0), [v, m] = p.useState(0), [y, I] = p.useState(!1), b = {
    left: d,
    top: f,
    width: g,
    height: v,
    borderRadius: c.map((T) => `${T}px`).join(" ")
  };
  a && (b["--wave-color"] = a);
  function C() {
    const T = getComputedStyle(r);
    s(rw(r));
    const N = T.position === "static", {
      borderLeftWidth: V,
      borderTopWidth: D
    } = T;
    u(N ? r.offsetLeft : Tc(-parseFloat(V))), h(N ? r.offsetTop : Tc(-parseFloat(D))), E(r.offsetWidth), m(r.offsetHeight);
    const {
      borderTopLeftRadius: x,
      borderTopRightRadius: O,
      borderBottomLeftRadius: w,
      borderBottomRightRadius: j
    } = T;
    l([x, O, j, w].map(($) => Tc(parseFloat($))));
  }
  if (p.useEffect(() => {
    if (r) {
      const T = Nr(() => {
        C(), I(!0);
      });
      let N;
      return typeof ResizeObserver < "u" && (N = new ResizeObserver(C), N.observe(r)), () => {
        Nr.cancel(T), N?.disconnect();
      };
    }
  }, []), !y)
    return null;
  const S = (n === "Checkbox" || n === "Radio") && r?.classList.contains(Rh);
  return /* @__PURE__ */ p.createElement(Bn, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (T, N) => {
      var V;
      if (N.deadline || N.propertyName === "opacity") {
        const D = (V = o.current) === null || V === void 0 ? void 0 : V.parentElement;
        ew(D).then(() => {
          D?.remove();
        });
      }
      return !1;
    }
  }, (T) => {
    let {
      className: N
    } = T;
    return /* @__PURE__ */ p.createElement("div", {
      ref: o,
      className: we(t, {
        "wave-quick": S
      }, N),
      style: b
    });
  });
}, ow = (e, t) => {
  var r;
  const {
    component: n
  } = t;
  if (n === "Checkbox" && !(!((r = e.querySelector("input")) === null || r === void 0) && r.checked))
    return;
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", e?.insertBefore(o, e?.firstChild), XD(/* @__PURE__ */ p.createElement(nw, Object.assign({}, t, {
    target: e
  })), o);
}, aw = ow;
function iw(e, t, r) {
  const {
    wave: n
  } = p.useContext(Mt), [, o, a] = Lr(), s = Ur((d) => {
    const u = e.current;
    if (n?.disabled || !u)
      return;
    const f = u.querySelector(`.${Rh}`) || u, {
      showEffect: h
    } = n || {};
    (h || aw)(f, {
      className: t,
      token: o,
      component: r,
      event: d,
      hashId: a
    });
  }), c = p.useRef();
  return (d) => {
    Nr.cancel(c.current), c.current = Nr(() => {
      s(d);
    });
  };
}
const Ph = (e) => {
  const {
    children: t,
    disabled: r,
    component: n
  } = e, {
    getPrefixCls: o
  } = Ir(Mt), a = Wt(null), s = o("wave"), [, c] = qD(s), l = iw(a, we(s, c), n);
  if (k.useEffect(() => {
    const u = a.current;
    if (!u || u.nodeType !== 1 || r)
      return;
    const f = (h) => {
      !gd(h.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || l(h);
    };
    return u.addEventListener("click", f, !0), () => {
      u.removeEventListener("click", f, !0);
    };
  }, [r]), !/* @__PURE__ */ k.isValidElement(t))
    return t ?? null;
  const d = Jo(t) ? po(t.ref, a) : a;
  return fo(t, {
    ref: d
  });
};
process.env.NODE_ENV !== "production" && (Ph.displayName = "Wave");
const sw = Ph;
var cw = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const jh = /* @__PURE__ */ p.createContext(void 0), lw = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = p.useContext(Mt), {
    prefixCls: n,
    size: o,
    className: a
  } = e, s = cw(e, ["prefixCls", "size", "className"]), c = t("btn-group", n), [, , l] = Lr();
  let d = "";
  switch (o) {
    case "large":
      d = "lg";
      break;
    case "small":
      d = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const f = ur("Button.Group");
    process.env.NODE_ENV !== "production" && f(!o || ["large", "small", "middle"].includes(o), "usage", "Invalid prop `size`.");
  }
  const u = we(c, {
    [`${c}-${d}`]: d,
    [`${c}-rtl`]: r === "rtl"
  }, a, l);
  return /* @__PURE__ */ p.createElement(jh.Provider, {
    value: o
  }, /* @__PURE__ */ p.createElement("div", Object.assign({}, s, {
    className: u
  })));
}, dw = lw, Xu = /^[\u4e00-\u9fa5]{2}$/, jl = Xu.test.bind(Xu);
function Zu(e) {
  return typeof e == "string";
}
function Pi(e) {
  return e === "text" || e === "link";
}
function uw(e, t) {
  if (e == null)
    return;
  const r = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && Zu(e.type) && jl(e.props.children) ? fo(e, {
    children: e.props.children.split("").join(r)
  }) : Zu(e) ? jl(e) ? /* @__PURE__ */ k.createElement("span", null, e.split("").join(r)) : /* @__PURE__ */ k.createElement("span", null, e) : Nh(e) ? /* @__PURE__ */ k.createElement("span", null, e) : e;
}
function fw(e, t) {
  let r = !1;
  const n = [];
  return k.Children.forEach(e, (o) => {
    const a = typeof o, s = a === "string" || a === "number";
    if (r && s) {
      const c = n.length - 1, l = n[c];
      n[c] = `${l}${o}`;
    } else
      n.push(o);
    r = s;
  }), k.Children.map(n, (o) => uw(o, t));
}
const mw = /* @__PURE__ */ Wa((e, t) => {
  const {
    className: r,
    style: n,
    children: o,
    prefixCls: a
  } = e, s = we(`${a}-icon`, r);
  return /* @__PURE__ */ k.createElement("span", {
    ref: t,
    className: s,
    style: n
  }, o);
}), $h = mw, Ju = /* @__PURE__ */ Wa((e, t) => {
  let {
    prefixCls: r,
    className: n,
    style: o,
    iconClassName: a
  } = e;
  const s = we(`${r}-loading-icon`, n);
  return /* @__PURE__ */ k.createElement($h, {
    prefixCls: r,
    className: s,
    style: o,
    ref: t
  }, /* @__PURE__ */ k.createElement(os, {
    className: a
  }));
}), Fc = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), Oc = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), pw = (e) => {
  const {
    prefixCls: t,
    loading: r,
    existIcon: n,
    className: o,
    style: a
  } = e, s = !!r;
  return n ? /* @__PURE__ */ k.createElement(Ju, {
    prefixCls: t,
    className: o,
    style: a
  }) : /* @__PURE__ */ k.createElement(Bn, {
    visible: s,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: s,
    removeOnLeave: !0,
    onAppearStart: Fc,
    onAppearActive: Oc,
    onEnterStart: Fc,
    onEnterActive: Oc,
    onLeaveStart: Oc,
    onLeaveActive: Fc
  }, (c, l) => {
    let {
      className: d,
      style: u
    } = c;
    return /* @__PURE__ */ k.createElement(Ju, {
      prefixCls: t,
      className: o,
      style: Object.assign(Object.assign({}, a), u),
      ref: l,
      iconClassName: d
    });
  });
}, hw = pw, ef = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), gw = (e) => {
  const {
    componentCls: t,
    fontSize: r,
    lineWidth: n,
    groupBorderColor: o,
    colorErrorHover: a
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(n).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: r
        }
      },
      // Border Color
      ef(`${t}-primary`, o),
      ef(`${t}-danger`, a)
    ]
  };
}, Ah = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: r,
    paddingBlock: n
  } = e;
  return fr(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: n,
    buttonIconOnlyFontSize: r
  });
}, _h = (e) => {
  var t, r, n, o, a, s;
  const c = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (r = e.contentFontSizeSM) !== null && r !== void 0 ? r : e.fontSize, d = (n = e.contentFontSizeLG) !== null && n !== void 0 ? n : e.fontSizeLG, u = (o = e.contentLineHeight) !== null && o !== void 0 ? o : qi(c), f = (a = e.contentLineHeightSM) !== null && a !== void 0 ? a : qi(l), h = (s = e.contentLineHeightLG) !== null && s !== void 0 ? s : qi(d);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    contentFontSize: c,
    contentFontSizeSM: l,
    contentFontSizeLG: d,
    contentLineHeight: u,
    contentLineHeightSM: f,
    contentLineHeightLG: h,
    paddingBlock: Math.max((e.controlHeight - c * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * f) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - d * h) / 2 - e.lineWidth, 0)
  };
}, vw = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontWeight: n
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: n,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${Me(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${r} + span, > span + ${r}`]: {
        marginInlineStart: e.marginXS
      },
      [`&:not(${t}-icon-only) > ${t}-icon`]: {
        [`&${t}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: e.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, iC(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${r})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${t}-compact-item`]: {
        flex: "none"
      }
    }
  };
}, yn = (e, t, r) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": r
  }
}), yw = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), bw = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), Cw = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), ka = (e, t, r, n, o, a, s, c) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: r || void 0,
    background: t,
    borderColor: n || void 0,
    boxShadow: "none"
  }, yn(e, Object.assign({
    background: t
  }, s), Object.assign({
    background: t
  }, c))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: o || void 0,
      borderColor: a || void 0
    }
  })
}), vd = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, Cw(e))
}), Mh = (e) => Object.assign({}, vd(e)), is = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), Lh = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Mh(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), yn(e.componentCls, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), ka(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, yn(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), ka(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), vd(e))
}), Iw = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Mh(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), yn(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), ka(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, yn(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), ka(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), vd(e))
}), xw = (e) => Object.assign(Object.assign({}, Lh(e)), {
  borderStyle: "dashed"
}), Sw = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, yn(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), is(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, yn(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), is(e))
}), Ew = (e) => Object.assign(Object.assign(Object.assign({}, yn(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), is(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, is(e)), yn(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }))
}), Dw = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: Lh(e),
    [`${t}-primary`]: Iw(e),
    [`${t}-dashed`]: xw(e),
    [`${t}-link`]: Sw(e),
    [`${t}-text`]: Ew(e),
    [`${t}-ghost`]: ka(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, yd = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: r,
    controlHeight: n,
    fontSize: o,
    lineHeight: a,
    borderRadius: s,
    buttonPaddingHorizontal: c,
    iconCls: l,
    buttonPaddingVertical: d
  } = e, u = `${r}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: o,
        lineHeight: a,
        height: n,
        padding: `${Me(d)} ${Me(c)}`,
        borderRadius: s,
        [`&${u}`]: {
          width: n,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${r}-round`]: {
            width: "auto"
          },
          [l]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${r}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${r}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${r}${r}-circle${t}`]: yw(e)
    },
    {
      [`${r}${r}-round${t}`]: bw(e)
    }
  ];
}, ww = (e) => {
  const t = fr(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return yd(t, e.componentCls);
}, Tw = (e) => {
  const t = fr(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return yd(t, `${e.componentCls}-sm`);
}, Fw = (e) => {
  const t = fr(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return yd(t, `${e.componentCls}-lg`);
}, Ow = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, Nw = Cn("Button", (e) => {
  const t = Ah(e);
  return [
    // Shared
    vw(t),
    // Size
    ww(t),
    Tw(t),
    Fw(t),
    // Block
    Ow(t),
    // Group (type, ghost, danger, loading)
    Dw(t),
    // Button Group
    gw(t)
  ];
}, _h, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function Rw(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function Pw(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function jw(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, Rw(e, t)), Pw(e.componentCls, t))
  };
}
const $w = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: r(e.lineWidth).mul(-1).equal(),
            insetInlineStart: r(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${Me(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: r(e.lineWidth).mul(-1).equal(),
              insetInlineStart: r(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${Me(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, Aw = mp(["Button", "compact"], (e) => {
  const t = Ah(e);
  return [
    // Space Compact
    Mp(t),
    jw(t),
    $w(t)
  ];
}, _h);
var _w = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Mw(e) {
  if (typeof e == "object" && e) {
    let t = e?.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const Lw = (e, t) => {
  var r, n;
  const {
    loading: o = !1,
    prefixCls: a,
    type: s = "default",
    danger: c,
    shape: l = "default",
    size: d,
    styles: u,
    disabled: f,
    className: h,
    rootClassName: g,
    children: E,
    icon: v,
    ghost: m = !1,
    block: y = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: I = "button",
    classNames: b,
    style: C = {}
  } = e, S = _w(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]), {
    getPrefixCls: T,
    autoInsertSpaceInButton: N,
    direction: V,
    button: D
  } = Ir(Mt), x = T("btn", a), [O, w, j] = Nw(x), $ = Ir(Qa), _ = f ?? $, A = Ir(jh), R = $a(() => Mw(o), [o]), [P, z] = ja(R.loading), [F, L] = ja(!1), B = po(t, /* @__PURE__ */ Gg()), W = Wg.count(E) === 1 && !v && !Pi(s);
  xr(() => {
    let Ie = null;
    R.delay > 0 ? Ie = setTimeout(() => {
      Ie = null, z(!0);
    }, R.delay) : z(R.loading);
    function Pe() {
      Ie && (clearTimeout(Ie), Ie = null);
    }
    return Pe;
  }, [R]), xr(() => {
    if (!B || !B.current || N === !1)
      return;
    const Ie = B.current.textContent;
    W && jl(Ie) ? F || L(!0) : F && L(!1);
  }, [B]);
  const ee = (Ie) => {
    const {
      onClick: Pe
    } = e;
    if (P || _) {
      Ie.preventDefault();
      return;
    }
    Pe?.(Ie);
  };
  if (process.env.NODE_ENV !== "production") {
    const Ie = ur("Button");
    process.env.NODE_ENV !== "production" && Ie(!(typeof v == "string" && v.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${v}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && Ie(!(m && Pi(s)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const te = N !== !1, {
    compactSize: de,
    compactItemClassnames: Z
  } = WI(x, V), ce = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Y = od((Ie) => {
    var Pe, Le;
    return (Le = (Pe = d ?? de) !== null && Pe !== void 0 ? Pe : A) !== null && Le !== void 0 ? Le : Ie;
  }), he = Y && ce[Y] || "", ve = P ? "loading" : v, ue = Ya(S, ["navigate"]), le = we(x, w, j, {
    [`${x}-${l}`]: l !== "default" && l,
    [`${x}-${s}`]: s,
    [`${x}-${he}`]: he,
    [`${x}-icon-only`]: !E && E !== 0 && !!ve,
    [`${x}-background-ghost`]: m && !Pi(s),
    [`${x}-loading`]: P,
    [`${x}-two-chinese-chars`]: F && te && !P,
    [`${x}-block`]: y,
    [`${x}-dangerous`]: !!c,
    [`${x}-rtl`]: V === "rtl"
  }, Z, h, g, D?.className), Fe = Object.assign(Object.assign({}, D?.style), C), He = we(b?.icon, (r = D?.classNames) === null || r === void 0 ? void 0 : r.icon), We = Object.assign(Object.assign({}, u?.icon || {}), ((n = D?.styles) === null || n === void 0 ? void 0 : n.icon) || {}), ie = v && !P ? /* @__PURE__ */ k.createElement($h, {
    prefixCls: x,
    className: He,
    style: We
  }, v) : /* @__PURE__ */ k.createElement(hw, {
    existIcon: !!v,
    prefixCls: x,
    loading: !!P
  }), ge = E || E === 0 ? fw(E, W && te) : null;
  if (ue.href !== void 0)
    return O(/* @__PURE__ */ k.createElement("a", Object.assign({}, ue, {
      className: we(le, {
        [`${x}-disabled`]: _
      }),
      href: _ ? void 0 : ue.href,
      style: Fe,
      onClick: ee,
      ref: B,
      tabIndex: _ ? -1 : 0
    }), ie, ge));
  let be = /* @__PURE__ */ k.createElement("button", Object.assign({}, S, {
    type: I,
    className: le,
    style: Fe,
    onClick: ee,
    disabled: _,
    ref: B
  }), ie, ge, !!Z && /* @__PURE__ */ k.createElement(Aw, {
    key: "compact",
    prefixCls: x
  }));
  return Pi(s) || (be = /* @__PURE__ */ k.createElement(sw, {
    component: "Button",
    disabled: !!P
  }, be)), O(be);
}, $s = /* @__PURE__ */ Wa(Lw);
process.env.NODE_ENV !== "production" && ($s.displayName = "Button");
$s.Group = dw;
$s.__ANT_BUTTON = !0;
const tf = $s;
function ji(e) {
  return Object.assign(Object.assign({}, e), {
    lastModified: e.lastModified,
    lastModifiedDate: e.lastModifiedDate,
    name: e.name,
    size: e.size,
    type: e.type,
    uid: e.uid,
    percent: 0,
    originFileObj: e
  });
}
function $i(e, t) {
  const r = Ne(t), n = r.findIndex((o) => {
    let {
      uid: a
    } = o;
    return a === e.uid;
  });
  return n === -1 ? r.push(e) : r[n] = e, r;
}
function Nc(e, t) {
  const r = e.uid !== void 0 ? "uid" : "name";
  return t.filter((n) => n[r] === e[r])[0];
}
function Vw(e, t) {
  const r = e.uid !== void 0 ? "uid" : "name", n = t.filter((o) => o[r] !== e[r]);
  return n.length === t.length ? null : n;
}
const zw = function() {
  const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split("/"), n = t[t.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(n) || [""])[0];
}, Vh = (e) => e.indexOf("image/") === 0, Bw = (e) => {
  if (e.type && !e.thumbUrl)
    return Vh(e.type);
  const t = e.thumbUrl || e.url || "", r = zw(t);
  return /^data:image\//.test(t) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(r) ? !0 : !(/^data:/.test(t) || r);
}, Dn = 200;
function kw(e) {
  return new Promise((t) => {
    if (!e.type || !Vh(e.type)) {
      t("");
      return;
    }
    const r = document.createElement("canvas");
    r.width = Dn, r.height = Dn, r.style.cssText = `position: fixed; left: 0; top: 0; width: ${Dn}px; height: ${Dn}px; z-index: 9999; display: none;`, document.body.appendChild(r);
    const n = r.getContext("2d"), o = new Image();
    if (o.onload = () => {
      const {
        width: a,
        height: s
      } = o;
      let c = Dn, l = Dn, d = 0, u = 0;
      a > s ? (l = s * (Dn / a), u = -(l - c) / 2) : (c = a * (Dn / s), d = -(c - l) / 2), n.drawImage(o, d, u, c, l);
      const f = r.toDataURL();
      document.body.removeChild(r), window.URL.revokeObjectURL(o.src), t(f);
    }, o.crossOrigin = "anonymous", e.type.startsWith("image/svg+xml")) {
      const a = new FileReader();
      a.onload = () => {
        a.result && typeof a.result == "string" && (o.src = a.result);
      }, a.readAsDataURL(e);
    } else if (e.type.startsWith("image/gif")) {
      const a = new FileReader();
      a.onload = () => {
        a.result && t(a.result);
      }, a.readAsDataURL(e);
    } else
      o.src = window.URL.createObjectURL(e);
  });
}
var Uw = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const qw = Uw;
var zh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: qw
  }));
};
process.env.NODE_ENV !== "production" && (zh.displayName = "DeleteOutlined");
const Hw = /* @__PURE__ */ p.forwardRef(zh);
var Ww = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" };
const Gw = Ww;
var Bh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: Gw
  }));
};
process.env.NODE_ENV !== "production" && (Bh.displayName = "DownloadOutlined");
const Kw = /* @__PURE__ */ p.forwardRef(Bh);
var Yw = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const Qw = Yw;
var kh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: Qw
  }));
};
process.env.NODE_ENV !== "production" && (kh.displayName = "EyeOutlined");
const Xw = /* @__PURE__ */ p.forwardRef(kh);
var Zw = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const Jw = Zw;
var Uh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: Jw
  }));
};
process.env.NODE_ENV !== "production" && (Uh.displayName = "CheckCircleFilled");
const qh = /* @__PURE__ */ p.forwardRef(Uh);
var eT = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const tT = eT;
var Hh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: tT
  }));
};
process.env.NODE_ENV !== "production" && (Hh.displayName = "CheckOutlined");
const Wh = /* @__PURE__ */ p.forwardRef(Hh);
var rT = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const nT = rT;
var Gh = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: nT
  }));
};
process.env.NODE_ENV !== "production" && (Gh.displayName = "CloseOutlined");
const oT = /* @__PURE__ */ p.forwardRef(Gh);
var aT = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, iT = function() {
  var t = Wt([]), r = Wt(null);
  return xr(function() {
    var n = Date.now(), o = !1;
    t.current.forEach(function(a) {
      if (a) {
        o = !0;
        var s = a.style;
        s.transitionDuration = ".3s, .3s, .3s, .06s", r.current && n - r.current < 100 && (s.transitionDuration = "0s, 0s");
      }
    }), o && (r.current = Date.now());
  }), t.current;
};
process.env.NODE_ENV;
var rf = 0, sT = process.env.NODE_ENV !== "test" && Zt();
function cT() {
  var e;
  return sT ? (e = rf, rf += 1) : e = "TEST_OR_SSR", e;
}
const lT = function(e) {
  var t = p.useState(), r = Se(t, 2), n = r[0], o = r[1];
  return p.useEffect(function() {
    o("rc_progress_".concat(cT()));
  }, []), e || n;
};
var nf = function(t) {
  var r = t.bg, n = t.children;
  return /* @__PURE__ */ p.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: r
    }
  }, n);
};
function of(e, t) {
  return Object.keys(e).map(function(r) {
    var n = parseFloat(r), o = "".concat(Math.floor(n * t), "%");
    return "".concat(e[r], " ").concat(o);
  });
}
var Kh = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.color, o = e.gradientId, a = e.radius, s = e.style, c = e.ptg, l = e.strokeLinecap, d = e.strokeWidth, u = e.size, f = e.gapDegree, h = n && it(n) === "object", g = h ? "#FFF" : void 0, E = u / 2, v = /* @__PURE__ */ p.createElement("circle", {
    className: "".concat(r, "-circle-path"),
    r: a,
    cx: E,
    cy: E,
    stroke: g,
    strokeLinecap: l,
    strokeWidth: d,
    opacity: c === 0 ? 0 : 1,
    style: s,
    ref: t
  });
  if (!h)
    return v;
  var m = "".concat(o, "-conic"), y = f ? "".concat(180 + f / 2, "deg") : "0deg", I = of(n, (360 - f) / 360), b = of(n, 1), C = "conic-gradient(from ".concat(y, ", ").concat(I.join(", "), ")"), S = "linear-gradient(to ".concat(f ? "bottom" : "top", ", ").concat(b.join(", "), ")");
  return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("mask", {
    id: m
  }, v), /* @__PURE__ */ p.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: u,
    height: u,
    mask: "url(#".concat(m, ")")
  }, /* @__PURE__ */ p.createElement(nf, {
    bg: S
  }, /* @__PURE__ */ p.createElement(nf, {
    bg: C
  }))));
});
process.env.NODE_ENV !== "production" && (Kh.displayName = "PtgCircle");
var Sa = 100, Rc = function(t, r, n, o, a, s, c, l, d, u) {
  var f = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, h = n / 100 * 360 * ((360 - s) / 360), g = s === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[c], E = (100 - o) / 100 * r;
  d === "round" && o !== 100 && (E += u / 2, E >= r && (E = r - 0.01));
  var v = Sa / 2;
  return {
    stroke: typeof l == "string" ? l : void 0,
    strokeDasharray: "".concat(r, "px ").concat(t),
    strokeDashoffset: E + f,
    transform: "rotate(".concat(a + h + g, "deg)"),
    transformOrigin: "".concat(v, "px ").concat(v, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, dT = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function af(e) {
  var t = e ?? [];
  return Array.isArray(t) ? t : [t];
}
var Yh = function(t) {
  var r = ae(ae({}, aT), t), n = r.id, o = r.prefixCls, a = r.steps, s = r.strokeWidth, c = r.trailWidth, l = r.gapDegree, d = l === void 0 ? 0 : l, u = r.gapPosition, f = r.trailColor, h = r.strokeLinecap, g = r.style, E = r.className, v = r.strokeColor, m = r.percent, y = cr(r, dT), I = Sa / 2, b = lT(n), C = "".concat(b, "-gradient"), S = I - s / 2, T = Math.PI * 2 * S, N = d > 0 ? 90 + d / 2 : -90, V = T * ((360 - d) / 360), D = it(a) === "object" ? a : {
    count: a,
    space: 2
  }, x = D.count, O = D.space, w = af(m), j = af(v), $ = j.find(function(L) {
    return L && it(L) === "object";
  }), _ = $ && it($) === "object", A = _ ? "butt" : h, R = Rc(T, V, 0, 100, N, d, u, f, A, s), P = iT(), z = function() {
    var M = 0;
    return w.map(function(B, W) {
      var ee = j[W] || j[j.length - 1], te = Rc(T, V, M, B, N, d, u, ee, A, s);
      return M += B, /* @__PURE__ */ p.createElement(Kh, {
        key: W,
        color: ee,
        ptg: B,
        radius: S,
        prefixCls: o,
        gradientId: C,
        style: te,
        strokeLinecap: A,
        strokeWidth: s,
        gapDegree: d,
        ref: function(Z) {
          P[W] = Z;
        },
        size: Sa
      });
    }).reverse();
  }, F = function() {
    var M = Math.round(x * (w[0] / 100)), B = 100 / x, W = 0;
    return new Array(x).fill(null).map(function(ee, te) {
      var de = te <= M - 1 ? j[0] : f, Z = de && it(de) === "object" ? "url(#".concat(C, ")") : void 0, ce = Rc(T, V, W, B, N, d, u, de, "butt", s, O);
      return W += (V - ce.strokeDashoffset + O) * 100 / V, /* @__PURE__ */ p.createElement("circle", {
        key: te,
        className: "".concat(o, "-circle-path"),
        r: S,
        cx: I,
        cy: I,
        stroke: Z,
        strokeWidth: s,
        opacity: 1,
        style: ce,
        ref: function(he) {
          P[te] = he;
        }
      });
    });
  };
  return /* @__PURE__ */ p.createElement("svg", mt({
    className: we("".concat(o, "-circle"), E),
    viewBox: "0 0 ".concat(Sa, " ").concat(Sa),
    style: g,
    id: n,
    role: "presentation"
  }, y), !x && /* @__PURE__ */ p.createElement("circle", {
    className: "".concat(o, "-circle-trail"),
    r: S,
    cx: I,
    cy: I,
    stroke: f,
    strokeLinecap: A,
    strokeWidth: c || s,
    style: R
  }), x ? F() : z());
};
process.env.NODE_ENV !== "production" && (Yh.displayName = "Circle");
function Qh(e) {
  var t = e.children, r = e.prefixCls, n = e.id, o = e.overlayInnerStyle, a = e.className, s = e.style;
  return /* @__PURE__ */ p.createElement("div", {
    className: we("".concat(r, "-content"), a),
    style: s
  }, /* @__PURE__ */ p.createElement("div", {
    className: "".concat(r, "-inner"),
    id: n,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
var Xh = /* @__PURE__ */ p.createContext(null), sf = [];
function uT(e, t) {
  var r = p.useState(function() {
    if (!Zt())
      return null;
    var E = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && E.setAttribute("data-debug", t), E;
  }), n = Se(r, 1), o = n[0], a = p.useRef(!1), s = p.useContext(Xh), c = p.useState(sf), l = Se(c, 2), d = l[0], u = l[1], f = s || (a.current ? void 0 : function(E) {
    u(function(v) {
      var m = [E].concat(Ne(v));
      return m;
    });
  });
  function h() {
    o.parentElement || document.body.appendChild(o), a.current = !0;
  }
  function g() {
    var E;
    (E = o.parentElement) === null || E === void 0 || E.removeChild(o), a.current = !1;
  }
  return jt(function() {
    return e ? s ? s(h) : h() : g(), g;
  }, [e]), jt(function() {
    d.length && (d.forEach(function(E) {
      return E();
    }), u(sf));
  }, [d]), [o, f];
}
var Pc;
function fT(e) {
  if (typeof document > "u")
    return 0;
  if (e || Pc === void 0) {
    var t = document.createElement("div");
    t.style.width = "100%", t.style.height = "200px";
    var r = document.createElement("div"), n = r.style;
    n.position = "absolute", n.top = "0", n.left = "0", n.pointerEvents = "none", n.visibility = "hidden", n.width = "200px", n.height = "150px", n.overflow = "hidden", r.appendChild(t), document.body.appendChild(r);
    var o = t.offsetWidth;
    r.style.overflow = "scroll";
    var a = t.offsetWidth;
    o === a && (a = r.clientWidth), document.body.removeChild(r), Pc = o - a;
  }
  return Pc;
}
function cf(e) {
  var t = e.match(/^(.*)px$/), r = Number(t?.[1]);
  return Number.isNaN(r) ? fT() : r;
}
function mT(e) {
  if (typeof document > "u" || !e || !(e instanceof Element))
    return {
      width: 0,
      height: 0
    };
  var t = getComputedStyle(e, "::-webkit-scrollbar"), r = t.width, n = t.height;
  return {
    width: cf(r),
    height: cf(n)
  };
}
function pT() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var hT = "rc-util-locker-".concat(Date.now()), lf = 0;
function gT(e) {
  var t = !!e, r = p.useState(function() {
    return lf += 1, "".concat(hT, "_").concat(lf);
  }), n = Se(r, 1), o = n[0];
  jt(function() {
    if (t) {
      var a = mT(document.body).width, s = pT();
      Pn(`
html body {
  overflow-y: hidden;
  `.concat(s ? "width: calc(100% - ".concat(a, "px);") : "", `
}`), o);
    } else
      Aa(o);
    return function() {
      Aa(o);
    };
  }, [t, o]);
}
var df = !1;
function vT(e) {
  return typeof e == "boolean" && (df = e), df;
}
var uf = function(t) {
  return t === !1 ? !1 : !Zt() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, bd = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.open, n = e.autoLock, o = e.getContainer, a = e.debug, s = e.autoDestroy, c = s === void 0 ? !0 : s, l = e.children, d = p.useState(r), u = Se(d, 2), f = u[0], h = u[1], g = f || r;
  process.env.NODE_ENV !== "production" && Tt(Zt() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), p.useEffect(function() {
    (c || r) && h(r);
  }, [r, c]);
  var E = p.useState(function() {
    return uf(o);
  }), v = Se(E, 2), m = v[0], y = v[1];
  p.useEffect(function() {
    var w = uf(o);
    y(w ?? null);
  });
  var I = uT(g && !m, a), b = Se(I, 2), C = b[0], S = b[1], T = m ?? C;
  gT(n && r && Zt() && (T === C || T === document.body));
  var N = null;
  if (l && Jo(l) && t) {
    var V = l;
    N = V.ref;
  }
  var D = Hl(N, t);
  if (!g || !Zt() || m === void 0)
    return null;
  var x = T === !1 || vT(), O = l;
  return t && (O = /* @__PURE__ */ p.cloneElement(l, {
    ref: D
  })), /* @__PURE__ */ p.createElement(Xh.Provider, {
    value: S
  }, x ? O : /* @__PURE__ */ Jg(O, T));
});
process.env.NODE_ENV !== "production" && (bd.displayName = "Portal");
function yT() {
  var e = ae({}, p);
  return e.useId;
}
var ff = 0, mf = yT();
const bT = mf ? (
  // Use React `useId`
  function(t) {
    var r = mf();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = p.useState("ssr-id"), n = Se(r, 2), o = n[0], a = n[1];
    return p.useEffect(function() {
      var s = ff;
      ff += 1, a("rc_unique_".concat(s));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : o);
  }
), CT = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e?.substr(0, 4));
};
function IT(e) {
  var t = e.prefixCls, r = e.align, n = e.arrow, o = e.arrowPos, a = n || {}, s = a.className, c = a.content, l = o.x, d = l === void 0 ? 0 : l, u = o.y, f = u === void 0 ? 0 : u, h = p.useRef();
  if (!r || !r.points)
    return null;
  var g = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var E = r.points[0], v = r.points[1], m = E[0], y = E[1], I = v[0], b = v[1];
    m === I || !["t", "b"].includes(m) ? g.top = f : m === "t" ? g.top = 0 : g.bottom = 0, y === b || !["l", "r"].includes(y) ? g.left = d : y === "l" ? g.left = 0 : g.right = 0;
  }
  return /* @__PURE__ */ p.createElement("div", {
    ref: h,
    className: we("".concat(t, "-arrow"), s),
    style: g
  }, c);
}
function xT(e) {
  var t = e.prefixCls, r = e.open, n = e.zIndex, o = e.mask, a = e.motion;
  return o ? /* @__PURE__ */ p.createElement(Bn, mt({}, a, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(s) {
    var c = s.className;
    return /* @__PURE__ */ p.createElement("div", {
      style: {
        zIndex: n
      },
      className: we("".concat(t, "-mask"), c)
    });
  }) : null;
}
var Zh = /* @__PURE__ */ p.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (Zh.displayName = "PopupContent");
var Jh = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.popup, n = e.className, o = e.prefixCls, a = e.style, s = e.target, c = e.onVisibleChanged, l = e.open, d = e.keepDom, u = e.fresh, f = e.onClick, h = e.mask, g = e.arrow, E = e.arrowPos, v = e.align, m = e.motion, y = e.maskMotion, I = e.forceRender, b = e.getPopupContainer, C = e.autoDestroy, S = e.portal, T = e.zIndex, N = e.onMouseEnter, V = e.onMouseLeave, D = e.onPointerEnter, x = e.ready, O = e.offsetX, w = e.offsetY, j = e.offsetR, $ = e.offsetB, _ = e.onAlign, A = e.onPrepare, R = e.stretch, P = e.targetWidth, z = e.targetHeight, F = typeof r == "function" ? r() : r, L = l || d, M = b?.length > 0, B = p.useState(!b || !M), W = Se(B, 2), ee = W[0], te = W[1];
  if (jt(function() {
    !ee && M && s && te(!0);
  }, [ee, M, s]), !ee)
    return null;
  var de = "auto", Z = {
    left: "-1000vw",
    top: "-1000vh",
    right: de,
    bottom: de
  };
  if (x || !l) {
    var ce, Y = v.points, he = v.dynamicInset || ((ce = v._experimental) === null || ce === void 0 ? void 0 : ce.dynamicInset), ve = he && Y[0][1] === "r", ue = he && Y[0][0] === "b";
    ve ? (Z.right = j, Z.left = de) : (Z.left = O, Z.right = de), ue ? (Z.bottom = $, Z.top = de) : (Z.top = w, Z.bottom = de);
  }
  var le = {};
  return R && (R.includes("height") && z ? le.height = z : R.includes("minHeight") && z && (le.minHeight = z), R.includes("width") && P ? le.width = P : R.includes("minWidth") && P && (le.minWidth = P)), l || (le.pointerEvents = "none"), /* @__PURE__ */ p.createElement(S, {
    open: I || L,
    getContainer: b && function() {
      return b(s);
    },
    autoDestroy: C
  }, /* @__PURE__ */ p.createElement(xT, {
    prefixCls: o,
    open: l,
    zIndex: T,
    mask: h,
    motion: y
  }), /* @__PURE__ */ p.createElement(ta, {
    onResize: _,
    disabled: !l
  }, function(Fe) {
    return /* @__PURE__ */ p.createElement(Bn, mt({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: I,
      leavedClassName: "".concat(o, "-hidden")
    }, m, {
      onAppearPrepare: A,
      onEnterPrepare: A,
      visible: l,
      onVisibleChanged: function(We) {
        var ie;
        m == null || (ie = m.onVisibleChanged) === null || ie === void 0 || ie.call(m, We), c(We);
      }
    }), function(He, We) {
      var ie = He.className, ge = He.style, be = we(o, ie, n);
      return /* @__PURE__ */ p.createElement("div", {
        ref: po(Fe, t, We),
        className: be,
        style: ae(ae(ae(ae({
          "--arrow-x": "".concat(E.x || 0, "px"),
          "--arrow-y": "".concat(E.y || 0, "px")
        }, Z), le), ge), {}, {
          boxSizing: "border-box",
          zIndex: T
        }, a),
        onMouseEnter: N,
        onMouseLeave: V,
        onPointerEnter: D,
        onClick: f
      }, g && /* @__PURE__ */ p.createElement(IT, {
        prefixCls: o,
        arrow: g,
        arrowPos: E,
        align: v
      }), /* @__PURE__ */ p.createElement(Zh, {
        cache: !l && !u
      }, F));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Jh.displayName = "Popup");
var eg = /* @__PURE__ */ p.forwardRef(function(e, t) {
  var r = e.children, n = e.getTriggerDOMNode, o = Jo(r), a = p.useCallback(function(c) {
    ql(t, n ? n(c) : c);
  }, [n]), s = Hl(a, r.ref);
  return o ? /* @__PURE__ */ p.cloneElement(r, {
    ref: s
  }) : r;
});
process.env.NODE_ENV !== "production" && (eg.displayName = "TriggerWrapper");
var pf = /* @__PURE__ */ p.createContext(null);
function hf(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function ST(e, t, r, n) {
  return p.useMemo(function() {
    var o = hf(r ?? t), a = hf(n ?? t), s = new Set(o), c = new Set(a);
    return e && (s.has("hover") && (s.delete("hover"), s.add("click")), c.has("hover") && (c.delete("hover"), c.add("click"))), [s, c];
  }, [e, t, r, n]);
}
function ET() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function DT(e, t, r, n) {
  for (var o = r.points, a = Object.keys(e), s = 0; s < a.length; s += 1) {
    var c, l = a[s];
    if (ET((c = e[l]) === null || c === void 0 ? void 0 : c.points, o, n))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function gf(e, t, r, n) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : n ? {
    motionName: n
  } : null);
}
function oi(e) {
  return e.ownerDocument.defaultView;
}
function $l(e) {
  for (var t = [], r = e?.parentElement, n = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var o = oi(r).getComputedStyle(r), a = o.overflowX, s = o.overflowY, c = o.overflow;
    [a, s, c].some(function(l) {
      return n.includes(l);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function Ua(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Ca(e) {
  return Ua(parseFloat(e), 0);
}
function vf(e, t) {
  var r = ae({}, e);
  return (t || []).forEach(function(n) {
    if (!(n instanceof HTMLBodyElement || n instanceof HTMLHtmlElement)) {
      var o = oi(n).getComputedStyle(n), a = o.overflow, s = o.overflowClipMargin, c = o.borderTopWidth, l = o.borderBottomWidth, d = o.borderLeftWidth, u = o.borderRightWidth, f = n.getBoundingClientRect(), h = n.offsetHeight, g = n.clientHeight, E = n.offsetWidth, v = n.clientWidth, m = Ca(c), y = Ca(l), I = Ca(d), b = Ca(u), C = Ua(Math.round(f.width / E * 1e3) / 1e3), S = Ua(Math.round(f.height / h * 1e3) / 1e3), T = (E - v - I - b) * C, N = (h - g - m - y) * S, V = m * S, D = y * S, x = I * C, O = b * C, w = 0, j = 0;
      if (a === "clip") {
        var $ = Ca(s);
        w = $ * C, j = $ * S;
      }
      var _ = f.x + x - w, A = f.y + V - j, R = _ + f.width + 2 * w - x - O - T, P = A + f.height + 2 * j - V - D - N;
      r.left = Math.max(r.left, _), r.top = Math.max(r.top, A), r.right = Math.min(r.right, R), r.bottom = Math.min(r.bottom, P);
    }
  }), r;
}
function yf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(t), n = r.match(/^(.*)\%$/);
  return n ? e * (parseFloat(n[1]) / 100) : parseFloat(r);
}
function bf(e, t) {
  var r = t || [], n = Se(r, 2), o = n[0], a = n[1];
  return [yf(e.width, o), yf(e.height, a)];
}
function Cf() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function Fo(e, t) {
  var r = t[0], n = t[1], o, a;
  return r === "t" ? a = e.y : r === "b" ? a = e.y + e.height : a = e.y + e.height / 2, n === "l" ? o = e.x : n === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: a
  };
}
function wn(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(n, o) {
    return o === t ? r[n] || "c" : n;
  }).join("");
}
function wT(e, t, r, n, o, a, s) {
  var c = p.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[n] || {}
  }), l = Se(c, 2), d = l[0], u = l[1], f = p.useRef(0), h = p.useMemo(function() {
    return t ? $l(t) : [];
  }, [t]), g = p.useRef({}), E = function() {
    g.current = {};
  };
  e || E();
  var v = Ur(function() {
    if (t && r && e) {
      let Dr = function(dn, Yn) {
        var Io = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : be, xo = F.x + dn, ma = F.y + Yn, pa = xo + ce, hi = ma + Z, Ys = Math.max(xo, Io.left), Qs = Math.max(ma, Io.top), Xs = Math.min(pa, Io.right), Zs = Math.min(hi, Io.bottom);
        return Math.max(0, (Xs - Ys) * (Zs - Qs));
      }, pi = function() {
        oe = F.y + je, Ce = oe + Z, ze = F.x + Ae, ct = ze + ce;
      };
      var I, b, C = t, S = C.ownerDocument, T = oi(C), N = T.getComputedStyle(C), V = N.width, D = N.height, x = N.position, O = C.style.left, w = C.style.top, j = C.style.right, $ = C.style.bottom, _ = C.style.overflow, A = ae(ae({}, o[n]), a), R = S.createElement("div");
      (I = C.parentElement) === null || I === void 0 || I.appendChild(R), R.style.left = "".concat(C.offsetLeft, "px"), R.style.top = "".concat(C.offsetTop, "px"), R.style.position = x, R.style.height = "".concat(C.offsetHeight, "px"), R.style.width = "".concat(C.offsetWidth, "px"), C.style.left = "0", C.style.top = "0", C.style.right = "auto", C.style.bottom = "auto", C.style.overflow = "hidden";
      var P;
      if (Array.isArray(r))
        P = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var z = r.getBoundingClientRect();
        P = {
          x: z.x,
          y: z.y,
          width: z.width,
          height: z.height
        };
      }
      var F = C.getBoundingClientRect(), L = S.documentElement, M = L.clientWidth, B = L.clientHeight, W = L.scrollWidth, ee = L.scrollHeight, te = L.scrollTop, de = L.scrollLeft, Z = F.height, ce = F.width, Y = P.height, he = P.width, ve = {
        left: 0,
        top: 0,
        right: M,
        bottom: B
      }, ue = {
        left: -de,
        top: -te,
        right: W - de,
        bottom: ee - te
      }, le = A.htmlRegion, Fe = "visible", He = "visibleFirst";
      le !== "scroll" && le !== He && (le = Fe);
      var We = le === He, ie = vf(ue, h), ge = vf(ve, h), be = le === Fe ? ge : ie, Ie = We ? ge : be;
      C.style.left = "auto", C.style.top = "auto", C.style.right = "0", C.style.bottom = "0";
      var Pe = C.getBoundingClientRect();
      C.style.left = O, C.style.top = w, C.style.right = j, C.style.bottom = $, C.style.overflow = _, (b = C.parentElement) === null || b === void 0 || b.removeChild(R);
      var Le = Ua(Math.round(ce / parseFloat(V) * 1e3) / 1e3), Ve = Ua(Math.round(Z / parseFloat(D) * 1e3) / 1e3);
      if (Le === 0 || Ve === 0 || Zi(r) && !gd(r))
        return;
      var _e = A.offset, ut = A.targetOffset, Nt = bf(F, _e), pt = Se(Nt, 2), Ge = pt[0], dt = pt[1], q = bf(P, ut), H = Se(q, 2), G = H[0], ne = H[1];
      P.x -= G, P.y -= ne;
      var fe = A.points || [], Te = Se(fe, 2), Be = Te[0], $e = Te[1], pe = Cf($e), X = Cf(Be), re = Fo(P, pe), ye = Fo(F, X), xe = ae({}, A), Ae = re.x - ye.x + Ge, je = re.y - ye.y + dt, Qe = Dr(Ae, je), ht = Dr(Ae, je, ge), Ft = Fo(P, ["t", "l"]), $t = Fo(F, ["t", "l"]), Er = Fo(P, ["b", "r"]), nn = Fo(F, ["b", "r"]), Lt = A.overflow || {}, on = Lt.adjustX, an = Lt.adjustY, zr = Lt.shiftX, sn = Lt.shiftY, U = function(Yn) {
        return typeof Yn == "boolean" ? Yn : Yn >= 0;
      }, oe, Ce, ze, ct;
      pi();
      var gt = U(an), tt = X[0] === pe[0];
      if (gt && X[0] === "t" && (Ce > Ie.bottom || g.current.bt)) {
        var Je = je;
        tt ? Je -= Z - Y : Je = Ft.y - nn.y - dt;
        var Ot = Dr(Ae, Je), Et = Dr(Ae, Je, ge);
        // Of course use larger one
        Ot > Qe || Ot === Qe && (!We || // Choose recommend one
        Et >= ht) ? (g.current.bt = !0, je = Je, dt = -dt, xe.points = [wn(X, 0), wn(pe, 0)]) : g.current.bt = !1;
      }
      if (gt && X[0] === "b" && (oe < Ie.top || g.current.tb)) {
        var lt = je;
        tt ? lt += Z - Y : lt = Er.y - $t.y - dt;
        var Yt = Dr(Ae, lt), Br = Dr(Ae, lt, ge);
        // Of course use larger one
        Yt > Qe || Yt === Qe && (!We || // Choose recommend one
        Br >= ht) ? (g.current.tb = !0, je = lt, dt = -dt, xe.points = [wn(X, 0), wn(pe, 0)]) : g.current.tb = !1;
      }
      var qn = U(on), mr = X[1] === pe[1];
      if (qn && X[1] === "l" && (ct > Ie.right || g.current.rl)) {
        var Hn = Ae;
        mr ? Hn -= ce - he : Hn = Ft.x - nn.x - Ge;
        var si = Dr(Hn, je), zs = Dr(Hn, je, ge);
        // Of course use larger one
        si > Qe || si === Qe && (!We || // Choose recommend one
        zs >= ht) ? (g.current.rl = !0, Ae = Hn, Ge = -Ge, xe.points = [wn(X, 1), wn(pe, 1)]) : g.current.rl = !1;
      }
      if (qn && X[1] === "r" && (ze < Ie.left || g.current.lr)) {
        var Wn = Ae;
        mr ? Wn += ce - he : Wn = Er.x - $t.x - Ge;
        var ci = Dr(Wn, je), yo = Dr(Wn, je, ge);
        // Of course use larger one
        ci > Qe || ci === Qe && (!We || // Choose recommend one
        yo >= ht) ? (g.current.lr = !0, Ae = Wn, Ge = -Ge, xe.points = [wn(X, 1), wn(pe, 1)]) : g.current.lr = !1;
      }
      pi();
      var cn = zr === !0 ? 0 : zr;
      typeof cn == "number" && (ze < ge.left && (Ae -= ze - ge.left - Ge, P.x + he < ge.left + cn && (Ae += P.x - ge.left + he - cn)), ct > ge.right && (Ae -= ct - ge.right - Ge, P.x > ge.right - cn && (Ae += P.x - ge.right + cn)));
      var Gn = sn === !0 ? 0 : sn;
      typeof Gn == "number" && (oe < ge.top && (je -= oe - ge.top - dt, P.y + Y < ge.top + Gn && (je += P.y - ge.top + Y - Gn)), Ce > ge.bottom && (je -= Ce - ge.bottom - dt, P.y > ge.bottom - Gn && (je += P.y - ge.bottom + Gn)));
      var bo = F.x + Ae, Co = bo + ce, ln = F.y + je, li = ln + Z, Kn = P.x, En = Kn + he, di = P.y, Bs = di + Y, ks = Math.max(bo, Kn), ui = Math.min(Co, En), Us = (ks + ui) / 2, qs = Us - bo, Hs = Math.max(ln, di), fi = Math.min(li, Bs), Ws = (Hs + fi) / 2, Gs = Ws - ln;
      s?.(t, xe);
      var mi = Pe.right - F.x - (Ae + F.width), Ks = Pe.bottom - F.y - (je + F.height);
      u({
        ready: !0,
        offsetX: Ae / Le,
        offsetY: je / Ve,
        offsetR: mi / Le,
        offsetB: Ks / Ve,
        arrowX: qs / Le,
        arrowY: Gs / Ve,
        scaleX: Le,
        scaleY: Ve,
        align: xe
      });
    }
  }), m = function() {
    f.current += 1;
    var b = f.current;
    Promise.resolve().then(function() {
      f.current === b && v();
    });
  }, y = function() {
    u(function(b) {
      return ae(ae({}, b), {}, {
        ready: !1
      });
    });
  };
  return jt(y, [n]), jt(function() {
    e || y();
  }, [e]), [d.ready, d.offsetX, d.offsetY, d.offsetR, d.offsetB, d.arrowX, d.arrowY, d.scaleX, d.scaleY, d.align, m];
}
function TT(e, t, r, n, o) {
  jt(function() {
    if (e && t && r) {
      let f = function() {
        n(), o();
      };
      var a = t, s = r, c = $l(a), l = $l(s), d = oi(s), u = new Set([d].concat(Ne(c), Ne(l)));
      return u.forEach(function(h) {
        h.addEventListener("scroll", f, {
          passive: !0
        });
      }), d.addEventListener("resize", f, {
        passive: !0
      }), n(), function() {
        u.forEach(function(h) {
          h.removeEventListener("scroll", f), d.removeEventListener("resize", f);
        });
      };
    }
  }, [e, t, r]);
}
function FT(e, t, r, n, o, a, s, c) {
  var l = p.useRef(e), d = p.useRef(!1);
  l.current !== e && (d.current = !0, l.current = e), p.useEffect(function() {
    var u = Nr(function() {
      d.current = !1;
    });
    return function() {
      Nr.cancel(u);
    };
  }, [e]), p.useEffect(function() {
    if (t && n && (!o || a)) {
      var u = function() {
        var x = !1, O = function($) {
          var _ = $.target;
          x = s(_);
        }, w = function($) {
          var _ = $.target;
          !d.current && l.current && !x && !s(_) && c(!1);
        };
        return [O, w];
      }, f = u(), h = Se(f, 2), g = h[0], E = h[1], v = u(), m = Se(v, 2), y = m[0], I = m[1], b = oi(n);
      b.addEventListener("mousedown", g, !0), b.addEventListener("click", E, !0), b.addEventListener("contextmenu", E, !0);
      var C = Xi(r);
      if (C && (C.addEventListener("mousedown", y, !0), C.addEventListener("click", I, !0), C.addEventListener("contextmenu", I, !0)), process.env.NODE_ENV !== "production") {
        var S, T, N = r == null || (S = r.getRootNode) === null || S === void 0 ? void 0 : S.call(r), V = (T = n.getRootNode) === null || T === void 0 ? void 0 : T.call(n);
        Bo(N === V, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        b.removeEventListener("mousedown", g, !0), b.removeEventListener("click", E, !0), b.removeEventListener("contextmenu", E, !0), C && (C.removeEventListener("mousedown", y, !0), C.removeEventListener("click", I, !0), C.removeEventListener("contextmenu", I, !0));
      };
    }
  }, [t, r, n, o, a]);
}
var OT = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function NT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bd, t = /* @__PURE__ */ p.forwardRef(function(r, n) {
    var o = r.prefixCls, a = o === void 0 ? "rc-trigger-popup" : o, s = r.children, c = r.action, l = c === void 0 ? "hover" : c, d = r.showAction, u = r.hideAction, f = r.popupVisible, h = r.defaultPopupVisible, g = r.onPopupVisibleChange, E = r.afterPopupVisibleChange, v = r.mouseEnterDelay, m = r.mouseLeaveDelay, y = m === void 0 ? 0.1 : m, I = r.focusDelay, b = r.blurDelay, C = r.mask, S = r.maskClosable, T = S === void 0 ? !0 : S, N = r.getPopupContainer, V = r.forceRender, D = r.autoDestroy, x = r.destroyPopupOnHide, O = r.popup, w = r.popupClassName, j = r.popupStyle, $ = r.popupPlacement, _ = r.builtinPlacements, A = _ === void 0 ? {} : _, R = r.popupAlign, P = r.zIndex, z = r.stretch, F = r.getPopupClassNameFromAlign, L = r.fresh, M = r.alignPoint, B = r.onPopupClick, W = r.onPopupAlign, ee = r.arrow, te = r.popupMotion, de = r.maskMotion, Z = r.popupTransitionName, ce = r.popupAnimation, Y = r.maskTransitionName, he = r.maskAnimation, ve = r.className, ue = r.getTriggerDOMNode, le = cr(r, OT), Fe = D || x || !1, He = p.useState(!1), We = Se(He, 2), ie = We[0], ge = We[1];
    jt(function() {
      ge(CT());
    }, []);
    var be = p.useRef({}), Ie = p.useContext(pf), Pe = p.useMemo(function() {
      return {
        registerSubPopup: function(Xe, Rt) {
          be.current[Xe] = Rt, Ie?.registerSubPopup(Xe, Rt);
        }
      };
    }, [Ie]), Le = bT(), Ve = p.useState(null), _e = Se(Ve, 2), ut = _e[0], Nt = _e[1], pt = Ur(function(Re) {
      Zi(Re) && ut !== Re && Nt(Re), Ie?.registerSubPopup(Le, Re);
    }), Ge = p.useState(null), dt = Se(Ge, 2), q = dt[0], H = dt[1], G = p.useRef(null), ne = Ur(function(Re) {
      Zi(Re) && q !== Re && (H(Re), G.current = Re);
    }), fe = p.Children.only(s), Te = fe?.props || {}, Be = {}, $e = Ur(function(Re) {
      var Xe, Rt, kt = q;
      return kt?.contains(Re) || ((Xe = Xi(kt)) === null || Xe === void 0 ? void 0 : Xe.host) === Re || Re === kt || ut?.contains(Re) || ((Rt = Xi(ut)) === null || Rt === void 0 ? void 0 : Rt.host) === Re || Re === ut || Object.values(be.current).some(function(Pt) {
        return Pt?.contains(Re) || Re === Pt;
      });
    }), pe = gf(a, te, ce, Z), X = gf(a, de, he, Y), re = p.useState(h || !1), ye = Se(re, 2), xe = ye[0], Ae = ye[1], je = f ?? xe, Qe = Ur(function(Re) {
      f === void 0 && Ae(Re);
    });
    jt(function() {
      Ae(f || !1);
    }, [f]);
    var ht = p.useRef(je);
    ht.current = je;
    var Ft = p.useRef([]);
    Ft.current = [];
    var $t = Ur(function(Re) {
      var Xe;
      Qe(Re), ((Xe = Ft.current[Ft.current.length - 1]) !== null && Xe !== void 0 ? Xe : je) !== Re && (Ft.current.push(Re), g?.(Re));
    }), Er = p.useRef(), nn = function() {
      clearTimeout(Er.current);
    }, Lt = function(Xe) {
      var Rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      nn(), Rt === 0 ? $t(Xe) : Er.current = setTimeout(function() {
        $t(Xe);
      }, Rt * 1e3);
    };
    p.useEffect(function() {
      return nn;
    }, []);
    var on = p.useState(!1), an = Se(on, 2), zr = an[0], sn = an[1];
    jt(function(Re) {
      (!Re || je) && sn(!0);
    }, [je]);
    var U = p.useState(null), oe = Se(U, 2), Ce = oe[0], ze = oe[1], ct = p.useState([0, 0]), gt = Se(ct, 2), tt = gt[0], Je = gt[1], Ot = function(Xe) {
      Je([Xe.clientX, Xe.clientY]);
    }, Et = wT(je, ut, M ? tt : q, $, A, R, W), lt = Se(Et, 11), Yt = lt[0], Br = lt[1], qn = lt[2], mr = lt[3], Hn = lt[4], si = lt[5], zs = lt[6], Wn = lt[7], ci = lt[8], yo = lt[9], cn = lt[10], Gn = ST(ie, l, d, u), bo = Se(Gn, 2), Co = bo[0], ln = bo[1], li = Co.has("click"), Kn = ln.has("click") || ln.has("contextMenu"), En = Ur(function() {
      zr || cn();
    }), di = function() {
      ht.current && M && Kn && Lt(!1);
    };
    TT(je, q, ut, En, di), jt(function() {
      En();
    }, [tt, $]), jt(function() {
      je && !(A != null && A[$]) && En();
    }, [JSON.stringify(R)]);
    var Bs = p.useMemo(function() {
      var Re = DT(A, a, yo, M);
      return we(Re, F?.(yo));
    }, [yo, F, A, a, M]);
    p.useImperativeHandle(n, function() {
      return {
        nativeElement: G.current,
        forceAlign: En
      };
    });
    var ks = p.useState(0), ui = Se(ks, 2), Us = ui[0], qs = ui[1], Hs = p.useState(0), fi = Se(Hs, 2), Ws = fi[0], Gs = fi[1], mi = function() {
      if (z && q) {
        var Xe = q.getBoundingClientRect();
        qs(Xe.width), Gs(Xe.height);
      }
    }, Ks = function() {
      mi(), En();
    }, Dr = function(Xe) {
      sn(!1), cn(), E?.(Xe);
    }, pi = function() {
      return new Promise(function(Xe) {
        mi(), ze(function() {
          return Xe;
        });
      });
    };
    jt(function() {
      Ce && (cn(), Ce(), ze(null));
    }, [Ce]);
    function dn(Re, Xe, Rt, kt) {
      Be[Re] = function(Pt) {
        var gi;
        kt?.(Pt), Lt(Xe, Rt);
        for (var Js = arguments.length, xd = new Array(Js > 1 ? Js - 1 : 0), vi = 1; vi < Js; vi++)
          xd[vi - 1] = arguments[vi];
        (gi = Te[Re]) === null || gi === void 0 || gi.call.apply(gi, [Te, Pt].concat(xd));
      };
    }
    (li || Kn) && (Be.onClick = function(Re) {
      var Xe;
      ht.current && Kn ? Lt(!1) : !ht.current && li && (Ot(Re), Lt(!0));
      for (var Rt = arguments.length, kt = new Array(Rt > 1 ? Rt - 1 : 0), Pt = 1; Pt < Rt; Pt++)
        kt[Pt - 1] = arguments[Pt];
      (Xe = Te.onClick) === null || Xe === void 0 || Xe.call.apply(Xe, [Te, Re].concat(kt));
    }), FT(je, Kn, q, ut, C, T, $e, Lt);
    var Yn = Co.has("hover"), Io = ln.has("hover"), xo, ma;
    Yn && (dn("onMouseEnter", !0, v, function(Re) {
      Ot(Re);
    }), dn("onPointerEnter", !0, v, function(Re) {
      Ot(Re);
    }), xo = function(Xe) {
      (je || zr) && ut !== null && ut !== void 0 && ut.contains(Xe.target) && Lt(!0, v);
    }, M && (Be.onMouseMove = function(Re) {
      var Xe;
      (Xe = Te.onMouseMove) === null || Xe === void 0 || Xe.call(Te, Re);
    })), Io && (dn("onMouseLeave", !1, y), dn("onPointerLeave", !1, y), ma = function() {
      Lt(!1, y);
    }), Co.has("focus") && dn("onFocus", !0, I), ln.has("focus") && dn("onBlur", !1, b), Co.has("contextMenu") && (Be.onContextMenu = function(Re) {
      var Xe;
      ht.current && ln.has("contextMenu") ? Lt(!1) : (Ot(Re), Lt(!0)), Re.preventDefault();
      for (var Rt = arguments.length, kt = new Array(Rt > 1 ? Rt - 1 : 0), Pt = 1; Pt < Rt; Pt++)
        kt[Pt - 1] = arguments[Pt];
      (Xe = Te.onContextMenu) === null || Xe === void 0 || Xe.call.apply(Xe, [Te, Re].concat(kt));
    }), ve && (Be.className = we(Te.className, ve));
    var pa = ae(ae({}, Te), Be), hi = {}, Ys = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Ys.forEach(function(Re) {
      le[Re] && (hi[Re] = function() {
        for (var Xe, Rt = arguments.length, kt = new Array(Rt), Pt = 0; Pt < Rt; Pt++)
          kt[Pt] = arguments[Pt];
        (Xe = pa[Re]) === null || Xe === void 0 || Xe.call.apply(Xe, [pa].concat(kt)), le[Re].apply(le, kt);
      });
    });
    var Qs = /* @__PURE__ */ p.cloneElement(fe, ae(ae({}, pa), hi)), Xs = {
      x: si,
      y: zs
    }, Zs = ee ? ae({}, ee !== !0 ? ee : {}) : null;
    return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement(ta, {
      disabled: !je,
      ref: ne,
      onResize: Ks
    }, /* @__PURE__ */ p.createElement(eg, {
      getTriggerDOMNode: ue
    }, Qs)), /* @__PURE__ */ p.createElement(pf.Provider, {
      value: Pe
    }, /* @__PURE__ */ p.createElement(Jh, {
      portal: e,
      ref: pt,
      prefixCls: a,
      popup: O,
      className: we(w, Bs),
      style: j,
      target: q,
      onMouseEnter: xo,
      onMouseLeave: ma,
      onPointerEnter: xo,
      zIndex: P,
      open: je,
      keepDom: zr,
      fresh: L,
      onClick: B,
      mask: C,
      motion: pe,
      maskMotion: X,
      onVisibleChanged: Dr,
      onPrepare: pi,
      forceRender: V,
      autoDestroy: Fe,
      getPopupContainer: N,
      align: yo,
      arrow: Zs,
      arrowPos: Xs,
      ready: Yt,
      offsetX: Br,
      offsetY: qn,
      offsetR: mr,
      offsetB: Hn,
      onAlign: En,
      stretch: z,
      targetWidth: Us / Wn,
      targetHeight: Ws / ci
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const RT = NT(bd);
var Oo = {
  shiftX: 64,
  adjustY: 1
}, No = {
  adjustX: 1,
  shiftY: !0
}, Fr = [0, 0], PT = {
  left: {
    points: ["cr", "cl"],
    overflow: No,
    offset: [-4, 0],
    targetOffset: Fr
  },
  right: {
    points: ["cl", "cr"],
    overflow: No,
    offset: [4, 0],
    targetOffset: Fr
  },
  top: {
    points: ["bc", "tc"],
    overflow: Oo,
    offset: [0, -4],
    targetOffset: Fr
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Oo,
    offset: [0, 4],
    targetOffset: Fr
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Oo,
    offset: [0, -4],
    targetOffset: Fr
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: No,
    offset: [-4, 0],
    targetOffset: Fr
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Oo,
    offset: [0, -4],
    targetOffset: Fr
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: No,
    offset: [4, 0],
    targetOffset: Fr
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Oo,
    offset: [0, 4],
    targetOffset: Fr
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: No,
    offset: [4, 0],
    targetOffset: Fr
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Oo,
    offset: [0, 4],
    targetOffset: Fr
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: No,
    offset: [-4, 0],
    targetOffset: Fr
  }
}, jT = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], $T = function(t, r) {
  var n = t.overlayClassName, o = t.trigger, a = o === void 0 ? ["hover"] : o, s = t.mouseEnterDelay, c = s === void 0 ? 0 : s, l = t.mouseLeaveDelay, d = l === void 0 ? 0.1 : l, u = t.overlayStyle, f = t.prefixCls, h = f === void 0 ? "rc-tooltip" : f, g = t.children, E = t.onVisibleChange, v = t.afterVisibleChange, m = t.transitionName, y = t.animation, I = t.motion, b = t.placement, C = b === void 0 ? "right" : b, S = t.align, T = S === void 0 ? {} : S, N = t.destroyTooltipOnHide, V = N === void 0 ? !1 : N, D = t.defaultVisible, x = t.getTooltipContainer, O = t.overlayInnerStyle;
  t.arrowContent;
  var w = t.overlay, j = t.id, $ = t.showArrow, _ = $ === void 0 ? !0 : $, A = cr(t, jT), R = Wt(null);
  Af(r, function() {
    return R.current;
  });
  var P = ae({}, A);
  "visible" in t && (P.popupVisible = t.visible);
  var z = function() {
    return /* @__PURE__ */ p.createElement(Qh, {
      key: "content",
      prefixCls: h,
      id: j,
      overlayInnerStyle: O
    }, w);
  };
  return /* @__PURE__ */ p.createElement(RT, mt({
    popupClassName: n,
    prefixCls: h,
    popup: z,
    action: a,
    builtinPlacements: PT,
    popupPlacement: C,
    ref: R,
    popupAlign: T,
    getPopupContainer: x,
    onPopupVisibleChange: E,
    afterPopupVisibleChange: v,
    popupTransitionName: m,
    popupAnimation: y,
    popupMotion: I,
    defaultPopupVisible: D,
    autoDestroy: V,
    mouseLeaveDelay: d,
    popupStyle: u,
    mouseEnterDelay: c,
    arrow: _
  }, P), g);
};
const AT = /* @__PURE__ */ Wa($T), tg = /* @__PURE__ */ k.createContext(void 0);
process.env.NODE_ENV !== "production" && (tg.displayName = "zIndexContext");
const rg = tg, Jn = 100, _T = 10, MT = Jn * _T, ng = {
  Modal: Jn,
  Drawer: Jn,
  Popover: Jn,
  Popconfirm: Jn,
  Tooltip: Jn,
  Tour: Jn
}, LT = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function VT(e) {
  return e in ng;
}
function zT(e, t) {
  const [, r] = Lr(), n = k.useContext(rg), o = VT(e);
  if (t !== void 0)
    return [t, t];
  let a = n ?? 0;
  return o ? (a += // Use preset token zIndex by default but not stack when has parent container
  (n ? 0 : r.zIndexPopupBase) + // Container offset
  ng[e], a = Math.min(a, r.zIndexPopupBase + MT)) : a += LT[e], [n === void 0 ? t : a, a];
}
function BT(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: r,
    borderRadiusOuter: n
  } = e, o = t / 2, a = 0, s = o, c = n * 1 / Math.sqrt(2), l = o - n * (1 - 1 / Math.sqrt(2)), d = o - r * (1 / Math.sqrt(2)), u = n * (Math.sqrt(2) - 1) + r * (1 / Math.sqrt(2)), f = 2 * o - d, h = u, g = 2 * o - c, E = l, v = 2 * o - a, m = s, y = o * Math.sqrt(2) + n * (Math.sqrt(2) - 2), I = n * (Math.sqrt(2) - 1), b = `polygon(${I}px 100%, 50% ${I}px, ${2 * o - I}px 100%, ${I}px 100%)`, C = `path('M ${a} ${s} A ${n} ${n} 0 0 0 ${c} ${l} L ${d} ${u} A ${r} ${r} 0 0 1 ${f} ${h} L ${g} ${E} A ${n} ${n} 0 0 0 ${v} ${m} Z')`;
  return {
    arrowShadowWidth: y,
    arrowPath: C,
    arrowPolygon: b
  };
}
const kT = (e, t, r) => {
  const {
    sizePopupArrow: n,
    arrowPolygon: o,
    arrowPath: a,
    arrowShadowWidth: s,
    borderRadiusXS: c,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: n,
    height: n,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: n,
      height: l(n).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, a]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: s,
      height: s,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${Me(c)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: r,
      zIndex: 0,
      background: "transparent"
    }
  };
}, og = 8;
function ag(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: r
  } = e, n = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: n,
    arrowOffsetVertical: r ? og : n
  };
}
function Ai(e, t) {
  return e ? t : {};
}
function UT(e, t, r) {
  const {
    componentCls: n,
    boxShadowPopoverArrow: o,
    arrowOffsetVertical: a,
    arrowOffsetHorizontal: s
  } = e, {
    arrowDistance: c = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = r || {};
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${n}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, kT(e, t, o)), {
        "&:before": {
          background: t
        }
      })]
    }, Ai(!!l.top, {
      [[`&-placement-top > ${n}-arrow`, `&-placement-topLeft > ${n}-arrow`, `&-placement-topRight > ${n}-arrow`].join(",")]: {
        bottom: c,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: s
        }
      },
      [`&-placement-topRight > ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: s
        }
      }
    })), Ai(!!l.bottom, {
      [[`&-placement-bottom > ${n}-arrow`, `&-placement-bottomLeft > ${n}-arrow`, `&-placement-bottomRight > ${n}-arrow`].join(",")]: {
        top: c,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${n}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: s
        }
      },
      [`&-placement-bottomRight > ${n}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: s
        }
      }
    })), Ai(!!l.left, {
      [[`&-placement-left > ${n}-arrow`, `&-placement-leftTop > ${n}-arrow`, `&-placement-leftBottom > ${n}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: c
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${n}-arrow`]: {
        top: a
      },
      [`&-placement-leftBottom > ${n}-arrow`]: {
        bottom: a
      }
    })), Ai(!!l.right, {
      [[`&-placement-right > ${n}-arrow`, `&-placement-rightTop > ${n}-arrow`, `&-placement-rightBottom > ${n}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: c
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${n}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${n}-arrow`]: {
        top: a
      },
      [`&-placement-rightBottom > ${n}-arrow`]: {
        bottom: a
      }
    }))
  };
}
function qT(e, t, r, n) {
  if (n === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const o = n && typeof n == "object" ? n : {}, a = {};
  switch (e) {
    case "top":
    case "bottom":
      a.shiftX = t.arrowOffsetHorizontal * 2 + r, a.shiftY = !0, a.adjustY = !0;
      break;
    case "left":
    case "right":
      a.shiftY = t.arrowOffsetVertical * 2 + r, a.shiftX = !0, a.adjustX = !0;
      break;
  }
  const s = Object.assign(Object.assign({}, a), o);
  return s.shiftX || (s.adjustX = !0), s.shiftY || (s.adjustY = !0), s;
}
const If = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, HT = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, WT = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function GT(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: r,
    arrowPointAtCenter: n,
    offset: o,
    borderRadius: a,
    visibleFirst: s
  } = e, c = t / 2, l = {};
  return Object.keys(If).forEach((d) => {
    const u = n && HT[d] || If[d], f = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[d] = f, WT.has(d) && (f.autoArrow = !1), d) {
      case "top":
      case "topLeft":
      case "topRight":
        f.offset[1] = -c - o;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        f.offset[1] = c + o;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        f.offset[0] = -c - o;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        f.offset[0] = c + o;
        break;
    }
    const h = ag({
      contentRadius: a,
      limitVerticalRadius: !0
    });
    if (n)
      switch (d) {
        case "topLeft":
        case "bottomLeft":
          f.offset[0] = -h.arrowOffsetHorizontal - c;
          break;
        case "topRight":
        case "bottomRight":
          f.offset[0] = h.arrowOffsetHorizontal + c;
          break;
        case "leftTop":
        case "rightTop":
          f.offset[1] = -h.arrowOffsetHorizontal - c;
          break;
        case "leftBottom":
        case "rightBottom":
          f.offset[1] = h.arrowOffsetHorizontal + c;
          break;
      }
    f.overflow = qT(d, h, t, r), s && (f.htmlRegion = "visibleFirst");
  }), l;
}
const KT = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: r,
    tooltipColor: n,
    tooltipBg: o,
    tooltipBorderRadius: a,
    zIndexPopup: s,
    controlHeight: c,
    boxShadowSecondary: l,
    paddingSM: d,
    paddingXS: u
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, ho(e)), {
        position: "absolute",
        zIndex: s,
        display: "block",
        width: "max-content",
        maxWidth: r,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": o,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: c,
          minHeight: c,
          padding: `${Me(e.calc(d).div(2).equal())} ${Me(u)}`,
          color: n,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: o,
          borderRadius: a,
          boxShadow: l,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(a, og)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), yC(e, (f, h) => {
        let {
          darkColor: g
        } = h;
        return {
          [`&${t}-${f}`]: {
            [`${t}-inner`]: {
              backgroundColor: g
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": g
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    UT(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, YT = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, ag({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), BT(fr(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), ig = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Cn("Tooltip", (n) => {
    const {
      borderRadius: o,
      colorTextLightSolid: a,
      colorBgSpotlight: s
    } = n, c = fr(n, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: a,
      tooltipBorderRadius: o,
      tooltipBg: s
    });
    return [KT(c), cE(n, "zoom-big-fast")];
  }, YT, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, QT = ns.map((e) => `${e}-inverse`);
function XT(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(Ne(QT), Ne(ns)).includes(e) : ns.includes(e);
}
function sg(e, t) {
  const r = XT(t), n = we({
    [`${e}-${t}`]: t && r
  }), o = {}, a = {};
  return t && !r && (o.background = t, a["--antd-arrow-background-color"] = t), {
    className: n,
    overlayStyle: o,
    arrowStyle: a
  };
}
const ZT = (e) => {
  const {
    prefixCls: t,
    className: r,
    placement: n = "top",
    title: o,
    color: a,
    overlayInnerStyle: s
  } = e, {
    getPrefixCls: c
  } = p.useContext(Mt), l = c("tooltip", t), [d, u, f] = ig(l), h = sg(l, a), g = h.arrowStyle, E = Object.assign(Object.assign({}, s), h.overlayStyle), v = we(u, f, l, `${l}-pure`, `${l}-placement-${n}`, r, h.className);
  return d(/* @__PURE__ */ p.createElement("div", {
    className: v,
    style: g
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ p.createElement(Qh, Object.assign({}, e, {
    className: u,
    prefixCls: l,
    overlayInnerStyle: E
  }), o)));
}, JT = ZT;
var e1 = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Cd = /* @__PURE__ */ p.forwardRef((e, t) => {
  var r, n;
  const {
    prefixCls: o,
    openClassName: a,
    getTooltipContainer: s,
    overlayClassName: c,
    color: l,
    overlayInnerStyle: d,
    children: u,
    afterOpenChange: f,
    afterVisibleChange: h,
    destroyTooltipOnHide: g,
    arrow: E = !0,
    title: v,
    overlay: m,
    builtinPlacements: y,
    arrowPointAtCenter: I = !1,
    autoAdjustOverflow: b = !0
  } = e, C = !!E, [, S] = Lr(), {
    getPopupContainer: T,
    getPrefixCls: N,
    direction: V
  } = p.useContext(Mt), D = ur("Tooltip"), x = p.useRef(null), O = () => {
    var Le;
    (Le = x.current) === null || Le === void 0 || Le.forceAlign();
  };
  p.useImperativeHandle(t, () => ({
    forceAlign: O,
    forcePopupAlign: () => {
      D.deprecated(!1, "forcePopupAlign", "forceAlign"), O();
    }
  })), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((Le) => {
    let [Ve, _e] = Le;
    D.deprecated(!(Ve in e), Ve, _e);
  }), process.env.NODE_ENV !== "production" && D(!g || typeof g == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && D(!E || typeof E == "boolean" || !("arrowPointAtCenter" in E), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [w, j] = Ka(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (n = e.defaultOpen) !== null && n !== void 0 ? n : e.defaultVisible
  }), $ = !v && !m && v !== 0, _ = (Le) => {
    var Ve, _e;
    j($ ? !1 : Le), $ || ((Ve = e.onOpenChange) === null || Ve === void 0 || Ve.call(e, Le), (_e = e.onVisibleChange) === null || _e === void 0 || _e.call(e, Le));
  }, A = p.useMemo(() => {
    var Le, Ve;
    let _e = I;
    return typeof E == "object" && (_e = (Ve = (Le = E.pointAtCenter) !== null && Le !== void 0 ? Le : E.arrowPointAtCenter) !== null && Ve !== void 0 ? Ve : I), y || GT({
      arrowPointAtCenter: _e,
      autoAdjustOverflow: b,
      arrowWidth: C ? S.sizePopupArrow : 0,
      borderRadius: S.borderRadius,
      offset: S.marginXXS,
      visibleFirst: !0
    });
  }, [I, E, y, S]), R = p.useMemo(() => v === 0 ? v : m || v || "", [m, v]), P = /* @__PURE__ */ p.createElement(GI, null, typeof R == "function" ? R() : R), {
    getPopupContainer: z,
    placement: F = "top",
    mouseEnterDelay: L = 0.1,
    mouseLeaveDelay: M = 0.1,
    overlayStyle: B,
    rootClassName: W
  } = e, ee = e1(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), te = N("tooltip", o), de = N(), Z = e["data-popover-inject"];
  let ce = w;
  !("open" in e) && !("visible" in e) && $ && (ce = !1);
  const Y = Yo(u) && !Nh(u) ? u : /* @__PURE__ */ p.createElement("span", null, u), he = Y.props, ve = !he.className || typeof he.className == "string" ? we(he.className, a || `${te}-open`) : he.className, [ue, le, Fe] = ig(te, !Z), He = sg(te, l), We = He.arrowStyle, ie = Object.assign(Object.assign({}, d), He.overlayStyle), ge = we(c, {
    [`${te}-rtl`]: V === "rtl"
  }, He.className, W, le, Fe), [be, Ie] = zT("Tooltip", ee.zIndex), Pe = /* @__PURE__ */ p.createElement(AT, Object.assign({}, ee, {
    zIndex: be,
    showArrow: C,
    placement: F,
    mouseEnterDelay: L,
    mouseLeaveDelay: M,
    prefixCls: te,
    overlayClassName: ge,
    overlayStyle: Object.assign(Object.assign({}, We), B),
    getTooltipContainer: z || s || T,
    ref: x,
    builtinPlacements: A,
    overlay: P,
    visible: ce,
    onVisibleChange: _,
    afterVisibleChange: f ?? h,
    overlayInnerStyle: ie,
    arrowContent: /* @__PURE__ */ p.createElement("span", {
      className: `${te}-arrow-content`
    }),
    motion: {
      motionName: BD(de, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!g
  }), ce ? fo(Y, {
    className: ve
  }) : Y);
  return ue(/* @__PURE__ */ p.createElement(rg.Provider, {
    value: Ie
  }, Pe));
});
process.env.NODE_ENV !== "production" && (Cd.displayName = "Tooltip");
Cd._InternalPanelDoNotUseOrYouWillBeFired = JT;
const Qo = Cd;
function Nn(e) {
  return !e || e < 0 ? 0 : e > 100 ? 100 : e;
}
function ss(e) {
  let {
    success: t,
    successPercent: r
  } = e, n = r;
  return t && "progress" in t && (n = t.progress), t && "percent" in t && (n = t.percent), n;
}
const t1 = (e) => {
  let {
    percent: t,
    success: r,
    successPercent: n
  } = e;
  const o = Nn(ss({
    success: r,
    successPercent: n
  }));
  return [o, Nn(Nn(t) - o)];
}, r1 = (e) => {
  let {
    success: t = {},
    strokeColor: r
  } = e;
  const {
    strokeColor: n
  } = t;
  return [n || Mo.green, r || null];
}, As = (e, t, r) => {
  var n, o, a, s;
  let c = -1, l = -1;
  if (t === "step") {
    const d = r.steps, u = r.strokeWidth;
    typeof e == "string" || typeof e > "u" ? (c = e === "small" ? 2 : 14, l = u ?? 8) : typeof e == "number" ? [c, l] = [e, e] : [c = 14, l = 8] = e, c *= d;
  } else if (t === "line") {
    const d = r?.strokeWidth;
    typeof e == "string" || typeof e > "u" ? l = d || (e === "small" ? 6 : 8) : typeof e == "number" ? [c, l] = [e, e] : [c = -1, l = 8] = e;
  } else
    (t === "circle" || t === "dashboard") && (typeof e == "string" || typeof e > "u" ? [c, l] = e === "small" ? [60, 60] : [120, 120] : typeof e == "number" ? [c, l] = [e, e] : (c = (o = (n = e[0]) !== null && n !== void 0 ? n : e[1]) !== null && o !== void 0 ? o : 120, l = (s = (a = e[0]) !== null && a !== void 0 ? a : e[1]) !== null && s !== void 0 ? s : 120));
  return [c, l];
}, n1 = 3, o1 = (e) => n1 / e * 100, a1 = (e) => {
  const {
    prefixCls: t,
    trailColor: r = null,
    strokeLinecap: n = "round",
    gapPosition: o,
    gapDegree: a,
    width: s = 120,
    type: c,
    children: l,
    success: d,
    size: u = s
  } = e, [f, h] = As(u, "circle");
  let {
    strokeWidth: g
  } = e;
  g === void 0 && (g = Math.max(o1(f), 6));
  const E = {
    width: f,
    height: h,
    fontSize: f * 0.15 + 6
  }, v = p.useMemo(() => {
    if (a || a === 0)
      return a;
    if (c === "dashboard")
      return 75;
  }, [a, c]), m = o || c === "dashboard" && "bottom" || void 0, y = Object.prototype.toString.call(e.strokeColor) === "[object Object]", I = r1({
    success: d,
    strokeColor: e.strokeColor
  }), b = we(`${t}-inner`, {
    [`${t}-circle-gradient`]: y
  }), C = /* @__PURE__ */ p.createElement(Yh, {
    percent: t1(e),
    strokeWidth: g,
    trailWidth: g,
    strokeColor: I,
    strokeLinecap: n,
    trailColor: r,
    prefixCls: t,
    gapDegree: v,
    gapPosition: m
  });
  return /* @__PURE__ */ p.createElement("div", {
    className: b,
    style: E
  }, f <= 20 ? /* @__PURE__ */ p.createElement(Qo, {
    title: l
  }, /* @__PURE__ */ p.createElement("span", null, C)) : /* @__PURE__ */ p.createElement(p.Fragment, null, C, l));
}, i1 = a1, cs = "--progress-line-stroke-color", cg = "--progress-percent", xf = (e) => {
  const t = e ? "100%" : "-100%";
  return new er(`antProgress${e ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, s1 = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, ho(e)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: e.fontSize,
        marginInlineEnd: e.marginXS,
        marginBottom: e.marginXS
      },
      [`${t}-outer`]: {
        display: "inline-block",
        width: "100%"
      },
      [`&${t}-show-info`]: {
        [`${t}-outer`]: {
          marginInlineEnd: `calc(-2em - ${Me(e.marginXS)})`,
          paddingInlineEnd: `calc(2em + ${Me(e.paddingXS)})`
        }
      },
      [`${t}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: e.remainingColor,
        borderRadius: e.lineBorderRadius
      },
      [`${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.defaultColor
        }
      },
      [`${t}-success-bg, ${t}-bg`]: {
        position: "relative",
        background: e.defaultColor,
        borderRadius: e.lineBorderRadius,
        transition: `all ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`
      },
      [`${t}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: !0,
            value: ["inherit", `var(${cs})`]
          },
          height: "100%",
          width: `calc(1 / var(${cg}) * 100%)`,
          display: "block"
        }
      },
      [`${t}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: e.colorSuccess
      },
      [`${t}-text`]: {
        display: "inline-block",
        width: "2em",
        marginInlineStart: e.marginXS,
        color: e.colorText,
        lineHeight: 1,
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [r]: {
          fontSize: e.fontSize
        }
      },
      [`&${t}-status-active`]: {
        [`${t}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: e.colorBgContainer,
          borderRadius: e.lineBorderRadius,
          opacity: 0,
          animationName: xf(),
          animationDuration: e.progressActiveMotionDuration,
          animationTimingFunction: e.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${t}-rtl${t}-status-active`]: {
        [`${t}-bg::before`]: {
          animationName: xf(!0)
        }
      },
      [`&${t}-status-exception`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorError
        },
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`&${t}-status-exception ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorError
        }
      },
      [`&${t}-status-success`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorSuccess
        },
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      },
      [`&${t}-status-success ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorSuccess
        }
      }
    })
  };
}, c1 = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: {
      [`${t}-circle-trail`]: {
        stroke: e.remainingColor
      },
      [`&${t}-circle ${t}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${t}-circle ${t}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: e.circleTextColor,
        fontSize: e.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [r]: {
          fontSize: e.circleIconFontSize
        }
      },
      [`${t}-circle&-status-exception`]: {
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`${t}-circle&-status-success`]: {
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      }
    },
    [`${t}-inline-circle`]: {
      lineHeight: 1,
      [`${t}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, l1 = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`${t}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: e.progressStepMinWidth,
          marginInlineEnd: e.progressStepMarginInlineEnd,
          backgroundColor: e.remainingColor,
          transition: `all ${e.motionDurationSlow}`,
          "&-active": {
            backgroundColor: e.defaultColor
          }
        }
      }
    }
  };
}, d1 = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: {
      [`${t}-small&-line, ${t}-small&-line ${t}-text ${r}`]: {
        fontSize: e.fontSizeSM
      }
    }
  };
}, u1 = (e) => ({
  circleTextColor: e.colorText,
  defaultColor: e.colorInfo,
  remainingColor: e.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${e.fontSize / e.fontSizeSM}em`
}), f1 = Cn("Progress", (e) => {
  const t = e.calc(e.marginXXS).div(2).equal(), r = fr(e, {
    progressStepMarginInlineEnd: t,
    progressStepMinWidth: t,
    progressActiveMotionDuration: "2.4s"
  });
  return [s1(r), c1(r), l1(r), d1(r)];
}, u1);
var m1 = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const p1 = (e) => {
  let t = [];
  return Object.keys(e).forEach((r) => {
    const n = parseFloat(r.replace(/%/g, ""));
    isNaN(n) || t.push({
      key: n,
      value: e[r]
    });
  }), t = t.sort((r, n) => r.key - n.key), t.map((r) => {
    let {
      key: n,
      value: o
    } = r;
    return `${o} ${n}%`;
  }).join(", ");
}, h1 = (e, t) => {
  const {
    from: r = Mo.blue,
    to: n = Mo.blue,
    direction: o = t === "rtl" ? "to left" : "to right"
  } = e, a = m1(e, ["from", "to", "direction"]);
  if (Object.keys(a).length !== 0) {
    const c = p1(a), l = `linear-gradient(${o}, ${c})`;
    return {
      background: l,
      [cs]: l
    };
  }
  const s = `linear-gradient(${o}, ${r}, ${n})`;
  return {
    background: s,
    [cs]: s
  };
}, g1 = (e) => {
  const {
    prefixCls: t,
    direction: r,
    percent: n,
    size: o,
    strokeWidth: a,
    strokeColor: s,
    strokeLinecap: c = "round",
    children: l,
    trailColor: d = null,
    success: u
  } = e, f = s && typeof s != "string" ? h1(s, r) : {
    [cs]: s,
    background: s
  }, h = c === "square" || c === "butt" ? 0 : void 0, g = o ?? [-1, a || (o === "small" ? 6 : 8)], [E, v] = As(g, "line", {
    strokeWidth: a
  });
  process.env.NODE_ENV !== "production" && ur("Progress").deprecated(!("strokeWidth" in e), "strokeWidth", "size");
  const m = {
    backgroundColor: d || void 0,
    borderRadius: h
  }, y = Object.assign(Object.assign({
    width: `${Nn(n)}%`,
    height: v,
    borderRadius: h
  }, f), {
    [cg]: Nn(n) / 100
  }), I = ss(e), b = {
    width: `${Nn(I)}%`,
    height: v,
    borderRadius: h,
    backgroundColor: u?.strokeColor
  }, C = {
    width: E < 0 ? "100%" : E,
    height: v
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("div", {
    className: `${t}-outer`,
    style: C
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${t}-inner`,
    style: m
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${t}-bg`,
    style: y
  }), I !== void 0 ? /* @__PURE__ */ p.createElement("div", {
    className: `${t}-success-bg`,
    style: b
  }) : null)), l);
}, v1 = g1, y1 = (e) => {
  const {
    size: t,
    steps: r,
    percent: n = 0,
    strokeWidth: o = 8,
    strokeColor: a,
    trailColor: s = null,
    prefixCls: c,
    children: l
  } = e, d = Math.round(r * (n / 100)), f = t ?? [t === "small" ? 2 : 14, o], [h, g] = As(f, "step", {
    steps: r,
    strokeWidth: o
  }), E = h / r, v = new Array(r);
  for (let m = 0; m < r; m++) {
    const y = Array.isArray(a) ? a[m] : a;
    v[m] = /* @__PURE__ */ p.createElement("div", {
      key: m,
      className: we(`${c}-steps-item`, {
        [`${c}-steps-item-active`]: m <= d - 1
      }),
      style: {
        backgroundColor: m <= d - 1 ? y : s,
        width: E,
        height: g
      }
    });
  }
  return /* @__PURE__ */ p.createElement("div", {
    className: `${c}-steps-outer`
  }, v, l);
}, b1 = y1;
var C1 = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const I1 = ["normal", "exception", "active", "success"], lg = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: n,
    rootClassName: o,
    steps: a,
    strokeColor: s,
    percent: c = 0,
    size: l = "default",
    showInfo: d = !0,
    type: u = "line",
    status: f,
    format: h,
    style: g
  } = e, E = C1(e, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style"]), v = p.useMemo(() => {
    var j, $;
    const _ = ss(e);
    return parseInt(_ !== void 0 ? (j = _ ?? 0) === null || j === void 0 ? void 0 : j.toString() : ($ = c ?? 0) === null || $ === void 0 ? void 0 : $.toString(), 10);
  }, [c, e.success, e.successPercent]), m = p.useMemo(() => !I1.includes(f) && v >= 100 ? "success" : f || "normal", [f, v]), {
    getPrefixCls: y,
    direction: I,
    progress: b
  } = p.useContext(Mt), C = y("progress", r), [S, T, N] = f1(C), V = p.useMemo(() => {
    if (!d)
      return null;
    const j = ss(e);
    let $;
    const _ = h || ((R) => `${R}%`), A = u === "line";
    return h || m !== "exception" && m !== "success" ? $ = _(Nn(c), Nn(j)) : m === "exception" ? $ = A ? /* @__PURE__ */ p.createElement(kl, null) : /* @__PURE__ */ p.createElement(oT, null) : m === "success" && ($ = A ? /* @__PURE__ */ p.createElement(qh, null) : /* @__PURE__ */ p.createElement(Wh, null)), /* @__PURE__ */ p.createElement("span", {
      className: `${C}-text`,
      title: typeof $ == "string" ? $ : void 0
    }, $);
  }, [d, c, v, m, u, C, h]);
  if (process.env.NODE_ENV !== "production") {
    const j = ur("Progress");
    j.deprecated(!("successPercent" in e), "successPercent", "success.percent"), j.deprecated(!("width" in e), "width", "size"), (u === "circle" || u === "dashboard") && Array.isArray(l) && process.env.NODE_ENV !== "production" && j(!1, "usage", 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.'), e.success && "progress" in e.success && j.deprecated(!1, "success.progress", "success.percent");
  }
  const D = Array.isArray(s) ? s[0] : s, x = typeof s == "string" || Array.isArray(s) ? s : void 0;
  let O;
  u === "line" ? O = a ? /* @__PURE__ */ p.createElement(b1, Object.assign({}, e, {
    strokeColor: x,
    prefixCls: C,
    steps: a
  }), V) : /* @__PURE__ */ p.createElement(v1, Object.assign({}, e, {
    strokeColor: D,
    prefixCls: C,
    direction: I
  }), V) : (u === "circle" || u === "dashboard") && (O = /* @__PURE__ */ p.createElement(i1, Object.assign({}, e, {
    strokeColor: D,
    prefixCls: C,
    progressStatus: m
  }), V));
  const w = we(C, `${C}-status-${m}`, `${C}-${u === "dashboard" && "circle" || a && "steps" || u}`, {
    [`${C}-inline-circle`]: u === "circle" && As(l, "circle")[0] <= 20,
    [`${C}-show-info`]: d,
    [`${C}-${l}`]: typeof l == "string",
    [`${C}-rtl`]: I === "rtl"
  }, b?.className, n, o, T, N);
  return S(/* @__PURE__ */ p.createElement("div", Object.assign({
    ref: t,
    style: Object.assign(Object.assign({}, b?.style), g),
    className: w,
    role: "progressbar",
    "aria-valuenow": v
  }, Ya(E, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), O));
});
process.env.NODE_ENV !== "production" && (lg.displayName = "Progress");
const x1 = lg, S1 = /* @__PURE__ */ p.forwardRef((e, t) => {
  let {
    prefixCls: r,
    className: n,
    style: o,
    locale: a,
    listType: s,
    file: c,
    items: l,
    progress: d,
    iconRender: u,
    actionIconRender: f,
    itemRender: h,
    isImgUrl: g,
    showPreviewIcon: E,
    showRemoveIcon: v,
    showDownloadIcon: m,
    previewIcon: y,
    removeIcon: I,
    downloadIcon: b,
    onPreview: C,
    onDownload: S,
    onClose: T
  } = e;
  var N, V;
  const {
    status: D
  } = c, [x, O] = p.useState(D);
  p.useEffect(() => {
    D !== "removed" && O(D);
  }, [D]);
  const [w, j] = p.useState(!1);
  p.useEffect(() => {
    const Y = setTimeout(() => {
      j(!0);
    }, 300);
    return () => {
      clearTimeout(Y);
    };
  }, []);
  const $ = u(c);
  let _ = /* @__PURE__ */ p.createElement("div", {
    className: `${r}-icon`
  }, $);
  if (s === "picture" || s === "picture-card" || s === "picture-circle")
    if (x === "uploading" || !c.thumbUrl && !c.url) {
      const Y = we(`${r}-list-item-thumbnail`, {
        [`${r}-list-item-file`]: x !== "uploading"
      });
      _ = /* @__PURE__ */ p.createElement("div", {
        className: Y
      }, $);
    } else {
      const Y = g?.(c) ? /* @__PURE__ */ p.createElement("img", {
        src: c.thumbUrl || c.url,
        alt: c.name,
        className: `${r}-list-item-image`,
        crossOrigin: c.crossOrigin
      }) : $, he = we(`${r}-list-item-thumbnail`, {
        [`${r}-list-item-file`]: g && !g(c)
      });
      _ = /* @__PURE__ */ p.createElement("a", {
        className: he,
        onClick: (ve) => C(c, ve),
        href: c.url || c.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, Y);
    }
  const A = we(`${r}-list-item`, `${r}-list-item-${x}`), R = typeof c.linkProps == "string" ? JSON.parse(c.linkProps) : c.linkProps, P = v ? f(
    (typeof I == "function" ? I(c) : I) || /* @__PURE__ */ p.createElement(Hw, null),
    () => T(c),
    r,
    a.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    !0
  ) : null, z = m && x === "done" ? f((typeof b == "function" ? b(c) : b) || /* @__PURE__ */ p.createElement(Kw, null), () => S(c), r, a.downloadFile) : null, F = s !== "picture-card" && s !== "picture-circle" && /* @__PURE__ */ p.createElement("span", {
    key: "download-delete",
    className: we(`${r}-list-item-actions`, {
      picture: s === "picture"
    })
  }, z, P), L = we(`${r}-list-item-name`), M = c.url ? [/* @__PURE__ */ p.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: L,
    title: c.name
  }, R, {
    href: c.url,
    onClick: (Y) => C(c, Y)
  }), c.name), F] : [/* @__PURE__ */ p.createElement("span", {
    key: "view",
    className: L,
    onClick: (Y) => C(c, Y),
    title: c.name
  }, c.name), F], B = E && (c.url || c.thumbUrl) ? /* @__PURE__ */ p.createElement("a", {
    href: c.url || c.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (Y) => C(c, Y),
    title: a.previewFile
  }, typeof y == "function" ? y(c) : y || /* @__PURE__ */ p.createElement(Xw, null)) : null, W = (s === "picture-card" || s === "picture-circle") && x !== "uploading" && /* @__PURE__ */ p.createElement("span", {
    className: `${r}-list-item-actions`
  }, B, x === "done" && z, P), {
    getPrefixCls: ee
  } = p.useContext(Mt), te = ee(), de = /* @__PURE__ */ p.createElement("div", {
    className: A
  }, _, M, W, w && /* @__PURE__ */ p.createElement(Bn, {
    motionName: `${te}-fade`,
    visible: x === "uploading",
    motionDeadline: 2e3
  }, (Y) => {
    let {
      className: he
    } = Y;
    const ve = "percent" in c ? /* @__PURE__ */ p.createElement(x1, Object.assign({}, d, {
      type: "line",
      percent: c.percent,
      "aria-label": c["aria-label"],
      "aria-labelledby": c["aria-labelledby"]
    })) : null;
    return /* @__PURE__ */ p.createElement("div", {
      className: we(`${r}-list-item-progress`, he)
    }, ve);
  })), Z = c.response && typeof c.response == "string" ? c.response : ((N = c.error) === null || N === void 0 ? void 0 : N.statusText) || ((V = c.error) === null || V === void 0 ? void 0 : V.message) || a.uploadError, ce = x === "error" ? /* @__PURE__ */ p.createElement(Qo, {
    title: Z,
    getPopupContainer: (Y) => Y.parentNode
  }, de) : de;
  return /* @__PURE__ */ p.createElement("div", {
    className: we(`${r}-list-item-container`, n),
    style: o,
    ref: t
  }, h ? h(ce, c, l, {
    download: S.bind(null, c),
    preview: C.bind(null, c),
    remove: T.bind(null, c)
  }) : ce);
}), E1 = S1, D1 = (e, t) => {
  const {
    listType: r = "text",
    previewFile: n = kw,
    onPreview: o,
    onDownload: a,
    onRemove: s,
    locale: c,
    iconRender: l,
    isImageUrl: d = Bw,
    prefixCls: u,
    items: f = [],
    showPreviewIcon: h = !0,
    showRemoveIcon: g = !0,
    showDownloadIcon: E = !1,
    removeIcon: v,
    previewIcon: m,
    downloadIcon: y,
    progress: I = {
      size: [-1, 2],
      showInfo: !1
    },
    appendAction: b,
    appendActionVisible: C = !0,
    itemRender: S,
    disabled: T
  } = e, N = LD(), [V, D] = p.useState(!1);
  p.useEffect(() => {
    r !== "picture" && r !== "picture-card" && r !== "picture-circle" || (f || []).forEach((B) => {
      typeof document > "u" || typeof window > "u" || !window.FileReader || !window.File || !(B.originFileObj instanceof File || B.originFileObj instanceof Blob) || B.thumbUrl !== void 0 || (B.thumbUrl = "", n && n(B.originFileObj).then((W) => {
        B.thumbUrl = W || "", N();
      }));
    });
  }, [r, f, n]), p.useEffect(() => {
    D(!0);
  }, []);
  const x = (B, W) => {
    if (o)
      return W?.preventDefault(), o(B);
  }, O = (B) => {
    typeof a == "function" ? a(B) : B.url && window.open(B.url);
  }, w = (B) => {
    s?.(B);
  }, j = (B) => {
    if (l)
      return l(B, r);
    const W = B.status === "uploading", ee = d && d(B) ? /* @__PURE__ */ p.createElement(MD, null) : /* @__PURE__ */ p.createElement(OD, null);
    let te = W ? /* @__PURE__ */ p.createElement(os, null) : /* @__PURE__ */ p.createElement($D, null);
    return r === "picture" ? te = W ? /* @__PURE__ */ p.createElement(os, null) : ee : (r === "picture-card" || r === "picture-circle") && (te = W ? c.uploading : ee), te;
  }, $ = (B, W, ee, te, de) => {
    const Z = {
      type: "text",
      size: "small",
      title: te,
      onClick: (ce) => {
        W(), Yo(B) && B.props.onClick && B.props.onClick(ce);
      },
      className: `${ee}-list-item-action`
    };
    if (de && (Z.disabled = T), Yo(B)) {
      const ce = fo(B, Object.assign(Object.assign({}, B.props), {
        onClick: () => {
        }
      }));
      return /* @__PURE__ */ p.createElement(tf, Object.assign({}, Z, {
        icon: ce
      }));
    }
    return /* @__PURE__ */ p.createElement(tf, Object.assign({}, Z), /* @__PURE__ */ p.createElement("span", null, B));
  };
  p.useImperativeHandle(t, () => ({
    handlePreview: x,
    handleDownload: O
  }));
  const {
    getPrefixCls: _
  } = p.useContext(Mt), A = _("upload", u), R = _(), P = we(`${A}-list`, `${A}-list-${r}`), z = Ne(f.map((B) => ({
    key: B.uid,
    file: B
  })));
  let L = {
    motionDeadline: 2e3,
    motionName: `${A}-${r === "picture-card" || r === "picture-circle" ? "animate-inline" : "animate"}`,
    keys: z,
    motionAppear: V
  };
  const M = p.useMemo(() => {
    const B = Object.assign({}, Nl(R));
    return delete B.onAppearEnd, delete B.onEnterEnd, delete B.onLeaveEnd, B;
  }, [R]);
  return r !== "picture-card" && r !== "picture-circle" && (L = Object.assign(Object.assign({}, M), L)), /* @__PURE__ */ p.createElement("div", {
    className: P
  }, /* @__PURE__ */ p.createElement(Ep, Object.assign({}, L, {
    component: !1
  }), (B) => {
    let {
      key: W,
      file: ee,
      className: te,
      style: de
    } = B;
    return /* @__PURE__ */ p.createElement(E1, {
      key: W,
      locale: c,
      prefixCls: A,
      className: te,
      style: de,
      file: ee,
      items: f,
      progress: I,
      listType: r,
      isImgUrl: d,
      showPreviewIcon: h,
      showRemoveIcon: g,
      showDownloadIcon: E,
      removeIcon: v,
      previewIcon: m,
      downloadIcon: y,
      iconRender: j,
      actionIconRender: $,
      itemRender: S,
      onPreview: x,
      onDownload: O,
      onClose: w
    });
  }), b && /* @__PURE__ */ p.createElement(Bn, Object.assign({}, L, {
    visible: C,
    forceRender: !0
  }), (B) => {
    let {
      className: W,
      style: ee
    } = B;
    return fo(b, (te) => ({
      className: we(te.className, W),
      style: Object.assign(Object.assign(Object.assign({}, ee), {
        // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
        pointerEvents: W ? "none" : void 0
      }), te.style)
    }));
  }));
}, dg = /* @__PURE__ */ p.forwardRef(D1);
process.env.NODE_ENV !== "production" && (dg.displayName = "UploadList");
const w1 = dg;
var T1 = function(e, t, r, n) {
  function o(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function c(u) {
      try {
        d(n.next(u));
      } catch (f) {
        s(f);
      }
    }
    function l(u) {
      try {
        d(n.throw(u));
      } catch (f) {
        s(f);
      }
    }
    function d(u) {
      u.done ? a(u.value) : o(u.value).then(c, l);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const Ea = `__LIST_IGNORE_${Date.now()}__`, F1 = (e, t) => {
  const {
    fileList: r,
    defaultFileList: n,
    onRemove: o,
    showUploadList: a = !0,
    listType: s = "text",
    onPreview: c,
    onDownload: l,
    onChange: d,
    onDrop: u,
    previewFile: f,
    disabled: h,
    locale: g,
    iconRender: E,
    isImageUrl: v,
    progress: m,
    prefixCls: y,
    className: I,
    type: b = "select",
    children: C,
    style: S,
    itemRender: T,
    maxCount: N,
    data: V = {},
    multiple: D = !1,
    hasControlInside: x = !0,
    action: O = "",
    accept: w = "",
    supportServerRender: j = !0,
    rootClassName: $
  } = e, _ = p.useContext(Qa), A = h ?? _, [R, P] = Ka(n || [], {
    value: r,
    postState: (H) => H ?? []
  }), [z, F] = p.useState("drop"), L = p.useRef(null);
  if (process.env.NODE_ENV !== "production") {
    const H = ur("Upload");
    process.env.NODE_ENV !== "production" && H("fileList" in e || !("value" in e), "usage", "`value` is not a valid prop, do you mean `fileList`?"), H.deprecated(!("transformFile" in e), "transformFile", "beforeUpload");
  }
  p.useMemo(() => {
    const H = Date.now();
    (r || []).forEach((G, ne) => {
      !G.uid && !Object.isFrozen(G) && (G.uid = `__AUTO__${H}_${ne}__`);
    });
  }, [r]);
  const M = (H, G, ne) => {
    let fe = Ne(G), Te = !1;
    N === 1 ? fe = fe.slice(-1) : N && (Te = fe.length > N, fe = fe.slice(0, N)), Sd(() => {
      P(fe);
    });
    const Be = {
      file: H,
      fileList: fe
    };
    ne && (Be.event = ne), (!Te || // We should ignore event if current file is exceed `maxCount`
    fe.some(($e) => $e.uid === H.uid)) && Sd(() => {
      d?.(Be);
    });
  }, B = (H, G) => T1(void 0, void 0, void 0, function* () {
    const {
      beforeUpload: ne,
      transformFile: fe
    } = e;
    let Te = H;
    if (ne) {
      const Be = yield ne(H, G);
      if (Be === !1)
        return !1;
      if (delete H[Ea], Be === Ea)
        return Object.defineProperty(H, Ea, {
          value: !0,
          configurable: !0
        }), !1;
      typeof Be == "object" && Be && (Te = Be);
    }
    return fe && (Te = yield fe(Te)), Te;
  }), W = (H) => {
    const G = H.filter((Te) => !Te.file[Ea]);
    if (!G.length)
      return;
    const ne = G.map((Te) => ji(Te.file));
    let fe = Ne(R);
    ne.forEach((Te) => {
      fe = $i(Te, fe);
    }), ne.forEach((Te, Be) => {
      let $e = Te;
      if (G[Be].parsedFile)
        Te.status = "uploading";
      else {
        const {
          originFileObj: pe
        } = Te;
        let X;
        try {
          X = new File([pe], pe.name, {
            type: pe.type
          });
        } catch {
          X = new Blob([pe], {
            type: pe.type
          }), X.name = pe.name, X.lastModifiedDate = /* @__PURE__ */ new Date(), X.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        X.uid = Te.uid, $e = X;
      }
      M($e, fe);
    });
  }, ee = (H, G, ne) => {
    try {
      typeof H == "string" && (H = JSON.parse(H));
    } catch {
    }
    if (!Nc(G, R))
      return;
    const fe = ji(G);
    fe.status = "done", fe.percent = 100, fe.response = H, fe.xhr = ne;
    const Te = $i(fe, R);
    M(fe, Te);
  }, te = (H, G) => {
    if (!Nc(G, R))
      return;
    const ne = ji(G);
    ne.status = "uploading", ne.percent = H.percent;
    const fe = $i(ne, R);
    M(ne, fe, H);
  }, de = (H, G, ne) => {
    if (!Nc(ne, R))
      return;
    const fe = ji(ne);
    fe.error = H, fe.response = G, fe.status = "error";
    const Te = $i(fe, R);
    M(fe, Te);
  }, Z = (H) => {
    let G;
    Promise.resolve(typeof o == "function" ? o(H) : o).then((ne) => {
      var fe;
      if (ne === !1)
        return;
      const Te = Vw(H, R);
      Te && (G = Object.assign(Object.assign({}, H), {
        status: "removed"
      }), R?.forEach((Be) => {
        const $e = G.uid !== void 0 ? "uid" : "name";
        Be[$e] === G[$e] && !Object.isFrozen(Be) && (Be.status = "removed");
      }), (fe = L.current) === null || fe === void 0 || fe.abort(G), M(G, Te));
    });
  }, ce = (H) => {
    F(H.type), H.type === "drop" && u?.(H);
  };
  p.useImperativeHandle(t, () => ({
    onBatchStart: W,
    onSuccess: ee,
    onProgress: te,
    onError: de,
    fileList: R,
    upload: L.current
  }));
  const {
    getPrefixCls: Y,
    direction: he,
    upload: ve
  } = p.useContext(Mt), ue = Y("upload", y), le = Object.assign(Object.assign({
    onBatchStart: W,
    onError: de,
    onProgress: te,
    onSuccess: ee
  }, e), {
    data: V,
    multiple: D,
    action: O,
    accept: w,
    supportServerRender: j,
    prefixCls: ue,
    disabled: A,
    beforeUpload: B,
    onChange: void 0,
    hasControlInside: x
  });
  delete le.className, delete le.style, (!C || A) && delete le.id;
  const Fe = `${ue}-wrapper`, [He, We, ie] = wD(ue, Fe), [ge] = ed("Upload", $n.Upload), {
    showRemoveIcon: be,
    showPreviewIcon: Ie,
    showDownloadIcon: Pe,
    removeIcon: Le,
    previewIcon: Ve,
    downloadIcon: _e
  } = typeof a == "boolean" ? {} : a, ut = typeof be > "u" ? !A : !!be, Nt = (H, G) => a ? /* @__PURE__ */ p.createElement(w1, {
    prefixCls: ue,
    listType: s,
    items: R,
    previewFile: f,
    onPreview: c,
    onDownload: l,
    onRemove: Z,
    showRemoveIcon: ut,
    showPreviewIcon: Ie,
    showDownloadIcon: Pe,
    removeIcon: Le,
    previewIcon: Ve,
    downloadIcon: _e,
    iconRender: E,
    locale: Object.assign(Object.assign({}, ge), g),
    isImageUrl: v,
    progress: m,
    appendAction: H,
    appendActionVisible: G,
    itemRender: T,
    disabled: A
  }) : H, pt = we(Fe, I, $, We, ie, ve?.className, {
    [`${ue}-rtl`]: he === "rtl",
    [`${ue}-picture-card-wrapper`]: s === "picture-card",
    [`${ue}-picture-circle-wrapper`]: s === "picture-circle"
  }), Ge = Object.assign(Object.assign({}, ve?.style), S);
  if (b === "drag") {
    const H = we(We, ue, `${ue}-drag`, {
      [`${ue}-drag-uploading`]: R.some((G) => G.status === "uploading"),
      [`${ue}-drag-hover`]: z === "dragover",
      [`${ue}-disabled`]: A,
      [`${ue}-rtl`]: he === "rtl"
    });
    return He(/* @__PURE__ */ p.createElement("span", {
      className: pt
    }, /* @__PURE__ */ p.createElement("div", {
      className: H,
      style: Ge,
      onDrop: ce,
      onDragOver: ce,
      onDragLeave: ce
    }, /* @__PURE__ */ p.createElement(Ol, Object.assign({}, le, {
      ref: L,
      className: `${ue}-btn`
    }), /* @__PURE__ */ p.createElement("div", {
      className: `${ue}-drag-container`
    }, C))), Nt()));
  }
  const dt = we(ue, `${ue}-select`, {
    [`${ue}-disabled`]: A
  }), q = /* @__PURE__ */ p.createElement("div", {
    className: dt,
    style: C ? void 0 : {
      display: "none"
    }
  }, /* @__PURE__ */ p.createElement(Ol, Object.assign({}, le, {
    ref: L
  })));
  return He(s === "picture-card" || s === "picture-circle" ? /* @__PURE__ */ p.createElement("span", {
    className: pt
  }, Nt(q, !!C)) : /* @__PURE__ */ p.createElement("span", {
    className: pt
  }, q, Nt()));
}, ug = /* @__PURE__ */ p.forwardRef(F1);
process.env.NODE_ENV !== "production" && (ug.displayName = "Upload");
const fg = ug;
var O1 = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const mg = /* @__PURE__ */ p.forwardRef((e, t) => {
  var {
    style: r,
    height: n,
    hasControlInside: o = !1
  } = e, a = O1(e, ["style", "height", "hasControlInside"]);
  return /* @__PURE__ */ p.createElement(fg, Object.assign({
    ref: t,
    hasControlInside: o
  }, a, {
    type: "drag",
    style: Object.assign(Object.assign({}, r), {
      height: n
    })
  }));
});
process.env.NODE_ENV !== "production" && (mg.displayName = "Dragger");
const N1 = mg, Id = fg;
Id.Dragger = N1;
Id.LIST_IGNORE = Ea;
const R1 = Id, pg = ({ Area: e, DocumentId: t, DocumentoTipoId: r }) => Ye({
  networkMode: "online",
  enabled: !!t,
  queryKey: ["Files", t, r, e],
  queryFn: () => md.getFilesByDocumentId({
    area: e,
    documentoId: t,
    tipoDocumentoId: r
  })
}), P1 = (e) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["Files", e],
  queryFn: () => md.getById(e || 0)
});
Ee.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
Ee.th`
	text-align: left;
	width: ${(e) => e.width ? e.width : "200px"};
	padding: 15px 0 15px 0;
	text-align: ${(e) => e.align ? e.align : "left"};
`;
Ee.td`
	text-align: ${(e) => e.align ? e.align : "left"};
`;
const hg = Ee.div`
	background-color: #fafafa;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	padding: 5px;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
Ee.div`
	display: flex;
	flex-direction: row;
	width: 85%;
	margin: 0 auto;
`;
Ee.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
`;
Ee.div`
	margin-right: 10px;
`;
Ee.span`
	width: 124.61px;
`;
Ee.div`
	width: calc(100% - 134.61px);
`;
Ee(to)`
	background: #b3def6;
	width: 8%;
	display: flex;
	flex-direction: row;
	justify-content: center;
`;
const Jr = ({ Area: e, TableData: t, DocumentoId: r, TipoDocumentoId: n, LlevaInfoEntrega: o }) => {
  const [a, s] = k.useState(""), c = (j) => {
    s(j.target.value);
  }, d = {
    size: "small",
    bordered: !0,
    layout: sr(`${st.maxDevice.mobileM}`) ? "vertical" : "horizontal",
    column: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2 }
  }, u = lS({
    Table: t,
    DocumentoId: r,
    Accion: "Get_Info_Adicional"
  }), f = ah(r, n || 0, e || "Ventas"), h = oh(r, n, e || "Ventas"), [g, E] = k.useState(!1), [v, m] = k.useState([]), [y, I] = k.useState([]), { data: b } = pg({
    DocumentId: r,
    Area: e || "Ventas",
    DocumentoTipoId: n || 0
  }), [C, S] = k.useState({ open: !1, selectedFile: {} }), T = (j) => {
    const $ = j.Data, _ = j.ContentType, A = j.FileName, R = atob($), P = [];
    for (let M = 0; M < R.length; M++)
      P.push(R.charCodeAt(M));
    const z = new Uint8Array(P), F = new Blob([z], { type: _ }), L = document.createElement("a");
    L.href = URL.createObjectURL(F), L.download = A, L.click();
  }, N = (j) => new Promise(($, _) => {
    const A = new FileReader();
    A.onload = function() {
      $(A.result);
    }, A.onerror = function(R) {
      _(R);
    }, A.readAsDataURL(j.originFileObj);
  }), V = async () => {
    const j = v?.map((R) => R), $ = v?.map((R) => N(R)), _ = await Promise.all($), A = {
      DocumentoId: r || 0,
      TipoDocumentoId: n || 0,
      FilesData: v?.map((R, P) => ({
        IsTemp: !1,
        Data: _[P],
        ArchivoNombre: R.name,
        ContentType: R.type || "",
        FileSize: R.originFileObj?.size || 0
      }))
    };
    await se.promise(h.mutateAsync(A), {
      loading: "Guardando archivos",
      error: "Error guardando archivos",
      success: () => (I((R) => [...R, ...j]), "Archivos guardados correctamente")
    });
  }, D = async (j, $) => {
    await se.promise(f.mutateAsync(j), {
      loading: "Borrando el documento",
      error: "Error borrando documento",
      success: () => (I((_) => _?.filter((R) => R.fileName !== $)), "Documento eliminado correctamente")
    });
  }, x = [
    {
      width: "20%",
      title: "Nombre",
      key: "FileName",
      dataIndex: "FileName"
    },
    {
      width: "10%",
      title: "Extensión",
      key: "ContentType",
      dataIndex: "ContentType"
    },
    {
      fixed: "right",
      key: "Acciones",
      title: "Acciones",
      render: (j, $) => i.jsxs(Ke, { children: [i.jsx(wt, { style: { border: "none" }, onClick: () => {
        Or.info("Se va a descargar el archivo"), T($);
      }, children: i.jsx(me, { name: "download" }) }), i.jsx(wt, { style: { border: "none" }, onClick: () => S({ open: !0, selectedFile: $ }), children: i.jsx(me, { name: "trash", color: "#E85A49" }) })] })
    }
  ], O = k.useMemo(() => Array.isArray(b) ? b.reduce((j, $) => [$.FileName, $.ContentType].some((A) => dd(A, a)) ? [...j, $] : j, []) : [], [a, b]), w = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay archivos." }) }), []);
  return i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsxs(Qt, { loading: u.isPending, bodyStyle: { gap: 16, display: "flex", flexDirection: "column" }, children: [o && i.jsxs(pr, { title: "Información de entrega", ...d, children: [ot("Fecha de entrega", bt(u?.data?.Result?.InformacionEntrega.FechaEntrega).format("YYYY-MM-DD")), ot("Dirección de entrega", u?.data?.Result?.InformacionEntrega?.DireccionEnvio)] }), i.jsxs(pr, { title: "Notas y observaciones", ...d, children: [ot("Observaciones", u?.data?.Result?.InformacionEntrega?.Observaciones !== "" ? u?.data?.Result?.InformacionEntrega?.Observaciones : "N/A"), ot("Notas", u?.data?.Result?.InformacionEntrega?.Notas !== "" ? u?.data?.Result?.InformacionEntrega?.Notas : "N/A")] })] }), i.jsx(Ln, { title: "Archivos", dataSource: O, columns: x, skeletonLoadingRowCount: 5, placeholderSearch: "Búsqueda...", skeletonLoading: u.isPending, onChangeSearch: Mn({ delay: 500 }, c), onSearch: (j) => {
    a !== j && s(j);
  }, renderHeadActions: [
    i.jsx(wt, { size: "large", type: "primary", onClick: () => E(!0), children: "Agregar archivos" }, "Buttton add file")
  ], tableProps: {
    loading: u.isFetching,
    scroll: { x: x.length * 100 },
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: w(),
      filterEmptyText: "Sin filtros"
    }
  } }), i.jsx(Rn, { width: "45%", cancelText: "Cancelar", style: { padding: 0 }, okText: "Subir archivos", open: g, okButtonProps: { color: "#29AAE0" }, title: i.jsx("strong", { children: "Agregar archivos" }), onCancel: () => {
    E(!1), I([]);
  }, onOk: () => {
    E(!1), V(), I([]), m([]);
  }, children: i.jsxs("div", { style: {
    padding: "20px 10px",
    borderTop: "0.01px solid #D9D9D9",
    borderBottom: "0.01px solid #D9D9D9"
  }, children: [i.jsx(R1, { multiple: !0, listType: "text", fileList: y, showUploadList: !1, onChange: (j) => m(j.fileList), children: i.jsxs(wt, { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px"
  }, children: [i.jsx(me, { name: "", color: "black" }), i.jsx("span", { style: { marginLeft: "8px" }, children: i.jsx("strong", { children: "Clic aquí para agregar archivos" }) })] }) }), v.length > 0 ? v?.map((j, $) => i.jsxs(hg, { children: [i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(me, { size: 40, name: "" }), i.jsx("span", { style: { color: "#29AAE0", fontWeight: "bold" }, children: j.name })] }), i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(rr, { color: "#108ee9", style: { marginRight: "5px" }, children: "Sin subir" }), i.jsx(me, { name: "", onClick: () => m((_) => _?.filter((R) => R.fileName !== j.fileName)) })] })] }, $)) : null] }) }), i.jsx(Rn, { okText: "Confirmar", cancelText: "Cancelar", open: C.open, onCancel: () => S({
    open: !1,
    selectedFile: {}
  }), onOk: () => {
    D(C.selectedFile.FileId, C.selectedFile.FileName), S({
      open: !1,
      selectedFile: {}
    });
  }, title: i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(me, { name: "" }), i.jsx("strong", { style: { marginLeft: "3px" }, children: "Eliminar archivo" })] }), children: i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  }, children: i.jsxs("div", { style: {
    width: "100%",
    display: "flex",
    textAlign: "center",
    flexDirection: "column"
  }, children: [i.jsxs("div", { style: {
    padding: "5px",
    display: "flex",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "5px",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px",
    background: "#E0DEDE",
    justifyContent: "center",
    border: "1px solid #C4C3C3",
    boxShadow: "0.5px 0.5px 1px rgba(0, 0, 0, 0.15)"
  }, children: [i.jsx(me, { size: 35, name: "" }), i.jsx("span", { children: C.selectedFile.FileName })] }), i.jsx("div", { style: {
    display: "flex",
    margin: "0 auto",
    width: "367.84px",
    textAlign: "center",
    flexDirection: "column",
    borderBottom: "0.5px solid #E0DEDE"
  }, children: i.jsx("span", { style: { fontSize: 15 }, children: i.jsx("strong", { children: "¿Seguro que desea eliminar este archivo?" }) }) })] }) }) })] });
}, gg = ({ TableData: e, DocumentoId: t }) => {
  const n = {
    size: "small",
    bordered: !0,
    layout: sr(`${st.maxDevice.mobileM}`) ? "vertical" : "horizontal",
    column: { xs: 1, sm: 1, md: 2, lg: 2, xl: 4, xxl: 4 }
  }, o = fS({
    Table: e,
    DocumentoId: t,
    Accion: "Get_Info_Recurrencia"
  });
  return i.jsx(Qt, { loading: o.isPending, children: i.jsxs(pr, { ...n, children: [ot("Frecuencia", o.data?.Result?.FrecuenciaPagoNombre), ot("Cantidad veces", o.data?.Result?.CantidadVeces), ot("Fecha próxima", bt(o.data?.Result?.FechaProxima).format("DD-MM-YY")), ot("Enviar por correo", ld(o.data?.Result?.EnviarPorCorreo))] }) });
}, j1 = ({ TableData: e, DataFetch: t }) => {
  const r = Eh(t), n = pS(t);
  return e === "FacturasComprasDetallesLotes" ? r : n;
}, $1 = ({ FacturaId: e, TableData: t, ProductoId: r }) => {
  const n = j1({
    TableData: t,
    DataFetch: {
      FacturaId: e,
      ProductoId: r
    }
  }), o = [
    {
      key: "Numero",
      align: "center",
      dataIndex: "Numero",
      title: "Número de lote",
      render: (s, c) => i.jsx("span", { children: c.Numero })
    },
    {
      key: "Cantidad",
      align: "center",
      title: "Cantidad",
      dataIndex: "Cantidad",
      render: (s, c) => i.jsx("span", { children: c.Cantidad })
    },
    {
      align: "center",
      key: "Vencimiento",
      title: "Vencimiento",
      dataIndex: "Vencimiento",
      render: (s, c) => i.jsx("span", { children: rt(c.Vencimiento).format("DD/MM/YYYY") })
    }
  ], a = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "Este producto no tiene lotes." }) }), []);
  return i.jsx(mo, { size: "small", columns: o, dataSource: n.data, loading: n.isLoading, pagination: {
    defaultPageSize: 5
  }, locale: {
    emptyText: a()
  }, title: () => i.jsxs(Ke, { style: {
    gap: 8,
    padding: "5px",
    borderRadius: "8px",
    alignItems: "center",
    background: "#3da86b"
  }, children: [i.jsx(me, { name: "cube", color: "white" }), i.jsx(at, { style: { color: "white", fontWeight: "bold" }, children: t == "FacturasComprasDetallesLotes" ? "Lotes del producto creados en esta factura:" : "Lotes del producto usados en esta factura" })] }) });
}, en = ({ TableData: e, DocumentoId: t, TipoDocumentoId: r }) => {
  const [n, o] = k.useState(""), a = (h) => {
    o(h.target.value);
  }, { docTypes: s } = et(), c = cS({
    Table: e,
    DocumentoId: t,
    Accion: "Get_Total_Y_Productos"
  }), l = [
    {
      key: "Codigo",
      title: "Producto",
      dataIndex: "Codigo",
      render: (h) => i.jsx(qt, { strong: !0, children: h })
    },
    {
      title: "Precio",
      align: "center",
      key: "PrecioUnitario",
      dataIndex: "PrecioUnitario",
      render: (h, g) => i.jsxs("span", { children: ["$", De(g.PrecioUnitario)] })
    },
    {
      key: "Cantidad",
      align: "center",
      title: "Cantidad",
      dataIndex: "Cantidad",
      render: (h, g) => i.jsx("span", { children: De(g.Cantidad) })
    },
    {
      align: "center",
      key: "Descuento",
      title: "Descuento",
      dataIndex: "Descuento",
      render: (h, g) => i.jsxs("span", { children: ["$", De(g?.Descuento)] })
    },
    {
      key: "SubTotal",
      align: "center",
      title: "Subtotal",
      dataIndex: "SubTotal",
      render: (h, g) => i.jsxs("span", { children: ["$", De(g?.SubTotal || 0)] })
    }
  ], d = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay total por productos." }) }), []), u = k.useMemo(() => c.data?.Result?.TotalPorProductos.length ? c.data?.Result?.TotalPorProductos.reduce((h, g) => [
    g.Codigo,
    `${g.PrecioUnitario}`,
    `${g.Cantidad}`,
    `${g.Descuento}`,
    `${g.LotesCreados}`,
    `${g.SubTotal}`
  ].some((v) => dd(v, n)) ? [...h, g] : h, []) : [], [c.data?.Result, n]), f = sr(`${st.maxDevice.tablet}`);
  return i.jsx(bn, { bodyStyle: { padding: 0 }, loading: c.isFetching, children: i.jsxs(Ke, { style: {
    width: "100%",
    flexWrap: "wrap",
    flexDirection: f ? "column" : "row"
  }, children: [i.jsx(ZE, { enabled: !1, isLoading: c.isLoading || c.data == null, Total: De(c.data?.Result?.TotalGeneral?.Total || 0), Subtotal: De(c.data?.Result?.TotalGeneral?.Monto || 0), Importe: De(c.data?.Result?.TotalGeneral?.Importe || 0), Descuento: De(c.data?.Result?.TotalGeneral?.Descuento || 0), Impuestos: De(c.data?.Result?.TotalGeneral?.Impuestos || 0), Retenciones: De(c.data?.Result?.TotalGeneral?.Retenciones || 0) }), i.jsx(at, { style: { flex: 3, width: "100%" }, children: i.jsx(Ln, { columns: l, dataSource: u, title: "Total por productos", skeletonLoadingRowCount: 3, placeholderSearch: "Búsqueda...", skeletonLoading: c.isPending, onChangeSearch: Mn({ delay: 500 }, a), onSearch: (h) => {
    n !== h && o(h);
  }, tableProps: {
    loading: c.isFetching,
    scroll: { x: l.length * 100 },
    pagination: {
      defaultPageSize: 3,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: d(),
      filterEmptyText: "Sin filtros"
    },
    expandable: {
      expandedRowRender: r && (r == s.Factura_de_compra || r == s.Factura_de_venta) ? (h) => i.jsx($1, { FacturaId: t, ProductoId: h.ProductoId, TableData: r === s.Factura_de_compra ? "FacturasComprasDetallesLotes" : "FacturasVentasDetallesLotes" }) : void 0
    }
  } }) })] }) });
}, ai = () => {
  const e = xt(), { docTypes: t } = et();
  return Kg((n, o, a, s) => {
    let c = (a == "Compras", "");
    const l = "-detalles", d = a == "Compras" ? "compra" : "venta";
    switch (n) {
      case t.Nota_de_credito:
        c += `nota-credito${l}`;
        break;
      case t.Nota_de_debito:
        c += `nota-debito${l}`;
        break;
      case t.Conduce:
        c += `conduce-${d}${l}`;
        break;
      case t.Factura_de_compra:
        c += `factura-compra${l}`;
        break;
      case t.Orden_de_compra:
        c += `orden-compra${l}`;
        break;
      default:
        c += "movimiento-inventario";
        break;
      case t.Cotizacion:
        c += `cotizacion${l}`;
        break;
      case t.Factura_de_venta:
        c += `factura-venta${l}`;
        break;
    }
    c += `/${o}`, e(`${s === "child" ? "" : s === "sibling" ? "../" : "./"}${c}`);
  }, [e, t]);
}, tn = ({ Area: e, TableData: t, DocumentoId: r }) => {
  const [n, o] = k.useState(""), a = (f) => {
    o(f.target.value);
  }, s = ai(), c = dS({
    Table: t,
    DocumentoId: r,
    Accion: "Get_Documentos_Referencia"
  }), l = [
    {
      width: 150,
      title: "Secuencia",
      key: "DocumentoNumero",
      dataIndex: "DocumentoNumero",
      render: (f, h) => i.jsx(nr, { onClick: () => {
        s(h.TipoDocumentoId, h.DocumentoId, e, "sibling");
      }, children: h.DocumentoNumero })
    },
    {
      width: 250,
      title: "Tipo de documento",
      key: "TipoDocumentoNombre",
      dataIndex: "TipoDocumentoNombre"
    },
    {
      width: 150,
      key: "Fecha",
      title: "Fecha",
      dataIndex: "Fecha",
      render: (f) => i.jsx("span", { children: f ? new Date(f).toLocaleDateString() : "N/A" })
    },
    {
      key: "Notas",
      title: "Notas",
      dataIndex: "Notas",
      render: (f) => f !== "" ? f : "N/A"
    },
    {
      width: 300,
      title: "Estado",
      key: "EstadoNombre",
      dataIndex: "EstadoNombre",
      render: (f) => i.jsx(rr.Status, { state: f })
    }
  ], d = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay documentos de referencia." }) }), []), u = k.useMemo(() => {
    const f = c.data?.Result;
    return Array.isArray(f) ? (c.data?.Result).reduce((h, g) => [
      g.DocumentoNumero,
      g.TipoDocumentoNombre,
      bt(g.Fecha).format("DD/MM/YY"),
      g.Notas,
      g.EstadoNombre
    ].some((v) => dd(v, n)) ? [...h, g] : h, []) : [];
  }, [c.data?.Result, n]);
  return i.jsx(Ln, { dataSource: u, columns: l, skeletonLoadingRowCount: 5, placeholderSearch: "Búsqueda...", title: "Documentos de referencia", onChangeSearch: Mn({ delay: 500 }, a), skeletonLoading: c.isPending, onSearch: (f) => {
    n !== f && o(f);
  }, tableProps: {
    loading: c.isFetching,
    scroll: { x: l.length * 100 },
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: d(),
      filterEmptyText: "Sin filtros"
    }
  } });
}, A1 = {
  column: 2,
  colon: !1,
  size: "small",
  bordered: !0,
  style: { flex: 1 },
  layout: "vertical",
  labelStyle: {
    flex: 1,
    display: "flex",
    justifyContent: "center"
  },
  contentStyle: {
    flex: 1,
    display: "flex",
    justifyContent: "center"
  }
}, _1 = ({ Monto: e, Pendiente: t }) => i.jsxs(On, { ...A1, children: [ot("Monto total", tr(Number(e), "RD$")), ot("Pendiente", tr(Number(t), "RD$"))] }), M1 = ({ DocumentoId: e }) => {
  const t = sr(`${st.maxDevice.mobileM}`), r = sr(`${st.maxDevice.tablet}`), n = {
    column: 1,
    colon: !1,
    size: "small",
    bordered: !0,
    style: { flex: 1 },
    layout: t ? "vertical" : "horizontal",
    contentStyle: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-end"
    }
  }, o = uS({
    DocumentoId: e,
    Table: "Facturas-Ventas",
    Accion: "Get_Info_Pagos"
  }), { statesValues: a } = et(), s = yS({
    DocumentoId: e,
    Table: "Facturas-Ventas",
    Accion: "Get_Info_Pagos"
  }, {
    DocumentoId: e,
    Table: "Facturas-Ventas",
    Accion: "Get_Informacion_Principal"
  }), c = async () => {
    await se.promise(s.mutateAsync({
      EstadoId: a.Anulado || 0,
      ReciboId: l?.ReciboId || 0
    }), {
      loading: "Anulando el recibo de pago",
      error: () => "Error al anular el recibo de pago",
      success: () => "Recibo anulado correctamente"
    });
  }, [l, d] = k.useState(), [u, f] = k.useState(), [h, g] = k.useState();
  k.useEffect(() => {
    const y = o.data?.Result;
    y?.Recibo && y.DetalleRecibo && y.FormasPago ? (d(y.Recibo), f(y.DetalleRecibo), g(y.FormasPago)) : (d(void 0), f(void 0), g(void 0));
  }, [
    o.data?.Result,
    d,
    f,
    g
  ]);
  const E = [
    {
      key: "Descripcion",
      title: "Forma de Pago",
      dataIndex: "Descripcion"
    },
    {
      key: "Monto",
      title: "Monto",
      align: "center",
      dataIndex: "Monto",
      render: (y, I) => i.jsxs("span", { children: [De(I.Monto), "$"] })
    },
    {
      key: "Recibido",
      align: "center",
      title: "Recibido",
      dataIndex: "Recibido",
      render: (y, I) => i.jsxs("span", { children: [De(I.Recibido), "$"] })
    },
    {
      key: "Referencia",
      title: "Referencia",
      dataIndex: "Referencia",
      render: (y, I) => i.jsx("span", { children: I.Referencia == "" ? "N/A" : I.Referencia })
    },
    {
      title: "Banco",
      key: "BancoNombre",
      dataIndex: "BancoNombre"
    },
    {
      key: "CuentaNombre",
      dataIndex: "CuentaNombre",
      title: "Cuadre Banco Caja"
    }
  ], v = (y, I) => i.jsx(pr.Item, { label: typeof y == "string" ? i.jsx(qt, { strong: !0, children: y }) : y, children: typeof I == "string" ? i.jsx(qt, { children: I }) : I }), m = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay métodos de pago." }) }), []);
  return i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [l?.EstadoId == a.Anulado ? null : i.jsx("div", { style: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end"
  }, children: i.jsx(wt, { onClick: () => c(), renderLeftIcon: i.jsx(me, { size: 20, name: "wallet-off" }), children: i.jsx("strong", { style: { marginLeft: "5px" }, children: "Anular pago" }) }) }), i.jsxs(Qt, { title: "Información de pago", headStyle: { paddingRight: 0 }, loading: o.isPending, extra: i.jsx(_1, { Monto: u?.Monto, Pendiente: u?.Pendiente }), bodyStyle: {
    gap: 16,
    paddingLeft: 8,
    display: "flex",
    paddingRight: 8,
    flexDirection: r ? "column" : "row"
  }, children: [i.jsxs(pr, { style: { flex: 1 }, title: `Recibo de pago No. ${l?.Secuencia}`, ...n, children: [v("Tipo de recibo", l?.ReciboTipoNombre), v("Concepto general", l?.ReciboConceptoGeneralNombre), v("Origen pago", l?.ReciboTipoFuentePagoNombre), v("Sucursal", l?.SucursalNombre), v("Fecha", bt(l?.Fecha).format("DD-MM-YYYY")), v("Moneda", l?.MonedaNombre), v("Tasa", l?.Tasa ? (l?.Tasa || "").toString() : "N/A"), v("Estado", i.jsx(rr.Status, { state: l?.EstadoNombre || "" }))] }), i.jsxs(pr, { style: { flex: 1 }, ...n, title: "Total general", children: [v("Subtotal", tr(Number(l?.SubTotal), "RD$")), v("Impuestos", tr(Number(l?.Impuestos), "RD$")), v("Retenciones", tr(Number(l?.Retenciones), "RD$")), v("Total pagado", tr(Number(l?.TotalAPagar), "RD$")), v("Recibido", tr(Number(l?.Recibido), "RD$")), v("Devolución", tr(Number(l?.Devolucion), "RD$"))] })] }), i.jsx(Ln, { hideSearch: !0, columns: E, dataSource: h, skeletonLoadingRowCount: 5, title: "Métodos de pago utilizados", skeletonLoading: o.isPending, tableProps: {
    loading: o.isFetching,
    scroll: { x: E.length * 100 },
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: m(),
      filterEmptyText: "Sin filtros"
    }
  } })] });
}, L1 = ({ disabled: e, DocumentData: t, formInstance: r, clientId: n = null }) => {
  const { data: o } = Qx(n), a = Ba("ContactDirection", r), s = o?.map((l) => ({
    value: l.Direccion,
    label: l.Direccion,
    Key: l.DireccionId
  }));
  xr(() => {
    r && r.setFieldValue("DireccionEnvio", a);
  }, [a, r]);
  const c = sr(`${st.maxDevice.laptop}`);
  return i.jsx(K, { form: r, children: i.jsxs(Ke, { style: {
    gap: 16,
    flexDirection: c ? "column" : "row"
  }, children: [i.jsx(K.Item, { style: { flex: 0.8 }, name: "FechaEntrega", label: i.jsx(qt, { strong: !0, children: "Fecha de entrega" }), initialValue: rt(t?.FechaEntrega), rules: [
    ...n ? [
      {
        required: !0,
        message: "Este campo es requerido"
      }
    ] : []
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }), n != null ? i.jsx(K.Item, { style: { flex: 1 }, name: "ContactDirection", label: i.jsx(qt, { strong: !0, children: "Seleccionar dirección" }), children: i.jsx(Ht, { size: "large", disabled: e, options: s }) }) : void 0, i.jsx(K.Item, { style: { flex: 1 }, name: "DireccionEnvio", initialValue: t?.DireccionEnvio, label: i.jsx(qt, { strong: !0, children: "Dirección específica de entrega" }), rules: [
    n ? {
      required: !0,
      message: "Este campo es requerido"
    } : {}
  ], children: i.jsx(Ja, { autoSize: !0, required: !0, size: "large", disabled: e }) })] }) });
};
var V1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const z1 = V1;
var vg = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: z1
  }));
};
process.env.NODE_ENV !== "production" && (vg.displayName = "CopyOutlined");
const B1 = /* @__PURE__ */ p.forwardRef(vg);
var k1 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const U1 = k1;
var yg = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: U1
  }));
};
process.env.NODE_ENV !== "production" && (yg.displayName = "EditOutlined");
const q1 = /* @__PURE__ */ p.forwardRef(yg);
var H1 = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, r = [], n = 0; n < e.rangeCount; n++)
    r.push(e.getRangeAt(n));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(o) {
      e.addRange(o);
    }), t && t.focus();
  };
}, W1 = H1, Sf = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, G1 = "Copy to clipboard: #{key}, Enter";
function K1(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function Y1(e, t) {
  var r, n, o, a, s, c, l = !1;
  t || (t = {}), r = t.debug || !1;
  try {
    o = W1(), a = document.createRange(), s = document.getSelection(), c = document.createElement("span"), c.textContent = e, c.ariaHidden = "true", c.style.all = "unset", c.style.position = "fixed", c.style.top = 0, c.style.clip = "rect(0, 0, 0, 0)", c.style.whiteSpace = "pre", c.style.webkitUserSelect = "text", c.style.MozUserSelect = "text", c.style.msUserSelect = "text", c.style.userSelect = "text", c.addEventListener("copy", function(u) {
      if (u.stopPropagation(), t.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          r && console.warn("unable to use e.clipboardData"), r && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var f = Sf[t.format] || Sf.default;
          window.clipboardData.setData(f, e);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(t.format, e);
      t.onCopy && (u.preventDefault(), t.onCopy(u.clipboardData));
    }), document.body.appendChild(c), a.selectNodeContents(c), s.addRange(a);
    var d = document.execCommand("copy");
    if (!d)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (u) {
    r && console.error("unable to copy using execCommand: ", u), r && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
    } catch (f) {
      r && console.error("unable to copy using clipboardData: ", f), r && console.error("falling back to prompt"), n = K1("message" in t ? t.message : G1), window.prompt(n, e);
    }
  } finally {
    s && (typeof s.removeRange == "function" ? s.removeRange(a) : s.removeAllRanges()), c && document.body.removeChild(c), o();
  }
  return l;
}
var Q1 = Y1;
const X1 = /* @__PURE__ */ Hf(Q1);
var bg = function(t) {
  if (Zt() && window.document.documentElement) {
    var r = Array.isArray(t) ? t : [t], n = window.document.documentElement;
    return r.some(function(o) {
      return o in n.style;
    });
  }
  return !1;
}, Z1 = function(t, r) {
  if (!bg(t))
    return !1;
  var n = document.createElement("div"), o = n.style[t];
  return n.style[t] = r, n.style[t] !== o;
};
function Ef(e, t) {
  return !Array.isArray(e) && t !== void 0 ? Z1(e, t) : bg(e);
}
var qe = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var r = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    r >= qe.F1 && r <= qe.F12)
      return !1;
    switch (r) {
      case qe.ALT:
      case qe.CAPS_LOCK:
      case qe.CONTEXT_MENU:
      case qe.CTRL:
      case qe.DOWN:
      case qe.END:
      case qe.ESC:
      case qe.HOME:
      case qe.INSERT:
      case qe.LEFT:
      case qe.MAC_FF_META:
      case qe.META:
      case qe.NUMLOCK:
      case qe.NUM_CENTER:
      case qe.PAGE_DOWN:
      case qe.PAGE_UP:
      case qe.PAUSE:
      case qe.PRINT_SCREEN:
      case qe.RIGHT:
      case qe.SHIFT:
      case qe.UP:
      case qe.WIN_KEY:
      case qe.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= qe.ZERO && t <= qe.NINE || t >= qe.NUM_ZERO && t <= qe.NUM_MULTIPLY || t >= qe.A && t <= qe.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case qe.SPACE:
      case qe.QUESTION_MARK:
      case qe.NUM_PLUS:
      case qe.NUM_MINUS:
      case qe.NUM_PERIOD:
      case qe.NUM_DIVISION:
      case qe.SEMICOLON:
      case qe.DASH:
      case qe.EQUALS:
      case qe.COMMA:
      case qe.PERIOD:
      case qe.SLASH:
      case qe.APOSTROPHE:
      case qe.SINGLE_QUOTE:
      case qe.OPEN_SQUARE_BRACKET:
      case qe.BACKSLASH:
      case qe.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, J1 = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const eF = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, tF = /* @__PURE__ */ p.forwardRef((e, t) => {
  const r = (d) => {
    const {
      keyCode: u
    } = d;
    u === qe.ENTER && d.preventDefault();
  }, n = (d) => {
    const {
      keyCode: u
    } = d, {
      onClick: f
    } = e;
    u === qe.ENTER && f && f();
  }, {
    style: o,
    noStyle: a,
    disabled: s
  } = e, c = J1(e, ["style", "noStyle", "disabled"]);
  let l = {};
  return a || (l = Object.assign({}, eF)), s && (l.pointerEvents = "none"), l = Object.assign(Object.assign({}, l), o), /* @__PURE__ */ p.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref: t
  }, c, {
    onKeyDown: r,
    onKeyUp: n,
    style: l
  }));
}), Df = tF;
var rF = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const nF = rF;
var Cg = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: nF
  }));
};
process.env.NODE_ENV !== "production" && (Cg.displayName = "EnterOutlined");
const oF = /* @__PURE__ */ p.forwardRef(Cg), aF = (e, t, r, n) => {
  const {
    titleMarginBottom: o,
    fontWeightStrong: a
  } = n;
  return {
    marginBottom: o,
    color: r,
    fontWeight: a,
    fontSize: e,
    lineHeight: t
  };
}, iF = (e) => {
  const t = [1, 2, 3, 4, 5], r = {};
  return t.forEach((n) => {
    r[`
      h${n}&,
      div&-h${n},
      div&-h${n} > textarea,
      h${n}
    `] = aF(e[`fontSizeHeading${n}`], e[`lineHeightHeading${n}`], e.colorTextHeading, e);
  }), r;
}, sF = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, ap(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, cF = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: uy[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), lF = (e) => {
  const {
    componentCls: t,
    paddingSM: r
  } = e, n = r;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(n).mul(-1).equal(),
        marginBottom: `calc(1em - ${Me(n)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, dF = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), uF = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), fF = (e) => {
  const {
    componentCls: t,
    titleMarginTop: r
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccess
      },
      [`&${t}-warning`]: {
        color: e.colorWarning
      },
      [`&${t}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, iF(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: r
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: r
        }
      }
    }), cF(e)), sF(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, ap(e)), {
        marginInlineStart: e.marginXXS
      })
    }), lF(e)), dF(e)), uF()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, mF = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), Ig = Cn("Typography", (e) => [fF(e)], mF), pF = (e) => {
  const {
    prefixCls: t,
    "aria-label": r,
    className: n,
    style: o,
    direction: a,
    maxLength: s,
    autoSize: c = !0,
    value: l,
    onSave: d,
    onCancel: u,
    onEnd: f,
    component: h,
    enterIcon: g = /* @__PURE__ */ p.createElement(oF, null)
  } = e, E = p.useRef(null), v = p.useRef(!1), m = p.useRef(), [y, I] = p.useState(l);
  p.useEffect(() => {
    I(l);
  }, [l]), p.useEffect(() => {
    if (E.current && E.current.resizableTextArea) {
      const {
        textArea: _
      } = E.current.resizableTextArea;
      _.focus();
      const {
        length: A
      } = _.value;
      _.setSelectionRange(A, A);
    }
  }, []);
  const b = (_) => {
    let {
      target: A
    } = _;
    I(A.value.replace(/[\n\r]/g, ""));
  }, C = () => {
    v.current = !0;
  }, S = () => {
    v.current = !1;
  }, T = (_) => {
    let {
      keyCode: A
    } = _;
    v.current || (m.current = A);
  }, N = () => {
    d(y.trim());
  }, V = (_) => {
    let {
      keyCode: A,
      ctrlKey: R,
      altKey: P,
      metaKey: z,
      shiftKey: F
    } = _;
    m.current === A && !v.current && !R && !P && !z && !F && (A === qe.ENTER ? (N(), f?.()) : A === qe.ESC && u());
  }, D = () => {
    N();
  }, x = h ? `${t}-${h}` : "", [O, w, j] = Ig(t), $ = we(t, `${t}-edit-content`, {
    [`${t}-rtl`]: a === "rtl"
  }, n, x, w, j);
  return O(/* @__PURE__ */ p.createElement("div", {
    className: $,
    style: o
  }, /* @__PURE__ */ p.createElement(Ja, {
    ref: E,
    maxLength: s,
    value: y,
    onChange: b,
    onKeyDown: T,
    onKeyUp: V,
    onCompositionStart: C,
    onCompositionEnd: S,
    onBlur: D,
    "aria-label": r,
    rows: 1,
    autoSize: c
  }), g !== null ? fo(g, {
    className: `${t}-edit-content-confirm`
  }) : null));
}, hF = pF;
function jc(e, t) {
  return p.useMemo(() => {
    const r = !!e;
    return [r, Object.assign(Object.assign({}, t), r && typeof e == "object" ? e : null)];
  }, [e]);
}
const gF = (e, t) => {
  const r = p.useRef(!1);
  p.useEffect(() => {
    r.current ? e() : r.current = !0;
  }, t);
};
var vF = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const xg = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    component: n = "article",
    className: o,
    rootClassName: a,
    setContentRef: s,
    children: c,
    direction: l,
    style: d
  } = e, u = vF(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: f,
    direction: h,
    typography: g
  } = p.useContext(Mt), E = l ?? h;
  let v = t;
  s && (v = po(t, s)), process.env.NODE_ENV !== "production" && ur("Typography").deprecated(!s, "setContentRef", "ref");
  const m = f("typography", r), [y, I, b] = Ig(m), C = we(m, g?.className, {
    [`${m}-rtl`]: E === "rtl"
  }, o, a, I, b), S = Object.assign(Object.assign({}, g?.style), d);
  return y(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ p.createElement(n, Object.assign({
      className: C,
      style: S,
      ref: v
    }, u), c)
  );
});
process.env.NODE_ENV !== "production" && (xg.displayName = "Typography");
const yF = xg;
function Sg(e) {
  const t = typeof e;
  return t === "string" || t === "number";
}
function bF(e) {
  let t = 0;
  return e.forEach((r) => {
    Sg(r) ? t += String(r).length : t += 1;
  }), t;
}
function $c(e, t) {
  let r = 0;
  const n = [];
  for (let o = 0; o < e.length; o += 1) {
    if (r === t)
      return n;
    const a = e[o], c = Sg(a) ? String(a).length : 1, l = r + c;
    if (l > t) {
      const d = t - r;
      return n.push(String(a).slice(0, d)), n;
    }
    n.push(a), r = l;
  }
  return e;
}
const CF = 0, _i = 1, wf = 2, Ac = 3, _c = 4, Eg = (e) => {
  let {
    enabledMeasure: t,
    children: r,
    text: n,
    width: o,
    fontSize: a,
    rows: s,
    onEllipsis: c
  } = e;
  const [[l, d, u], f] = p.useState([0, 0, 0]), [h, g] = p.useState(0), [E, v] = p.useState(CF), [m, y] = p.useState(0), I = p.useRef(null), b = p.useRef(null), C = p.useMemo(() => lo(n), [n]), S = p.useMemo(() => bF(C), [C]), T = p.useMemo(() => !t || E !== Ac ? h && E !== _c && t ? r($c(C, h), h < S) : r(C, !1) : r($c(C, d), d < S), [t, E, r, C, d, S]);
  jt(() => {
    t && o && a && S && (v(_i), f([0, Math.ceil(S / 2), S]));
  }, [t, o, a, n, S, s]), jt(() => {
    var x;
    E === _i && y(((x = I.current) === null || x === void 0 ? void 0 : x.offsetHeight) || 0);
  }, [E]), jt(() => {
    var x, O;
    if (m) {
      if (E === _i) {
        const w = ((x = b.current) === null || x === void 0 ? void 0 : x.offsetHeight) || 0, j = s * m;
        w <= j ? (v(_c), c(!1)) : v(wf);
      } else if (E === wf)
        if (l !== u) {
          const w = ((O = b.current) === null || O === void 0 ? void 0 : O.offsetHeight) || 0, j = s * m;
          let $ = l, _ = u;
          l === u - 1 ? _ = l : w <= j ? $ = d : _ = d;
          const A = Math.ceil(($ + _) / 2);
          f([$, A, _]);
        } else
          v(Ac), g(d), c(!0);
    }
  }, [E, l, u, s, m]);
  const N = {
    width: o,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  }, V = (x, O, w) => /* @__PURE__ */ p.createElement("span", {
    "aria-hidden": !0,
    ref: O,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      zIndex: -9999,
      visibility: "hidden",
      pointerEvents: "none",
      fontSize: Math.ceil(a / 2) * 2
    }, w)
  }, x), D = (x, O) => {
    const w = $c(C, x);
    return V(r(w, !0), O, N);
  };
  return /* @__PURE__ */ p.createElement(p.Fragment, null, T, t && E !== Ac && E !== _c && /* @__PURE__ */ p.createElement(p.Fragment, null, V("lg", I, {
    wordBreak: "keep-all",
    whiteSpace: "nowrap"
  }), E === _i ? V(r(C, !1), b, N) : D(d, b)));
};
process.env.NODE_ENV !== "production" && (Eg.displayName = "Ellipsis");
const IF = Eg, Dg = (e) => {
  let {
    enabledEllipsis: t,
    isEllipsis: r,
    children: n,
    tooltipProps: o
  } = e;
  return !o?.title || !t ? n : /* @__PURE__ */ p.createElement(Qo, Object.assign({
    open: r ? void 0 : !1
  }, o), n);
};
process.env.NODE_ENV !== "production" && (Dg.displayName = "EllipsisTooltip");
const xF = Dg;
var SF = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function EF(e, t) {
  let {
    mark: r,
    code: n,
    underline: o,
    delete: a,
    strong: s,
    keyboard: c,
    italic: l
  } = e, d = t;
  function u(f, h) {
    h && (d = /* @__PURE__ */ p.createElement(f, {}, d));
  }
  return u("strong", s), u("u", o), u("del", a), u("code", n), u("mark", r), u("kbd", c), u("i", l), d;
}
function Mi(e, t, r) {
  return e === !0 || e === void 0 ? t : e || r && t;
}
function Tf(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
const DF = "...", wF = /* @__PURE__ */ p.forwardRef((e, t) => {
  var r, n, o;
  const {
    prefixCls: a,
    className: s,
    style: c,
    type: l,
    disabled: d,
    children: u,
    ellipsis: f,
    editable: h,
    copyable: g,
    component: E,
    title: v
  } = e, m = SF(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: y,
    direction: I
  } = p.useContext(Mt), [b] = ed("Text"), C = p.useRef(null), S = p.useRef(null), T = y("typography", a), N = Ya(m, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [V, D] = jc(h), [x, O] = Ka(!1, {
    value: D.editing
  }), {
    triggerType: w = ["icon"]
  } = D, j = (X) => {
    var re;
    X && ((re = D.onStart) === null || re === void 0 || re.call(D)), O(X);
  };
  gF(() => {
    var X;
    x || (X = S.current) === null || X === void 0 || X.focus();
  }, [x]);
  const $ = (X) => {
    X?.preventDefault(), j(!0);
  }, _ = (X) => {
    var re;
    (re = D.onChange) === null || re === void 0 || re.call(D, X), j(!1);
  }, A = () => {
    var X;
    (X = D.onCancel) === null || X === void 0 || X.call(D), j(!1);
  }, [R, P] = jc(g), [z, F] = p.useState(!1), L = p.useRef(null), M = {};
  P.format && (M.format = P.format);
  const B = () => {
    L.current && clearTimeout(L.current);
  }, W = (X) => {
    var re;
    X?.preventDefault(), X?.stopPropagation(), X1(P.text || String(u) || "", M), F(!0), B(), L.current = setTimeout(() => {
      F(!1);
    }, 3e3), (re = P.onCopy) === null || re === void 0 || re.call(P, X);
  };
  p.useEffect(() => B, []);
  const [ee, te] = p.useState(!1), [de, Z] = p.useState(!1), [ce, Y] = p.useState(!1), [he, ve] = p.useState(!1), [ue, le] = p.useState(!1), [Fe, He] = p.useState(!0), [We, ie] = jc(f, {
    expandable: !1
  }), ge = We && !ce, {
    rows: be = 1
  } = ie, Ie = p.useMemo(() => (
    // Disable ellipsis
    !ge || // Provide suffix
    ie.suffix !== void 0 || ie.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    ie.expandable || V || R
  ), [ge, ie, V, R]);
  jt(() => {
    We && !Ie && (te(Ef("webkitLineClamp")), Z(Ef("textOverflow")));
  }, [Ie, We]);
  const Pe = p.useMemo(() => Ie ? !1 : be === 1 ? de : ee, [Ie, de, ee]), Le = ge && (Pe ? ue : he), Ve = ge && be === 1 && Pe, _e = ge && be > 1 && Pe, ut = (X) => {
    var re;
    Y(!0), (re = ie.onExpand) === null || re === void 0 || re.call(ie, X);
  }, [Nt, pt] = p.useState(0), [Ge, dt] = p.useState(0), q = (X, re) => {
    let {
      offsetWidth: ye
    } = X;
    var xe;
    pt(ye), dt(parseInt((xe = window.getComputedStyle) === null || xe === void 0 ? void 0 : xe.call(window, re).fontSize, 10) || 0);
  }, H = (X) => {
    var re;
    ve(X), he !== X && ((re = ie.onEllipsis) === null || re === void 0 || re.call(ie, X));
  };
  p.useEffect(() => {
    const X = C.current;
    if (We && Pe && X) {
      const re = _e ? X.offsetHeight < X.scrollHeight : X.offsetWidth < X.scrollWidth;
      ue !== re && le(re);
    }
  }, [We, Pe, u, _e, Fe, Nt]), p.useEffect(() => {
    const X = C.current;
    if (typeof IntersectionObserver > "u" || !X || !Pe || !ge)
      return;
    const re = new IntersectionObserver(() => {
      He(!!X.offsetParent);
    });
    return re.observe(X), () => {
      re.disconnect();
    };
  }, [Pe, ge]);
  let G = {};
  ie.tooltip === !0 ? G = {
    title: (r = D.text) !== null && r !== void 0 ? r : u
  } : /* @__PURE__ */ p.isValidElement(ie.tooltip) ? G = {
    title: ie.tooltip
  } : typeof ie.tooltip == "object" ? G = Object.assign({
    title: (n = D.text) !== null && n !== void 0 ? n : u
  }, ie.tooltip) : G = {
    title: ie.tooltip
  };
  const ne = p.useMemo(() => {
    const X = (re) => ["string", "number"].includes(typeof re);
    if (!(!We || Pe)) {
      if (X(D.text))
        return D.text;
      if (X(u))
        return u;
      if (X(v))
        return v;
      if (X(G.title))
        return G.title;
    }
  }, [We, Pe, v, G.title, Le]);
  if (x)
    return /* @__PURE__ */ p.createElement(hF, {
      value: (o = D.text) !== null && o !== void 0 ? o : typeof u == "string" ? u : "",
      onSave: _,
      onCancel: A,
      onEnd: D.onEnd,
      prefixCls: T,
      className: s,
      style: c,
      direction: I,
      component: E,
      maxLength: D.maxLength,
      autoSize: D.autoSize,
      enterIcon: D.enterIcon
    });
  const fe = () => {
    const {
      expandable: X,
      symbol: re
    } = ie;
    if (!X)
      return null;
    let ye;
    return re ? ye = re : ye = b?.expand, /* @__PURE__ */ p.createElement("a", {
      key: "expand",
      className: `${T}-expand`,
      onClick: ut,
      "aria-label": b?.expand
    }, ye);
  }, Te = () => {
    if (!V)
      return;
    const {
      icon: X,
      tooltip: re
    } = D, ye = lo(re)[0] || b?.edit, xe = typeof ye == "string" ? ye : "";
    return w.includes("icon") ? /* @__PURE__ */ p.createElement(Qo, {
      key: "edit",
      title: re === !1 ? "" : ye
    }, /* @__PURE__ */ p.createElement(Df, {
      ref: S,
      className: `${T}-edit`,
      onClick: $,
      "aria-label": xe
    }, X || /* @__PURE__ */ p.createElement(q1, {
      role: "button"
    }))) : null;
  }, Be = () => {
    if (!R)
      return null;
    const {
      tooltips: X,
      icon: re
    } = P, ye = Tf(X), xe = Tf(re), Ae = z ? Mi(ye[1], b?.copied) : Mi(ye[0], b?.copy), je = z ? b?.copied : b?.copy, Qe = typeof Ae == "string" ? Ae : je;
    return /* @__PURE__ */ p.createElement(Qo, {
      key: "copy",
      title: Ae
    }, /* @__PURE__ */ p.createElement(Df, {
      className: we(`${T}-copy`, {
        [`${T}-copy-success`]: z,
        [`${T}-copy-icon-only`]: u == null
      }),
      onClick: W,
      "aria-label": Qe
    }, z ? Mi(xe[1], /* @__PURE__ */ p.createElement(Wh, null), !0) : Mi(xe[0], /* @__PURE__ */ p.createElement(B1, null), !0)));
  }, $e = (X) => [X && fe(), Te(), Be()], pe = (X) => [X && /* @__PURE__ */ p.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, DF), ie.suffix, $e(X)];
  return /* @__PURE__ */ p.createElement(ta, {
    onResize: q,
    disabled: !ge
  }, (X) => /* @__PURE__ */ p.createElement(xF, {
    tooltipProps: G,
    enabledEllipsis: ge,
    isEllipsis: Le
  }, /* @__PURE__ */ p.createElement(yF, Object.assign({
    className: we({
      [`${T}-${l}`]: l,
      [`${T}-disabled`]: d,
      [`${T}-ellipsis`]: We,
      [`${T}-single-line`]: ge && be === 1,
      [`${T}-ellipsis-single-line`]: Ve,
      [`${T}-ellipsis-multiple-line`]: _e
    }, s),
    prefixCls: a,
    style: Object.assign(Object.assign({}, c), {
      WebkitLineClamp: _e ? be : void 0
    }),
    component: E,
    ref: po(X, C, t),
    direction: I,
    onClick: w.includes("text") ? $ : void 0,
    "aria-label": ne?.toString(),
    title: v
  }, N), /* @__PURE__ */ p.createElement(IF, {
    enabledMeasure: ge && !Pe,
    text: u,
    rows: be,
    width: Nt,
    fontSize: Ge,
    onEllipsis: H
  }, (re, ye) => {
    let xe = re;
    return re.length && ye && ne && (xe = /* @__PURE__ */ p.createElement("span", {
      key: "show-content",
      "aria-hidden": !0
    }, xe)), EF(e, /* @__PURE__ */ p.createElement(p.Fragment, null, xe, pe(ye)));
  }))));
}), TF = wF;
var FF = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const OF = /* @__PURE__ */ p.forwardRef((e, t) => {
  var {
    ellipsis: r,
    rel: n
  } = e, o = FF(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const s = ur("Typography.Link");
    process.env.NODE_ENV !== "production" && s(typeof r != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const a = Object.assign(Object.assign({}, o), {
    rel: n === void 0 && o.target === "_blank" ? "noopener noreferrer" : n
  });
  return delete a.navigate, /* @__PURE__ */ p.createElement(TF, Object.assign({}, a, {
    ref: t,
    ellipsis: !!r,
    component: "a"
  }));
}), NF = OF, RF = ({ fetchProductsBySeach: e }) => e.isLoading ? i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "row",
  justifyContent: "center"
}, children: [i.jsx(Xo, {}), i.jsx("div", { style: { width: "100%", textAlign: "center" }, children: i.jsx("span", { children: "Buscando" }) })] }) : e.isSuccess || e.data?.length === 0 || e.data ? i.jsxs("div", { style: {
  display: "flex",
  padding: "10px",
  flexDirection: "column"
}, children: [i.jsxs("div", { style: {
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: "10px",
  justifyContent: "center"
}, children: [i.jsx(me, { name: "mood-confuzed" }), i.jsx("div", { style: { width: "100%", textAlign: "center" }, children: i.jsx("span", { children: "No se han encontrado productos" }) })] }), i.jsxs(NF, { target: "blank", href: "/inventory", style: {
  padding: "5px",
  display: "flex",
  borderRadius: "8px",
  flexDirection: "row",
  alignItems: "center",
  background: "#D3D3D3"
}, children: [i.jsx(me, { size: 18, name: "square-rounded-plus-filled" }), i.jsx("strong", { style: { fontSize: "15px", marginLeft: "5px" }, children: "Crear Producto" })] })] }) : e.isError ? i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "row",
  justifyContent: "center"
}, children: [i.jsx(me, { name: "error-404" }), i.jsx("div", { style: { width: "100%", textAlign: "center" }, children: i.jsx("span", { children: "Error en la busqueda" }) })] }) : null, PF = ({ tax: e, form: t, loading: r, disabled: n, dataSource: o, DocumentData: a, setDataSource: s, detailInConflict: c, setDetailInConflict: l }) => {
  const u = Ba("products", t) === void 0, { docTypes: f, statesValues: h } = et(), [g, E] = k.useState({
    searchTerm: ""
  }), v = Wx({
    ...g
  }), m = (w, j, $) => ({
    Key: j,
    Total: 0,
    Flete: 0,
    SubTotal: 0,
    Impuesto: 0,
    Descuento: 0,
    Cantidad: $,
    DescuentoUnitario: 0,
    DocumentoDetalleId: 0,
    Codigo: w.Codigo,
    DescuentoEsPorcentual: !1,
    EstadoId: h.Activo,
    ProductoId: w.ProductoId,
    Referencia: w.Referencia,
    ImpuestoId: w.ImpuestoId,
    LLevaSerie: w.LLevaSerie,
    Descripcion: w.Descripcion,
    PrecioUnitario: w.PrecioVenta,
    CostoUnitario: w.CostoUnitario,
    UnidadMedidaId: w.UnidadMedidaId,
    TieneVencimiento: w.TieneVencimiento,
    DocumentoId: a?.DocumentoId || 0,
    PrecioUnitarioOriginal: w.PrecioVenta,
    ImpuestoPorcentaje: w.ImpuestoPorcentaje,
    PrecioUnitarioMinimo: w.PrecioVentaMinimo
  }), y = () => {
    const w = o ? o?.map((_) => _.Key) : 1, j = JSON.parse(t.getFieldValue("products")), $ = m(j, Vo(w), 0);
    a?.TipoDocumentoId === f.Nota_de_credito ? a?.ProductosCantidadesDisponibles?.map((A) => A?.ProductoId)?.includes(j.ProductoId) ? (t.setFieldValue("products", null), s([...o || [], $])) : se.error("El producto seleccionado no está incluido en la factura original.") : s([...o || [], $]);
  }, I = () => {
    const w = a?.ProductosCantidadesDisponibles?.map(($) => $.ProductoId) || [], j = v.data?.filter(($) => w.includes($.ProductoId));
    s([
      ...j?.map(($, _) => m($, _, 1)) || []
    ]);
  }, b = (w) => {
    const j = o?.filter(($) => $.Key !== w);
    s(j);
  }, C = (w) => {
    const j = [...o], $ = j.findIndex((R) => w.ProductoId === R.ProductoId), A = { ...j[$], ...w };
    j.splice($, 1, {
      ...A,
      Total: T(A),
      Impuesto: S(A),
      DescuentoUnitario: w.DescuentoUnitario,
      ImpuestosPorImpuesto: S(A),
      Flete: t.getFieldValue("Flete") / o.length,
      SubTotal: Number.parseFloat(String(N(A))),
      Descuento: V(w.DescuentoUnitario, w.Cantidad, w.DescuentoEsPorcentual, w.PrecioUnitario)
    }), s(j);
  }, S = (w) => Number.parseFloat(String(N(w))) * ((w?.ImpuestoPorcentaje || 0) / 100), T = (w) => Number.parseFloat(String(N(w))) + Number.parseFloat(String(S(w))), N = k.useCallback((w) => {
    const j = /true/i.test(e), $ = w.Cantidad && w.PrecioUnitario ? w.Cantidad * w.PrecioUnitario : 0, _ = j ? $ - (w?.Flete ? w?.Flete : 0) : $, A = (w?.ImpuestoPorcentaje || 0) / 100 + 1, R = V(w?.DescuentoUnitario || 0, w.Cantidad || 0, w.DescuentoEsPorcentual, w.PrecioUnitario || 0);
    return j ? ((_ - R) / A).toFixed(2) : _ - R - (w?.Flete ? w.Flete : 0);
  }, [e]), V = (w, j, $, _) => $ ? j * (_ || 0) * w / 100 : j * w, D = (w) => {
    if (w.key === "Enter") {
      const j = /[\\/]\d*/g, $ = g.searchTerm.replace(j, ""), _ = v.data?.find((A) => A.Codigo === $);
      if (_) {
        let A = {}, R = {};
        if (_?.FacturaCompraDetalleLoteId) {
          const F = o ? o?.map((L) => L.Key) : 1;
          A = {
            Cantidad: 1,
            DetalleId: 0,
            FacturaVentaDetalleLoteId: 0,
            Key: Vo(F),
            FacturaCompraDetalleLoteId: _.FacturaCompraDetalleLoteId
          };
        }
        _?.FacturaCompraDetalleSerieId && (R = {
          DetalleId: 0,
          FacturaVentaDetalleSerieId: 0,
          NumeroSerie: _.NumeroSerie || "1",
          FacturaCompraDetalleSerieId: _?.FacturaCompraDetalleSerieId
        });
        const P = o ? o?.map((F) => F.Key) : 1, z = {
          Total: 0,
          Flete: 0,
          Cantidad: 1,
          SubTotal: 0,
          Impuesto: 0,
          Descuento: 0,
          DescuentoUnitario: 0,
          DocumentoDetalleId: 0,
          DescuentoEsPorcentual: !1,
          EstadoId: h.Activo,
          Codigo: _?.Codigo,
          Key: Vo(P),
          ProductoId: _?.ProductoId,
          Referencia: _?.Referencia,
          ImpuestoId: _?.ImpuestoId,
          LLevaSerie: _?.LLevaSerie,
          Descripcion: _?.Descripcion,
          DocumentoId: a?.DocumentoId || 0,
          PrecioUnitario: _?.PrecioVenta,
          CostoUnitario: _?.CostoUnitario,
          UnidadMedidaId: _?.UnidadMedidaId,
          FacturaVentaDetalleLotes: [{ ...A }],
          TieneVencimiento: _?.TieneVencimiento,
          FacturaVentaDetalleSeries: [{ ...R }],
          PrecioUnitarioOriginal: _?.PrecioVenta,
          ImpuestoPorcentaje: _?.ImpuestoPorcentaje,
          PrecioUnitarioMinimo: _?.PrecioVentaMinimo
        };
        a?.TipoDocumentoId === f.Nota_de_credito ? a?.ProductosCantidadesDisponibles?.map((L) => L?.ProductoId)?.includes(_?.ProductoId || 0) ? (t.setFieldValue("products", null), s([...o || [], z])) : se.error("El producto escaneado no esta incluido en la factura original.") : (Or.info("execute"), s([...o || [], z]));
      }
    }
  }, x = k.useCallback(() => i.jsx(Wr, { emptyText: "No hay productos agregados" }), []), O = sr(`${st.maxDevice.mobileL}`);
  return i.jsx(Qt, { loading: r, title: "Agregar producto:", style: { height: "100%" }, styles: {
    body: {
      padding: 0,
      width: "100%",
      display: "flex",
      overflow: "hidden",
      alignItems: "center",
      justifyContent: "center",
      height: O ? 500 : 300
    }
  }, extra: i.jsx(Vc, { style: { width: "100%", minWidth: 300 }, children: i.jsx(K, { form: t, layout: "vertical", style: { width: "100%" }, children: i.jsxs(ir.Compact, { style: { width: "100%" }, children: [i.jsx(K.Item, { noStyle: !0, name: "products", children: i.jsx(Ht, { allowClear: !0, showSearch: !0, size: "large", disabled: n, placeholder: "Buscar", style: { width: "100%" }, onKeyDown: (w) => D(w), onSearch: (w) => E({ searchTerm: w }), notFoundContent: i.jsx(RF, { fetchProductsBySeach: v }), options: v.data?.map((w) => ({
    value: JSON.stringify(w),
    label: "(" + w.Codigo + ") " + w.Descripcion
  })) }) }), i.jsx(wt, { size: "large", type: "primary", onClick: y, disabled: u || n, loading: v.isLoading, renderRightIcon: i.jsx(me, { name: "plus", color: "white" }) })] }) }) }), children: i.jsx(i.Fragment, { children: o.length ? i.jsx(at, { style: {
    padding: 16,
    width: "100%",
    height: "100%",
    direction: "rtl",
    overflowY: "auto",
    overflowX: "hidden"
  }, children: i.jsxs(K, { form: t, layout: "vertical", style: { direction: "ltr" }, children: [a?.TipoDocumentoId === f.Nota_de_credito && a !== void 0 ? i.jsx(ir.Compact, { style: {
    display: "flex",
    marginBottom: "16px",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, children: i.jsx(nr, { onClick: () => I(), children: "Cargar productos de la factura" }) }) : null, i.jsx(ir.Compact, { style: {
    display: "flex",
    paddingLeft: "40px",
    paddingRight: "40px",
    marginBottom: "15px",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, children: a?.TipoDocumentoId === f.Nota_de_credito }), i.jsx(Vc, { style: {
    gap: 16,
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  }, children: o?.map((w) => i.jsx(ME, { item: w, onSave: C, enabled: !n, onDelete: b, dataSource: o, DocumentData: a, setDataSource: s, detailInConflict: c, setDetailInConflict: l, detailWidthConflict: c?.ObjectDetail.Key == w.Key }, w.Key)) })] }) }) : x() }) });
}, jF = ({ enabled: e, DocumentData: t, formConfigInstance: r }) => {
  const { docTypes: n } = et(), o = Jx(), [a, s] = k.useState(o.data?.find((C) => C.NombreISO === "DOP") || {}), { data: c } = mS(a.MonedaId || 1), l = Ba("TieneDescuentoPorFecha", r);
  k.useEffect(() => {
    c && (r.setFieldValue("Tasa", c[0]?.TasaVenta), r.setFieldValue("TasaFecha", rt(c[0]?.Fecha)));
  }, [a.MonedaId, c, r]);
  const d = Yx(), u = Xx(3), f = Zx(), h = eS(), g = d?.data?.map((C) => ({
    value: C.ProductoListaPrecioId,
    label: C.ProductoListaPrecioNombre
  })), E = u?.data?.map((C) => ({ label: C.FullName, value: C.ContactoId })), v = o?.data?.map((C) => ({ value: C.MonedaId, label: C.MonedaNombre })), m = f?.data ? Qg(f?.data, (C) => C?.ImpuestoBaseNombre || "Sin Base") : {}, y = Object.keys(m).map((C) => ({
    label: C,
    options: m[C]?.map((S) => ({
      label: S.ImpuestoNombre,
      value: JSON.stringify(S)
    }))
  })), I = Ba("Retencion", r), b = h?.data?.map((C) => ({ value: C.AlmacenId, label: C.AlmacenNombre }));
  return i.jsxs(K, { layout: "vertical", disabled: !e, form: r, children: [[
    n.Nota_de_credito,
    n.Nota_de_debito,
    n.Factura_de_compra,
    n.Orden_de_compra
  ].find((C) => C === t?.TipoDocumentoId) ? null : i.jsx(K.Item, { name: "ListaPrecioId", label: i.jsx("strong", { children: "Lista de precio" }), initialValue: t?.ListaPrecioId, rules: [{ required: !0, message: "Este campo es requerido" }], style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Ht, { options: g, loading: d.isLoading }) }), [
    n.Nota_de_credito,
    n.Nota_de_debito,
    n.Factura_de_compra,
    n.Orden_de_compra
  ].find((C) => C === t?.TipoDocumentoId) ? null : i.jsx(K.Item, { name: "Vendedor", label: i.jsx("strong", { children: "Vendedor" }), initialValue: t?.VendedorId, rules: [{ required: !0, message: "Este campo es requerido" }], style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Ht, { options: E, loading: u.isLoading }) }), i.jsx(K.Item, { name: "Referencia", label: i.jsx("strong", { children: "Referido por" }), initialValue: t?.Referencia, style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Hr, {}) }), i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, children: [i.jsx(K.Item, { name: "MonedaId", label: i.jsx("strong", { children: "Moneda" }), initialValue: t?.MonedaId, rules: [{ required: !0, message: "Este campo es requerido" }], style: {
    width: "69%",
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Ht, { disabled: !e, options: v, loading: o.isLoading, onChange: (C) => {
    const S = o.data?.find((T) => T.MonedaId === C);
    S !== void 0 && s(S), S?.NombreISO === "DOP" ? r.setFieldValue("Tasa", 1) : r.setFieldValue("Tasa", void 0);
  } }) }), i.jsx(K.Item, { name: "Tasa", label: i.jsx("strong", { children: "Tasa" }), initialValue: t?.Tasa, style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Vn, { type: "number", disabled: c == null || c?.length > 0 }) })] }), i.jsx(K.Item, { name: "TasaFecha", label: i.jsx("strong", { children: "Fecha de tasa" }), initialValue: rt(t?.TasaFecha || /* @__PURE__ */ new Date()), style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Kt, { disabled: !0, style: { width: "100%" } }) }), [
    n.Factura_de_venta,
    n.Factura_de_compra,
    n.Orden_de_compra,
    n.Cotizacion
  ].find((C) => C === t?.TipoDocumentoId) ? i.jsx(K.Item, { name: "AlmacenId", label: i.jsx("strong", { children: "Almacén" }), initialValue: t?.AlmacenId, rules: [{ required: !0, message: "Este campo es requerido" }], style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Ht, { options: b, loading: h.isLoading }) }) : null, i.jsx(K.Item, { name: "Retenciones", label: i.jsx("strong", { children: "Retenciones" }), style: {
    marginLeft: "0",
    marginRight: "0",
    marginTop: "15px",
    marginBottom: "0"
  }, children: i.jsx(Ht, { mode: "multiple", loading: f.isLoading, options: y.map((C) => {
    const S = C.options?.filter((T) => JSON.parse(T.value)?.ImpuestoBaseId == null ? !0 : I?.findIndex((N) => JSON.parse(N)?.ImpuestoNombre === T.label) >= 0);
    return {
      ...C,
      options: I?.length > 0 ? S : C.options
    };
  }) }) }), [
    n.Factura_de_compra,
    n.Nota_de_debito,
    n.Nota_de_credito
  ].find((C) => C === t?.TipoDocumentoId) ? i.jsxs("div", { style: {
    display: "flex",
    marginTop: "15px",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(K.Item, { style: { margin: "0" }, name: "ImpuestosIncluidos", initialValue: t?.ImpuestosIncluidos, children: i.jsx(Lc, { style: { marginRight: "5px" } }) }), i.jsx("span", { children: "Impuesto incluido en el precio." })] }) : null, [n.Factura_de_venta, n.Factura_de_compra].find((C) => C === t?.TipoDocumentoId) ? i.jsxs("div", { style: {
    display: "flex",
    marginTop: "15px",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(K.Item, { style: { margin: "0" }, valuePropName: "checked", name: "TieneDescuentoPorFecha", initialValue: t?.TieneDescuentoPorFecha, children: i.jsx(Lc, { style: { marginRight: "5px" } }) }), i.jsx("span", { children: "Esta factura posee descuento por límite de fecha." })] }) : null, l && l == !0 ? i.jsx(K.Item, { style: { width: "100%" }, name: "FechaLimiteDescuento", initialValue: t?.FechaLimiteDescuento, label: i.jsx("strong", { style: { width: "100%", marginTop: "15px" }, children: "Fecha Limite" }), children: i.jsx(Kt, { style: { width: "100%" } }) }) : null] });
}, $F = ({ disabled: e, DocumentData: t }) => {
  const r = sr(`${st.maxDevice.tablet}`);
  return i.jsxs(Vc, { style: { gap: 16, flexDirection: r ? "column" : "row" }, children: [i.jsx(K.Item, { style: { flex: 1 }, name: "Observaciones", label: i.jsx(qt, { strong: !0, children: "Observaciones" }), initialValue: t?.Observaciones, children: i.jsx(Ja, { autoSize: !0, size: "large", disabled: e, style: { width: "100%" } }) }), i.jsx(K.Item, { name: "Notas", style: { flex: 1 }, label: i.jsx(qt, { strong: !0, children: "Notas" }), initialValue: t?.Notas, children: i.jsx(av, { autoSize: !0, size: "large", disabled: e, style: { width: "100%" } }) })] });
}, AF = ({ id: e, Area: t, disabled: r, DocumentData: n }) => {
  const o = ah(Number.parseInt(e || "0", 10), n?.TipoDocumentoId || 0, t || "Ventas"), a = oh(n?.DocumentoId, n?.TipoDocumentoId || 0, t || "Ventas"), [s, c] = k.useState(!1), [l, d] = k.useState([]), [u, f] = k.useState([]), { data: h } = pg({
    Area: t || "venta",
    DocumentId: Number.parseInt(e || "0", 10),
    DocumentoTipoId: n?.TipoDocumentoId || 0
  }), [g, E] = k.useState({ open: !1, selectedFile: {} }), v = (C) => {
    const S = C.Data, T = C.ContentType, N = C.FileName, V = atob(S), D = [];
    for (let j = 0; j < V.length; j++)
      D.push(V.charCodeAt(j));
    const x = new Uint8Array(D), O = new Blob([x], { type: T }), w = document.createElement("a");
    w.href = URL.createObjectURL(O), w.download = N, w.click();
  }, m = (C) => new Promise((S, T) => {
    const N = new FileReader();
    N.onload = function() {
      S(N.result);
    }, N.onerror = function(V) {
      T(V);
    }, N.readAsDataURL(C.originFileObj);
  }), y = async () => {
    const C = l?.map((V) => V), S = l?.map((V) => m(V)), T = await Promise.all(S), N = {
      DocumentoId: Number.parseInt(e ?? "0") || 0,
      TipoDocumentoId: n?.TipoDocumentoId || 0,
      FilesData: l?.map((V, D) => ({
        IsTemp: !1,
        Data: T[D],
        ArchivoNombre: V.name,
        ContentType: V.type || "",
        FileSize: V.originFileObj?.size || 0
      }))
    };
    await se.promise(a.mutateAsync(N), {
      loading: "Guardando archivos",
      error: "Error guardando archivos",
      success: () => (f((V) => [...V, ...C]), "Archivos guardados correctamente")
    });
  }, I = async (C, S) => {
    await se.promise(o.mutateAsync(C), {
      loading: "Borrando el documento",
      error: "Error borrando documento",
      success: () => (f((T) => T?.filter((V) => V.fileName !== S)), "Documento eliminado correctamente")
    });
  }, b = [
    {
      width: "1%",
      key: "Archivo",
      align: "center",
      title: "Archivo",
      dataIndex: "Archivo",
      render: () => i.jsx(me, { colorPrimary: !0, size: "large", name: "folder-filled" })
    },
    {
      width: "20%",
      title: "Nombre",
      key: "FileName",
      dataIndex: "FileName"
    },
    {
      width: "10%",
      title: "Extensión",
      key: "ContentType",
      dataIndex: "ContentType"
    },
    {
      width: "15%",
      key: "actions",
      align: "center",
      title: "Acciones",
      render: (C, S) => i.jsxs(ir, { children: [i.jsx(me, { colorPrimary: !0, name: "download", onClick: () => {
        Or.info("Se va a descargar el archivo"), v(S);
      } }), i.jsx(me, { name: "trash", color: "#ff4d4f", onClick: () => r ? null : E({ open: !0, selectedFile: S }) })] })
    }
  ];
  return i.jsxs(i.Fragment, { children: [i.jsx(K.Item, { children: i.jsx("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }, children: i.jsx(wt, { ghost: !0, size: "large", type: "primary", onClick: () => r ? null : c(!0), children: "Agregar archivos" }) }) }), i.jsx(mo, { size: "small", dataSource: h, columns: b, loading: a.isPending }), i.jsxs(Rn, { cancelText: "Cancelar", style: { padding: 0 }, okText: "Subir archivos", title: "Agregar archivos", open: s, okButtonProps: { color: "#29AAE0" }, onCancel: () => {
    c(!1), f([]);
  }, onOk: () => {
    c(!1), y(), f([]), d([]);
  }, styles: {
    body: {
      height: 100,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, children: [i.jsx(dv, { multiple: !0, listType: "text", fileList: u, showUploadList: !1, onChange: (C) => d(C.fileList), children: i.jsx(wt, { size: "large", renderLeftIcon: i.jsx(me, { name: "paperclip" }), children: "Clic aquí para agregar archivos" }) }), l.length > 0 ? l?.map((C, S) => i.jsxs(hg, { children: [i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(me, { name: "" }), i.jsx("span", { style: { color: "#29AAE0", fontWeight: "bold" }, children: C.name })] }), i.jsxs("div", { style: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, children: [i.jsx(uv, { color: "#108ee9", style: { marginRight: "5px" }, children: "Sin subir" }), i.jsx(me, { name: "", onClick: () => d((T) => T?.filter((V) => V.fileName !== C.fileName)) })] })] }, S)) : null] }), i.jsx(Rn, { okType: "primary", okText: "Confirmar", cancelText: "Cancelar", open: g.open, okButtonProps: { danger: !0 }, title: "¿Seguro que desea eliminar este archivo?", onCancel: () => E({
    open: !1,
    selectedFile: {}
  }), onOk: () => {
    I(g.selectedFile.FileId, g.selectedFile.FileName), E({
      open: !1,
      selectedFile: {}
    });
  }, children: i.jsx(zo, { type: "error", description: "Esta acción no podrá deshacerse.", message: g.selectedFile.FileName }) })] });
}, _F = ({ Area: e, DocumentData: t }) => {
  const { docTypes: r } = et(), n = {
    documentoId: t?.DocumentoId || 0,
    table: t?.TipoDocumentoId === r.Factura_de_venta ? "Facturas-Ventas" : t?.TipoDocumentoId === r.Factura_de_compra ? "Facturas-Compras" : t?.TipoDocumentoId === r.Cotizacion ? "Cotizaciones" : t?.TipoDocumentoId === r.Orden_de_compra ? "Ordenes-Compras" : t?.TipoDocumentoId === r.Factura_de_compra ? "Facturas-Compras" : t?.TipoDocumentoId === r.Conduce && e === "Ventas" ? "ConducesVentas" : t?.TipoDocumentoId === r.Conduce && e === "Compras" ? "ConducesCompras" : [
      r.Nota_de_debito,
      r.Nota_de_debito
    ].includes(t?.TipoDocumentoId || 0) && e === "Compras" ? "Notas-Debitos" : [
      r.Nota_de_debito,
      r.Nota_de_debito
    ].includes(t?.TipoDocumentoId || 0) && e === "Ventas" ? "Notas-Ventas" : ""
  }, o = sS({
    ...n
  }), a = ai(), s = [
    {
      width: 150,
      key: "Secuencia",
      title: "Secuencia",
      dataIndex: "Secuencia",
      sorter: (c, l) => c.DocumentoNumero.localeCompare(l.DocumentoNumero),
      render: (c, l) => i.jsx(nr, { onClick: () => a(l.TipoDocumentoId, l.DocumentoId, e), children: l.DocumentoNumero })
    },
    {
      width: 250,
      title: "Tipo de documento",
      key: "TipoDocumentoNombre",
      dataIndex: "TipoDocumentoNombre"
    },
    {
      width: 200,
      key: "Fecha",
      title: "Fecha",
      dataIndex: "Fecha",
      render: (c) => i.jsx(i.Fragment, { children: c ? bt(c).format("YYYY-MM-DD") : "N/A" })
    },
    {
      key: "Notas",
      title: "Notas",
      dataIndex: "Notas",
      render: (c) => i.jsx("span", { children: c !== "" ? c : "N/A" })
    },
    {
      width: 250,
      title: "Estado",
      key: "EstadoNombre",
      dataIndex: "EstadoNombre"
    }
  ];
  return i.jsx(mo, { scroll: { x: 800 }, columns: s, dataSource: o.data, loading: o.isLoading });
}, rn = ({ tax: e, area: t, alert: r, loading: n, disabled: o, clientId: a, dataSource: s, formConfig: c, DocumentData: l, formInstance: d, setDataSource: u, detailInConflict: f, setDetailInConflict: h }) => {
  const { id: g } = _t(), [E] = Os(), { docTypes: v, statesValues: m } = et(), y = [
    {
      key: "1",
      label: i.jsx(Eo, { text: "Productos", icon: i.jsx(me, { name: "shopping-cart" }) }),
      children: i.jsx(PF, { tax: e, form: E, loading: n, disabled: o, dataSource: s, DocumentData: l, setDataSource: u, detailInConflict: f, setDetailInConflict: h })
    },
    ...l?.TipoDocumentoId == v.Cotizacion || l?.TipoDocumentoId == v.Factura_de_venta ? [
      {
        key: "2",
        children: i.jsx(Qt, { loading: n, children: i.jsx(L1, { disabled: o, clientId: a, DocumentData: l, formInstance: d }) }),
        label: i.jsxs(i.Fragment, { children: [r ? i.jsx(zo, { type: "warning", message: "Campos faltantes" }) : void 0, i.jsx(Eo, { size: 14, text: "Entrega", icon: i.jsx(me, { name: "truck-delivery" }) })] })
      }
    ] : [],
    {
      key: "3",
      label: i.jsx(Eo, { size: 14, text: "Observaciones", icon: i.jsx(me, { name: "clipboard-text" }) }),
      children: i.jsx(Qt, { loading: n, children: i.jsx($F, { disabled: o, DocumentData: l }) })
    },
    {
      key: "4",
      label: i.jsx(Eo, { size: 14, icon: i.jsx(me, { name: "folder" }), text: "Documentos de referencia" }),
      children: i.jsx(Qt, { loading: n, children: i.jsx(_F, { Area: t, DocumentData: l }) })
    },
    {
      key: "5",
      label: i.jsx(Eo, { size: 14, text: "Archivos", icon: i.jsx(me, { name: "file" }) }),
      children: i.jsx(Qt, { loading: n, children: i.jsx(AF, { id: g, Area: t, disabled: o, DocumentData: l }) })
    },
    {
      key: "6",
      label: i.jsx(Eo, { size: 14, text: "Información básica", icon: i.jsx(me, { name: "file-dots" }) }),
      children: i.jsx(Qt, { loading: n, children: i.jsx(jF, { DocumentData: l, formConfigInstance: c, enabled: l?.EstadoId == m.Borrador }) })
    }
  ];
  return i.jsx(iv, { type: "card", size: "large", items: y, defaultActiveKey: "1", tabBarStyle: { margin: 0 } });
}, Un = (e, t, r) => [
  {
    Importe: e?.reduce((n, o) => n + o?.SubTotal, 0),
    Flete: e?.reduce((n, o) => n + (o?.Flete ? o?.Flete : 0), 0),
    SubTotal: e?.reduce((n, o) => n + (o?.SubTotal ? o?.SubTotal : 0), 0),
    Impuestos: e?.reduce((n, o) => n + (o?.Impuesto ? o?.Impuesto : 0), 0),
    Descuento: e?.reduce((n, o) => n + (o?.Descuento ? o?.Descuento : 0), 0),
    Retenciones: t?.reduce((n, o) => o.ImpuestoBaseId === null ? n + e?.reduce((a, s) => a + (s.SubTotal ? s.SubTotal : 0) * (o.Porcentaje / 100), 0) : n + e?.reduce((a, s) => a + (s.ImpuestoId && s.ImpuestoId === o.ImpuestoBaseId ? (s.Impuesto ? s.Impuesto : 0) * (o.Porcentaje / 100) : 0), 0), 0),
    Total: e?.reduce((n, o) => n + (o.Total ? o.Total : 0), 0) - t?.reduce((n, o) => o.ImpuestoBaseId === null ? n + e?.reduce((a, s) => a + (s.SubTotal ? s.SubTotal : 0) * (o.Porcentaje / 100), 0) : n + e?.reduce((a, s) => a + (s.ImpuestoId && s.ImpuestoId === o.ImpuestoBaseId ? (s.Impuesto ? s.Impuesto : 0) * (o.Porcentaje / 100) : 0), 0), 0) + (r || 0)
  }
];
function MF(e) {
  if (typeof e == "function")
    return e;
  const t = lo(e);
  return t.length <= 1 ? t[0] : t;
}
const wg = () => {
  const {
    status: e,
    errors: t = [],
    warnings: r = []
  } = Ir(Ho);
  if (process.env.NODE_ENV !== "production") {
    const n = ur("Form.Item");
    process.env.NODE_ENV !== "production" && n(e !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus");
  }
  return {
    status: e,
    errors: t,
    warnings: r
  };
};
wg.Context = Ho;
const LF = wg;
function VF(e) {
  const [t, r] = p.useState(e), n = Wt(null), o = Wt([]), a = Wt(!1);
  p.useEffect(() => (a.current = !1, () => {
    a.current = !0, Nr.cancel(n.current), n.current = null;
  }), []);
  function s(c) {
    a.current || (n.current === null && (o.current = [], n.current = Nr(() => {
      n.current = null, r((l) => {
        let d = l;
        return o.current.forEach((u) => {
          d = u(d);
        }), d;
      });
    })), o.current.push(c));
  }
  return [t, s];
}
function zF() {
  const {
    itemRef: e
  } = p.useContext(An), t = p.useRef({});
  function r(n, o) {
    const a = o && typeof o == "object" && o.ref, s = n.join("_");
    return (t.current.name !== s || t.current.originRef !== a) && (t.current.name = s, t.current.originRef = a, t.current.ref = po(e(n), a)), t.current.ref;
  }
  return r;
}
const BF = /* @__PURE__ */ Ha({}), Tg = BF, kF = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, UF = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, qF = (e, t) => {
  const {
    prefixCls: r,
    componentCls: n,
    gridColumns: o
  } = e, a = {};
  for (let s = o; s >= 0; s--)
    s === 0 ? (a[`${n}${t}-${s}`] = {
      display: "none"
    }, a[`${n}-push-${s}`] = {
      insetInlineStart: "auto"
    }, a[`${n}-pull-${s}`] = {
      insetInlineEnd: "auto"
    }, a[`${n}${t}-push-${s}`] = {
      insetInlineStart: "auto"
    }, a[`${n}${t}-pull-${s}`] = {
      insetInlineEnd: "auto"
    }, a[`${n}${t}-offset-${s}`] = {
      marginInlineStart: 0
    }, a[`${n}${t}-order-${s}`] = {
      order: 0
    }) : (a[`${n}${t}-${s}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${s / o * 100}%`,
        maxWidth: `${s / o * 100}%`
      }
    ], a[`${n}${t}-push-${s}`] = {
      insetInlineStart: `${s / o * 100}%`
    }, a[`${n}${t}-pull-${s}`] = {
      insetInlineEnd: `${s / o * 100}%`
    }, a[`${n}${t}-offset-${s}`] = {
      marginInlineStart: `${s / o * 100}%`
    }, a[`${n}${t}-order-${s}`] = {
      order: s
    });
  return a[`${n}${t}-flex`] = {
    flex: `var(--${r}${t}-flex)`
  }, a;
}, Al = (e, t) => qF(e, t), HF = (e, t, r) => ({
  [`@media (min-width: ${Me(t)})`]: Object.assign({}, Al(e, r))
}), WF = () => ({}), GF = () => ({}), KF = Cn("Grid", kF, WF), YF = Cn("Grid", (e) => {
  const t = fr(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), r = {
    "-sm": t.screenSMMin,
    "-md": t.screenMDMin,
    "-lg": t.screenLGMin,
    "-xl": t.screenXLMin,
    "-xxl": t.screenXXLMin
  };
  return [UF(t), Al(t, ""), Al(t, "-xs"), Object.keys(r).map((n) => HF(t, r[n], n)).reduce((n, o) => Object.assign(Object.assign({}, n), o), {})];
}, GF);
var QF = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Ff(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const XF = ["xs", "sm", "md", "lg", "xl", "xxl"], Fg = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: n
  } = p.useContext(Mt), {
    gutter: o,
    wrap: a
  } = p.useContext(Tg), {
    prefixCls: s,
    span: c,
    order: l,
    offset: d,
    push: u,
    pull: f,
    className: h,
    children: g,
    flex: E,
    style: v
  } = e, m = QF(e, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), y = r("col", s), [I, b, C] = YF(y), S = {};
  let T = {};
  XF.forEach((D) => {
    let x = {};
    const O = e[D];
    typeof O == "number" ? x.span = O : typeof O == "object" && (x = O || {}), delete m[D], T = Object.assign(Object.assign({}, T), {
      [`${y}-${D}-${x.span}`]: x.span !== void 0,
      [`${y}-${D}-order-${x.order}`]: x.order || x.order === 0,
      [`${y}-${D}-offset-${x.offset}`]: x.offset || x.offset === 0,
      [`${y}-${D}-push-${x.push}`]: x.push || x.push === 0,
      [`${y}-${D}-pull-${x.pull}`]: x.pull || x.pull === 0,
      [`${y}-rtl`]: n === "rtl"
    }), x.flex && (T[`${y}-${D}-flex`] = !0, S[`--${y}-${D}-flex`] = Ff(x.flex));
  });
  const N = we(y, {
    [`${y}-${c}`]: c !== void 0,
    [`${y}-order-${l}`]: l,
    [`${y}-offset-${d}`]: d,
    [`${y}-push-${u}`]: u,
    [`${y}-pull-${f}`]: f
  }, h, T, b, C), V = {};
  if (o && o[0] > 0) {
    const D = o[0] / 2;
    V.paddingLeft = D, V.paddingRight = D;
  }
  return E && (V.flex = Ff(E), a === !1 && !V.minWidth && (V.minWidth = 0)), I(/* @__PURE__ */ p.createElement("div", Object.assign({}, m, {
    style: Object.assign(Object.assign(Object.assign({}, V), v), S),
    className: N,
    ref: t
  }), g));
});
process.env.NODE_ENV !== "production" && (Fg.displayName = "Col");
const Og = Fg, qa = ["xxl", "xl", "lg", "md", "sm", "xs"], ZF = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), JF = (e) => {
  const t = e, r = [].concat(qa).reverse();
  return r.forEach((n, o) => {
    const a = n.toUpperCase(), s = `screen${a}Min`, c = `screen${a}`;
    if (!(t[s] <= t[c]))
      throw new Error(`${s}<=${c} fails : !(${t[s]}<=${t[c]})`);
    if (o < r.length - 1) {
      const l = `screen${a}Max`;
      if (!(t[c] <= t[l]))
        throw new Error(`${c}<=${l} fails : !(${t[c]}<=${t[l]})`);
      const u = `screen${r[o + 1].toUpperCase()}Min`;
      if (!(t[l] <= t[u]))
        throw new Error(`${l}<=${u} fails : !(${t[l]}<=${t[u]})`);
    }
  }), e;
};
function eO() {
  const [, e] = Lr(), t = ZF(JF(e));
  return k.useMemo(() => {
    const r = /* @__PURE__ */ new Map();
    let n = -1, o = {};
    return {
      matchHandlers: {},
      dispatch(a) {
        return o = a, r.forEach((s) => s(o)), r.size >= 1;
      },
      subscribe(a) {
        return r.size || this.register(), n += 1, r.set(n, a), a(o), n;
      },
      unsubscribe(a) {
        r.delete(a), r.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((a) => {
          const s = t[a], c = this.matchHandlers[s];
          c?.mql.removeListener(c?.listener);
        }), r.clear();
      },
      register() {
        Object.keys(t).forEach((a) => {
          const s = t[a], c = (d) => {
            let {
              matches: u
            } = d;
            this.dispatch(Object.assign(Object.assign({}, o), {
              [a]: u
            }));
          }, l = window.matchMedia(s);
          l.addListener(c), this.matchHandlers[s] = {
            mql: l,
            listener: c
          }, c(l);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
var tO = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Of(e, t) {
  const [r, n] = p.useState(typeof e == "string" ? e : ""), o = () => {
    if (typeof e == "string" && n(e), typeof e == "object")
      for (let a = 0; a < qa.length; a++) {
        const s = qa[a];
        if (!t[s])
          continue;
        const c = e[s];
        if (c !== void 0) {
          n(c);
          return;
        }
      }
  };
  return p.useEffect(() => {
    o();
  }, [JSON.stringify(e), t]), r;
}
const Ng = /* @__PURE__ */ p.forwardRef((e, t) => {
  const {
    prefixCls: r,
    justify: n,
    align: o,
    className: a,
    style: s,
    children: c,
    gutter: l = 0,
    wrap: d
  } = e, u = tO(e, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: f,
    direction: h
  } = p.useContext(Mt), [g, E] = p.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), [v, m] = p.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), y = Of(o, v), I = Of(n, v), b = p.useRef(l), C = eO();
  p.useEffect(() => {
    const R = C.subscribe((P) => {
      m(P);
      const z = b.current || 0;
      (!Array.isArray(z) && typeof z == "object" || Array.isArray(z) && (typeof z[0] == "object" || typeof z[1] == "object")) && E(P);
    });
    return () => C.unsubscribe(R);
  }, []);
  const S = () => {
    const R = [void 0, void 0];
    return (Array.isArray(l) ? l : [l, void 0]).forEach((z, F) => {
      if (typeof z == "object")
        for (let L = 0; L < qa.length; L++) {
          const M = qa[L];
          if (g[M] && z[M] !== void 0) {
            R[F] = z[M];
            break;
          }
        }
      else
        R[F] = z;
    }), R;
  }, T = f("row", r), [N, V, D] = KF(T), x = S(), O = we(T, {
    [`${T}-no-wrap`]: d === !1,
    [`${T}-${I}`]: I,
    [`${T}-${y}`]: y,
    [`${T}-rtl`]: h === "rtl"
  }, a, V, D), w = {}, j = x[0] != null && x[0] > 0 ? x[0] / -2 : void 0;
  j && (w.marginLeft = j, w.marginRight = j), [, w.rowGap] = x;
  const [$, _] = x, A = p.useMemo(() => ({
    gutter: [$, _],
    wrap: d
  }), [$, _, d]);
  return N(/* @__PURE__ */ p.createElement(Tg.Provider, {
    value: A
  }, /* @__PURE__ */ p.createElement("div", Object.assign({}, u, {
    className: O,
    style: Object.assign(Object.assign({}, w), s),
    ref: t
  }), c)));
});
process.env.NODE_ENV !== "production" && (Ng.displayName = "Row");
const rO = Ng;
function ls(e) {
  const [t, r] = p.useState(e);
  return p.useEffect(() => {
    const n = setTimeout(() => {
      r(e);
    }, e.length ? 0 : 10);
    return () => {
      clearTimeout(n);
    };
  }, [e]), t;
}
const Nf = [];
function Mc(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof e == "string" ? e : `${t}-${n}`,
    error: e,
    errorStatus: r
  };
}
const nO = (e) => {
  let {
    help: t,
    helpStatus: r,
    errors: n = Nf,
    warnings: o = Nf,
    className: a,
    fieldId: s,
    onVisibleChanged: c
  } = e;
  const {
    prefixCls: l
  } = p.useContext($p), d = `${l}-item-explain`, u = xs(l), [f, h, g] = hd(l, u), E = $a(() => Nl(l), [l]), v = ls(n), m = ls(o), y = p.useMemo(() => t != null ? [Mc(t, "help", r)] : [].concat(Ne(v.map((b, C) => Mc(b, "error", "error", C))), Ne(m.map((b, C) => Mc(b, "warning", "warning", C)))), [t, r, v, m]), I = {};
  return s && (I.id = `${s}_help`), f(/* @__PURE__ */ p.createElement(Bn, {
    motionDeadline: E.motionDeadline,
    motionName: `${l}-show-help`,
    visible: !!y.length,
    onVisibleChanged: c
  }, (b) => {
    const {
      className: C,
      style: S
    } = b;
    return /* @__PURE__ */ p.createElement("div", Object.assign({}, I, {
      className: we(d, C, g, u, a, h),
      style: S,
      role: "alert"
    }), /* @__PURE__ */ p.createElement(Ep, Object.assign({
      keys: y
    }, Nl(l), {
      motionName: `${l}-show-help-item`,
      component: !1
    }), (T) => {
      const {
        key: N,
        error: V,
        errorStatus: D,
        className: x,
        style: O
      } = T;
      return /* @__PURE__ */ p.createElement("div", {
        key: N,
        className: we(x, {
          [`${d}-${D}`]: D
        }),
        style: O
      }, V);
    }));
  }));
}, oO = nO, aO = (e) => {
  const {
    formItemCls: t
  } = e;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${t}-control`]: {
        display: "flex"
      }
    }
  };
}, iO = mp(["Form", "item-item"], (e, t) => {
  let {
    rootPrefixCls: r
  } = t;
  const n = vh(e, r);
  return [aO(n)];
}), sO = (e) => {
  const {
    prefixCls: t,
    status: r,
    wrapperCol: n,
    children: o,
    errors: a,
    warnings: s,
    _internalItemRender: c,
    extra: l,
    help: d,
    fieldId: u,
    marginBottom: f,
    onErrorVisibleChanged: h
  } = e, g = `${t}-item`, E = p.useContext(An), v = n || E.wrapperCol || {}, m = we(`${g}-control`, v.className), y = p.useMemo(() => Object.assign({}, E), [E]);
  delete y.labelCol, delete y.wrapperCol;
  const I = /* @__PURE__ */ p.createElement("div", {
    className: `${g}-control-input`
  }, /* @__PURE__ */ p.createElement("div", {
    className: `${g}-control-input-content`
  }, o)), b = p.useMemo(() => ({
    prefixCls: t,
    status: r
  }), [t, r]), C = f !== null || a.length || s.length ? /* @__PURE__ */ p.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ p.createElement($p.Provider, {
    value: b
  }, /* @__PURE__ */ p.createElement(oO, {
    fieldId: u,
    errors: a,
    warnings: s,
    help: d,
    helpStatus: r,
    className: `${g}-explain-connected`,
    onVisibleChanged: h
  })), !!f && /* @__PURE__ */ p.createElement("div", {
    style: {
      width: 0,
      height: f
    }
  })) : null, S = {};
  u && (S.id = `${u}_extra`);
  const T = l ? /* @__PURE__ */ p.createElement("div", Object.assign({}, S, {
    className: `${g}-extra`
  }), l) : null, N = c && c.mark === "pro_table_render" && c.render ? c.render(e, {
    input: I,
    errorList: C,
    extra: T
  }) : /* @__PURE__ */ p.createElement(p.Fragment, null, I, C, T);
  return /* @__PURE__ */ p.createElement(An.Provider, {
    value: y
  }, /* @__PURE__ */ p.createElement(Og, Object.assign({}, v, {
    className: m
  }), N), /* @__PURE__ */ p.createElement(iO, {
    prefixCls: t
  }));
}, cO = sO;
var lO = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const dO = lO;
var Rg = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: dO
  }));
};
process.env.NODE_ENV !== "production" && (Rg.displayName = "QuestionCircleOutlined");
const uO = /* @__PURE__ */ p.forwardRef(Rg);
var fO = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function mO(e) {
  return e ? typeof e == "object" && !/* @__PURE__ */ p.isValidElement(e) ? e : {
    title: e
  } : null;
}
const pO = (e) => {
  let {
    prefixCls: t,
    label: r,
    htmlFor: n,
    labelCol: o,
    labelAlign: a,
    colon: s,
    required: c,
    requiredMark: l,
    tooltip: d
  } = e;
  var u;
  const [f] = ed("Form"), {
    vertical: h,
    labelAlign: g,
    labelCol: E,
    labelWrap: v,
    colon: m
  } = p.useContext(An);
  if (!r)
    return null;
  const y = o || E || {}, I = a || g, b = `${t}-item-label`, C = we(b, I === "left" && `${b}-left`, y.className, {
    [`${b}-wrap`]: !!v
  });
  let S = r;
  const T = s === !0 || m !== !1 && s !== !1;
  T && !h && typeof r == "string" && r.trim() !== "" && (S = r.replace(/[:|：]\s*$/, ""));
  const V = mO(d);
  if (V) {
    const {
      icon: w = /* @__PURE__ */ p.createElement(uO, null)
    } = V, j = fO(V, ["icon"]), $ = /* @__PURE__ */ p.createElement(Qo, Object.assign({}, j), /* @__PURE__ */ p.cloneElement(w, {
      className: `${t}-item-tooltip`,
      title: "",
      onClick: (_) => {
        _.preventDefault();
      },
      tabIndex: null
    }));
    S = /* @__PURE__ */ p.createElement(p.Fragment, null, S, $);
  }
  const D = l === "optional", x = typeof l == "function";
  x ? S = l(S, {
    required: !!c
  }) : D && !c && (S = /* @__PURE__ */ p.createElement(p.Fragment, null, S, /* @__PURE__ */ p.createElement("span", {
    className: `${t}-item-optional`,
    title: ""
  }, f?.optional || ((u = $n.Form) === null || u === void 0 ? void 0 : u.optional))));
  const O = we({
    [`${t}-item-required`]: c,
    [`${t}-item-required-mark-optional`]: D || x,
    [`${t}-item-no-colon`]: !T
  });
  return /* @__PURE__ */ p.createElement(Og, Object.assign({}, y, {
    className: C
  }), /* @__PURE__ */ p.createElement("label", {
    htmlFor: n,
    className: O,
    title: typeof r == "string" ? r : ""
  }, S));
}, hO = pO;
var gO = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const vO = gO;
var Pg = function(t, r) {
  return /* @__PURE__ */ p.createElement(or, mt({}, t, {
    ref: r,
    icon: vO
  }));
};
process.env.NODE_ENV !== "production" && (Pg.displayName = "ExclamationCircleFilled");
const yO = /* @__PURE__ */ p.forwardRef(Pg), bO = {
  success: qh,
  warning: yO,
  error: kl,
  validating: os
};
function jg(e) {
  let {
    children: t,
    errors: r,
    warnings: n,
    hasFeedback: o,
    validateStatus: a,
    prefixCls: s,
    meta: c,
    noStyle: l
  } = e;
  const d = `${s}-item`, {
    feedbackIcons: u
  } = p.useContext(An), f = ph(r, n, c, null, !!o, a), {
    isFormItemInput: h,
    status: g,
    hasFeedback: E,
    feedbackIcon: v
  } = p.useContext(Ho), m = p.useMemo(() => {
    var y;
    let I;
    if (o) {
      const C = o !== !0 && o.icons || u, S = f && ((y = C?.({
        status: f,
        errors: r,
        warnings: n
      })) === null || y === void 0 ? void 0 : y[f]), T = f && bO[f];
      I = S !== !1 && T ? /* @__PURE__ */ p.createElement("span", {
        className: we(`${d}-feedback-icon`, `${d}-feedback-icon-${f}`)
      }, S || /* @__PURE__ */ p.createElement(T, null)) : null;
    }
    const b = {
      status: f || "",
      errors: r,
      warnings: n,
      hasFeedback: !!o,
      feedbackIcon: I,
      isFormItemInput: !0
    };
    return l && (b.status = (f ?? g) || "", b.isFormItemInput = h, b.hasFeedback = !!(o ?? E), b.feedbackIcon = o !== void 0 ? b.feedbackIcon : v), b;
  }, [f, o, l, h, g]);
  return /* @__PURE__ */ p.createElement(Ho.Provider, {
    value: m
  }, t);
}
var CO = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function IO(e) {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: o,
    help: a,
    errors: s,
    warnings: c,
    validateStatus: l,
    meta: d,
    hasFeedback: u,
    hidden: f,
    children: h,
    fieldId: g,
    required: E,
    isRequired: v,
    onSubItemMetaChange: m
  } = e, y = CO(e, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange"]), I = `${t}-item`, {
    requiredMark: b
  } = p.useContext(An), C = p.useRef(null), S = ls(s), T = ls(c), N = a != null, V = !!(N || s.length || c.length), D = !!C.current && gd(C.current), [x, O] = p.useState(null);
  jt(() => {
    if (V && C.current) {
      const A = getComputedStyle(C.current);
      O(parseInt(A.marginBottom, 10));
    }
  }, [V, D]);
  const w = (A) => {
    A || O(null);
  }, $ = function() {
    let A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const R = A ? S : d.errors, P = A ? T : d.warnings;
    return ph(R, P, d, "", !!u, l);
  }(), _ = we(I, r, n, {
    [`${I}-with-help`]: N || S.length || T.length,
    // Status
    [`${I}-has-feedback`]: $ && u,
    [`${I}-has-success`]: $ === "success",
    [`${I}-has-warning`]: $ === "warning",
    [`${I}-has-error`]: $ === "error",
    [`${I}-is-validating`]: $ === "validating",
    [`${I}-hidden`]: f
  });
  return /* @__PURE__ */ p.createElement("div", {
    className: _,
    style: o,
    ref: C
  }, /* @__PURE__ */ p.createElement(rO, Object.assign({
    className: `${I}-row`
  }, Ya(y, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ p.createElement(hO, Object.assign({
    htmlFor: g
  }, e, {
    requiredMark: b,
    required: E ?? v,
    prefixCls: t
  })), /* @__PURE__ */ p.createElement(cO, Object.assign({}, e, d, {
    errors: S,
    warnings: T,
    prefixCls: t,
    status: $,
    help: a,
    marginBottom: x,
    onErrorVisibleChanged: w
  }), /* @__PURE__ */ p.createElement(jp.Provider, {
    value: m
  }, /* @__PURE__ */ p.createElement(jg, {
    prefixCls: t,
    meta: d,
    errors: d.errors,
    warnings: d.warnings,
    hasFeedback: u,
    // Already calculated
    validateStatus: $
  }, h)))), !!x && /* @__PURE__ */ p.createElement("div", {
    className: `${I}-margin-offset`,
    style: {
      marginBottom: -x
    }
  }));
}
const xO = "__SPLIT__";
function SO(e, t) {
  const r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every((o) => {
    const a = e[o], s = t[o];
    return a === s || typeof a == "function" || typeof s == "function";
  });
}
const EO = /* @__PURE__ */ p.memo((e) => {
  let {
    children: t
  } = e;
  return t;
}, (e, t) => SO(e.control, t.control) && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((r, n) => r === t.childProps[n]));
function Rf() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function DO(e) {
  const {
    name: t,
    noStyle: r,
    className: n,
    dependencies: o,
    prefixCls: a,
    shouldUpdate: s,
    rules: c,
    children: l,
    required: d,
    label: u,
    messageVariables: f,
    trigger: h = "onChange",
    validateTrigger: g,
    hidden: E,
    help: v
  } = e, {
    getPrefixCls: m
  } = p.useContext(Mt), {
    name: y
  } = p.useContext(An), I = MF(l), b = typeof I == "function", C = p.useContext(jp), {
    validateTrigger: S
  } = p.useContext(uo), T = g !== void 0 ? g : S, N = t != null, V = m("form", a), D = xs(V), [x, O, w] = hd(V, D), j = ur("Form.Item");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && j(t !== null, "usage", "`null` is passed as `name` property");
  const $ = p.useContext(Va), _ = p.useRef(), [A, R] = VF({}), [P, z] = ao(() => Rf()), F = (de) => {
    const Z = $?.getKey(de.name);
    if (z(de.destroy ? Rf() : de, !0), r && v !== !1 && C) {
      let ce = de.name;
      if (de.destroy)
        ce = _.current || ce;
      else if (Z !== void 0) {
        const [Y, he] = Z;
        ce = [Y].concat(Ne(he)), _.current = ce;
      }
      C(de, ce);
    }
  }, L = (de, Z) => {
    R((ce) => {
      const Y = Object.assign({}, ce), ve = [].concat(Ne(de.name.slice(0, -1)), Ne(Z)).join(xO);
      return de.destroy ? delete Y[ve] : Y[ve] = de, Y;
    });
  }, [M, B] = p.useMemo(() => {
    const de = Ne(P.errors), Z = Ne(P.warnings);
    return Object.values(A).forEach((ce) => {
      de.push.apply(de, Ne(ce.errors || [])), Z.push.apply(Z, Ne(ce.warnings || []));
    }), [de, Z];
  }, [A, P.errors, P.warnings]), W = zF();
  function ee(de, Z, ce) {
    return r && !E ? /* @__PURE__ */ p.createElement(jg, {
      prefixCls: V,
      hasFeedback: e.hasFeedback,
      validateStatus: e.validateStatus,
      meta: P,
      errors: M,
      warnings: B,
      noStyle: !0
    }, de) : /* @__PURE__ */ p.createElement(IO, Object.assign({
      key: "row"
    }, e, {
      className: we(n, w, D, O),
      prefixCls: V,
      fieldId: Z,
      isRequired: ce,
      errors: M,
      warnings: B,
      meta: P,
      onSubItemMetaChange: L
    }), de);
  }
  if (!N && !b && !o)
    return x(ee(I));
  let te = {};
  return typeof u == "string" ? te.label = u : t && (te.label = String(t)), f && (te = Object.assign(Object.assign({}, te), f)), x(/* @__PURE__ */ p.createElement(id, Object.assign({}, e, {
    messageVariables: te,
    trigger: h,
    validateTrigger: T,
    onMetaChange: F
  }), (de, Z, ce) => {
    const Y = Pa(t).length && Z ? Z.name : [], he = mh(Y, y), ve = d !== void 0 ? d : !!(c && c.some((Fe) => {
      if (Fe && typeof Fe == "object" && Fe.required && !Fe.warningOnly)
        return !0;
      if (typeof Fe == "function") {
        const He = Fe(ce);
        return He && He.required && !He.warningOnly;
      }
      return !1;
    })), ue = Object.assign({}, de);
    let le = null;
    if (process.env.NODE_ENV !== "production" && j(!(s && o), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(I) && N)
      process.env.NODE_ENV !== "production" && j(!1, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), le = I;
    else if (b && (!(s || o) || N))
      process.env.NODE_ENV !== "production" && j(!!(s || o), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && j(!N, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (o && !b && !N)
      process.env.NODE_ENV !== "production" && j(!1, "usage", "Must set `name` or use a render function when `dependencies` is set.");
    else if (Yo(I)) {
      process.env.NODE_ENV !== "production" && j(I.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const Fe = Object.assign(Object.assign({}, I.props), ue);
      if (Fe.id || (Fe.id = he), v || M.length > 0 || B.length > 0 || e.extra) {
        const ie = [];
        (v || M.length > 0) && ie.push(`${he}_help`), e.extra && ie.push(`${he}_extra`), Fe["aria-describedby"] = ie.join(" ");
      }
      M.length > 0 && (Fe["aria-invalid"] = "true"), ve && (Fe["aria-required"] = "true"), Jo(I) && (Fe.ref = W(Y, I)), new Set([].concat(Ne(Pa(h)), Ne(Pa(T)))).forEach((ie) => {
        Fe[ie] = function() {
          for (var ge, be, Ie, Pe, Le, Ve = arguments.length, _e = new Array(Ve), ut = 0; ut < Ve; ut++)
            _e[ut] = arguments[ut];
          (Ie = ue[ie]) === null || Ie === void 0 || (ge = Ie).call.apply(ge, [ue].concat(_e)), (Le = (Pe = I.props)[ie]) === null || Le === void 0 || (be = Le).call.apply(be, [Pe].concat(_e));
        };
      });
      const We = [Fe["aria-required"], Fe["aria-invalid"], Fe["aria-describedby"]];
      le = /* @__PURE__ */ p.createElement(EO, {
        control: ue,
        update: I,
        childProps: We
      }, fo(I, Fe));
    } else
      b && (s || o) && !N ? le = I(ce) : (process.env.NODE_ENV !== "production" && j(!Y.length, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), le = I);
    return ee(le, he, ve);
  }));
}
const $g = DO;
$g.useStatus = LF;
const wO = $g, In = Ee(Ke)`
	gap: 16px;
	overflow: hidden;
	align-items: center;
	flex-wrap: wrap;

	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: column;
		overflow: unset;
	}
`, xn = Ee(Ke)`
	flex-direction: column;
	gap: 24px;
	flex: 3;
	overflow-y: auto;
	height: 100%;

	@media screen and (${st.maxDevice.tablet}) {
		overflow: unset;
		width: 100%;
	}
`, Cr = Ee(Ke)`
	width: 100%;
	gap: 16px;
	@media screen and (${st.maxDevice.laptop}) {
		flex-direction: column;
	}

	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: row;
	}
	@media screen and (${st.maxDevice.mobileL}) {
		flex-direction: column;
	}
`, Ut = Ee(at)`
	width: 100%;
`;
Ee(Ke)`
	width: 100%;
	flex-direction: column;
	gap: 16px;
	@media screen and (${st.maxDevice.tablet}) {
		flex-direction: row;
		gap: 16px;
	}

	@media screen and (${st.maxDevice.mobileL}) {
		flex-direction: column;
	}
`;
Ee.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	@media (max-width: 1096px) {
		flex-direction: column;
		width: 100%;
	}
`;
Ee.div`
	display: flex;

	flex-direction: column;
	@media (max-width: 1096px) {
		width: 100%;
	}
`;
Ee(Qt)`
	margin-bottom: 30px;
	box-shadow: 0px 0px 19.66px 0px #0000000d;
	width: 100%;
	min-heigth: 250px;
`;
const Sn = Ee(K)`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
Ee(wO)`
	width: ${(e) => e.width || "100%"};
	min-width: ${(e) => e.minWidth || "181.03px"};
	max-width: ${(e) => e.maxWidth || e.width || "100%"};
`;
const ii = (e) => {
  const t = Hx({
    area: e.area ? e.area : "Compras"
  }), r = t?.data?.map((n) => ({ label: n.Nombre, value: n.TipoNCFId }));
  return i.jsx(K.Item, { style: { width: "100%" }, label: "Tipo de comprobante:", initialValue: e.initialValue, rules: [{ required: !0, message: "Este campo es requerido" }], name: e.area == "Ventas" ? "TipoNCFId" : "TipoFuenteComprobanteId", children: i.jsx(Ht, { size: "large", style: { width: "100%" }, options: r, disabled: t.isLoading || e.disabled, placeholder: `Seleccione ${e.area === "Ventas" ? "el tipo de comprobante" : "el tipo de fuente comprobante"}` }) });
}, TO = ({ CotizacionId: e }) => Ye({
  networkMode: "online",
  enabled: !!e,
  queryKey: ["/Cotizaciones", e],
  queryFn: () => go.getById(e || 0)
}), da = (e) => Ye({
  networkMode: "online",
  enabled: !!e,
  queryKey: [Oe.CLIENTE_INFO_BASICA, e],
  queryFn: () => Vx.getInfoBasicClient?.(e || 0)
}), Pf = {
  column: 1,
  size: "small",
  bordered: !0
}, FO = () => i.jsxs("div", { style: { height: "100%" }, children: [i.jsx(Ki, {}), i.jsx(Ki, {})] }), ua = ({ Open: e, Title: t, setOpen: r, dataContact: n, isContactInfoLoading: o }) => i.jsx(Ga, { width: 340, open: e, title: t, placement: "left", onClose: () => r(!1), children: o ? i.jsx(FO, {}) : i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsxs(Ke, { style: {
  gap: 16,
  alignItems: "center",
  flexDirection: "column"
}, children: [i.jsx(Ml, { size: 150, alt: "client info", src: "/avatar-placeholder.png" }), i.jsx(gn, { level: 4, children: Up(n?.ContactoNombre, n?.ContactoApellido) })] }), i.jsxs(pr, { ...Pf, labelStyle: { textAlign: "center" }, children: [ot(i.jsx(me, { name: "id", hoverablePrimary: !0 }), n?.DNI), ot(i.jsx(me, { hoverablePrimary: !0, name: "device-mobile" }), i.jsx(nr, { href: `tel: ${n?.Telefono}`, children: n?.Telefono })), ot(i.jsx(me, { name: "at", hoverablePrimary: !0 }), i.jsx(nr, { href: `mailto: ${n?.CorreoElectronico}`, children: Dx(`${n?.CorreoElectronico}`, 20) }))] }), i.jsxs(pr, { ...Pf, layout: "vertical", children: [ot("Deuda", tr(Number(n?.Deuda), "RD$")), ot("Crédito disponible", tr(Number(n?.CreditoDisponible), "RD$")), ot("Saldo a favor", tr(Number(n?.SaldoAFavor), "RD$"))] })] }) }), OO = ({ fileId: e }) => {
  const { isLoading: t, data: r } = P1(e);
  return t ? i.jsx(Xo, {}) : i.jsx(Ml, { src: r && r.ContentType?.includes("image") ? r?.Data : "" });
}, fa = ({ Name: e, Label: t, TitleView: r, setSearch: n, contactoId: o, Placeholder: a, initialValue: s, optionsContacts: c, setOpenDrawerIC: l, required: d = !1, isContactsLoading: u }) => {
  const f = (h, g) => (g?.label ?? "").toLowerCase().includes(h.toLowerCase());
  return i.jsxs(Ke, { style: {
    gap: 8,
    width: "95%",
    maxWidth: 500,
    alignItems: "center"
  }, children: [i.jsx(K.Item, { name: e, label: t, style: { width: "100%" }, initialValue: s, rules: [{ required: d, message: "Este campo es requerido" }], children: i.jsx(Ht, { allowClear: !0, showSearch: !0, size: "large", onSearch: n, optionLabelProp: "label", style: { width: "100%" }, placeholder: a, optionFilterProp: "children", filterOption: f, loading: u, children: c?.map((h, g) => i.jsx(Ht.Option, { value: h.value, label: h.fullName + " " + (h.DNI || ""), children: h.value === null ? i.jsxs(ir, { onClick: (E) => E.stopPropagation(), children: [i.jsx(me, { name: "user-x" }), `Sin ${t}`] }) : i.jsx("div", { children: h.ArchivoId ? i.jsxs(ir, { children: [i.jsx(OO, { fileId: h.ArchivoId }), h.fullName + " " + (h.DNI || "")] }) : i.jsxs(ir, { children: [i.jsx(me, { name: "photo-off" }), h.fullName + " " + (h.DNI || "")] }) }) }, g)) }) }), i.jsx(Ar, { color: "#2C874F", title: r, children: i.jsx(me, { name: "eye", touchable: !!o, colorPrimary: !!o, color: o ? void 0 : "#E1E1E1", onClick: () => o && l(!0) }) })] });
}, NO = () => {
  const e = Ue();
  return ke({
    mutationFn: go.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, RO = () => {
  const e = Ue();
  return ke({
    mutationFn: go.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, PO = () => {
  const e = Ue();
  return ke({
    mutationFn: go.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, jO = () => {
  const e = Ue();
  return ke({
    mutationFn: go.clonateQuote,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, Ag = (e) => {
  const t = Ue();
  return ke({
    mutationFn: go.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/Cotizaciones", e]
      });
    }
  });
}, $O = () => {
  const e = Ue();
  return ke({
    mutationFn: go.convertToConduce,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_VENTAS]
      });
    }
  });
}, AO = () => {
  const { id: e } = _t(), t = xt(), [r, n] = k.useState(""), [o] = K.useForm(), [a] = K.useForm(), [s] = K.useForm(), c = K.useWatch("IsFlete", o), l = K.useWatch("Flete", o), d = K.useWatch("ClienteDNITipoId", o), u = K.useWatch("TipoFuenteComprobanteId", o), f = K.useWatch("TipoPlazoId", o), h = K.useWatch("ClienteId", o), { data: g } = Dh(), { docTypes: E, statesValues: v, sourcesVouchersT: m, tiposPlazosValues: y } = et(), b = Zp().data?.map((Z) => ({ value: Z.TipoPlazoId, label: Z.TipoPlazoNombre })), { isError: C, data: S, isLoading: T, isSuccess: N } = TO({
    CotizacionId: Number.parseInt(e ?? "")
  });
  k.useEffect(() => {
    f === y.Contado && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date())), f === y._7_Dias && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(7, "day")), f === y._15_Dias && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(15, "day")), f === y._30_Dias && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(30, "day")), f === y._60_Dias && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(60, "day")), f === y._90_Dias && o.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(90, "day"));
  }, [o, f, y]);
  const { data: V, isLoading: D } = la(1, h, r), x = [
    {
      DNI: "",
      value: null,
      ArchivoId: 0,
      key: "0 sin cliente",
      fullName: "Sin cliente"
    },
    ...V?.map((Z) => ({
      DNI: Z.DNI,
      value: Z.ContactoId,
      fullName: Z.FullName,
      ArchivoId: Z.ArchivoId,
      key: Z.ContactoId + Z.ContentType
    })) || []
  ], O = da(h), w = PO(), j = RO(), [$, _] = k.useState([]), { data: A } = Qr(), [R, P] = k.useState(!1), z = Ag(S?.CotizacionId), [F, L] = k.useState(void 0);
  k.useEffect(() => {
    if (N && S !== void 0) {
      const Z = S.CotizacionesDetallesCotizacionId?.map((Y, he) => {
        const ve = {
          Key: he,
          ...Y,
          DocumentoId: Y.CotizacionId,
          DocumentoDetalleId: Y.DetalleId
        };
        return {
          ...Bt(ve, [
            "CotizacionId",
            "DetalleId"
          ])
        };
      }), ce = {
        ...S,
        ContactoId: S.ClienteId,
        ContactoDNI: S.ClenteDNI,
        TipoDocumentoId: E.Cotizacion,
        DocumentoId: S.CotizacionId,
        Secuencia: S.CotizacionNumero,
        DocumentosDetallesDocumentoId: Z,
        ContactoNombre: S.ClienteNombre
      };
      L(Bt(ce, ["CotizacionId"])), _(Z);
    }
  }, [N, S, E.Cotizacion]);
  const M = k.useMemo(() => s.getFieldValue("Retenciones")?.length > 0 ? s.getFieldValue("Retenciones")?.reduce((Z, ce) => [...Z, JSON.parse(ce)], []) : 0, [s]), B = Un($, M || [], l), W = (Z) => {
    for (const ce in Z)
      return typeof Z[ce] > "u" ? (Or.info(`Falta el campo ${ce}`), !1) : !0;
  }, ee = async () => {
    const Z = o.getFieldsValue(), ce = a.getFieldsValue(), Y = {
      DNI: Z.ClenteDNI,
      Telefono: Z.ClienteTelefono,
      DNITipoId: Z.ClienteDNITipoId,
      Direccion: Z.ClienteDireccion,
      CotizacionId: S?.CotizacionId,
      NombreCompleto: O.data ? O.data?.ContactoNombre + " " + O.data?.ContactoApellido : Z.ClienteNombre
    };
    if (W(Z)) {
      const he = s.getFieldsValue(), ve = {
        Fecha: Z.Fecha,
        Notas: ce.Notas,
        Total: B[0].Total,
        EstadoId: v.Activo,
        TipoNCFId: Z.TipoNCFId,
        Importe: B[0].Importe,
        ClienteId: Z?.ClienteId,
        TipoPlazoId: Z.TipoPlazoId,
        Referencia: he.Referencia,
        Descuento: B[0].Descuento,
        Impuestos: B[0].Impuestos,
        FechaEntrega: ce.FechaEntrega,
        Retenciones: B[0].Retenciones,
        FechaVencimiento: Z.Vencimiento,
        Observaciones: ce.Observaciones,
        CotizacionId: S?.CotizacionId,
        DireccionEnvio: ce.DireccionEnvio,
        CotizacionNumero: S?.CotizacionNumero,
        ImpuestosIncluidos: he.ImpuestosIncluidos,
        Tasa: he.Tasa ? he.Tasa : S?.MonedaId,
        ClenteDNI: O.data ? O.data?.DNI : Z.ClenteDNI,
        MonedaId: he.MonedaId ? he.MonedaId : S?.MonedaId,
        CotizacionesClienteCotizacionId: Z?.ClienteId ? void 0 : Y,
        AlmacenId: he.AlmacenId ? he.AlmacenId : S?.MonedaId,
        TasaFecha: he.TasaFecha ? he.TasaFecha : S?.TasaFecha,
        VendedorId: he.Vendedor ? he.Vendedor : S?.VendedorId,
        Monto: B[0].Importe - B[0].Descuento + B[0].Retenciones,
        ListaPrecioId: he.ListaPrecioId ? he.ListaPrecioId : S?.ListaPrecioId,
        ClienteNombre: O.data ? O.data?.ContactoNombre + " " + O.data?.ContactoApellido : Z.ClienteNombre,
        CotizacionesDetallesCotizacionId: $?.map((ue) => ({
          Total: ue.Total,
          Codigo: ue.Codigo,
          Cantidad: ue.Cantidad,
          SubTotal: ue.SubTotal,
          Impuesto: ue.Impuesto,
          Descuento: ue.Descuento,
          ProductoId: ue.ProductoId,
          Referencia: ue.Referencia,
          EstadoId: v.Activo,
          Descripcion: ue.Descripcion,
          CostoUnitario: ue.CostoUnitario,
          UnidadMedidaId: ue.UnidadMedidaId,
          PrecioUnitario: ue.PrecioUnitario,
          DetalleId: ue.DocumentoDetalleId || 0,
          CotizacionId: S?.CotizacionId,
          DescuentoUnitario: ue.DescuentoUnitario,
          DescuentoEsPorcentual: ue.DescuentoEsPorcentual
        }))
      };
      await se.promise(w.mutateAsync(ve), {
        error: (ue) => ue,
        loading: "Guardando cotización",
        success: () => (t("../cotizacion-detalles/" + e), `cotización ${e} guardada correctamente`)
      });
    }
  }, te = async () => {
    const Z = o.getFieldsValue(), ce = a.getFieldsValue(), Y = s.getFieldsValue(), he = {
      DNI: Z.ClenteDNI,
      Telefono: Z.ClienteTelefono,
      DNITipoId: Z.ClienteDNITipoId,
      Direccion: Z.ClienteDireccion,
      CotizacionId: S?.CotizacionId,
      NombreCompleto: O.data ? O.data?.ContactoNombre + " " + O.data?.ContactoApellido : Z.ClienteNombre
    }, ve = {
      Fecha: Z.Fecha,
      Notas: ce.Notas,
      Total: B[0].Total,
      TipoNCFId: Z.TipoNCFId,
      Importe: B[0].Importe,
      EstadoId: v.Borrador,
      ClienteId: Z?.ClienteId,
      TipoPlazoId: Z.TipoPlazoId,
      Referencia: Y.Referencia,
      Descuento: B[0].Descuento,
      Impuestos: B[0].Impuestos,
      FechaEntrega: ce.FechaEntrega,
      Retenciones: B[0].Retenciones,
      FechaVencimiento: Z.Vencimiento,
      Observaciones: ce.Observaciones,
      CotizacionId: S?.CotizacionId,
      DireccionEnvio: ce.DireccionEnvio,
      CotizacionNumero: S?.CotizacionNumero,
      ImpuestosIncluidos: Y.ImpuestosIncluidos,
      Tasa: Y.Tasa ? Y.Tasa : S?.MonedaId,
      ClenteDNI: O.data ? O.data?.DNI : Z.ClenteDNI,
      MonedaId: Y.MonedaId ? Y.MonedaId : S?.MonedaId,
      CotizacionesClienteCotizacionId: Z?.ClienteId ? void 0 : he,
      AlmacenId: Y.AlmacenId ? Y.AlmacenId : S?.MonedaId,
      TasaFecha: Y.TasaFecha ? Y.TasaFecha : S?.TasaFecha,
      Monto: B[0].Importe - B[0].Descuento + B[0].Retenciones,
      VendedorId: Y.Vendedor ? Y.Vendedor : S?.VendedorId || void 0,
      ListaPrecioId: Y.ListaPrecioId ? Y.ListaPrecioId : S?.ListaPrecioId,
      ClienteNombre: O.data ? O.data?.ContactoNombre + " " + O.data?.ContactoApellido : Z.ClienteNombre,
      CotizacionesDetallesCotizacionId: $?.map((ue) => ({
        Total: ue.Total,
        Codigo: ue.Codigo,
        Cantidad: ue.Cantidad,
        SubTotal: ue.SubTotal,
        Impuesto: ue.Impuesto,
        Descuento: ue.Descuento,
        ProductoId: ue.ProductoId,
        Referencia: ue.Referencia,
        EstadoId: v.Activo,
        Descripcion: ue.Descripcion,
        CostoUnitario: ue.CostoUnitario,
        UnidadMedidaId: ue.UnidadMedidaId,
        PrecioUnitario: ue.PrecioUnitario,
        DetalleId: ue.DocumentoDetalleId || 0,
        CotizacionId: S?.CotizacionId,
        DescuentoUnitario: ue.DescuentoUnitario,
        DescuentoEsPorcentual: ue.DescuentoEsPorcentual
      }))
    };
    await se.promise(j.mutateAsync(ve), {
      error: (ue) => ue,
      loading: "Guardando cotización en borrador",
      success: () => (t("../cotizacion-detalles/" + e), `Cotización ${e} guardada correctamente`)
    });
  }, de = async () => {
    await se.promise(z.mutateAsync({
      EstadoId: v.Borrador,
      CotizacionId: S?.CotizacionId || 0
    }), {
      loading: "Devolviendo la cotización a borrador",
      error: () => "Error al volver cotización a borrador",
      success: () => `La cotización ${e} ahora está en borrador`
    });
  };
  return C ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la Cotización"
  }) : w.isPending || j.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(GE, { children: [i.jsxs(KE, { children: [i.jsx(bn, { loading: T, title: i.jsx(gn, { level: 3, children: `Cotización ${F?.Secuencia !== "0" && F !== void 0 ? F?.Secuencia : ""}` }), children: T ? i.jsx(Vr, { size: "large", isLoading: T, title: "Cargando la cotización" }) : i.jsxs(Sn, { form: o, layout: "vertical", disabled: F?.EstadoId !== v.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { Label: "Cliente", Name: "ClienteId", contactoId: h, TitleView: "Ver cliente", setSearch: n, optionsContacts: x, setOpenDrawerIC: P, Placeholder: "Seleccione el cliente", isContactsLoading: D, initialValue: S?.ClienteId, disabled: S?.EstadoId !== v.Borrador }) }), i.jsxs(ba, { children: [i.jsx(kr, { children: i.jsx(ii, { area: "Ventas", initialValue: S?.TipoNCFId, documentTypeId: E.Factura_de_venta, disabled: S?.EstadoId !== v.Borrador }) }), i.jsx(kr, { children: i.jsx(K.Item, { name: "TipoPlazoId", label: "Tipo de plazo:", initialValue: S?.TipoPlazoId, rules: [
    { required: !0, message: "Este campo es requerido" }
  ], children: i.jsx(Ht, { size: "large", options: b, placeholder: "Seleccione el tipo de plazo" }) }) })] }), i.jsxs(ba, { children: [i.jsx(kr, { children: i.jsx(K.Item, { name: "Vencimiento", label: "Vencimiento:", initialValue: rt(S?.FechaVencimiento), rules: [
    { required: !0, message: "Este campo es requerido" }
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" }, disabled: y.VencimientoManual !== f }) }) }), i.jsx(kr, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", initialValue: rt(S?.Fecha), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) })] }), u === m.Comprobante_factura ? i.jsx(ba, { children: i.jsx(K.Item, { name: "Secuencia", label: "Número de comprobante:", initialValue: S?.CotizacionNumero, children: i.jsx(Hr, { size: "large", style: { width: "100%" }, placeholder: "Ingrese el NCF" }) }) }) : null, h === null ? i.jsxs(i.Fragment, { children: [i.jsxs(ba, { children: [i.jsx(kr, { children: i.jsx(K.Item, { name: "ClienteNombre", style: { width: "100%" }, label: "Cliente nombre:", initialValue: S?.CotizacionesClienteCotizacionId?.NombreCompleto, children: i.jsx(Hr, { size: "large", style: { width: "100%" }, placeholder: "Nombre Completo" }) }) }), i.jsx(kr, { children: i.jsx(K.Item, { label: "DNI", name: "ClenteDNI", style: { width: "100%" }, initialValue: S?.CotizacionesClienteCotizacionId?.DNI, rules: [
    {
      min: d == 1 || d == 4 ? 11 : void 0,
      message: `${d == 1 || d == 4 ? 11 : void 0} dígitos como mínimo`
    },
    {
      max: d == 1 || d == 4 ? 11 : void 0,
      message: `${d == 1 || d == 4 ? 11 : void 0} dígitos como máximo`
    }
  ], children: i.jsx(Hr, { size: "large", placeholder: "DNI", style: { width: "100%" }, disabled: d === void 0, maxLength: d == 1 || d == 4 ? 11 : void 0, addonBefore: i.jsx(K.Item, { noStyle: !0, name: "ClienteDNITipoId", initialValue: S?.CotizacionesClienteCotizacionId?.DNITipoId, children: i.jsx(Ht, { size: "large", style: { width: 100 }, options: g?.map((Z) => ({
    value: Z.ContactoTipoDNIId,
    label: Z.ContactoTipoDNINombre
  })) }) }) }) }) })] }), i.jsxs(ba, { children: [i.jsx(kr, { children: i.jsx(K.Item, { label: "Teléfono", name: "ClienteTelefono", initialValue: S?.CotizacionesClienteCotizacionId?.Telefono, children: i.jsx(Vn, { size: "large", maxLength: 10, controls: !1, placeholder: "Teléfono", style: { width: "100%" } }) }) }), i.jsx(kr, { children: i.jsx(K.Item, { label: "Dirección", name: "ClienteDireccion", initialValue: S?.CotizacionesClienteCotizacionId?.Direccion, children: i.jsx(Ja, { autoSize: !0, size: "large", placeholder: "Dirección" }) }) })] })] }) : void 0] }) }), i.jsx(K, { form: a, layout: "vertical", children: i.jsx(rn, { isOrden: !0, area: "Ventas", formInstance: a, isFleteActive: c, formConfig: s, dataSource: $, loading: T, DocumentData: F, setDataSource: _, disabled: F?.EstadoId !== v.Borrador, tax: A?.Valor ? A?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: o, isFleteEnable: !c, dataSource: $, isLoading: T, formIntanceConfig: s, Total: De(B[0].Total), Importe: De(B[0].Importe), Subtotal: De(B[0].SubTotal), Descuento: De(B[0].Descuento), Impuestos: De(B[0].Impuestos), Retenciones: De(B[0].Retenciones), enabled: F?.EstadoId === v.Borrador, IsBorradorDocument: S?.EstadoId == v.Borrador, methods: {
    handleSaveNormal: ee,
    handleSaveBorrador: te,
    handleVolverABorrador: de
  } })] }), i.jsx(ua, { Open: R, setOpen: P, dataContact: O.data, Title: "Información del cliente", optionsContacts: x, isContactInfoLoading: O.isLoading })] });
}, _O = () => {
  const e = Ue();
  return ke({
    mutationFn: aa.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, MO = () => {
  const e = Ue();
  return ke({
    mutationFn: aa.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, LO = () => {
  const e = Ue();
  return ke({
    mutationFn: aa.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, _g = () => {
  const e = Ue();
  return ke({
    mutationFn: aa.clonateSaleInvoice,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, Mg = (e) => {
  const t = Ue();
  return ke({
    mutationFn: aa.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/FacturasVentas", e]
      });
    }
  });
}, Lg = (e) => {
  const { docTypes: t, tiposNotas: r, statesValues: n } = et(), o = NS(e.record.DocumentoId), a = OS(e.record.DocumentoId), s = async (b) => {
    const C = b === r.nota_credito ? "nota-credito" : "nota-debito", S = b === r.nota_credito ? "nota de crédito" : "nota de débito";
    await se.promise(o.mutateAsync({
      tipoNotaId: b,
      facturaId: e.record.DocumentoId
    }), {
      loading: "Creando " + S,
      error: () => "Error al crear la " + S,
      success: (T) => (d(`${C}/${T}`), S + " creada correctamente")
    });
  }, c = async (b) => {
    const C = b === r.nota_credito ? "nota-credito" : "nota-debito", S = b === r.nota_credito ? "nota de crédito" : "nota de débito";
    await se.promise(a.mutateAsync({
      tipoNotaId: b,
      facturaId: e.record.DocumentoId
    }), {
      loading: "Creando " + S,
      error: () => "Error al crear la " + S,
      success: (T) => (d(`${C}/${T}`), S + " creada correctamente")
    });
  }, l = ai(), d = xt(), { setIsOpenModalRec: u, setModalActionChangeState: f } = e.methods, h = _g(), g = async () => {
    await se.promise(h.mutateAsync(e.record.DocumentoId), {
      loading: "Clonando la factura de venta",
      error: () => "Error al clonar la factura de venta",
      success: (b) => (d("factura-venta/" + b[0].FacturaId), `La factura de venta ${e.record.DocumentoId} ha sido clonada correctamente`)
    });
  }, E = e.record.TipoDocumentoId === t.Factura_de_venta ? "ReporteFacturaVenta2" : e.record.TipoDocumentoId === t.Cotizacion ? "ReporteCotizacion" : e.record.TipoDocumentoId === t.Conduce ? "ReporteConduce" : "", v = e.record.TipoDocumentoId === t.Factura_de_venta ? "facturaId" : e.record.TipoDocumentoId === t.Cotizacion ? "cotizacionId" : e.record.TipoDocumentoId === t.Conduce ? "conduceId" : "", m = [
    {
      key: 1,
      label: "Ver detalles",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "file-description" }) }),
      onClick: () => {
        l(e.record.TipoDocumentoId, e.record.DocumentoId, e.type === "venta" ? "Ventas" : "Compras");
      }
    },
    {
      key: 2,
      label: "Imprimir",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "printer" }) }),
      onClick: () => Qi.chooseReportType(() => {
        window.location.assign(`${Qi.generatePath(E, {
          [v]: `${e.record.DocumentoId}`
        }, "pdf")}`);
      }, {
        documentId: e.record.DocumentoId,
        documentTypeId: e.record.TipoDocumentoId
      })
    },
    {
      key: 3,
      label: "Hacer recurrente",
      onClick: () => u(!0),
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "arrow-left-right" }) })
    },
    {
      key: 4,
      label: "Clonar",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "repeat-once" }) }),
      onClick: () => {
        e.record.TipoDocumentoId === t.Factura_de_venta ? g() : e.record.TipoDocumentoId === t.Conduce || e.record.TipoDocumentoId === t.Factura_de_compra || (e.record.TipoDocumentoId, t.Orden_de_compra);
      }
    },
    {
      key: 5,
      label: "Aplicar nota de crédito",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "square-minus" }) }),
      onClick: () => {
        e.type === "venta" ? c(r.nota_credito) : s(r.nota_credito);
      }
    },
    {
      key: 6,
      label: "Aplicar nota de débito",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "square-plus" }) }),
      onClick: () => {
        e.type === "compra" ? s(r.nota_debito) : c(r.nota_debito);
      }
    },
    {
      key: 7,
      label: "Anular",
      onClick: () => f({ Open: !0, Action: "Anular" }),
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "backspace" }) })
    },
    {
      key: 8,
      label: "Editar",
      icon: i.jsx(at, { children: i.jsx(me, { name: "edit", size: "small" }) }),
      onClick: () => d(`${e.record.TipoDocumentoId === t.Cotizacion ? "cotizacion" : e.record.TipoDocumentoId === t.Factura_de_venta ? "factura-venta" : e.record.TipoDocumentoId === t.Nota_de_credito ? "nota-credito" : e.record.TipoDocumentoId === t.Nota_de_debito ? "nota-debito" : e.record.TipoDocumentoId === t.Conduce ? e.type === "venta" ? "conduce-venta" : "conduce-compra" : e.record.TipoDocumentoId === t.Factura_de_compra ? "factura-compra" : e.record.TipoDocumentoId === t.Orden_de_compra ? "orden-compra" : "movimiento-inventario"}/${e.record.DocumentoId}`)
    },
    {
      key: 9,
      label: "Eliminar",
      icon: i.jsx(at, { children: i.jsx(me, { name: "trash", size: "small" }) }),
      onClick: () => f({ Open: !0, Action: "Eliminar" })
    }
  ], I = (() => {
    let b = [];
    return [
      n.Saldado,
      n.Anulado,
      n.Borrador,
      n.Facturado,
      n.Pendiente_de_aprobacion
    ].includes(e.record.EstadoId) ? (b = m.filter((C) => [8, 7, 1].includes(Number(C?.key))), b) : [t.Conduce, t.Cotizacion].includes(e.record.TipoDocumentoId) && [n.Activo].includes(e.record.EstadoId) ? (b = m.filter((C) => [8, 2, 4, 7, 1].includes(Number(C?.key))), b) : [t.Orden_de_compra].includes(e.record.TipoDocumentoId) && [n.Activo].includes(e.record.EstadoId) ? (b = m.filter((C) => [8, 7, 1].includes(Number(C?.key))), b) : ([t.Nota_de_debito, t.Nota_de_credito].includes(e.record.TipoDocumentoId) && [n.Activo].includes(e.record.EstadoId) ? b = m.filter((C) => [7, 8, 1].includes(Number(C?.key))) : [t.Factura_de_venta].includes(e.record.TipoDocumentoId) && [n.Activo].includes(e.record.EstadoId) ? (b = m.filter((C) => [1, 2, 3, 4, 5, 6, 7, 8, 1].includes(Number(C?.key))), e.record.Recurrencia && (b = m.filter((C) => [1, 2, 3, 4, 5, 6, 7, 8, 1].includes(Number(C?.key)) && ![3, 1].includes(Number(C?.key))))) : [t.Factura_de_compra].includes(e.record.TipoDocumentoId) && [n.Activo].includes(e.record.EstadoId) && (b = m.filter((C) => [3, 8, 5, 6, 7, 1].includes(Number(C?.key))), e.record.Recurrencia && (b = m.filter((C) => [8, 5, 6, 7, 1].includes(Number(C?.key)) && ![3, 1].includes(Number(C?.key))))), b);
  })().map((b) => ({
    icon: b.icon,
    label: b.label,
    onClick: b.onClick,
    key: Number(b?.key)
  }));
  return i.jsx(zf, { menu: { items: I }, trigger: ["click"], children: i.jsx(me, { touchable: !0, name: "dots-vertical", onClick: () => e.setSelectedItem(e.record) }) }, `Actions ${e.record.DocumentoId} ${e.indexRender}`);
}, Vg = (e) => {
  const t = xt(), n = [
    {
      key: 2,
      label: "Ver factura",
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "eye-search" }) }),
      onClick: () => t(`../factura-${e.type}-detalles/` + e.record.DocumentoId)
    },
    {
      key: 9,
      label: "Desactivar",
      onClick: () => {
      },
      icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "plug-off" }) })
    }
  ].map((o) => ({
    key: o.key,
    icon: o.icon,
    label: o.label,
    onClick: o.onClick
  }));
  return i.jsx(zf, { menu: { items: n }, trigger: ["click"], children: i.jsx(me, { touchable: !0, name: "dots-vertical", onClick: () => e.setSelectedItem(e.record) }) }, `Actions ${e.record.DocumentoId} ${e.indexRender}`);
}, zg = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.clonate,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS]
      });
    }
  });
}, VO = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS]
      });
    }
  });
}, zO = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.convertOrdenCompraToFacutra,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS]
      });
    }
  });
}, BO = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.convertCotizacionToFacutra,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS]
      });
    }
  });
}, kO = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.convertConduceVentaToFacutra,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS]
      });
    }
  });
}, UO = () => {
  const e = Ue();
  return ke({
    mutationFn: Sr.convertConduceVentaToFacutra,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.GET_ALL_DOCUMENTOS_COMPRAS]
      });
    }
  });
}, qO = () => {
  const e = localStorage.getItem("token") ?? "";
  if (!(e === "" || !e))
    try {
      return JSON.parse(decodeURIComponent(window.atob(e.split(".")[1].replace("-", "+").replace("_", "/")).split("").map((t) => `%${`00${t.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")));
    } catch (t) {
      console.error(t);
    }
}, HO = () => {
  const e = Ue();
  return ke({
    mutationFn: ia.create,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, WO = () => {
  const e = Ue();
  return ke({
    mutationFn: ia.update,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, GO = () => {
  const e = Ue();
  return ke({
    mutationFn: ia.saveChanges,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, KO = () => {
  const e = Ue();
  return ke({
    mutationFn: ia.clonateConduceVenta,
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      });
    }
  });
}, Bg = (e) => {
  const t = Ue();
  return ke({
    mutationFn: ia.changeState,
    onSuccess: () => {
      t.invalidateQueries({
        queryKey: [Oe.DOCUMENTOS_VENTAS]
      }), t.invalidateQueries({
        queryKey: ["/ConducesVentas", e]
      });
    }
  });
}, kg = (e, t, r) => {
  const n = r ? "Clonando" : "Creando", o = r ? t : "", a = r ? "la" : "nueva";
  return `${e === "conduce" ? `${n} conduce` : e === "nota-credito" ? "Creando nota de crédito" : e === "nota-debito" ? "Creando nota de débito" : e === "factura-venta" ? `${n} ${a} factura de venta ${o}` : e === "factura-compra" ? `${n} ${a} factura de compra ${o}` : e === "cotizacion" ? "Creando cotización" : e == "orden-compra" ? "Creando orden de compra" : ""}`;
}, Ug = (e, t) => {
  const r = t ? "clonada" : "creada";
  return `${e === "conduce" ? `Conduce ${r} correctamente` : e === "nota-credito" ? "Nota de crédito creada correctamente" : e === "nota-debito" ? "Nota de débito creada correctamente" : e === "factura-venta" ? `Factura de venta ${r} correntamente` : e === "factura-compra" ? `Factura de compra ${r} correntamente` : e === "cotizacion" ? "Cotización creada correctamente" : e === "orden-compra" ? "Orden de compra creada correctamente" : ""}`;
}, YO = () => {
  let e = {};
  const { statesValues: t } = et();
  return e = {
    Monto: 0,
    Total: 0,
    Notas: "",
    OrdenId: 0,
    Importe: 0,
    MonedaId: 1,
    AlmacenId: 1,
    Descuento: 0,
    Impuestos: 0,
    Referencia: "",
    Retenciones: 0,
    OrdenNumero: "0",
    ProveedorDNI: "",
    Fecha: /* @__PURE__ */ new Date(),
    ProveedorId: null,
    Observaciones: "",
    ProveedorNombre: "",
    ImpuestosIncluidos: !1,
    EstadoId: t.Borrador,
    FechaVencimientoNCF: /* @__PURE__ */ new Date()
  }, e;
}, QO = (e) => {
  let t = {};
  const { statesValues: r } = et(), n = e ? {
    EstadoId: 1,
    FacturaId: 0,
    FrecuenciaId: 3,
    CantidadVeces: 0,
    EsLimitado: !1,
    EnviarPorCorreo: !1,
    FechaInicio: /* @__PURE__ */ new Date(),
    FechaProxima: /* @__PURE__ */ new Date(),
    CrearComoBorrador: !1
  } : void 0;
  return t = {
    Tasa: 1,
    Monto: 0,
    Total: 0,
    Notas: "",
    Importe: 0,
    MonedaId: 1,
    FacturaId: 0,
    AlmacenId: 1,
    TipoNCFId: 5,
    Descuento: 0,
    Impuestos: 0,
    Referencia: "",
    Retenciones: 0,
    ProveedorDNI: "",
    Fecha: /* @__PURE__ */ new Date(),
    ProveedorId: null,
    Observaciones: "",
    FacturaNumero: "0",
    ProveedorNombre: "",
    TasaFecha: /* @__PURE__ */ new Date(),
    ImpuestosIncluidos: !1,
    TieneDescuentoPorFecha: !1,
    FechaVencimientoNCF: /* @__PURE__ */ new Date(),
    EstadoId: r.Borrador,
    FacturasComprasRecurrentesFacturaId: n
  }, t;
}, XO = (e, t) => {
  let r = {};
  const { statesValues: n } = et(), o = e ? {
    EstadoId: 1,
    FacturaId: 0,
    FrecuenciaId: 3,
    CantidadVeces: 0,
    EsLimitado: !1,
    EnviarPorCorreo: !1,
    FechaInicio: /* @__PURE__ */ new Date(),
    FechaProxima: /* @__PURE__ */ new Date(),
    CrearComoBorrador: !1
  } : void 0;
  return r = {
    Tasa: 1,
    Notas: "",
    Monto: 0,
    Total: 0,
    MonedaId: 1,
    FacturaId: 0,
    AlmacenId: 1,
    TipoNCFId: 1,
    Importe: 0,
    ClenteDNI: "",
    TipoPlazoId: 1,
    Referencia: "",
    Descuento: 0,
    Impuestos: 0,
    ClienteId: null,
    ListaPrecioId: 1,
    Retenciones: 0,
    Fecha: /* @__PURE__ */ new Date(),
    ClienteNombre: "",
    Observaciones: "",
    FacturaNumero: "0",
    TasaFecha: /* @__PURE__ */ new Date(),
    VendedorId: t,
    ImpuestosIncluidos: !1,
    FechaVencimiento: /* @__PURE__ */ new Date(),
    TieneDescuentoPorFecha: !1,
    FechaVencimientoNCF: /* @__PURE__ */ new Date(),
    EstadoId: n.Borrador,
    FacturasVentasRecurrentesFacturaId: o
  }, r;
}, ZO = (e) => {
  let t = {};
  const { statesValues: r } = et();
  return t = {
    Tasa: 1,
    Notas: "",
    Monto: 0,
    Total: 0,
    MonedaId: 1,
    AlmacenId: 1,
    TipoNCFId: 1,
    Importe: 0,
    ClenteDNI: "",
    TipoPlazoId: 1,
    Referencia: "",
    Descuento: 0,
    Impuestos: 0,
    CotizacionId: 0,
    ClienteId: null,
    ListaPrecioId: 1,
    Retenciones: 0,
    Fecha: /* @__PURE__ */ new Date(),
    ClienteNombre: "",
    Observaciones: "",
    DireccionEnvio: "",
    TasaFecha: /* @__PURE__ */ new Date(),
    CotizacionNumero: "0",
    VendedorId: e,
    FechaEntrega: /* @__PURE__ */ new Date(),
    ImpuestosIncluidos: !1,
    FechaVencimiento: /* @__PURE__ */ new Date(),
    FechaVencimientoNCF: /* @__PURE__ */ new Date(),
    EstadoId: r.Borrador
  }, t;
}, JO = (e) => {
  let t = {};
  const { statesValues: r } = et();
  return t = {
    Tasa: 1,
    Notas: "",
    Monto: 0,
    Total: 0,
    MonedaId: 1,
    ConduceId: 0,
    AlmacenId: 1,
    TipoNCFId: 1,
    Importe: 0,
    ClenteDNI: "",
    Referencia: "",
    Descuento: 0,
    Impuestos: 0,
    ClienteId: null,
    ListaPrecioId: 1,
    Retenciones: 0,
    Fecha: /* @__PURE__ */ new Date(),
    ClienteNombre: "",
    Observaciones: "",
    ConduceNumero: "0",
    TasaFecha: /* @__PURE__ */ new Date(),
    VendedorId: e,
    ImpuestosIncluidos: !1,
    FechaVencimientoNCF: /* @__PURE__ */ new Date(),
    EstadoId: r.Borrador
  }, t;
}, eN = () => {
  let e = {};
  const { statesValues: t } = et();
  return e = {
    Tasa: 1,
    Notas: "",
    Monto: 0,
    Total: 0,
    MonedaId: 1,
    ConduceId: 0,
    AlmacenId: 1,
    TipoNCFId: 1,
    Importe: 0,
    Referencia: "",
    Descuento: 0,
    Impuestos: 0,
    ProveedorDNI: "",
    Retenciones: 0,
    Fecha: /* @__PURE__ */ new Date(),
    ProveedorId: null,
    Observaciones: "",
    ConduceNumero: "0",
    ProveedorNombre: "",
    TasaFecha: /* @__PURE__ */ new Date(),
    ImpuestosIncluidos: !1,
    FechaVencimientoNCF: /* @__PURE__ */ new Date(),
    EstadoId: t.Borrador
  }, e;
}, qg = (e) => {
  const t = xt(), r = CS(), n = DS(), o = hS({
    UserId: qO().id
  });
  k.useEffect(() => {
    e.isSalesArea && (o.data === null || o.data === void 0) && o.refetch;
  }, [
    o.data,
    o.refetch,
    e.isSalesArea
  ]);
  const a = _O(), s = NO(), c = HO(), l = RS(), d = async (m) => {
    await se.promise(c.mutateAsync(JO(o.data && o?.data[0].ContactoId ? o?.data[0]?.ContactoId : void 0)), {
      loading: "Creando conduce",
      error: (y) => y || "Ha ocurrido un error al crear la conduce",
      success: (y) => (t(`conduce-venta/${y.ConduceId}`), "Conduce creado correctamente")
    });
  }, u = async (m) => {
    await se.promise(l.mutateAsync(eN()), {
      loading: "Creando conduce",
      error: (y) => y || "Ha ocurrido un error al crear la conduce",
      success: (y) => (t(`conduce-compra/${y.ConduceId}`), "Conduce creado correctamente")
    });
  }, f = async () => {
    await se.promise(s.mutateAsync(ZO(o.data && o?.data[0].ContactoId ? o?.data[0]?.ContactoId : void 0)), {
      loading: "Creando cotización",
      error: (m) => m || "Ha ocurrido un error al crear la cotización",
      success: (m) => (t(`cotizacion/${m.CotizacionId}`), "Cotización creada correctamente")
    });
  }, h = async (m) => {
    await se.promise(r.mutateAsync(YO()), {
      loading: "Creando orden de compra",
      error: () => "Ha ocurrido un error creando la orden de compra",
      success: (y) => (t(`orden-compra/${y.OrdenId}`), "Orden de compra creada correctamente")
    });
  }, g = async (m) => {
    await se.promise(n.mutateAsync(QO(m || !1)), {
      loading: "Creando factura de compra",
      error: () => "Ha ocurrido un error creando la factura",
      success: (y) => (t(`factura-compra/${y.FacturaId}`), "Factura de de compra creada correctamente")
    });
  }, E = async (m) => {
    await se.promise(a.mutateAsync(XO(m || !1, o.data && o?.data[0].ContactoId ? o?.data[0]?.ContactoId : void 0)), {
      loading: "Creando factura de venta",
      error: (y) => y || "Ha ocurrido un error al crear la factura",
      success: (y) => (t(`factura-venta/${y?.FacturaId}`), "Factura creada correctamente")
    });
  }, v = (m, y) => {
    e.isSalesArea && (o.data == null || o.data == null) ? Or.info("No se ha podido obtener la información del usuario, intente de nuevo") : y && y(m || !1);
  };
  return i.jsx(sv, { trigger: ["click"], menu: {
    items: [
      {
        key: 1,
        label: "Cotización",
        onClick: () => v(!1, f),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "pencil" }) })
      },
      {
        key: 2,
        label: "Factura de venta",
        onClick: () => v(!1, E),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "receipt-2" }) })
      },
      {
        key: 3,
        label: "Conduce",
        onClick: () => v(!1, d),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "outbound" }) })
      },
      {
        key: 4,
        label: "Conduce",
        onClick: () => v(!1, u),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "outbound" }) })
      },
      {
        key: 5,
        label: "Factura de compra",
        onClick: () => v(!1, g),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "receipt-2" }) })
      },
      {
        key: 6,
        label: "Orden de compra",
        onClick: () => v(!1, h),
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "shopping-cart" }) })
      },
      {
        key: 7,
        label: "Factura recurrente",
        icon: i.jsx(at, { children: i.jsx(me, { size: "small", name: "arrow-left-right" }) }),
        onClick: () => e.isSalesArea ? v(!0, E) : v(!0, g)
      }
    ].filter((m) => e.isSalesArea ? [1, 2, 3, 7].includes(m.key) : [4, 5, 6, 7].includes(m.key))
  }, children: i.jsx(wt, { size: "large", type: "primary", renderLeftIcon: i.jsx(me, { name: "plus" }), children: "Agregar" }) });
}, _s = (e) => {
  const t = () => {
    const r = {};
    return e.modalAction.Action === "Eliminar" ? (r.Title = "Eliminar documento", r.StateId = 15, r.WordAction = "eliminar", r.WordLoading = "Eliminando", r.WordSuccess = "eliminado", r.Icon = i.jsx(cv, {})) : e.modalAction.Action === "Desactivar" ? (r.Title = "Desactivar documento", r.StateId = 2, r.WordAction = "desactivar", r.WordLoading = "Desactivando", r.WordSuccess = "desactivado", r.Icon = i.jsx(yi, {})) : e.modalAction.Action === "Activar" ? (r.Title = "Activar documento", r.StateId = 1, r.WordAction = "activar", r.WordLoading = "Activando", r.WordSuccess = "activado", r.Icon = i.jsx(yi, {})) : e.modalAction.Action === "Anular" ? (r.Title = "Anular documento", r.StateId = 4, r.WordAction = "anular", r.WordLoading = "Anulando", r.WordSuccess = "anulado", r.Icon = i.jsx(yi, {})) : e.modalAction.Action === "Borrador" && (r.Title = "Devolver a borrador", r.StateId = 4, r.WordAction = "devolver a borrador", r.WordLoading = "Devolviendo a borrador", r.WordSuccess = "puesto en borrador", r.Icon = i.jsx(yi, {})), r;
  };
  return i.jsx(i.Fragment, { children: i.jsx(Rn, { width: 450, closable: !1, okText: "Confirmar", maskClosable: !1, cancelText: "Cancelar", open: e.modalAction.Open, okButtonProps: { ghost: !0, danger: !0 }, onCancel: () => e.setModalAction({ Action: "", Open: !1 }), title: i.jsx(Ke, { style: { justifyContent: "center" }, children: i.jsx(at, { children: t().Title }) }), onOk: () => {
    e.setModalAction({ Action: "", Open: !1 }), se.promise(e.changeState.mutateAsync({
      area: e.area ?? "",
      estadoId: t().StateId,
      documentoId: e.selectedItem?.DocumentoId || 0,
      tipoDocumentoId: e.selectedItem?.TipoDocumentoId || 0
    }), {
      error: "Error",
      loading: `${t().WordLoading} el documento ${e.selectedItem?.DocumentoNumero}...`,
      success: `El documento ${e.selectedItem?.DocumentoNumero}, ha sido ${t().WordSuccess}`
    });
  }, children: i.jsxs(Ke, { style: { gap: 16, alignItems: "center", flexDirection: "column" }, children: [i.jsx(qt, { children: `¿Está seguro que desea ${t().WordAction} este documento?` }), i.jsx(at, { style: { width: 96, margin: "0 auto" }, children: e.changeState.isPending ? i.jsx(Xo, {}) : t().Icon })] }) }) });
}, jf = () => {
  const e = xt(), [t, r] = k.useState(""), n = (D) => {
    r(D.target.value);
  }, [o, a] = k.useState({ Action: "", Open: !1 }), [s, c] = k.useState(), [l] = Vt.useForm(), { statesValues: d } = et(), [u, f] = k.useState(!1), h = Kx(), g = Es(), E = Jp(0);
  ri();
  const v = Ds("Venta"), m = rh(), y = zg(), I = _S(s?.DocumentoId), b = async () => {
    const D = l.getFieldsValue(), x = {
      EstadoId: d.Activo,
      FacturaId: s?.DocumentoId || 0,
      FechaInicio: D.FechaInicio,
      FrecuenciaId: D.FrecuenciaId,
      EsLimitado: D.EsLimitado || !1,
      CantidadVeces: D.CantidadVeces || 0,
      EnviarPorCorreo: D.EnviarPorCorreo || !1,
      CrearComoBorrador: D.CrearComoBorrador || !1,
      FechaProxima: Ss(D.FechaInicio, D.FrecuenciaId)
    };
    await se.promise(I.mutateAsync(x), {
      loading: "Volviendo factura como recurrente",
      error: "Error volviendo la factura a borrador",
      success: () => (e("factura-venta-detalles/" + s?.DocumentoId), "Factura de venta convertida a recurrente")
    });
  }, C = ai(), S = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay facturas de venta agregadas." }) }), []), T = [
    {
      key: "Secuencia",
      title: "Secuencia",
      dataIndex: "Secuencia",
      sorter: (D, x) => D.DocumentoNumero.localeCompare(x.DocumentoNumero),
      render: (D, x, O) => x.DocumentoNumero == "0" ? i.jsx(rr.Status, { state: "Pendiente" }) : i.jsx(nr, { onClick: () => {
        C(x.TipoDocumentoId, x.DocumentoId, "Ventas");
      }, children: x.DocumentoNumero }, `sec ${x.DocumentoId} ${O}`)
    },
    {
      key: "TipoDocumentoId",
      title: "Tipo de documento",
      dataIndex: "TipoDocumentoId",
      onFilter: (D, x) => x.TipoDocumentoId === D,
      filters: E.data?.map((D) => ({
        value: D.DocumentoTipoId,
        text: D.DocumentoTipoNombre
      })),
      render: (D, x, O) => i.jsx(i.Fragment, { children: i.jsx("span", { children: x.DocumentoTipoNombre }, `DocTypeName ${x.DocumentoId} ${O}`) })
    },
    {
      key: "Fecha",
      title: "Fecha",
      dataIndex: "Fecha",
      filterDropdown: Ko,
      render: (D) => bt(D).format("DD/MM/YYYY"),
      sorter: (D, x) => new Date(D.Fecha).getTime() - new Date(x.Fecha).getTime(),
      onFilter: (D, x) => {
        if (typeof D != "string" && typeof D != "number")
          return !1;
        const O = bt(D, "DD/MM/YYYY");
        return O.isValid() && bt(x.Fecha).isSame(O, "D");
      }
    },
    {
      width: 300,
      key: "Cliente",
      title: "Cliente",
      dataIndex: "ContactoNombre",
      sorter: (D, x) => `${D?.ContactoNombre}`.localeCompare(`${x?.ContactoNombre}`),
      render: (D, x) => x?.ContactoNombre && x?.ContactoNombre !== "- -" ? x?.ContactoNombre : i.jsx(rr.Status, { state: "Pendiente" })
    },
    {
      width: 150,
      title: "Estado",
      key: "EstadoId",
      dataIndex: "EstadoId",
      render: (D, x) => i.jsx(rr.Status, { state: x.EstadoNombre }),
      onFilter: (D, x) => x.EstadoId === D,
      filters: g.data?.map((D) => ({
        value: D.EstadoId,
        text: D.EstadoNombre
      }))
    },
    {
      align: "center",
      key: "Recurrencia",
      title: "Recurrencia",
      dataIndex: "Recurrencia",
      render: (D, x) => ld(x.Recurrencia),
      onFilter: (D, x) => x.Recurrencia === D,
      filters: [
        { value: !0, text: "Solo recurrentes" },
        { value: !1, text: "No recurrentes" }
      ]
    },
    {
      title: "",
      width: 50,
      fixed: "right",
      key: "Acciones",
      render: (D, x, O) => i.jsx(Lg, { type: "venta", record: x, indexRender: O, setSelectedItem: c, methods: {
        setIsOpenModalRec: f,
        handleCreateClonar: N,
        setModalActionChangeState: a
      } })
    }
  ], N = async (D, x) => {
    await se.promise(y.mutateAsync({
      isComprasArea: 0,
      tipoDocumentoId: x,
      documentoId: s?.DocumentoId || 0,
      isRecurrente: s?.Recurrencia ? 1 : 0
    }), {
      error: () => "Error clonando documento",
      loading: kg(D, s?.DocumentoNumero || "", !0),
      success: (O) => (e(`${D}/${O}`), Ug(D, !0))
    });
  }, V = k.useMemo(() => !h.data || h.isLoading || h?.data?.length === 0 || h.data === void 0 ? [] : h.data.map((x) => ({ ...x, Fecha: rt(x.Fecha).format("YYYY-MM-DD") })).reduce((x, O) => {
    const w = t.toLowerCase(), j = `${O.ContactoNombre}`;
    return `${O?.DocumentoNumero}`.toLocaleLowerCase().includes(w) || `${O?.Fecha}`.toLowerCase().includes(w) || j.toLowerCase().includes(w) || `${O.EstadoNombre}`.toLowerCase().includes(w) || `${O.DocumentoTipoNombre}`.toLowerCase().includes(w) ? [...x, { ...O, clientFullName: j }] : x;
  }, []), [h.data, h.isLoading, t]);
  return k.useEffect(() => {
    v.isSuccess && a({ Action: "", Open: !1 });
  }, [v.isPending, v.isSuccess]), k.useEffect(() => {
    m.isSuccess && f(!1);
  }, [m.isPending, m.isSuccess]), i.jsxs(i.Fragment, { children: [i.jsx(_s, { area: "Ventas", changeState: v, selectedItem: s, modalAction: o, setModalAction: a }), i.jsx(Ln, { columns: T, title: "Área de ventas", dataSource: V, skeletonLoadingRowCount: 5, placeholderSearch: "Búsqueda...", skeletonLoading: h.isPending, onChangeSearch: Mn({ delay: 500 }, n), onSearch: (D) => {
    t !== D && r(D);
  }, renderHeadActions: [
    i.jsx(wt, { ghost: !0, size: "large", type: "primary", renderLeftIcon: i.jsx(me, { name: "currency-xrp" }), onClick: () => e("facturas-ventas-recurrentes"), children: "Documentos recurrentes" }, "DR_BUTTON"),
    i.jsx(qg, { isSalesArea: !0 }, "NEW_BUTTON")
  ], tableProps: {
    scroll: { x: T.length * 160 },
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    loading: h.isFetching || g.isFetching || v.isPending || y.isPending,
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: S(),
      filterEmptyText: "Sin filtros"
    }
  } }), i.jsx(Fs, { isOpen: u, setIsOpen: f, formRecurring: l, changeStateLoading: v.isPending, methodOk: () => {
    b(), f(!1);
  } })] });
}, tN = ({ FacturaId: e }) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["/FacturasCompras", e],
  queryFn: () => sa.getById(e || 0)
}), rN = () => {
  const { id: e } = _t(), t = xt(), { docTypes: r, statesValues: n } = et(), [o] = K.useForm(), [a] = K.useForm(), [s] = K.useForm(), [c] = K.useForm(), l = K.useWatch("IsFlete", o), d = K.useWatch("Flete", o), [u, f] = k.useState(""), [h, g] = k.useState(!1), E = K.useWatch("TipoFuenteComprobanteId", o), v = K.useWatch("ProveedorId", o), { sourcesVouchersT: m } = et(), { data: y, isLoading: I } = la(2, v, u), b = [
    ...y?.map((te) => ({
      DNI: te.DNI,
      value: te.ContactoId,
      fullName: te.FullName,
      ArchivoId: te.ArchivoId,
      key: te.ContactoId + te.ContentType
    })) || []
  ], C = da(v), S = TS(), T = wS(), [N, V] = k.useState(), [D, x] = k.useState([]), { data: O } = Qr(), [w, j] = k.useState(!1), [$, _] = k.useState(void 0), A = sh($?.DocumentoId), { isError: R, data: P, isSuccess: z, isLoading: F } = tN({
    FacturaId: Number.parseInt(e ?? "")
  });
  k.useEffect(() => {
    if (z && P !== void 0) {
      const te = P.FacturasComprasDetallesFacturaId?.map((Z, ce) => {
        const Y = {
          ...Z,
          Key: ce,
          DocumentoId: Z.FacturaId,
          DocumentoDetalleId: Z.DetalleId
        };
        return {
          ...Bt(Y, [
            "FacturaId"
          ])
        };
      }), de = {
        ...P,
        DocumentosDetallesDocumentoId: te,
        DocumentoId: P.FacturaId,
        ContactoId: P.ProveedorId,
        TipoDocumentoId: r.Factura_de_compra,
        Secuencia: P.FacturaNumero,
        ContactoDNI: P.ProveedorDNI,
        ContactoNombre: P.ProveedorNombre
      };
      x(te), _(Bt(de, ["FacturaId"]));
    }
  }, [z, P, r.Factura_de_compra]);
  const L = k.useMemo(() => c.getFieldValue("Retenciones")?.length > 0 ? c.getFieldValue("Retenciones")?.reduce((te, de) => [...te, JSON.parse(de)], []) : 0, [c]), M = Un(D, L || [], d), B = async () => {
    const te = o.getFieldsValue(), de = a.getFieldsValue(), Z = c.getFieldsValue();
    if (te.TipoFuenteComprobanteId === void 0)
      Or.info("Seleccionar comprobante");
    else {
      const ce = s.getFieldsValue(), Y = P?.FacturasComprasRecurrentesFacturaId !== null ? {
        EstadoId: n.Activo,
        EsLimitado: ce.EsLimitado,
        FechaInicio: ce.FechaInicio,
        FacturaId: P?.FacturaId || 0,
        FrecuenciaId: ce.FrecuenciaId,
        EnviarPorCorreo: ce.EnviarPorCorreo,
        CantidadVeces: ce.CantidadVeces || 0,
        CrearComoBorrador: ce.CrearComoBorrador,
        FechaProxima: Ss(ce.FechaInicio, ce.FrecuenciaId)
      } : void 0, he = {
        Fecha: te?.Fecha,
        Notas: de.Notas,
        ImpuestosIncluidos: !1,
        Total: M[0].Total,
        EstadoId: n.Activo,
        Importe: M[0].Importe,
        ProveedorId: te.ProveedorId,
        Descuento: M[0].Descuento,
        Impuestos: M[0].Impuestos,
        ProveedorDNI: C.data?.DNI,
        Retenciones: M[0].Retenciones,
        Observaciones: de.Observaciones,
        FacturaId: P?.FacturaId,
        Referencia: Z.Referencia || "",
        FacturasComprasRecurrentesFacturaId: Y,
        TipoFuenteComprobanteId: te.TipoFuenteComprobanteId,
        MonedaId: Z.MonedaId || P?.MonedaId,
        AlmacenId: Z.AlmacenId || P?.AlmacenId,
        Monto: M[0].Importe - M[0]?.Descuento + M[0].Retenciones,
        ProveedorNombre: C.data?.ContactoNombre + " " + C.data?.ContactoApellido,
        FacturaNumero: E === m.Comprobante_factura ? te.FacturaNumero : $?.Secuencia || "",
        FacturasComprasDetallesFacturaId: D?.map((ve) => ({
          Total: ve.Total,
          Codigo: ve.Codigo,
          Cantidad: ve.Cantidad,
          SubTotal: ve.SubTotal,
          Impuesto: ve.Impuesto,
          Descuento: ve.Descuento,
          ProductoId: ve.ProductoId,
          EstadoId: n.Activo,
          Descripcion: ve.Descripcion,
          Referencia: ve.Referencia || "",
          CostoUnitario: ve.CostoUnitario,
          DetalleSeries: ve.DetalleSeries,
          UnidadMedidaId: ve.UnidadMedidaId,
          PrecioUnitario: ve.PrecioUnitario,
          DetalleId: ve.DocumentoDetalleId || 0,
          FacturaId: P?.FacturaId,
          DescuentoUnitario: ve.DescuentoUnitario,
          DescuentoEsPorcentual: ve.DescuentoEsPorcentual,
          DetalleLotes: ve?.FacturaCompraDetalleLotes?.map((ue) => ({
            LoteId: ue.LoteId,
            Numero: ue.Numero,
            Cantidad: ue.Cantidad,
            Vencimiento: ue.Vencimiento,
            ProductoId: ve.ProductoId,
            FacturaDetalleLoteId: ue.FacturaDetalleLoteId
          }))
        }))
      };
      await se.promise(S.mutateAsync(he), {
        loading: "Guardando factura de compra",
        error: (ve) => `${ve.message}`,
        success: () => (t("../factura-compra-detalles/" + e), `Factura de compra ${e} guardada correctamente`)
      });
    }
  }, W = async () => {
    const te = o.getFieldsValue(), de = a.getFieldsValue(), Z = c.getFieldsValue();
    if (te.TipoFuenteComprobanteId === void 0)
      Or.info("Seleccionar comprobante");
    else {
      const ce = {
        Fecha: te?.Fecha,
        Notas: de.Notas,
        ImpuestosIncluidos: !1,
        Total: M[0].Total,
        MonedaId: Z.MonedaId,
        Importe: M[0].Importe,
        EstadoId: n.Borrador,
        AlmacenId: Z.AlmacenId,
        ProveedorId: te.ProveedorId,
        Descuento: M[0].Descuento,
        Impuestos: M[0].Impuestos,
        Retenciones: M[0].Retenciones,
        Observaciones: de.Observaciones,
        FacturaId: P?.FacturaId,
        Referencia: Z.Referencia || "",
        ProveedorDNI: C.data?.DNI || "-",
        TipoFuenteComprobanteId: te.TipoFuenteComprobanteId,
        Monto: M[0].Importe - M[0]?.Descuento + M[0].Retenciones,
        FacturaNumero: E === m.Comprobante_factura ? te.FacturaNumero : $?.Secuencia || "",
        ProveedorNombre: C.data ? C.data?.ContactoNombre + " " + C.data?.ContactoApellido : "Sin Proveedor",
        FacturasComprasDetallesFacturaId: D?.map((Y) => ({
          Total: Y.Total,
          Codigo: Y.Codigo,
          Cantidad: Y.Cantidad,
          SubTotal: Y.SubTotal,
          Impuesto: Y.Impuesto,
          Descuento: Y.Descuento,
          ProductoId: Y.ProductoId,
          EstadoId: n.Activo,
          Descripcion: Y.Descripcion,
          Referencia: Y.Referencia || "",
          CostoUnitario: Y.CostoUnitario,
          UnidadMedidaId: Y.UnidadMedidaId,
          PrecioUnitario: Y.PrecioUnitario,
          DetalleId: Y.DocumentoDetalleId || 0,
          FacturaId: P?.FacturaId,
          DescuentoUnitario: Y.DescuentoUnitario,
          DescuentoEsPorcentual: Y.DescuentoEsPorcentual
        }))
      };
      await se.promise(T.mutateAsync(ce), {
        loading: "Guardando factura de compra",
        error: "Error guardando factura de compra en borrador",
        success: () => (t("../factura-compra-detalles/" + e), `Factura de compra ${e} guardada correctamente`)
      });
    }
  }, ee = async () => {
    await se.promise(A.mutateAsync({
      EstadoId: n.Borrador,
      FacturaId: P?.FacturaId || 0
    }), {
      loading: "Devolviendo la factura a borrador",
      error: () => "Error al volver la factura de compra a borrador",
      success: () => `La factura de compra ${e} ahora está en borrador`
    });
  };
  return R ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de compra"
  }) : S.isPending || T.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(bn, { loading: F, title: `Factura de compra ${$?.Secuencia !== "0" && $ !== void 0 ? $?.Secuencia : ""}`, children: F ? i.jsx(Vr, { size: "large", isLoading: F, title: "Cargando la de factura de compra" }) : i.jsxs(Sn, { form: o, layout: "vertical", disabled: $?.EstadoId !== n.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { required: !1, Label: "Proveedor", Name: "ProveedorId", contactoId: v, TitleView: "Ver proveedor", setSearch: f, optionsContacts: b, setOpenDrawerIC: j, isContactsLoading: I, Placeholder: "Seleccione el proveedor", initialValue: P?.ProveedorId, disabled: P?.EstadoId !== n.Borrador }) }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", initialValue: rt(P?.Fecha), rules: [
    { required: !0, message: "Este campo es requerido" }
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" }, disabled: P?.EstadoId !== n.Borrador }) }) }), i.jsx(Ut, { children: i.jsx(ii, { area: "Compras", documentTypeId: r.Factura_de_compra, disabled: P?.EstadoId !== n.Borrador, initialValue: P?.TipoNCFId == 5 || P?.TipoNCFId == 2 ? 1 : P?.TipoFuenteComprobanteId }) })] }), E === m.Comprobante_factura && i.jsx(Cr, { children: i.jsx(Ut, { children: i.jsx(K.Item, { name: "FacturaNumero", style: { width: "100%" }, label: "Número de comprobante:", initialValue: P?.FacturaNumero, rules: [
    {
      required: !0,
      message: "Este campo es requerido"
    },
    { min: 11, message: "11 dígitos como mínimo" },
    { max: 19, message: "19 dígitos como máximo" }
  ], children: i.jsx(Hr, { size: "large", style: { width: "100%" }, placeholder: "Ingrese el NCF", disabled: P?.EstadoId !== n.Borrador }) }) }) })] }) }), i.jsx(K, { form: a, layout: "vertical", children: i.jsx(rn, { area: "Compras", formInstance: a, isFleteActive: l, formConfig: c, dataSource: D, loading: F, DocumentData: $, setDataSource: x, detailInConflict: N, setDetailInConflict: V, disabled: $?.EstadoId !== n.Borrador, tax: O?.Valor ? O?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: o, isFleteEnable: !l, dataSource: D, isLoading: F, formIntanceConfig: c, detailInConflict: N, setDetailInConflict: V, Total: De(M[0].Total), Importe: De(M[0].Importe), ValidationDetails: "FacturaCompraDetallesLotes", Subtotal: De(M[0].SubTotal), Descuento: De(M[0].Descuento), Impuestos: De(M[0].Impuestos), Retenciones: De(M[0].Retenciones), IsBorradorDocument: P?.EstadoId == n.Borrador, IsRecurringDocument: P?.FacturasComprasRecurrentesFacturaId !== null, methods: {
    handleSaveBorrador: W,
    handleVolverABorrador: ee,
    handleSaveNormal: P?.FacturasComprasRecurrentesFacturaId !== null ? () => g(!0) : B
  } })] }), i.jsx(ua, { Open: w, setOpen: j, dataContact: C.data, optionsContacts: b, Title: "Información del proveedor", isContactInfoLoading: C.isLoading }), i.jsx(Fs, { isOpen: h, setIsOpen: g, formRecurring: s, changeStateLoading: A.isPending, methodOk: () => {
    B(), g(!1);
  } })] });
}, nN = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = FS(), o = async () => {
    await se.promise(n.mutateAsync(a.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), {
      loading: "Clonando la factura de compra",
      error: () => "Error al clonar la factura de compra",
      success: (u) => (t("../factura-compra/" + u[0].FacturaId), `La factura de compra ${e} ha sido clonada correctamente`)
    });
  }, a = Yr({
    Table: "Facturas-Compras",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), s = sh(a.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), c = async () => {
    await se.promise(s.mutateAsync({
      EstadoId: r.Borrador,
      FacturaId: a.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la factura a borrador",
      error: () => "Error al volver la factura de compra a borrador",
      success: () => (t("../factura-compra/" + e), `La factura de compra ${e} ahora está en borrador`)
    });
  }, l = () => {
    const u = a.data?.Result?.DocumentPrincipalDataInfo?.LotesUsados, f = a.data?.Result?.DocumentPrincipalDataInfo?.SeriesUsadas;
    u ? se.error("Los lotes creados en esta factura de compra ya han sido usados en una factura de venta") : f ? se.error("Las series creadas en esta factura de compra ya han sido usadas en una factura de venta") : c();
  }, d = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Facturas-Compras", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: a.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId || 0 })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Compras", TableData: "Facturas-Compras", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Compras", LlevaInfoEntrega: !1, TableData: "Facturas-Compras", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: a.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    },
    ...a.data?.Result?.DocumentPrincipalDataInfo?.EsRecurrente ? [
      {
        key: "4",
        label: "Recurrencia",
        children: i.jsx(gg, { TableData: "Facturas-Compras", DocumentoId: parseInt(e || "0", 10) })
      }
    ] : []
  ];
  return i.jsx(i.Fragment, { children: a.isLoading ? i.jsx(Ct, {}) : a.isSuccess ? a.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Compras", RouteNavigate: "factura-compra", isPending: a.isPending, ExecuteBackToDraft: l, ExecuteClonate: o, isFetching: a.isFetching, ContactInfo: a.data?.Result?.ContactDataInfo, PrincipalInfo: a.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: d, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : a.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de compra"
  }) : i.jsx(Ct, {}) : a.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de compra"
  }) : i.jsx(Ct, {}) });
}, oN = () => {
  const { id: e } = _t(), t = xt(), [r, n] = k.useState(""), [o, a] = k.useState(!1), [s, c] = k.useState({}), [l] = K.useForm(), [d] = K.useForm(), [u] = K.useForm(), [f] = K.useForm(), h = K.useWatch("IsFlete", d), g = K.useWatch("Flete", d), E = K.useWatch("TipoPlazoId", d), v = K.useWatch("ClienteId", d), m = K.useWatch("ClienteDNITipoId", d), { data: y } = Dh();
  k.useEffect(() => {
    u.setFieldValue("DireccionEnvio", null), u.setFieldValue("FechaEntrega", null), u.setFieldValue("ContactDirection", null);
  }, [v, u]);
  const { docTypes: I, statesValues: b, tiposPlazosValues: C } = et(), [S, T] = k.useState(), V = Zp().data?.map((ie) => ({ value: ie.TipoPlazoId, label: ie.TipoPlazoNombre })), { isError: D, data: x, isLoading: O, isSuccess: w } = nS({
    FacturaId: Number.parseInt(e ?? "")
  });
  k.useEffect(() => {
    E === C.Contado && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date())), E === C._7_Dias && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(7, "day")), E === C._15_Dias && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(15, "day")), E === C._30_Dias && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(30, "day")), E === C._60_Dias && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(60, "day")), E === C._90_Dias && d.setFieldValue("Vencimiento", rt(/* @__PURE__ */ new Date()).add(90, "day"));
  }, [d, E, C]);
  const { data: j, isLoading: $ } = la(1, v, r), _ = [
    {
      DNI: "",
      value: null,
      ArchivoId: 0,
      key: "0 sin cliente",
      fullName: "Sin cliente"
    },
    ...j?.map((ie) => ({
      DNI: ie.DNI,
      value: ie.ContactoId,
      fullName: ie.FullName,
      ArchivoId: ie.ArchivoId,
      key: ie.ContactoId + ie.ContentType
    })) || []
  ];
  k.useEffect(() => {
    n("");
  }, [v]);
  const A = da(v), R = LO(), P = MO(), [z, F] = k.useState([]), { data: L } = Qr(), [M, B] = k.useState(!1), [W, ee] = k.useState(!1), [te, de] = k.useState(void 0);
  k.useEffect(() => {
    if (w && x !== void 0) {
      const ie = x.FacturasVentasDetallesFacturaId?.map((be, Ie) => {
        const Pe = {
          Key: Ie,
          ...be,
          DocumentoId: be.FacturaId,
          DocumentoDetalleId: be.DetalleId
        };
        return {
          ...Bt(Pe, [
            "FacturaId",
            "DetalleId"
          ])
        };
      }), ge = {
        ...x,
        ContactoId: x.ClienteId,
        DocumentoId: x.FacturaId,
        ContactoDNI: x.ClenteDNI,
        Secuencia: x.FacturaNumero,
        DocumentosDetallesDocumentoId: ie,
        TipoDocumentoId: I.Factura_de_venta,
        ContactoNombre: x.ClienteNombre
      };
      de(Bt(ge, ["FacturaId", "Recibo"])), F(ie);
    }
  }, [w, x, I.Factura_de_venta]), k.useEffect(() => {
    h || d.setFieldValue("Flete", "");
  }, [h, d]);
  const Z = Mg(x?.FacturaId), ce = k.useMemo(() => f.getFieldValue("Retenciones")?.length > 0 ? f.getFieldValue("Retenciones")?.reduce((ie, ge) => [...ie, JSON.parse(ge)], []) : 0, [f]), Y = Un(z, ce || [], g), [he, ve] = k.useState(!1), ue = async () => {
    const ie = d.getFieldsValue(), ge = u.getFieldsValue(), be = f.getFieldsValue(), Ie = l.getFieldsValue(), Pe = x?.FacturasVentasRecurrentesFacturaId !== null ? {
      EstadoId: b.Activo,
      FacturaId: x?.FacturaId || 0,
      EsLimitado: Ie.EsLimitado,
      FechaInicio: Ie.FechaInicio,
      FrecuenciaId: Ie.FrecuenciaId,
      EnviarPorCorreo: Ie.EnviarPorCorreo,
      CantidadVeces: Ie.CantidadVeces || 0,
      CrearComoBorrador: Ie.CrearComoBorrador,
      FechaProxima: Ss(Ie.FechaInicio, Ie.FrecuenciaId)
    } : void 0, Le = {
      DNI: ie.ClenteDNI,
      Telefono: ie.ClienteTelefono,
      FacturaId: x?.FacturaId,
      DNITipoId: ie.ClienteDNITipoId,
      Direccion: ie.ClienteDireccion,
      NombreCompleto: A.data ? A.data?.ContactoNombre + " " + A.data?.ContactoApellido : ie.ClienteNombre
    }, Ve = {
      Flete: ie.Flete,
      Fecha: ie.Fecha,
      Notas: ge.Notas,
      Total: Y[0].Total,
      EstadoId: b.Activo,
      TipoNCFId: ie.TipoNCFId,
      Importe: Y[0].Importe,
      ClienteId: ie?.ClienteId,
      TipoPlazoId: ie.TipoPlazoId,
      Referencia: be.Referencia,
      Descuento: Y[0].Descuento,
      Impuestos: Y[0].Impuestos,
      FacturaId: x?.FacturaId,
      FechaEntrega: ge.FechaEntrega,
      Retenciones: Y[0].Retenciones,
      FechaVencimiento: ie.Vencimiento,
      Observaciones: ge.Observaciones,
      ListaPrecioId: be.ListaPrecioId,
      DireccionEnvio: ge.DireccionEnvio,
      FacturaNumero: x?.FacturaNumero,
      Tasa: be.Tasa || x?.Tasa,
      ImpuestosIncluidos: be.ImpuestosIncluidos,
      TieneDescuentoPorFecha: be.TieneDescuentoPorFecha,
      MonedaId: be.MonedaId || x?.MonedaId,
      TasaFecha: be.TasaFecha || x?.TasaFecha,
      AlmacenId: be.AlmacenId || x?.AlmacenId,
      ClenteDNI: A.data ? A.data?.DNI : ie.ClenteDNI,
      FacturasVentasClienteFacturaId: ie?.ClienteId ? void 0 : Le,
      Recibo: x?.FacturasVentasRecurrentesFacturaId ? void 0 : s,
      Monto: Y[0].Importe - Y[0].Descuento + Y[0].Retenciones,
      VendedorId: be.Vendedor ? be.Vendedor : x?.VendedorId || void 0,
      FechaLimiteDescuento: be.TieneDescuentoPorFecha ? be.FechaLimiteDescuento : void 0,
      FacturasVentasRecurrentesFacturaId: x?.FacturasVentasRecurrentesFacturaId ? Pe : void 0,
      ClienteNombre: A.data ? A.data?.ContactoNombre + " " + A.data?.ContactoApellido : ie.ClienteNombre,
      FacturasVentasDetallesFacturaId: z?.map((_e) => ({
        Total: _e.Total,
        Codigo: _e.Codigo,
        Cantidad: _e.Cantidad,
        SubTotal: _e.SubTotal,
        Impuesto: _e.Impuesto,
        Descuento: _e.Descuento,
        ProductoId: _e.ProductoId,
        Referencia: _e.Referencia,
        EstadoId: b.Activo,
        Descripcion: _e.Descripcion,
        CostoUnitario: _e.CostoUnitario,
        UnidadMedidaId: _e.UnidadMedidaId,
        PrecioUnitario: _e.PrecioUnitario,
        FacturaId: x?.FacturaId,
        DetalleId: _e.DocumentoDetalleId || 0,
        DescuentoUnitario: _e.DescuentoUnitario,
        Flete: ie.Flete / z.length,
        DescuentoEsPorcentual: _e.DescuentoEsPorcentual,
        DetallesFacturaVentaLotes: _e.FacturaVentaDetalleLotes,
        DetallesFacturaVentaSeries: _e.FacturaVentaDetalleSeries
      }))
    };
    await se.promise(R.mutateAsync(Ve), {
      error: (_e) => _e,
      loading: "Guardando factura de venta",
      success: () => (t("../factura-venta-detalles/" + e), `Factura de venta ${e} guardada correctamente`)
    });
  }, le = async () => {
    const ie = d.getFieldsValue(), ge = u.getFieldsValue(), be = f.getFieldsValue(), Ie = {
      DNI: ie.ClenteDNI,
      Telefono: ie.ClienteTelefono,
      FacturaId: x?.FacturaId,
      DNITipoId: ie.ClienteDNITipoId,
      Direccion: ie.ClienteDireccion,
      NombreCompleto: A.data ? A.data?.ContactoNombre + " " + A.data?.ContactoApellido : ie.ClienteNombre
    }, Pe = {
      Fecha: ie.Fecha,
      Flete: ie.Flete,
      Notas: ge.Notas,
      Total: Y[0].Total,
      TipoNCFId: ie.TipoNCFId,
      Importe: Y[0].Importe,
      EstadoId: b.Borrador,
      ClienteId: ie?.ClienteId,
      TipoPlazoId: ie.TipoPlazoId,
      Referencia: be.Referencia,
      Descuento: Y[0].Descuento,
      Impuestos: Y[0].Impuestos,
      FacturaId: x?.FacturaId,
      FechaEntrega: ge.FechaEntrega,
      Retenciones: Y[0].Retenciones,
      FechaVencimiento: ie.Vencimiento,
      Observaciones: ge.Observaciones,
      ListaPrecioId: be.ListaPrecioId,
      DireccionEnvio: ge.DireccionEnvio,
      FacturaNumero: x?.FacturaNumero,
      Tasa: be.Tasa || x?.Tasa,
      ImpuestosIncluidos: be.ImpuestosIncluidos,
      MonedaId: be.MonedaId || x?.MonedaId,
      TasaFecha: be.TasaFecha || x?.TasaFecha,
      AlmacenId: be.AlmacenId || x?.AlmacenId,
      TieneDescuentoPorFecha: be.TieneDescuentoPorFecha === !0,
      ClenteDNI: A.data ? A.data?.DNI : ie.ClenteDNI,
      FacturasVentasClienteFacturaId: ie?.ClienteId ? void 0 : Ie,
      Monto: Y[0].Importe - Y[0].Descuento + Y[0].Retenciones,
      VendedorId: be.Vendedor ? be.Vendedor : x?.VendedorId || void 0,
      FechaLimiteDescuento: be.TieneDescuentoPorFecha ? be.FechaLimiteDescuento : null,
      ClienteNombre: A.data ? A.data?.ContactoNombre + " " + A.data?.ContactoApellido : ie.ClienteNombre,
      FacturasVentasDetallesFacturaId: z?.map((Ve) => ({
        Total: Ve.Total,
        Codigo: Ve.Codigo,
        Cantidad: Ve.Cantidad,
        SubTotal: Ve.SubTotal,
        Impuesto: Ve.Impuesto,
        Descuento: Ve.Descuento,
        ProductoId: Ve.ProductoId,
        Referencia: Ve.Referencia,
        EstadoId: b.Activo,
        Descripcion: Ve.Descripcion,
        CostoUnitario: Ve.CostoUnitario,
        UnidadMedidaId: Ve.UnidadMedidaId,
        PrecioUnitario: Ve.PrecioUnitario,
        FacturaId: x?.FacturaId,
        DetalleId: Ve.DocumentoDetalleId || 0,
        DescuentoUnitario: Ve.DescuentoUnitario,
        Flete: ie.Flete / z.length,
        DescuentoEsPorcentual: Ve.DescuentoEsPorcentual
      }))
    }, Le = u.getFieldsValue();
    !Le || Le?.FechaEntrega == null || Le.DireccionEnvio == null ? (a(!0), Or.warning("Faltan algunos campos"), Le?.FechaEntrega == null && u.getFieldInstance("FechaEntrega")?.focus(), Le.DireccionEnvio == null && u.getFieldInstance("DireccionEnvio")?.focus()) : (a(!1), await se.promise(P.mutateAsync(Pe), {
      error: (Ve) => Ve,
      loading: "Guardando factura de venta en borrador",
      success: () => (t("../factura-venta-detalles/" + e), `Factura de venta ${e} guardada correctamente`)
    }));
  }, Fe = async () => {
    await se.promise(Z.mutateAsync({
      EstadoId: b.Borrador,
      FacturaId: x?.FacturaId || 0
    }), {
      loading: "Devolviendo la factura de venta a borrador",
      error: () => "Error al volver factura de venta a borrador",
      success: () => `La factura de venta ${e} ahora está en borrador`
    });
  }, He = () => {
    const ie = u.getFieldsValue();
    !ie || ie?.FechaEntrega == null || ie.DireccionEnvio == null ? (a(!0), Or.warning("Faltan algunos campos"), ie?.FechaEntrega == null && u.getFieldInstance("FechaEntrega")?.focus(), ie.DireccionEnvio == null && u.getFieldInstance("DireccionEnvio")?.focus()) : (a(!1), x?.FacturasVentasRecurrentesFacturaId ? ve(!0) : We());
  }, We = () => {
    ee(!0);
  };
  return D ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de venta"
  }) : R.isPending || P.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(bn, { loading: O, title: `Factura de venta ${te?.Secuencia !== "0" && te !== void 0 ? te?.Secuencia : ""}`, children: O ? i.jsx(Vr, { size: "large", isLoading: O, title: "Cargando la de factura de venta" }) : i.jsxs(K, { form: d, layout: "vertical", disabled: te?.EstadoId !== b.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { required: !1, Label: "Cliente", Name: "ClienteId", contactoId: v, TitleView: "Ver cliente", setSearch: n, optionsContacts: _, setOpenDrawerIC: B, Placeholder: "Seleccione el cliente", isContactsLoading: $, initialValue: x?.ClienteId, disabled: x?.EstadoId !== b.Borrador }) }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(ii, { area: "Ventas", initialValue: x?.TipoNCFId, documentTypeId: I.Factura_de_venta, disabled: x?.EstadoId !== b.Borrador }) }), i.jsx(Ut, { children: i.jsx(K.Item, { name: "TipoPlazoId", label: "Tipo de plazo:", initialValue: x?.TipoPlazoId, rules: [
    { required: !0, message: "Este campo es requerido" }
  ], children: i.jsx(Ht, { size: "large", options: V, placeholder: "Seleccione el tipo de plazo" }) }) })] }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { name: "Vencimiento", label: "Vencimiento:", initialValue: rt(x?.FechaVencimiento), rules: [
    { required: !0, message: "Este campo es requerido" }
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" }, disabled: C.VencimientoManual !== E }) }) }), i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", initialValue: rt(x?.Fecha), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) })] }), v === null ? i.jsxs(i.Fragment, { children: [i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { name: "ClienteNombre", style: { width: "100%" }, label: "Cliente nombre:", initialValue: x?.FacturasVentasClienteFacturaId?.NombreCompleto, children: i.jsx(Hr, { size: "large", style: { width: "100%" }, placeholder: "Nombre Completo" }) }) }), i.jsx(Ut, { children: i.jsx(K.Item, { label: "DNI", name: "ClenteDNI", style: { width: "100%" }, initialValue: x?.FacturasVentasClienteFacturaId?.DNI, rules: [
    {
      min: m == 1 || m == 4 ? 11 : void 0,
      message: `${m == 1 || m == 4 ? 11 : void 0} dígitos como mínimo`
    },
    {
      max: m == 1 || m == 4 ? 11 : void 0,
      message: `${m == 1 || m == 4 ? 11 : void 0} dígitos como máximo`
    }
  ], children: i.jsx(Hr, { size: "large", placeholder: "DNI", style: { width: "100%" }, disabled: m === void 0, maxLength: m == 1 || m == 4 ? 11 : void 0, addonBefore: i.jsx(K.Item, { noStyle: !0, name: "ClienteDNITipoId", initialValue: x?.FacturasVentasClienteFacturaId?.DNITipoId, children: i.jsx(Ht, { size: "large", style: { width: 100 }, options: y?.map((ie) => ({
    value: ie.ContactoTipoDNIId,
    label: ie.ContactoTipoDNINombre
  })) }) }) }) }) })] }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { label: "Teléfono", name: "ClienteTelefono", initialValue: x?.FacturasVentasClienteFacturaId?.Telefono, children: i.jsx(Vn, { size: "large", maxLength: 10, controls: !1, placeholder: "Teléfono", style: { width: "100%" } }) }) }), i.jsx(Ut, { children: i.jsx(K.Item, { label: "Dirección", name: "ClienteDireccion", initialValue: x?.FacturasVentasClienteFacturaId?.Direccion, children: i.jsx(Ja, { autoSize: !0, size: "large", placeholder: "Dirección" }) }) })] })] }) : void 0] }) }), i.jsx(rn, { area: "Ventas", alert: o, formInstance: u, clientId: v, isFleteActive: h, formConfig: f, dataSource: z, loading: O, DocumentData: te, setDataSource: F, detailInConflict: S, setDetailInConflict: T, disabled: te?.EstadoId !== b.Borrador, tax: L?.Valor ? L?.Valor : "false" })] }), i.jsx(Xr, { formInstance: d, isFleteEnable: !h, dataSource: z, isLoading: O, formIntanceConfig: f, detailInConflict: S, setDetailInConflict: T, Total: De(Y[0].Total), ValidationDetails: "FacturaVentaDetallesLotes", Importe: De(Y[0].Importe), Subtotal: De(Y[0].SubTotal), Descuento: De(Y[0].Descuento), Impuestos: De(Y[0].Impuestos), Retenciones: De(Y[0].Retenciones), enabled: te?.EstadoId === b.Borrador, IsBorradorDocument: x?.EstadoId == b.Borrador, IsRecurringDocument: x?.FacturasVentasRecurrentesFacturaId !== null, methods: {
    handleSaveBorrador: le,
    handleSaveNormal: () => He(),
    handleVolverABorrador: Fe
  } })] }), i.jsx(ua, { Open: M, setOpen: B, dataContact: A.data, Title: "Información del cliente", optionsContacts: _, isContactInfoLoading: A.isLoading }), i.jsx(kE, { clientId: v, receiptData: s, open: W, ContactoInfo: A, setReceiptData: c, handleSaveNormal: ue, onClose: () => {
    ee(!1);
  }, paymentProps: {
    SubTotal: Y[0].SubTotal,
    Impuestos: Y[0].Impuestos,
    Retenciones: Y[0].Retenciones,
    FacturaId: te?.DocumentoId || 0,
    TotalPagar: Math.round(Y[0].Total),
    Monto: Y[0].Importe - Y[0].Descuento + Y[0].Retenciones
  } }), i.jsx(Fs, { isOpen: he, setIsOpen: ve, formRecurring: l, changeStateLoading: Z.isPending, methodOk: () => {
    ue(), ve(!1);
  } })] });
}, aN = () => {
  const { statesValues: e } = et(), [t] = Vt.useForm(), [r, n] = k.useState(""), o = (D) => {
    n(D.target.value);
  }, a = xt(), [s, c] = k.useState({ Action: "", Open: !1 }), [l, d] = k.useState(), u = rh(), [f, h] = k.useState(!1), g = Ds("Compra"), E = zg(), v = rS();
  ri();
  const m = Es(), y = Jp(1), I = AS(l?.DocumentoId), b = async (D, x) => {
    await se.promise(E.mutateAsync({
      isComprasArea: 0,
      tipoDocumentoId: x,
      documentoId: l?.DocumentoId || 0,
      isRecurrente: l?.Recurrencia ? 1 : 0
    }), {
      error: () => "Error clonando documento",
      loading: kg(D, l?.DocumentoNumero || "", !0),
      success: (O) => (a(`${D}/${O}`), Ug(D, !0))
    });
  }, C = ai(), S = [
    {
      key: "Secuencia",
      title: "Secuencia",
      dataIndex: "Secuencia",
      sorter: (D, x) => D.DocumentoNumero.localeCompare(x.DocumentoNumero),
      render: (D, x, O) => x.DocumentoNumero == "0" ? i.jsx(rr.Status, { state: "Pendiente" }) : i.jsx(nr, { onClick: () => {
        C(x.TipoDocumentoId, x.DocumentoId, "Compras");
      }, children: x.DocumentoNumero }, `sec ${x.DocumentoId} ${O}`)
    },
    {
      key: "TipoDocumentoId",
      title: "Tipo de documento",
      dataIndex: "TipoDocumentoId",
      onFilter: (D, x) => x.TipoDocumentoId === D,
      filters: y.data?.map((D) => ({
        value: D.DocumentoTipoId,
        text: D.DocumentoTipoNombre
      })),
      render: (D, x, O) => i.jsx(i.Fragment, { children: i.jsx("span", { children: x.TipoDocumentoNombre }, `DocTypeName ${x.DocumentoId} ${O}`) })
    },
    {
      key: "Fecha",
      title: "Fecha",
      dataIndex: "Fecha",
      filterDropdown: Ko,
      render: (D) => bt(D).format("DD/MM/YYYY"),
      sorter: (D, x) => new Date(D.Fecha).getTime() - new Date(x.Fecha).getTime(),
      onFilter: (D, x) => {
        if (typeof D != "string" && typeof D != "number")
          return !1;
        const O = bt(D, "DD/MM/YYYY");
        return O.isValid() && bt(x.Fecha).isSame(O, "D");
      }
    },
    {
      width: 300,
      key: "Proveedor",
      title: "Proveedor",
      dataIndex: "NombreApellido",
      sorter: (D, x) => `${D?.ProveedorNombre}`.localeCompare(`${x?.ProveedorNombre}`),
      render: (D, x) => x?.ProveedorNombre && x?.ProveedorNombre !== "- -" ? x?.ProveedorNombre : i.jsx(rr.Status, { state: "Pendiente" })
    },
    {
      width: 150,
      title: "Estado",
      key: "EstadoId",
      dataIndex: "EstadoId",
      render: (D, x) => i.jsx(rr.Status, { state: x.EstadoNombre }),
      onFilter: (D, x) => x.EstadoId === D,
      filters: m.data?.map((D) => ({
        value: D.EstadoId,
        text: D.EstadoNombre
      }))
    },
    {
      align: "center",
      key: "Recurrencia",
      title: "Recurrencia",
      dataIndex: "Recurrencia",
      render: (D, x) => ld(x.Recurrencia),
      onFilter: (D, x) => x.Recurrencia === D,
      filters: [
        { value: !0, text: "Solo recurrentes" },
        { value: !1, text: "No recurrentes" }
      ]
    },
    {
      title: "",
      width: 50,
      fixed: "right",
      key: "Acciones",
      render: (D, x, O) => i.jsx(Lg, { type: "compra", record: x, indexRender: O, setSelectedItem: d, methods: {
        setIsOpenModalRec: h,
        handleCreateClonar: b,
        setModalActionChangeState: c
      } })
    }
  ], T = k.useMemo(() => !v.data || v.isLoading || v?.data?.length === 0 || v.data === void 0 ? [] : (Array.isArray(v?.data) ? v?.data?.map((x) => ({ ...x, Fecha: rt(x.Fecha).format("YYYY-MM-DD") })) : []).reduce((x, O) => {
    const w = r.toLowerCase(), j = `${O.ProveedorNombre}`;
    return `${O?.Secuencia}`.toLocaleLowerCase().includes(w) || `${O?.Fecha}`.toLowerCase().includes(w) || j.toLowerCase().includes(w) || `${O.EstadoNombre}`.toLowerCase().includes(w) || `${O.TipoDocumentoNombre}`.toLowerCase().includes(w) ? [...x, { ...O, proveedorNombre: j }] : x;
  }, []), [v.data, v.isLoading, r]);
  k.useEffect(() => {
    g.isSuccess && c({ Action: "", Open: !1 });
  }, [g.isSuccess]), k.useEffect(() => {
    u.isSuccess && h(!1);
  }, [u.isSuccess]);
  const N = async () => {
    const D = t.getFieldsValue(), x = {
      EstadoId: e.Activo,
      FacturaId: l?.DocumentoId || 0,
      FechaInicio: D.FechaInicio,
      FrecuenciaId: D.FrecuenciaId,
      EsLimitado: D.EsLimitado || !1,
      CantidadVeces: D.CantidadVeces || 0,
      EnviarPorCorreo: D.EnviarPorCorreo || !1,
      CrearComoBorrador: D.CrearComoBorrador || !1,
      FechaProxima: Ss(D.FechaInicio, D.FrecuenciaId)
    };
    await se.promise(I.mutateAsync(x), {
      loading: "Volviendo factura como recurrente",
      error: "Error volviendo la factura a borrador",
      success: () => (a("factura-compra-detalles/" + l?.DocumentoId), "Factura de compra convertida a recurrente")
    });
  }, V = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay facturas de compra agregadas." }) }), []);
  return i.jsxs(i.Fragment, { children: [i.jsx(_s, { area: "Compras", changeState: g, selectedItem: l, modalAction: s, setModalAction: c }), i.jsx(Ln, { columns: S, title: "Área de compras", dataSource: T, skeletonLoadingRowCount: 5, placeholderSearch: "Búsqueda...", skeletonLoading: v.isPending, onChangeSearch: Mn({ delay: 500 }, o), onSearch: (D) => {
    r !== D && n(D);
  }, renderHeadActions: [
    i.jsx(wt, { ghost: !0, size: "large", type: "primary", renderLeftIcon: i.jsx(me, { name: "currency-xrp" }), onClick: () => a("facturas-compras-recurrentes"), children: "Documentos recurrentes" }, "DR_BUTTON"),
    i.jsx(qg, { isSalesArea: !1 }, "NEW_BUTTON")
  ], tableProps: {
    scroll: { x: S.length * 160 },
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    loading: v.isFetching || m.isFetching || g.isPending || E.isPending,
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: V(),
      filterEmptyText: "Sin filtros"
    }
  } }), i.jsx(Fs, { isOpen: f, setIsOpen: h, formRecurring: t, changeStateLoading: g.isPending, methodOk: () => {
    N(), h(!1);
  } })] });
}, iN = () => {
  const { id: e } = _t(), [t] = K.useForm(), [r, n] = k.useState(""), { docTypes: o, statesValues: a } = et(), [s] = K.useForm(), [c] = K.useForm(), l = K.useWatch("IsFlete", s), d = K.useWatch("Flete", s), u = xt(), f = K.useWatch("ProveedorId", s), { data: h, isLoading: g } = la(2, f, r), E = [
    ...h?.map((z) => ({
      DNI: z.DNI,
      value: z.ContactoId,
      fullName: z.FullName,
      ArchivoId: z.ArchivoId,
      key: z.ContactoId + z.ContentType
    })) || []
  ], v = da(f), m = xS(), y = IS(), [I, b] = k.useState([]), { data: C } = Qr(), [S, T] = k.useState(!1), [N, V] = k.useState(void 0), { isError: D, data: x, isSuccess: O, isLoading: w } = gS({
    OrdenId: Number.parseInt(e ?? "")
  });
  k.useEffect(() => {
    if (O && x !== void 0) {
      const z = x.OrdenesComprasDetalleOrdenId?.map((L) => {
        const M = {
          ...L,
          DocumentoId: L.OrdenId,
          DocumentoDetalleId: L.DetalleId
        };
        return {
          ...Bt(M, [
            "OrdenId",
            "DetalleId"
          ])
        };
      }), F = {
        ...x,
        DocumentoId: x.OrdenId,
        Secuencia: x.OrdenNumero,
        TipoDocumentoId: o.Orden_de_compra,
        ContactoId: x.ProveedorId,
        DocumentosDetallesDocumentoId: z,
        ContactoDNI: x.ProveedorDNI,
        ContactoNombre: x.ProveedorNombre,
        FechaVencimientoNCF: x.FechaVencimientoNCF
      };
      V(Bt(F, ["OrdenId"])), b(z);
    }
  }, [O, x, o.Orden_de_compra]);
  const j = k.useMemo(() => c.getFieldValue("Retenciones")?.length > 0 ? c.getFieldValue("Retenciones")?.reduce((z, F) => [...z, JSON.parse(F)], []) : 0, [c]), $ = Un(I, j || [], d), _ = async () => {
    const z = s.getFieldsValue(), F = t.getFieldsValue(), L = c.getFieldsValue(), M = {
      Monto: 0,
      Tasa: L.Tasa,
      Fecha: z?.Fecha,
      Notas: F.Notas,
      Total: $[0].Total,
      Importe: N?.Importe,
      Referencia: z.Referencia,
      OrdenId: x?.OrdenId,
      ProveedorId: z.ProveedorId,
      Descuento: $[0].Descuento,
      Impuestos: $[0].Impuestos,
      Retenciones: $[0].Retenciones,
      Observaciones: F.Observaciones,
      ProveedorDNI: v.data?.DNI || "-",
      EstadoId: a.Pendiente_de_aprobacion,
      TasaFecha: L.TasaFecha || /* @__PURE__ */ new Date(),
      ImpuestosIncluidos: L.ImpuestosIncluidos,
      MonedaId: L.MonedaId || x?.MonedaId || 0,
      AlmacenId: L.AlmacenId || x?.AlmacenId || 0,
      ProveedorNombre: v.data ? v.data?.ContactoNombre + " " + v.data?.ContactoApellido : "Sin Proveedor",
      OrdenesComprasDetalleOrdenId: I?.map((B) => ({
        Total: B.Total,
        Codigo: B.Codigo,
        Cantidad: B.Cantidad,
        SubTotal: B.SubTotal,
        Impuesto: B.Impuesto,
        Descuento: B.Descuento,
        CreadoPor: B.CreadoPor,
        ProductoId: B.ProductoId,
        Referencia: B.Referencia,
        EstadoId: a.Activo,
        Descripcion: B.Descripcion,
        CostoUnitario: B.CostoUnitario,
        FechaCreacion: B.FechaCreacion,
        DetalleId: B.DocumentoDetalleId,
        UnidadMedidaId: B.UnidadMedidaId,
        PrecioUnitario: B.PrecioUnitario,
        DescuentoUnitario: B.DescuentoUnitario,
        OrdenId: N?.DocumentoId,
        DescuentoEsPorcentual: B.DescuentoEsPorcentual
      }))
    };
    await se.promise(m.mutateAsync(M), {
      loading: "Guardando orden de compra",
      error: "Error guardando orden de compra",
      success: () => (u("../orden-compra-detalles/" + e), `Orden de compra ${e} guardada correctamente`)
    });
  }, A = async () => {
    const z = s.getFieldsValue(), F = t.getFieldsValue(), L = c.getFieldsValue(), M = {
      Monto: 0,
      Fecha: z?.Fecha,
      Notas: F.Notas,
      Total: $[0].Total,
      Importe: N?.Importe,
      MonedaId: L.MonedaId,
      EstadoId: a.Borrador,
      AlmacenId: L.AlmacenId,
      Referencia: z.Referencia,
      OrdenId: x?.OrdenId,
      ProveedorId: z.ProveedorId,
      Descuento: $[0].Descuento,
      Impuestos: $[0].Impuestos,
      OrdenNumero: N?.Secuencia,
      Retenciones: $[0].Retenciones,
      Observaciones: F.Observaciones,
      ProveedorDNI: v.data?.DNI || "-",
      ImpuestosIncluidos: L.ImpuestosIncluidos,
      ProveedorNombre: v.data ? v.data?.ContactoNombre + " " + v.data?.ContactoApellido : "Sin Proveedor",
      OrdenesComprasDetalleOrdenId: I?.map((B) => ({
        Total: B.Total,
        Codigo: B.Codigo,
        Cantidad: B.Cantidad,
        SubTotal: B.SubTotal,
        Impuesto: B.Impuesto,
        Descuento: B.Descuento,
        CreadoPor: B.CreadoPor,
        ProductoId: B.ProductoId,
        Referencia: B.Referencia,
        EstadoId: a.Activo,
        Descripcion: B.Descripcion,
        CostoUnitario: B.CostoUnitario,
        FechaCreacion: B.FechaCreacion,
        DetalleId: B.DocumentoDetalleId,
        UnidadMedidaId: B.UnidadMedidaId,
        PrecioUnitario: B.PrecioUnitario,
        DescuentoUnitario: B.DescuentoUnitario,
        OrdenId: N?.DocumentoId,
        DescuentoEsPorcentual: B.DescuentoEsPorcentual
      }))
    };
    await se.promise(y.mutateAsync(M), {
      error: "Error guardando orden de compra",
      loading: "Guardando orden de compra en borrador",
      success: () => (u("../orden-compra-detalles/" + e), `Orden de compra ${e} guardada correctamente`)
    });
  }, R = ih(N?.DocumentoId), P = async () => {
    await se.promise(R.mutateAsync({
      EstadoId: a.Borrador,
      OrdenId: x?.OrdenId || 0
    }), {
      loading: "Devolviendo la orden de compra a borrador",
      error: () => "Error al volver la orden de compra a borrador",
      success: () => (setTimeout(() => location.reload(), 1500), `La orden de compra ${e} ahora está en borrador`)
    });
  };
  return D ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la orden de compra"
  }) : m.isPending || y.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(bn, { loading: w, title: `Orden de compra ${N?.Secuencia !== "0" && N !== void 0 ? N?.Secuencia : ""}`, children: w ? i.jsx(Vr, { size: "large", isLoading: w, title: "Cargando la orden de compra" }) : i.jsxs(Sn, { form: s, layout: "vertical", justifyContent: "flex-start", disabled: N?.EstadoId !== a.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { Label: "Proveedor", Name: "ProveedorId", contactoId: f, TitleView: "Ver proveedor", setSearch: n, optionsContacts: E, setOpenDrawerIC: T, isContactsLoading: g, Placeholder: "Seleccione el Proveedor", initialValue: x?.ProveedorId, disabled: N?.EstadoId !== a.Borrador }) }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", style: { width: "100%" }, initialValue: rt(x?.Fecha), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }), i.jsx(Ut, {})] })] }) }), i.jsx(K, { form: t, layout: "vertical", children: i.jsx(rn, { isOrden: !0, area: "Compras", formInstance: t, isFleteActive: l, formConfig: c, dataSource: I, loading: w, DocumentData: N, setDataSource: b, disabled: N?.EstadoId !== a.Borrador, tax: C?.Valor ? C?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: s, isFleteEnable: !l, dataSource: I, isLoading: w, formIntanceConfig: c, Total: De($[0].Total), Importe: De($[0].Importe), Subtotal: De($[0].SubTotal), Descuento: De($[0].Descuento), Impuestos: De($[0].Impuestos), Retenciones: De($[0].Retenciones), IsBorradorDocument: x?.EstadoId == a.Borrador, methods: {
    handleSaveNormal: _,
    handleSaveBorrador: A,
    handleVolverABorrador: P
  } })] }), i.jsx(ua, { Open: S, setOpen: T, dataContact: v.data, optionsContacts: E, Title: "Información del proveedor", isContactInfoLoading: v.isLoading })] });
}, Ms = ({ buttons: e }) => {
  const t = xt(), { dispatch: r } = lv();
  k.useEffect(() => (r({
    payload: e,
    type: "SET_ACTIONS"
  }), () => {
    r({
      type: "CLEAR_ACTIONS"
    });
  }), [e.length, r, t]);
}, { docTypes: sN, statesValues: Li } = et(), cN = () => {
  const { id: e } = _t(), t = xt(), r = SS(), n = async () => {
    await se.promise(r.mutateAsync(o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), {
      loading: "Clonando la orden de compra",
      error: () => "Error al clonar la orden de compra",
      success: (E) => (t("../orden-compra/" + E[0].OrdenId), `La orden de compra ${e} ha sido clonada correctamente`)
    });
  }, o = Yr({
    Table: "Ordenes-Compras",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), a = ih(o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), s = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: Li.Borrador,
      OrdenId: o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la orden de compra a borrador",
      error: () => "Error al volver la orden de compra a borrador",
      success: () => (t("../orden-compra/" + e), `La orden de compra ${e} ahora está en borrador`)
    });
  }, c = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: Li.Activo,
      OrdenId: o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Aprobando la orden de compra",
      error: () => "Error aprobando la orden de compra ",
      success: () => (setTimeout(() => location.reload(), 1500), `La orden de compra ${e} ahora está aprobada`)
    });
  }, l = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: Li.Anulado,
      OrdenId: o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Anulando la orden de compra",
      error: () => "Error al anular la orden de compra",
      success: () => (setTimeout(() => location.reload(), 1500), `La orden de compra ${e} ahora está anulada`)
    });
  }, d = zO(), u = ES(), f = async () => {
    const E = {
      TipoDocumentoId: sN.Orden_de_compra,
      OrdenId: o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    };
    await se.promise(d.mutateAsync(E), {
      loading: "Convirtiendo en factura de compra",
      error: "Error convirtiendo en factura de compra",
      success: (v) => (t("../factura-compra/" + v.FacturaId), `Orden de compra ${e} ha sido convertida a factura no. ${v.FacturaId}`)
    });
  }, h = async () => {
    const E = {
      OrdenId: o.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    };
    await se.promise(u.mutateAsync(E), {
      loading: "Convirtiendo en conduce",
      error: "Error convirtiendo en conduce",
      success: (v) => (t("../conduce-compra/" + v[0].ConduceId), `Orden de compra ${e} ha sido convertida a conduce no. ${v[0].ConduceId}`)
    });
  };
  Ms({
    buttons: [
      i.jsx(Ps, { ExecuteApprove: c, ExecuteOverride: l, ExecuteBackToDraft: s, ExecuteConvertToInvoice: f, ExecuteConvertToConduce: h, EstadoId: o.data?.Result?.DocumentPrincipalDataInfo?.EstadoId }, "BtnsPurchaseDetail")
    ]
  });
  const g = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Ordenes-Compras", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Compras", TableData: "Ordenes-Compras", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Compras", LlevaInfoEntrega: !1, TableData: "Ordenes-Compras", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: o.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: o.isLoading ? i.jsx(Ct, {}) : o.isSuccess ? o.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Compras", RouteNavigate: "orden-compra", ExecuteBackToDraft: s, isPending: o.isPending, isFetching: o.isFetching, ContactInfo: o.data?.Result?.ContactDataInfo, PrincipalInfo: o.data?.Result?.DocumentPrincipalDataInfo, ExecuteClonate: o.data?.Result?.DocumentPrincipalDataInfo.EstadoId == Li.Activo ? n : void 0 }), i.jsx(Kr, { type: "card", items: g, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : o.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la orden de compra"
  }) : i.jsx(Ct, {}) : o.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la orden de compra"
  }) : i.jsx(Ct, {}) });
}, lN = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = Yr({
    Table: "Facturas-Ventas",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), o = Mg(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), a = async () => {
    await se.promise(o.mutateAsync({
      EstadoId: r.Borrador,
      FacturaId: n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la factura de venta a borrador",
      error: () => "Error al volver factura de venta a borrador",
      success: () => (t("../factura-venta/" + e), `La factura de venta ${e} ahora está en borrador`)
    });
  }, s = _g(), c = async () => {
    await se.promise(s.mutateAsync(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), {
      loading: "Clonando la factura de venta",
      error: () => "Error al clonar la factura de venta",
      success: (d) => (t("../factura-venta/" + d[0].FacturaId), `La factura de venta ${e} ha sido clonada correctamente`)
    });
  }, l = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Facturas-Ventas", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Ventas", TableData: "Facturas-Ventas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Ventas", LlevaInfoEntrega: !0, TableData: "Facturas-Ventas", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    },
    ...n.data?.Result?.DocumentPrincipalDataInfo?.EsRecurrente ? [
      {
        key: "4",
        label: "Recurrencia",
        children: i.jsx(gg, { TableData: "Facturas-Ventas", DocumentoId: parseInt(e || "0", 10) })
      }
    ] : [],
    ...n.data?.Result?.DocumentPrincipalDataInfo?.TieneRecibo ? [
      {
        key: "5",
        label: "Información de pago",
        children: i.jsx(M1, { DocumentoId: parseInt(e || "0", 10) })
      }
    ] : []
  ];
  return i.jsx(i.Fragment, { children: n.isLoading ? i.jsx(Ct, {}) : n.isSuccess ? n.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "factura-venta", ExecuteBackToDraft: a, isPending: n.isPending, isFetching: n.isFetching, ExecuteClonate: c, ContactInfo: n.data?.Result?.ContactDataInfo, PrincipalInfo: n.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: l, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : n.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de venta"
  }) : i.jsx(Ct, {}) : n.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la factura de venta"
  }) : i.jsx(Ct, {}) });
}, { docTypes: dN, statesValues: uN } = et(), fN = () => {
  const { id: e } = _t(), t = xt(), r = Yr({
    Table: "Cotizaciones",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), n = jO(), o = async () => {
    await se.promise(n.mutateAsync(r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), {
      loading: "Clonando la cotización",
      error: () => "Error al clonar la cotización",
      success: (h) => (t("../cotizacion/" + h[0].CotizacionId), `La cotización ${e} ha sido clonada correctamente`)
    });
  }, a = Ag(r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), s = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: uN.Borrador,
      CotizacionId: r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la cotización a borrador",
      error: () => "Error al volver la cotización a borrador",
      success: () => (t("../cotizacion/" + e), `La cotización ${e} ahora está en borrador`)
    });
  }, c = BO(), l = $O(), d = async () => {
    const h = {
      TipoDocumentoId: dN.Cotizacion,
      CotizacionId: r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    };
    await se.promise(c.mutateAsync(h), {
      loading: "Convirtiendo en factura de venta",
      error: "Error convirtiendo en factura de venta",
      success: (g) => (t("../factura-venta/" + g.FacturaId), `Cotizacion ${e} ha sido convertida a factura no. ${g.FacturaId}`)
    });
  }, u = async () => {
    const h = {
      CotizacionId: r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    };
    await se.promise(l.mutateAsync(h), {
      loading: "Convirtiendo en conduce",
      error: "Error convirtiendo en conduce",
      success: (g) => (t("../conduce-venta/" + g[0].ConduceId), `Cotización ${e} ha sido convertida a conduce no. ${g[0].ConduceId}`)
    });
  };
  Ms({
    buttons: [
      i.jsx(Ps, { ExecuteBackToDraft: s, ExecuteConvertToConduce: u, ExecuteConvertToInvoice: d, EstadoId: r.data?.Result?.DocumentPrincipalDataInfo?.EstadoId }, "BtnsPurchaseDetail")
    ]
  });
  const f = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Cotizaciones", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Ventas", TableData: "Cotizaciones", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Ventas", LlevaInfoEntrega: !0, TableData: "Cotizaciones", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: r.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: r.isLoading ? i.jsx(Ct, {}) : r.isSuccess ? r.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "cotizacion", ExecuteClonate: o, ExecuteBackToDraft: s, isPending: r.isPending, isFetching: r.isFetching, ContactInfo: r.data?.Result?.ContactDataInfo, PrincipalInfo: r.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: f, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : r.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la cotización"
  }) : i.jsx(Ct, {}) : r.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la cotización"
  }) : i.jsx(Ct, {}) });
}, { docTypes: mN, statesValues: pN } = et(), hN = () => {
  const { id: e } = _t(), t = xt(), r = Yr({
    Table: "ConducesVentas",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), n = KO(), o = async () => {
    await se.promise(n.mutateAsync(r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), {
      loading: "Clonando conduce",
      error: () => "Error al clonar el conduce",
      success: (u) => (t("../conduce-venta/" + u[0].ConduceId), `El conduce ${e} ha sido clonada correctamente`)
    });
  }, a = Bg(r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0), s = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: pN.Borrador,
      ConduceId: r.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la factura a borrador",
      error: () => "Error al volver el conduce de venta a borrador",
      success: () => (t("../conduce-venta/" + e), `El conduce de venta ${e} ahora está en borrador`)
    });
  }, c = kO(), l = async () => {
    const u = {
      area: "ventas",
      TipoDocumentoId: mN.Conduce,
      ConduceId: r.data?.Result?.DocumentPrincipalDataInfo.DocumentoId || 0
    };
    await se.promise(c.mutateAsync(u), {
      loading: "Convirtiendo en factura de venta",
      error: "Error convirtiendo en factura de venta",
      success: (f) => (t("../factura-venta/" + f.FacturaId), `Conduce ${e} ha sido convertida a factura no. ${f.FacturaId}`)
    });
  };
  Ms({
    buttons: [
      i.jsx(Ps, { ExecuteBackToDraft: s, ExecuteConvertToInvoice: l, EstadoId: r.data?.Result?.DocumentPrincipalDataInfo?.EstadoId }, "BtnsPurchaseDetail")
    ]
  });
  const d = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "ConducesVentas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Ventas", TableData: "ConducesVentas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Ventas", LlevaInfoEntrega: !1, TableData: "ConducesVentas", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: r.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: r.isLoading ? i.jsx(Ct, {}) : r.isSuccess ? r.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "conduce-venta", ExecuteClonate: o, ExecuteBackToDraft: s, isPending: r.isPending, isFetching: r.isFetching, ContactInfo: r.data?.Result?.ContactDataInfo, PrincipalInfo: r.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: d, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : r.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de venta"
  }) : i.jsx(Ct, {}) : r.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de venta"
  }) : i.jsx(Ct, {}) });
}, gN = ({ ConduceId: e }) => Ye({
  enabled: !!e,
  networkMode: "online",
  queryKey: ["/ConducesVentas", e],
  queryFn: () => ia.getById(e || 0)
}), vN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), [o] = K.useForm(), a = K.useWatch("IsFlete", r), s = K.useWatch("Flete", r), [c, l] = k.useState(""), d = K.useWatch("ClienteId", r), { docTypes: u, statesValues: f } = et(), { isError: h, data: g, isLoading: E, isSuccess: v } = gN({
    ConduceId: Number.parseInt(e ?? "")
  }), { data: m, isLoading: y } = la(1, d, c), I = [
    {
      DNI: "",
      value: null,
      ArchivoId: 0,
      key: "0 sin cliente",
      fullName: "Sin cliente"
    },
    ...m?.map((F) => ({
      DNI: F.DNI,
      value: F.ContactoId,
      fullName: F.FullName,
      ArchivoId: F.ArchivoId,
      key: F.ContactoId + F.ContentType
    })) || []
  ], b = da(d), C = GO(), S = WO(), [T, N] = k.useState([]), { data: V } = Qr(), [D, x] = k.useState(!1), O = Bg(g?.ConduceId), [w, j] = k.useState(void 0);
  k.useEffect(() => {
    if (v && g !== void 0) {
      const F = g.ConducesVentasDetallesConduceId?.map((M, B) => {
        const W = {
          Key: B,
          ...M,
          DocumentoId: M.ConduceId,
          DocumentoDetalleId: M.DetalleId
        };
        return {
          ...Bt(W, [
            "ConduceId",
            "DetalleId"
          ])
        };
      }), L = {
        ...g,
        TipoDocumentoId: u.Conduce,
        ContactoId: g.ClienteId,
        DocumentoId: g.ConduceId,
        ContactoDNI: g.ClenteDNI,
        Secuencia: g.ConduceNumero,
        DocumentosDetallesDocumentoId: F,
        ContactoNombre: g.ClienteNombre
      };
      j(Bt(L, ["ConduceId"])), N(F);
    }
  }, [v, g, u.Conduce]);
  const $ = k.useMemo(() => o.getFieldValue("Retenciones")?.length > 0 ? o.getFieldValue("Retenciones")?.reduce((F, L) => [...F, JSON.parse(L)], []) : 0, [o]), _ = Un(T, $ || [], s), A = (F) => {
    for (const L in F)
      return typeof F[L] > "u" ? (Or.info(`Falta el campo ${L}`), !1) : !0;
  }, R = async () => {
    const F = r.getFieldsValue(), L = n.getFieldsValue();
    if (A(F)) {
      const M = o.getFieldsValue(), B = {
        Fecha: F.Fecha,
        Notas: L.Notas,
        Total: _[0].Total,
        EstadoId: f.Activo,
        TipoNCFId: F.TipoNCFId,
        Importe: _[0].Importe,
        ClienteId: F?.ClienteId,
        Referencia: M.Referencia,
        Descuento: _[0].Descuento,
        Impuestos: _[0].Impuestos,
        ConduceId: g?.ConduceId,
        Retenciones: _[0].Retenciones,
        Observaciones: L.Observaciones,
        ConduceNumero: g?.ConduceNumero,
        ImpuestosIncluidos: M.ImpuestosIncluidos,
        Tasa: M.Tasa ? M.Tasa : g?.MonedaId,
        ClenteDNI: b.data ? b.data?.DNI : F.ClenteDNI,
        MonedaId: M.MonedaId ? M.MonedaId : g?.MonedaId,
        AlmacenId: M.AlmacenId ? M.AlmacenId : g?.MonedaId,
        VendedorId: M.Vendedor ? M.Vendedor : g?.VendedorId,
        TasaFecha: M.TasaFecha ? M.TasaFecha : g?.TasaFecha,
        Monto: _[0].Importe - _[0].Descuento + _[0].Retenciones,
        ListaPrecioId: M.ListaPrecioId ? M.ListaPrecioId : g?.ListaPrecioId,
        ClienteNombre: b.data ? b.data?.ContactoNombre + " " + b.data?.ContactoApellido : F.ClienteNombre,
        ConducesVentasDetallesConduceId: T?.map((W) => ({
          Total: W.Total,
          Codigo: W.Codigo,
          Cantidad: W.Cantidad,
          SubTotal: W.SubTotal,
          Impuesto: W.Impuesto,
          Descuento: W.Descuento,
          ProductoId: W.ProductoId,
          Referencia: W.Referencia,
          EstadoId: f.Activo,
          Descripcion: W.Descripcion,
          CostoUnitario: W.CostoUnitario,
          UnidadMedidaId: W.UnidadMedidaId,
          PrecioUnitario: W.PrecioUnitario,
          ConduceId: g?.ConduceId,
          DetalleId: W.DocumentoDetalleId || 0,
          DescuentoUnitario: W.DescuentoUnitario,
          DescuentoEsPorcentual: W.DescuentoEsPorcentual
        }))
      };
      await se.promise(C.mutateAsync(B), {
        error: (W) => W,
        loading: "Guardando conduce",
        success: () => (t("../conduce-venta-detalles/" + e), `conduce ${e} guardada correctamente`)
      });
    }
  }, P = async () => {
    const F = r.getFieldsValue(), L = o.getFieldsValue(), M = n.getFieldsValue(), B = {
      Tasa: L.Tasa,
      Fecha: F.Fecha,
      Notas: M.Notas,
      Total: _[0].Total,
      MonedaId: L.MonedaId,
      TipoNCFId: F.TipoNCFId,
      Importe: _[0].Importe,
      EstadoId: f.Borrador,
      ClienteId: F?.ClienteId,
      TasaFecha: L.TasaFecha,
      AlmacenId: L.AlmacenId,
      TipoPlazoId: F.TipoPlazoId,
      Referencia: L.Referencia,
      Descuento: _[0].Descuento,
      Impuestos: _[0].Impuestos,
      ConduceId: g?.ConduceId,
      Retenciones: _[0].Retenciones,
      FechaVencimiento: F.Vencimiento,
      Observaciones: M.Observaciones,
      ConduceNumero: g?.ConduceNumero,
      ImpuestosIncluidos: L.ImpuestosIncluidos,
      ClenteDNI: b.data ? b.data?.DNI : F.ClenteDNI,
      Monto: _[0].Importe - _[0].Descuento + _[0].Retenciones,
      VendedorId: L.Vendedor ? L.Vendedor : g?.VendedorId || void 0,
      ListaPrecioId: L.ListaPrecioId ? L.ListaPrecioId : g?.ListaPrecioId,
      ClienteNombre: b.data ? b.data?.ContactoNombre + " " + b.data?.ContactoApellido : F.ClienteNombre,
      ConducesVentasDetallesConduceId: T?.map((W) => ({
        Total: W.Total,
        Codigo: W.Codigo,
        Cantidad: W.Cantidad,
        SubTotal: W.SubTotal,
        Impuesto: W.Impuesto,
        Descuento: W.Descuento,
        ProductoId: W.ProductoId,
        Referencia: W.Referencia,
        EstadoId: f.Activo,
        Descripcion: W.Descripcion,
        CostoUnitario: W.CostoUnitario,
        UnidadMedidaId: W.UnidadMedidaId,
        PrecioUnitario: W.PrecioUnitario,
        ConduceId: g?.ConduceId,
        DetalleId: W.DocumentoDetalleId || 0,
        DescuentoUnitario: W.DescuentoUnitario,
        DescuentoEsPorcentual: W.DescuentoEsPorcentual
      }))
    };
    await se.promise(S.mutateAsync(B), {
      error: (W) => W,
      loading: "Guardando conduce en borrador",
      success: () => (t("../conduce-venta-detalles/" + e), `Conduce ${e} guardada correctamente`)
    });
  }, z = async () => {
    await se.promise(O.mutateAsync({
      EstadoId: f.Borrador,
      ConduceId: g?.ConduceId || 0
    }), {
      loading: "Devolviendo la conduce a borrador",
      error: () => "Error al volver conduce a borrador",
      success: () => `La conduce ${e} ahora está en borrador`
    });
  };
  return h ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de venta"
  }) : C.isPending || S.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(bn, { loading: E, title: `Conduce de venta ${w?.Secuencia !== "0" && w !== void 0 ? w?.Secuencia : ""}`, children: E ? i.jsx(Vr, { size: "large", isLoading: E, title: "Cargando conduce de venta" }) : i.jsxs(Sn, { form: r, layout: "vertical", disabled: w?.EstadoId !== f.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { Label: "Cliente", Name: "ClienteId", contactoId: d, TitleView: "Ver cliente", setSearch: l, optionsContacts: I, setOpenDrawerIC: x, Placeholder: "Seleccione el cliente", isContactsLoading: y, initialValue: g?.ClienteId, disabled: g?.EstadoId !== f.Borrador }) }), i.jsxs(Cr, { children: [i.jsx(kr, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", initialValue: rt(g?.Fecha), rules: [
    {
      required: !0,
      message: "Este campo es requerido"
    }
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }), i.jsx(kr, { children: i.jsx(ii, { area: "Ventas", documentTypeId: u.Conduce, initialValue: g?.TipoNCFId, disabled: g?.EstadoId !== f.Borrador }) })] })] }) }), i.jsx(K, { form: n, layout: "vertical", children: i.jsx(rn, { isOrden: !0, area: "Ventas", formInstance: n, isFleteActive: a, formConfig: o, dataSource: T, loading: E, DocumentData: w, setDataSource: N, disabled: w?.EstadoId !== f.Borrador, tax: V?.Valor ? V?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !a, dataSource: T, isLoading: E, formIntanceConfig: o, Total: De(_[0].Total), Importe: De(_[0].Importe), Subtotal: De(_[0].SubTotal), Descuento: De(_[0].Descuento), Impuestos: De(_[0].Impuestos), Retenciones: De(_[0].Retenciones), enabled: w?.EstadoId === f.Borrador, IsBorradorDocument: g?.EstadoId == f.Borrador, methods: {
    handleSaveNormal: R,
    handleSaveBorrador: P,
    handleVolverABorrador: z
  } })] }), i.jsx(ua, { Open: D, setOpen: x, dataContact: b.data, Title: "Información del cliente", optionsContacts: I, isContactInfoLoading: b.isLoading })] });
}, { docTypes: yN, statesValues: bN } = et(), CN = () => {
  const { id: e } = _t(), t = xt(), r = $S(), n = async () => {
    await se.promise(r.mutateAsync(o.data?.Result?.DocumentPrincipalDataInfo.DocumentoId || 0), {
      loading: "Clonando conduce",
      error: () => "Error al clonar el conduce",
      success: (u) => (t("../conduce-compra/" + u[0].ConduceId), `El conduce ${e} ha sido clonada correctamente`)
    });
  }, o = Yr({
    Table: "ConducesCompras",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), a = fh(o.data?.Result?.DocumentPrincipalDataInfo.DocumentoId || 0), s = async () => {
    await se.promise(a.mutateAsync({
      EstadoId: bN.Borrador,
      ConduceId: o.data?.Result?.DocumentPrincipalDataInfo.DocumentoId || 0
    }), {
      loading: "Devolviendo el conduce a borrador",
      error: () => "Error al volver el conduce a borrador",
      success: () => (t("../conduce-compra/" + e), `Conduce ${e} ahora está en borrador`)
    });
  }, c = UO(), l = async () => {
    const u = {
      area: "compras",
      TipoDocumentoId: yN.Conduce,
      ConduceId: o.data?.Result?.DocumentPrincipalDataInfo.DocumentoId || 0
    };
    await se.promise(c.mutateAsync(u), {
      loading: "Convirtiendo en factura de compra",
      error: "Error convirtiendo en factura de compra",
      success: (f) => (t("../factura-compra/" + f.FacturaId), `Conduce ${e} ha sido convertida a factura no. ${f.FacturaId}`)
    });
  };
  Ms({
    buttons: [
      i.jsx(Ps, { ExecuteBackToDraft: s, ExecuteConvertToInvoice: l, EstadoId: o.data?.Result?.DocumentPrincipalDataInfo.EstadoId }, "BtnsPurchaseDetail")
    ]
  });
  const d = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "ConducesCompras", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Compras", TableData: "ConducesCompras", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Compras", LlevaInfoEntrega: !1, TableData: "ConducesCompras", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: o.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: o.isLoading ? i.jsx(Ct, {}) : o.isSuccess ? o.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "conduce-compra", ExecuteBackToDraft: s, isPending: o.isPending, ExecuteClonate: n, isFetching: o.isFetching, ContactInfo: o.data?.Result?.ContactDataInfo, PrincipalInfo: o.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: d, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : o.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de compra"
  }) : i.jsx(Ct, {}) : o.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de compra"
  }) : i.jsx(Ct, {}) });
}, IN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), [o] = K.useForm(), a = K.useWatch("IsFlete", r), s = K.useWatch("Flete", r), [c, l] = k.useState(""), d = K.useWatch("ProveedorId", r), { docTypes: u, statesValues: f } = et(), { isError: h, data: g, isLoading: E, isSuccess: v } = oS({
    ConduceId: Number.parseInt(e ?? "")
  }), { data: m, isLoading: y } = la(2, d, c), I = [
    ...m?.map((F) => ({
      DNI: F.DNI,
      value: F.ContactoId,
      fullName: F.FullName,
      ArchivoId: F.ArchivoId,
      key: F.ContactoId + F.ContentType
    })) || []
  ], b = da(d), C = jS(), S = PS(), [T, N] = k.useState([]), { data: V } = Qr(), [D, x] = k.useState(!1), O = fh(g?.ConduceId), [w, j] = k.useState(void 0);
  k.useEffect(() => {
    if (v && g !== void 0) {
      const F = g.ConducesComprasDetallesConduceId?.map((M, B) => {
        const W = {
          Key: B,
          ...M,
          DocumentoId: M.ConduceId,
          DocumentoDetalleId: M.DetalleId
        };
        return {
          ...Bt(W, [
            "ConduceId",
            "DetalleId"
          ])
        };
      }), L = {
        ...g,
        TipoDocumentoId: u.Conduce,
        DocumentosDetallesDocumentoId: F,
        DocumentoId: g.ConduceId,
        ContactoId: g.ProveedorId,
        Secuencia: g.ConduceNumero,
        ContactoDNI: g.ProveedorDNI,
        ContactoNombre: g.ProveedorNombre
      };
      j(Bt(L, ["ConduceId"])), N(F);
    }
  }, [v, g, u.Conduce]);
  const $ = k.useMemo(() => o.getFieldValue("Retenciones")?.length > 0 ? o.getFieldValue("Retenciones")?.reduce((F, L) => [...F, JSON.parse(L)], []) : 0, [o]), _ = Un(T, $ || [], s), A = (F) => {
    for (const L in F)
      return typeof F[L] > "u" ? (Or.info(`Falta el campo ${L}`), !1) : !0;
  }, R = async () => {
    const F = r.getFieldsValue(), L = n.getFieldsValue();
    if (A(F)) {
      const M = o.getFieldsValue(), B = {
        Fecha: F.Fecha,
        Notas: L.Notas,
        Total: _[0].Total,
        EstadoId: f.Activo,
        Importe: _[0].Importe,
        Descuento: _[0].Descuento,
        Impuestos: _[0].Impuestos,
        ProveedorId: F?.ProveedorId,
        Observaciones: L.Observaciones,
        ConduceId: g?.ConduceId,
        ProveedorDNI: b.data?.DNI || "-",
        TipoNCFId: F.TipoFuenteComprobanteId,
        ConduceNumero: g?.ConduceNumero,
        ImpuestosIncluidos: M.ImpuestosIncluidos,
        Tasa: M.Tasa ? M.Tasa : g?.MonedaId,
        MonedaId: M.MonedaId ? M.MonedaId : g?.MonedaId,
        AlmacenId: M.AlmacenId ? M.AlmacenId : g?.MonedaId,
        TasaFecha: M.TasaFecha ? M.TasaFecha : g?.TasaFecha,
        Monto: _[0].Importe - _[0].Descuento + _[0].Retenciones,
        Referencia: M.Referencia ? M.Referencia : g?.Referencia,
        Retenciones: _[0].Retenciones ? _[0].Retenciones : g?.Retenciones,
        ProveedorNombre: b.data ? b.data?.ContactoNombre + " " + b.data?.ContactoApellido : "Sin cliente",
        ConducesComprasDetallesConduceId: T?.map((W) => ({
          Total: W.Total,
          Codigo: W.Codigo,
          Cantidad: W.Cantidad,
          SubTotal: W.SubTotal,
          Impuesto: W.Impuesto,
          Descuento: W.Descuento,
          ProductoId: W.ProductoId,
          Referencia: W.Referencia,
          EstadoId: f.Activo,
          Descripcion: W.Descripcion,
          CostoUnitario: W.CostoUnitario,
          UnidadMedidaId: W.UnidadMedidaId,
          PrecioUnitario: W.PrecioUnitario,
          DetalleId: W.DocumentoDetalleId || 0,
          ConduceId: g?.ConduceId,
          DescuentoUnitario: W.DescuentoUnitario,
          DescuentoEsPorcentual: W.DescuentoEsPorcentual
        }))
      };
      await se.promise(C.mutateAsync(B), {
        error: (W) => W,
        loading: "Guardando conduce",
        success: () => (t("../conduce-compra-detalles/" + e), `conduce ${e} guardada correctamente`)
      });
    }
  }, P = async () => {
    const F = r.getFieldsValue(), L = n.getFieldsValue(), M = o.getFieldsValue(), B = {
      Tasa: M.Tasa,
      Fecha: F.Fecha,
      Notas: L.Notas,
      Total: _[0].Total,
      MonedaId: M.MonedaId,
      Importe: _[0].Importe,
      EstadoId: f.Borrador,
      TasaFecha: M.TasaFecha,
      AlmacenId: M.AlmacenId,
      TipoPlazoId: F.TipoPlazoId,
      Descuento: _[0].Descuento,
      Impuestos: _[0].Impuestos,
      ProveedorId: F?.ProveedorId,
      FechaVencimiento: F.Vencimiento,
      Observaciones: L.Observaciones,
      ConduceId: g?.ConduceId,
      ProveedorDNI: b.data?.DNI || "-",
      TipoNCFId: F.TipoFuenteComprobanteId,
      ConduceNumero: g?.ConduceNumero,
      ImpuestosIncluidos: M.ImpuestosIncluidos,
      Monto: _[0].Importe - _[0].Descuento + _[0].Retenciones,
      Referencia: M.Referencia ? M.Referencia : g?.Referencia,
      Retenciones: _[0].Retenciones ? _[0].Retenciones : g?.Retenciones,
      ProveedorNombre: b.data ? b.data?.ContactoNombre + " " + b.data?.ContactoApellido : "Sin cliente",
      ConducesComprasDetallesConduceId: T?.map((W) => ({
        Total: W.Total,
        Codigo: W.Codigo,
        Cantidad: W.Cantidad,
        SubTotal: W.SubTotal,
        Impuesto: W.Impuesto,
        Descuento: W.Descuento,
        ProductoId: W.ProductoId,
        Referencia: W.Referencia,
        EstadoId: f.Activo,
        Descripcion: W.Descripcion,
        CostoUnitario: W.CostoUnitario,
        UnidadMedidaId: W.UnidadMedidaId,
        PrecioUnitario: W.PrecioUnitario,
        DetalleId: W.DocumentoDetalleId || 0,
        ConduceId: g?.ConduceId,
        DescuentoUnitario: W.DescuentoUnitario,
        DescuentoEsPorcentual: W.DescuentoEsPorcentual
      }))
    };
    await se.promise(S.mutateAsync(B), {
      error: (W) => W,
      loading: "Guardando conduce en borrador",
      success: () => (t("../conduce-compra-detalles/" + e), `Conduce ${e} guardada correctamente`)
    });
  }, z = async () => {
    await se.promise(O.mutateAsync({
      EstadoId: f.Borrador,
      ConduceId: g?.ConduceId || 0
    }), {
      loading: "Devolviendo la conduce a borrador",
      error: () => "Error al volver conduce a borrador",
      success: () => `La conduce ${e} ahora está en borrador`
    });
  };
  return h ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar el conduce de compra"
  }) : C.isPending || S.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(bn, { loading: E, title: `Conduce ${w?.Secuencia !== "0" && w !== void 0 ? w?.Secuencia : ""}`, children: E ? i.jsx(Vr, { size: "large", isLoading: E, title: "Cargando conduce de compra" }) : i.jsxs(Sn, { form: r, layout: "vertical", disabled: w?.EstadoId !== f.Borrador, children: [i.jsx(Zo, { style: { width: "100%" }, children: i.jsx(fa, { Label: "Proveedor", Name: "ProveedorId", contactoId: d, TitleView: "Ver proveedor", setSearch: l, optionsContacts: I, setOpenDrawerIC: x, isContactsLoading: y, Placeholder: "Seleccione el proveedor", initialValue: g?.ProveedorId, disabled: g?.EstadoId !== f.Borrador }) }), i.jsxs(Cr, { children: [i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", initialValue: rt(g?.Fecha), rules: [
    {
      required: !0,
      message: "Este campo es requerido"
    }
  ], children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }), i.jsx(Ut, { children: i.jsx(ii, { area: "Compras", documentTypeId: u.Conduce, initialValue: g?.TipoNCFId, disabled: g?.EstadoId !== f.Borrador }) })] })] }) }), i.jsx(K, { form: n, layout: "vertical", children: i.jsx(rn, { isOrden: !0, area: "Compras", formInstance: n, isFleteActive: a, formConfig: o, dataSource: T, loading: E, DocumentData: w, setDataSource: N, disabled: w?.EstadoId !== f.Borrador, tax: V?.Valor ? V?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !a, dataSource: T, isLoading: E, formIntanceConfig: o, Total: De(_[0].Total), Importe: De(_[0].Importe), Subtotal: De(_[0].SubTotal), Descuento: De(_[0].Descuento), Impuestos: De(_[0].Impuestos), enabled: w?.EstadoId === f.Borrador, IsBorradorDocument: g?.EstadoId == f.Borrador, methods: {
    handleSaveBorrador: P,
    handleSaveNormal: () => R(),
    handleVolverABorrador: z
  }, Retenciones: _[0].Retenciones ? De(_[0].Retenciones) : De(g?.Retenciones ? g?.Retenciones : 0) })] }), i.jsx(ua, { Open: D, setOpen: x, dataContact: b.data, optionsContacts: I, Title: "Información del proveedor", isContactInfoLoading: b.isLoading })] });
}, xN = () => {
  const [e, t] = k.useState(""), r = (m) => {
    t(m.target.value);
  }, n = xt(), [o, a] = k.useState({ Action: "", Open: !1 }), [s, c] = k.useState(), l = Ds("Venta"), d = iS();
  ri();
  const u = Es(), f = Yi.useFetchFrequencyPayments(), h = k.useMemo(() => f.data?.length ? Da.selectTextValue(f.data, "FrecuenciaPagoNombre", "FrecuenciaPagoNombre") : [], [f.data]), g = [
    {
      key: "Secuencia",
      title: "Secuencia",
      dataIndex: "Secuencia",
      sorter: (m, y) => m.DocumentoNumero.localeCompare(y.DocumentoNumero),
      render: (m, y, I) => y.DocumentoNumero == "0" ? i.jsx(rr.Status, { state: "Pendiente" }) : i.jsx(nr, { onClick: () => n(`../factura-venta-detalles/${y.DocumentoId}`), children: y.DocumentoNumero }, `sec ${y.DocumentoId} ${I}`)
    },
    {
      width: 150,
      title: "Frecuencia",
      key: "FrecuenciaPagoNombre",
      dataIndex: "FrecuenciaPagoNombre",
      filters: h,
      onFilter: (m, y) => y.FrecuenciaPagoNombre?.indexOf(m.toString()) === 0
    },
    {
      width: 200,
      align: "center",
      key: "CantidadVeces",
      title: "Cantidad de veces",
      dataIndex: "CantidadVeces",
      sorter: (m, y) => m.CantidadVeces - y.CantidadVeces
    },
    {
      width: 180,
      key: "FechaInicio",
      title: "Fecha Inicio",
      dataIndex: "FechaInicio",
      filterDropdown: Ko,
      render: (m) => bt(m).format("DD/MM/YYYY"),
      sorter: (m, y) => new Date(m.FechaInicio).getTime() - new Date(y.FechaInicio).getTime(),
      onFilter: (m, y) => {
        if (typeof m != "string" && typeof m != "number")
          return !1;
        const I = bt(m, "DD/MM/YYYY");
        return I.isValid() && bt(y.FechaInicio).isSame(I, "D");
      }
    },
    {
      width: 180,
      key: "FechaProxima",
      title: "Fecha Próxima",
      dataIndex: "FechaProxima",
      filterDropdown: Ko,
      render: (m) => bt(m).format("DD/MM/YYYY"),
      sorter: (m, y) => new Date(m.FechaProxima).getTime() - new Date(y.FechaProxima).getTime(),
      onFilter: (m, y) => {
        if (typeof m != "string" && typeof m != "number")
          return !1;
        const I = bt(m, "DD/MM/YYYY");
        return I.isValid() && bt(y.FechaProxima).isSame(I, "D");
      }
    },
    {
      width: 250,
      key: "Cliente",
      title: "Cliente",
      dataIndex: "NombreApellido",
      sorter: (m, y) => `${m?.ClienteNombre}`.localeCompare(`${y?.ClienteNombre}`),
      render: (m, y) => y?.ClienteNombre && y?.ClienteNombre !== "- -" ? y?.ClienteNombre : i.jsx(rr.Status, { state: "Pendiente" })
    },
    {
      title: "Estado",
      key: "EstadoId",
      dataIndex: "EstadoId",
      render: (m, y) => i.jsx(rr.Status, { state: y.EstadoNombre }),
      onFilter: (m, y) => y.EstadoId === m,
      filters: u.data?.map((m) => ({
        value: m.EstadoId,
        text: m.EstadoNombre
      }))
    },
    {
      title: "",
      width: 50,
      fixed: "right",
      key: "Acciones",
      render: (m, y, I) => i.jsx(Vg, { type: "venta", record: y, indexRender: I, setSelectedItem: c })
    }
  ], E = k.useMemo(() => !d.data || d.isLoading || d?.data?.length === 0 || d.data === void 0 ? [] : (Array.isArray(d?.data) ? d?.data?.map((y) => ({ ...y, Fecha: rt(y.Fecha).format("YYYY-MM-DD") })) : []).reduce((y, I) => {
    const b = e.toLowerCase(), C = `${I.ClienteNombre}`;
    return `${I?.Secuencia}`.toLocaleLowerCase().includes(b) || `${I?.Fecha}`.toLowerCase().includes(b) || C.toLowerCase().includes(b) || `${I.EstadoNombre}`.toLowerCase().includes(b) || `${I.TipoDocumentoNombre}`.toLowerCase().includes(b) ? [...y, { ...I, ClienteNombre: C }] : y;
  }, []), [
    d.data,
    d.isLoading,
    e
  ]).sort((m, y) => y.CantidadVeces - m.CantidadVeces);
  k.useEffect(() => {
    l.isSuccess && a({ Action: "", Open: !1 });
  }, [l.isSuccess]);
  const v = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay facturas recurrentes de venta agregadas." }) }), []);
  return i.jsxs(i.Fragment, { children: [i.jsx(_s, { changeState: l, selectedItem: s, modalAction: o, setModalAction: a }), i.jsx(Ln, { columns: g, dataSource: E, skeletonLoadingRowCount: 5, title: "Facturas recurrentes", placeholderSearch: "Búsqueda...", onChangeSearch: Mn({ delay: 500 }, r), skeletonLoading: d.isPending, onSearch: (m) => {
    e !== m && t(m);
  }, tableProps: {
    scroll: { x: g.length * 160 },
    loading: d.isFetching || u.isFetching || l.isPending,
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: v(),
      filterEmptyText: "Sin filtros"
    }
  } })] });
}, SN = () => {
  const [e, t] = k.useState(""), r = (m) => {
    t(m.target.value);
  }, n = xt(), [o, a] = k.useState({ Action: "", Open: !1 }), [s, c] = k.useState(), l = Ds("Compra"), d = aS();
  ri();
  const u = Es(), f = Yi.useFetchFrequencyPayments(), h = k.useMemo(() => f.data?.length ? Da.selectTextValue(f.data, "FrecuenciaPagoNombre", "FrecuenciaPagoNombre") : [], [f.data]), g = [
    {
      key: "Secuencia",
      title: "Secuencia",
      dataIndex: "Secuencia",
      sorter: (m, y) => m.DocumentoNumero.localeCompare(y.DocumentoNumero),
      render: (m, y, I) => y.DocumentoNumero == "0" ? i.jsx(rr.Status, { state: "Pendiente" }) : i.jsx(nr, { onClick: () => n(`../factura-compra/${y.DocumentoId}`), children: y.DocumentoNumero }, `sec ${y.DocumentoId} ${I}`)
    },
    {
      width: 150,
      title: "Frecuencia",
      key: "FrecuenciaPagoNombre",
      dataIndex: "FrecuenciaPagoNombre",
      filters: h,
      onFilter: (m, y) => y.FrecuenciaPagoNombre?.indexOf(m.toString()) === 0
    },
    {
      width: 200,
      align: "center",
      key: "CantidadVeces",
      title: "Cantidad de veces",
      dataIndex: "CantidadVeces",
      sorter: (m, y) => m.CantidadVeces - y.CantidadVeces
    },
    {
      width: 180,
      key: "FechaInicio",
      title: "Fecha Inicio",
      dataIndex: "FechaInicio",
      filterDropdown: Ko,
      render: (m) => bt(m).format("DD/MM/YYYY"),
      sorter: (m, y) => new Date(m.FechaInicio).getTime() - new Date(y.FechaInicio).getTime(),
      onFilter: (m, y) => {
        if (typeof m != "string" && typeof m != "number")
          return !1;
        const I = bt(m, "DD/MM/YYYY");
        return I.isValid() && bt(y.FechaInicio).isSame(I, "D");
      }
    },
    {
      width: 180,
      key: "FechaProxima",
      title: "Fecha Próxima",
      dataIndex: "FechaProxima",
      filterDropdown: Ko,
      render: (m) => bt(m).format("DD/MM/YYYY"),
      sorter: (m, y) => new Date(m.FechaProxima).getTime() - new Date(y.FechaProxima).getTime(),
      onFilter: (m, y) => {
        if (typeof m != "string" && typeof m != "number")
          return !1;
        const I = bt(m, "DD/MM/YYYY");
        return I.isValid() && bt(y.FechaProxima).isSame(I, "D");
      }
    },
    {
      width: 250,
      key: "Proveedor",
      title: "Proveedor",
      dataIndex: "NombreApellido",
      sorter: (m, y) => `${m?.ProveedorNombre}`.localeCompare(`${y?.ProveedorNombre}`),
      render: (m, y) => y?.ProveedorNombre && y?.ProveedorNombre !== "- -" ? y?.ProveedorNombre : i.jsx(rr.Status, { state: "Pendiente" })
    },
    {
      title: "Estado",
      key: "EstadoId",
      dataIndex: "EstadoId",
      render: (m, y) => i.jsx(rr.Status, { state: y.EstadoNombre }),
      onFilter: (m, y) => y.EstadoId === m,
      filters: u.data?.map((m) => ({
        value: m.EstadoId,
        text: m.EstadoNombre
      }))
    },
    {
      title: "",
      width: 50,
      fixed: "right",
      key: "Acciones",
      render: (m, y, I) => i.jsx(Vg, { type: "compra", record: y, indexRender: I, setSelectedItem: c })
    }
  ], E = k.useMemo(() => !d.data || d.isLoading || d?.data?.length === 0 || d.data === void 0 ? [] : (Array.isArray(d?.data) ? d?.data?.map((y) => ({ ...y, Fecha: rt(y.Fecha).format("YYYY-MM-DD") })) : []).reduce((y, I) => {
    const b = e.toLowerCase(), C = `${I.ProveedorNombre}`;
    return `${I?.Secuencia}`.toLocaleLowerCase().includes(b) || `${I?.Fecha}`.toLowerCase().includes(b) || C.toLowerCase().includes(b) || `${I.EstadoNombre}`.toLowerCase().includes(b) || `${I.TipoDocumentoNombre}`.toLowerCase().includes(b) ? [...y, { ...I, proveedorNombre: C }] : y;
  }, []), [
    d.data,
    d.isLoading,
    e
  ]).sort((m, y) => y.CantidadVeces - m.CantidadVeces);
  k.useEffect(() => {
    l.isSuccess && a({ Action: "", Open: !1 });
  }, [l.isSuccess]);
  const v = k.useCallback(() => i.jsx(at, { children: i.jsx(Wr, { emptyText: "No hay facturas recurrentes de compra agregadas." }) }), []);
  return i.jsxs(i.Fragment, { children: [i.jsx(_s, { changeState: l, selectedItem: s, modalAction: o, setModalAction: a }), i.jsx(Ln, { columns: g, dataSource: E, skeletonLoadingRowCount: 5, title: "Facturas recurrentes", placeholderSearch: "Búsqueda...", onChangeSearch: Mn({ delay: 500 }, r), skeletonLoading: d.isPending, onSearch: (m) => {
    e !== m && t(m);
  }, tableProps: {
    scroll: { x: g.length * 160 },
    loading: d.isFetching || u.isFetching || l.isPending,
    pagination: {
      defaultPageSize: 5,
      showSizeChanger: !0,
      style: { marginRight: "30px" }
    },
    locale: {
      filterConfirm: "Aplicar",
      filterReset: "Restablecer",
      emptyText: v(),
      filterEmptyText: "Sin filtros"
    }
  } })] });
}, EN = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = Yr({
    Table: "Notas-Ventas",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), o = ws(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), a = async () => {
    await se.promise(o.mutateAsync({
      EstadoId: r.Borrador,
      NotaVentaId: n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la nota de débito a borrador",
      error: () => "Error al volver la nota de débito a borrador",
      success: () => (t("../nota-debito/" + e), `La nota de débito ${e} ahora está en borrador`)
    });
  }, s = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Notas-Ventas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Ventas", TableData: "Notas-Ventas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Ventas", TableData: "Notas-Ventas", LlevaInfoEntrega: !1, DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: n.isLoading ? i.jsx(Ct, {}) : n.isSuccess ? n.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "nota-debito", isPending: n.isPending, isFetching: n.isFetching, ExecuteBackToDraft: a, ContactInfo: n.data?.Result?.ContactDataInfo, PrincipalInfo: n.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: s, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : n.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : i.jsx(Ct, {}) : n.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : i.jsx(Ct, {}) });
}, DN = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = Yr({
    Table: "Notas-Ventas",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), o = ws(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), a = async () => {
    await se.promise(o.mutateAsync({
      EstadoId: r.Borrador,
      NotaVentaId: n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la nota de crédito a borrador",
      error: () => "Error al volver la nota de crédito a borrador",
      success: () => (t("../nota-credito/" + e), `La nota de crédito ${e} ahora está en borrador`)
    });
  }, s = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Notas-Ventas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Ventas", TableData: "Notas-Ventas", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Ventas", TableData: "Notas-Ventas", LlevaInfoEntrega: !1, DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: n.isLoading ? i.jsx(Ct, {}) : n.isSuccess ? n.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Ventas", RouteNavigate: "nota-credito", ExecuteBackToDraft: a, isPending: n.isPending, isFetching: n.isFetching, ContactInfo: n.data?.Result?.ContactDataInfo, PrincipalInfo: n.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: s, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : n.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : i.jsx(Ct, {}) : n.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : i.jsx(Ct, {}) });
}, Ls = ({ onClose: e, modalSaveDraft: t, handleBorrador: r }) => i.jsx(Rn, { okText: "Confirmar", open: t, cancelText: "Cancelar", title: "Volver borrador", onCancel: () => e(), onOk: () => r(), children: i.jsx("div", { style: {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
}, children: i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  textAlign: "center",
  flexDirection: "column"
}, children: [i.jsx(Vf, { size: 60, name: "" }), i.jsx("span", { style: { fontSize: 15 }, children: i.jsxs("strong", { children: ["¿Seguro que desea guardar estos cambios", i.jsx("br", {}), "y el documento como borrador?"] }) })] }) }) }), Vs = ({ method: e, onClose: t, stateAction: r, modalBorrador: n }) => (k.useEffect(() => {
  (r.isError || r.isSuccess) && t();
}, [r.isError, r.isSuccess, t]), i.jsx(Rn, { okText: "Confirmar", open: n, cancelText: "Cancelar", onOk: () => e(), title: "Volver borrador", onCancel: () => t(), closable: r.isLoading, children: i.jsx("div", { style: {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
}, children: r.isLoading ? i.jsxs("div", { style: { display: "flex", flexDirection: "row" }, children: [i.jsx(Xo, {}), i.jsx("span", { children: "Camdiado estado" })] }) : i.jsxs("div", { style: {
  width: "100%",
  display: "flex",
  textAlign: "center",
  flexDirection: "column"
}, children: [i.jsx(Vf, { size: 60, name: "" }), i.jsx("span", { style: { fontSize: 15 }, children: i.jsx("strong", { children: "¿Seguro que desea volver este documento a borrador?" }) })] }) }) })), wN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), o = K.useWatch("IsFlete", r), a = K.useWatch("Flete", r), [s, c] = k.useState(!1), [l, d] = k.useState(!1), { docTypes: u, tiposNotas: f, tiposNCFIds: h, statesValues: g } = et(), E = lh(), v = ch(), [m] = K.useForm(), { isError: y, data: I, isSuccess: b, isLoading: C } = th({
    NotaVentaId: Number.parseInt(e ?? "")
  }), [S, T] = k.useState([]), { data: N } = Qr(), [V, D] = k.useState(void 0), x = ws(I?.NotaVentaId);
  k.useEffect(() => {
    if (b && I !== void 0) {
      const A = I.NotasVentasDetallesNotaVentaId?.map((P, z) => {
        const F = {
          ...P,
          Key: z,
          DocumentoId: P.NotaVentaId,
          DocumentoDetalleId: P.DetalleId
        };
        return {
          ...Bt(F, [
            "NotaVentaId",
            "DetalleId"
          ])
        };
      }), R = {
        ...I,
        AlmacenId: 1,
        ContactoId: 1,
        Secuencia: I.NotaNumero,
        DocumentoId: I.NotaVentaId,
        TipoDocumentoId: u.Nota_de_debito,
        DocumentosDetallesDocumentoId: A,
        DocumentoReferenciaId: I.FacturaId,
        FechaVencimientoNCF: I.FechaVencimientoNCF
      };
      T(A || []), D(Bt(R, ["NotaVentaId", "TipoNotaId", "NotaNumero"]));
    }
  }, [b, I, u.Nota_de_debito]);
  const O = k.useMemo(() => n.getFieldValue("Retenciones")?.length > 0 ? n.getFieldValue("Retenciones")?.reduce((A, R) => [...A, JSON.parse(R)], []) : 0, [n]), w = Un(S, O || [], a), j = async () => {
    const A = r.getFieldsValue(), R = m.getFieldsValue(), P = n.getFieldsValue(), z = {
      Total: w[0].Total,
      EstadoId: g.Activo,
      Monto: w[0]?.SubTotal,
      Importe: w[0].Importe,
      Notas: R?.Notas || "",
      Referencia: A.Referencia,
      TipoNotaId: f.nota_debito,
      Descuento: w[0].Descuento,
      Impuestos: w[0].Impuestos,
      TipoNCFId: h.Nota_de_Debito,
      Retenciones: w[0].Retenciones,
      FacturaId: I?.FacturaId || 0,
      NotaVentaId: I?.NotaVentaId || 0,
      NotaNumero: I?.NotaNumero || "0",
      Observaciones: R?.Observaciones || "",
      MonedaId: P.MonedaId || I?.MonedaId,
      ImpuestosIncluidos: P.ImpuestosIncluidos || I?.ImpuestosIncluidos,
      NotasVentasDetallesNotaVentaId: S?.map((F) => ({
        Total: F.Total,
        Codigo: F.Codigo,
        Cantidad: F.Cantidad,
        SubTotal: F.SubTotal,
        Impuesto: F.Impuesto,
        Descuento: F.Descuento,
        ProductoId: F.ProductoId,
        Referencia: F.Referencia,
        EstadoId: g.Activo,
        Descripcion: F.Descripcion,
        CostoUnitario: F.CostoUnitario,
        DetalleId: F.DocumentoDetalleId,
        UnidadMedidaId: F.UnidadMedidaId,
        PrecioUnitario: F.PrecioUnitario,
        NotaVentaId: I?.NotaVentaId,
        DescuentoUnitario: F.DescuentoUnitario,
        DescuentoEsPorcentual: F.DescuentoEsPorcentual
      }))
    };
    await se.promise(E.mutateAsync(z), {
      loading: "Guardando nota de débito",
      error: "Error guardando nota de débito",
      success: () => (t("../nota-debito-detalles/" + e), `Nota de débito ${e} guardada correctamente`)
    });
  }, $ = async () => {
    const A = r.getFieldsValue(), R = m.getFieldsValue(), P = n.getFieldsValue(), z = {
      Total: w[0].Total,
      Monto: w[0]?.SubTotal,
      Importe: w[0].Importe,
      Notas: R?.Notas || "",
      EstadoId: g.Borrador,
      Referencia: A.Referencia,
      TipoNotaId: f.nota_debito,
      Descuento: w[0].Descuento,
      Impuestos: w[0].Impuestos,
      TipoNCFId: h.Nota_de_Debito,
      Retenciones: w[0].Retenciones,
      FacturaId: I?.FacturaId || 0,
      NotaVentaId: I?.NotaVentaId || 0,
      NotaNumero: I?.NotaNumero || "0",
      Observaciones: R?.Observaciones || "",
      MonedaId: P.MonedaId || I?.MonedaId,
      ImpuestosIncluidos: P.ImpuestosIncluidos || I?.ImpuestosIncluidos,
      NotasVentasDetallesNotaVentaId: S?.map((F) => ({
        Total: F.Total,
        Codigo: F.Codigo,
        Cantidad: F.Cantidad,
        SubTotal: F.SubTotal,
        Impuesto: F.Impuesto,
        Descuento: F.Descuento,
        ProductoId: F.ProductoId,
        Referencia: F.Referencia,
        EstadoId: g.Activo,
        Descripcion: F.Descripcion,
        CostoUnitario: F.CostoUnitario,
        DetalleId: F.DocumentoDetalleId,
        UnidadMedidaId: F.UnidadMedidaId,
        PrecioUnitario: F.PrecioUnitario,
        NotaVentaId: I?.NotaVentaId,
        DescuentoUnitario: F.DescuentoUnitario,
        DescuentoEsPorcentual: F.DescuentoEsPorcentual
      }))
    };
    await se.promise(v.mutateAsync(z), {
      error: "Error guardando nota de débito",
      loading: "Guardando nota de débito en borrador",
      success: () => (t("../nota-debito-detalles/" + e), `Nota de débito ${e} guardada correctamente`)
    });
  }, _ = async () => {
    await se.promise(x.mutateAsync({
      EstadoId: g.Borrador,
      NotaVentaId: I?.NotaVentaId || 0
    }), {
      loading: "Devolviendo la nota de débito a borrador",
      error: () => "Error al volver la nota de débito a borrador",
      success: () => `La nota de débito # ${e} ahora está en borrador`
    });
  };
  return y ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : E.isPending || v.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(Qt, { loading: C, title: `Nota de débito ${V?.Secuencia !== "0" && V !== void 0 ? V?.Secuencia : ""}`, children: C ? i.jsx(Vr, { size: "large", isLoading: C, title: "Cargando la nota de débito" }) : i.jsx(i.Fragment, { children: i.jsx(Sn, { form: r, layout: "vertical", disabled: I?.EstadoId !== g.Borrador, children: i.jsx(Cr, { children: i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", style: { width: "100%", maxWidth: 300 }, initialValue: rt(I?.Fecha || /* @__PURE__ */ new Date()), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }) }) }) }) }), i.jsx(K, { form: m, layout: "vertical", children: i.jsx(rn, { area: "Ventas", formInstance: m, isFleteActive: o, formConfig: n, dataSource: S, loading: C, DocumentData: V, setDataSource: T, disabled: V?.EstadoId !== g.Borrador, tax: N?.Valor ? N?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !o, dataSource: S, isLoading: C, formIntanceConfig: n, Total: De(w[0].Total), Importe: De(w[0].Importe), Subtotal: De(w[0].SubTotal), Descuento: De(w[0].Descuento), Impuestos: De(w[0].Impuestos), Retenciones: De(w[0].Retenciones), IsBorradorDocument: I?.EstadoId == g.Borrador, methods: {
    handleSaveBorrador: $,
    handleSaveNormal: j,
    handleVolverABorrador: _
  } })] }), i.jsx(Vs, { modalBorrador: s, method: () => _(), onClose: () => c(!1), tipoDocumentoId: u.Orden_de_compra, documentoId: I?.FacturaId, stateAction: {
    isError: x.isError,
    isLoading: x.isPending,
    isSuccess: x.isSuccess
  } }), i.jsx(Ls, { modalSaveDraft: l, handleBorrador: $, onClose: () => d(!1) })] });
}, TN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), o = K.useWatch("IsFlete", r), a = K.useWatch("Flete", r), [s, c] = k.useState(!1), [l, d] = k.useState(!1), { docTypes: u, tiposNotas: f, tiposNCFIds: h, statesValues: g } = et(), E = lh(), v = ch(), [m] = K.useForm(), { isError: y, data: I, isSuccess: b, isLoading: C } = th({
    NotaVentaId: Number.parseInt(e ?? "")
  }), [S, T] = k.useState([]), { data: N } = Qr(), [V, D] = k.useState(void 0), x = ws(I?.NotaVentaId);
  k.useEffect(() => {
    if (b && I !== void 0) {
      const R = I.NotasVentasDetallesNotaVentaId?.map((z, F) => {
        const L = {
          ...z,
          Key: F,
          DocumentoId: z.NotaVentaId,
          DocumentoDetalleId: z.DetalleId
        };
        return {
          ...Bt(L, [
            "NotaVentaId",
            "DetalleId"
          ])
        };
      }), P = {
        ...I,
        AlmacenId: 1,
        ContactoId: 1,
        Secuencia: I.NotaNumero,
        DocumentoId: I.NotaVentaId,
        TipoDocumentoId: u.Nota_de_credito,
        DocumentosDetallesDocumentoId: R,
        DocumentoReferenciaId: I.FacturaId,
        FechaVencimientoNCF: I.FechaVencimientoNCF
      };
      T(R || []), D(Bt(P, ["NotaVentaId", "TipoNotaId", "NotaNumero"]));
    }
  }, [b, I, u.Nota_de_credito]);
  const O = k.useMemo(() => n.getFieldValue("Retenciones")?.length > 0 ? n.getFieldValue("Retenciones")?.reduce((R, P) => [...R, JSON.parse(P)], []) : 0, [n]), w = (R, P) => {
    const z = new Date(R), F = new Date(P), L = Math.abs(F.getTime() - z.getTime());
    return Math.ceil(L / (1e3 * 3600 * 24));
  }, j = [
    {
      Importe: S?.reduce((R, P) => R + P?.SubTotal, 0),
      Flete: S?.reduce((R, P) => R + (P?.Flete ? P?.Flete : 0), 0),
      SubTotal: S?.reduce((R, P) => R + (P?.SubTotal ? P?.SubTotal : 0), 0),
      Descuento: S?.reduce((R, P) => R + (P?.Descuento ? P?.Descuento : 0), 0),
      Impuestos: (() => {
        const R = S?.reduce((P, z) => P + (z?.Impuesto ? z?.Impuesto : 0), 0);
        if (I?.DocumentosReferencia != null) {
          const P = I?.DocumentosReferencia[0]?.Fecha, z = I?.DocumentosReferencia[0]?.FechaCreacion, F = /* @__PURE__ */ new Date();
          return P != null ? w(P, F) < 30 ? R : 0 : w(z, F) < 30 ? R : 0;
        } else
          return R;
      })(),
      Retenciones: O ? O?.reduce((R, P) => P.ImpuestoBaseId === null ? R + S?.reduce((z, F) => z + (F.SubTotal ? F.SubTotal : 0) * (P.Porcentaje / 100), 0) : R + S?.reduce((z, F) => z + (F.ImpuestoId && F.ImpuestoId === P.ImpuestoBaseId ? (F.Impuesto ? F.Impuesto : 0) * (P.Porcentaje / 100) : 0), 0), 0) : 0,
      Total: S?.reduce((R, P) => R + (P.Total ? P.Total : 0), 0) - (O ? O?.reduce((R, P) => P.ImpuestoBaseId === null ? R + S?.reduce((z, F) => z + (F.SubTotal ? F.SubTotal : 0) * (P.Porcentaje / 100), 0) : R + S?.reduce((z, F) => z + (F.ImpuestoId && F.ImpuestoId === P.ImpuestoBaseId ? (F.Impuesto ? F.Impuesto : 0) * (P.Porcentaje / 100) : 0), 0), 0) : 0) + (a || 0)
    }
  ], $ = async () => {
    const R = r.getFieldsValue(), P = m.getFieldsValue(), z = n.getFieldsValue(), F = {
      Total: j[0].Total,
      EstadoId: g.Activo,
      Monto: j[0]?.SubTotal,
      Importe: j[0].Importe,
      Notas: P?.Notas || "",
      Referencia: R.Referencia,
      TipoNotaId: f.nota_credito,
      Descuento: j[0].Descuento,
      Impuestos: j[0].Impuestos,
      TipoNCFId: h.Nota_de_Credito,
      Retenciones: j[0].Retenciones,
      FacturaId: I?.FacturaId || 0,
      NotaVentaId: I?.NotaVentaId || 0,
      NotaNumero: I?.NotaNumero || "0",
      Observaciones: P?.Observaciones || "",
      MonedaId: z.MonedaId || I?.MonedaId,
      ImpuestosIncluidos: z.ImpuestosIncluidos || I?.ImpuestosIncluidos,
      NotasVentasDetallesNotaVentaId: S?.map((L) => ({
        Total: L.Total,
        Codigo: L.Codigo,
        Cantidad: L.Cantidad,
        SubTotal: L.SubTotal,
        Impuesto: L.Impuesto,
        Descuento: L.Descuento,
        ProductoId: L.ProductoId,
        Referencia: L.Referencia,
        EstadoId: g.Activo,
        Descripcion: L.Descripcion,
        CostoUnitario: L.CostoUnitario,
        DetalleId: L.DocumentoDetalleId,
        UnidadMedidaId: L.UnidadMedidaId,
        PrecioUnitario: L.PrecioUnitario,
        NotaVentaId: I?.NotaVentaId,
        DescuentoUnitario: L.DescuentoUnitario,
        DescuentoEsPorcentual: L.DescuentoEsPorcentual
      }))
    };
    await se.promise(E.mutateAsync(F), {
      loading: "Guardando nota de crédito",
      error: "Error guardando nota de crédito",
      success: () => (t("../nota-credito-detalles/" + e), `Nota de crédito ${e} guardada correctamente`)
    });
  }, _ = async () => {
    const R = r.getFieldsValue(), P = m.getFieldsValue(), z = n.getFieldsValue(), F = {
      Total: j[0].Total,
      Monto: j[0]?.SubTotal,
      Importe: j[0].Importe,
      Notas: P?.Notas || "",
      EstadoId: g.Borrador,
      Referencia: R.Referencia,
      TipoNotaId: f.nota_credito,
      Descuento: j[0].Descuento,
      Impuestos: j[0].Impuestos,
      TipoNCFId: h.Nota_de_Credito,
      Retenciones: j[0].Retenciones,
      FacturaId: I?.FacturaId || 0,
      NotaVentaId: I?.NotaVentaId || 0,
      NotaNumero: I?.NotaNumero || "0",
      Observaciones: P?.Observaciones || "",
      MonedaId: z.MonedaId || I?.MonedaId,
      ImpuestosIncluidos: z.ImpuestosIncluidos || I?.ImpuestosIncluidos,
      NotasVentasDetallesNotaVentaId: S?.map((L) => ({
        Total: L.Total,
        Codigo: L.Codigo,
        Cantidad: L.Cantidad,
        SubTotal: L.SubTotal,
        Impuesto: L.Impuesto,
        Descuento: L.Descuento,
        ProductoId: L.ProductoId,
        Referencia: L.Referencia,
        EstadoId: g.Activo,
        Descripcion: L.Descripcion,
        CostoUnitario: L.CostoUnitario,
        DetalleId: L.DocumentoDetalleId,
        UnidadMedidaId: L.UnidadMedidaId,
        PrecioUnitario: L.PrecioUnitario,
        NotaVentaId: I?.NotaVentaId,
        DescuentoUnitario: L.DescuentoUnitario,
        DescuentoEsPorcentual: L.DescuentoEsPorcentual
      }))
    };
    await se.promise(v.mutateAsync(F), {
      error: "Error guardando nota de crédito",
      loading: "Guardando nota de crédito en borrador",
      success: () => (t("../nota-credito-detalles/" + e), `Nota de crédito ${e} guardada correctamente`)
    });
  }, A = async () => {
    await se.promise(x.mutateAsync({
      EstadoId: g.Borrador,
      NotaVentaId: I?.NotaVentaId || 0
    }), {
      loading: "Devolviendo la nota de crédito a borrador",
      error: () => "Error al volver la nota de crédito a borrador",
      success: () => `La nota de crédito # ${e} ahora está en borrador`
    });
  };
  return y ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : E.isPending || v.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(Qt, { loading: C, title: `Nota de crédito ${V?.Secuencia !== "0" && V !== void 0 ? V?.Secuencia : ""}`, children: C ? i.jsx(Vr, { size: "large", isLoading: C, title: "Cargando la nota de crédito" }) : i.jsx(Sn, { form: r, layout: "vertical", disabled: I?.EstadoId !== g.Borrador, children: i.jsx(Cr, { children: i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", style: { width: "100%", maxWidth: 300 }, initialValue: rt(I?.Fecha || /* @__PURE__ */ new Date()), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }) }) }) }), i.jsx(K, { form: m, layout: "vertical", children: i.jsx(rn, { area: "Ventas", formInstance: m, isFleteActive: o, formConfig: n, dataSource: S, loading: C, DocumentData: V, setDataSource: T, disabled: V?.EstadoId !== g.Borrador, tax: N?.Valor ? N?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !o, dataSource: S, isLoading: C, formIntanceConfig: n, Total: De(j[0].Total), Importe: De(j[0].Importe), Subtotal: De(j[0].SubTotal), Descuento: De(j[0].Descuento), Impuestos: De(j[0].Impuestos), Retenciones: De(j[0].Retenciones), IsBorradorDocument: I?.EstadoId == g.Borrador, methods: {
    handleSaveNormal: $,
    handleSaveBorrador: _,
    handleVolverABorrador: A
  } })] }), i.jsx(Vs, { modalBorrador: s, method: () => A(), onClose: () => c(!1), tipoDocumentoId: u.Orden_de_compra, documentoId: I?.FacturaId, stateAction: {
    isError: x.isError,
    isLoading: x.isPending,
    isSuccess: x.isSuccess
  } }), i.jsx(Ls, { modalSaveDraft: l, handleBorrador: _, onClose: () => d(!1) })] });
}, FN = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = Yr({
    Table: "Notas-Debitos",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), o = Ts(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), a = async () => {
    await se.promise(o.mutateAsync({
      EstadoId: r.Borrador,
      NotaDebitoId: n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la nota de débito a borrador",
      error: () => "Error al volver la nota de débito a borrador",
      success: () => (t("../nota-debito/" + e), `La nota de débito ${e} ahora está en borrador`)
    });
  }, s = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Compras", TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Compras", LlevaInfoEntrega: !1, TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: n.isLoading ? i.jsx(Ct, {}) : n.isSuccess ? n.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Compras", RouteNavigate: "nota-debito", ExecuteBackToDraft: a, isPending: n.isPending, isFetching: n.isFetching, ContactInfo: n.data?.Result?.ContactDataInfo, PrincipalInfo: n.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: s, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : n.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : i.jsx(Ct, {}) : n.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : i.jsx(Ct, {}) });
}, ON = () => {
  const { id: e } = _t(), t = xt(), { statesValues: r } = et(), n = Yr({
    Table: "Notas-Debitos",
    Accion: "Get_Informacion_Principal",
    DocumentoId: parseInt(e || "0", 10)
  }), o = Ts(n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId), a = async () => {
    await se.promise(o.mutateAsync({
      EstadoId: r.Borrador,
      NotaDebitoId: n.data?.Result?.DocumentPrincipalDataInfo?.DocumentoId || 0
    }), {
      loading: "Devolviendo la nota de crédito a borrador",
      error: () => "Error al volver la nota de crédito a borrador",
      success: () => (t("../nota-credito/" + e), `La nota de crédito ${e} ahora está en borrador`)
    });
  }, s = [
    {
      key: "1",
      label: "Total y productos",
      children: i.jsx(en, { TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "2",
      label: "Documentos de referencia",
      children: i.jsx(tn, { Area: "Compras", TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10) })
    },
    {
      key: "3",
      label: "Información adicional",
      children: i.jsx(Jr, { Area: "Compras", LlevaInfoEntrega: !1, TableData: "Notas-Debitos", DocumentoId: parseInt(e || "0", 10), TipoDocumentoId: n.data?.Result?.DocumentPrincipalDataInfo?.TipoDocumentoId })
    }
  ];
  return i.jsx(i.Fragment, { children: n.isLoading ? i.jsx(Ct, {}) : n.isSuccess ? n.data.OperationStatus == "Success" ? i.jsxs(Ke, { style: { gap: 16, flexDirection: "column" }, children: [i.jsx(Zr, { Area: "Compras", RouteNavigate: "nota-credito", ExecuteBackToDraft: a, isPending: n.isPending, isFetching: n.isFetching, ContactInfo: n.data?.Result?.ContactDataInfo, PrincipalInfo: n.data?.Result?.DocumentPrincipalDataInfo }), i.jsx(Kr, { type: "card", items: s, defaultActiveKey: "1", tabBarStyle: { margin: 0 } })] }) : n.data.OperationStatus == "Failure" ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : i.jsx(Ct, {}) : n.isError ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : i.jsx(Ct, {}) });
}, NN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), o = K.useWatch("IsFlete", r), a = K.useWatch("Flete", r), [s, c] = k.useState(!1), [l, d] = k.useState(!1), { docTypes: u, tiposNotas: f, tiposNCFIds: h, statesValues: g } = et(), E = uh(), v = dh(), { isError: m, data: y, isSuccess: I, isLoading: b } = eh({
    NotaDebitoId: Number.parseInt(e ?? "")
  }), [C, S] = k.useState([]), { data: T } = Qr(), [N, V] = k.useState(void 0), [D] = K.useForm(), x = Ts(y?.NotaDebitoId);
  k.useEffect(() => {
    if (I && y !== void 0) {
      const A = y.NotasDetalleNotaDebitoId?.map((P, z) => {
        const F = {
          ...P,
          Key: z,
          DocumentoId: P.NotaDebitoId,
          DocumentoDetalleId: P.DetalleId
        };
        return {
          ...Bt(F, [
            "NotaDebitoId",
            "DetalleId"
          ])
        };
      }), R = {
        ...y,
        AlmacenId: 1,
        ContactoId: 1,
        Secuencia: y.NotaNumero,
        DocumentoId: y.NotaDebitoId,
        TipoDocumentoId: u.Nota_de_debito,
        DocumentosDetallesDocumentoId: A,
        DocumentoReferenciaId: y.FacturaId,
        FechaVencimientoNCF: y.FechaVencimientoNCF
      };
      S(A || []), V(Bt(R, ["NotaDebitoId", "TipoNotaId", "NotaNumero"]));
    }
  }, [I, y, u.Nota_de_debito]);
  const O = k.useMemo(() => n.getFieldValue("Retenciones")?.length > 0 ? n.getFieldValue("Retenciones")?.reduce((A, R) => [...A, JSON.parse(R)], []) : 0, [n]), w = Un(C, O || [], a), j = async () => {
    const A = r.getFieldsValue(), R = D.getFieldsValue(), P = n.getFieldsValue(), z = {
      Total: w[0].Total,
      EstadoId: g.Activo,
      Monto: w[0]?.SubTotal,
      Importe: w[0].Importe,
      Notas: R?.Notas || "",
      Referencia: A.Referencia,
      TipoNotaId: f.nota_debito,
      Descuento: w[0].Descuento,
      Impuestos: w[0].Impuestos,
      TipoNCFId: h.Nota_de_Debito,
      Retenciones: w[0].Retenciones,
      FacturaId: y?.FacturaId || 0,
      NotaNumero: y?.NotaNumero || "0",
      NotaDebitoId: y?.NotaDebitoId || 0,
      Observaciones: R?.Observaciones || "",
      ImpuestosIncluidos: P.ImpuestosIncluidos,
      MonedaId: P.MonedaId || y?.MonedaId,
      NotasDetalleNotaDebitoId: C?.map((F) => ({
        Total: F.Total,
        Codigo: F.Codigo,
        Cantidad: F.Cantidad,
        SubTotal: F.SubTotal,
        Impuesto: F.Impuesto,
        Descuento: F.Descuento,
        ProductoId: F.ProductoId,
        Referencia: F.Referencia,
        EstadoId: g.Activo,
        Descripcion: F.Descripcion,
        CostoUnitario: F.CostoUnitario,
        DetalleId: F.DocumentoDetalleId,
        UnidadMedidaId: F.UnidadMedidaId,
        PrecioUnitario: F.PrecioUnitario,
        NotaDebitoId: y?.NotaDebitoId,
        DescuentoUnitario: F.DescuentoUnitario,
        DescuentoEsPorcentual: F.DescuentoEsPorcentual
      }))
    };
    await se.promise(E.mutateAsync(z), {
      loading: "Guardando nota de débito",
      error: "Error guardando nota de débito",
      success: () => (t("../nota-debito-detalles/" + e), `Nota de débito ${e} guardada correctamente`)
    });
  }, $ = async () => {
    const A = r.getFieldsValue(), R = D.getFieldsValue(), P = n.getFieldsValue(), z = {
      Total: w[0].Total,
      MonedaId: P.MonedaId,
      Monto: w[0]?.SubTotal,
      Importe: w[0].Importe,
      Notas: R?.Notas || "",
      EstadoId: g.Borrador,
      Referencia: A.Referencia,
      TipoNotaId: f.nota_debito,
      Descuento: w[0].Descuento,
      Impuestos: w[0].Impuestos,
      TipoNCFId: h.Nota_de_Debito,
      Retenciones: w[0].Retenciones,
      FacturaId: y?.FacturaId || 0,
      NotaNumero: y?.NotaNumero || "0",
      NotaDebitoId: y?.NotaDebitoId || 0,
      Observaciones: R?.Observaciones || "",
      ImpuestosIncluidos: P.ImpuestosIncluidos,
      NotasDetalleNotaDebitoId: C?.map((F) => ({
        Total: F.Total,
        Codigo: F.Codigo,
        Cantidad: F.Cantidad,
        SubTotal: F.SubTotal,
        Impuesto: F.Impuesto,
        Descuento: F.Descuento,
        ProductoId: F.ProductoId,
        Referencia: F.Referencia,
        EstadoId: g.Activo,
        Descripcion: F.Descripcion,
        CostoUnitario: F.CostoUnitario,
        DetalleId: F.DocumentoDetalleId,
        UnidadMedidaId: F.UnidadMedidaId,
        PrecioUnitario: F.PrecioUnitario,
        NotaDebitoId: y?.NotaDebitoId,
        DescuentoUnitario: F.DescuentoUnitario,
        DescuentoEsPorcentual: F.DescuentoEsPorcentual
      }))
    };
    await se.promise(v.mutateAsync(z), {
      error: "Error guardando nota de débito",
      loading: "Guardando nota de débito en borrador",
      success: () => (t("../nota-debito-detalles/" + e), `Nota de débito ${e} guardada correctamente`)
    });
  }, _ = async () => {
    await se.promise(x.mutateAsync({
      EstadoId: g.Borrador,
      NotaDebitoId: y?.NotaDebitoId || 0
    }), {
      loading: "Devolviendo la nota de débito a borrador",
      error: () => "Error al volver la nota de débito a borrador",
      success: () => `La nota de débito # ${e} ahora está en borrador`
    });
  };
  return m ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de débito"
  }) : E.isPending || v.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(Qt, { loading: b, title: `Nota de débito No. ${N?.Secuencia !== "0" && N !== void 0 ? N?.Secuencia : ""}`, children: b ? i.jsx(Vr, { size: "large", isLoading: b, title: "Cargando la nota de débito" }) : i.jsx(i.Fragment, { children: i.jsx(Sn, { form: r, layout: "vertical", disabled: y?.EstadoId !== g.Borrador, children: i.jsx(Cr, { children: i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", style: { width: "100%", maxWidth: 300 }, initialValue: rt(y?.Fecha || /* @__PURE__ */ new Date()), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }) }) }) }) }), i.jsx(K, { form: D, layout: "vertical", children: i.jsx(rn, { area: "Compras", formInstance: D, isFleteActive: o, formConfig: n, dataSource: C, loading: b, DocumentData: N, setDataSource: S, disabled: N?.EstadoId !== g.Borrador, tax: T?.Valor ? T?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !o, dataSource: C, isLoading: b, formIntanceConfig: n, Total: De(w[0].Total), Importe: De(w[0].Importe), Subtotal: De(w[0].SubTotal), Descuento: De(w[0].Descuento), Impuestos: De(w[0].Impuestos), Retenciones: De(w[0].Retenciones), IsBorradorDocument: y?.EstadoId == g.Borrador, methods: {
    handleSaveBorrador: $,
    handleSaveNormal: () => j(),
    handleVolverABorrador: _
  } })] }), i.jsx(Vs, { modalBorrador: s, method: () => _(), onClose: () => c(!1), tipoDocumentoId: u.Orden_de_compra, documentoId: y?.FacturaId, stateAction: {
    isError: x.isError,
    isLoading: x.isPending,
    isSuccess: x.isSuccess
  } }), i.jsx(Ls, { modalSaveDraft: l, handleBorrador: $, onClose: () => d(!1) })] });
}, RN = () => {
  const { id: e } = _t(), t = xt(), [r] = K.useForm(), [n] = K.useForm(), o = K.useWatch("IsFlete", r), a = K.useWatch("Flete", r), s = VO(), [c, l] = k.useState(!1), [d, u] = k.useState(!1), { docTypes: f, tiposNotas: h, tiposNCFIds: g, statesValues: E } = et(), v = uh(), m = dh(), [y] = K.useForm(), { isError: I, data: b, isSuccess: C, isLoading: S } = eh({
    NotaDebitoId: Number.parseInt(e ?? "")
  }), [T, N] = k.useState([]), { data: V } = Qr(), [D, x] = k.useState(void 0), O = Ts(b?.NotaDebitoId);
  k.useEffect(() => {
    if (C && b !== void 0) {
      const z = b.NotasDetalleNotaDebitoId?.map((L, M) => {
        const B = {
          ...L,
          Key: M,
          DocumentoId: L.NotaDebitoId,
          DocumentoDetalleId: L.DetalleId
        };
        return {
          ...Bt(B, [
            "NotaDebitoId",
            "DetalleId"
          ])
        };
      }), F = {
        ...b,
        AlmacenId: 1,
        ContactoId: 1,
        Secuencia: b.NotaNumero,
        DocumentoId: b.NotaDebitoId,
        TipoDocumentoId: f.Nota_de_credito,
        DocumentosDetallesDocumentoId: z,
        DocumentoReferenciaId: b.FacturaId,
        FechaVencimientoNCF: b.FechaVencimientoNCF
      };
      N(z || []), x(Bt(F, ["NotaDebitoId", "TipoNotaId", "NotaNumero"]));
    }
  }, [C, b, f.Nota_de_credito]);
  const w = k.useMemo(() => n.getFieldValue("Retenciones")?.length > 0 ? n.getFieldValue("Retenciones")?.reduce((z, F) => [...z, JSON.parse(F)], []) : 0, [n]), j = (z, F) => {
    const L = new Date(z), M = new Date(F), B = Math.abs(M.getTime() - L.getTime());
    return Math.ceil(B / (1e3 * 3600 * 24));
  }, $ = [
    {
      Importe: T?.reduce((z, F) => z + F?.SubTotal, 0),
      Flete: T?.reduce((z, F) => z + (F?.Flete ? F?.Flete : 0), 0),
      SubTotal: T?.reduce((z, F) => z + (F?.SubTotal ? F?.SubTotal : 0), 0),
      Descuento: T?.reduce((z, F) => z + (F?.Descuento ? F?.Descuento : 0), 0),
      Impuestos: (() => {
        const z = T?.reduce((F, L) => F + (L?.Impuesto ? L?.Impuesto : 0), 0);
        if (b?.DocumentosReferencia != null) {
          const F = b?.DocumentosReferencia[0]?.Fecha, L = b?.DocumentosReferencia[0]?.FechaCreacion, M = /* @__PURE__ */ new Date();
          return F != null ? j(F, M) < 30 ? z : 0 : j(L, M) < 30 ? z : 0;
        } else
          return z;
      })(),
      Retenciones: w ? w?.reduce((z, F) => F.ImpuestoBaseId === null ? z + T?.reduce((L, M) => L + (M.SubTotal ? M.SubTotal : 0) * (F.Porcentaje / 100), 0) : z + T?.reduce((L, M) => L + (M.ImpuestoId && M.ImpuestoId === F.ImpuestoBaseId ? (M.Impuesto ? M.Impuesto : 0) * (F.Porcentaje / 100) : 0), 0), 0) : 0,
      Total: T?.reduce((z, F) => z + (F.Total ? F.Total : 0), 0) - (w ? w?.reduce((z, F) => F.ImpuestoBaseId === null ? z + T?.reduce((L, M) => L + (M.SubTotal ? M.SubTotal : 0) * (F.Porcentaje / 100), 0) : z + T?.reduce((L, M) => L + (M.ImpuestoId && M.ImpuestoId === F.ImpuestoBaseId ? (M.Impuesto ? M.Impuesto : 0) * (F.Porcentaje / 100) : 0), 0), 0) : 0) + (a || 0)
    }
  ], _ = async () => {
    const z = r.getFieldsValue(), F = y.getFieldsValue(), L = n.getFieldsValue(), M = {
      Total: $[0].Total,
      EstadoId: E.Activo,
      Monto: $[0]?.SubTotal,
      Importe: $[0].Importe,
      Notas: F?.Notas || "",
      Referencia: z.Referencia,
      TipoNotaId: h.nota_credito,
      Descuento: $[0].Descuento,
      Impuestos: $[0].Impuestos,
      TipoNCFId: g.Nota_de_Credito,
      Retenciones: $[0].Retenciones,
      FacturaId: b?.FacturaId || 0,
      NotaNumero: b?.NotaNumero || "0",
      NotaDebitoId: b?.NotaDebitoId || 0,
      Observaciones: F?.Observaciones || "",
      ImpuestosIncluidos: L.ImpuestosIncluidos,
      MonedaId: L.MonedaId || b?.MonedaId,
      NotasDetalleNotaDebitoId: T?.map((B) => ({
        Total: B.Total,
        Codigo: B.Codigo,
        Cantidad: B.Cantidad,
        SubTotal: B.SubTotal,
        Impuesto: B.Impuesto,
        Descuento: B.Descuento,
        ProductoId: B.ProductoId,
        Referencia: B.Referencia,
        EstadoId: E.Activo,
        Descripcion: B.Descripcion,
        CostoUnitario: B.CostoUnitario,
        DetalleId: B.DocumentoDetalleId,
        UnidadMedidaId: B.UnidadMedidaId,
        PrecioUnitario: B.PrecioUnitario,
        NotaDebitoId: b?.NotaDebitoId,
        DescuentoUnitario: B.DescuentoUnitario,
        DescuentoEsPorcentual: B.DescuentoEsPorcentual
      }))
    };
    await se.promise(v.mutateAsync(M), {
      loading: "Guardando nota de crédito",
      error: "Error guardando nota de crédito",
      success: () => (t("../nota-credito-detalles/" + e), `Nota de crédito ${e} guardada correctamente`)
    });
  }, A = async () => {
    const z = r.getFieldsValue(), F = y.getFieldsValue(), L = n.getFieldsValue(), M = {
      Total: $[0].Total,
      MonedaId: L.MonedaId,
      Monto: $[0]?.SubTotal,
      Importe: $[0].Importe,
      Notas: F?.Notas || "",
      EstadoId: E.Borrador,
      Referencia: z.Referencia,
      TipoNotaId: h.nota_credito,
      Descuento: $[0].Descuento,
      Impuestos: $[0].Impuestos,
      TipoNCFId: g.Nota_de_Credito,
      Retenciones: $[0].Retenciones,
      FacturaId: b?.FacturaId || 0,
      NotaNumero: b?.NotaNumero || "0",
      NotaDebitoId: b?.NotaDebitoId || 0,
      Observaciones: F?.Observaciones || "",
      ImpuestosIncluidos: L.ImpuestosIncluidos,
      NotasDetalleNotaDebitoId: T?.map((B) => ({
        Total: B.Total,
        Codigo: B.Codigo,
        Cantidad: B.Cantidad,
        SubTotal: B.SubTotal,
        Impuesto: B.Impuesto,
        Descuento: B.Descuento,
        ProductoId: B.ProductoId,
        Referencia: B.Referencia,
        EstadoId: E.Activo,
        Descripcion: B.Descripcion,
        CostoUnitario: B.CostoUnitario,
        DetalleId: B.DocumentoDetalleId,
        UnidadMedidaId: B.UnidadMedidaId,
        PrecioUnitario: B.PrecioUnitario,
        NotaDebitoId: b?.NotaDebitoId,
        DescuentoUnitario: B.DescuentoUnitario,
        DescuentoEsPorcentual: B.DescuentoEsPorcentual
      }))
    };
    await se.promise(m.mutateAsync(M), {
      error: "Error guardando nota de crédito",
      loading: "Guardando nota de crédito en borrador",
      success: () => (t("../nota-credito-detalles/" + e), `Nota de crédito ${e} guardada correctamente`)
    });
  }, R = async () => {
    const z = r.getFieldsValue(), F = n.getFieldsValue(), L = {
      ...D,
      ...z,
      ...F,
      TipoNCFId: 4,
      DocumentosDetallesDocumentoId: T.map((M) => {
        const B = {
          ...M,
          EstadoId: 3,
          DocumentoId: e,
          Flete: M.Flete,
          Total: M.Total,
          CuentaContableId: 1,
          DocumentoDetalleId: 1,
          Cantidad: M.Cantidad,
          Impuesto: M.Impuesto,
          SubTotal: M.SubTotal,
          PrecioUnitarioMinimo: 1,
          Descuento: M.Descuento,
          ImpuestoModificado: !1,
          PrecioUnitarioOriginal: 1,
          ImpuestoId: M.ImpuestoId,
          PrecioUnitario: M.PrecioUnitario,
          UnidadMedidaId: M.UnidadMedidaId,
          DescuentoUnitario: M.DescuentoUnitario,
          DescuentoEsPorcentual: M.DescuentoEsPorcentual,
          CantidadCortesia: M.CantidadCortesia ? M.CantidadCortesia : 0
        };
        return delete B.FacturaCompraDetalleLotes, B;
      }),
      ...$[0]
    };
    delete L.ProductosLotes, delete L.ReferenceDocumentData, delete L.DocumentosClienteDocumentoId, delete L.DocumentosComprasDocumentoId, delete L.FilesDocumentsData, delete L.Flete, delete L.CreadoPor, delete L.FechaCreacion, delete L.ModificadoPor, delete L.FechaModificacion, await se.promise(s.mutateAsync(L), {
      loading: "Guardando en borrador",
      error: "Error guardando en borrador",
      success: () => (t("../nota-credito-detalles/" + e), `Borrador del nota de débito ${e} guardada`)
    });
  }, P = async () => {
    await se.promise(O.mutateAsync({
      EstadoId: E.Borrador,
      NotaDebitoId: b?.NotaDebitoId || 0
    }), {
      loading: "Devolviendo la nota de crédito a borrador",
      error: () => "Error al volver la nota de crédito a borrador",
      success: () => `La nota de crédito # ${e} ahora está en borrador`
    });
  };
  return I ? It({
    fontSizeText: 23,
    errorText: "Ha ocurrido un error al cargar la nota de crédito"
  }) : v.isPending || m.isPending ? i.jsx(Gr, { fullscreen: !0 }) : i.jsxs(i.Fragment, { children: [i.jsxs(In, { children: [i.jsxs(xn, { children: [i.jsx(Qt, { loading: S, title: `Nota de crédito No. ${D?.Secuencia !== "0" && D !== void 0 ? D?.Secuencia : ""}`, children: S ? i.jsx(Vr, { size: "large", isLoading: S, title: "Cargando la nota de crédito" }) : i.jsx(i.Fragment, { children: i.jsx(Sn, { form: r, layout: "vertical", disabled: b?.EstadoId !== E.Borrador, children: i.jsx(Cr, { children: i.jsx(Ut, { children: i.jsx(K.Item, { name: "Fecha", label: "Fecha:", style: { width: "100%", maxWidth: 300 }, initialValue: rt(b?.Fecha || /* @__PURE__ */ new Date()), children: i.jsx(Kt, { size: "large", style: { width: "100%" } }) }) }) }) }) }) }), i.jsx(K, { form: y, layout: "vertical", children: i.jsx(rn, { area: "Compras", formInstance: y, isFleteActive: o, formConfig: n, dataSource: T, loading: S, DocumentData: D, setDataSource: N, disabled: D?.EstadoId !== E.Borrador, tax: V?.Valor ? V?.Valor : "false" }) })] }), i.jsx(Xr, { formInstance: r, isFleteEnable: !o, dataSource: T, isLoading: S, formIntanceConfig: n, Total: De($[0].Total), Importe: De($[0].Importe), Subtotal: De($[0].SubTotal), Descuento: De($[0].Descuento), Impuestos: De($[0].Impuestos), Retenciones: De($[0].Retenciones), IsBorradorDocument: b?.EstadoId == E.Borrador, methods: {
    handleSaveBorrador: A,
    handleSaveNormal: () => _(),
    handleVolverABorrador: P
  } })] }), i.jsx(Vs, { modalBorrador: c, method: () => P(), onClose: () => l(!1), tipoDocumentoId: f.Orden_de_compra, documentoId: b?.FacturaId, stateAction: {
    isError: O.isError,
    isLoading: O.isPending,
    isSuccess: O.isSuccess
  } }), i.jsx(Ls, { modalSaveDraft: d, handleBorrador: R, onClose: () => u(!1) })] });
}, PN = () => ({
  sidebar: !0,
  element: Wi,
  subSidebar: !0,
  id: "temp-billing-root",
  iconName: "file-invoice",
  path: "/accounts-payable",
  title: "Cuentas por pagar",
  children: [
    {
      sidebar: !0,
      element: Wi,
      withOnClick: !0,
      id: "documentos-compras",
      iconName: "shopping-cart",
      title: "Documentos de compras",
      path: Iv,
      children: [
        {
          path: "",
          index: !0,
          sidebar: !1,
          id: "documents-c",
          element: aN,
          title: "Documentos de compras"
        },
        {
          sidebar: !1,
          id: "credit-note-pa",
          title: "Nota de crédito",
          element: RN,
          path: `${Bf}/:id`
        },
        {
          sidebar: !1,
          title: "Nota de débito",
          element: ON,
          id: "credit-note-detail-pa",
          path: `/${kf}/:id`
        },
        {
          sidebar: !1,
          title: "Nota de débito",
          element: FN,
          id: "debit-note-detail-pa",
          path: `/${qf}/:id`
        },
        {
          sidebar: !1,
          id: "debit-note-pa",
          title: "Nota de débito",
          element: NN,
          path: `/${Uf}/:id`
        },
        {
          sidebar: !1,
          id: "purchase-invoice",
          element: rN,
          title: "Factura de compra",
          path: `/${Pv}/:id`
        },
        {
          sidebar: !1,
          id: "purchase-invoice-detail",
          element: nN,
          title: "Detalle factura de compra ",
          path: `/${jv}/:id`
        },
        {
          sidebar: !1,
          id: "purchase-order",
          element: iN,
          title: "Orden de compra",
          path: `/${xv}/:id`
        },
        {
          sidebar: !1,
          id: "purchase-order-detail",
          element: cN,
          title: "Detalle orden de compra",
          path: `/${Sv}/:id`
        },
        {
          sidebar: !1,
          id: "documents-v-recurrent",
          element: SN,
          path: "/facturas-compras-recurrentes",
          title: "Facturas de compras recurrentes"
        },
        {
          sidebar: !1,
          id: "conduce-PURCHASE",
          title: "Conduce Compra",
          element: IN,
          path: `/${Dv}/:id`
        },
        {
          sidebar: !1,
          title: "Detalle Conduce",
          id: "conduce-purchase-detail",
          element: CN,
          path: `/${Tv}/:id`
        }
      ]
    }
  ]
}), jN = () => ({
  sidebar: !0,
  element: Wi,
  subSidebar: !0,
  iconName: "report-money",
  title: "Cuentas por cobrar",
  path: "/accounts-receivable",
  id: "temp_billing_accounts_receivable_root",
  children: [
    {
      path: "",
      sidebar: !1,
      element: jf,
      id: "sales-documents-view-1",
      title: "Documentos de ventas"
    },
    {
      sidebar: !0,
      element: jf,
      iconName: "report-money",
      id: "sales-documents-view",
      title: "Documentos de ventas",
      path: Td
    },
    {
      sidebar: !1,
      element: Wi,
      id: "documentos-ventas-root",
      title: "Documentos de ventas",
      path: Td,
      children: [
        {
          element: AO,
          sidebar: !1,
          id: "quotation",
          title: "Cotización",
          path: `/${Fv}/:id`
        },
        {
          sidebar: !1,
          id: "quotation-detail",
          element: fN,
          title: "Detalle Cotización ",
          path: `/${Ov}/:id`
        },
        {
          sidebar: !1,
          id: "sale-invoice",
          element: oN,
          title: "Factura de venta",
          path: `/${Nv}/:id`
        },
        {
          sidebar: !1,
          id: "detail-sale-invoice",
          element: lN,
          title: "Detalle factura de venta",
          path: `/${Rv}/:id`
        },
        {
          sidebar: !1,
          id: "conduce-sale",
          title: "Conduce Venta",
          element: vN,
          path: `/${Ev}/:id`
        },
        {
          sidebar: !1,
          title: "Detalle Conduce",
          id: "conduce-sale-detail",
          element: hN,
          path: `/${wv}/:id`
        },
        {
          sidebar: !1,
          id: "credit-note-sa",
          title: "Nota de crédito",
          element: TN,
          path: `/${Bf}/:id`
        },
        {
          sidebar: !1,
          title: "Nota de crédito",
          element: DN,
          id: "credit-note-detail-sa",
          path: `/${kf}/:id`
        },
        {
          sidebar: !1,
          title: "Nota de débito",
          element: EN,
          id: "debit-note-detail-sa",
          path: `/${qf}/:id`
        },
        {
          sidebar: !1,
          id: "debit-note-sa",
          title: "Nota de débito",
          element: wN,
          path: `/${Uf}/:id`
        },
        {
          sidebar: !1,
          id: "documents-c-recurrent",
          element: xN,
          path: "/facturas-ventas-recurrentes",
          title: "Facturas de ventas recurrentes"
        }
      ]
    }
  ]
});
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var $f;
(function(e) {
  (function(t) {
    var r = typeof globalThis == "object" ? globalThis : typeof jo == "object" ? jo : typeof self == "object" ? self : typeof this == "object" ? this : c(), n = o(e);
    typeof r.Reflect < "u" && (n = o(r.Reflect, n)), t(n, r), typeof r.Reflect > "u" && (r.Reflect = e);
    function o(l, d) {
      return function(u, f) {
        Object.defineProperty(l, u, { configurable: !0, writable: !0, value: f }), d && d(u, f);
      };
    }
    function a() {
      try {
        return Function("return this;")();
      } catch {
      }
    }
    function s() {
      try {
        return (0, eval)("(function() { return this; })()");
      } catch {
      }
    }
    function c() {
      return a() || s();
    }
  })(function(t, r) {
    var n = Object.prototype.hasOwnProperty, o = typeof Symbol == "function", a = o && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", s = o && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", c = typeof Object.create == "function", l = { __proto__: [] } instanceof Array, d = !c && !l, u = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: c ? function() {
        return dt(/* @__PURE__ */ Object.create(null));
      } : l ? function() {
        return dt({ __proto__: null });
      } : function() {
        return dt({});
      },
      has: d ? function(q, H) {
        return n.call(q, H);
      } : function(q, H) {
        return H in q;
      },
      get: d ? function(q, H) {
        return n.call(q, H) ? q[H] : void 0;
      } : function(q, H) {
        return q[H];
      }
    }, f = Object.getPrototypeOf(Function), h = typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : Nt(), g = typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : pt(), E = typeof WeakMap == "function" ? WeakMap : Ge(), v = o ? Symbol.for("@reflect-metadata:registry") : void 0, m = Le(), y = Ve(m);
    function I(q, H, G, ne) {
      if (M(G)) {
        if (!he(q))
          throw new TypeError();
        if (!ue(H))
          throw new TypeError();
        return w(q, H);
      } else {
        if (!he(q))
          throw new TypeError();
        if (!ee(H))
          throw new TypeError();
        if (!ee(ne) && !M(ne) && !B(ne))
          throw new TypeError();
        return B(ne) && (ne = void 0), G = Y(G), j(q, H, G, ne);
      }
    }
    t("decorate", I);
    function b(q, H) {
      function G(ne, fe) {
        if (!ee(ne))
          throw new TypeError();
        if (!M(fe) && !le(fe))
          throw new TypeError();
        P(q, H, ne, fe);
      }
      return G;
    }
    t("metadata", b);
    function C(q, H, G, ne) {
      if (!ee(G))
        throw new TypeError();
      return M(ne) || (ne = Y(ne)), P(q, H, G, ne);
    }
    t("defineMetadata", C);
    function S(q, H, G) {
      if (!ee(H))
        throw new TypeError();
      return M(G) || (G = Y(G)), $(q, H, G);
    }
    t("hasMetadata", S);
    function T(q, H, G) {
      if (!ee(H))
        throw new TypeError();
      return M(G) || (G = Y(G)), _(q, H, G);
    }
    t("hasOwnMetadata", T);
    function N(q, H, G) {
      if (!ee(H))
        throw new TypeError();
      return M(G) || (G = Y(G)), A(q, H, G);
    }
    t("getMetadata", N);
    function V(q, H, G) {
      if (!ee(H))
        throw new TypeError();
      return M(G) || (G = Y(G)), R(q, H, G);
    }
    t("getOwnMetadata", V);
    function D(q, H) {
      if (!ee(q))
        throw new TypeError();
      return M(H) || (H = Y(H)), z(q, H);
    }
    t("getMetadataKeys", D);
    function x(q, H) {
      if (!ee(q))
        throw new TypeError();
      return M(H) || (H = Y(H)), F(q, H);
    }
    t("getOwnMetadataKeys", x);
    function O(q, H, G) {
      if (!ee(H))
        throw new TypeError();
      if (M(G) || (G = Y(G)), !ee(H))
        throw new TypeError();
      M(G) || (G = Y(G));
      var ne = ut(
        H,
        G,
        /*Create*/
        !1
      );
      return M(ne) ? !1 : ne.OrdinaryDeleteMetadata(q, H, G);
    }
    t("deleteMetadata", O);
    function w(q, H) {
      for (var G = q.length - 1; G >= 0; --G) {
        var ne = q[G], fe = ne(H);
        if (!M(fe) && !B(fe)) {
          if (!ue(fe))
            throw new TypeError();
          H = fe;
        }
      }
      return H;
    }
    function j(q, H, G, ne) {
      for (var fe = q.length - 1; fe >= 0; --fe) {
        var Te = q[fe], Be = Te(H, G, ne);
        if (!M(Be) && !B(Be)) {
          if (!ee(Be))
            throw new TypeError();
          ne = Be;
        }
      }
      return ne;
    }
    function $(q, H, G) {
      var ne = _(q, H, G);
      if (ne)
        return !0;
      var fe = Ie(H);
      return B(fe) ? !1 : $(q, fe, G);
    }
    function _(q, H, G) {
      var ne = ut(
        H,
        G,
        /*Create*/
        !1
      );
      return M(ne) ? !1 : Z(ne.OrdinaryHasOwnMetadata(q, H, G));
    }
    function A(q, H, G) {
      var ne = _(q, H, G);
      if (ne)
        return R(q, H, G);
      var fe = Ie(H);
      if (!B(fe))
        return A(q, fe, G);
    }
    function R(q, H, G) {
      var ne = ut(
        H,
        G,
        /*Create*/
        !1
      );
      if (!M(ne))
        return ne.OrdinaryGetOwnMetadata(q, H, G);
    }
    function P(q, H, G, ne) {
      var fe = ut(
        G,
        ne,
        /*Create*/
        !0
      );
      fe.OrdinaryDefineOwnMetadata(q, H, G, ne);
    }
    function z(q, H) {
      var G = F(q, H), ne = Ie(q);
      if (ne === null)
        return G;
      var fe = z(ne, H);
      if (fe.length <= 0)
        return G;
      if (G.length <= 0)
        return fe;
      for (var Te = new g(), Be = [], $e = 0, pe = G; $e < pe.length; $e++) {
        var X = pe[$e], re = Te.has(X);
        re || (Te.add(X), Be.push(X));
      }
      for (var ye = 0, xe = fe; ye < xe.length; ye++) {
        var X = xe[ye], re = Te.has(X);
        re || (Te.add(X), Be.push(X));
      }
      return Be;
    }
    function F(q, H) {
      var G = ut(
        q,
        H,
        /*create*/
        !1
      );
      return G ? G.OrdinaryOwnMetadataKeys(q, H) : [];
    }
    function L(q) {
      if (q === null)
        return 1;
      switch (typeof q) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return q === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function M(q) {
      return q === void 0;
    }
    function B(q) {
      return q === null;
    }
    function W(q) {
      return typeof q == "symbol";
    }
    function ee(q) {
      return typeof q == "object" ? q !== null : typeof q == "function";
    }
    function te(q, H) {
      switch (L(q)) {
        case 0:
          return q;
        case 1:
          return q;
        case 2:
          return q;
        case 3:
          return q;
        case 4:
          return q;
        case 5:
          return q;
      }
      var G = H === 3 ? "string" : H === 5 ? "number" : "default", ne = He(q, a);
      if (ne !== void 0) {
        var fe = ne.call(q, G);
        if (ee(fe))
          throw new TypeError();
        return fe;
      }
      return de(q, G === "default" ? "number" : G);
    }
    function de(q, H) {
      if (H === "string") {
        var G = q.toString;
        if (ve(G)) {
          var ne = G.call(q);
          if (!ee(ne))
            return ne;
        }
        var fe = q.valueOf;
        if (ve(fe)) {
          var ne = fe.call(q);
          if (!ee(ne))
            return ne;
        }
      } else {
        var fe = q.valueOf;
        if (ve(fe)) {
          var ne = fe.call(q);
          if (!ee(ne))
            return ne;
        }
        var Te = q.toString;
        if (ve(Te)) {
          var ne = Te.call(q);
          if (!ee(ne))
            return ne;
        }
      }
      throw new TypeError();
    }
    function Z(q) {
      return !!q;
    }
    function ce(q) {
      return "" + q;
    }
    function Y(q) {
      var H = te(
        q,
        3
        /* String */
      );
      return W(H) ? H : ce(H);
    }
    function he(q) {
      return Array.isArray ? Array.isArray(q) : q instanceof Object ? q instanceof Array : Object.prototype.toString.call(q) === "[object Array]";
    }
    function ve(q) {
      return typeof q == "function";
    }
    function ue(q) {
      return typeof q == "function";
    }
    function le(q) {
      switch (L(q)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function Fe(q, H) {
      return q === H || q !== q && H !== H;
    }
    function He(q, H) {
      var G = q[H];
      if (G != null) {
        if (!ve(G))
          throw new TypeError();
        return G;
      }
    }
    function We(q) {
      var H = He(q, s);
      if (!ve(H))
        throw new TypeError();
      var G = H.call(q);
      if (!ee(G))
        throw new TypeError();
      return G;
    }
    function ie(q) {
      return q.value;
    }
    function ge(q) {
      var H = q.next();
      return H.done ? !1 : H;
    }
    function be(q) {
      var H = q.return;
      H && H.call(q);
    }
    function Ie(q) {
      var H = Object.getPrototypeOf(q);
      if (typeof q != "function" || q === f || H !== f)
        return H;
      var G = q.prototype, ne = G && Object.getPrototypeOf(G);
      if (ne == null || ne === Object.prototype)
        return H;
      var fe = ne.constructor;
      return typeof fe != "function" || fe === q ? H : fe;
    }
    function Pe() {
      var q;
      !M(v) && typeof r.Reflect < "u" && !(v in r.Reflect) && typeof r.Reflect.defineMetadata == "function" && (q = _e(r.Reflect));
      var H, G, ne, fe = new E(), Te = {
        registerProvider: Be,
        getProvider: pe,
        setProvider: re
      };
      return Te;
      function Be(ye) {
        if (!Object.isExtensible(Te))
          throw new Error("Cannot add provider to a frozen registry.");
        switch (!0) {
          case q === ye:
            break;
          case M(H):
            H = ye;
            break;
          case H === ye:
            break;
          case M(G):
            G = ye;
            break;
          case G === ye:
            break;
          default:
            ne === void 0 && (ne = new g()), ne.add(ye);
            break;
        }
      }
      function $e(ye, xe) {
        if (!M(H)) {
          if (H.isProviderFor(ye, xe))
            return H;
          if (!M(G)) {
            if (G.isProviderFor(ye, xe))
              return H;
            if (!M(ne))
              for (var Ae = We(ne); ; ) {
                var je = ge(Ae);
                if (!je)
                  return;
                var Qe = ie(je);
                if (Qe.isProviderFor(ye, xe))
                  return be(Ae), Qe;
              }
          }
        }
        if (!M(q) && q.isProviderFor(ye, xe))
          return q;
      }
      function pe(ye, xe) {
        var Ae = fe.get(ye), je;
        return M(Ae) || (je = Ae.get(xe)), M(je) && (je = $e(ye, xe), M(je) || (M(Ae) && (Ae = new h(), fe.set(ye, Ae)), Ae.set(xe, je))), je;
      }
      function X(ye) {
        if (M(ye))
          throw new TypeError();
        return H === ye || G === ye || !M(ne) && ne.has(ye);
      }
      function re(ye, xe, Ae) {
        if (!X(Ae))
          throw new Error("Metadata provider not registered.");
        var je = pe(ye, xe);
        if (je !== Ae) {
          if (!M(je))
            return !1;
          var Qe = fe.get(ye);
          M(Qe) && (Qe = new h(), fe.set(ye, Qe)), Qe.set(xe, Ae);
        }
        return !0;
      }
    }
    function Le() {
      var q;
      return !M(v) && ee(r.Reflect) && Object.isExtensible(r.Reflect) && (q = r.Reflect[v]), M(q) && (q = Pe()), !M(v) && ee(r.Reflect) && Object.isExtensible(r.Reflect) && Object.defineProperty(r.Reflect, v, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: q
      }), q;
    }
    function Ve(q) {
      var H = new E(), G = {
        isProviderFor: function(X, re) {
          var ye = H.get(X);
          return M(ye) ? !1 : ye.has(re);
        },
        OrdinaryDefineOwnMetadata: Be,
        OrdinaryHasOwnMetadata: fe,
        OrdinaryGetOwnMetadata: Te,
        OrdinaryOwnMetadataKeys: $e,
        OrdinaryDeleteMetadata: pe
      };
      return m.registerProvider(G), G;
      function ne(X, re, ye) {
        var xe = H.get(X), Ae = !1;
        if (M(xe)) {
          if (!ye)
            return;
          xe = new h(), H.set(X, xe), Ae = !0;
        }
        var je = xe.get(re);
        if (M(je)) {
          if (!ye)
            return;
          if (je = new h(), xe.set(re, je), !q.setProvider(X, re, G))
            throw xe.delete(re), Ae && H.delete(X), new Error("Wrong provider for target.");
        }
        return je;
      }
      function fe(X, re, ye) {
        var xe = ne(
          re,
          ye,
          /*Create*/
          !1
        );
        return M(xe) ? !1 : Z(xe.has(X));
      }
      function Te(X, re, ye) {
        var xe = ne(
          re,
          ye,
          /*Create*/
          !1
        );
        if (!M(xe))
          return xe.get(X);
      }
      function Be(X, re, ye, xe) {
        var Ae = ne(
          ye,
          xe,
          /*Create*/
          !0
        );
        Ae.set(X, re);
      }
      function $e(X, re) {
        var ye = [], xe = ne(
          X,
          re,
          /*Create*/
          !1
        );
        if (M(xe))
          return ye;
        for (var Ae = xe.keys(), je = We(Ae), Qe = 0; ; ) {
          var ht = ge(je);
          if (!ht)
            return ye.length = Qe, ye;
          var Ft = ie(ht);
          try {
            ye[Qe] = Ft;
          } catch ($t) {
            try {
              be(je);
            } finally {
              throw $t;
            }
          }
          Qe++;
        }
      }
      function pe(X, re, ye) {
        var xe = ne(
          re,
          ye,
          /*Create*/
          !1
        );
        if (M(xe) || !xe.delete(X))
          return !1;
        if (xe.size === 0) {
          var Ae = H.get(re);
          M(Ae) || (Ae.delete(ye), Ae.size === 0 && H.delete(Ae));
        }
        return !0;
      }
    }
    function _e(q) {
      var H = q.defineMetadata, G = q.hasOwnMetadata, ne = q.getOwnMetadata, fe = q.getOwnMetadataKeys, Te = q.deleteMetadata, Be = new E(), $e = {
        isProviderFor: function(pe, X) {
          var re = Be.get(pe);
          return M(re) ? fe(pe, X).length ? (M(re) && (re = new g(), Be.set(pe, re)), re.add(X), !0) : !1 : re.has(X);
        },
        OrdinaryDefineOwnMetadata: H,
        OrdinaryHasOwnMetadata: G,
        OrdinaryGetOwnMetadata: ne,
        OrdinaryOwnMetadataKeys: fe,
        OrdinaryDeleteMetadata: Te
      };
      return $e;
    }
    function ut(q, H, G) {
      var ne = m.getProvider(q, H);
      if (!M(ne))
        return ne;
      if (G) {
        if (m.setProvider(q, H, y))
          return y;
        throw new Error("Illegal state.");
      }
    }
    function Nt() {
      var q = {}, H = [], G = (
        /** @class */
        function() {
          function $e(pe, X, re) {
            this._index = 0, this._keys = pe, this._values = X, this._selector = re;
          }
          return $e.prototype["@@iterator"] = function() {
            return this;
          }, $e.prototype[s] = function() {
            return this;
          }, $e.prototype.next = function() {
            var pe = this._index;
            if (pe >= 0 && pe < this._keys.length) {
              var X = this._selector(this._keys[pe], this._values[pe]);
              return pe + 1 >= this._keys.length ? (this._index = -1, this._keys = H, this._values = H) : this._index++, { value: X, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, $e.prototype.throw = function(pe) {
            throw this._index >= 0 && (this._index = -1, this._keys = H, this._values = H), pe;
          }, $e.prototype.return = function(pe) {
            return this._index >= 0 && (this._index = -1, this._keys = H, this._values = H), { value: pe, done: !0 };
          }, $e;
        }()
      ), ne = (
        /** @class */
        function() {
          function $e() {
            this._keys = [], this._values = [], this._cacheKey = q, this._cacheIndex = -2;
          }
          return Object.defineProperty($e.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), $e.prototype.has = function(pe) {
            return this._find(
              pe,
              /*insert*/
              !1
            ) >= 0;
          }, $e.prototype.get = function(pe) {
            var X = this._find(
              pe,
              /*insert*/
              !1
            );
            return X >= 0 ? this._values[X] : void 0;
          }, $e.prototype.set = function(pe, X) {
            var re = this._find(
              pe,
              /*insert*/
              !0
            );
            return this._values[re] = X, this;
          }, $e.prototype.delete = function(pe) {
            var X = this._find(
              pe,
              /*insert*/
              !1
            );
            if (X >= 0) {
              for (var re = this._keys.length, ye = X + 1; ye < re; ye++)
                this._keys[ye - 1] = this._keys[ye], this._values[ye - 1] = this._values[ye];
              return this._keys.length--, this._values.length--, Fe(pe, this._cacheKey) && (this._cacheKey = q, this._cacheIndex = -2), !0;
            }
            return !1;
          }, $e.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = q, this._cacheIndex = -2;
          }, $e.prototype.keys = function() {
            return new G(this._keys, this._values, fe);
          }, $e.prototype.values = function() {
            return new G(this._keys, this._values, Te);
          }, $e.prototype.entries = function() {
            return new G(this._keys, this._values, Be);
          }, $e.prototype["@@iterator"] = function() {
            return this.entries();
          }, $e.prototype[s] = function() {
            return this.entries();
          }, $e.prototype._find = function(pe, X) {
            if (!Fe(this._cacheKey, pe)) {
              this._cacheIndex = -1;
              for (var re = 0; re < this._keys.length; re++)
                if (Fe(this._keys[re], pe)) {
                  this._cacheIndex = re;
                  break;
                }
            }
            return this._cacheIndex < 0 && X && (this._cacheIndex = this._keys.length, this._keys.push(pe), this._values.push(void 0)), this._cacheIndex;
          }, $e;
        }()
      );
      return ne;
      function fe($e, pe) {
        return $e;
      }
      function Te($e, pe) {
        return pe;
      }
      function Be($e, pe) {
        return [$e, pe];
      }
    }
    function pt() {
      var q = (
        /** @class */
        function() {
          function H() {
            this._map = new h();
          }
          return Object.defineProperty(H.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), H.prototype.has = function(G) {
            return this._map.has(G);
          }, H.prototype.add = function(G) {
            return this._map.set(G, G), this;
          }, H.prototype.delete = function(G) {
            return this._map.delete(G);
          }, H.prototype.clear = function() {
            this._map.clear();
          }, H.prototype.keys = function() {
            return this._map.keys();
          }, H.prototype.values = function() {
            return this._map.keys();
          }, H.prototype.entries = function() {
            return this._map.entries();
          }, H.prototype["@@iterator"] = function() {
            return this.keys();
          }, H.prototype[s] = function() {
            return this.keys();
          }, H;
        }()
      );
      return q;
    }
    function Ge() {
      var q = 16, H = u.create(), G = ne();
      return (
        /** @class */
        function() {
          function pe() {
            this._key = ne();
          }
          return pe.prototype.has = function(X) {
            var re = fe(
              X,
              /*create*/
              !1
            );
            return re !== void 0 ? u.has(re, this._key) : !1;
          }, pe.prototype.get = function(X) {
            var re = fe(
              X,
              /*create*/
              !1
            );
            return re !== void 0 ? u.get(re, this._key) : void 0;
          }, pe.prototype.set = function(X, re) {
            var ye = fe(
              X,
              /*create*/
              !0
            );
            return ye[this._key] = re, this;
          }, pe.prototype.delete = function(X) {
            var re = fe(
              X,
              /*create*/
              !1
            );
            return re !== void 0 ? delete re[this._key] : !1;
          }, pe.prototype.clear = function() {
            this._key = ne();
          }, pe;
        }()
      );
      function ne() {
        var pe;
        do
          pe = "@@WeakMap@@" + $e();
        while (u.has(H, pe));
        return H[pe] = !0, pe;
      }
      function fe(pe, X) {
        if (!n.call(pe, G)) {
          if (!X)
            return;
          Object.defineProperty(pe, G, { value: u.create() });
        }
        return pe[G];
      }
      function Te(pe, X) {
        for (var re = 0; re < X; ++re)
          pe[re] = Math.random() * 255 | 0;
        return pe;
      }
      function Be(pe) {
        return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(pe)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(pe)) : Te(new Uint8Array(pe), pe) : Te(new Array(pe), pe);
      }
      function $e() {
        var pe = Be(q);
        pe[6] = pe[6] & 79 | 64, pe[8] = pe[8] & 191 | 128;
        for (var X = "", re = 0; re < q; ++re) {
          var ye = pe[re];
          (re === 4 || re === 6 || re === 8) && (X += "-"), ye < 16 && (X += "0"), X += ye.toString(16).toLowerCase();
        }
        return X;
      }
    }
    function dt(q) {
      return q.__ = void 0, delete q.__, q;
    }
  });
})($f || ($f = {}));
class rR {
  static register(t, r) {
    r.addResourceBundle("en", "billing_module", Mv), r.addResourceBundle("es", "billing_module", Vv), r.addResourceBundle("en", "error_billing_module", Fd.en), r.addResourceBundle("es", "error_billing_module", Fd.es), t.bind("Routes").toConstantValue(jN()), t.bind("Routes").toConstantValue(PN());
  }
}
export {
  rR as BillingModule
};
